import P, { useState as je, createContext as Jn, useEffect as Me, useContext as _t, useRef as ye, Fragment as ea, useId as F0, useLayoutEffect as _9, useMemo as jr, useReducer as vC, Component as W0, isValidElement as zr, Children as Ma, PureComponent as Cr, forwardRef as mC, useImperativeHandle as gC, useCallback as yC, cloneElement as Nt, createElement as D9 } from "react";
import z0, { unstable_batchedUpdates as bC } from "react-dom";
var To = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Je(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function et(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      if (this instanceof n) {
        var a = [null];
        a.push.apply(a, arguments);
        var i = Function.bind.apply(t, a);
        return new i();
      }
      return t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else
    r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var a = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, a.get ? a : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var N2 = { exports: {} }, vo = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var r6;
function CC() {
  if (r6)
    return vo;
  r6 = 1;
  var e = P, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(s, l, c) {
    var u, f = {}, p = null, h = null;
    c !== void 0 && (p = "" + c), l.key !== void 0 && (p = "" + l.key), l.ref !== void 0 && (h = l.ref);
    for (u in l)
      n.call(l, u) && !i.hasOwnProperty(u) && (f[u] = l[u]);
    if (s && s.defaultProps)
      for (u in l = s.defaultProps, l)
        f[u] === void 0 && (f[u] = l[u]);
    return { $$typeof: t, type: s, key: p, ref: h, props: f, _owner: a.current };
  }
  return vo.Fragment = r, vo.jsx = o, vo.jsxs = o, vo;
}
var mo = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var n6;
function xC() {
  return n6 || (n6 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = P, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), s = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), m = Symbol.iterator, v = "@@iterator";
    function g(U) {
      if (U === null || typeof U != "object")
        return null;
      var ie = m && U[m] || U[v];
      return typeof ie == "function" ? ie : null;
    }
    var y = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function b(U) {
      {
        for (var ie = arguments.length, le = new Array(ie > 1 ? ie - 1 : 0), Pe = 1; Pe < ie; Pe++)
          le[Pe - 1] = arguments[Pe];
        w("error", U, le);
      }
    }
    function w(U, ie, le) {
      {
        var Pe = y.ReactDebugCurrentFrame, ze = Pe.getStackAddendum();
        ze !== "" && (ie += "%s", le = le.concat([ze]));
        var ot = le.map(function(Re) {
          return String(Re);
        });
        ot.unshift("Warning: " + ie), Function.prototype.apply.call(console[U], console, ot);
      }
    }
    var x = !1, C = !1, S = !1, E = !1, D = !1, I;
    I = Symbol.for("react.module.reference");
    function k(U) {
      return !!(typeof U == "string" || typeof U == "function" || U === n || U === i || D || U === a || U === c || U === u || E || U === h || x || C || S || typeof U == "object" && U !== null && (U.$$typeof === p || U.$$typeof === f || U.$$typeof === o || U.$$typeof === s || U.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      U.$$typeof === I || U.getModuleId !== void 0));
    }
    function V(U, ie, le) {
      var Pe = U.displayName;
      if (Pe)
        return Pe;
      var ze = ie.displayName || ie.name || "";
      return ze !== "" ? le + "(" + ze + ")" : le;
    }
    function W(U) {
      return U.displayName || "Context";
    }
    function L(U) {
      if (U == null)
        return null;
      if (typeof U.tag == "number" && b("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof U == "function")
        return U.displayName || U.name || null;
      if (typeof U == "string")
        return U;
      switch (U) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case i:
          return "Profiler";
        case a:
          return "StrictMode";
        case c:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof U == "object")
        switch (U.$$typeof) {
          case s:
            var ie = U;
            return W(ie) + ".Consumer";
          case o:
            var le = U;
            return W(le._context) + ".Provider";
          case l:
            return V(U, U.render, "ForwardRef");
          case f:
            var Pe = U.displayName || null;
            return Pe !== null ? Pe : L(U.type) || "Memo";
          case p: {
            var ze = U, ot = ze._payload, Re = ze._init;
            try {
              return L(Re(ot));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var G = Object.assign, Q = 0, X, K, te, _, j, T, A;
    function O() {
    }
    O.__reactDisabledLog = !0;
    function N() {
      {
        if (Q === 0) {
          X = console.log, K = console.info, te = console.warn, _ = console.error, j = console.group, T = console.groupCollapsed, A = console.groupEnd;
          var U = {
            configurable: !0,
            enumerable: !0,
            value: O,
            writable: !0
          };
          Object.defineProperties(console, {
            info: U,
            log: U,
            warn: U,
            error: U,
            group: U,
            groupCollapsed: U,
            groupEnd: U
          });
        }
        Q++;
      }
    }
    function q() {
      {
        if (Q--, Q === 0) {
          var U = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: G({}, U, {
              value: X
            }),
            info: G({}, U, {
              value: K
            }),
            warn: G({}, U, {
              value: te
            }),
            error: G({}, U, {
              value: _
            }),
            group: G({}, U, {
              value: j
            }),
            groupCollapsed: G({}, U, {
              value: T
            }),
            groupEnd: G({}, U, {
              value: A
            })
          });
        }
        Q < 0 && b("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Y = y.ReactCurrentDispatcher, z;
    function R(U, ie, le) {
      {
        if (z === void 0)
          try {
            throw Error();
          } catch (ze) {
            var Pe = ze.stack.trim().match(/\n( *(at )?)/);
            z = Pe && Pe[1] || "";
          }
        return `
` + z + U;
      }
    }
    var $ = !1, F;
    {
      var B = typeof WeakMap == "function" ? WeakMap : Map;
      F = new B();
    }
    function M(U, ie) {
      if (!U || $)
        return "";
      {
        var le = F.get(U);
        if (le !== void 0)
          return le;
      }
      var Pe;
      $ = !0;
      var ze = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var ot;
      ot = Y.current, Y.current = null, N();
      try {
        if (ie) {
          var Re = function() {
            throw Error();
          };
          if (Object.defineProperty(Re.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Re, []);
            } catch (mn) {
              Pe = mn;
            }
            Reflect.construct(U, [], Re);
          } else {
            try {
              Re.call();
            } catch (mn) {
              Pe = mn;
            }
            U.call(Re.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (mn) {
            Pe = mn;
          }
          U();
        }
      } catch (mn) {
        if (mn && Pe && typeof mn.stack == "string") {
          for (var $e = mn.stack.split(`
`), Yt = Pe.stack.split(`
`), Pt = $e.length - 1, Dt = Yt.length - 1; Pt >= 1 && Dt >= 0 && $e[Pt] !== Yt[Dt]; )
            Dt--;
          for (; Pt >= 1 && Dt >= 0; Pt--, Dt--)
            if ($e[Pt] !== Yt[Dt]) {
              if (Pt !== 1 || Dt !== 1)
                do
                  if (Pt--, Dt--, Dt < 0 || $e[Pt] !== Yt[Dt]) {
                    var xr = `
` + $e[Pt].replace(" at new ", " at ");
                    return U.displayName && xr.includes("<anonymous>") && (xr = xr.replace("<anonymous>", U.displayName)), typeof U == "function" && F.set(U, xr), xr;
                  }
                while (Pt >= 1 && Dt >= 0);
              break;
            }
        }
      } finally {
        $ = !1, Y.current = ot, q(), Error.prepareStackTrace = ze;
      }
      var Ga = U ? U.displayName || U.name : "", t6 = Ga ? R(Ga) : "";
      return typeof U == "function" && F.set(U, t6), t6;
    }
    function J(U, ie, le) {
      return M(U, !1);
    }
    function H(U) {
      var ie = U.prototype;
      return !!(ie && ie.isReactComponent);
    }
    function ee(U, ie, le) {
      if (U == null)
        return "";
      if (typeof U == "function")
        return M(U, H(U));
      if (typeof U == "string")
        return R(U);
      switch (U) {
        case c:
          return R("Suspense");
        case u:
          return R("SuspenseList");
      }
      if (typeof U == "object")
        switch (U.$$typeof) {
          case l:
            return J(U.render);
          case f:
            return ee(U.type, ie, le);
          case p: {
            var Pe = U, ze = Pe._payload, ot = Pe._init;
            try {
              return ee(ot(ze), ie, le);
            } catch {
            }
          }
        }
      return "";
    }
    var ne = Object.prototype.hasOwnProperty, ae = {}, se = y.ReactDebugCurrentFrame;
    function de(U) {
      if (U) {
        var ie = U._owner, le = ee(U.type, U._source, ie ? ie.type : null);
        se.setExtraStackFrame(le);
      } else
        se.setExtraStackFrame(null);
    }
    function ve(U, ie, le, Pe, ze) {
      {
        var ot = Function.call.bind(ne);
        for (var Re in U)
          if (ot(U, Re)) {
            var $e = void 0;
            try {
              if (typeof U[Re] != "function") {
                var Yt = Error((Pe || "React class") + ": " + le + " type `" + Re + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof U[Re] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Yt.name = "Invariant Violation", Yt;
              }
              $e = U[Re](ie, Re, Pe, le, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Pt) {
              $e = Pt;
            }
            $e && !($e instanceof Error) && (de(ze), b("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Pe || "React class", le, Re, typeof $e), de(null)), $e instanceof Error && !($e.message in ae) && (ae[$e.message] = !0, de(ze), b("Failed %s type: %s", le, $e.message), de(null));
          }
      }
    }
    var Te = Array.isArray;
    function We(U) {
      return Te(U);
    }
    function Ze(U) {
      {
        var ie = typeof Symbol == "function" && Symbol.toStringTag, le = ie && U[Symbol.toStringTag] || U.constructor.name || "Object";
        return le;
      }
    }
    function yt(U) {
      try {
        return Tt(U), !1;
      } catch {
        return !0;
      }
    }
    function Tt(U) {
      return "" + U;
    }
    function kr(U) {
      if (yt(U))
        return b("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ze(U)), Tt(U);
    }
    var vn = y.ReactCurrentOwner, xu = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, qd, Gd, wu;
    wu = {};
    function eC(U) {
      if (ne.call(U, "ref")) {
        var ie = Object.getOwnPropertyDescriptor(U, "ref").get;
        if (ie && ie.isReactWarning)
          return !1;
      }
      return U.ref !== void 0;
    }
    function tC(U) {
      if (ne.call(U, "key")) {
        var ie = Object.getOwnPropertyDescriptor(U, "key").get;
        if (ie && ie.isReactWarning)
          return !1;
      }
      return U.key !== void 0;
    }
    function rC(U, ie) {
      if (typeof U.ref == "string" && vn.current && ie && vn.current.stateNode !== ie) {
        var le = L(vn.current.type);
        wu[le] || (b('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', L(vn.current.type), U.ref), wu[le] = !0);
      }
    }
    function nC(U, ie) {
      {
        var le = function() {
          qd || (qd = !0, b("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ie));
        };
        le.isReactWarning = !0, Object.defineProperty(U, "key", {
          get: le,
          configurable: !0
        });
      }
    }
    function aC(U, ie) {
      {
        var le = function() {
          Gd || (Gd = !0, b("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ie));
        };
        le.isReactWarning = !0, Object.defineProperty(U, "ref", {
          get: le,
          configurable: !0
        });
      }
    }
    var iC = function(U, ie, le, Pe, ze, ot, Re) {
      var $e = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: U,
        key: ie,
        ref: le,
        props: Re,
        // Record the component responsible for creating this element.
        _owner: ot
      };
      return $e._store = {}, Object.defineProperty($e._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty($e, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Pe
      }), Object.defineProperty($e, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ze
      }), Object.freeze && (Object.freeze($e.props), Object.freeze($e)), $e;
    };
    function oC(U, ie, le, Pe, ze) {
      {
        var ot, Re = {}, $e = null, Yt = null;
        le !== void 0 && (kr(le), $e = "" + le), tC(ie) && (kr(ie.key), $e = "" + ie.key), eC(ie) && (Yt = ie.ref, rC(ie, ze));
        for (ot in ie)
          ne.call(ie, ot) && !xu.hasOwnProperty(ot) && (Re[ot] = ie[ot]);
        if (U && U.defaultProps) {
          var Pt = U.defaultProps;
          for (ot in Pt)
            Re[ot] === void 0 && (Re[ot] = Pt[ot]);
        }
        if ($e || Yt) {
          var Dt = typeof U == "function" ? U.displayName || U.name || "Unknown" : U;
          $e && nC(Re, Dt), Yt && aC(Re, Dt);
        }
        return iC(U, $e, Yt, ze, Pe, vn.current, Re);
      }
    }
    var Ou = y.ReactCurrentOwner, Yd = y.ReactDebugCurrentFrame;
    function qa(U) {
      if (U) {
        var ie = U._owner, le = ee(U.type, U._source, ie ? ie.type : null);
        Yd.setExtraStackFrame(le);
      } else
        Yd.setExtraStackFrame(null);
    }
    var Su;
    Su = !1;
    function Pu(U) {
      return typeof U == "object" && U !== null && U.$$typeof === t;
    }
    function Kd() {
      {
        if (Ou.current) {
          var U = L(Ou.current.type);
          if (U)
            return `

Check the render method of \`` + U + "`.";
        }
        return "";
      }
    }
    function sC(U) {
      {
        if (U !== void 0) {
          var ie = U.fileName.replace(/^.*[\\\/]/, ""), le = U.lineNumber;
          return `

Check your code at ` + ie + ":" + le + ".";
        }
        return "";
      }
    }
    var Xd = {};
    function lC(U) {
      {
        var ie = Kd();
        if (!ie) {
          var le = typeof U == "string" ? U : U.displayName || U.name;
          le && (ie = `

Check the top-level render call using <` + le + ">.");
        }
        return ie;
      }
    }
    function Qd(U, ie) {
      {
        if (!U._store || U._store.validated || U.key != null)
          return;
        U._store.validated = !0;
        var le = lC(ie);
        if (Xd[le])
          return;
        Xd[le] = !0;
        var Pe = "";
        U && U._owner && U._owner !== Ou.current && (Pe = " It was passed a child from " + L(U._owner.type) + "."), qa(U), b('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', le, Pe), qa(null);
      }
    }
    function Jd(U, ie) {
      {
        if (typeof U != "object")
          return;
        if (We(U))
          for (var le = 0; le < U.length; le++) {
            var Pe = U[le];
            Pu(Pe) && Qd(Pe, ie);
          }
        else if (Pu(U))
          U._store && (U._store.validated = !0);
        else if (U) {
          var ze = g(U);
          if (typeof ze == "function" && ze !== U.entries)
            for (var ot = ze.call(U), Re; !(Re = ot.next()).done; )
              Pu(Re.value) && Qd(Re.value, ie);
        }
      }
    }
    function cC(U) {
      {
        var ie = U.type;
        if (ie == null || typeof ie == "string")
          return;
        var le;
        if (typeof ie == "function")
          le = ie.propTypes;
        else if (typeof ie == "object" && (ie.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        ie.$$typeof === f))
          le = ie.propTypes;
        else
          return;
        if (le) {
          var Pe = L(ie);
          ve(le, U.props, "prop", Pe, U);
        } else if (ie.PropTypes !== void 0 && !Su) {
          Su = !0;
          var ze = L(ie);
          b("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ze || "Unknown");
        }
        typeof ie.getDefaultProps == "function" && !ie.getDefaultProps.isReactClassApproved && b("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function uC(U) {
      {
        for (var ie = Object.keys(U.props), le = 0; le < ie.length; le++) {
          var Pe = ie[le];
          if (Pe !== "children" && Pe !== "key") {
            qa(U), b("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Pe), qa(null);
            break;
          }
        }
        U.ref !== null && (qa(U), b("Invalid attribute `ref` supplied to `React.Fragment`."), qa(null));
      }
    }
    function e6(U, ie, le, Pe, ze, ot) {
      {
        var Re = k(U);
        if (!Re) {
          var $e = "";
          (U === void 0 || typeof U == "object" && U !== null && Object.keys(U).length === 0) && ($e += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Yt = sC(ze);
          Yt ? $e += Yt : $e += Kd();
          var Pt;
          U === null ? Pt = "null" : We(U) ? Pt = "array" : U !== void 0 && U.$$typeof === t ? (Pt = "<" + (L(U.type) || "Unknown") + " />", $e = " Did you accidentally export a JSX literal instead of a component?") : Pt = typeof U, b("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Pt, $e);
        }
        var Dt = oC(U, ie, le, ze, ot);
        if (Dt == null)
          return Dt;
        if (Re) {
          var xr = ie.children;
          if (xr !== void 0)
            if (Pe)
              if (We(xr)) {
                for (var Ga = 0; Ga < xr.length; Ga++)
                  Jd(xr[Ga], U);
                Object.freeze && Object.freeze(xr);
              } else
                b("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Jd(xr, U);
        }
        return U === n ? uC(Dt) : cC(Dt), Dt;
      }
    }
    function fC(U, ie, le) {
      return e6(U, ie, le, !0);
    }
    function dC(U, ie, le) {
      return e6(U, ie, le, !1);
    }
    var pC = dC, hC = fC;
    mo.Fragment = n, mo.jsx = pC, mo.jsxs = hC;
  }()), mo;
}
process.env.NODE_ENV === "production" ? N2.exports = CC() : N2.exports = xC();
var d = N2.exports;
const qs = P.forwardRef((e, t) => {
  const {
    image: r,
    size: n = "sm",
    grayscale: a = !1
  } = e, i = {
    xs: "h-[24px] w-[24px] min-w-[24px]",
    sm: "h-[28px] w-[28px] min-w-[28px]",
    md: "h-[32px] w-[32px] min-w-[32px]"
  };
  return /* @__PURE__ */ d.jsx("div", { ref: t, className: `${i[n]} flex items-center justify-center aspect-square rounded-full bg-secondary-200 border border-white overflow-hidden ${a ? "grayscale-[70%]" : ""}`, children: r.length > 2 ? /* @__PURE__ */ d.jsx(
    "img",
    {
      src: r,
      className: "h-full w-full object-cover bg-secondary-200 text-secondary-100",
      alt: ""
    }
  ) : r.length === 2 ? /* @__PURE__ */ d.jsx("span", { className: "text-secondary-500 font-bold leading-none text-xs", children: r }) : null });
});
qs.displayName = "Avatar";
const Gs = {
  light: "300",
  normal: "normal",
  medium: "500",
  semibold: "600",
  bold: "700",
  black: "900"
}, U0 = {
  DEFAULT: "0.25rem",
  0: "0",
  xs: "0.25rem",
  md: "0.5rem",
  lg: "1rem",
  xl: "2rem",
  full: "100%"
}, Ae = {
  transparent: "rgba(255, 255, 255, 0.08)",
  DEFAULT: "#E6E6E6",
  white: "#FFFFFF",
  "neutral-100": "#FFFFFF",
  "neutral-200": "#F5F5F5",
  "neutral-300": "#E6E6E6",
  "neutral-400": "#A3A3A3",
  "neutral-500": "#525252",
  "neutral-600": "#292929",
  "primary-100": "#FEF2F0",
  "primary-200": "#FDE5E1",
  "primary-300": "#FCD8D1",
  "primary-400": "#FBCBC2",
  "primary-500": "#F3765F",
  "primary-600": "#F15C41",
  "primary-700": "#CE4D37",
  "primary-800": "#A53C2B",
  "primary-850": "#7B2A1F",
  "primary-900": "#521913",
  "primary-950": "#280706",
  "secondary-100": "#EEF4F9",
  "secondary-200": "#DDE9F3",
  "secondary-300": "#CBDEED",
  "secondary-400": "#BAD3E7",
  "secondary-500": "#4A8BC0",
  "secondary-600": "#2875B4",
  "secondary-700": "#22629B",
  "secondary-800": "#165892",
  "secondary-850": "#104D85;",
  "secondary-900": "#0A4379",
  "secondary-950": "#03386C",
  "accent-100": "#FDEEF3",
  "accent-200": "#FBDEE7",
  "accent-300": "#F9CDDB",
  "accent-400": "#F7BCD0",
  "accent-500": "#E94F83",
  "accent-600": "#E52E6B",
  "accent-700": "#C4275B",
  "accent-800": "#9D1E47",
  "accent-850": "#761534",
  "accent-900": "#4F0C21",
  "accent-950": "#27040E",
  "info-50": "#EEF5FD",
  "info-100": "#DEEBFB",
  "info-200": "#CDE1F9",
  "info-300": "#BCD7F7",
  "info-400": "#4F96E9",
  "info-500": "#2E82E5",
  "info-600": "#276EC4",
  "info-700": "#0F2D59",
  "info-800": "#0B2348",
  "info-900": "#071938",
  "info-950": "#040F27",
  "success-50": "#EEFBF1",
  "success-100": "#DDF7E2",
  "success-200": "#CCF3D4",
  "success-300": "#BAEFC6",
  "success-400": "#4BD469",
  "success-500": "#29CC4D",
  "success-600": "#22AF42",
  "success-700": "#0D5120",
  "success-800": "#0A421B",
  "success-900": "#073415",
  "success-950": "#032510",
  "warning-50": "#FDF7EE",
  "warning-100": "#FBEFDE",
  "warning-200": "#F9E7CD",
  "warning-300": "#F7DFBC",
  "warning-400": "#E9AC4F",
  "warning-500": "#E59C2E",
  "warning-600": "#C48427",
  "warning-700": "#59350F",
  "warning-800": "#48290B",
  "warning-900": "#381C07",
  "warning-950": "#271004",
  "warning-1000": "#fbbf24",
  "error-50": "#FDEEEE",
  "error-100": "#FBDEDE",
  "error-200": "#F9CDCD",
  "error-300": "#F7BCBC",
  "error-400": "#E94F4F",
  "error-500": "#E52E2E",
  "error-600": "#C42727",
  "error-700": "#590F10",
  "error-800": "#480B0C",
  "error-900": "#380709",
  "error-950": "#270405"
}, On = P.forwardRef((e, t) => {
  const {
    mb: r,
    mt: n,
    bg: a,
    color: i,
    rounded: o,
    isHidden: s,
    spacing: l,
    spacingX: c,
    spacingY: u,
    spacingTop: f,
    spacingBottom: p,
    textAlign: h,
    border: m,
    borderTop: v,
    borderBottom: g,
    borderColor: y,
    children: b,
    className: w,
    shadow: x,
    ...C
  } = e, S = {
    textAlign: h,
    marginBottom: r !== void 0 ? `${r / 4}rem` : void 0,
    marginTop: n !== void 0 ? `${n / 4}rem` : void 0,
    backgroundColor: a !== void 0 ? Ae[a] : void 0,
    color: i !== void 0 ? Ae[i] : void 0,
    borderRadius: o !== void 0 ? U0[o] : void 0,
    borderColor: y !== void 0 ? Ae[y] : void 0,
    padding: l !== void 0 ? `${l / 4}rem` : void 0
  };
  return m !== void 0 ? S.borderWidth = m : (S.borderTopWidth = v, S.borderBottomWidth = g), c !== void 0 && (S.paddingLeft = `${c / 4}rem`, S.paddingRight = `${c / 4}rem`), u !== void 0 && (S.paddingTop = `${u / 4}rem`, S.paddingBottom = `${u / 4}rem`), f !== void 0 && (S.paddingTop = `${f / 4}rem`), p !== void 0 && (S.paddingBottom = `${p / 4}rem`), x !== void 0 && (S.boxShadow = "0 4px 10px rgba(0,0,0,0.2)"), /* @__PURE__ */ d.jsx(
    "div",
    {
      ref: t,
      className: `${s === !0 ? "hidden" : "block"}`,
      style: S,
      ...C,
      children: b
    }
  );
});
On.displayName = "Box";
const wC = P.forwardRef((e, t) => {
  const {
    text: r,
    variant: n,
    minHeight: a = "60vh",
    minHeigthDesktop: i = "40vh"
  } = e, o = {
    "--ck-min-h-box-status": typeof a == "number" ? `${a}px` : a,
    "--ck-min-h-box-status-desktop": typeof i == "number" ? `${i}px` : i
  }, l = r ?? {
    loading: "Cargando...",
    empty: ""
  }[n];
  return /* @__PURE__ */ d.jsxs(
    "div",
    {
      ref: t,
      style: o,
      className: "bg-secondary-100 flex items-center justify-center p-5 rounded-md h-full w-full min-h-[var(--ck-min-h-box-status)] m:min-h-[var(--ck-min-h-box-status-desktop)]",
      children: [
        n === "loading" && /* @__PURE__ */ d.jsxs("div", { className: "flex flex-col items-center justify-center w-full text-center animate-pulse", children: [
          /* @__PURE__ */ d.jsx("div", { className: "bg-white flex justify-center items-center w-[64px] h-[64px] rounded-md mb-4", children: /* @__PURE__ */ d.jsxs(
            "svg",
            {
              width: 36,
              height: 40,
              viewBox: "0 0 36 40",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: [
                /* @__PURE__ */ d.jsx(
                  "path",
                  {
                    d: "M1.65723 39.2676H28.9346C34.1715 39.2676 37.5922 33.638 35.247 28.8537L31.8969 22.001C24.2797 31.012 13.6826 37.3071 1.65723 39.2676Z",
                    fill: "#165892"
                  }
                ),
                /* @__PURE__ */ d.jsx(
                  "path",
                  {
                    d: "M23.2922 4.46453L22.1638 2.16232C21.2292 0.255791 18.5667 0.255791 17.6322 2.16232L3.87891 30.2386C12.8715 24.1413 19.7834 15.0943 23.2922 4.46453Z",
                    fill: "#F15C41"
                  }
                ),
                /* @__PURE__ */ d.jsx(
                  "path",
                  {
                    d: "M31.28 20.7422L24.1036 6.10156C20.1363 17.181 12.5367 26.4798 2.78593 32.5051L0 38.2067C12.5014 36.57 23.5569 30.131 31.2976 20.7602L31.28 20.7422Z",
                    fill: "#2875B4"
                  }
                )
              ]
            }
          ) }),
          l !== "" && /* @__PURE__ */ d.jsx(yr, { variant: "description-3", children: l })
        ] }),
        n === "empty" && /* @__PURE__ */ d.jsxs("div", { className: "flex flex-col items-center justify-center w-full max-w-[300px] gap-4 text-center", children: [
          /* @__PURE__ */ d.jsx("div", { className: "flex justify-center select-none", children: /* @__PURE__ */ d.jsx(
            "svg",
            {
              width: 90,
              height: 101,
              viewBox: "0 0 90 101",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: /* @__PURE__ */ d.jsxs("g", { clipPath: "url(#clip0_2127_49432)", children: [
                /* @__PURE__ */ d.jsx(
                  "path",
                  {
                    d: "M89.9844 52.4766C89.8853 51.6849 89.314 51.0339 88.5418 50.8307L80.2566 48.6484L86.6766 41.5833C87.0783 41.1406 87.2531 40.5417 87.1566 39.9531C87.0601 39.3646 86.7001 38.8542 86.1783 38.5625L62.2618 25.276C61.3644 23.6068 60.2166 22.0573 58.834 20.6823C55.1401 16.9922 50.2253 14.9609 45.0001 14.9609C39.7748 14.9609 34.8601 16.9922 31.1661 20.6823C29.7731 22.0729 28.6357 23.6224 27.7514 25.2708L3.82441 38.5651C3.30267 38.8542 2.94267 39.3672 2.84614 39.9557C2.74962 40.5443 2.92701 41.1432 3.32875 41.5859L9.74615 48.651L1.45832 50.8333C0.686145 51.0365 0.11484 51.6875 0.0157101 52.4792C-0.0834204 53.2708 0.307884 54.0417 1.00701 54.4297L11.4027 60.2057V80.974C11.4027 81.6823 11.7888 82.3359 12.407 82.6797L44.0505 100.258C44.3479 100.422 44.674 100.505 45.0027 100.505C45.3314 100.505 45.6601 100.424 45.9548 100.258L77.5983 82.6797C78.2192 82.3359 78.6027 81.6823 78.6027 80.974V60.2057L88.9983 54.4297C89.6948 54.0417 90.0888 53.2708 89.987 52.4792L89.9844 52.4766ZM82.1192 40.7839L76.2366 47.2578L63.694 40.2917C64.2679 38.4401 64.5653 36.4896 64.5653 34.4974C64.5653 33.2578 64.4505 32.0365 64.2261 30.8438L82.1218 40.7839H82.1192ZM33.9314 23.4479C36.887 20.4974 40.8183 18.8724 45.0001 18.8724C49.1818 18.8724 53.1105 20.4974 56.0688 23.4479C59.027 26.3984 60.6522 30.3229 60.6522 34.4974C60.6522 38.6719 59.0244 42.5938 56.0688 45.5469C54.0235 47.5885 51.4644 49.0208 48.6653 49.6901C48.1435 49.8151 47.6948 50.1484 47.4261 50.612L45.0001 54.8099C44.1914 53.4089 43.3827 52.0104 42.574 50.612C42.3053 50.1484 41.8566 49.8151 41.3348 49.6875C38.5383 49.0182 35.9792 47.5859 33.934 45.5443C27.8322 39.4531 27.8322 29.5391 33.934 23.4479H33.9314ZM7.88093 40.7839L25.7896 30.8359C25.1948 33.9714 25.3696 37.2214 26.3192 40.2865L13.7661 47.2604L7.88354 40.7865L7.88093 40.7839ZM13.0957 51.8073L20.5331 55.9401C20.8357 56.1068 21.1618 56.1875 21.4827 56.1875C22.1714 56.1875 22.8366 55.8255 23.194 55.1823C23.7209 54.2396 23.3792 53.0495 22.4348 52.526L17.3818 49.7188L27.8531 43.9036C28.7218 45.4844 29.8279 46.9688 31.1661 48.3073C33.5192 50.6563 36.4148 52.3594 39.5922 53.2682C40.4348 54.7266 41.2774 56.1849 42.1227 57.6458C42.7253 58.6823 43.7975 59.2995 44.9975 59.2995H45.0235C46.2131 59.2917 47.3114 58.6484 47.8957 57.6172L50.4105 53.2682C53.5853 52.3568 56.4835 50.6536 58.8366 48.3073C60.1618 46.9818 61.2757 45.5026 62.1575 43.9063L72.6209 49.7188L45.0027 65.0599L37.8261 61.0729C36.8818 60.5495 35.6896 60.888 35.1653 61.8307C34.6383 62.7734 34.9801 63.9635 35.9244 64.487L39.8061 66.6432L33.8661 68.2057L7.15571 53.3672L13.0957 51.8047V51.8073ZM15.3157 62.375L32.6505 72.0052C33.0914 72.25 33.6105 72.3151 34.1009 72.1875L43.0461 69.8333V95.2266L15.3157 79.8229V62.3776V62.375ZM74.687 79.8203L46.9566 95.224V69.8307L55.9018 72.1849C56.0661 72.2266 56.2331 72.25 56.4001 72.25C56.7314 72.25 57.0574 72.1667 57.3496 72.0026L74.6844 62.3724V79.8177L74.687 79.8203ZM56.1392 68.2083L50.1992 66.6432L76.907 51.8073L82.847 53.3698L56.1392 68.2083Z",
                    fill: "#2875B4"
                  }
                ),
                /* @__PURE__ */ d.jsx(
                  "path",
                  {
                    d: "M35.2173 36.7422C36.2973 36.7422 37.1738 35.8672 37.1738 34.7891C37.1738 33.7109 36.2973 32.8359 35.2173 32.8359C34.1373 32.8359 33.2607 33.7109 33.2607 34.7891C33.2607 35.8672 34.1373 36.7422 35.2173 36.7422Z",
                    fill: "#2875B4"
                  }
                ),
                /* @__PURE__ */ d.jsx(
                  "path",
                  {
                    d: "M45 36.7422C46.08 36.7422 46.9565 35.8672 46.9565 34.7891C46.9565 33.7109 46.08 32.8359 45 32.8359C43.92 32.8359 43.0435 33.7109 43.0435 34.7891C43.0435 35.8672 43.92 36.7422 45 36.7422Z",
                    fill: "#2875B4"
                  }
                ),
                /* @__PURE__ */ d.jsx(
                  "path",
                  {
                    d: "M54.7827 36.7422C55.8627 36.7422 56.7392 35.8672 56.7392 34.7891C56.7392 33.7109 55.8627 32.8359 54.7827 32.8359C53.7027 32.8359 52.8262 33.7109 52.8262 34.7891C52.8262 35.8672 53.7027 36.7422 54.7827 36.7422Z",
                    fill: "#2875B4"
                  }
                ),
                /* @__PURE__ */ d.jsx(
                  "path",
                  {
                    d: "M45 8.89844C46.08 8.89844 46.9565 8.02344 46.9565 6.94531V2.45312C46.9565 1.375 46.08 0.5 45 0.5C43.92 0.5 43.0435 1.375 43.0435 2.45312V6.94531C43.0435 8.02344 43.92 8.89844 45 8.89844Z",
                    fill: "#2875B4"
                  }
                ),
                /* @__PURE__ */ d.jsx(
                  "path",
                  {
                    d: "M33.0573 10.6639C33.4199 11.2915 34.0773 11.6405 34.7529 11.6405C35.0842 11.6405 35.4207 11.5571 35.7286 11.38C36.6651 10.841 36.9859 9.64566 36.4459 8.71077L34.1973 4.82014C33.6573 3.88525 32.4599 3.56494 31.5259 4.104C30.5894 4.64306 30.2686 5.83837 30.8086 6.77327L33.0573 10.6639Z",
                    fill: "#2875B4"
                  }
                ),
                /* @__PURE__ */ d.jsx(
                  "path",
                  {
                    d: "M54.2685 11.3776C54.5764 11.5547 54.9129 11.638 55.2468 11.638C55.9225 11.638 56.5799 11.2891 56.9425 10.6615L59.1912 6.77083C59.7312 5.83593 59.4103 4.64062 58.4738 4.10156C57.5372 3.56249 56.3425 3.88281 55.8025 4.8177L53.5538 8.70833C53.0138 9.64322 53.3346 10.8359 54.2685 11.3776Z",
                    fill: "#2875B4"
                  }
                ),
                /* @__PURE__ */ d.jsx(
                  "path",
                  {
                    d: "M29.1782 56.5547C28.0982 56.5547 27.2217 57.4297 27.2217 58.5078C27.2217 59.5859 28.0982 60.4609 29.1782 60.4609C30.2582 60.4609 31.1347 59.5885 31.1347 58.5078C31.1347 57.4271 30.2582 56.5547 29.1782 56.5547Z",
                    fill: "#2875B4"
                  }
                )
              ] })
            }
          ) }),
          l !== "" && /* @__PURE__ */ d.jsx(yr, { variant: "description-3", children: l })
        ] })
      ]
    }
  );
});
wC.displayName = "BoxStatus";
const jue = P.forwardRef((e, t) => {
  const {
    mb: r,
    mt: n,
    bg: a,
    color: i,
    borderColor: o,
    rounded: s,
    spacing: l,
    textAlign: c,
    onChangeFile: u,
    onRemoveFile: f,
    fileName: p = "",
    children: h,
    className: m,
    ...v
  } = e, [g, y] = je(!1), [b, w] = je(p), x = {
    textAlign: c,
    marginBottom: r !== void 0 ? `${r / 4}rem` : void 0,
    marginTop: n !== void 0 ? `${n / 4}rem` : void 0,
    backgroundColor: g ? "transparent" : a !== void 0 ? Ae[a] : void 0,
    color: i !== void 0 ? Ae[i] : void 0,
    // borderColor: borderColor !== undefined ? colors[borderColor] : undefined,
    borderRadius: s !== void 0 ? U0[s] : void 0,
    padding: l !== void 0 ? `${l / 4}rem` : void 0
  }, C = (D) => {
    D.preventDefault(), y(!0);
  }, S = (D) => {
    D.preventDefault(), y(!1);
    const I = D.dataTransfer.files[0];
    u && u(I), w(I.name);
  }, E = () => {
    w(""), f && f();
  };
  return /* @__PURE__ */ d.jsxs(
    "div",
    {
      ref: t,
      className: `border-dashed border-2 border-${o !== void 0 ? Ae[o] : void 0}`,
      style: x,
      ...v,
      onDragEnter: C,
      onDragLeave: () => y(!1),
      onDragOver: (D) => D.preventDefault(),
      onDrop: S,
      children: [
        /* @__PURE__ */ d.jsx(ds, { justifyItems: "center", gapY: 6, children: b !== "" ? /* @__PURE__ */ d.jsx(
          Ut,
          {
            type: "button",
            onClick: () => {
              E();
            },
            variant: "error-light",
            icon: "trash",
            size: "m",
            children: b
          }
        ) : /* @__PURE__ */ d.jsx(Io, { children: /* @__PURE__ */ d.jsxs(yr, { variant: "description-3", color: "neutral-400", children: [
          "Arrastra aqui tu archivo",
          /* @__PURE__ */ d.jsx("br", {}),
          "(PDF,DOC,EXC, hasta 200kb)"
        ] }) }) }),
        h
      ]
    }
  );
});
function Ne(e) {
  return `${e.filter((t) => t !== void 0).join(" ").trim()}`;
}
const OC = P.forwardRef((e, t) => {
  const {
    items: r = [],
    className: n
  } = e;
  return /* @__PURE__ */ d.jsx(
    "ul",
    {
      ref: t,
      className: Ne(["m:flex flex-wrap gap-2", n]),
      children: r.map((a, i) => /* @__PURE__ */ d.jsxs(
        "li",
        {
          className: "text-neutral-400 flex gap-2 items-center",
          children: [
            /* @__PURE__ */ d.jsx(
              "div",
              {
                className: `hover:text-secondary-600 ${i + 1 === r.length ? "pointer-events-none" : "cursor-pointer"}`,
                onClick: () => {
                  i + 1 !== r.length && a.onClick !== void 0 && a.onClick();
                },
                children: /* @__PURE__ */ d.jsx(lr, { variant: "title-3", children: a.description })
              }
            ),
            i + 1 !== r.length && /* @__PURE__ */ d.jsx("span", { className: "w-[14px] min-w-[14px] -rotate-90", children: /* @__PURE__ */ d.jsx(ge, { variant: "arrow-down", width: 14 }) })
          ]
        },
        a.description
      ))
    }
  );
});
OC.displayName = "Breadcrumb";
const SC = () => /* @__PURE__ */ d.jsxs("svg", { className: "w-full", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ d.jsx("g", { clipPath: "url(#clip0_1441_2226)", children: /* @__PURE__ */ d.jsx("path", { d: "M16.4808 2.685C14.75 0.954167 12.4475 0 10 0C7.5525 0 5.25 0.954167 3.51833 2.685C-0.055837 6.25917 -0.055837 12.0742 3.54166 15.6717L6.82666 18.7067C7.68 19.5408 8.8075 20.0008 10 20.0008C11.1925 20.0008 12.3192 19.5408 13.155 18.7233L16.4808 15.65C20.055 12.0758 20.055 6.26 16.4808 2.68583V2.685ZM15.3258 14.4475L12.0067 17.515C10.9275 18.5717 9.09 18.5875 7.975 17.4983L4.69583 14.47C1.77166 11.545 1.77166 6.7875 4.69583 3.8625C6.1125 2.44667 7.99666 1.66583 9.99916 1.66583C12.0017 1.66583 13.885 2.44667 15.3017 3.8625C18.2258 6.7875 18.2258 11.545 15.325 14.4467L15.3258 14.4475ZM9.16583 9.58333V5C9.16583 4.53917 9.53833 4.16667 9.99916 4.16667C10.46 4.16667 10.8325 4.53917 10.8325 5V9.58333C10.8325 10.0442 10.46 10.4167 9.99916 10.4167C9.53833 10.4167 9.16583 10.0442 9.16583 9.58333ZM11.2492 12.9167C11.2492 13.6067 10.6892 14.1667 9.99916 14.1667C9.30916 14.1667 8.74916 13.6067 8.74916 12.9167C8.74916 12.2267 9.30916 11.6667 9.99916 11.6667C10.6892 11.6667 11.2492 12.2267 11.2492 12.9167Z", fill: "currentColor" }) }),
  /* @__PURE__ */ d.jsx("defs", { children: /* @__PURE__ */ d.jsx("clipPath", { id: "clip0_1441_2226", children: /* @__PURE__ */ d.jsx("rect", { width: "20", height: "20", fill: "currentColor" }) }) })
] }), PC = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 15 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        d: "M14.043.71a.999.999 0 00-1.42 0l-4.58 4.58a1 1 0 01-1.42 0L2.043.71a1 1 0 10-1.42 1.41l4.59 4.59a3 3 0 004.24 0l4.59-4.59a1 1 0 000-1.41z",
        fill: "currentColor"
      }
    )
  }
), EC = () => /* @__PURE__ */ d.jsx("svg", { className: "w-full", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ d.jsx("path", { d: "M13.29063 3.29018C13.38436 3.38315 13.45875 3.49375 13.50952 3.61561C13.56029 3.73747 13.58643 3.86817 13.58643 4.00018C13.58643 4.1322 13.56029 4.2629 13.50952 4.38476C13.45875 4.50662 13.38436 4.61722 13.29063 4.71018L8.71063 9.29018C8.61689 9.38315 8.5425 9.49375 8.49173 9.61561C8.44096 9.73747 8.41482 9.86817 8.41482 10.0002C8.41482 10.1322 8.44096 10.2629 8.49173 10.3848C8.5425 10.5066 8.61689 10.6172 8.71063 10.7102L13.29063 15.2902C13.38436 15.3831 13.45875 15.4937 13.50952 15.6156C13.56029 15.7375 13.58643 15.8682 13.58643 16.0002C13.58643 16.1322 13.56029 16.2629 13.50952 16.3848C13.45875 16.5066 13.38436 16.6172 13.29063 16.7102C13.1033 16.8964 12.8498 17.001 12.5856 17.001C12.3214 17.001 12.0679 16.8964 11.8806 16.7102L7.29063 12.1202C6.72882 11.5577 6.41329 10.7952 6.41329 10.0002C6.41329 9.20518 6.72882 8.44269 7.29063 7.88018L11.8806 3.29018C12.0679 3.10393 12.3214 2.99939 12.5856 2.99939C12.8498 2.99939 13.1033 3.10393 13.29063 3.29018Z", fill: "currentColor" }) }), jC = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        d: "M6.70937 3.29018C6.61564 3.38315 6.54125 3.49375 6.49048 3.61561C6.43971 3.73747 6.41357 3.86817 6.41357 4.00018C6.41357 4.1322 6.43971 4.2629 6.49048 4.38476C6.54125 4.50662 6.61564 4.61722 6.70937 4.71018L11.2894 9.29018C11.3831 9.38315 11.4575 9.49375 11.5083 9.61561C11.559 9.73747 11.5852 9.86817 11.5852 10.0002C11.5852 10.1322 11.559 10.2629 11.5083 10.3848C11.4575 10.5066 11.3831 10.6172 11.2894 10.7102L6.70937 15.2902C6.61564 15.3831 6.54125 15.4937 6.49048 15.6156C6.43971 15.7375 6.41357 15.8682 6.41357 16.0002C6.41357 16.1322 6.43971 16.2629 6.49048 16.3848C6.54125 16.5066 6.61564 16.6172 6.70937 16.7102C6.89673 16.8964 7.15019 17.001 7.41437 17.001C7.67856 17.001 7.93201 16.8964 8.11937 16.7102L12.7094 12.1202C13.2712 11.5577 13.5867 10.7952 13.5867 10.0002C13.5867 9.20518 13.2712 8.44269 12.7094 7.88018L8.11937 3.29018C7.93201 3.10393 7.67856 2.99939 7.41437 2.99939C7.15019 2.99939 6.89673 3.10393 6.70937 3.29018Z",
        fill: "currentColor"
      }
    )
  }
), _C = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        d: "M16 9.005H6l3.29-3.29a1 1 0 10-1.41-1.42l-4.29 4.3a2 2 0 00-.59 1.41 2 2 0 00.59 1.4l4.29 4.3a1 1 0 001.628-1.096 1 1 0 00-.218-.324L6 11.005h10a1 1 0 000-2z",
        fill: "currentColor"
      }
    )
  }
), DC = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        d: "M13.426.2L15.2 2l-7.32 7.21a2.503 2.503 0 01-1.777.734 2.528 2.528 0 01-1.79-.74L.8 5.799 2.56 3.982l3.53 3.42 7.339-7.2L13.426.2z",
        fill: "currentColor"
      }
    )
  }
), AC = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsx("g", { clipPath: "url(#clip0_2127_36415)", children: /* @__PURE__ */ d.jsx(
      "path",
      {
        d: "M14.0817 6.90667L15.2517 8.09417L10.4242 12.85C10.1017 13.1725 9.6775 13.3333 9.25167 13.3333C8.82583 13.3333 8.3975 13.1708 8.07167 12.8458L5.75333 10.5992L6.91417 9.40167L9.24167 11.6575L14.0817 6.90667ZM20.5 10C20.5 15.5142 16.0142 20 10.5 20C4.98583 20 0.5 15.5142 0.5 10C0.5 4.48583 4.98583 0 10.5 0C16.0142 0 20.5 4.48583 20.5 10ZM18.8333 10C18.8333 5.405 15.095 1.66667 10.5 1.66667C5.905 1.66667 2.16667 5.405 2.16667 10C2.16667 14.595 5.905 18.3333 10.5 18.3333C15.095 18.3333 18.8333 14.595 18.8333 10Z",
        fill: "currentColor"
      }
    ) })
  }
), MC = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        d: "M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17316C0.00433286 8.00043 -0.1937 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8078C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C19.9971 7.34871 18.9426 4.80684 17.0679 2.9321C15.1932 1.05736 12.6513 0.00286757 10 0ZM10 18.3333C8.35183 18.3333 6.74066 17.8446 5.37025 16.9289C3.99984 16.0132 2.93174 14.7117 2.30101 13.189C1.67028 11.6663 1.50525 9.99075 1.82679 8.37425C2.14834 6.75774 2.94201 5.27288 4.10745 4.10744C5.27288 2.94201 6.75774 2.14833 8.37425 1.82679C9.99076 1.50525 11.6663 1.67027 13.189 2.301C14.7117 2.93173 16.0132 3.99984 16.9289 5.37025C17.8446 6.74066 18.3333 8.35182 18.3333 10C18.3309 12.2094 17.4522 14.3276 15.8899 15.8899C14.3276 17.4522 12.2094 18.3309 10 18.3333ZM10.8333 9.16667H14.1667V10.8333H10.8333V14.1667H9.16667V10.8333H5.83334V9.16667H9.16667V5.83333H10.8333V9.16667Z",
        fill: "currentColor"
      }
    )
  }
), TC = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        d: "M12.9998 0.999818C12.8123 0.812347 12.558 0.707031 12.2928 0.707031C12.0277 0.707031 11.7733 0.812347 11.5858 0.999818L6.99982 5.58582L2.41382 0.999818C2.22629 0.812347 1.97198 0.707031 1.70682 0.707031C1.44165 0.707031 1.18735 0.812347 0.999818 0.999818C0.812347 1.18735 0.707031 1.44165 0.707031 1.70682C0.707031 1.97198 0.812347 2.22629 0.999818 2.41382L5.58582 6.99982L0.999818 11.5858C0.812347 11.7733 0.707031 12.0277 0.707031 12.2928C0.707031 12.558 0.812347 12.8123 0.999818 12.9998C1.18735 13.1873 1.44165 13.2926 1.70682 13.2926C1.97198 13.2926 2.22629 13.1873 2.41382 12.9998L6.99982 8.41382L11.5858 12.9998C11.7733 13.1873 12.0277 13.2926 12.2928 13.2926C12.558 13.2926 12.8123 13.1873 12.9998 12.9998C13.1873 12.8123 13.2926 12.558 13.2926 12.2928C13.2926 12.0277 13.1873 11.7733 12.9998 11.5858L8.41382 6.99982L12.9998 2.41382C13.1873 2.22629 13.2926 1.97198 13.2926 1.70682C13.2926 1.44165 13.1873 1.18735 12.9998 0.999818Z",
        fill: "currentColor"
      }
    )
  }
), $C = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsxs("g", { clipPath: "url(#clip0_1902_296)", children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M0.83 6.16504H19.16C19.62 6.16504 19.99 6.53504 19.99 6.99504C19.99 7.45504 19.62 7.82504 19.16 7.82504H0.83C0.37 7.83504 0 7.46504 0 7.00504C0 6.54504 0.37 6.16504 0.83 6.16504Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M9.83977 0.334961H19.1698C19.6298 0.334961 19.9998 0.704961 19.9998 1.16496C19.9998 1.62496 19.6298 1.99496 19.1698 1.99496H9.83977C9.37977 1.99496 9.00977 1.62496 9.00977 1.16496C9.00977 0.704961 9.37977 0.334961 9.83977 0.334961Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M9.83977 12.0049H19.1698C19.6298 12.0049 19.9998 12.3749 19.9998 12.8349C19.9998 13.2949 19.6298 13.6649 19.1698 13.6649H9.83977C9.37977 13.6649 9.00977 13.2949 9.00977 12.8349C9.00977 12.3749 9.37977 12.0049 9.83977 12.0049Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M2.17982 7.6749C1.80982 7.3049 1.79982 6.7049 2.17982 6.3249L6.54982 1.9649C6.91982 1.5949 6.92982 0.994902 6.54982 0.614902C6.17982 0.244902 5.57982 0.244902 5.20982 0.614902L0.839824 4.9849C-0.270176 6.1049 -0.270176 7.9049 0.839824 9.0249L5.20982 13.3949C5.38982 13.5749 5.62982 13.6749 5.87982 13.6749C6.12982 13.6749 6.37982 13.5749 6.55982 13.3949C6.92982 13.0249 6.93982 12.4249 6.55982 12.0449L2.17982 7.6749Z",
          fill: "currentColor"
        }
      )
    ] })
  }
), NC = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        d: "M15.8333 1.6665H4.16667C1.86917 1.6665 0 3.53567 0 5.83317V14.1665C0 16.464 1.86917 18.3332 4.16667 18.3332H15.8333C18.1308 18.3332 20 16.464 20 14.1665V5.83317C20 3.53567 18.1308 1.6665 15.8333 1.6665ZM4.16667 3.33317H15.8333C17.2117 3.33317 18.3333 4.45484 18.3333 5.83317H1.66667C1.66667 4.45484 2.78833 3.33317 4.16667 3.33317ZM1.66667 14.1665V7.49984H9.16667V16.6665H4.16667C2.78833 16.6665 1.66667 15.5448 1.66667 14.1665ZM15.8333 16.6665H10.8333V7.49984H18.3333V14.1665C18.3333 15.5448 17.2117 16.6665 15.8333 16.6665Z",
        fill: "currentColor"
      }
    )
  }
), IC = () => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M9.99984 6.6665C9.34057 6.6665 8.6961 6.862 8.14794 7.22827C7.59977 7.59454 7.17253 8.11514 6.92024 8.72423C6.66795 9.33331 6.60194 10.0035 6.73055 10.6501C6.85917 11.2967 7.17664 11.8907 7.64282 12.3569C8.10899 12.823 8.70293 13.1405 9.34954 13.2691C9.99614 13.3977 10.6664 13.3317 11.2755 13.0794C11.8845 12.8271 12.4051 12.3999 12.7714 11.8517C13.1377 11.3036 13.3332 10.6591 13.3332 9.99984C13.3332 9.11578 12.982 8.26794 12.3569 7.64281C11.7317 7.01769 10.8839 6.6665 9.99984 6.6665ZM9.99984 11.6665C9.6702 11.6665 9.34797 11.5688 9.07389 11.3856C8.79981 11.2025 8.58619 10.9422 8.46004 10.6376C8.33389 10.3331 8.30089 9.99799 8.3652 9.67469C8.42951 9.35139 8.58824 9.05441 8.82133 8.82133C9.05442 8.58824 9.35139 8.4295 9.67469 8.36519C9.99799 8.30089 10.3331 8.33389 10.6376 8.46004C10.9422 8.58618 11.2025 8.79981 11.3856 9.07389C11.5688 9.34797 11.6665 9.6702 11.6665 9.99984C11.6665 10.4419 11.4909 10.8658 11.1783 11.1783C10.8658 11.4909 10.4419 11.6665 9.99984 11.6665Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M17.7452 11.5833L17.3752 11.37C17.5417 10.4637 17.5417 9.53463 17.3752 8.62833L17.7452 8.415C18.0297 8.25085 18.2791 8.03226 18.4792 7.77172C18.6792 7.51118 18.826 7.21378 18.9111 6.89651C18.9962 6.57925 19.018 6.24832 18.9753 5.92263C18.9325 5.59694 18.826 5.28286 18.6618 4.99833C18.4977 4.7138 18.2791 4.46439 18.0185 4.26434C17.758 4.06428 17.4606 3.91751 17.1433 3.83239C16.8261 3.74726 16.4951 3.72547 16.1695 3.76824C15.8438 3.81101 15.5297 3.91751 15.2452 4.08167L14.8743 4.29583C14.1739 3.69743 13.369 3.23354 12.5002 2.9275V2.5C12.5002 1.83696 12.2368 1.20107 11.7679 0.732233C11.2991 0.263392 10.6632 0 10.0002 0C9.33712 0 8.70123 0.263392 8.23239 0.732233C7.76355 1.20107 7.50016 1.83696 7.50016 2.5V2.9275C6.63131 3.23464 5.8267 3.69967 5.12682 4.29917L4.75432 4.08333C4.17969 3.75181 3.49689 3.66214 2.85614 3.83405C2.21539 4.00596 1.66918 4.42536 1.33766 5C1.00614 5.57464 0.916468 6.25743 1.08838 6.89818C1.26028 7.53893 1.67969 8.08515 2.25432 8.41667L2.62432 8.63C2.45775 9.5363 2.45775 10.4654 2.62432 11.3717L2.25432 11.585C1.67969 11.9165 1.26028 12.4627 1.08838 13.1035C0.916468 13.7442 1.00614 14.427 1.33766 15.0017C1.66918 15.5763 2.21539 15.9957 2.85614 16.1676C3.49689 16.3395 4.17969 16.2499 4.75432 15.9183L5.12516 15.7042C5.8258 16.3027 6.63097 16.7666 7.50016 17.0725V17.5C7.50016 18.163 7.76355 18.7989 8.23239 19.2678C8.70123 19.7366 9.33712 20 10.0002 20C10.6632 20 11.2991 19.7366 11.7679 19.2678C12.2368 18.7989 12.5002 18.163 12.5002 17.5V17.0725C13.369 16.7654 14.1736 16.3003 14.8735 15.7008L15.246 15.9158C15.8206 16.2474 16.5034 16.337 17.1442 16.1651C17.7849 15.9932 18.3311 15.5738 18.6627 14.9992C18.9942 14.4245 19.0838 13.7417 18.9119 13.101C18.74 12.4602 18.3206 11.914 17.746 11.5825L17.7452 11.5833ZM15.6218 8.43667C15.904 9.45922 15.904 10.5391 15.6218 11.5617C15.5725 11.7396 15.5838 11.9289 15.6538 12.0998C15.7238 12.2707 15.8485 12.4135 16.0085 12.5058L16.9118 13.0275C17.1033 13.138 17.2431 13.3201 17.3004 13.5336C17.3577 13.7472 17.3277 13.9747 17.2172 14.1663C17.1067 14.3578 16.9247 14.4975 16.7111 14.5548C16.4976 14.6121 16.27 14.5822 16.0785 14.4717L15.1735 13.9483C15.0134 13.8556 14.827 13.8188 14.6437 13.8437C14.4604 13.8686 14.2906 13.9538 14.161 14.0858C13.4193 14.843 12.4848 15.3833 11.4585 15.6483C11.2794 15.6944 11.1206 15.7987 11.0073 15.9449C10.894 16.0911 10.8326 16.2709 10.8327 16.4558V17.5C10.8327 17.721 10.7449 17.933 10.5886 18.0893C10.4323 18.2455 10.2203 18.3333 9.99932 18.3333C9.77831 18.3333 9.56635 18.2455 9.41007 18.0893C9.25379 17.933 9.16599 17.721 9.16599 17.5V16.4567C9.16608 16.2717 9.10464 16.092 8.99133 15.9458C8.87802 15.7996 8.7193 15.6952 8.54016 15.6492C7.51378 15.3831 6.5796 14.8416 5.83849 14.0833C5.70893 13.9513 5.53911 13.8661 5.35579 13.8412C5.17247 13.8163 4.98608 13.8531 4.82599 13.9458L3.92266 14.4683C3.82785 14.5239 3.72298 14.5602 3.6141 14.5751C3.50521 14.59 3.39445 14.5832 3.2882 14.5551C3.18195 14.527 3.08231 14.4782 2.99501 14.4114C2.90771 14.3446 2.83447 14.2613 2.77952 14.1661C2.72457 14.0709 2.68899 13.9658 2.67482 13.8568C2.66066 13.7479 2.66819 13.6372 2.69698 13.5311C2.72578 13.425 2.77527 13.3257 2.8426 13.2389C2.90994 13.152 2.99379 13.0793 3.08932 13.025L3.99266 12.5033C4.15262 12.411 4.27739 12.2682 4.34737 12.0973C4.41736 11.9264 4.4286 11.7371 4.37932 11.5592C4.09712 10.5366 4.09712 9.45672 4.37932 8.43417C4.42771 8.25657 4.41594 8.06795 4.34584 7.89774C4.27574 7.72754 4.15125 7.58534 3.99182 7.49333L3.08849 6.97167C2.89698 6.86116 2.75722 6.6791 2.69994 6.46555C2.64266 6.25199 2.67257 6.02442 2.78307 5.83292C2.89358 5.64141 3.07564 5.50164 3.2892 5.44437C3.50275 5.38709 3.73032 5.41699 3.92182 5.5275L4.82682 6.05083C4.98647 6.14376 5.17247 6.18101 5.3556 6.15672C5.53872 6.13244 5.70858 6.048 5.83849 5.91667C6.58023 5.15945 7.51468 4.61918 8.54099 4.35417C8.72068 4.30797 8.87982 4.20313 8.99319 4.05625C9.10655 3.90938 9.16766 3.72887 9.16682 3.54333V2.5C9.16682 2.27899 9.25462 2.06702 9.4109 1.91074C9.56718 1.75446 9.77914 1.66667 10.0002 1.66667C10.2212 1.66667 10.4331 1.75446 10.5894 1.91074C10.7457 2.06702 10.8335 2.27899 10.8335 2.5V3.54333C10.8334 3.7283 10.8948 3.90804 11.0082 4.05423C11.1215 4.20043 11.2802 4.30478 11.4593 4.35083C12.486 4.61679 13.4205 5.15824 14.1618 5.91667C14.2914 6.04872 14.4612 6.13391 14.6445 6.15881C14.8278 6.1837 15.0142 6.14689 15.1743 6.05417L16.0777 5.53167C16.1725 5.47609 16.2773 5.43981 16.3862 5.42492C16.4951 5.41003 16.6059 5.41683 16.7121 5.44492C16.8184 5.47301 16.918 5.52184 17.0053 5.58859C17.0926 5.65535 17.1658 5.73872 17.2208 5.83389C17.2757 5.92907 17.3113 6.03417 17.3255 6.14316C17.3397 6.25214 17.3321 6.36285 17.3033 6.46891C17.2745 6.57497 17.225 6.67429 17.1577 6.76114C17.0904 6.848 17.0065 6.92068 16.911 6.975L16.0077 7.49667C15.8485 7.58892 15.7244 7.73123 15.6546 7.90141C15.5848 8.07159 15.5733 8.26008 15.6218 8.4375V8.43667Z",
          fill: "currentColor"
        }
      )
    ]
  }
), LC = () => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ d.jsxs("g", { clipPath: "url(#clip0_842_3882)", children: [
        /* @__PURE__ */ d.jsx(
          "path",
          {
            d: "M5.83333 0H3.33333C2.44928 0 1.60143 0.35119 0.976311 0.976311C0.35119 1.60143 0 2.44928 0 3.33333L0 5.83333C0 6.71739 0.35119 7.56524 0.976311 8.19036C1.60143 8.81548 2.44928 9.16667 3.33333 9.16667H5.83333C6.71739 9.16667 7.56524 8.81548 8.19036 8.19036C8.81548 7.56524 9.16667 6.71739 9.16667 5.83333V3.33333C9.16667 2.44928 8.81548 1.60143 8.19036 0.976311C7.56524 0.35119 6.71739 0 5.83333 0ZM7.5 5.83333C7.5 6.27536 7.32441 6.69928 7.01185 7.01185C6.69928 7.32441 6.27536 7.5 5.83333 7.5H3.33333C2.89131 7.5 2.46738 7.32441 2.15482 7.01185C1.84226 6.69928 1.66667 6.27536 1.66667 5.83333V3.33333C1.66667 2.89131 1.84226 2.46738 2.15482 2.15482C2.46738 1.84226 2.89131 1.66667 3.33333 1.66667H5.83333C6.27536 1.66667 6.69928 1.84226 7.01185 2.15482C7.32441 2.46738 7.5 2.89131 7.5 3.33333V5.83333Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ d.jsx(
          "path",
          {
            d: "M16.6668 0H14.1668C13.2828 0 12.4349 0.35119 11.8098 0.976311C11.1847 1.60143 10.8335 2.44928 10.8335 3.33333V5.83333C10.8335 6.71739 11.1847 7.56524 11.8098 8.19036C12.4349 8.81548 13.2828 9.16667 14.1668 9.16667H16.6668C17.5509 9.16667 18.3987 8.81548 19.0239 8.19036C19.649 7.56524 20.0002 6.71739 20.0002 5.83333V3.33333C20.0002 2.44928 19.649 1.60143 19.0239 0.976311C18.3987 0.35119 17.5509 0 16.6668 0ZM18.3335 5.83333C18.3335 6.27536 18.1579 6.69928 17.8453 7.01185C17.5328 7.32441 17.1089 7.5 16.6668 7.5H14.1668C13.7248 7.5 13.3009 7.32441 12.9883 7.01185C12.6758 6.69928 12.5002 6.27536 12.5002 5.83333V3.33333C12.5002 2.89131 12.6758 2.46738 12.9883 2.15482C13.3009 1.84226 13.7248 1.66667 14.1668 1.66667H16.6668C17.1089 1.66667 17.5328 1.84226 17.8453 2.15482C18.1579 2.46738 18.3335 2.89131 18.3335 3.33333V5.83333Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ d.jsx(
          "path",
          {
            d: "M5.83333 10.8335H3.33333C2.44928 10.8335 1.60143 11.1847 0.976311 11.8098C0.35119 12.4349 0 13.2828 0 14.1668L0 16.6668C0 17.5509 0.35119 18.3987 0.976311 19.0239C1.60143 19.649 2.44928 20.0002 3.33333 20.0002H5.83333C6.71739 20.0002 7.56524 19.649 8.19036 19.0239C8.81548 18.3987 9.16667 17.5509 9.16667 16.6668V14.1668C9.16667 13.2828 8.81548 12.4349 8.19036 11.8098C7.56524 11.1847 6.71739 10.8335 5.83333 10.8335ZM7.5 16.6668C7.5 17.1089 7.32441 17.5328 7.01185 17.8453C6.69928 18.1579 6.27536 18.3335 5.83333 18.3335H3.33333C2.89131 18.3335 2.46738 18.1579 2.15482 17.8453C1.84226 17.5328 1.66667 17.1089 1.66667 16.6668V14.1668C1.66667 13.7248 1.84226 13.3009 2.15482 12.9883C2.46738 12.6758 2.89131 12.5002 3.33333 12.5002H5.83333C6.27536 12.5002 6.69928 12.6758 7.01185 12.9883C7.32441 13.3009 7.5 13.7248 7.5 14.1668V16.6668Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ d.jsx(
          "path",
          {
            d: "M16.6668 10.8335H14.1668C13.2828 10.8335 12.4349 11.1847 11.8098 11.8098C11.1847 12.4349 10.8335 13.2828 10.8335 14.1668V16.6668C10.8335 17.5509 11.1847 18.3987 11.8098 19.0239C12.4349 19.649 13.2828 20.0002 14.1668 20.0002H16.6668C17.5509 20.0002 18.3987 19.649 19.0239 19.0239C19.649 18.3987 20.0002 17.5509 20.0002 16.6668V14.1668C20.0002 13.2828 19.649 12.4349 19.0239 11.8098C18.3987 11.1847 17.5509 10.8335 16.6668 10.8335ZM18.3335 16.6668C18.3335 17.1089 18.1579 17.5328 17.8453 17.8453C17.5328 18.1579 17.1089 18.3335 16.6668 18.3335H14.1668C13.7248 18.3335 13.3009 18.1579 12.9883 17.8453C12.6758 17.5328 12.5002 17.1089 12.5002 16.6668V14.1668C12.5002 13.7248 12.6758 13.3009 12.9883 12.9883C13.3009 12.6758 13.7248 12.5002 14.1668 12.5002H16.6668C17.1089 12.5002 17.5328 12.6758 17.8453 12.9883C18.1579 13.3009 18.3335 13.7248 18.3335 14.1668V16.6668Z",
            fill: "currentColor"
          }
        )
      ] }),
      /* @__PURE__ */ d.jsx("defs", { children: /* @__PURE__ */ d.jsx("clipPath", { id: "clip0_842_3882", children: /* @__PURE__ */ d.jsx("rect", { width: 20, height: 20, fill: "white" }) }) })
    ]
  }
), RC = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsx("g", { clipPath: "url(#clip0_2127_30852)", children: /* @__PURE__ */ d.jsx(
      "path",
      {
        d: "M10 14.1666V17.4999C10 17.9583 9.625 18.3333 9.16667 18.3333H5.83333C5.375 18.3333 5 17.9583 5 17.4999C5 17.0416 5.375 16.6666 5.83333 16.6666H8.33333V14.9999H4.16667C1.86667 14.9999 0 13.1333 0 10.8333V4.99992C0 2.69992 1.86667 0.833252 4.16667 0.833252H14.1667C16.4667 0.833252 18.3333 2.69992 18.3333 4.99992C18.3333 5.45825 17.9583 5.83325 17.5 5.83325C17.0417 5.83325 16.6667 5.45825 16.6667 4.99992C16.6667 3.62492 15.5417 2.49992 14.1667 2.49992H4.16667C2.79167 2.49992 1.66667 3.62492 1.66667 4.99992V10.8333C1.66667 12.2083 2.79167 13.3333 4.16667 13.3333H9.16667C9.625 13.3333 10 13.7083 10 14.1666ZM20 10.8333V16.6666C20 18.5083 18.5083 19.9999 16.6667 19.9999H15C13.1583 19.9999 11.6667 18.5083 11.6667 16.6666V10.8333C11.6667 8.99158 13.1583 7.49992 15 7.49992H16.6667C18.5083 7.49992 20 8.99158 20 10.8333ZM18.3333 10.8333C18.3333 9.91658 17.5833 9.16658 16.6667 9.16658H15C14.0833 9.16658 13.3333 9.91658 13.3333 10.8333V16.6666C13.3333 17.5833 14.0833 18.3333 15 18.3333H16.6667C17.5833 18.3333 18.3333 17.5833 18.3333 16.6666V10.8333Z",
        fill: "currentColor"
      }
    ) })
  }
), kC = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsx("g", { clipPath: "url(#clip0_2656_4445)", children: /* @__PURE__ */ d.jsx(
      "path",
      {
        d: "M13.3333 19.1667C13.3333 19.6267 12.9608 20 12.4999 20H4.99992C2.70242 20 0.833252 18.1308 0.833252 15.8333V4.16667C0.833252 1.86917 2.70242 0 4.99992 0H8.76242C10.3199 0 11.7849 0.606667 12.8874 1.70833L15.7908 4.61333C16.0166 4.83917 16.2266 5.08667 16.4141 5.34917C16.6816 5.72333 16.5949 6.24417 16.2208 6.51167C15.8466 6.77833 15.3249 6.6925 15.0583 6.3175C14.9241 6.13 14.7741 5.9525 14.6133 5.7925L11.7091 2.8875C11.4441 2.6225 11.1499 2.39833 10.8333 2.21667V5.83333C10.8333 6.2925 11.2066 6.66667 11.6666 6.66667H14.1666C14.6274 6.66667 14.9999 7.04 14.9999 7.5C14.9999 7.96 14.6274 8.33333 14.1666 8.33333H11.6666C10.2883 8.33333 9.16659 7.21167 9.16659 5.83333V1.68583C9.03325 1.67333 8.89825 1.66667 8.76242 1.66667H4.99992C3.62159 1.66667 2.49992 2.78833 2.49992 4.16667V15.8333C2.49992 17.2117 3.62159 18.3333 4.99992 18.3333H12.4999C12.9608 18.3333 13.3333 18.7067 13.3333 19.1667ZM18.0708 13.5558L15.5366 13.1333C15.2258 13.0817 14.9999 12.815 14.9999 12.5C14.9999 12.0408 15.3733 11.6667 15.8333 11.6667H17.7233C18.0199 11.6667 18.2966 11.8267 18.4458 12.0833C18.6749 12.4817 19.1833 12.6175 19.5841 12.3875C19.9824 12.1567 20.1191 11.6475 19.8874 11.2492C19.4424 10.4783 18.6124 9.99917 17.7224 9.99917H17.4991V9.16583C17.4991 8.70583 17.1266 8.3325 16.6658 8.3325C16.2049 8.3325 15.8324 8.70583 15.8324 9.16583V9.99917C14.4541 9.99917 13.3324 11.1208 13.3324 12.4992C13.3324 13.6325 14.1441 14.5908 15.2616 14.7767L17.7958 15.1992C18.1066 15.2508 18.3324 15.5175 18.3324 15.8325C18.3324 16.2917 17.9591 16.6658 17.4991 16.6658H15.6091C15.3124 16.6658 15.0358 16.5058 14.8866 16.2492C14.6574 15.85 14.1483 15.7142 13.7483 15.945C13.3499 16.1758 13.2133 16.685 13.4449 17.0833C13.8899 17.8542 14.7199 18.3325 15.6099 18.3325H15.8333V19.1658C15.8333 19.6258 16.2058 19.9992 16.6666 19.9992C17.1274 19.9992 17.4999 19.6258 17.4999 19.1658V18.3325C18.8783 18.3325 19.9999 17.2108 19.9999 15.8325C19.9999 14.6992 19.1883 13.7417 18.0708 13.5558ZM6.24992 12.5H10.8333C11.2941 12.5 11.6666 12.1267 11.6666 11.6667C11.6666 11.2067 11.2941 10.8333 10.8333 10.8333H6.24992C5.10159 10.8333 4.16659 11.7683 4.16659 12.9167V14.5833C4.16659 15.7317 5.10159 16.6667 6.24992 16.6667H10.8333C11.2941 16.6667 11.6666 16.2933 11.6666 15.8333C11.6666 15.3733 11.2941 15 10.8333 15H6.24992C6.01992 15 5.83325 14.8133 5.83325 14.5833V12.9167C5.83325 12.6867 6.01992 12.5 6.24992 12.5ZM4.99992 9.16667H6.66659C7.12659 9.16667 7.49992 8.79333 7.49992 8.33333C7.49992 7.87333 7.12659 7.5 6.66659 7.5H4.99992C4.53992 7.5 4.16659 7.87333 4.16659 8.33333C4.16659 8.79333 4.53992 9.16667 4.99992 9.16667ZM4.99992 5.83333H6.66659C7.12659 5.83333 7.49992 5.46 7.49992 5C7.49992 4.54 7.12659 4.16667 6.66659 4.16667H4.99992C4.53992 4.16667 4.16659 4.54 4.16659 5C4.16659 5.46 4.53992 5.83333 4.99992 5.83333Z",
        fill: "currentColor"
      }
    ) })
  }
), BC = () => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M7.33366 3.33333C8.25413 3.33333 9.00033 2.58714 9.00033 1.66667C9.00033 0.746192 8.25413 0 7.33366 0C6.41318 0 5.66699 0.746192 5.66699 1.66667C5.66699 2.58714 6.41318 3.33333 7.33366 3.33333Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M7.33366 11.6668C8.25413 11.6668 9.00033 10.9206 9.00033 10.0002C9.00033 9.07969 8.25413 8.3335 7.33366 8.3335C6.41318 8.3335 5.66699 9.07969 5.66699 10.0002C5.66699 10.9206 6.41318 11.6668 7.33366 11.6668Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M7.33366 19.9998C8.25413 19.9998 9.00033 19.2536 9.00033 18.3332C9.00033 17.4127 8.25413 16.6665 7.33366 16.6665C6.41318 16.6665 5.66699 17.4127 5.66699 18.3332C5.66699 19.2536 6.41318 19.9998 7.33366 19.9998Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M12.6667 3.33333C13.5871 3.33333 14.3333 2.58714 14.3333 1.66667C14.3333 0.746192 13.5871 0 12.6667 0C11.7462 0 11 0.746192 11 1.66667C11 2.58714 11.7462 3.33333 12.6667 3.33333Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M12.6667 11.6668C13.5871 11.6668 14.3333 10.9206 14.3333 10.0002C14.3333 9.07969 13.5871 8.3335 12.6667 8.3335C11.7462 8.3335 11 9.07969 11 10.0002C11 10.9206 11.7462 11.6668 12.6667 11.6668Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M12.6667 19.9998C13.5871 19.9998 14.3333 19.2536 14.3333 18.3332C14.3333 17.4127 13.5871 16.6665 12.6667 16.6665C11.7462 16.6665 11 17.4127 11 18.3332C11 19.2536 11.7462 19.9998 12.6667 19.9998Z",
          fill: "currentColor"
        }
      )
    ]
  }
), VC = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsx("g", { clipPath: "url(#clip0_2127_32960)", children: /* @__PURE__ */ d.jsx(
      "path",
      {
        d: "M10.8333 4.99954H4.16667C1.86667 4.99954 0 6.86621 0 9.16621V15.8329C0 18.1329 1.86667 19.9995 4.16667 19.9995H10.8333C13.1333 19.9995 15 18.1329 15 15.8329V9.16621C15 6.86621 13.1333 4.99954 10.8333 4.99954ZM4.16667 6.66621H10.8333C12.2083 6.66621 13.3333 7.79121 13.3333 9.16621H1.66667C1.66667 7.79121 2.79167 6.66621 4.16667 6.66621ZM10.8333 18.3329H4.16667C2.79167 18.3329 1.66667 17.2079 1.66667 15.8329V10.8329H13.3333V15.8329C13.3333 17.2079 12.2083 18.3329 10.8333 18.3329ZM20 4.16621V11.2829C20 12.7662 19.2 14.1495 17.9167 14.8912C17.7833 14.9662 17.6417 14.9995 17.5 14.9995C17.2083 14.9995 16.9333 14.8495 16.775 14.5829C16.5417 14.1829 16.6833 13.6745 17.075 13.4412C17.85 12.9912 18.325 12.1662 18.325 11.2745V4.16621C18.325 2.79121 17.2 1.66621 15.825 1.66621H8.71667C7.825 1.66621 7 2.14954 6.55 2.91621C6.31667 3.31621 5.80833 3.44954 5.40833 3.21621C5.00833 2.98288 4.875 2.47454 5.10833 2.07454C5.85 0.791211 7.23333 -0.00878906 8.71667 -0.00878906H15.8333C18.1333 -0.00878906 20 1.85788 20 4.15788V4.16621Z",
        fill: "currentColor"
      }
    ) })
  }
), HC = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsxs("g", { clipPath: "url(#clip0_2341_562)", children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M15.5468 0.775223L5.38676 10.9352C4.99872 11.3212 4.69108 11.7803 4.48167 12.2859C4.27225 12.7916 4.16522 13.3338 4.16676 13.8811V15.0002C4.16676 15.2212 4.25456 15.4332 4.41084 15.5895C4.56712 15.7458 4.77908 15.8336 5.0001 15.8336H6.11926C6.66657 15.8351 7.20874 15.7281 7.71439 15.5187C8.22005 15.3092 8.67914 15.0016 9.0651 14.6136L19.2251 4.45356C19.7121 3.96536 19.9856 3.30395 19.9856 2.61439C19.9856 1.92483 19.7121 1.26341 19.2251 0.775223C18.7298 0.301801 18.0711 0.0375977 17.3859 0.0375977C16.7008 0.0375977 16.042 0.301801 15.5468 0.775223ZM18.0468 3.27522L7.88676 13.4352C7.41687 13.9022 6.78177 14.1652 6.11926 14.1669H5.83343V13.8811C5.83517 13.2186 6.09807 12.5835 6.5651 12.1136L16.7251 1.95356C16.9031 1.78352 17.1398 1.68863 17.3859 1.68863C17.6321 1.68863 17.8688 1.78352 18.0468 1.95356C18.2217 2.12899 18.32 2.36663 18.32 2.61439C18.32 2.86215 18.2217 3.09979 18.0468 3.27522Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M19.1667 7.4825C18.9457 7.4825 18.7337 7.5703 18.5774 7.72658C18.4211 7.88286 18.3333 8.09482 18.3333 8.31583V12.5H15C14.337 12.5 13.7011 12.7634 13.2322 13.2322C12.7634 13.7011 12.5 14.337 12.5 15V18.3333H4.16667C3.50363 18.3333 2.86774 18.0699 2.3989 17.6011C1.93006 17.1323 1.66667 16.4964 1.66667 15.8333V4.16667C1.66667 3.50363 1.93006 2.86774 2.3989 2.3989C2.86774 1.93006 3.50363 1.66667 4.16667 1.66667H11.7017C11.9227 1.66667 12.1346 1.57887 12.2909 1.42259C12.4472 1.26631 12.535 1.05435 12.535 0.833333C12.535 0.61232 12.4472 0.400358 12.2909 0.244078C12.1346 0.0877974 11.9227 0 11.7017 0L4.16667 0C3.062 0.00132321 2.00296 0.440735 1.22185 1.22185C0.440735 2.00296 0.00132321 3.062 0 4.16667L0 15.8333C0.00132321 16.938 0.440735 17.997 1.22185 18.7782C2.00296 19.5593 3.062 19.9987 4.16667 20H13.6192C14.1666 20.0016 14.7089 19.8945 15.2147 19.6851C15.7205 19.4757 16.1797 19.1681 16.5658 18.78L18.7792 16.565C19.1673 16.1791 19.475 15.72 19.6846 15.2143C19.8941 14.7087 20.0013 14.1665 20 13.6192V8.31583C20 8.09482 19.9122 7.88286 19.7559 7.72658C19.5996 7.5703 19.3877 7.4825 19.1667 7.4825ZM15.3875 17.6017C15.0525 17.9358 14.6289 18.1672 14.1667 18.2683V15C14.1667 14.779 14.2545 14.567 14.4107 14.4107C14.567 14.2545 14.779 14.1667 15 14.1667H18.2708C18.1677 14.6279 17.9367 15.0508 17.6042 15.3867L15.3875 17.6017Z",
          fill: "currentColor"
        }
      )
    ] })
  }
), FC = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsx("g", { clipPath: "url(#clip0_2462_9634)", children: /* @__PURE__ */ d.jsx(
      "path",
      {
        d: "M15.55 17.4167C15.2083 17.1083 14.675 17.1417 14.375 17.4917C13.9 18.0333 13.2167 18.3417 12.5 18.3417H4.16667C2.79167 18.3417 1.66667 17.2167 1.66667 15.8417V4.16667C1.66667 2.79167 2.79167 1.66667 4.16667 1.66667H7.925C8.05833 1.66667 8.2 1.66667 8.33333 1.68333V5.83333C8.33333 7.20833 9.45833 8.33333 10.8333 8.33333H15.675C15.9333 8.33333 16.175 8.21667 16.3333 8.00833C16.4917 7.8 16.5417 7.54167 16.4833 7.29167C16.225 6.275 15.7 5.35 14.9583 4.60833L12.0583 1.70833C10.9583 0.608333 9.49167 0 7.93333 0H4.16667C1.86667 0 0 1.86667 0 4.16667V15.8333C0 18.1333 1.86667 20 4.16667 20H12.5C13.6917 20 14.8333 19.4833 15.625 18.5917C15.9333 18.25 15.9 17.7167 15.55 17.4167ZM10 2.21667C10.3167 2.4 10.6083 2.625 10.875 2.89167L13.775 5.79167C14.0333 6.05 14.2583 6.35 14.4417 6.66667H10.825C10.3667 6.66667 9.99167 6.29167 9.99167 5.83333V2.21667H10ZM19.275 15.075L17.9333 16.4167C17.7667 16.5833 17.5583 16.6583 17.3417 16.6583C17.125 16.6583 16.9167 16.575 16.75 16.4167C16.425 16.0917 16.425 15.5667 16.75 15.2417L17.825 14.1667H11.6583C11.2 14.1667 10.825 13.7917 10.825 13.3333C10.825 12.875 11.2 12.5 11.6583 12.5H17.825L16.75 11.425C16.425 11.1 16.425 10.575 16.75 10.25C17.075 9.925 17.6 9.925 17.925 10.25L19.2667 11.5917C20.225 12.55 20.225 14.1167 19.2667 15.0833L19.275 15.075Z",
        fill: "currentColor"
      }
    ) })
  }
), WC = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsxs("g", { clipPath: "url(#clip0_842_5289)", fill: "currentColor", children: [
      /* @__PURE__ */ d.jsx("path", { d: "M19.392 7.85C18.1 5.745 15.16 2.213 10 2.213c-5.16 0-8.1 3.532-9.393 5.637a4.09 4.09 0 000 4.301C1.9 14.256 4.84 17.788 10 17.788c5.16 0 8.1-3.532 9.392-5.637a4.09 4.09 0 000-4.301zm-1.42 3.429c-1.11 1.805-3.623 4.842-7.972 4.842-4.35 0-6.862-3.037-7.972-4.842a2.431 2.431 0 010-2.557C3.138 6.917 5.651 3.88 10 3.88s6.861 3.034 7.971 4.842a2.432 2.432 0 010 2.557z" }),
      /* @__PURE__ */ d.jsx("path", { d: "M10 5.833a4.167 4.167 0 100 8.333 4.167 4.167 0 000-8.333zm0 6.667A2.5 2.5 0 1110 7.5a2.5 2.5 0 010 4.999z" })
    ] })
  }
), zC = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsx("g", { clipPath: "url(#clip0_842_5318)", children: /* @__PURE__ */ d.jsx(
      "path",
      {
        d: "M19.392 7.849a13.22 13.22 0 00-2.809-3.258l2.334-2.333a.833.833 0 00-1.179-1.178l-2.537 2.54A10.045 10.045 0 0010 2.212c-5.16 0-8.1 3.532-9.393 5.637a4.09 4.09 0 000 4.301 13.222 13.222 0 002.81 3.258l-2.334 2.333a.833.833 0 101.178 1.179l2.544-2.544A10.044 10.044 0 0010 17.787c5.159 0 8.099-3.531 9.392-5.636a4.09 4.09 0 000-4.302zM2.027 11.278a2.432 2.432 0 010-2.557C3.14 6.916 5.651 3.88 10 3.88a8.417 8.417 0 013.972.97l-1.678 1.678a4.16 4.16 0 00-5.767 5.767l-1.925 1.925a11.435 11.435 0 01-2.575-2.941zM12.5 10a2.5 2.5 0 01-2.5 2.5 2.458 2.458 0 01-1.071-.25l3.32-3.321c.164.333.25.7.25 1.07zm-5 0A2.5 2.5 0 0110 7.5a2.46 2.46 0 011.07.25l-3.32 3.32A2.46 2.46 0 017.5 10zm10.472 1.278C16.861 13.083 14.348 16.12 10 16.12a8.417 8.417 0 01-3.972-.97l1.678-1.678a4.16 4.16 0 005.766-5.767l1.925-1.925c1.021.826 1.892 1.82 2.575 2.941a2.431 2.431 0 010 2.557z",
        fill: "currentColor"
      }
    ) })
  }
), UC = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsxs("g", { clipPath: "url(#clip0_2127_51729)", children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M1.2474 4.58208H3.5274C3.70626 5.24019 4.09671 5.82116 4.6385 6.23536C5.1803 6.64956 5.84333 6.87397 6.52531 6.87397C7.2073 6.87397 7.87033 6.64956 8.41212 6.23536C8.95392 5.82116 9.34437 5.24019 9.52323 4.58208H19.5807C19.8017 4.58208 20.0137 4.49429 20.17 4.33801C20.3263 4.18173 20.4141 3.96976 20.4141 3.74875C20.4141 3.52774 20.3263 3.31578 20.17 3.1595C20.0137 3.00321 19.8017 2.91542 19.5807 2.91542H9.52323C9.34437 2.25731 8.95392 1.67634 8.41212 1.26214C7.87033 0.847944 7.2073 0.623535 6.52531 0.623535C5.84333 0.623535 5.1803 0.847944 4.6385 1.26214C4.09671 1.67634 3.70626 2.25731 3.5274 2.91542H1.2474C1.02638 2.91542 0.81442 3.00321 0.65814 3.1595C0.50186 3.31578 0.414063 3.52774 0.414062 3.74875C0.414063 3.96976 0.50186 4.18173 0.65814 4.33801C0.81442 4.49429 1.02638 4.58208 1.2474 4.58208ZM6.5249 2.29042C6.81333 2.29042 7.09528 2.37595 7.3351 2.53619C7.57492 2.69643 7.76184 2.9242 7.87222 3.19067C7.9826 3.45715 8.01148 3.75037 7.95521 4.03326C7.89894 4.31615 7.76004 4.576 7.55609 4.77995C7.35214 4.9839 7.09229 5.12279 6.8094 5.17906C6.52651 5.23533 6.23329 5.20645 5.96682 5.09608C5.70034 4.9857 5.47258 4.79878 5.31234 4.55896C5.15209 4.31914 5.06656 4.03718 5.06656 3.74875C5.067 3.36211 5.22079 2.99144 5.49419 2.71804C5.76758 2.44465 6.13826 2.29086 6.5249 2.29042Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M19.5807 10.1667H17.3007C17.1222 9.50846 16.7319 8.92728 16.1901 8.51291C15.6484 8.09854 14.9853 7.87402 14.3032 7.87402C13.6212 7.87402 12.9581 8.09854 12.4163 8.51291C11.8746 8.92728 11.4843 9.50846 11.3057 10.1667H1.2474C1.02638 10.1667 0.81442 10.2545 0.65814 10.4108C0.50186 10.5671 0.414063 10.779 0.414062 11.0001C0.414063 11.2211 0.50186 11.433 0.65814 11.5893C0.81442 11.7456 1.02638 11.8334 1.2474 11.8334H11.3057C11.4843 12.4916 11.8746 13.0728 12.4163 13.4872C12.9581 13.9016 13.6212 14.1261 14.3032 14.1261C14.9853 14.1261 15.6484 13.9016 16.1901 13.4872C16.7319 13.0728 17.1222 12.4916 17.3007 11.8334H19.5807C19.8017 11.8334 20.0137 11.7456 20.17 11.5893C20.3263 11.433 20.4141 11.2211 20.4141 11.0001C20.4141 10.779 20.3263 10.5671 20.17 10.4108C20.0137 10.2545 19.8017 10.1667 19.5807 10.1667ZM14.3032 12.4584C14.0148 12.4584 13.7328 12.3729 13.493 12.2126C13.2532 12.0524 13.0663 11.8246 12.9559 11.5581C12.8455 11.2917 12.8166 10.9984 12.8729 10.7155C12.9292 10.4327 13.0681 10.1728 13.272 9.96885C13.476 9.7649 13.7358 9.62601 14.0187 9.56974C14.3016 9.51347 14.5948 9.54235 14.8613 9.65273C15.1278 9.76311 15.3555 9.95002 15.5158 10.1898C15.676 10.4297 15.7616 10.7116 15.7616 11.0001C15.7611 11.3867 15.6073 11.7574 15.3339 12.0308C15.0605 12.3042 14.6899 12.4579 14.3032 12.4584Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M19.5807 17.4179H9.52323C9.34437 16.7597 8.95392 16.1788 8.41212 15.7646C7.87033 15.3504 7.2073 15.126 6.52531 15.126C5.84333 15.126 5.1803 15.3504 4.6385 15.7646C4.09671 16.1788 3.70626 16.7597 3.5274 17.4179H1.2474C1.02638 17.4179 0.81442 17.5057 0.65814 17.6619C0.50186 17.8182 0.414063 18.0302 0.414062 18.2512C0.414063 18.4722 0.50186 18.6842 0.65814 18.8404C0.81442 18.9967 1.02638 19.0845 1.2474 19.0845H3.5274C3.70626 19.7426 4.09671 20.3236 4.6385 20.7378C5.1803 21.152 5.84333 21.3764 6.52531 21.3764C7.2073 21.3764 7.87033 21.152 8.41212 20.7378C8.95392 20.3236 9.34437 19.7426 9.52323 19.0845H19.5807C19.8017 19.0845 20.0137 18.9967 20.17 18.8404C20.3263 18.6842 20.4141 18.4722 20.4141 18.2512C20.4141 18.0302 20.3263 17.8182 20.17 17.6619C20.0137 17.5057 19.8017 17.4179 19.5807 17.4179ZM6.5249 19.7095C6.23646 19.7095 5.95451 19.624 5.71469 19.4638C5.47487 19.3035 5.28795 19.0757 5.17757 18.8093C5.06719 18.5428 5.03831 18.2496 5.09458 17.9667C5.15085 17.6838 5.28975 17.4239 5.4937 17.22C5.69765 17.016 5.9575 16.8772 6.24039 16.8209C6.52328 16.7646 6.8165 16.7935 7.08298 16.9039C7.34945 17.0142 7.57721 17.2012 7.73746 17.441C7.8977 17.6808 7.98323 17.9628 7.98323 18.2512C7.98257 18.6378 7.82871 19.0083 7.55536 19.2817C7.28202 19.555 6.91147 19.7089 6.5249 19.7095Z",
          fill: "currentColor"
        }
      )
    ] })
  }
), ZC = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsxs("g", { clipPath: "url(#clip0_2656_4413)", children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M15.8333 0H4.16667C1.86667 0 0 1.86667 0 4.16667V15.8333C0 18.1333 1.86667 20 4.16667 20H8.69167C9.15 20 9.525 19.625 9.525 19.1667C9.525 18.7083 9.15 18.3333 8.69167 18.3333H4.16667C2.78333 18.3333 1.66667 17.2167 1.66667 15.8333V4.16667C1.66667 2.78333 2.78333 1.66667 4.16667 1.66667H15.8333C17.2167 1.66667 18.3333 2.78333 18.3333 4.16667V7.78333C18.3333 8.24167 18.7083 8.61667 19.1667 8.61667C19.625 8.61667 20 8.24167 20 7.78333V4.16667C20 1.86667 18.1333 0 15.8333 0Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M9.67511 9.6333C9.67511 10.9416 8.60844 12.0083 7.30011 12.0083V12.8C7.30011 13.2416 6.94178 13.5916 6.50844 13.5916C6.07511 13.5916 5.71678 13.2333 5.71678 12.8V12.0083H5.50844C4.65844 12.0083 3.87511 11.55 3.45011 10.8166C3.23344 10.4333 3.35844 9.94997 3.74178 9.7333C4.12511 9.5083 4.60844 9.64163 4.82511 10.025C4.96678 10.2666 5.23344 10.425 5.50844 10.425H7.30844C7.75011 10.425 8.10011 10.0666 8.10011 9.6333C8.10011 9.3333 7.88344 9.0833 7.59178 9.0333L5.18344 8.6333C4.11678 8.4583 3.35011 7.54163 3.35011 6.46663C3.35011 5.1583 4.41678 4.09163 5.72511 4.09163V3.29997C5.72511 2.8583 6.08344 2.5083 6.51678 2.5083C6.95011 2.5083 7.30844 2.86663 7.30844 3.29997V4.09163H7.51678C8.36678 4.09163 9.15011 4.54997 9.57511 5.2833C9.79178 5.6583 9.66678 6.14997 9.28344 6.36663C8.90011 6.5833 8.41678 6.4583 8.20011 6.07497C8.05844 5.8333 7.79178 5.67497 7.51678 5.67497H5.71678C5.27511 5.67497 4.92511 6.0333 4.92511 6.46663C4.92511 6.76663 5.14178 7.01663 5.43344 7.06663L7.84178 7.46663C8.90844 7.64163 9.67511 8.5583 9.67511 9.6333Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M19.8916 11.2499C19.6583 10.8499 19.15 10.7166 18.75 10.9416L17.9416 11.4083C17.35 10.7499 16.575 10.2583 15.675 10.0833V9.16659C15.675 8.70825 15.3 8.33325 14.8416 8.33325C14.3833 8.33325 14.0083 8.70825 14.0083 9.16659V10.0833C13.1083 10.2666 12.325 10.7499 11.7416 11.4083L10.9333 10.9416C10.5333 10.7083 10.025 10.8499 9.79164 11.2499C9.55831 11.6499 9.69997 12.1583 10.1 12.3916L10.9083 12.8583C10.7666 13.2749 10.675 13.7083 10.675 14.1666C10.675 14.6249 10.7666 15.0583 10.9083 15.4749L10.1 15.9416C9.69997 16.1749 9.56664 16.6833 9.79164 17.0833C9.94997 17.3499 10.225 17.4999 10.5166 17.4999C10.6583 17.4999 10.8 17.4666 10.9333 17.3916L11.7416 16.9249C12.3333 17.5833 13.1083 18.0749 14.0083 18.2499V19.1666C14.0083 19.6249 14.3833 19.9999 14.8416 19.9999C15.3 19.9999 15.675 19.6249 15.675 19.1666V18.2499C16.575 18.0666 17.3583 17.5833 17.9416 16.9249L18.75 17.3916C18.8833 17.4666 19.025 17.4999 19.1666 17.4999C19.4583 17.4999 19.7333 17.3499 19.8916 17.0833C20.125 16.6833 19.9833 16.1749 19.5833 15.9416L18.775 15.4749C18.9166 15.0583 19.0083 14.6249 19.0083 14.1666C19.0083 13.7083 18.9166 13.2666 18.775 12.8583L19.5833 12.3916C19.9833 12.1583 20.1166 11.6499 19.8916 11.2499ZM14.8416 16.6666C13.4666 16.6666 12.3416 15.5416 12.3416 14.1666C12.3416 12.7916 13.4666 11.6666 14.8416 11.6666C16.2166 11.6666 17.3416 12.7916 17.3416 14.1666C17.3416 15.5416 16.2166 16.6666 14.8416 16.6666Z",
          fill: "currentColor"
        }
      )
    ] })
  }
), qC = () => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M50.072 28.858A14.429 14.429 0 1164.5 14.428c-.01 7.965-6.463 14.42-14.428 14.429v.002zm0-26.358A11.928 11.928 0 1062 14.43C61.992 7.844 56.657 2.507 50.072 2.5z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M50.071 18.817c-.69 0-1.25-.56-1.25-1.25v-.087a5.753 5.753 0 012.729-4.855 2.766 2.766 0 10-4.245-2.338 1.25 1.25 0 11-2.5 0 5.288 5.288 0 011.673-3.85 5.22 5.22 0 013.965-1.402 5.267 5.267 0 012.445 9.705 3.258 3.258 0 00-1.567 2.742v.087c0 .69-.56 1.25-1.25 1.25v-.002zM50.072 23.837a1.19 1.19 0 01-.477-.095 1.195 1.195 0 01-.218-.117 1.208 1.208 0 01-.46-.561 1.26 1.26 0 01-.072-.727 1.26 1.26 0 01.982-.982 1.206 1.206 0 01.723.072 1.326 1.326 0 01.405.27 1.218 1.218 0 01.27.407 1.26 1.26 0 01.072.726 1.05 1.05 0 01-.072.234c-.032.075-.07.148-.114.216a1.277 1.277 0 01-1.038.557h-.002zM53.625 64H6.36A5.866 5.866 0 01.5 58.14V31.658a5.879 5.879 0 012.392-4.723l5.033-3.698a1.251 1.251 0 011.482 2.015L4.375 28.95A3.378 3.378 0 003 31.66V58.14a3.363 3.363 0 003.36 3.36h47.265a3.363 3.363 0 003.36-3.36V31.658a3.374 3.374 0 00-1.375-2.708L54 27.765a1.25 1.25 0 011.476-2.015l1.612 1.185a5.885 5.885 0 012.392 4.724V58.14A5.866 5.866 0 0153.625 64z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M56.663 62.85c-.266 0-.526-.085-.74-.243L35.938 47.923a1.25 1.25 0 111.48-2.015l19.987 14.684a1.25 1.25 0 01-.74 2.258h-.002zM3.317 62.85a1.252 1.252 0 01-.742-2.258l19.987-14.684a1.25 1.25 0 111.48 2.015L4.055 62.607a1.24 1.24 0 01-.738.243z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M29.99 52.278a5.852 5.852 0 01-3.707-1.313L1.401 30.653a1.253 1.253 0 01-.205-1.78c.214-.261.524-.426.86-.454.337-.03.67.078.925.298l24.882 20.31a3.376 3.376 0 004.25 0L57 28.717a1.251 1.251 0 111.581 1.937l-24.875 20.31a5.852 5.852 0 01-3.716 1.314z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M51.313 36.22c-.69 0-1.25-.56-1.25-1.25V27.55a1.25 1.25 0 112.5 0v7.421c0 .69-.56 1.25-1.25 1.25zM8.665 36.22c-.69 0-1.25-.56-1.25-1.25V10.875a5.869 5.869 0 015.862-5.86H39.72a1.25 1.25 0 010 2.5H13.277a3.365 3.365 0 00-3.362 3.36V34.97c0 .69-.56 1.25-1.25 1.25z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M28.106 13.797H15.555a1.25 1.25 0 010-2.5h12.551a1.25 1.25 0 010 2.5zM37.885 20.698H15.557a1.25 1.25 0 010-2.5h22.328a1.25 1.25 0 010 2.5zM44.423 27.602H15.557a1.25 1.25 0 010-2.5h28.868a1.25 1.25 0 010 2.5h-.002zM44.423 34.5H15.557a1.25 1.25 0 010-2.5h28.868a1.25 1.25 0 010 2.5h-.002zM44.423 41.408H15.557a1.25 1.25 0 010-2.5h28.868a1.25 1.25 0 010 2.5h-.002z",
          fill: "currentColor"
        }
      )
    ]
  }
), GC = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        d: "M11.115 0.54899C10.809 0.27352 10.4118 0.121094 10 0.121094C9.58824 0.121094 9.19105 0.27352 8.885 0.54899L0 8.54566V17.2123C0 17.9196 0.280952 18.5978 0.781049 19.0979C1.28115 19.598 1.95942 19.879 2.66667 19.879H17.3333C18.0406 19.879 18.7189 19.598 19.219 19.0979C19.719 18.5978 20 17.9196 20 17.2123V8.54566L11.115 0.54899ZM12.5 18.2098H7.5V14.0215C7.5 13.3584 7.76339 12.7226 8.23223 12.2537C8.70107 11.7849 9.33696 11.5215 10 11.5215C10.663 11.5215 11.2989 11.7849 11.7678 12.2537C12.2366 12.7226 12.5 13.3584 12.5 14.0215V18.2098ZM18.3333 17.2098C18.3333 17.475 18.228 17.7294 18.0404 17.9169C17.8529 18.1045 17.5985 18.2098 17.3333 18.2098H14.1667V14.0215C14.1667 12.9164 13.7277 11.8566 12.9463 11.0752C12.1649 10.2938 11.1051 9.85482 10 9.85482C8.89493 9.85482 7.83512 10.2938 7.05372 11.0752C6.27232 11.8566 5.83333 12.9164 5.83333 14.0215V18.2098H2.66667C2.40145 18.2098 2.1471 18.1045 1.95956 17.9169C1.77202 17.7294 1.66667 17.475 1.66667 17.2098V9.28732L10 1.78732L18.3333 9.28732V17.2098Z",
        fill: "currentColor"
      }
    )
  }
), YC = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        d: "M15.8333 21.0018H4.16667C1.86917 21.0018 0 19.1326 0 16.8351V9.10513C0 7.71763 0.686667 6.42596 1.83667 5.65096L7.66917 1.7143C9.085 0.759297 10.915 0.759297 12.3308 1.7143L18.1642 5.65096C19.3133 6.42596 20 7.7168 20 9.10513V16.8351C20 19.1326 18.1308 21.0018 15.8333 21.0018ZM10 2.66596C9.51333 2.66596 9.02667 2.8093 8.60167 3.0968L2.76833 7.03263C2.07833 7.49763 1.66667 8.2718 1.66667 9.1043V16.8343C1.66667 18.2126 2.78833 19.3343 4.16667 19.3343H15.8333C17.2117 19.3343 18.3333 18.2126 18.3333 16.8343V9.10513C18.3333 8.27263 17.9217 7.49763 17.2325 7.03346L11.3983 3.0968C10.9733 2.8093 10.4867 2.66596 10 2.66596Z",
        fill: "currentColor"
      }
    )
  }
), KC = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsxs("g", { clipPath: "url(#clip0_2127_30847)", children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M15.8334 7.02V5.83333C15.8334 4.28624 15.2188 2.80251 14.1249 1.70854C13.0309 0.614582 11.5472 0 10.0001 0C8.45298 0 6.96925 0.614582 5.87529 1.70854C4.78133 2.80251 4.16675 4.28624 4.16675 5.83333V7.02C3.42455 7.34392 2.79283 7.8771 2.34883 8.55434C1.90484 9.23158 1.66781 10.0235 1.66675 10.8333V15.8333C1.66807 16.938 2.10748 17.997 2.8886 18.7782C3.66971 19.5593 4.72875 19.9987 5.83341 20H14.1667C15.2714 19.9987 16.3305 19.5593 17.1116 18.7782C17.8927 17.997 18.3321 16.938 18.3334 15.8333V10.8333C18.3323 10.0235 18.0953 9.23158 17.6513 8.55434C17.2073 7.8771 16.5756 7.34392 15.8334 7.02ZM5.83341 5.83333C5.83341 4.72826 6.2724 3.66846 7.0538 2.88705C7.8352 2.10565 8.89501 1.66667 10.0001 1.66667C11.1052 1.66667 12.165 2.10565 12.9464 2.88705C13.7278 3.66846 14.1667 4.72826 14.1667 5.83333V6.66667H5.83341V5.83333ZM16.6667 15.8333C16.6667 16.4964 16.4034 17.1323 15.9345 17.6011C15.4657 18.0699 14.8298 18.3333 14.1667 18.3333H5.83341C5.17037 18.3333 4.53449 18.0699 4.06565 17.6011C3.59681 17.1323 3.33341 16.4964 3.33341 15.8333V10.8333C3.33341 10.1703 3.59681 9.53441 4.06565 9.06557C4.53449 8.59672 5.17037 8.33333 5.83341 8.33333H14.1667C14.8298 8.33333 15.4657 8.59672 15.9345 9.06557C16.4034 9.53441 16.6667 10.1703 16.6667 10.8333V15.8333Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M10.0001 11.6667C9.77907 11.6667 9.56711 11.7545 9.41083 11.9108C9.25455 12.0671 9.16675 12.2791 9.16675 12.5001V14.1667C9.16675 14.3878 9.25455 14.5997 9.41083 14.756C9.56711 14.9123 9.77907 15.0001 10.0001 15.0001C10.2211 15.0001 10.4331 14.9123 10.5893 14.756C10.7456 14.5997 10.8334 14.3878 10.8334 14.1667V12.5001C10.8334 12.2791 10.7456 12.0671 10.5893 11.9108C10.4331 11.7545 10.2211 11.6667 10.0001 11.6667Z",
          fill: "currentColor"
        }
      )
    ] })
  }
), XC = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsxs("g", { clipPath: "url(#clip0_2127_30861)", children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M9.56333 12.5C9.34232 12.5 9.13036 12.5878 8.97408 12.7441C8.8178 12.9004 8.73 13.1123 8.73 13.3333V15.8333C8.73 16.4964 8.46661 17.1323 7.99777 17.6011C7.52893 18.0699 6.89304 18.3333 6.23 18.3333H4.16667C3.50363 18.3333 2.86774 18.0699 2.3989 17.6011C1.93006 17.1323 1.66667 16.4964 1.66667 15.8333V4.16667C1.66667 3.50363 1.93006 2.86774 2.3989 2.3989C2.86774 1.93006 3.50363 1.66667 4.16667 1.66667H6.23C6.89304 1.66667 7.52893 1.93006 7.99777 2.3989C8.46661 2.86774 8.73 3.50363 8.73 4.16667V6.66667C8.73 6.88768 8.8178 7.09964 8.97408 7.25592C9.13036 7.4122 9.34232 7.5 9.56333 7.5C9.78435 7.5 9.99631 7.4122 10.1526 7.25592C10.3089 7.09964 10.3967 6.88768 10.3967 6.66667V4.16667C10.3953 3.062 9.95593 2.00296 9.17482 1.22185C8.3937 0.440735 7.33466 0.00132321 6.23 0H4.16667C3.062 0.00132321 2.00296 0.440735 1.22185 1.22185C0.440735 2.00296 0.00132321 3.062 0 4.16667L0 15.8333C0.00132321 16.938 0.440735 17.997 1.22185 18.7782C2.00296 19.5593 3.062 19.9987 4.16667 20H6.23C7.33466 19.9987 8.3937 19.5593 9.17482 18.7782C9.95593 17.997 10.3953 16.938 10.3967 15.8333V13.3333C10.3967 13.1123 10.3089 12.9004 10.1526 12.7441C9.99631 12.5878 9.78435 12.5 9.56333 12.5Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M19.0557 8.23232L15.234 4.41066C15.1571 4.33107 15.0652 4.26758 14.9635 4.22391C14.8618 4.18023 14.7525 4.15724 14.6418 4.15628C14.5312 4.15532 14.4215 4.1764 14.319 4.21831C14.2166 4.26021 14.1236 4.32208 14.0453 4.40033C13.9671 4.47857 13.9052 4.57161 13.8633 4.67403C13.8214 4.77644 13.8003 4.88618 13.8013 4.99682C13.8023 5.10747 13.8252 5.21682 13.8689 5.31849C13.9126 5.42016 13.9761 5.51212 14.0557 5.58899L17.6073 9.14149L4.99984 9.16649C4.77882 9.16649 4.56686 9.25429 4.41058 9.41057C4.2543 9.56685 4.1665 9.77881 4.1665 9.99982C4.1665 10.2208 4.2543 10.4328 4.41058 10.5891C4.56686 10.7454 4.77882 10.8332 4.99984 10.8332L17.6565 10.8073L14.054 14.4107C13.9744 14.4875 13.9109 14.5795 13.8673 14.6812C13.8236 14.7828 13.8006 14.8922 13.7996 15.0028C13.7987 15.1135 13.8198 15.2232 13.8617 15.3256C13.9036 15.428 13.9654 15.5211 14.0437 15.5993C14.1219 15.6776 14.215 15.7394 14.3174 15.7813C14.4198 15.8232 14.5295 15.8443 14.6402 15.8434C14.7508 15.8424 14.8602 15.8194 14.9618 15.7757C15.0635 15.7321 15.1555 15.6686 15.2323 15.589L19.054 11.7673C19.5229 11.2987 19.7865 10.6631 19.7868 10.0002C19.7871 9.33726 19.5241 8.70136 19.0557 8.23232Z",
          fill: "currentColor"
        }
      )
    ] })
  }
), QC = () => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M19.1667 6.16699H0.833333C0.373096 6.16699 0 6.54009 0 7.00033C0 7.46056 0.373096 7.83366 0.833333 7.83366H19.1667C19.6269 7.83366 20 7.46056 20 7.00033C20 6.54009 19.6269 6.16699 19.1667 6.16699Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M19.1667 0.333496H0.833333C0.373096 0.333496 0 0.706592 0 1.16683C0 1.62707 0.373096 2.00016 0.833333 2.00016H19.1667C19.6269 2.00016 20 1.62707 20 1.16683C20 0.706592 19.6269 0.333496 19.1667 0.333496Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M19.1667 12H0.833333C0.373096 12 0 12.3731 0 12.8333C0 13.2936 0.373096 13.6667 0.833333 13.6667H19.1667C19.6269 13.6667 20 13.2936 20 12.8333C20 12.3731 19.6269 12 19.1667 12Z",
          fill: "currentColor"
        }
      )
    ]
  }
), JC = () => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M9.99992 3.33333C10.9204 3.33333 11.6666 2.58714 11.6666 1.66667C11.6666 0.746192 10.9204 0 9.99992 0C9.07944 0 8.33325 0.746192 8.33325 1.66667C8.33325 2.58714 9.07944 3.33333 9.99992 3.33333Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M9.99992 11.6668C10.9204 11.6668 11.6666 10.9206 11.6666 10.0002C11.6666 9.07969 10.9204 8.3335 9.99992 8.3335C9.07944 8.3335 8.33325 9.07969 8.33325 10.0002C8.33325 10.9206 9.07944 11.6668 9.99992 11.6668Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M9.99992 19.9998C10.9204 19.9998 11.6666 19.2536 11.6666 18.3332C11.6666 17.4127 10.9204 16.6665 9.99992 16.6665C9.07944 16.6665 8.33325 17.4127 8.33325 18.3332C8.33325 19.2536 9.07944 19.9998 9.99992 19.9998Z",
          fill: "currentColor"
        }
      )
    ]
  }
), ex = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        d: "M18.91 11.382l-1.583-5.696a7.767 7.767 0 00-15.065.395l-1.225 5.512a4.166 4.166 0 004.067 5.07h.928a4.166 4.166 0 008.166 0h.698a4.166 4.166 0 004.014-5.281zm-8.795 6.947a2.5 2.5 0 01-2.346-1.666h4.692a2.5 2.5 0 01-2.346 1.666zm6.77-4.32a2.48 2.48 0 01-1.99.987H5.104a2.5 2.5 0 01-2.44-3.042L3.89 6.442a6.1 6.1 0 0111.832-.31l1.583 5.696a2.48 2.48 0 01-.418 2.181z",
        fill: "currentColor"
      }
    )
  }
), tx = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        d: "M15.4374 6.63908L7.48643 0.805027C6.86542 0.350291 6.13061 0.0764315 5.36347 0.0138145C4.59632 -0.0488024 3.82682 0.10227 3.1403 0.45028C2.45377 0.798291 1.87704 1.32964 1.47406 1.98541C1.07108 2.64118 0.857591 3.39575 0.857269 4.16544V15.8336C0.857407 16.6036 1.07091 17.3585 1.47407 18.0146C1.87724 18.6707 2.45431 19.2022 3.14124 19.5502C3.82816 19.8982 4.59807 20.049 5.36553 19.986C6.13299 19.923 6.86798 19.6485 7.48892 19.1931L15.4399 13.3591C15.9677 12.972 16.3969 12.4661 16.6927 11.8823C16.9886 11.2985 17.1427 10.6532 17.1427 9.99867C17.1427 9.34417 16.9886 8.69887 16.6927 8.11505C16.3969 7.53123 15.9677 7.0253 15.4399 6.63825L15.4374 6.63908ZM14.4506 12.0148L6.49964 17.8488C6.1271 18.121 5.68651 18.2849 5.22662 18.3222C4.76673 18.3595 4.30549 18.2688 3.89395 18.0602C3.48241 17.8516 3.13662 17.5331 2.89486 17.1402C2.6531 16.7472 2.52479 16.295 2.52414 15.8336V4.16544C2.51952 3.70318 2.6454 3.24898 2.88734 2.85505C3.12927 2.46112 3.47743 2.14343 3.89181 1.9385C4.24427 1.75922 4.63402 1.66557 5.02945 1.66513C5.55943 1.66716 6.07476 1.83923 6.49964 2.15603L14.4506 7.99008C14.7669 8.22236 15.0241 8.52582 15.2013 8.87592C15.3786 9.22602 15.471 9.61292 15.471 10.0053C15.471 10.3977 15.3786 10.7847 15.2013 11.1348C15.0241 11.4848 14.7669 11.7883 14.4506 12.0206V12.0148Z",
        fill: "currentColor"
      }
    )
  }
), rx = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        d: "M15.8333 8.83333H11.1667V4.16667C11.1667 3.85725 11.0437 3.5605 10.825 3.34171C10.6062 3.12292 10.3094 3 10 3C9.69058 3 9.39383 3.12292 9.17504 3.34171C8.95625 3.5605 8.83333 3.85725 8.83333 4.16667V8.83333H4.16667C3.85725 8.83333 3.5605 8.95625 3.34171 9.17504C3.12292 9.39383 3 9.69058 3 10C3 10.3094 3.12292 10.6062 3.34171 10.825C3.5605 11.0437 3.85725 11.1667 4.16667 11.1667H8.83333V15.8333C8.83333 16.1428 8.95625 16.4395 9.17504 16.6583C9.39383 16.8771 9.69058 17 10 17C10.3094 17 10.6062 16.8771 10.825 16.6583C11.0437 16.4395 11.1667 16.1428 11.1667 15.8333V11.1667H15.8333C16.1428 11.1667 16.4395 11.0437 16.6583 10.825C16.8771 10.6062 17 10.3094 17 10C17 9.69058 16.8771 9.39383 16.6583 9.17504C16.4395 8.95625 16.1428 8.83333 15.8333 8.83333Z",
        fill: "currentColor"
      }
    )
  }
), nx = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsx("g", { clipPath: "url(#clip0_842_3889)", children: /* @__PURE__ */ d.jsx(
      "path",
      {
        d: "M15.8333 3.33333H14.9167C14.7233 2.39284 14.2115 1.54779 13.4677 0.940598C12.7239 0.333408 11.7935 0.0012121 10.8333 0L9.16667 0C8.2065 0.0012121 7.2761 0.333408 6.53229 0.940598C5.78848 1.54779 5.27675 2.39284 5.08333 3.33333H4.16667C3.062 3.33466 2.00296 3.77407 1.22185 4.55518C0.440735 5.3363 0.00132321 6.39534 0 7.5L0 15.8333C0.00132321 16.938 0.440735 17.997 1.22185 18.7782C2.00296 19.5593 3.062 19.9987 4.16667 20H15.8333C16.938 19.9987 17.997 19.5593 18.7782 18.7782C19.5593 17.997 19.9987 16.938 20 15.8333V7.5C19.9987 6.39534 19.5593 5.3363 18.7782 4.55518C17.997 3.77407 16.938 3.33466 15.8333 3.33333ZM9.16667 1.66667H10.8333C11.3485 1.6688 11.8505 1.83007 12.2706 2.12841C12.6906 2.42674 13.0083 2.84758 13.18 3.33333H6.82C6.99174 2.84758 7.30936 2.42674 7.72942 2.12841C8.14948 1.83007 8.65145 1.6688 9.16667 1.66667ZM4.16667 5H15.8333C16.4964 5 17.1323 5.26339 17.6011 5.73223C18.0699 6.20107 18.3333 6.83696 18.3333 7.5V10H1.66667V7.5C1.66667 6.83696 1.93006 6.20107 2.3989 5.73223C2.86774 5.26339 3.50363 5 4.16667 5ZM15.8333 18.3333H4.16667C3.50363 18.3333 2.86774 18.0699 2.3989 17.6011C1.93006 17.1323 1.66667 16.4964 1.66667 15.8333V11.6667H9.16667V12.5C9.16667 12.721 9.25446 12.933 9.41074 13.0893C9.56702 13.2455 9.77899 13.3333 10 13.3333C10.221 13.3333 10.433 13.2455 10.5893 13.0893C10.7455 12.933 10.8333 12.721 10.8333 12.5V11.6667H18.3333V15.8333C18.3333 16.4964 18.0699 17.1323 17.6011 17.6011C17.1323 18.0699 16.4964 18.3333 15.8333 18.3333Z",
        fill: "currentColor"
      }
    ) })
  }
), ax = () => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17316C0.00433286 8.00043 -0.1937 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8078C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C19.9971 7.34871 18.9426 4.80684 17.0679 2.9321C15.1932 1.05736 12.6513 0.00286757 10 0ZM10 18.3333C8.35183 18.3333 6.74066 17.8446 5.37025 16.9289C3.99984 16.0132 2.93174 14.7117 2.30101 13.189C1.67028 11.6663 1.50525 9.99075 1.82679 8.37425C2.14834 6.75774 2.94201 5.27288 4.10745 4.10744C5.27288 2.94201 6.75774 2.14833 8.37425 1.82679C9.99076 1.50525 11.6663 1.67027 13.189 2.301C14.7117 2.93173 16.0132 3.99984 16.9289 5.37025C17.8446 6.74066 18.3333 8.35182 18.3333 10C18.3309 12.2094 17.4522 14.3276 15.8899 15.8899C14.3276 17.4522 12.2094 18.3309 10 18.3333Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M10.5978 4.21903C10.1173 4.13147 9.62333 4.1506 9.15099 4.27506C8.67864 4.39952 8.23942 4.62628 7.8644 4.93928C7.48939 5.25228 7.18775 5.64388 6.98083 6.08636C6.77392 6.52884 6.66677 7.01139 6.66699 7.49986C6.66699 7.72087 6.75479 7.93284 6.91107 8.08912C7.06735 8.2454 7.27931 8.33319 7.50033 8.33319C7.72134 8.33319 7.9333 8.2454 8.08958 8.08912C8.24586 7.93284 8.33366 7.72087 8.33366 7.49986C8.33345 7.25467 8.38734 7.01246 8.49149 6.79049C8.59563 6.56852 8.74747 6.37227 8.93617 6.21572C9.12488 6.05917 9.3458 5.94618 9.58318 5.88481C9.82056 5.82345 10.0686 5.81521 10.3095 5.86069C10.6387 5.9246 10.9414 6.08518 11.1789 6.32193C11.4164 6.55869 11.5779 6.86086 11.6428 7.18986C11.7084 7.5352 11.6631 7.89242 11.5135 8.21047C11.3638 8.52852 11.1174 8.79111 10.8095 8.96069C10.2996 9.25608 9.87831 9.68279 9.58943 10.1964C9.30055 10.7099 9.15467 11.2916 9.16699 11.8807V12.4999C9.16699 12.7209 9.25479 12.9328 9.41107 13.0891C9.56735 13.2454 9.77931 13.3332 10.0003 13.3332C10.2213 13.3332 10.4333 13.2454 10.5896 13.0891C10.7459 12.9328 10.8337 12.7209 10.8337 12.4999V11.8807C10.8232 11.5907 10.8893 11.3031 11.0254 11.0468C11.1614 10.7905 11.3626 10.5745 11.6087 10.4207C12.2124 10.0891 12.6986 9.57857 13.0004 8.95936C13.3022 8.34015 13.4047 7.64266 13.2939 6.9628C13.1831 6.28294 12.8644 5.6541 12.3816 5.16277C11.8988 4.67144 11.2756 4.34175 10.5978 4.21903Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M10.8337 14.9998C10.8337 14.5396 10.4606 14.1665 10.0003 14.1665C9.54009 14.1665 9.16699 14.5396 9.16699 14.9998C9.16699 15.4601 9.54009 15.8332 10.0003 15.8332C10.4606 15.8332 10.8337 15.4601 10.8337 14.9998Z",
          fill: "currentColor"
        }
      )
    ]
  }
), ix = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsx("g", { clipPath: "url(#clip0_1353_11649)", children: /* @__PURE__ */ d.jsx("path", { d: "M19.7561 18.5773L14.782 13.6032C16.1375 11.9453 16.804 9.8299 16.6435 7.69445C16.4831 5.55901 15.508 3.56693 13.92 2.13025C12.3319 0.693577 10.2525 -0.0777715 8.11167 -0.024245C5.97088 0.0292815 3.93256 0.903588 2.41832 2.41783C0.904076 3.93207 0.0297698 5.97039 -0.0237567 8.11119C-0.0772832 10.252 0.694065 12.3314 2.13074 13.9195C3.56742 15.5075 5.5595 16.4826 7.69494 16.643C9.83038 16.8035 11.9458 16.137 13.6036 14.7815L18.5778 19.7557C18.735 19.9075 18.9455 19.9914 19.164 19.9895C19.3825 19.9876 19.5915 19.9 19.746 19.7455C19.9005 19.591 19.9881 19.382 19.99 19.1635C19.9919 18.945 19.9079 18.7345 19.7561 18.5773ZM8.33364 14.9998C7.0151 14.9998 5.72617 14.6088 4.62984 13.8763C3.53351 13.1437 2.67903 12.1025 2.17444 10.8844C1.66986 9.6662 1.53784 8.32576 1.79507 7.03255C2.05231 5.73934 2.68724 4.55146 3.61959 3.61911C4.55194 2.68676 5.73983 2.05182 7.03304 1.79458C8.32624 1.53735 9.66669 1.66937 10.8849 2.17395C12.103 2.67854 13.1442 3.53302 13.8768 4.62935C14.6093 5.72568 15.0003 7.01461 15.0003 8.33315C14.9983 10.1007 14.2953 11.7952 13.0455 13.045C11.7957 14.2948 10.1011 14.9978 8.33364 14.9998Z", fill: "currentColor" }) })
  }
), ox = () => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M16.743 10L8.25505 10C8.1049 9.9994 7.95831 9.95665 7.83381 9.87715C7.70931 9.79765 7.6125 9.68497 7.55561 9.55336C7.49873 9.42176 7.48433 9.27713 7.51423 9.13777C7.54413 8.99841 7.61699 8.87057 7.7236 8.77043L11.96 4.75815C12.0306 4.69075 12.1145 4.63726 12.207 4.60075C12.2996 4.56425 12.3988 4.54545 12.499 4.54545C12.5992 4.54545 12.6985 4.56425 12.791 4.60075C12.8835 4.63726 12.9675 4.69075 13.0381 4.75815L17.2744 8.77043C17.3811 8.87057 17.4539 8.99841 17.4838 9.13777C17.5137 9.27713 17.4993 9.42176 17.4424 9.55337C17.3855 9.68497 17.2887 9.79765 17.1642 9.87715C17.0397 9.95665 16.8931 9.9994 16.743 10Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M8.25505 14H16.743C16.8931 14.0006 17.0397 14.0433 17.1642 14.1228C17.2887 14.2023 17.3855 14.315 17.4424 14.4466C17.4993 14.5782 17.5137 14.7229 17.4838 14.8622C17.4539 15.0016 17.3811 15.1294 17.2744 15.2296L13.0381 19.2419C12.9675 19.3092 12.8835 19.3627 12.791 19.3992C12.6985 19.4358 12.5992 19.4545 12.499 19.4545C12.3988 19.4545 12.2996 19.4358 12.207 19.3992C12.1145 19.3627 12.0306 19.3092 11.96 19.2419L7.7236 15.2296C7.61699 15.1294 7.54413 15.0016 7.51423 14.8622C7.48433 14.7229 7.49873 14.5782 7.55561 14.4466C7.6125 14.315 7.70931 14.2023 7.83381 14.1228C7.95831 14.0433 8.1049 14.0006 8.25505 14Z",
          fill: "currentColor"
        }
      )
    ]
  }
), sx = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 97 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsxs("g", { clipPath: "url(#clip0_1300_12843)", fill: "currentColor", children: [
      /* @__PURE__ */ d.jsx("path", { d: "M67.225 43.186c-.387 0-.778-.113-1.11-.34a29.453 29.453 0 00-7.388-3.625 1.96 1.96 0 01-1.356-1.861V20.11c0-4.326-3.537-7.845-7.885-7.845s-7.885 3.518-7.885 7.844v17.25a1.96 1.96 0 01-1.356 1.862 29.545 29.545 0 00-7.388 3.624 1.978 1.978 0 01-2.03.114 1.959 1.959 0 01-1.05-1.734V20.106C29.776 9.296 38.618.5 49.484.5 60.35.5 69.194 9.296 69.194 20.11v21.117a1.972 1.972 0 01-1.972 1.962l.003-.003zm-5.913-7.214c1.35.508 2.67 1.102 3.941 1.779V20.109c0-8.651-7.073-15.688-15.767-15.688-8.694 0-15.767 7.037-15.767 15.688v17.642a33.676 33.676 0 013.94-1.779V20.106c0-6.487 5.306-11.764 11.827-11.764s11.826 5.277 11.826 11.764v15.866z" }),
      /* @__PURE__ */ d.jsx("path", { d: "M49.486 100.5c-18.476 0-33.51-14.952-33.51-33.332 0-18.38 15.032-33.332 33.51-33.332 18.478 0 33.507 14.953 33.507 33.332 0 18.38-15.031 33.332-33.507 33.332zm0-62.744c-16.303 0-29.565 13.194-29.565 29.412 0 16.218 13.262 29.412 29.565 29.412s29.565-13.194 29.565-29.412c0-16.218-13.262-29.412-29.565-29.412z" }),
      /* @__PURE__ */ d.jsx("path", { d: "M53.427 88.736h-7.885a1.967 1.967 0 01-1.972-1.962v-2.966a17.763 17.763 0 01-1.732-.716l-2.109 2.098a1.979 1.979 0 01-2.789 0l-5.575-5.547a1.959 1.959 0 010-2.775l2.108-2.097c-.27-.564-.51-1.138-.72-1.726h-2.981a1.967 1.967 0 01-1.972-1.962V63.24c0-1.082.881-1.962 1.972-1.962h2.982c.209-.585.449-1.162.72-1.725l-2.11-2.098a1.964 1.964 0 01-.577-1.388c0-.521.21-1.018.578-1.387l5.575-5.546a1.979 1.979 0 012.79 0l2.108 2.097c.566-.269 1.144-.508 1.732-.716v-2.966c0-1.082.882-1.962 1.972-1.962h7.885c1.088 0 1.972.877 1.972 1.962v2.966c.589.208 1.169.447 1.735.716l2.109-2.097a1.977 1.977 0 012.786 0l5.575 5.546c.77.766.77 2.006 0 2.772l-2.108 2.098c.27.563.51 1.137.72 1.726h2.981c1.088 0 1.972.876 1.972 1.961v7.844a1.967 1.967 0 01-1.972 1.962h-2.981c-.21.586-.45 1.163-.72 1.723l2.109 2.098c.77.766.77 2.006 0 2.775l-5.576 5.543a1.977 1.977 0 01-2.786 0l-2.11-2.097c-.565.269-1.143.507-1.734.716v2.966a1.965 1.965 0 01-1.972 1.962v.008zm-5.913-3.92h3.944v-2.457c0-.896.608-1.675 1.478-1.897 1.244-.32 2.44-.813 3.556-1.468a1.978 1.978 0 012.396.302l1.746 1.737 2.79-2.775-1.75-1.736a1.953 1.953 0 01-.303-2.384c.658-1.11 1.154-2.3 1.475-3.538a1.97 1.97 0 011.908-1.47h2.468v-3.92h-2.468a1.968 1.968 0 01-1.908-1.471 13.609 13.609 0 00-1.475-3.538 1.953 1.953 0 01.304-2.384l1.749-1.737-2.79-2.771-1.746 1.736a1.979 1.979 0 01-2.396.303 13.76 13.76 0 00-3.556-1.468 1.961 1.961 0 01-1.478-1.898v-2.455h-3.944v2.455c0 .896-.608 1.676-1.481 1.898-1.244.32-2.44.813-3.556 1.468a1.975 1.975 0 01-2.396-.303l-1.746-1.736-2.787 2.771 1.746 1.737c.636.633.762 1.615.305 2.384a13.646 13.646 0 00-1.476 3.538 1.968 1.968 0 01-1.908 1.47h-2.468v3.92h2.468c.901 0 1.685.606 1.908 1.471.32 1.238.817 2.428 1.476 3.538.457.771.331 1.751-.305 2.384l-1.746 1.736 2.787 2.775 1.746-1.737a1.98 1.98 0 012.396-.302 13.796 13.796 0 003.556 1.468 1.96 1.96 0 011.481 1.897v2.456z" }),
      /* @__PURE__ */ d.jsx("path", { d: "M49.483 77.287c-1.632 0-3.3-.374-4.892-1.143-1.584-.766-3.361-2.53-4.13-4.11-2.043-4.18-1.326-8.903 1.82-12.033 3.147-3.13 7.894-3.84 12.097-1.812 1.584.766 3.361 2.533 4.13 4.11 2.043 4.178 1.326 8.904-1.82 12.03-1.956 1.946-4.527 2.956-7.205 2.956v.002zm.011-16.334a6.296 6.296 0 00-4.426 1.82c-1.545 1.537-2.636 4.326-1.063 7.547.388.794 1.51 1.91 2.307 2.295 3.235 1.565 6.041.48 7.584-1.057 1.545-1.538 2.635-4.326 1.062-7.548-.387-.793-1.509-1.909-2.306-2.294-1.116-.538-2.179-.763-3.158-.763zM92.847 52.46a2.949 2.949 0 01-2.957 2.94 2.95 2.95 0 01-2.956-2.94 2.95 2.95 0 012.956-2.942 2.95 2.95 0 012.957 2.941zM6.122 25.01a2.949 2.949 0 01-2.956 2.94 2.949 2.949 0 01-2.957-2.94 2.949 2.949 0 012.957-2.942 2.949 2.949 0 012.956 2.941zM14.005 87.754a2.949 2.949 0 01-2.957 2.94 2.95 2.95 0 01-2.956-2.94 2.95 2.95 0 012.956-2.942 2.95 2.95 0 012.957 2.942zM21.89 8.345a1.967 1.967 0 01-1.972 1.961 1.965 1.965 0 01-1.972-1.961c0-1.085.881-1.962 1.972-1.962 1.09 0 1.972.877 1.972 1.962zM21.89 37.754a1.967 1.967 0 01-1.972 1.961 1.965 1.965 0 01-1.972-1.962c0-1.084.881-1.961 1.972-1.961 1.09 0 1.972.877 1.972 1.962zM92.847 86.774a1.967 1.967 0 01-1.972 1.962 1.965 1.965 0 01-1.972-1.962c0-1.085.881-1.962 1.972-1.962 1.09 0 1.972.877 1.972 1.962zM81.02 35.795c-8.696 0-15.77-7.037-15.77-15.689 0-8.651 7.074-15.685 15.77-15.685 8.697 0 15.768 7.037 15.768 15.686 0 8.648-7.074 15.688-15.768 15.688zm0-27.45c-6.52 0-11.826 5.277-11.826 11.764 0 6.487 5.305 11.765 11.826 11.765 6.522 0 11.827-5.277 11.827-11.765 0-6.487-5.305-11.764-11.827-11.764z" }),
      /* @__PURE__ */ d.jsx("path", { d: "M79.288 25.992c-.504 0-1.01-.192-1.394-.575l-2.62-2.605a1.956 1.956 0 010-2.775 1.98 1.98 0 012.79 0l1.224 1.218 5.576-5.546a1.977 1.977 0 012.786 0c.77.765.77 2.006 0 2.774l-6.967 6.931c-.385.383-.89.575-1.395.575v.003z" })
    ] })
  }
), lx = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsxs("g", { clipPath: "url(#clip0_2648_4382)", children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M4.16667 18.3333C2.78333 18.3333 1.66667 17.2167 1.66667 15.8333V5.83333H7.5C7.5 7.21667 8.61667 8.33333 10 8.33333C11.3833 8.33333 12.5 7.21667 12.5 5.83333H18.3333V7.96667C18.3333 8.425 18.7083 8.8 19.1667 8.8C19.625 8.8 20 8.425 20 7.96667V4.16667C20 1.86667 18.1333 0 15.8333 0H4.16667C1.86667 0 0 1.86667 0 4.16667V15.8333C0 18.1333 1.86667 20 4.16667 20H9.30833C9.76667 20 10.1417 19.625 10.1417 19.1667C10.1417 18.7083 9.76667 18.3333 9.30833 18.3333H4.16667ZM12.5 1.66667H15.8333C17.2167 1.66667 18.3333 2.78333 18.3333 4.16667H12.5V1.66667ZM9.16667 1.66667H10.8333V5.83333C10.8333 6.29167 10.4583 6.66667 10 6.66667C9.54167 6.66667 9.16667 6.29167 9.16667 5.83333V1.66667ZM4.16667 1.66667H7.5V4.16667H1.66667C1.66667 2.78333 2.78333 1.66667 4.16667 1.66667Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M19.5833 15.9499L18.775 15.4832C18.9166 15.0666 19.0083 14.6332 19.0083 14.1749C19.0083 13.7166 18.9166 13.2749 18.775 12.8666L19.5833 12.3999C19.9833 12.1666 20.1166 11.6582 19.8916 11.2582C19.6583 10.8582 19.15 10.7249 18.75 10.9499L17.9416 11.4166C17.35 10.7582 16.575 10.2666 15.675 10.0916V9.17489C15.675 8.71655 15.3 8.34155 14.8416 8.34155C14.3833 8.34155 14.0083 8.71655 14.0083 9.17489V10.0916C13.1083 10.2749 12.325 10.7582 11.7416 11.4166L10.9333 10.9499C10.5333 10.7166 10.025 10.8582 9.79164 11.2582C9.55831 11.6582 9.69997 12.1666 10.1 12.3999L10.9083 12.8666C10.7666 13.2832 10.675 13.7166 10.675 14.1749C10.675 14.6332 10.7666 15.0666 10.9083 15.4832L10.1 15.9499C9.69997 16.1832 9.56664 16.6916 9.79164 17.0916C9.94997 17.3582 10.225 17.5082 10.5166 17.5082C10.6583 17.5082 10.8 17.4749 10.9333 17.3999L11.7416 16.9332C12.3333 17.5916 13.1083 18.0832 14.0083 18.2582V19.1749C14.0083 19.6332 14.3833 20.0082 14.8416 20.0082C15.3 20.0082 15.675 19.6332 15.675 19.1749V18.2582C16.575 18.0749 17.3583 17.5916 17.9416 16.9332L18.75 17.3999C18.8833 17.4749 19.025 17.5082 19.1666 17.5082C19.4583 17.5082 19.7333 17.3582 19.8916 17.0916C20.125 16.6916 19.9833 16.1832 19.5833 15.9499ZM14.8333 16.6749C13.4583 16.6749 12.3333 15.5499 12.3333 14.1749C12.3333 12.7999 13.4583 11.6749 14.8333 11.6749C16.2083 11.6749 17.3333 12.7999 17.3333 14.1749C17.3333 15.5499 16.2083 16.6749 14.8333 16.6749Z",
          fill: "currentColor"
        }
      )
    ] })
  }
), cx = () => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M15.8333 3.33333H13.25C13.0566 2.39284 12.5448 1.54779 11.801 0.940598C11.0572 0.333408 10.1268 0.0012121 9.16667 0L7.5 0C6.53983 0.0012121 5.60943 0.333408 4.86562 0.940598C4.12182 1.54779 3.61008 2.39284 3.41667 3.33333H0.833333C0.61232 3.33333 0.400358 3.42113 0.244078 3.57741C0.0877973 3.73369 0 3.94565 0 4.16667C0 4.38768 0.0877973 4.59964 0.244078 4.75592C0.400358 4.9122 0.61232 5 0.833333 5H1.66667V15.8333C1.66799 16.938 2.1074 17.997 2.88852 18.7782C3.66963 19.5593 4.72867 19.9987 5.83333 20H10.8333C11.938 19.9987 12.997 19.5593 13.7782 18.7782C14.5593 17.997 14.9987 16.938 15 15.8333V5H15.8333C16.0543 5 16.2663 4.9122 16.4226 4.75592C16.5789 4.59964 16.6667 4.38768 16.6667 4.16667C16.6667 3.94565 16.5789 3.73369 16.4226 3.57741C16.2663 3.42113 16.0543 3.33333 15.8333 3.33333ZM7.5 1.66667H9.16667C9.68356 1.6673 10.1876 1.82781 10.6097 2.1262C11.0317 2.42459 11.3512 2.84624 11.5242 3.33333H5.1425C5.31549 2.84624 5.63492 2.42459 6.05699 2.1262C6.47906 1.82781 6.9831 1.6673 7.5 1.66667ZM13.3333 15.8333C13.3333 16.4964 13.0699 17.1323 12.6011 17.6011C12.1323 18.0699 11.4964 18.3333 10.8333 18.3333H5.83333C5.17029 18.3333 4.53441 18.0699 4.06557 17.6011C3.59673 17.1323 3.33333 16.4964 3.33333 15.8333V5H13.3333V15.8333Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M6.66683 15.0002C6.88784 15.0002 7.0998 14.9124 7.25608 14.7561C7.41237 14.5998 7.50016 14.3878 7.50016 14.1668V9.16683C7.50016 8.94582 7.41237 8.73385 7.25608 8.57757C7.0998 8.42129 6.88784 8.3335 6.66683 8.3335C6.44582 8.3335 6.23385 8.42129 6.07757 8.57757C5.92129 8.73385 5.8335 8.94582 5.8335 9.16683V14.1668C5.8335 14.3878 5.92129 14.5998 6.07757 14.7561C6.23385 14.9124 6.44582 15.0002 6.66683 15.0002Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M9.99984 15.0002C10.2209 15.0002 10.4328 14.9124 10.5891 14.7561C10.7454 14.5998 10.8332 14.3878 10.8332 14.1668V9.16683C10.8332 8.94582 10.7454 8.73385 10.5891 8.57757C10.4328 8.42129 10.2209 8.3335 9.99984 8.3335C9.77882 8.3335 9.56686 8.42129 9.41058 8.57757C9.2543 8.73385 9.1665 8.94582 9.1665 9.16683V14.1668C9.1665 14.3878 9.2543 14.5998 9.41058 14.7561C9.56686 14.9124 9.77882 15.0002 9.99984 15.0002Z",
          fill: "currentColor"
        }
      )
    ]
  }
), ux = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsxs("g", { clipPath: "url(#clip0_2127_30842)", children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M10 10C10.9889 10 11.9556 9.70676 12.7779 9.15735C13.6001 8.60794 14.241 7.82705 14.6194 6.91342C14.9978 5.99979 15.0969 4.99446 14.9039 4.02455C14.711 3.05465 14.2348 2.16373 13.5355 1.46447C12.8363 0.765206 11.9454 0.289002 10.9755 0.0960758C10.0055 -0.0968503 9.00021 0.00216643 8.08658 0.380605C7.17295 0.759043 6.39206 1.39991 5.84265 2.22215C5.29324 3.0444 5 4.0111 5 5C5.00132 6.32568 5.52853 7.59668 6.46593 8.53407C7.40332 9.47147 8.67432 9.99868 10 10ZM10 1.66667C10.6593 1.66667 11.3037 1.86217 11.8519 2.22844C12.4001 2.59471 12.8273 3.1153 13.0796 3.72439C13.3319 4.33348 13.3979 5.0037 13.2693 5.6503C13.1407 6.29691 12.8232 6.89085 12.357 7.35703C11.8908 7.8232 11.2969 8.14067 10.6503 8.26929C10.0037 8.3979 9.33348 8.33189 8.72439 8.0796C8.1153 7.82731 7.59471 7.40007 7.22843 6.8519C6.86216 6.30374 6.66667 5.65927 6.66667 5C6.66667 4.11595 7.01786 3.2681 7.64298 2.64298C8.2681 2.01786 9.11594 1.66667 10 1.66667Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M10 11.6667C8.01155 11.669 6.10518 12.4598 4.69914 13.8659C3.29309 15.2719 2.50221 17.1783 2.5 19.1667C2.5 19.3878 2.5878 19.5997 2.74408 19.756C2.90036 19.9123 3.11232 20.0001 3.33333 20.0001C3.55435 20.0001 3.76631 19.9123 3.92259 19.756C4.07887 19.5997 4.16667 19.3878 4.16667 19.1667C4.16667 17.6197 4.78125 16.1359 5.87521 15.042C6.96917 13.948 8.4529 13.3334 10 13.3334C11.5471 13.3334 13.0308 13.948 14.1248 15.042C15.2188 16.1359 15.8333 17.6197 15.8333 19.1667C15.8333 19.3878 15.9211 19.5997 16.0774 19.756C16.2337 19.9123 16.4457 20.0001 16.6667 20.0001C16.8877 20.0001 17.0996 19.9123 17.2559 19.756C17.4122 19.5997 17.5 19.3878 17.5 19.1667C17.4978 17.1783 16.7069 15.2719 15.3009 13.8659C13.8948 12.4598 11.9884 11.669 10 11.6667Z",
          fill: "currentColor"
        }
      )
    ] })
  }
), fx = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsx("g", { clipPath: "url(#clip0_2127_30857)", children: /* @__PURE__ */ d.jsx(
      "path",
      {
        d: "M5.83333 11.6667C7.675 11.6667 9.16667 10.175 9.16667 8.33333C9.16667 6.49167 7.675 5 5.83333 5C3.99167 5 2.5 6.49167 2.5 8.33333C2.5 10.175 3.99167 11.6667 5.83333 11.6667ZM5.83333 6.66667C6.75 6.66667 7.5 7.41667 7.5 8.33333C7.5 9.25 6.75 10 5.83333 10C4.91667 10 4.16667 9.25 4.16667 8.33333C4.16667 7.41667 4.91667 6.66667 5.83333 6.66667ZM11.6667 19.1667C11.6667 19.625 11.2917 20 10.8333 20C10.375 20 10 19.625 10 19.1667C10 16.8667 8.13333 15 5.83333 15C3.53333 15 1.66667 16.8667 1.66667 19.1667C1.66667 19.625 1.29167 20 0.833333 20C0.375 20 0 19.625 0 19.1667C0 15.95 2.61667 13.3333 5.83333 13.3333C9.05 13.3333 11.6667 15.95 11.6667 19.1667ZM20 4.16667V10.8333C20 13.1333 18.1333 15 15.8333 15H12.5C12.0417 15 11.6667 14.625 11.6667 14.1667C11.6667 13.7083 12.0417 13.3333 12.5 13.3333H15.8333C17.2083 13.3333 18.3333 12.2083 18.3333 10.8333V4.16667C18.3333 2.79167 17.2083 1.66667 15.8333 1.66667H7.88333C6.99167 1.66667 6.16667 2.15 5.71667 2.91667C5.48333 3.31667 4.975 3.45 4.575 3.225C4.175 2.99167 4.04167 2.48333 4.275 2.08333C5.025 0.8 6.40833 0 7.88333 0H15.8333C18.1333 0 20 1.86667 20 4.16667ZM11.3917 9.1L13.825 6.66667H12.5C12.0417 6.66667 11.6667 6.29167 11.6667 5.83333C11.6667 5.375 12.0417 5 12.5 5H15C15.9167 5 16.6667 5.75 16.6667 6.66667V9.16667C16.6667 9.625 16.2917 10 15.8333 10C15.375 10 15 9.625 15 9.16667V7.84167L12.5667 10.275C12.1833 10.6583 11.6667 10.8667 11.1417 10.8667C10.9583 10.8667 10.775 10.8417 10.5917 10.7917C10.15 10.6667 9.89167 10.2083 10.0167 9.76667C10.1417 9.325 10.6 9.06667 11.05 9.19167C11.15 9.21667 11.2833 9.20833 11.3917 9.1Z",
        fill: "currentColor"
      }
    ) })
  }
), dx = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsx("g", { clipPath: "url(#clip0_2656_4398)", children: /* @__PURE__ */ d.jsx(
      "path",
      {
        d: "M12.4999 5C12.4999 2.2425 10.2574 0 7.49986 0C4.74236 0 2.49986 2.2425 2.49986 5C2.49986 7.7575 4.74236 10 7.49986 10C10.2574 10 12.4999 7.7575 12.4999 5ZM7.49986 8.33333C5.66152 8.33333 4.16652 6.83833 4.16652 5C4.16652 3.16167 5.66152 1.66667 7.49986 1.66667C9.33819 1.66667 10.8332 3.16167 10.8332 5C10.8332 6.83833 9.33819 8.33333 7.49986 8.33333ZM7.49319 12.4483C7.54986 12.905 7.22652 13.3208 6.76902 13.3783C3.85986 13.7417 1.66569 16.2292 1.66569 19.1667C1.66569 19.6267 1.29236 20 0.832357 20C0.372357 20 -0.000976562 19.6267 -0.000976562 19.1667C-0.000976562 15.3908 2.82069 12.1917 6.56236 11.725C7.01402 11.6675 7.43486 11.9917 7.49236 12.4492L7.49319 12.4483ZM18.9132 15.9442L18.1015 15.4758C18.2399 15.0617 18.3332 14.6267 18.3332 14.1658C18.3332 13.705 18.2407 13.27 18.1015 12.8558L18.9132 12.3875C19.3115 12.1575 19.4482 11.6475 19.2182 11.2492C18.9874 10.85 18.479 10.7125 18.0799 10.9442L17.269 11.4125C16.6815 10.7508 15.899 10.2667 14.9999 10.0842V9.16667C14.9999 8.70667 14.6265 8.33333 14.1665 8.33333C13.7065 8.33333 13.3332 8.70667 13.3332 9.16667V10.0842C12.434 10.2675 11.6515 10.7517 11.064 11.4125L10.2532 10.9442C9.85319 10.7133 9.34486 10.85 9.11486 11.2492C8.88486 11.6483 9.02152 12.1575 9.41986 12.3875L10.2315 12.8558C10.0932 13.27 9.99986 13.705 9.99986 14.1658C9.99986 14.6267 10.0924 15.0617 10.2315 15.4758L9.41986 15.9442C9.02152 16.1742 8.88486 16.6842 9.11486 17.0825C9.26986 17.35 9.54902 17.4992 9.83736 17.4992C9.97819 17.4992 10.1215 17.4633 10.2532 17.3875L11.064 16.9192C11.6515 17.5808 12.434 18.065 13.3332 18.2475V19.165C13.3332 19.625 13.7065 19.9983 14.1665 19.9983C14.6265 19.9983 14.9999 19.625 14.9999 19.165V18.2475C15.899 18.0642 16.6815 17.58 17.269 16.9192L18.0799 17.3875C18.2115 17.4633 18.3549 17.4992 18.4957 17.4992C18.784 17.4992 19.064 17.35 19.2182 17.0825C19.4482 16.6833 19.3115 16.1742 18.9132 15.9442ZM14.1665 16.6658C12.7882 16.6658 11.6665 15.5442 11.6665 14.1658C11.6665 12.7875 12.7882 11.6658 14.1665 11.6658C15.5449 11.6658 16.6665 12.7875 16.6665 14.1658C16.6665 15.5442 15.5449 16.6658 14.1665 16.6658Z",
        fill: "currentColor"
      }
    ) })
  }
), px = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsx("g", { clipPath: "url(#clip0_2127_42419)", children: /* @__PURE__ */ d.jsx(
      "path",
      {
        d: "M9.13972 12.5022C9.25472 12.9481 8.98639 13.4022 8.54055 13.5164C5.96472 14.1797 4.16555 16.5022 4.16555 19.1664C4.16555 19.6264 3.79222 19.9997 3.33222 19.9997C2.87222 19.9997 2.49889 19.6264 2.49889 19.1664C2.49889 15.7422 4.81222 12.7556 8.12389 11.9031C8.57305 11.7889 9.02389 12.0564 9.13889 12.5022H9.13972ZM19.7556 19.7556C19.5931 19.9181 19.3797 19.9997 19.1664 19.9997C18.9531 19.9997 18.7397 19.9181 18.5772 19.7556L0.243887 1.42222C-0.0819466 1.09639 -0.0819466 0.56972 0.243887 0.243887C0.56972 -0.0819466 1.09639 -0.0819466 1.42222 0.243887L5.11555 3.93722C5.60472 1.68972 7.60722 -0.000279957 9.99972 -0.000279957C12.7572 -0.000279957 14.9997 2.24222 14.9997 4.99972C14.9997 7.39222 13.3097 9.39472 11.0622 9.88389L19.7556 18.5772C20.0814 18.9031 20.0814 19.4297 19.7556 19.7556ZM6.72055 5.54222L9.45722 8.27889C9.63639 8.30805 9.81722 8.33305 9.99972 8.33305C11.8381 8.33305 13.3331 6.83805 13.3331 4.99972C13.3331 3.16139 11.8381 1.66639 9.99972 1.66639C8.16139 1.66639 6.66639 3.16139 6.66639 4.99972C6.66639 5.18139 6.69139 5.36305 6.72055 5.54222Z",
        fill: "currentColor"
      }
    ) })
  }
), hx = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsxs("g", { clipPath: "url(#clip0_2364_27217)", children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M19.8333 9.1665H18.1667V7.49984C18.1667 7.27882 18.0789 7.06686 17.9226 6.91058C17.7663 6.7543 17.5543 6.6665 17.3333 6.6665C17.1123 6.6665 16.9004 6.7543 16.7441 6.91058C16.5878 7.06686 16.5 7.27882 16.5 7.49984V9.1665H14.8333C14.6123 9.1665 14.4004 9.2543 14.2441 9.41058C14.0878 9.56686 14 9.77882 14 9.99984C14 10.2209 14.0878 10.4328 14.2441 10.5891C14.4004 10.7454 14.6123 10.8332 14.8333 10.8332H16.5V12.4998C16.5 12.7209 16.5878 12.9328 16.7441 13.0891C16.9004 13.2454 17.1123 13.3332 17.3333 13.3332C17.5543 13.3332 17.7663 13.2454 17.9226 13.0891C18.0789 12.9328 18.1667 12.7209 18.1667 12.4998V10.8332H19.8333C20.0543 10.8332 20.2663 10.7454 20.4226 10.5891C20.5789 10.4328 20.6667 10.2209 20.6667 9.99984C20.6667 9.77882 20.5789 9.56686 20.4226 9.41058C20.2663 9.2543 20.0543 9.1665 19.8333 9.1665Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M8.16699 10C9.1559 10 10.1226 9.70676 10.9448 9.15735C11.7671 8.60794 12.408 7.82705 12.7864 6.91342C13.1648 5.99979 13.2638 4.99446 13.0709 4.02455C12.878 3.05465 12.4018 2.16373 11.7025 1.46447C11.0033 0.765206 10.1123 0.289002 9.14244 0.0960758C8.17254 -0.0968503 7.16721 0.00216643 6.25358 0.380605C5.33994 0.759043 4.55905 1.39991 4.00964 2.22215C3.46024 3.0444 3.16699 4.0111 3.16699 5C3.16832 6.32568 3.69553 7.59668 4.63292 8.53407C5.57032 9.47147 6.84132 9.99868 8.16699 10ZM8.16699 1.66667C8.82626 1.66667 9.47073 1.86217 10.0189 2.22844C10.5671 2.59471 10.9943 3.1153 11.2466 3.72439C11.4989 4.33348 11.5649 5.0037 11.4363 5.6503C11.3077 6.29691 10.9902 6.89085 10.524 7.35703C10.0578 7.8232 9.4639 8.14067 8.81729 8.26929C8.17069 8.3979 7.50047 8.33189 6.89138 8.0796C6.28229 7.82731 5.7617 7.40007 5.39543 6.8519C5.02916 6.30374 4.83366 5.65927 4.83366 5C4.83366 4.11595 5.18485 3.2681 5.80997 2.64298C6.43509 2.01786 7.28294 1.66667 8.16699 1.66667Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M8.16699 11.6665C6.17855 11.6687 4.27217 12.4596 2.86613 13.8656C1.46008 15.2717 0.669198 17.1781 0.666992 19.1665C0.666992 19.3875 0.75479 19.5995 0.91107 19.7558C1.06735 19.912 1.27931 19.9998 1.50033 19.9998C1.72134 19.9998 1.9333 19.912 2.08958 19.7558C2.24586 19.5995 2.33366 19.3875 2.33366 19.1665C2.33366 17.6194 2.94824 16.1357 4.0422 15.0417C5.13616 13.9478 6.6199 13.3332 8.16699 13.3332C9.71409 13.3332 11.1978 13.9478 12.2918 15.0417C13.3857 16.1357 14.0003 17.6194 14.0003 19.1665C14.0003 19.3875 14.0881 19.5995 14.2444 19.7558C14.4007 19.912 14.6126 19.9998 14.8337 19.9998C15.0547 19.9998 15.2666 19.912 15.4229 19.7558C15.5792 19.5995 15.667 19.3875 15.667 19.1665C15.6648 17.1781 14.8739 15.2717 13.4679 13.8656C12.0618 12.4596 10.1554 11.6687 8.16699 11.6665Z",
          fill: "currentColor"
        }
      )
    ] })
  }
), vx = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsx("g", { clipPath: "url(#clip0_842_3895)", children: /* @__PURE__ */ d.jsx(
      "path",
      {
        d: "M10 13.3333C9.34073 13.3333 8.69626 13.1378 8.1481 12.7716C7.59994 12.4053 7.17269 11.8847 6.9204 11.2756C6.66811 10.6665 6.6021 9.9963 6.73072 9.3497C6.85933 8.7031 7.1768 8.10915 7.64298 7.64298C8.10915 7.1768 8.7031 6.85933 9.3497 6.73072C9.9963 6.6021 10.6665 6.66811 11.2756 6.9204C11.8847 7.1727 12.4053 7.59994 12.7716 8.1481C13.1378 8.69627 13.3333 9.34073 13.3333 10C13.3333 10.8841 12.9821 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333ZM10 8.33333C9.67036 8.33333 9.34813 8.43108 9.07405 8.61422C8.79997 8.79735 8.58635 9.05765 8.4602 9.3622C8.33405 9.66674 8.30105 10.0019 8.36536 10.3252C8.42967 10.6485 8.5884 10.9454 8.82149 11.1785C9.05458 11.4116 9.35155 11.5703 9.67485 11.6346C9.99815 11.699 10.3333 11.6659 10.6378 11.5398C10.9423 11.4137 11.2026 11.2 11.3858 10.926C11.5689 10.6519 11.6667 10.3296 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.8659 8.50893 10.442 8.33333 10 8.33333ZM15 19.1667C15 17.8406 14.4732 16.5688 13.5355 15.6311C12.5979 14.6935 11.3261 14.1667 10 14.1667C8.67392 14.1667 7.40215 14.6935 6.46447 15.6311C5.52678 16.5688 5 17.8406 5 19.1667C5 19.3877 5.0878 19.5996 5.24408 19.7559C5.40036 19.9122 5.61232 20 5.83333 20C6.05435 20 6.26631 19.9122 6.42259 19.7559C6.57887 19.5996 6.66667 19.3877 6.66667 19.1667C6.66667 18.2826 7.01786 17.4348 7.64298 16.8096C8.2681 16.1845 9.11594 15.8333 10 15.8333C10.8841 15.8333 11.7319 16.1845 12.357 16.8096C12.9821 17.4348 13.3333 18.2826 13.3333 19.1667C13.3333 19.3877 13.4211 19.5996 13.5774 19.7559C13.7337 19.9122 13.9457 20 14.1667 20C14.3877 20 14.5996 19.9122 14.7559 19.7559C14.9122 19.5996 15 19.3877 15 19.1667ZM15 6.66667C14.3407 6.66667 13.6963 6.47117 13.1481 6.1049C12.5999 5.73863 12.1727 5.21803 11.9204 4.60895C11.6681 3.99986 11.6021 3.32964 11.7307 2.68303C11.8593 2.03643 12.1768 1.44249 12.643 0.976312C13.1092 0.510137 13.7031 0.192668 14.3497 0.0640506C14.9963 -0.0645668 15.6665 0.00144427 16.2756 0.253736C16.8847 0.506029 17.4053 0.93327 17.7716 1.48143C18.1378 2.0296 18.3333 2.67406 18.3333 3.33334C18.3333 4.21739 17.9821 5.06524 17.357 5.69036C16.7319 6.31548 15.8841 6.66667 15 6.66667ZM15 1.66667C14.6704 1.66667 14.3481 1.76442 14.074 1.94755C13.8 2.13069 13.5863 2.39099 13.4602 2.69553C13.3341 3.00007 13.301 3.33518 13.3654 3.65849C13.4297 3.98179 13.5884 4.27876 13.8215 4.51185C14.0546 4.74493 14.3515 4.90367 14.6748 4.96798C14.9982 5.03229 15.3333 4.99928 15.6378 4.87313C15.9423 4.74699 16.2026 4.53337 16.3858 4.25929C16.5689 3.9852 16.6667 3.66297 16.6667 3.33334C16.6667 2.89131 16.4911 2.46738 16.1785 2.15482C15.8659 1.84226 15.442 1.66667 15 1.66667ZM20 12.5C19.9987 11.1743 19.4715 9.90333 18.5341 8.96593C17.5967 8.02853 16.3257 7.50133 15 7.5C14.779 7.5 14.567 7.5878 14.4107 7.74408C14.2545 7.90036 14.1667 8.11232 14.1667 8.33333C14.1667 8.55435 14.2545 8.76631 14.4107 8.92259C14.567 9.07887 14.779 9.16667 15 9.16667C15.8841 9.16667 16.7319 9.51786 17.357 10.143C17.9821 10.7681 18.3333 11.6159 18.3333 12.5C18.3333 12.721 18.4211 12.933 18.5774 13.0893C18.7337 13.2455 18.9457 13.3333 19.1667 13.3333C19.3877 13.3333 19.5996 13.2455 19.7559 13.0893C19.9122 12.933 20 12.721 20 12.5ZM5 6.66667C4.34073 6.66667 3.69626 6.47117 3.1481 6.1049C2.59994 5.73863 2.17269 5.21803 1.9204 4.60895C1.66811 3.99986 1.6021 3.32964 1.73072 2.68303C1.85933 2.03643 2.1768 1.44249 2.64298 0.976312C3.10915 0.510137 3.7031 0.192668 4.3497 0.0640506C4.9963 -0.0645668 5.66652 0.00144427 6.27561 0.253736C6.8847 0.506029 7.40529 0.93327 7.77156 1.48143C8.13784 2.0296 8.33333 2.67406 8.33333 3.33334C8.33333 4.21739 7.98214 5.06524 7.35702 5.69036C6.7319 6.31548 5.88405 6.66667 5 6.66667ZM5 1.66667C4.67036 1.66667 4.34813 1.76442 4.07405 1.94755C3.79997 2.13069 3.58635 2.39099 3.4602 2.69553C3.33405 3.00007 3.30105 3.33518 3.36536 3.65849C3.42967 3.98179 3.5884 4.27876 3.82149 4.51185C4.05458 4.74493 4.35155 4.90367 4.67485 4.96798C4.99815 5.03229 5.33326 4.99928 5.63781 4.87313C5.94235 4.74699 6.20265 4.53337 6.38578 4.25929C6.56892 3.9852 6.66667 3.66297 6.66667 3.33334C6.66667 2.89131 6.49107 2.46738 6.17851 2.15482C5.86595 1.84226 5.44203 1.66667 5 1.66667ZM1.66667 12.5C1.66667 11.6159 2.01786 10.7681 2.64298 10.143C3.2681 9.51786 4.11594 9.16667 5 9.16667C5.22101 9.16667 5.43297 9.07887 5.58926 8.92259C5.74554 8.76631 5.83333 8.55435 5.83333 8.33333C5.83333 8.11232 5.74554 7.90036 5.58926 7.74408C5.43297 7.5878 5.22101 7.5 5 7.5C3.67432 7.50133 2.40332 8.02853 1.46593 8.96593C0.528533 9.90333 0.00132369 11.1743 0 12.5C0 12.721 0.0877974 12.933 0.244078 13.0893C0.400358 13.2455 0.61232 13.3333 0.833333 13.3333C1.05435 13.3333 1.26631 13.2455 1.42259 13.0893C1.57887 12.933 1.66667 12.721 1.66667 12.5Z",
        fill: "currentColor"
      }
    ) })
  }
), mx = () => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M19.3925 6.34919C18.1 4.24419 15.16 0.712524 10 0.712524C4.84 0.712524 1.9 4.24419 0.607497 6.34919C0.207937 6.99545 -0.00370789 7.74023 -0.00370789 8.50002C-0.00370789 9.25982 0.207937 10.0046 0.607497 10.6509C1.9 12.7559 4.84 16.2875 10 16.2875C15.16 16.2875 18.1 12.7559 19.3925 10.6509C19.7921 10.0046 20.0037 9.25982 20.0037 8.50002C20.0037 7.74023 19.7921 6.99545 19.3925 6.34919ZM17.9717 9.77836C16.8617 11.5834 14.3492 14.6209 10 14.6209C5.65083 14.6209 3.13833 11.5834 2.02833 9.77836C1.79094 9.39423 1.66521 8.95159 1.66521 8.50002C1.66521 8.04846 1.79094 7.60582 2.02833 7.22169C3.13833 5.41669 5.65083 2.37919 10 2.37919C14.3492 2.37919 16.8617 5.41336 17.9717 7.22169C18.2091 7.60582 18.3348 8.04846 18.3348 8.50002C18.3348 8.95159 18.2091 9.39423 17.9717 9.77836Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M10 4.33331C9.17591 4.33331 8.37033 4.57768 7.68512 5.03552C6.99992 5.49336 6.46586 6.14411 6.1505 6.90547C5.83513 7.66682 5.75262 8.5046 5.91339 9.31286C6.07416 10.1211 6.471 10.8635 7.05372 11.4463C7.63644 12.029 8.37887 12.4258 9.18712 12.5866C9.99537 12.7474 10.8332 12.6648 11.5945 12.3495C12.3559 12.0341 13.0066 11.5001 13.4645 10.8149C13.9223 10.1297 14.1667 9.32407 14.1667 8.49998C14.1653 7.39532 13.7259 6.33628 12.9448 5.55516C12.1637 4.77405 11.1047 4.33464 10 4.33331ZM10 11C9.50554 11 9.02219 10.8534 8.61107 10.5787C8.19995 10.304 7.87952 9.9135 7.6903 9.45669C7.50108 8.99987 7.45157 8.49721 7.54803 8.01225C7.6445 7.5273 7.8826 7.08184 8.23223 6.73221C8.58186 6.38258 9.02732 6.14448 9.51227 6.04802C9.99722 5.95155 10.4999 6.00106 10.9567 6.19028C11.4135 6.3795 11.804 6.69993 12.0787 7.11105C12.3534 7.52218 12.5 8.00553 12.5 8.49998C12.5 9.16302 12.2366 9.79891 11.7678 10.2677C11.2989 10.7366 10.663 11 10 11Z",
          fill: "currentColor"
        }
      )
    ]
  }
), gx = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        d: "M11.0833 1.16669H5.83333C4.22333 1.16669 2.91667 2.47335 2.91667 4.08335V7.58335C2.91667 9.19335 4.22333 10.5 5.83333 10.5H11.0833C12.6933 10.5 14 9.19335 14 7.58335V4.08335C14 2.47335 12.6933 1.16669 11.0833 1.16669ZM5.83333 2.33335H11.0833C11.8417 2.33335 12.4833 2.82335 12.7283 3.50002H4.18833C4.4275 2.82335 5.06917 2.33335 5.83333 2.33335ZM11.0833 9.33335H5.83333C4.87083 9.33335 4.08333 8.54585 4.08333 7.58335V4.66669H12.8333V7.58335C12.8333 8.54585 12.0458 9.33335 11.0833 9.33335ZM9.91667 12.25C9.91667 12.5709 9.65417 12.8334 9.33333 12.8334H2.91667C1.30667 12.8334 0 11.5267 0 9.91669V5.62919C0 4.91752 0.256667 4.23502 0.729167 3.69835C0.945 3.45919 1.3125 3.43585 1.55167 3.64585C1.79667 3.86169 1.81417 4.22919 1.60417 4.46835C1.32417 4.78919 1.16667 5.19752 1.16667 5.62335V9.91085C1.16667 10.8734 1.95417 11.6609 2.91667 11.6609H9.33333C9.65417 11.6609 9.91667 11.9234 9.91667 12.2442V12.25Z",
        fill: "currentColor"
      }
    )
  }
), yx = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        d: "M19.275 10.741L14.7667 6.08268C14.45 5.74935 13.9167 5.74102 13.5917 6.06602C13.2583 6.38268 13.25 6.91602 13.575 7.24102L17.8583 11.6577H4.16667C2.79167 11.6577 1.66667 10.5327 1.66667 9.15768V2.49935C1.66667 2.04102 1.29167 1.66602 0.833333 1.66602C0.375 1.66602 0 2.04102 0 2.49935V9.16602C0 11.466 1.86667 13.3327 4.16667 13.3327H17.85L13.5667 17.7493C13.25 18.0827 13.2583 18.6077 13.5833 18.9243C13.7417 19.0827 13.95 19.1577 14.1667 19.1577C14.3833 19.1577 14.6 19.0744 14.7667 18.9077L19.2667 14.2577C20.2417 13.2827 20.2417 11.6993 19.275 10.7327V10.741Z",
        fill: "currentColor"
      }
    )
  }
), bx = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        d: "M16.6667 38.3333C16.6667 39.255 15.9217 40 15 40H8.33333C3.73833 40 0 36.2617 0 31.6667V8.33333C0 3.73833 3.73833 0 8.33333 0H21.6667C26.2617 0 30 3.73833 30 8.33333V11.6667C30 12.5883 29.255 13.3333 28.3333 13.3333C27.4117 13.3333 26.6667 12.5883 26.6667 11.6667V8.33333C26.6667 5.57667 24.4233 3.33333 21.6667 3.33333H8.33333C5.57667 3.33333 3.33333 5.57667 3.33333 8.33333V31.6667C3.33333 34.4233 5.57667 36.6667 8.33333 36.6667H15C15.9217 36.6667 16.6667 37.4117 16.6667 38.3333ZM23.3333 10C23.3333 9.07833 22.5883 8.33333 21.6667 8.33333H8.33333C7.41167 8.33333 6.66667 9.07833 6.66667 10C6.66667 10.9217 7.41167 11.6667 8.33333 11.6667H21.6667C22.5883 11.6667 23.3333 10.9217 23.3333 10ZM16.6667 18.3333C16.6667 17.4117 15.9217 16.6667 15 16.6667H8.33333C7.41167 16.6667 6.66667 17.4117 6.66667 18.3333C6.66667 19.255 7.41167 20 8.33333 20H15C15.9217 20 16.6667 19.255 16.6667 18.3333ZM8.33333 25C7.41167 25 6.66667 25.745 6.66667 26.6667C6.66667 27.5883 7.41167 28.3333 8.33333 28.3333H11.6667C12.5883 28.3333 13.3333 27.5883 13.3333 26.6667C13.3333 25.745 12.5883 25 11.6667 25H8.33333ZM40 28.3333C40 34.765 34.765 40 28.3333 40C21.9017 40 16.6667 34.765 16.6667 28.3333C16.6667 21.9017 21.9017 16.6667 28.3333 16.6667C34.765 16.6667 40 21.9017 40 28.3333ZM36.6667 28.3333C36.6667 23.7383 32.9283 20 28.3333 20C23.7383 20 20 23.7383 20 28.3333C20 32.9283 23.7383 36.6667 28.3333 36.6667C32.9283 36.6667 36.6667 32.9283 36.6667 28.3333ZM31.3467 26.265L27.6417 29.8217C27.4017 30.0567 27.01 30.0617 26.7717 29.825L24.8867 27.9783C24.2267 27.3317 23.1733 27.3417 22.53 28.0017C21.885 28.66 21.895 29.7133 22.5533 30.3583L24.44 32.2067C25.2067 32.955 26.21 33.33 27.2117 33.33C28.2133 33.33 29.2133 32.955 29.9667 32.2117L33.655 28.6717C34.3183 28.0333 34.34 26.9783 33.7033 26.315C33.065 25.6483 32.0083 25.63 31.3467 26.2667V26.265Z",
        fill: "currentColor"
      }
    )
  }
), Cx = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        d: "M20 0C16.0444 0 12.1776 1.17298 8.8886 3.3706C5.59962 5.56824 3.03618 8.6918 1.52242 12.3463C0.00866604 16.0009 -0.387402 20.0222 0.384304 23.9018C1.15601 27.7814 3.06082 31.345 5.85788 34.1422C8.65492 36.9392 12.2186 38.844 16.0982 39.6158C19.9778 40.3874 23.9992 39.9914 27.6536 38.4776C31.3082 36.9638 34.4318 34.4004 36.6294 31.1114C38.827 27.8224 40 23.9556 40 20C39.9942 14.6974 37.8852 9.61368 34.1358 5.8642C30.3864 2.11472 25.3026 0.00573514 20 0ZM20 3.33334C23.8442 3.33026 27.5698 4.66292 30.54 7.10334L7.10334 30.54C5.10428 28.0998 3.83944 25.1418 3.45604 22.0108C3.07264 18.8796 3.58644 15.7039 4.93766 12.8534C6.28886 10.0029 8.4219 7.5948 11.0885 5.9094C13.755 4.22402 16.8455 3.33066 20 3.33334ZM20 36.6666C16.1559 36.6698 12.4301 35.337 9.46 32.8966L32.8966 9.46C34.8958 11.9003 36.1606 14.8581 36.544 17.9893C36.9274 21.1204 36.4136 24.2962 35.0624 27.1466C33.7112 29.9972 31.5782 32.4052 28.9116 34.0906C26.245 35.776 23.1546 36.6694 20 36.6666Z",
        fill: "currentColor"
      }
    )
  }
), xx = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsxs("g", { "clip-path": "url(#clip0_16_25)", children: [
      /* @__PURE__ */ d.jsx("path", { d: "M20 0C16.0444 0 12.1776 1.17298 8.8886 3.37061C5.59962 5.56824 3.03617 8.69181 1.52242 12.3463C0.00866572 16.0009 -0.387401 20.0222 0.384303 23.9018C1.15601 27.7814 3.06082 31.3451 5.85787 34.1421C8.65492 36.9392 12.2186 38.844 16.0982 39.6157C19.9778 40.3874 23.9992 39.9913 27.6537 38.4776C31.3082 36.9638 34.4318 34.4004 36.6294 31.1114C38.827 27.8224 40 23.9556 40 20C39.9943 14.6974 37.8853 9.61368 34.1358 5.8642C30.3863 2.11471 25.3026 0.00573514 20 0ZM20 36.6667C16.7037 36.6667 13.4813 35.6892 10.7405 33.8578C7.99969 32.0265 5.86348 29.4235 4.60202 26.3781C3.34056 23.3326 3.0105 19.9815 3.65359 16.7485C4.29667 13.5155 5.88402 10.5458 8.2149 8.21489C10.5458 5.88401 13.5155 4.29667 16.7485 3.65358C19.9815 3.01049 23.3326 3.34055 26.3781 4.60201C29.4235 5.86347 32.0265 7.99968 33.8578 10.7405C35.6892 13.4813 36.6667 16.7036 36.6667 20C36.6618 24.4188 34.9043 28.6552 31.7798 31.7798C28.6552 34.9043 24.4188 36.6618 20 36.6667Z", fill: "currentColor" }),
      /* @__PURE__ */ d.jsx("path", { d: "M20 8.33331C19.558 8.33331 19.134 8.50891 18.8215 8.82147C18.5089 9.13403 18.3333 9.55795 18.3333 9.99998V23.3333C18.3333 23.7753 18.5089 24.1993 18.8215 24.5118C19.134 24.8244 19.558 25 20 25C20.442 25 20.8659 24.8244 21.1785 24.5118C21.4911 24.1993 21.6666 23.7753 21.6666 23.3333V9.99998C21.6666 9.55795 21.4911 9.13403 21.1785 8.82147C20.8659 8.50891 20.442 8.33331 20 8.33331Z", fill: "currentColor" }),
      /* @__PURE__ */ d.jsx("path", { d: "M21.6666 30C21.6666 29.0795 20.9205 28.3333 20 28.3333C19.0795 28.3333 18.3333 29.0795 18.3333 30C18.3333 30.9205 19.0795 31.6666 20 31.6666C20.9205 31.6666 21.6666 30.9205 21.6666 30Z", fill: "currentColor" })
    ] })
  }
), wx = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsx("path", { d: "M18.3295 20.0111V10.0055C18.3295 9.08836 19.0799 8.33794 19.9971 8.33794C20.9142 8.33794 21.6647 9.08836 21.6647 10.0055V20.0111C21.6647 20.9282 20.9142 21.6787 19.9971 21.6787C19.0799 21.6787 18.3295 20.9282 18.3295 20.0111ZM19.9971 23.3462C18.613 23.3462 17.4957 24.4635 17.4957 25.8476C17.4957 27.2317 18.613 28.349 19.9971 28.349C21.3812 28.349 22.4984 27.2317 22.4984 25.8476C22.4984 24.4635 21.3812 23.3462 19.9971 23.3462ZM39.3077 31.4841C38.1404 33.7353 35.6891 35.0194 32.6207 35.0194H7.39009C4.30505 35.0194 1.87037 33.7353 0.703061 31.4841C-0.480927 29.2162 -0.147409 26.3145 1.53686 23.8799L14.9443 2.66814C16.1283 0.967201 17.996 0 19.9971 0C21.9982 0 23.8659 0.967201 24.9998 2.61811L38.4739 23.9132C40.1582 26.3479 40.4751 29.2328 39.2911 31.4841H39.3077ZM35.7224 25.7809C35.7224 25.7809 35.6891 25.7476 35.6891 25.7142L22.2316 4.45246C21.748 3.76875 20.9142 3.33518 19.9971 3.33518C19.0799 3.33518 18.2461 3.76875 17.7291 4.51917L4.30505 25.7142C3.27115 27.1817 3.03769 28.7826 3.63802 29.9332C4.22167 31.0672 5.55574 31.6842 7.37342 31.6842H32.5874C34.405 31.6842 35.7391 31.0672 36.3228 29.9332C36.9231 28.7826 36.6896 27.1817 35.7057 25.7809H35.7224Z", fill: "currentColor" })
  }
), Ox = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsxs("g", { "clip-path": "url(#clip0_16_33)", children: [
      /* @__PURE__ */ d.jsx("path", { d: "M20 16.6667C18.6814 16.6667 17.3925 17.0577 16.2962 17.7902C15.1999 18.5228 14.3454 19.564 13.8408 20.7821C13.3362 22.0003 13.2042 23.3407 13.4614 24.634C13.7186 25.9272 14.3536 27.115 15.2859 28.0474C16.2183 28.9797 17.4062 29.6147 18.6994 29.8719C19.9926 30.1292 21.333 29.9971 22.5512 29.4926C23.7694 28.988 24.8106 28.1335 25.5431 27.0372C26.2757 25.9408 26.6666 24.6519 26.6666 23.3334C26.6666 21.5652 25.9643 19.8696 24.714 18.6193C23.4638 17.3691 21.7681 16.6667 20 16.6667ZM20 26.6667C19.3407 26.6667 18.6962 26.4712 18.1481 26.1049C17.5999 25.7386 17.1727 25.2181 16.9204 24.609C16.6681 23.9999 16.6021 23.3297 16.7307 22.6831C16.8593 22.0364 17.1768 21.4425 17.643 20.9763C18.1091 20.5102 18.7031 20.1927 19.3497 20.0641C19.9963 19.9355 20.6665 20.0015 21.2756 20.2538C21.8847 20.506 22.4053 20.9333 22.7715 21.4815C23.1378 22.0296 23.3333 22.6741 23.3333 23.3334C23.3333 24.2174 22.9821 25.0653 22.357 25.6904C21.7319 26.3155 20.884 26.6667 20 26.6667Z", fill: "currentColor" }),
      /* @__PURE__ */ d.jsx("path", { d: "M37.56 6.87003L33.13 2.44003C32.3581 1.66394 31.4399 1.04867 30.4286 0.629836C29.4173 0.211008 28.3329 -0.0030576 27.2383 3.29938e-05H8.33333C6.12401 0.00267942 4.00593 0.881503 2.4437 2.44373C0.88147 4.00596 0.00264643 6.12404 0 8.33337L0 31.6667C0.00264643 33.876 0.88147 35.9941 2.4437 37.5563C4.00593 39.1186 6.12401 39.9974 8.33333 40H31.6667C33.876 39.9974 35.9941 39.1186 37.5563 37.5563C39.1185 35.9941 39.9974 33.876 40 31.6667V12.7617C40.0031 11.6671 39.789 10.5828 39.3702 9.57144C38.9514 8.56013 38.3361 7.64194 37.56 6.87003ZM28.3333 3.4667V5.00003C28.3333 6.32612 27.8066 7.59789 26.8689 8.53557C25.9312 9.47325 24.6594 10 23.3333 10H16.6667C15.3406 10 14.0688 9.47325 13.1311 8.53557C12.1935 7.59789 11.6667 6.32612 11.6667 5.00003V3.33337H27.2383C27.6072 3.33664 27.9745 3.38136 28.3333 3.4667ZM36.6667 31.6667C36.6667 32.9928 36.1399 34.2646 35.2022 35.2022C34.2645 36.1399 32.9928 36.6667 31.6667 36.6667H8.33333C7.00725 36.6667 5.73548 36.1399 4.7978 35.2022C3.86012 34.2646 3.33333 32.9928 3.33333 31.6667V8.33337C3.33333 7.00728 3.86012 5.73551 4.7978 4.79783C5.73548 3.86015 7.00725 3.33337 8.33333 3.33337V5.00003C8.33598 7.20936 9.2148 9.32744 10.777 10.8897C12.3393 12.4519 14.4573 13.3307 16.6667 13.3334H23.3333C25.4292 13.3269 27.4453 12.5295 28.9785 11.1006C30.5118 9.67181 31.4492 7.71685 31.6033 5.6267L35.2033 9.2267C36.1374 10.1665 36.6632 11.4367 36.6667 12.7617V31.6667Z", fill: "currentColor" })
    ] })
  }
), Sx = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsxs("g", { "clip-path": "url(#clip0_16_33)", children: [
      /* @__PURE__ */ d.jsx("path", { d: "M31.6667 3.33333H30V1.66667C30 1.22464 29.8244 0.800716 29.5118 0.488155C29.1993 0.175595 28.7754 0 28.3333 0C27.8913 0 27.4674 0.175595 27.1548 0.488155C26.8423 0.800716 26.6667 1.22464 26.6667 1.66667V3.33333H13.3333V1.66667C13.3333 1.22464 13.1577 0.800716 12.8452 0.488155C12.5326 0.175595 12.1087 0 11.6667 0C11.2246 0 10.8007 0.175595 10.4882 0.488155C10.1756 0.800716 10 1.22464 10 1.66667V3.33333H8.33333C6.12401 3.33598 4.00593 4.2148 2.4437 5.77703C0.88147 7.33926 0.00264643 9.45734 0 11.6667V31.6667C0.00264643 33.876 0.88147 35.9941 2.4437 37.5563C4.00593 39.1185 6.12401 39.9974 8.33333 40H31.6667C33.876 39.9974 35.9941 39.1185 37.5563 37.5563C39.1185 35.9941 39.9974 33.876 40 31.6667V11.6667C39.9974 9.45734 39.1185 7.33926 37.5563 5.77703C35.9941 4.2148 33.876 3.33598 31.6667 3.33333ZM3.33333 11.6667C3.33333 10.3406 3.86012 9.06881 4.7978 8.13113C5.73548 7.19345 7.00725 6.66667 8.33333 6.66667H31.6667C32.9927 6.66667 34.2645 7.19345 35.2022 8.13113C36.1399 9.06881 36.6667 10.3406 36.6667 11.6667V13.3333H3.33333V11.6667ZM31.6667 36.6667H8.33333C7.00725 36.6667 5.73548 36.1399 4.7978 35.2022C3.86012 34.2645 3.33333 32.9927 3.33333 31.6667V16.6667H36.6667V31.6667C36.6667 32.9927 36.1399 34.2645 35.2022 35.2022C34.2645 36.1399 32.9927 36.6667 31.6667 36.6667Z", fill: "currentColor" }),
      /* @__PURE__ */ d.jsx("path", { d: "M20 27.5C21.3807 27.5 22.5 26.3807 22.5 25C22.5 23.6193 21.3807 22.5 20 22.5C18.6193 22.5 17.5 23.6193 17.5 25C17.5 26.3807 18.6193 27.5 20 27.5Z", fill: "currentColor" }),
      /* @__PURE__ */ d.jsx("path", { d: "M11.6667 27.5C13.0474 27.5 14.1667 26.3807 14.1667 25C14.1667 23.6193 13.0474 22.5 11.6667 22.5C10.286 22.5 9.16667 23.6193 9.16667 25C9.16667 26.3807 10.286 27.5 11.6667 27.5Z", fill: "currentColor" }),
      /* @__PURE__ */ d.jsx("path", { d: "M28.3333 27.5C29.714 27.5 30.8333 26.3807 30.8333 25C30.8333 23.6193 29.714 22.5 28.3333 22.5C26.9526 22.5 25.8333 23.6193 25.8333 25C25.8333 26.3807 26.9526 27.5 28.3333 27.5Z", fill: "currentColor" })
    ] })
  }
), Px = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsx("path", { d: "M36.201 13.7825L38.1094 8.62045C38.1094 8.62045 38.1125 8.61375 38.1135 8.60974C38.1156 8.60439 38.1177 8.59903 38.1187 8.59368L39.274 5.4673C39.8333 3.95095 39.2531 2.08128 37.9771 1.29968L36.4062 0.341422C35.7646 -0.0520521 35.026 -0.108263 34.3802 0.187512C33.7938 0.455182 33.3302 0.983829 33.074 1.67709L30.4063 8.89615C28.9156 8.22831 27.3573 7.88971 25.7646 7.88971H14.2333C10.4458 7.88971 6.875 9.79953 4.18021 13.2659C1.48438 16.7335 0 21.324 0 26.1943V26.9545C0 32.1995 1.75833 37.1781 4.83229 40.6685L4.52708 47.8822C4.50417 48.443 4.68958 48.7401 4.85 48.8913C4.95417 48.989 5.10833 49.0827 5.31875 49.0827C5.43854 49.0827 5.57708 49.0533 5.73438 48.977C5.75625 48.9663 5.77708 48.9543 5.79792 48.9409L11.2854 45.3139C11.3146 45.2952 11.3469 45.2738 11.3687 45.2591C11.3896 45.2591 11.4177 45.2591 11.4427 45.2591H17.5281C17.8521 45.2591 18.1135 44.9218 18.1135 44.5069C18.1135 44.092 17.851 43.7548 17.5281 43.7548H11.4469C11.1312 43.7508 11.0427 43.7815 10.75 43.9756L5.725 47.2974L6.01146 40.5133C6.06354 40.1158 5.9 39.8669 5.79479 39.7504C2.85625 36.5357 1.17083 31.8716 1.17083 26.9545V26.1943C1.17083 16.9316 7.03021 9.39535 14.2333 9.39535H25.7646C27.1823 9.39535 28.5708 9.68711 29.901 10.2653L27.924 15.6133C27.7854 15.9894 27.9094 16.4377 28.2021 16.6171C28.4948 16.7951 28.8438 16.6358 28.9833 16.2597L32.7219 6.14584L36.8062 8.6432L29.7073 27.8485L25.6229 25.3511L27.8385 19.358C27.9771 18.9819 27.8531 18.5336 27.5604 18.3543C27.2677 18.1763 26.9188 18.3355 26.7792 18.7116L24.3125 25.3846C24.2812 25.4703 24.2625 25.5639 24.2573 25.659L23.8406 33.9286H8.98542C8.66146 33.9286 8.4 34.2659 8.4 34.6808C8.4 35.0957 8.66146 35.4329 8.98542 35.4329H24C24.0771 35.5574 24.1729 35.6578 24.2885 35.7287C24.401 35.7969 24.5208 35.8317 24.6406 35.8317C24.8396 35.8317 25.0406 35.7394 25.2187 35.5614C25.2312 35.5494 25.2437 35.5346 25.2563 35.5212L30.3833 29.4037C30.4375 29.3394 30.4813 29.2605 30.5135 29.1748L35.6573 15.2587C37.7073 18.3154 38.8281 22.1578 38.8281 26.1943V26.9545C38.8281 36.2172 32.9688 43.7534 25.7656 43.7534H20.1292C19.8052 43.7534 19.5437 44.0907 19.5437 44.5056C19.5437 44.9205 19.8062 45.2577 20.1292 45.2577H25.7656C29.5521 45.2577 33.1219 43.3479 35.8188 39.8816C38.5156 36.4139 40 31.8234 40 26.9531V26.193C40 21.573 38.6542 17.1859 36.2031 13.7811L36.201 13.7825ZM33.2229 4.78474L34.1323 2.32352C34.2542 1.99428 34.4813 1.74 34.7719 1.60616C35.1271 1.44422 35.5385 1.47768 35.9021 1.69985L37.474 2.65944C38.1667 3.0837 38.499 4.054 38.2156 4.82087L37.3063 7.28076L33.2219 4.7834L33.2229 4.78474ZM25.0229 33.7412L25.1437 31.3523L26.3875 32.1125L25.0229 33.7412ZM27.3115 31.0097L25.225 29.7329L25.3698 26.8621L28.9521 29.053L27.3125 31.0097H27.3115Z", fill: "currentColor" })
  }
), Ex = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsx("path", { d: "M5.57407 17.7786C5.57407 17.4105 5.81724 17.113 6.11806 17.113H22.4116C22.7114 17.113 22.9556 17.4118 22.9556 17.7786C22.9556 18.1454 22.7124 18.4442 22.4116 18.4442H6.11806C5.81724 18.4442 5.57407 18.1466 5.57407 17.7786ZM14.4708 22.725H6.11806C5.81724 22.725 5.57407 23.0225 5.57407 23.3906C5.57407 23.7586 5.81724 24.0562 6.11806 24.0562H14.4708C14.7716 24.0562 15.0148 23.7586 15.0148 23.3906C15.0148 23.0225 14.7716 22.725 14.4708 22.725ZM14.4708 28.337H6.11806C5.81724 28.337 5.57407 28.6345 5.57407 29.0026C5.57407 29.3706 5.81724 29.6682 6.11806 29.6682H14.4708C14.7716 29.6682 15.0148 29.3706 15.0148 29.0026C15.0148 28.6345 14.7716 28.337 14.4708 28.337ZM14.4708 33.949H6.11806C5.81724 33.949 5.57407 34.2465 5.57407 34.6146C5.57407 34.9826 5.81724 35.2802 6.11806 35.2802H14.4708C14.7716 35.2802 15.0148 34.9826 15.0148 34.6146C15.0148 34.2465 14.7716 33.949 14.4708 33.949ZM39.879 33.477C39.7333 33.8682 39.4723 34.1644 39.1443 34.3132L37.4494 35.0839C37.3006 35.1506 37.1475 35.1852 36.9935 35.1852C36.8069 35.1852 36.6214 35.1365 36.4463 35.0378C36.3227 34.9685 36.2147 34.8723 36.1172 34.7646C36.0753 35.234 35.9306 35.6841 35.678 36.0227C35.3311 36.4869 34.8636 36.669 34.3647 36.5498C34.3521 36.8563 34.2861 37.1654 34.1593 37.4539C33.7872 38.3042 33.0126 38.7235 32.2757 38.5491C32.2621 38.8543 32.1929 39.1531 32.0724 39.4289C32.0032 39.5892 31.9131 39.729 31.8156 39.8598V41.7604C31.8156 44.1021 30.2905 46.013 28.3913 46.0912C27.9689 47.9097 26.6031 49.246 24.9837 49.246H3.5459C1.59109 49.246 0 47.3005 0 44.9088V7.48565C0 5.1439 1.52611 3.23305 3.42536 3.15482C3.85405 1.3222 5.24181 0 6.8329 0H28.2718C30.2266 0 31.8166 1.94676 31.8166 4.33724V25.0475C31.89 25.0834 31.9602 25.1206 32.0305 25.1565C32.5713 25.4335 32.912 25.5848 33.1813 25.5707C33.1216 25.2347 33.1478 24.8859 33.2673 24.5666C33.414 24.1767 33.674 23.8792 34.002 23.7304L35.698 22.9597C36.026 22.8109 36.3824 22.8276 36.701 23.0058C37.0197 23.1841 37.2628 23.5047 37.3844 23.9048L39.9178 32.2497C40.0394 32.6511 40.0258 33.0872 39.879 33.477ZM31.6102 26.3825C30.5861 25.858 29.5264 25.3155 28.0538 26.5595C27.7414 26.8237 27.4207 27.1571 27.0989 27.5534C26.905 27.7919 26.7069 28.0318 26.513 28.2639C26.1189 28.7371 25.6525 29.2988 25.4009 29.681C26.144 30.6287 26.9186 30.3402 28.1397 29.7785C29.1344 29.3206 30.2591 28.8012 31.2548 29.7297C31.5284 29.9208 31.9319 30.1645 32.3585 30.4222C33.5723 31.1545 34.5942 31.8022 35.2525 32.4562L33.5492 26.8442C33.4203 26.8801 33.2903 26.9019 33.1625 26.9019C32.6269 26.9019 32.0986 26.6313 31.6102 26.3812V26.3825ZM4.57833 3.14713H24.9837C26.9385 3.14713 28.5286 5.09388 28.5286 7.48437V24.7564C29.3535 24.3832 30.0851 24.4178 30.7276 24.6012V4.33724C30.7276 2.67903 29.625 1.3299 28.2697 1.3299H6.8329C5.8403 1.3299 4.9609 2.07244 4.57833 3.14585V3.14713ZM17.2044 10.8033L20.1381 8.38336C20.3216 8.23204 20.5626 8.23204 20.7461 8.38336L23.3696 10.5469V4.47831H17.2044V10.8033ZM27.4417 44.9088V43.2801C27.3274 43.3147 27.2132 43.3339 27.0989 43.3339C26.8327 43.3339 26.5717 43.2467 26.339 43.0941C25.9575 42.844 25.6388 42.4106 25.469 41.9053C25.4586 41.9091 25.447 41.9143 25.4355 41.9181C24.9995 42.0797 24.5404 42.0245 24.14 41.7629C23.8434 41.5821 23.5991 41.282 23.4409 40.9063C23.3644 40.9499 23.2857 40.987 23.204 41.0178C22.768 41.1781 22.3078 41.1243 21.9085 40.8627C21.5269 40.6292 21.2345 40.2035 21.0962 39.6713C21.0228 39.3866 20.9987 39.0877 21.0238 38.7966C20.7765 38.7838 20.527 38.7056 20.2943 38.5517C19.9138 38.3196 19.6204 37.8938 19.482 37.3616C19.3405 36.8178 19.3824 36.2253 19.5962 35.7354L19.7922 35.2878C19.679 35.3263 19.5638 35.3507 19.4474 35.3507C19.3122 35.3507 19.1759 35.325 19.0449 35.2725L17.3239 34.594C16.6363 34.3222 16.2568 33.4155 16.478 32.5742L18.7127 24.101C18.8196 23.6945 19.0512 23.3624 19.3636 23.1674C19.6759 22.9712 20.0312 22.9366 20.3635 23.0674L22.0856 23.7471C22.5269 23.9215 22.8392 24.3588 22.9482 24.8705C23.3476 24.8872 23.7459 24.791 24.1892 24.6833C25.1179 24.4576 26.1545 24.2075 27.4438 24.9859V7.48565C27.4438 5.82745 26.3411 4.47831 24.9858 4.47831H24.4586V11.7972C24.4586 12.0435 24.3475 12.2692 24.1704 12.3846C23.9922 12.5 23.7784 12.4859 23.6107 12.3487L20.4442 9.73635L17.2033 12.409C17.1132 12.4834 17.0073 12.5231 16.8994 12.5231H16.6635C16.3627 12.5231 16.1195 12.2256 16.1195 11.8575V4.47703H3.54904C2.19378 4.47703 1.09113 5.82616 1.09113 7.48437V44.9075C1.09113 46.5657 2.19378 47.9136 3.54904 47.9136H24.9869C26.3421 47.9136 27.4448 46.5644 27.4448 44.9075L27.4417 44.9088ZM29.0516 39.8803C29.1344 40.3035 29.0652 40.7229 28.9615 41.0717L29.017 41.1063C29.3556 41.3192 29.5285 40.9986 29.5726 40.8947C29.6218 40.778 29.7371 40.3997 29.365 40.0855L29.0527 39.879L29.0516 39.8803ZM28.5129 42.2874L28.4709 42.2605C28.4668 42.2695 28.4615 42.2785 28.4573 42.2874H28.5129ZM26.7593 40.1842L26.4784 40.8267C26.2992 41.2371 26.5759 41.7398 26.8516 41.9207C26.9553 41.9899 27.2719 42.1951 27.5601 41.5359L27.7645 41.0691C27.7645 41.0691 27.7645 41.0691 27.7645 41.0678C28.1502 40.1855 28.0381 40.0573 27.6282 39.7892C27.4521 39.6738 27.2624 39.7277 27.166 39.77C26.991 39.8457 26.8421 39.997 26.7604 40.1855L26.7593 40.1842ZM25.8631 37.8181C25.5665 37.6232 25.1934 37.7604 25.033 38.1259C25.033 38.1259 25.033 38.1272 25.033 38.1285L24.401 39.5738C24.3245 39.7495 24.3119 39.9662 24.3643 40.1688C24.3926 40.2766 24.4649 40.4741 24.6389 40.5805C24.7961 40.6831 24.9617 40.7023 25.119 40.6434C25.2762 40.5856 25.4061 40.4561 25.4827 40.2817L25.5194 40.1971C25.5194 40.1971 25.5194 40.1958 25.5204 40.1945L25.7971 39.5597C25.7971 39.5597 25.7971 39.5571 25.7971 39.5558L26.1137 38.8325C26.273 38.467 26.1598 38.0118 25.861 37.8156L25.8631 37.8181ZM24.2752 36.5703C24.228 36.3766 24.1222 36.2189 23.9796 36.1253C23.6819 35.9304 23.3088 36.0689 23.1484 36.4331C23.1484 36.4331 23.1484 36.4331 23.1484 36.4344L22.595 37.7014L22.1695 38.6735C22.0929 38.8492 22.0804 39.0659 22.1328 39.2686C22.1611 39.3763 22.2344 39.5751 22.4084 39.6802C22.7208 39.8841 23.0929 39.7444 23.2522 39.3814L23.443 38.9454C23.443 38.9454 23.443 38.9454 23.444 38.9428L24.075 37.5001C24.075 37.5001 24.075 37.5001 24.075 37.4988L24.2312 37.141C24.3087 36.9653 24.3245 36.7627 24.2762 36.569L24.2752 36.5703ZM22.0772 34.394C21.941 34.3145 21.7848 34.3004 21.637 34.3555C21.4798 34.4132 21.3509 34.5427 21.2733 34.7184L21.0406 35.2507L20.5543 36.3638C20.4777 36.5395 20.4641 36.7563 20.5176 36.9589C20.5459 37.0666 20.6182 37.2641 20.7932 37.3705C21.1035 37.5745 21.4766 37.4372 21.6359 37.0717C21.6359 37.0717 21.637 37.0692 21.637 37.0679L22.1894 35.8034L22.355 35.4238C22.4168 35.2814 22.6044 34.8518 22.0762 34.3914L22.0772 34.394ZM21.8938 25.3579C21.9305 25.2168 21.8655 25.059 21.7491 25.0142L20.027 24.3345C20.0029 24.3255 19.9809 24.3216 19.96 24.3216C19.9149 24.3216 19.8771 24.3396 19.8562 24.3524C19.8258 24.3716 19.7692 24.4191 19.7451 24.5102L17.5104 32.9833C17.4737 33.1244 17.5398 33.2821 17.6551 33.327L19.3772 34.0067C19.4526 34.0362 19.5166 34.008 19.547 33.9887C19.5784 33.9695 19.634 33.922 19.6581 33.8297L20.0459 32.3562C20.0595 32.2972 20.0721 32.2369 20.0868 32.1779C20.0931 32.1574 20.1004 32.1394 20.1077 32.1202L21.8917 25.3553L21.8938 25.3579ZM30.7297 41.7617V40.542C30.7297 40.542 30.7224 40.5446 30.7182 40.5446C30.7276 40.8845 30.6626 41.2205 30.5358 41.5141C30.2633 42.1515 29.7623 42.5068 29.2298 42.5068C28.9971 42.5068 28.7592 42.4375 28.5307 42.2964V44.751C29.7654 44.592 30.7297 43.3121 30.7297 41.7604V41.7617ZM34.9192 33.9246C34.5471 33.2321 32.9413 32.2613 31.8774 31.6188C31.3984 31.3302 30.9844 31.0801 30.6794 30.8634C30.6574 30.848 30.6354 30.8288 30.6144 30.8095C30.1176 30.3286 29.496 30.5787 28.5234 31.0276C27.3075 31.588 25.642 32.3536 24.2941 30.1363C24.1809 29.949 24.1547 29.7028 24.228 29.4861C24.4094 28.9461 24.9251 28.31 25.751 27.3161C25.9407 27.0879 26.1357 26.8545 26.3254 26.6198C26.4805 26.4287 26.6356 26.2492 26.7908 26.0812C25.9103 25.6195 25.1986 25.7926 24.3978 25.9875C23.8947 26.1106 23.3769 26.2338 22.8141 26.1914L21.0878 32.7396C21.049 32.9063 21.0175 33.0756 20.9987 33.2449C21.0993 33.1782 21.2073 33.1231 21.3205 33.082C21.7565 32.9192 22.2166 32.9756 22.616 33.2372C22.6411 33.2526 22.6642 33.2718 22.6872 33.2924C23.1359 33.6784 23.4115 34.1811 23.4954 34.7197C23.8276 34.6736 24.1746 34.7441 24.4922 34.9518C24.8915 35.2135 25.185 35.6508 25.316 36.1843C25.3349 36.2612 25.3506 36.3382 25.3621 36.4164C25.6996 36.3625 26.0539 36.4344 26.3767 36.6447C26.7719 36.9037 27.0476 37.3282 27.1817 37.8117C27.3368 37.5373 27.6366 37.4424 27.884 37.604L29.6879 38.7889C29.7182 38.8005 29.7497 38.8159 29.779 38.8351C29.779 38.8351 29.7801 38.8351 29.7811 38.8351L30.2318 39.1301C30.3849 39.2301 30.561 39.2506 30.7287 39.1891C30.8964 39.1262 31.0337 38.9903 31.1144 38.803C31.1961 38.6158 31.214 38.4003 31.1626 38.1952C31.1123 37.9912 31.0001 37.8232 30.8482 37.7232H30.8471C30.8282 37.7104 30.8125 37.6937 30.7957 37.6796L28.712 36.3164C28.4468 36.1432 28.3473 35.7406 28.4888 35.4161C28.6303 35.0916 28.9604 34.9685 29.2246 35.1429L31.3628 36.5421C31.3817 36.5536 31.3963 36.569 31.4131 36.5831L32.2988 37.1628C32.6227 37.3731 33.0273 37.2243 33.2002 36.8281C33.3679 36.4459 33.2568 35.9727 32.957 35.7495L30.0201 33.7989C29.756 33.6232 29.6585 33.2193 29.8011 32.8961C29.9446 32.5729 30.2748 32.4536 30.5389 32.6281L33.413 34.5363C33.4214 34.5415 33.4308 34.544 33.4392 34.5504L34.3322 35.134C34.6907 35.3674 34.8238 35.1917 34.8731 35.125C35.0617 34.8711 35.1215 34.3029 34.916 33.922L34.9192 33.9246ZM38.899 32.7153L36.3656 24.3704C36.3373 24.278 36.2807 24.2344 36.2482 24.2178C36.2283 24.2062 36.1948 24.1921 36.1539 24.1921C36.1308 24.1921 36.1057 24.1972 36.0784 24.2088L34.3825 24.9795C34.3081 25.0129 34.2725 25.0834 34.2578 25.1232C34.2431 25.1616 34.2232 25.2411 34.2505 25.3309L36.7838 33.6771C36.8111 33.7681 36.8687 33.8117 36.9002 33.831C36.9316 33.8477 36.9966 33.872 37.071 33.84L38.7669 33.0692C38.8414 33.0359 38.877 32.9653 38.8917 32.9269C38.9063 32.8884 38.9263 32.8089 38.899 32.7178V32.7153Z", fill: "currentColor" })
  }
), jx = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 33 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsx("path", { d: "M5.44355 49.8668H23.4943C26.359 49.8642 28.6809 47.5423 28.6835 44.6762V34.1782H29.9731C31.5924 34.1756 32.904 32.864 32.9066 31.2447V18.0663C32.9066 17.8858 32.8352 17.7144 32.708 17.5858L28.6848 13.5718V5.18926C28.6822 2.32452 26.3603 0.00259723 23.4956 0H5.44485C2.5788 0.00259723 0.258182 2.32452 0.255585 5.18926V44.6762C0.258182 47.541 2.5801 49.8629 5.44485 49.8668H5.44355ZM29.9744 32.8251H26.3382V22.0648C26.3382 21.8842 26.2668 21.7128 26.1396 21.5856L20.4399 15.8963C20.4399 15.8963 20.4373 15.8937 20.436 15.8924C20.3088 15.7613 20.1348 15.686 19.9517 15.686C19.9335 15.686 19.9153 15.6873 19.8984 15.6886C19.8802 15.6873 19.8621 15.686 19.8452 15.686H16.9155V14.6198C16.9155 13.7484 17.6232 13.042 18.4946 13.0407H25.8435V15.8197C25.8461 17.4391 27.1577 18.7507 28.777 18.7533H31.5561V31.2434C31.5548 32.1147 30.8483 32.8212 29.977 32.8225L29.9744 32.8251ZM19.2712 17.0417V19.8207C19.2725 21.4401 20.5854 22.7517 22.2048 22.7543H24.9838V35.2444C24.9838 36.1158 24.276 36.8222 23.4047 36.8235H11.9223C11.051 36.8222 10.3445 36.1158 10.3432 35.2444V18.6208C10.3432 17.7482 11.051 17.0417 11.9223 17.0404H19.2712V17.0417ZM24.0371 21.3999H22.2061C21.3334 21.3986 20.6282 20.6921 20.6269 19.8207V17.9975L24.0384 21.4012L24.0371 21.3999ZM27.3317 14.1328V14.1964H27.3953L30.6068 17.4001H28.7757C27.9044 17.4001 27.1966 16.6924 27.1966 15.821V13.9978L27.333 14.1341L27.3317 14.1328ZM5.44355 1.35445H23.4943C25.6123 1.35705 27.3278 3.07252 27.3304 5.19056V6.76967H25.7513C25.3773 6.76967 25.0747 7.07355 25.0747 7.44625C25.0747 7.81895 25.3786 8.12283 25.7513 8.12283H27.3304V12.2213L27.007 11.8992C27.007 11.8992 27.0044 11.8966 27.0018 11.8953C26.8746 11.7641 26.6993 11.6888 26.5175 11.6888C26.4993 11.6888 26.4811 11.6888 26.4642 11.6914C26.446 11.6888 26.4291 11.6888 26.411 11.6888H18.492C16.8727 11.6914 15.5611 13.003 15.5585 14.6224V15.6886H11.9223C10.303 15.6899 8.99136 17.0028 8.98876 18.6221V35.2457C8.99006 36.8651 10.303 38.1767 11.9223 38.1793H23.4047C25.024 38.178 26.3356 36.8651 26.3382 35.2457V34.1795H27.3317V40.3908H1.60874V8.12283H19.9984C20.3724 8.12283 20.675 7.81895 20.675 7.44625C20.675 7.07355 20.3724 6.76967 19.9984 6.76967H1.60874V5.19056C1.61134 3.07252 3.3281 1.35705 5.44485 1.35445H5.44355ZM1.60744 41.7439H27.3304V44.6775C27.3278 46.7956 25.6123 48.511 23.4943 48.5136H5.44355C3.32551 48.511 1.61004 46.7956 1.60744 44.6775V41.7439Z", fill: "currentColor" })
  }
), _x = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsx("path", { d: "M20.0001 20C21.3186 20 22.6076 19.609 23.7039 18.8765C24.8002 18.1439 25.6547 17.1027 26.1593 15.8846C26.6639 14.6664 26.7959 13.3259 26.5387 12.0327C26.2814 10.7395 25.6465 9.55164 24.7141 8.61929C23.7818 7.68694 22.5939 7.052 21.3007 6.79476C20.0075 6.53753 18.667 6.66955 17.4489 7.17414C16.2307 7.67872 15.1895 8.5332 14.457 9.62953C13.7244 10.7259 13.3334 12.0148 13.3334 13.3333C13.3334 15.1014 14.0358 16.7971 15.286 18.0474C16.5363 19.2976 18.232 20 20.0001 20ZM20.0001 10C20.6594 10 21.3038 10.1955 21.852 10.5618C22.4002 10.928 22.8274 11.4486 23.0797 12.0577C23.332 12.6668 23.398 13.337 23.2694 13.9836C23.1408 14.6302 22.8233 15.2242 22.3571 15.6904C21.8909 16.1565 21.297 16.474 20.6504 16.6026C20.0038 16.7312 19.3336 16.6652 18.7245 16.4129C18.1154 16.1606 17.5948 15.7334 17.2285 15.1852C16.8623 14.6371 16.6668 13.9926 16.6668 13.3333C16.6668 12.4493 17.0179 11.6014 17.6431 10.9763C18.2682 10.3512 19.116 10 20.0001 10ZM34.4334 15.2617L33.2351 14.8633C33.4507 12.9965 33.2693 11.1052 32.7028 9.31347C32.1362 7.52171 31.1973 5.86994 29.9476 4.46649C28.6979 3.06303 27.1656 1.9396 25.4513 1.16986C23.737 0.400112 21.8793 0.0014458 20.0001 0C18.0964 0.000734949 16.2149 0.40949 14.4825 1.19872C12.75 1.98796 11.2069 3.13934 9.95696 4.57529C8.70706 6.01124 7.77944 7.69841 7.23661 9.52312C6.69378 11.3478 6.54834 13.2677 6.81009 15.1533C5.21515 15.4507 3.7403 16.2032 2.56343 17.32C1.74872 18.0946 1.10104 19.0276 0.660223 20.0617C0.219405 21.0958 -0.00524229 22.2092 9.28451e-05 23.3333V30.125C0.0035955 31.9272 0.589746 33.68 1.67108 35.1218C2.75241 36.5635 4.27095 37.617 6.00009 38.125L10.7834 39.625C11.5869 39.875 12.4236 40.0015 13.2651 40C14.0284 39.999 14.7881 39.8947 15.5234 39.69L25.1568 36.84C26.015 36.6058 26.9202 36.6058 27.7784 36.84L31.7568 38.1733C32.7373 38.412 33.7591 38.4249 34.7454 38.2112C35.7316 37.9975 36.6564 37.5627 37.4502 36.9395C38.2439 36.3164 38.8858 35.5212 39.3275 34.6139C39.7692 33.7065 39.9992 32.7108 40.0001 31.7017V23.12C39.9963 21.3957 39.4593 19.7147 38.4627 18.3076C37.4661 16.9004 36.0587 15.8376 34.4334 15.2617ZM12.9301 6.27C13.8572 5.33915 14.959 4.60054 16.1722 4.09655C17.3855 3.59257 18.6863 3.33313 20.0001 3.33313C21.3139 3.33313 22.6147 3.59257 23.828 4.09655C25.0412 4.60054 26.143 5.33915 27.0701 6.27C28.9404 8.1519 29.9916 10.6964 29.9951 13.3496C29.9985 16.0028 28.9538 18.5499 27.0884 20.4367L21.1668 26.195C20.8577 26.498 20.4421 26.6678 20.0093 26.6678C19.5764 26.6678 19.1608 26.498 18.8518 26.195L12.9301 20.4617C11.0559 18.5756 10.0039 16.0247 10.0039 13.3658C10.0039 10.7069 11.0559 8.15602 12.9301 6.27ZM36.6668 31.7017C36.6678 32.2065 36.5536 32.7048 36.333 33.1589C36.1123 33.6129 35.791 34.0106 35.3934 34.3217C35.0178 34.6237 34.5802 34.8392 34.1118 34.953C33.6435 35.0668 33.1558 35.076 32.6834 34.98L28.7751 33.6667C27.2968 33.242 25.73 33.2327 24.2468 33.64L14.6068 36.4867C13.6806 36.7422 12.7003 36.7254 11.7834 36.4383L6.96009 34.9383C5.91618 34.6365 4.99836 34.0041 4.34442 33.1362C3.69049 32.2683 3.33574 31.2117 3.33343 30.125V23.3333C3.32968 22.6596 3.46377 21.9923 3.72746 21.3723C3.99115 20.7524 4.37886 20.1929 4.86676 19.7283C5.63052 19.0004 6.60346 18.5306 7.64843 18.385C8.32027 20.0503 9.32073 21.5632 10.5901 22.8333L16.5351 28.5883C17.4643 29.4982 18.713 30.0077 20.0134 30.0077C21.3139 30.0077 22.5626 29.4982 23.4918 28.5883L29.4301 22.8167C30.7597 21.4817 31.7897 19.879 32.4518 18.115L33.3468 18.4117C34.3174 18.7595 35.1571 19.3983 35.7512 20.2409C36.3454 21.0835 36.6651 22.089 36.6668 23.12V31.7017Z", fill: "currentColor" })
  }
), Dx = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsx("path", { d: "M21.6667 1.66664C21.6667 1.22462 21.8423 0.800692 22.1548 0.488131C22.4674 0.175571 22.8913 -2.39338e-05 23.3333 -2.39338e-05C27.7521 0.00482873 31.9885 1.76233 35.1131 4.88689C38.2376 8.01145 39.9951 12.2479 40 16.6666C40 17.1087 39.8244 17.5326 39.5118 17.8452C39.1993 18.1577 38.7754 18.3333 38.3333 18.3333C37.8913 18.3333 37.4674 18.1577 37.1548 17.8452C36.8423 17.5326 36.6667 17.1087 36.6667 16.6666C36.6627 13.1316 35.2567 9.74256 32.757 7.24294C30.2574 4.74331 26.8683 3.33728 23.3333 3.33331C22.8913 3.33331 22.4674 3.15771 22.1548 2.84515C21.8423 2.53259 21.6667 2.10867 21.6667 1.66664ZM23.3333 9.99998C25.1014 9.99998 26.7971 10.7024 28.0474 11.9526C29.2976 13.2028 30 14.8985 30 16.6666C30 17.1087 30.1756 17.5326 30.4881 17.8452C30.8007 18.1577 31.2246 18.3333 31.6667 18.3333C32.1087 18.3333 32.5326 18.1577 32.8452 17.8452C33.1577 17.5326 33.3333 17.1087 33.3333 16.6666C33.3307 14.0153 32.2763 11.4733 30.4015 9.5985C28.5267 7.72371 25.9847 6.66929 23.3333 6.66664C22.8913 6.66664 22.4674 6.84224 22.1548 7.1548C21.8423 7.46736 21.6667 7.89128 21.6667 8.33331C21.6667 8.77534 21.8423 9.19926 22.1548 9.51182C22.4674 9.82438 22.8913 9.99998 23.3333 9.99998ZM38.4883 27.8983C39.4542 28.8668 39.9966 30.1788 39.9966 31.5466C39.9966 32.9145 39.4542 34.2265 38.4883 35.195L36.9717 36.9433C23.3217 50.0116 -9.895 16.8033 2.97166 3.10998L4.88833 1.44331C5.85794 0.504438 7.15822 -0.0149421 8.50784 -0.00246586C9.85746 0.0100104 11.1479 0.55334 12.1 1.50998C12.1517 1.56164 15.24 5.57331 15.24 5.57331C16.1564 6.53602 16.6665 7.81486 16.6643 9.14398C16.6622 10.4731 16.1479 11.7503 15.2283 12.71L13.2983 15.1366C14.3664 17.7318 15.9368 20.0904 17.9192 22.0768C19.9016 24.0632 22.257 25.6383 24.85 26.7116L27.2917 24.77C28.2515 23.8512 29.5284 23.3375 30.8572 23.3356C32.1859 23.3337 33.4642 23.8439 34.4267 24.76C34.4267 24.76 38.4367 27.8466 38.4883 27.8983ZM36.195 30.3216C36.195 30.3216 32.2067 27.2533 32.155 27.2016C31.8116 26.8612 31.3477 26.6702 30.8642 26.6702C30.3806 26.6702 29.9167 26.8612 29.5733 27.2016C29.5283 27.2483 26.1667 29.9266 26.1667 29.9266C25.9401 30.107 25.6705 30.2252 25.3844 30.2696C25.0983 30.314 24.8055 30.2831 24.535 30.18C21.1758 28.9293 18.1246 26.9712 15.5881 24.4384C13.0516 21.9057 11.089 18.8574 9.83333 15.5C9.72199 15.2257 9.6857 14.9268 9.72817 14.6339C9.77064 14.341 9.89035 14.0646 10.075 13.8333C10.075 13.8333 12.7533 10.47 12.7983 10.4266C13.1388 10.0833 13.3298 9.61934 13.3298 9.13581C13.3298 8.65228 13.1388 8.18833 12.7983 7.84498C12.7467 7.79498 9.67833 3.80331 9.67833 3.80331C9.32983 3.49082 8.875 3.32347 8.40708 3.33555C7.93915 3.34764 7.49357 3.53825 7.16166 3.86831L5.245 5.53498C-4.15834 16.8416 24.6267 44.03 34.535 34.6666L36.0533 32.9166C36.4091 32.5871 36.6228 32.1321 36.6493 31.6478C36.6757 31.1635 36.5128 30.688 36.195 30.3216Z", fill: "currentColor" })
  }
), Ax = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsx("path", { d: "M31.6667 0H8.33333C6.12401 0.00264643 4.00593 0.88147 2.4437 2.4437C0.88147 4.00593 0.00264643 6.12401 0 8.33333L0 28.3333C0.00264643 30.5427 0.88147 32.6607 2.4437 34.223C4.00593 35.7852 6.12401 36.664 8.33333 36.6667H31.6667C33.876 36.664 35.9941 35.7852 37.5563 34.223C39.1185 32.6607 39.9974 30.5427 40 28.3333V8.33333C39.9974 6.12401 39.1185 4.00593 37.5563 2.4437C35.9941 0.88147 33.876 0.00264643 31.6667 0ZM8.33333 3.33333H31.6667C32.6646 3.3353 33.6392 3.63586 34.4649 4.19634C35.2906 4.75682 35.9298 5.55158 36.3 6.47833L23.5367 19.2433C22.5974 20.1789 21.3257 20.7041 20 20.7041C18.6743 20.7041 17.4026 20.1789 16.4633 19.2433L3.7 6.47833C4.07025 5.55158 4.70936 4.75682 5.53508 4.19634C6.3608 3.63586 7.33536 3.3353 8.33333 3.33333ZM31.6667 33.3333H8.33333C7.00725 33.3333 5.73548 32.8066 4.7978 31.8689C3.86012 30.9312 3.33333 29.6594 3.33333 28.3333V10.8333L14.1067 21.6C15.671 23.1604 17.7904 24.0367 20 24.0367C22.2096 24.0367 24.329 23.1604 25.8933 21.6L36.6667 10.8333V28.3333C36.6667 29.6594 36.1399 30.9312 35.2022 31.8689C34.2645 32.8066 32.9927 33.3333 31.6667 33.3333Z", fill: "currentColor" })
  }
), Mx = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsx("path", { d: "M34.1737 5.81333C30.4124 2.06667 25.4118 0.00166667 20.0846 0C9.10697 0 0.172493 8.89 0.167469 19.82C0.165794 23.3133 1.08353 26.7233 2.82688 29.73L0 40L10.5573 37.2433C13.4662 38.8233 16.7419 39.655 20.0745 39.6567H20.0829C31.0588 39.6567 39.995 30.765 40 19.835C40.0033 14.54 37.9334 9.55833 34.1737 5.81333ZM20.0846 36.3083H20.0779C17.107 36.3083 14.1947 35.5133 11.6525 34.0117L11.0479 33.655L4.78292 35.29L6.45593 29.21L6.06238 28.5867C4.40444 25.9633 3.53025 22.9317 3.53192 19.82C3.53527 10.7367 10.9625 3.34667 20.0929 3.34667C24.5141 3.34667 28.6707 5.06333 31.7957 8.17667C34.9207 11.2917 36.6406 15.43 36.6389 19.8317C36.6339 28.9183 29.2083 36.3083 20.0846 36.3083ZM29.1647 23.97C28.6674 23.7217 26.2206 22.5233 25.7634 22.3583C25.3079 22.1933 24.9763 22.11 24.6431 22.605C24.3098 23.1 23.3586 24.2167 23.0672 24.5483C22.7775 24.8783 22.4861 24.92 21.9887 24.6717C21.4913 24.4233 19.887 23.9017 17.9862 22.2133C16.5074 20.9 15.5076 19.2783 15.2179 18.7817C14.9282 18.285 15.1878 18.0183 15.4356 17.7717C15.66 17.55 15.933 17.1933 16.1825 16.9033C16.4337 16.6167 16.5158 16.41 16.6833 16.0783C16.8491 15.7483 16.767 15.4583 16.6414 15.21C16.5158 14.9633 15.521 12.525 15.1074 11.5333C14.7038 10.5667 14.2935 10.6983 13.987 10.6833C13.6973 10.6683 13.3657 10.6667 13.0324 10.6667C12.7009 10.6667 12.1616 10.79 11.7061 11.2867C11.2506 11.7833 9.96441 12.9817 9.96441 15.4183C9.96441 17.8567 11.748 20.2117 11.9958 20.5417C12.2437 20.8717 15.5043 25.875 20.4965 28.02C21.6839 28.53 22.6117 28.835 23.3335 29.0633C24.5259 29.44 25.6111 29.3867 26.4685 29.26C27.4247 29.1183 29.4126 28.0617 29.8279 26.905C30.2432 25.7483 30.2432 24.755 30.1176 24.55C29.9937 24.3417 29.6621 24.2183 29.1647 23.97Z", fill: "currentColor" })
  }
), Tx = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsx("path", { d: "M31.6667 4H20.7867C20.53 4 20.27 3.94 20.0417 3.825L14.7867 1.19834C14.095 0.851669 13.3217 0.668336 12.5467 0.668336H8.33333C3.73833 0.666669 0 4.405 0 9V29C0 33.595 3.73833 37.3333 8.33333 37.3333H13.3333C14.2533 37.3333 15 36.5883 15 35.6667C15 34.745 14.2533 34 13.3333 34H8.33333C5.57667 34 3.33333 31.7567 3.33333 29V14H36.6667V29C36.6667 31.7567 34.4233 34 31.6667 34H26.6667C25.7467 34 25 34.745 25 35.6667C25 36.5883 25.7467 37.3333 26.6667 37.3333H31.6667C36.2617 37.3333 40 33.595 40 29V12.3333C40 7.73834 36.2617 4 31.6667 4ZM3.33333 9C3.33333 6.24333 5.57667 4 8.33333 4H12.5467C12.8033 4 13.06 4.06 13.2917 4.17667L18.5517 6.805C19.2433 7.15 20.015 7.33167 20.7867 7.33167H31.6667C33.8367 7.33167 35.67 8.73 36.36 10.665H3.33333V9ZM23.8217 25.4933L21.6667 23.3383V35.6667C21.6667 36.5883 20.92 37.3333 20 37.3333C19.08 37.3333 18.3333 36.5883 18.3333 35.6667V23.3383L16.1783 25.4933C15.8533 25.8183 15.4267 25.9817 15 25.9817C14.5733 25.9817 14.1467 25.8183 13.8217 25.4933C13.17 24.8417 13.17 23.7883 13.8217 23.1367L16.51 20.4483C18.3733 18.5833 21.625 18.5833 23.49 20.4483L26.1783 23.1367C26.83 23.7883 26.83 24.8417 26.1783 25.4933C25.5267 26.145 24.4733 26.145 23.8217 25.4933Z", fill: "currentColor" })
  }
), $x = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 34 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsx("path", { d: "M32.2017 5.43333L28.2333 1.465C27.29 0.52 26.0333 0 24.6983 0H17C12.9767 0 9.60834 2.86833 8.835 6.66667H8.66667C4.07167 6.66667 0.333336 10.405 0.333336 15V31.6667C0.333336 36.2617 4.07167 40 8.66667 40H18.6667C23.2617 40 27 36.2617 27 31.6667V31.4983C30.7983 30.7233 33.6667 27.3567 33.6667 23.3333V8.96833C33.6667 7.63333 33.1467 6.37667 32.2017 5.43333ZM18.6667 36.6667H8.66667C5.91 36.6667 3.66667 34.4233 3.66667 31.6667V15C3.66667 12.2433 5.91 10 8.66667 10V23.3333C8.66667 27.9283 12.405 31.6667 17 31.6667H23.6667C23.6667 34.4233 21.4233 36.6667 18.6667 36.6667ZM25.3333 28.3333H17C14.2433 28.3333 12 26.09 12 23.3333V8.33333C12 5.57667 14.2433 3.33333 17 3.33333H23.6667V6.66667C23.6667 8.50833 25.1583 10 27 10H30.3333V23.3333C30.3333 26.09 28.09 28.3333 25.3333 28.3333ZM27 18.3333C27 19.2533 26.2533 20 25.3333 20H22.8333V22.5C22.8333 23.42 22.0867 24.1667 21.1667 24.1667C20.2467 24.1667 19.5 23.42 19.5 22.5V20H17C16.08 20 15.3333 19.2533 15.3333 18.3333C15.3333 17.4133 16.08 16.6667 17 16.6667H19.5V14.1667C19.5 13.2467 20.2467 12.5 21.1667 12.5C22.0867 12.5 22.8333 13.2467 22.8333 14.1667V16.6667H25.3333C26.2533 16.6667 27 17.4133 27 18.3333Z", fill: "currentColor" })
  }
), Nx = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsxs("g", { id: "Vector", children: [
      /* @__PURE__ */ d.jsx("path", { d: "M23.71 20.3C23.52 20.11 23.27 20.01 23 20.01C22.73 20.01 22.48 20.12 22.29 20.3C22.1 20.48 22 20.74 22 21.01C22 21.28 21.63 21.69 21 21.89V23.28C21 23.52 20.95 23.75 20.86 23.96C22.62 23.72 24 22.47 24 21.01C24 20.74 23.89 20.49 23.71 20.3Z", fill: "currentColor" }),
      /* @__PURE__ */ d.jsx("path", { d: "M15 23.28V21.99C14.92 21.99 14.83 22.01 14.75 22.01C13.66 22.01 13 21.32 13 21.01V11.39L14.99 12.04C15.83 11.4 16.87 11 18 11C18.71 11 19.39 11.15 20 11.42V9C20 7.94 19.58 6.92 18.83 6.17C18.08 5.42 17.06 5 16 5V4C16 2.94 15.58 1.92 14.83 1.17C14.08 0.42 13.06 0 12 0C10.94 0 9.92 0.42 9.17 1.17C8.42 1.92 8 2.94 8 4V5C6.94 5 5.92 5.42 5.17 6.17C4.42 6.92 4 7.94 4 9V11.57C3.32 11.8 2.75 12.27 2.39 12.89C2.03 13.51 1.9 14.24 2.03 14.94C2.47 17.27 3.58 19.42 5.22 21.12C5.27 21.18 5.31 21.24 5.35 21.31C5.15 21.54 4.91 21.72 4.63 21.83C4.35 21.95 4.05 22 3.75 21.99C2.66 21.99 2 21.3 2 20.99C2 20.72 1.89 20.47 1.71 20.28C1.52 20.09 1.27 19.99 1 19.99C0.73 19.99 0.48 20.1 0.29 20.28C0.1 20.47 0 20.72 0 20.99C0 22.62 1.72 23.99 3.75 23.99C4.76 23.99 5.74 23.64 6.51 22.99C7.28 23.63 8.25 23.99 9.25 23.99C10.25 23.99 11.22 23.65 12 23.01C12.78 23.65 13.75 23.99 14.75 23.99C14.88 23.99 15.01 23.97 15.15 23.95C15.06 23.74 15 23.5 15 23.26V23.28ZM10 4.01C10 3.48 10.21 2.97 10.59 2.6C10.97 2.22 11.47 2.01 12 2.01C12.53 2.01 13.04 2.22 13.41 2.6C13.79 2.98 14 3.48 14 4.01V5.01H10V4.01ZM11 21.01C11 21.35 10.32 22.01 9.25 22.01C8.92 22.03 8.58 21.96 8.28 21.81C7.98 21.66 7.72 21.44 7.54 21.16C7.33 20.66 7.05 20.2 6.69 19.79C5.31 18.36 4.38 16.57 4 14.62C3.95 14.38 4 14.13 4.12 13.92C4.24 13.71 4.44 13.55 4.67 13.47L11.01 11.4V21.02L11 21.01ZM11.06 9.27L6 10.92V9.01C6 8.48 6.21 7.97 6.59 7.6C6.97 7.22 7.47 7.01 8 7.01H16C16.53 7.01 17.04 7.22 17.41 7.6C17.79 7.98 18 8.48 18 9.01V10.93L12.95 9.27C12.34 9.07 11.67 9.07 11.06 9.27Z", fill: "currentColor" }),
      /* @__PURE__ */ d.jsx("path", { d: "M18 12.01C15.79 12.01 14 13.8 14 16.01C14 17.49 14.81 18.78 16 19.47V23.28C16 23.92 16.78 24.24 17.23 23.79L18 23.02L18.77 23.79C19.22 24.24 20 23.92 20 23.28V19.47C21.19 18.78 22 17.48 22 16.01C22 13.8 20.21 12.01 18 12.01ZM18 18.01C16.9 18.01 16 17.11 16 16.01C16 14.91 16.9 14.01 18 14.01C19.1 14.01 20 14.91 20 16.01C20 17.11 19.1 18.01 18 18.01Z", fill: "currentColor" })
    ] })
  }
), Ix = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        d: "M19.5 0H12.5C10.019 0 8 2.019 8 4.5V15.5C8 17.43 9.57 19 11.5 19H19.5C21.981 19 24 16.981 24 14.5V4.5C24 2.019 21.981 0 19.5 0ZM12.5 2H19.5C20.878 2 22 3.121 22 4.5V12H11.5C10.964 12 10.455 12.122 10 12.338V4.5C10 3.121 11.122 2 12.5 2ZM19.5 17H11.5C10.673 17 10 16.327 10 15.5C10 14.673 10.673 14 11.5 14H22V14.5C22 15.879 20.878 17 19.5 17ZM14.663 21.3C15.05 21.695 15.044 22.327 14.649 22.714C13.803 23.543 12.685 24 11.5 24H3.5C1.57 24 0 22.43 0 20.5V9.5C0 7.019 2.019 5 4.5 5H5C5.552 5 6 5.447 6 6C6 6.553 5.552 7 5 7H4.5C3.122 7 2 8.121 2 9.5V17.338C2.455 17.121 2.964 17 3.5 17H5C5.552 17 6 17.447 6 18C6 18.553 5.552 19 5 19H3.5C2.673 19 2 19.673 2 20.5C2 21.327 2.673 22 3.5 22H11.5C12.158 22 12.78 21.746 13.249 21.286C13.644 20.898 14.276 20.906 14.663 21.3Z",
        fill: "currentColor"
      }
    )
  }
), Lx = () => /* @__PURE__ */ d.jsx("svg", { className: "w-full", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ d.jsx(
  "path",
  {
    d: "M22.61 16.1623C21.46 15.7473 20.019 15.2563 18.385 14.7613L21.462 3.22227C21.664 2.46527 21.506 1.67527 21.029 1.05427C20.551 0.434271 19.83 0.0772705 19.047 0.0772705H18.749C17.34 0.0772705 15.994 0.75027 15.149 1.87827L9.298 9.67827C8.124 11.2433 6.342 12.0773 5.506 12.0773H1C0.447 12.0773 0 12.5243 0 13.0773C0 13.6303 0.447 14.0773 1 14.0773H3.008C9.909 14.0773 17.826 16.5613 21.932 18.0433C21.961 18.0543 22.001 18.0683 22 18.1393C22 18.2103 21.96 18.2243 21.931 18.2343C17.827 19.6703 9.91 22.0783 3.008 22.0783H1C0.447 22.0783 0 22.5253 0 23.0783C0 23.6313 0.447 24.0783 1 24.0783H3.008C10.204 24.0783 18.366 21.5993 22.591 20.1223C23.444 19.8243 23.996 19.0503 24 18.1493C24.004 17.2483 23.459 16.4683 22.61 16.1633V16.1623ZM10.899 10.8773L16.75 3.07727C17.22 2.45127 17.968 2.07727 18.75 2.07727H19.048C19.262 2.07727 19.388 2.19927 19.444 2.27227C19.5 2.34527 19.586 2.49927 19.531 2.70627L16.465 14.2043C14.219 13.5823 11.72 12.9983 9.173 12.6003C9.796 12.1313 10.392 11.5563 10.9 10.8783L10.899 10.8773ZM8 19.0773C7.447 19.0773 7 18.6303 7 18.0773C7 17.5243 7.447 17.0773 8 17.0773H13C13.553 17.0773 14 17.5243 14 18.0773C14 18.6303 13.553 19.0773 13 19.0773H8Z",
    fill: "currentColor"
  }
) }), Rx = () => /* @__PURE__ */ d.jsx("svg", { className: "w-full", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ d.jsx(
  "path",
  {
    d: "M21 24.0773C19.346 24.0773 18 22.7313 18 21.0773V13.0773C18 12.5263 17.552 12.0773 17 12.0773H7C6.448 12.0773 6 12.5263 6 13.0773V21.0773C6 22.7313 4.654 24.0773 3 24.0773C1.346 24.0773 0 22.7313 0 21.0773V9.80125C0 8.13625 0.824 6.58725 2.203 5.65625L9.203 0.932254C10.902 -0.213746 13.098 -0.213746 14.797 0.932254L21.797 5.65625C23.176 6.58725 24 8.13625 24 9.80125V21.0773C24 22.7313 22.654 24.0773 21 24.0773ZM7 10.0773H17C18.654 10.0773 20 11.4233 20 13.0773V21.0773C20 21.6283 20.448 22.0773 21 22.0773C21.552 22.0773 22 21.6283 22 21.0773V9.80125C22 8.80225 21.506 7.87225 20.678 7.31425L13.678 2.59025C12.658 1.90225 11.342 1.90225 10.323 2.59025L3.322 7.31425C2.494 7.87225 2 8.80225 2 9.80125V21.0773C2 21.6283 2.448 22.0773 3 22.0773C3.552 22.0773 4 21.6283 4 21.0773V13.0773C4 11.4233 5.346 10.0773 7 10.0773ZM11 23.0773V21.0773C11 20.5253 10.553 20.0773 10 20.0773H9C8.447 20.0773 8 20.5253 8 21.0773V23.0773C8 23.6293 8.447 24.0773 9 24.0773H10C10.553 24.0773 11 23.6293 11 23.0773ZM11 17.0773V15.0773C11 14.5253 10.553 14.0773 10 14.0773H9C8.447 14.0773 8 14.5253 8 15.0773V17.0773C8 17.6293 8.447 18.0773 9 18.0773H10C10.553 18.0773 11 17.6293 11 17.0773ZM16 23.0773V21.0773C16 20.5253 15.553 20.0773 15 20.0773H14C13.447 20.0773 13 20.5253 13 21.0773V23.0773C13 23.6293 13.447 24.0773 14 24.0773H15C15.553 24.0773 16 23.6293 16 23.0773Z",
    fill: "currentColor"
  }
) }), kx = () => /* @__PURE__ */ d.jsx("svg", { className: "w-full", viewBox: "0 0 14 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ d.jsx(
  "path",
  {
    d: "M1 5.00513H11L7.71 1.71513C7.61627 1.62216 7.54188 1.51156 7.49111 1.3897C7.44034 1.26784 7.4142 1.13714 7.4142 1.00513C7.4142 0.873114 7.44034 0.742408 7.49111 0.620549C7.54188 0.49869 7.61627 0.388089 7.71 0.295126C7.89736 0.108875 8.15081 0.0043335 8.415 0.0043335C8.67919 0.0043335 8.93264 0.108875 9.12 0.295126L13.41 4.59513C13.7856 4.96848 13.9978 5.47555 14 6.00513C13.9951 6.53123 13.7832 7.03423 13.41 7.40513L9.12 11.7051C9.02676 11.7977 8.9162 11.871 8.79463 11.9209C8.67306 11.9707 8.54286 11.9961 8.41146 11.9957C8.28007 11.9952 8.15005 11.9689 8.02884 11.9182C7.90762 11.8675 7.79758 11.7934 7.705 11.7001C7.61242 11.6069 7.53911 11.4963 7.48925 11.3748C7.4394 11.2532 7.41398 11.123 7.41444 10.9916C7.41491 10.8602 7.44125 10.7302 7.49196 10.609C7.54267 10.4877 7.61676 10.3777 7.71 10.2851L11 7.00513H1C0.734783 7.00513 0.480429 6.89977 0.292892 6.71223C0.105356 6.5247 0 6.27034 0 6.00513C0 5.73991 0.105356 5.48556 0.292892 5.29802C0.480429 5.11048 0.734783 5.00513 1 5.00513Z",
    fill: "currentColor"
  }
) }), Bx = () => /* @__PURE__ */ d.jsx("svg", { className: "w-full", viewBox: "0 0 20 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ d.jsx(
  "path",
  {
    d: "M17.949 5.536L14.465 2.05C13.142 0.728 11.384 0 9.515 0H5C2.243 0 0 2.243 0 5V19C0 21.757 2.243 24 5 24H15C17.757 24 20 21.757 20 19V10.485C20 8.614 19.271 6.858 17.949 5.536ZM16.535 6.951C16.853 7.268 17.122 7.621 17.34 8.001H12.999C12.447 8.001 11.999 7.552 11.999 7.001V2.659C12.379 2.877 12.732 3.146 13.05 3.464L16.535 6.951ZM18 19.001C18 20.655 16.654 22.001 15 22.001H5C3.346 22.001 2 20.655 2 19.001V5C2 3.346 3.346 2 5 2H9.515C9.678 2 9.84 2.008 10 2.023V7C10 8.654 11.346 10 13 10H17.977C17.992 10.16 18 10.322 18 10.485V19.001ZM13.707 16.106C14.098 16.496 14.098 17.129 13.707 17.52L12.094 19.134C11.517 19.711 10.758 20 10 20C9.242 20 8.483 19.711 7.906 19.134L6.293 17.52C5.902 17.129 5.902 16.496 6.293 16.106C6.684 15.715 7.316 15.715 7.707 16.106L9 17.399V13.001C9 12.449 9.447 12.001 10 12.001C10.553 12.001 11 12.449 11 13.001V17.399L12.293 16.106C12.684 15.715 13.316 15.715 13.707 16.106Z",
    fill: "currentColor"
  }
) }), Vx = () => /* @__PURE__ */ d.jsx("svg", { className: "w-full", viewBox: "0 0 25 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ d.jsx(
  "path",
  {
    d: "M18.86 5.14152C18.528 5.07552 18.257 4.86852 18.118 4.57252C16.566 1.30152 12.975 -0.527481 9.38301 0.134519C6.11101 0.734519 3.54601 3.34652 2.99901 6.63552C2.83701 7.60652 2.84901 8.57852 3.03201 9.52552C3.09201 9.83452 2.95901 10.1785 2.68601 10.4265C1.54101 11.4675 0.88501 12.9505 0.88501 14.4965C0.88501 17.5285 3.35201 19.9965 6.38501 19.9965H17.385C21.521 19.9965 24.885 16.6325 24.885 12.4965C24.885 8.93152 22.351 5.83852 18.859 5.14252L18.86 5.14152ZM17.386 17.9955H6.38601C4.45601 17.9955 2.88601 16.4255 2.88601 14.4955C2.88601 13.5125 3.30401 12.5675 4.03201 11.9055C4.81801 11.1905 5.18701 10.1325 4.99501 9.14252C4.85701 8.43052 4.84901 7.69752 4.97101 6.96152C5.37401 4.53952 7.33601 2.54052 9.74201 2.09952C10.127 2.02952 10.51 1.99552 10.887 1.99552C13.199 1.99552 15.293 3.28452 16.309 5.42952C16.723 6.30152 17.509 6.91052 18.467 7.10252C21.026 7.61352 22.884 9.88052 22.884 12.4965C22.884 15.5285 20.417 17.9965 17.384 17.9965L17.386 17.9955ZM16.007 11.2885C16.398 11.6795 16.398 12.3115 16.007 12.7025L13.3 15.4095C12.913 15.7965 12.404 15.9915 11.895 15.9935L11.886 15.9955L11.877 15.9935C11.368 15.9915 10.859 15.7965 10.472 15.4095L7.76501 12.7025C7.37401 12.3115 7.37401 11.6795 7.76501 11.2885C8.15601 10.8975 8.78801 10.8975 9.17901 11.2885L10.886 12.9955V7.99552C10.886 7.44252 11.334 6.99552 11.886 6.99552C12.438 6.99552 12.886 7.44252 12.886 7.99552V12.9955L14.593 11.2885C14.984 10.8975 15.616 10.8975 16.007 11.2885Z",
    fill: "currentColor"
  }
) }), Hx = () => /* @__PURE__ */ d.jsxs("svg", { className: "w-full", viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ d.jsx(
    "path",
    {
      d: "M16.885 8C16.6975 7.81253 16.4432 7.70721 16.178 7.70721C15.9128 7.70721 15.6585 7.81253 15.471 8L12.885 10.586L10.299 8C10.1104 7.81784 9.85781 7.71705 9.59561 7.71933C9.33341 7.7216 9.0826 7.82677 8.89719 8.01218C8.71178 8.19759 8.60661 8.4484 8.60434 8.7106C8.60206 8.9728 8.70285 9.2254 8.88501 9.414L11.471 12L8.88501 14.586C8.70285 14.7746 8.60206 15.0272 8.60434 15.2894C8.60661 15.5516 8.71178 15.8024 8.89719 15.9878C9.0826 16.1732 9.33341 16.2784 9.59561 16.2807C9.85781 16.283 10.1104 16.1822 10.299 16L12.885 13.414L15.471 16C15.6596 16.1822 15.9122 16.283 16.1744 16.2807C16.4366 16.2784 16.6874 16.1732 16.8728 15.9878C17.0582 15.8024 17.1634 15.5516 17.1657 15.2894C17.168 15.0272 17.0672 14.7746 16.885 14.586L14.299 12L16.885 9.414C17.0725 9.22647 17.1778 8.97216 17.1778 8.707C17.1778 8.44184 17.0725 8.18753 16.885 8Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ d.jsx(
    "path",
    {
      d: "M12.885 0C10.5116 0 8.19156 0.703788 6.21817 2.02236C4.24478 3.34094 2.70671 5.21509 1.79846 7.4078C0.890209 9.60051 0.652569 12.0133 1.11559 14.3411C1.57861 16.6689 2.7215 18.8071 4.39973 20.4853C6.07796 22.1635 8.21616 23.3064 10.5439 23.7694C12.8717 24.2324 15.2845 23.9948 17.4772 23.0866C19.6699 22.1783 21.5441 20.6402 22.8626 18.6668C24.1812 16.6935 24.885 14.3734 24.885 12C24.8816 8.81846 23.6162 5.76821 21.3665 3.51852C19.1168 1.26883 16.0666 0.00344108 12.885 0ZM12.885 22C10.9072 22 8.9738 21.4135 7.32931 20.3147C5.68482 19.2159 4.4031 17.6541 3.64622 15.8268C2.88934 13.9996 2.69131 11.9889 3.07716 10.0491C3.46301 8.10929 4.41542 6.32746 5.81395 4.92893C7.21247 3.53041 8.9943 2.578 10.9341 2.19215C12.8739 1.8063 14.8846 2.00433 16.7119 2.7612C18.5391 3.51808 20.1009 4.79981 21.1997 6.4443C22.2985 8.08879 22.885 10.0222 22.885 12C22.8821 14.6513 21.8276 17.1931 19.9529 19.0679C18.0781 20.9426 15.5363 21.9971 12.885 22Z",
      fill: "currentColor"
    }
  )
] }), Fx = () => /* @__PURE__ */ d.jsx("svg", { className: "w-full", viewBox: "0 0 25 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ d.jsx(
  "path",
  {
    d: "M4.88501 14V21C4.88501 21.552 4.43701 22 3.88501 22C3.33301 22 2.88501 21.552 2.88501 21V14C2.88501 13.448 3.33301 13 3.88501 13C4.43701 13 4.88501 13.448 4.88501 14ZM18.885 13C18.333 13 17.885 13.448 17.885 14V21C17.885 21.552 18.333 22 18.885 22C19.437 22 19.885 21.552 19.885 21V14C19.885 13.448 19.437 13 18.885 13ZM10.885 13C10.333 13 9.88501 13.448 9.88501 14V21C9.88501 21.552 10.333 22 10.885 22C11.437 22 11.885 21.552 11.885 21V14C11.885 13.448 11.437 13 10.885 13ZM7.38501 13C6.55601 13 5.88501 13.671 5.88501 14.5V20.5C5.88501 21.329 6.55601 22 7.38501 22C8.21401 22 8.88501 21.329 8.88501 20.5V14.5C8.88501 13.671 8.21401 13 7.38501 13ZM15.385 13C14.556 13 13.885 13.671 13.885 14.5V20.5C13.885 21.329 14.556 22 15.385 22C16.214 22 16.885 21.329 16.885 20.5V14.5C16.885 13.671 16.214 13 15.385 13ZM21.885 13C21.333 13 20.885 13.448 20.885 14V21C20.885 21.552 21.333 22 21.885 22C22.437 22 22.885 21.552 22.885 21V14C22.885 13.448 22.437 13 21.885 13ZM23.885 9H22.885V1C22.885 0.448 22.437 0 21.885 0C21.333 0 20.885 0.448 20.885 1V9H19.885V1C19.885 0.448 19.437 0 18.885 0C18.333 0 17.885 0.448 17.885 1V9H16.885V1.5C16.885 0.671 16.214 0 15.385 0C14.556 0 13.885 0.671 13.885 1.5V9H11.885V1C11.885 0.448 11.437 0 10.885 0C10.333 0 9.88501 0.448 9.88501 1V9H8.88501V1.5C8.88501 0.671 8.21401 0 7.38501 0C6.55601 0 5.88501 0.671 5.88501 1.5V9H4.88501V1C4.88501 0.448 4.43701 0 3.88501 0C3.33301 0 2.88501 0.448 2.88501 1V9H1.88501C1.33301 9 0.88501 9.448 0.88501 10C0.88501 10.552 1.33301 11 1.88501 11H23.885C24.437 11 24.885 10.552 24.885 10C24.885 9.448 24.437 9 23.885 9Z",
    fill: "currentColor"
  }
) }), Wx = () => /* @__PURE__ */ d.jsxs("svg", { className: "w-full", viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ d.jsx("path", { d: "M18.885 19C19.0828 19 19.2761 18.9413 19.4405 18.8314C19.6049 18.7215 19.733 18.5654 19.8087 18.3827C19.8844 18.2 19.9042 17.9989 19.8656 17.805C19.827 17.611 19.7318 17.4328 19.592 17.293L13.42 11.122C12.4824 10.1846 11.2108 9.65807 9.88501 9.65807C8.55919 9.65807 7.28765 10.1846 6.35001 11.122L4.17801 13.293C3.99585 13.4816 3.89506 13.7342 3.89734 13.9964C3.89961 14.2586 4.00478 14.5094 4.19019 14.6948C4.3756 14.8802 4.62641 14.9854 4.88861 14.9877C5.15081 14.99 5.40341 14.8892 5.59201 14.707L7.76401 12.536C8.33523 11.9901 9.09491 11.6855 9.88501 11.6855C10.6751 11.6855 11.4348 11.9901 12.006 12.536L18.178 18.707C18.3655 18.8946 18.6198 18.9999 18.885 19Z", fill: "currentColor" }),
  /* @__PURE__ */ d.jsx("path", { d: "M16.885 10.5C17.5772 10.5 18.2539 10.2947 18.8295 9.91014C19.4051 9.52556 19.8537 8.97893 20.1186 8.33939C20.3835 7.69985 20.4528 6.99612 20.3178 6.31718C20.1827 5.63825 19.8494 5.01461 19.3599 4.52513C18.8704 4.03564 18.2468 3.7023 17.5678 3.56725C16.8889 3.4322 16.1852 3.50151 15.5456 3.76642C14.9061 4.03133 14.3595 4.47993 13.9749 5.0555C13.5903 5.63108 13.385 6.30777 13.385 7C13.385 7.92826 13.7538 8.8185 14.4101 9.47487C15.0665 10.1313 15.9568 10.5 16.885 10.5ZM16.885 5.5C17.1817 5.5 17.4717 5.58797 17.7184 5.7528C17.965 5.91762 18.1573 6.15189 18.2708 6.42597C18.3844 6.70006 18.4141 7.00166 18.3562 7.29264C18.2983 7.58361 18.1554 7.85088 17.9457 8.06066C17.7359 8.27044 17.4686 8.4133 17.1776 8.47118C16.8867 8.52906 16.5851 8.49935 16.311 8.38582C16.0369 8.27229 15.8026 8.08003 15.6378 7.83335C15.473 7.58668 15.385 7.29667 15.385 7C15.385 6.60218 15.543 6.22064 15.8243 5.93934C16.1057 5.65804 16.4872 5.5 16.885 5.5Z", fill: "currentColor" }),
  /* @__PURE__ */ d.jsx("path", { d: "M23.885 16C23.6198 16 23.3654 16.1054 23.1779 16.2929C22.9904 16.4804 22.885 16.7348 22.885 17V19C22.885 19.7957 22.5689 20.5587 22.0063 21.1213C21.4437 21.6839 20.6807 22 19.885 22H17.885C17.6198 22 17.3654 22.1054 17.1779 22.2929C16.9904 22.4804 16.885 22.7348 16.885 23C16.885 23.2652 16.9904 23.5196 17.1779 23.7071C17.3654 23.8946 17.6198 24 17.885 24H19.885C21.2106 23.9984 22.4815 23.4711 23.4188 22.5338C24.3561 21.5964 24.8834 20.3256 24.885 19V17C24.885 16.7348 24.7797 16.4804 24.5921 16.2929C24.4046 16.1054 24.1502 16 23.885 16Z", fill: "currentColor" }),
  /* @__PURE__ */ d.jsx("path", { d: "M1.88501 8C2.15023 8 2.40458 7.89464 2.59212 7.70711C2.77965 7.51957 2.88501 7.26522 2.88501 7V5C2.88501 4.20435 3.20108 3.44129 3.76369 2.87868C4.3263 2.31607 5.08936 2 5.88501 2H7.88501C8.15023 2 8.40458 1.89464 8.59212 1.70711C8.77965 1.51957 8.88501 1.26522 8.88501 1C8.88501 0.734784 8.77965 0.48043 8.59212 0.292893C8.40458 0.105357 8.15023 0 7.88501 0H5.88501C4.55941 0.00158786 3.28857 0.528882 2.35123 1.46622C1.41389 2.40356 0.886598 3.67441 0.88501 5V7C0.88501 7.26522 0.990367 7.51957 1.1779 7.70711C1.36544 7.89464 1.61979 8 1.88501 8Z", fill: "currentColor" }),
  /* @__PURE__ */ d.jsx("path", { d: "M7.88501 22H5.88501C5.08936 22 4.3263 21.6839 3.76369 21.1213C3.20108 20.5587 2.88501 19.7957 2.88501 19V17C2.88501 16.7348 2.77965 16.4804 2.59212 16.2929C2.40458 16.1054 2.15023 16 1.88501 16C1.61979 16 1.36544 16.1054 1.1779 16.2929C0.990367 16.4804 0.88501 16.7348 0.88501 17V19C0.886598 20.3256 1.41389 21.5964 2.35123 22.5338C3.28857 23.4711 4.55941 23.9984 5.88501 24H7.88501C8.15023 24 8.40458 23.8946 8.59212 23.7071C8.77965 23.5196 8.88501 23.2652 8.88501 23C8.88501 22.7348 8.77965 22.4804 8.59212 22.2929C8.40458 22.1054 8.15023 22 7.88501 22Z", fill: "currentColor" }),
  /* @__PURE__ */ d.jsx("path", { d: "M19.885 0H17.885C17.6198 0 17.3654 0.105357 17.1779 0.292893C16.9904 0.48043 16.885 0.734784 16.885 1C16.885 1.26522 16.9904 1.51957 17.1779 1.70711C17.3654 1.89464 17.6198 2 17.885 2H19.885C20.6807 2 21.4437 2.31607 22.0063 2.87868C22.5689 3.44129 22.885 4.20435 22.885 5V7C22.885 7.26522 22.9904 7.51957 23.1779 7.70711C23.3654 7.89464 23.6198 8 23.885 8C24.1502 8 24.4046 7.89464 24.5921 7.70711C24.7797 7.51957 24.885 7.26522 24.885 7V5C24.8834 3.67441 24.3561 2.40356 23.4188 1.46622C22.4815 0.528882 21.2106 0.00158786 19.885 0Z", fill: "currentColor" })
] }), zx = () => /* @__PURE__ */ d.jsx("svg", { className: "w-full", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ d.jsx(
  "path",
  {
    d: "M24.3294 22.7398L21.8994 15.5698C21.5834 14.6528 20.7924 14.0608 19.8814 14.0608C18.9704 14.0608 18.1794 14.6538 17.8634 15.5738L15.4344 22.7398C15.2574 23.2628 15.5374 23.8308 16.0604 24.0088C16.5844 24.1868 17.1504 23.9048 17.3284 23.3828L17.7974 21.9998H21.9654L22.4344 23.3828C22.5764 23.7988 22.9644 24.0618 23.3814 24.0618C23.4874 24.0618 23.5964 24.0448 23.7024 24.0088C24.2254 23.8308 24.5064 23.2638 24.3284 22.7398H24.3294ZM18.4754 19.9998L19.7564 16.2208C19.8314 15.9998 19.9334 16.0038 20.0064 16.2168L21.2884 19.9998H18.4754ZM16.5404 9.55077C16.0344 8.59677 15.0504 8.00377 13.9714 8.00377L10.1384 8.00077L11.3434 2.77377C11.6524 1.69577 11.2044 0.601772 10.2794 0.173772C9.3994 -0.233228 8.4144 0.087772 7.8064 0.999772L1.3874 11.4608C0.781404 12.3548 0.719404 13.5028 1.2244 14.4568C1.7294 15.4108 2.7144 16.0038 3.7944 16.0038H7.6244L6.4204 21.2298C6.1114 22.3088 6.5594 23.4018 7.4844 23.8298C7.7374 23.9468 7.9994 24.0038 8.2574 24.0038C8.8994 24.0038 9.5244 23.6538 9.9564 23.0038L16.3764 12.5468C16.9824 11.6528 17.0444 10.5048 16.5394 9.55177L16.5404 9.55077ZM14.6974 11.4608L8.3334 21.8258C8.3384 21.7968 9.8554 15.2278 9.8554 15.2278C9.9234 14.9308 9.8534 14.6198 9.6634 14.3798C9.4734 14.1418 9.1854 14.0028 8.8804 14.0028H3.7944C3.3004 14.0028 3.0684 13.6648 2.9914 13.5198C2.9144 13.3738 2.7644 12.9918 3.0664 12.5448L9.4304 2.17677C9.4254 2.20577 7.9084 8.77577 7.9084 8.77577C7.8404 9.07277 7.9104 9.38377 8.1004 9.62277C8.2904 9.86177 8.5784 10.0008 8.8824 10.0008L13.9704 10.0048C14.4644 10.0048 14.6964 10.3428 14.7734 10.4878C14.8504 10.6328 14.9994 11.0138 14.6974 11.4608Z",
    fill: "currentColor"
  }
) }), Ux = () => /* @__PURE__ */ d.jsxs("svg", { className: "w-full", viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ d.jsx("path", { d: "M12.3361 2.00028C13.6626 2.00463 14.9751 2.27201 16.1976 2.78696C17.4201 3.30191 18.5283 4.05419 19.4581 5.00028H16.3361C16.0709 5.00028 15.8166 5.10563 15.629 5.29317C15.4415 5.48071 15.3361 5.73506 15.3361 6.00028C15.3361 6.26549 15.4415 6.51985 15.629 6.70738C15.8166 6.89492 16.0709 7.00028 16.3361 7.00028H20.4791C20.9716 7.00001 21.4437 6.80428 21.7919 6.45608C22.1401 6.10788 22.3359 5.6357 22.3361 5.14328V1.00028C22.3361 0.735059 22.2308 0.480706 22.0432 0.293169C21.8557 0.105633 21.6014 0.000275954 21.3361 0.000275954C21.0709 0.000275954 20.8166 0.105633 20.629 0.293169C20.4415 0.480706 20.3361 0.735059 20.3361 1.00028V3.07828C18.6833 1.58973 16.6487 0.590686 14.4602 0.193025C12.2717 -0.204636 10.0158 0.0147879 7.94493 0.826723C5.87408 1.63866 4.07016 3.01105 2.73515 4.7902C1.40015 6.56935 0.586782 8.68502 0.38614 10.9003C0.373223 11.0395 0.389456 11.18 0.433803 11.3126C0.47815 11.4452 0.54964 11.5672 0.643716 11.6707C0.737793 11.7741 0.852394 11.8569 0.980218 11.9136C1.10804 11.9704 1.24629 11.9999 1.38614 12.0003C1.63073 12.0034 1.86767 11.9151 2.0506 11.7527C2.23352 11.5903 2.34925 11.3655 2.37514 11.1223C2.59775 8.63302 3.74311 6.31698 5.58622 4.62911C7.42933 2.94125 9.83696 2.00357 12.3361 2.00028Z", fill: "currentColor" }),
  /* @__PURE__ */ d.jsx("path", { d: "M23.2869 12.0003C23.0423 11.9972 22.8054 12.0855 22.6225 12.2479C22.4396 12.4103 22.3238 12.6351 22.2979 12.8783C22.1326 14.7816 21.4249 16.5974 20.2586 18.1105C19.0923 19.6236 17.5165 20.7704 15.7181 21.4149C13.9197 22.0593 11.9741 22.1744 10.1123 21.7464C8.25044 21.3184 6.55043 20.3654 5.21394 19.0003H8.33594C8.60115 19.0003 8.85551 18.895 9.04305 18.7074C9.23058 18.5199 9.33594 18.2655 9.33594 18.0003C9.33594 17.7351 9.23058 17.4808 9.04305 17.2932C8.85551 17.1057 8.60115 17.0003 8.33594 17.0003H4.19294C3.94904 17.0002 3.7075 17.0481 3.48214 17.1414C3.25678 17.2347 3.05201 17.3715 2.87955 17.5439C2.70708 17.7164 2.5703 17.9212 2.47703 18.1465C2.38375 18.3719 2.33581 18.6134 2.33594 18.8573V23.0003C2.33594 23.2655 2.44129 23.5199 2.62883 23.7074C2.81637 23.895 3.07072 24.0003 3.33594 24.0003C3.60115 24.0003 3.85551 23.895 4.04304 23.7074C4.23058 23.5199 4.33594 23.2655 4.33594 23.0003V20.9223C5.98877 22.4109 8.02335 23.4099 10.2118 23.8076C12.4003 24.2052 14.6563 23.9858 16.7272 23.1739C18.798 22.3619 20.6019 20.9896 21.9369 19.2104C23.2719 17.4312 24.0853 15.3156 24.2859 13.1003C24.2989 12.9611 24.2826 12.8206 24.2383 12.688C24.1939 12.5554 24.1224 12.4334 24.0284 12.3299C23.9343 12.2265 23.8197 12.1437 23.6919 12.087C23.564 12.0302 23.4268 12.0007 23.2869 12.0003Z", fill: "currentColor" }),
  /* @__PURE__ */ d.jsx("path", { d: "M12.3359 11.167C11.4151 11.167 10.6693 11.9128 10.6693 12.8336C10.6693 13.7545 11.4151 14.5003 12.3359 14.5003C13.2568 14.5003 14.0026 13.7545 14.0026 12.8336C14.0026 11.9128 13.2568 11.167 12.3359 11.167ZM14.8359 17.0003H9.83594C8.4576 17.0003 7.33594 15.8786 7.33594 14.5003V11.167C7.33594 9.80114 8.43677 8.68864 9.79677 8.6678L10.3768 7.76531C10.6834 7.28697 11.2076 7.00031 11.7784 7.00031H12.8934C13.4643 7.00031 13.9876 7.28697 14.2959 7.76614L14.8751 8.6678C16.2359 8.68864 17.3359 9.80114 17.3359 11.167V14.5003C17.3359 15.8786 16.2143 17.0003 14.8359 17.0003ZM15.6693 11.167C15.6693 10.707 15.2959 10.3336 14.8359 10.3336H9.83594C9.37594 10.3336 9.0026 10.707 9.0026 11.167V14.5003C9.0026 14.9603 9.37594 15.3336 9.83594 15.3336H14.8359C15.2959 15.3336 15.6693 14.9603 15.6693 14.5003V11.167Z", fill: "currentColor" })
] }), Zx = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsx(
      "path",
      {
        d: "M33.1018 6.06516C29.5133 2.47661 24.7418 0.5 19.667 0.5C14.5922 0.5 9.8207 2.47661 6.23215 6.06516C2.6436 9.65371 0.666992 14.4252 0.666992 19.5C0.666992 22.492 1.34323 25.3563 2.67527 28.0122C3.94602 30.5445 5.80619 32.801 8.0535 34.5386C8.16484 34.6244 8.29764 34.6663 8.42839 34.6663C8.61124 34.6663 8.79307 34.5846 8.91361 34.4283C9.12097 34.1606 9.07194 33.7755 8.80328 33.5682C4.57425 30.2983 2.0828 25.4206 1.90404 20.1129H17.4493C17.718 21.0854 18.6108 21.8015 19.668 21.8015C20.7253 21.8015 21.617 21.0854 21.8857 20.1129H37.43C37.2553 25.2664 34.8803 30.0501 30.8504 33.3159C30.5879 33.5294 30.547 33.9155 30.7605 34.178C30.974 34.4405 31.3591 34.4814 31.6227 34.2679C36.0999 30.6395 38.668 25.2562 38.668 19.5C38.668 14.4252 36.6914 9.65371 33.1029 6.06516H33.1018ZM37.4289 18.8871H30.9526C30.8658 17.2752 30.4408 15.7521 29.7462 14.3884L35.3532 11.1512C36.5933 13.4721 37.3339 16.0994 37.4289 18.8871ZM34.7383 10.0899L29.1302 13.3281C28.2722 12.0165 27.1495 10.8938 25.8379 10.0358L29.0761 4.42769C31.3653 5.86188 33.3051 7.80172 34.7393 10.0899H34.7383ZM14.5544 9.42081L11.3172 3.81376C13.6381 2.57366 16.2654 1.83306 19.0531 1.73806V8.21339C17.4411 8.30022 15.9181 8.72618 14.5544 9.42081ZM20.2799 1.73704C23.0676 1.83204 25.6949 2.57263 28.0158 3.81274L24.7776 9.42081C23.4139 8.72618 21.8908 8.30022 20.2789 8.21339V1.73704H20.2799ZM10.2569 4.42769L13.494 10.0358C12.1824 10.8938 11.0598 12.0165 10.2017 13.3281L4.59366 10.0899C6.02785 7.80172 7.96769 5.86188 10.2559 4.42769H10.2569ZM9.5878 14.3884C8.89318 15.7521 8.46721 17.2762 8.3814 18.8871H1.90404C1.99904 16.0994 2.73963 13.4721 3.97973 11.1512L9.58678 14.3884H9.5878ZM17.4493 18.8871H9.60925C9.92694 13.6151 14.3163 9.42285 19.668 9.42285C25.0197 9.42285 29.4081 13.6151 29.7258 18.8871H21.8857C21.8346 18.7022 21.7611 18.5275 21.6691 18.3651L24.1831 15.8512C24.4221 15.6122 24.4221 15.224 24.1831 14.9849C23.944 14.7459 23.5559 14.7459 23.3168 14.9849L20.8029 17.4989C20.4679 17.3078 20.0807 17.1985 19.669 17.1985C18.6118 17.1985 17.72 17.9146 17.4503 18.8871H17.4493ZM19.668 20.5756C19.0745 20.5756 18.5924 20.0925 18.5924 19.5C18.5924 18.9075 19.0745 18.4244 19.668 18.4244C20.2615 18.4244 20.7437 18.9065 20.7437 19.5C20.7437 20.0935 20.2615 20.5756 19.668 20.5756ZM18.4963 28.5475H15.7618C15.4237 28.5475 15.1489 28.8212 15.1489 29.1604V37.8871C15.1489 38.2252 15.4237 38.5 15.7618 38.5H18.4963C18.8345 38.5 19.1092 38.2252 19.1092 37.8871V29.1604C19.1092 28.8212 18.8345 28.5475 18.4963 28.5475ZM17.8834 37.2742H16.3747V29.7733H17.8834V37.2742ZM23.5732 29.6865H20.8397C20.5005 29.6865 20.2268 29.9612 20.2268 30.2994V37.8871C20.2268 38.2252 20.5005 38.5 20.8397 38.5H23.5732C23.9113 38.5 24.1861 38.2252 24.1861 37.8871V30.2994C24.1861 29.9612 23.9113 29.6865 23.5732 29.6865ZM22.9603 37.2742H21.4526V30.9123H22.9603V37.2742ZM28.6501 24.961H25.9155C25.5774 24.961 25.3026 25.2358 25.3026 25.5739V37.8871C25.3026 38.2252 25.5774 38.5 25.9155 38.5H28.6501C28.9893 38.5 29.263 38.2252 29.263 37.8871V25.5739C29.263 25.2358 28.9893 24.961 28.6501 24.961ZM28.0372 37.2742H26.5284V26.1868H28.0372V37.2742ZM13.4195 31.9327H10.6849C10.3468 31.9327 10.072 32.2075 10.072 32.5456V37.8871C10.072 38.2252 10.3468 38.5 10.6849 38.5H13.4195C13.7586 38.5 14.0324 38.2252 14.0324 37.8871V32.5456C14.0324 32.2075 13.7586 31.9327 13.4195 31.9327ZM12.8066 37.2742H11.2978V33.1585H12.8066V37.2742ZM22.0216 25.7608L25.652 22.0997C25.3261 22.111 25.0483 21.8689 25.0197 21.542C24.9901 21.2049 25.2393 20.9066 25.5764 20.878L27.2292 20.733C27.412 20.7166 27.5929 20.784 27.7216 20.9158C27.8493 21.0476 27.9126 21.2294 27.8922 21.4123L27.7083 23.061C27.6736 23.3746 27.408 23.6054 27.1005 23.6054C27.078 23.6054 27.0545 23.6044 27.031 23.6013C26.7205 23.5666 26.4906 23.3041 26.4866 22.9997L22.6273 26.8926C22.4649 27.0571 22.2228 27.1153 22.0032 27.0438L17.2501 25.5024L12.4296 29.2554C12.3173 29.3422 12.1855 29.3851 12.0537 29.3851C11.8709 29.3851 11.6901 29.3044 11.5695 29.1491C11.3622 28.8815 11.4091 28.4964 11.6768 28.289L16.7537 24.3358C16.914 24.2112 17.1255 24.1734 17.3196 24.2367L22.0226 25.7628L22.0216 25.7608Z",
        fill: "currentColor"
      }
    )
  }
), qx = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsxs("g", { "clip-path": "url(#clip0_2383_69933)", children: [
      /* @__PURE__ */ d.jsx("path", { d: "M30.0156 7.9375C27.8143 7.9375 26.0312 9.72051 26.0312 11.9219V13.25H21.2294C22.8298 10.5134 23.6406 8.46078 23.6406 7.14062C23.6406 3.47898 20.6616 0.5 17 0.5C13.3384 0.5 10.3594 3.47898 10.3594 7.14062C10.3594 8.46078 11.1702 10.5134 12.7706 13.25H7.96875V11.9219C7.96875 9.72449 6.18176 7.9375 3.98438 7.9375C1.78699 7.9375 0 9.72051 0 11.9219V15.6406C0 16.0072 0.2975 16.3047 0.664062 16.3047C1.03062 16.3047 1.32812 16.0072 1.32812 15.6406V11.9219C1.32812 10.455 2.5168 9.26562 3.98438 9.26562C5.45195 9.26562 6.64062 10.4576 6.64062 11.9219V27.5486C5.93539 26.9164 5.00371 26.5312 3.98438 26.5312C2.96504 26.5312 2.03336 26.9171 1.32812 27.5493V20.9531C1.32812 20.5866 1.03062 20.2891 0.664062 20.2891C0.2975 20.2891 0 20.5866 0 20.9531V30.5156C0 32.794 1.96695 34.5 4.17363 34.5H30.0156C32.213 34.5 34 32.713 34 30.5156V11.9219C34 9.72449 32.213 7.9375 30.0156 7.9375ZM27.3594 11.9219C27.3594 10.455 28.548 9.26562 30.0156 9.26562C31.4832 9.26562 32.6719 10.4576 32.6719 11.9219V27.53C32.215 27.1236 31.6658 26.8208 31.0662 26.6667C29.7354 26.3227 28.3661 26.6468 27.3594 27.5453V11.9219ZM26.0312 21.2188H17.5312C15.306 19.0997 11.0553 15.0516 10.5586 14.5781H13.5754C15.0251 16.8944 16.4535 18.8075 16.4681 18.8275C16.5936 18.9948 16.7908 19.0938 17 19.0938C17.2092 19.0938 17.4064 18.9955 17.5319 18.8275C17.5465 18.8075 18.9749 16.8937 20.4246 14.5781H26.0312V21.2188ZM17 1.82812C19.9292 1.82812 22.3125 4.21145 22.3125 7.14062C22.3125 9.60629 18.4231 15.3079 17 17.3001C15.5543 15.2761 11.6875 9.58371 11.6875 7.14062C11.6875 4.21145 14.0708 1.82812 17 1.82812ZM1.32812 30.5156C1.32812 29.0514 2.51945 27.8594 3.98438 27.8594C5.4493 27.8594 6.64062 29.0514 6.64062 30.5156C6.64062 30.8822 6.93813 31.1797 7.30469 31.1797C7.67125 31.1797 7.96875 30.8822 7.96875 30.5156V19.4477L14.709 25.8672L7.03906 33.1719H4.17363C2.68414 33.1719 1.32812 32.0589 1.32812 30.5156ZM16.1294 26.348C16.2609 26.2225 16.3359 26.0485 16.3359 25.8672C16.3359 25.6859 16.2616 25.5113 16.1294 25.3864L7.96875 17.6142V14.5781H8.63281C8.67797 14.6213 16.4913 22.0628 16.8074 22.3636C16.9309 22.4811 17.095 22.5469 17.265 22.5469H26.0306V25.2031H20.9837C20.8077 25.2031 20.6384 25.2729 20.5142 25.3977L12.7394 33.1719H8.96418L16.1287 26.348H16.1294ZM30.0156 33.1719H14.6187L21.2593 26.5312H26.0312V30.5156C26.0312 30.8822 26.3288 31.1797 26.6953 31.1797C27.0619 31.1797 27.3594 30.8822 27.3594 30.5156C27.3594 28.7984 28.9677 27.4961 30.7341 27.9523C31.8126 28.2312 32.6719 29.2267 32.6719 30.5156C32.6719 31.9805 31.4799 33.1719 30.0156 33.1719Z", fill: "currentColor" }),
      /* @__PURE__ */ d.jsx("path", { d: "M17 10.4609C18.8308 10.4609 20.3203 8.97145 20.3203 7.14062C20.3203 5.3098 18.8308 3.82031 17 3.82031C15.1692 3.82031 13.6797 5.3098 13.6797 7.14062C13.6797 8.97145 15.1692 10.4609 17 10.4609ZM17 5.14844C18.0984 5.14844 18.9922 6.04227 18.9922 7.14062C18.9922 8.23898 18.0984 9.13281 17 9.13281C15.9016 9.13281 15.0078 8.23898 15.0078 7.14062C15.0078 6.04227 15.9016 5.14844 17 5.14844Z", fill: "currentColor" }),
      /* @__PURE__ */ d.jsx("path", { d: "M0.664062 18.9609C1.03062 18.9609 1.32812 18.6634 1.32812 18.2969C1.32812 17.9303 1.03062 17.6328 0.664062 17.6328C0.2975 17.6328 0 17.9303 0 18.2969C0 18.6634 0.2975 18.9609 0.664062 18.9609Z", fill: "currentColor" })
    ] })
  }
), Gx = () => /* @__PURE__ */ d.jsx("svg", { viewBox: "0 0 40 41", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ d.jsxs("g", { "clip-path": "url(#clip0_106_18)", children: [
  /* @__PURE__ */ d.jsx("path", { d: "M13.75 24.3719C13.94 26.8166 15.825 28.7205 19.205 28.946V30.75H20.705V28.9332C24.205 28.6821 26.25 26.7653 26.25 23.9824C26.25 21.4533 24.685 20.1489 21.8875 19.4724L20.705 19.1854V14.2731C22.205 14.4474 23.16 15.2879 23.39 16.4513H26.02C25.83 14.0963 23.86 12.2539 20.705 12.054V10.25H19.205V12.0924C16.2175 12.3922 14.18 14.2347 14.18 16.8408C14.18 19.147 15.695 20.6128 18.2125 21.2149L19.205 21.4661V26.6782C17.6675 26.4399 16.65 25.5763 16.42 24.3719H13.75ZM19.1925 18.8216C17.7175 18.4705 16.9175 17.7556 16.9175 16.6793C16.9175 15.4749 17.78 14.5729 19.205 14.309V18.819L19.1925 18.8216ZM20.9225 21.8786C22.715 22.304 23.5425 22.9933 23.5425 24.2105C23.5425 25.5994 22.5125 26.5526 20.705 26.7269V21.8274L20.9225 21.8786Z", fill: "currentColor" }),
  /* @__PURE__ */ d.jsx("path", { d: "M20 38.4375C15.3587 38.4375 10.9075 36.5477 7.62563 33.1837C4.34374 29.8198 2.5 25.2573 2.5 20.5C2.5 15.7427 4.34374 11.1802 7.62563 7.81627C10.9075 4.45234 15.3587 2.5625 20 2.5625C24.6413 2.5625 29.0925 4.45234 32.3744 7.81627C35.6563 11.1802 37.5 15.7427 37.5 20.5C37.5 25.2573 35.6563 29.8198 32.3744 33.1837C29.0925 36.5477 24.6413 38.4375 20 38.4375ZM20 41C25.3043 41 30.3914 38.8402 34.1421 34.9957C37.8929 31.1512 40 25.9369 40 20.5C40 15.0631 37.8929 9.84881 34.1421 6.00431C30.3914 2.15982 25.3043 0 20 0C14.6957 0 9.60859 2.15982 5.85786 6.00431C2.10714 9.84881 0 15.0631 0 20.5C0 25.9369 2.10714 31.1512 5.85786 34.9957C9.60859 38.8402 14.6957 41 20 41Z", fill: "currentColor" }),
  /* @__PURE__ */ d.jsx("path", { d: "M20 34.5938C16.3533 34.5938 12.8559 33.1089 10.2773 30.4658C7.69866 27.8227 6.25 24.2379 6.25 20.5C6.25 16.7621 7.69866 13.1773 10.2773 10.5342C12.8559 7.89112 16.3533 6.40625 20 6.40625C23.6467 6.40625 27.1441 7.89112 29.7227 10.5342C32.3013 13.1773 33.75 16.7621 33.75 20.5C33.75 24.2379 32.3013 27.8227 29.7227 30.4658C27.1441 33.1089 23.6467 34.5938 20 34.5938ZM20 35.875C21.9698 35.875 23.9204 35.4773 25.7403 34.7046C27.5601 33.932 29.2137 32.7995 30.6066 31.3718C31.9995 29.9441 33.1044 28.2491 33.8582 26.3838C34.612 24.5184 35 22.5191 35 20.5C35 18.4809 34.612 16.4816 33.8582 14.6162C33.1044 12.7509 31.9995 11.0559 30.6066 9.62823C29.2137 8.20053 27.5601 7.06802 25.7403 6.29535C23.9204 5.52269 21.9698 5.125 20 5.125C16.0218 5.125 12.2064 6.74486 9.3934 9.62823C6.58035 12.5116 5 16.4223 5 20.5C5 24.5777 6.58035 28.4884 9.3934 31.3718C12.2064 34.2551 16.0218 35.875 20 35.875Z", fill: "currentColor" })
] }) }), Yx = () => /* @__PURE__ */ d.jsxs("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ d.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M39.6339 0.366153C39.9874 0.719731 40.0963 1.25 39.9106 1.71427L32.9106 19.2143C32.6542 19.8553 31.9267 20.167 31.2857 19.9106C30.6448 19.6542 30.333 18.9268 30.5894 18.2858L35.3277 6.44013L16.5929 25.1749L20.0318 30.5789C20.4025 31.1614 20.2308 31.934 19.6484 32.3046C19.0659 32.6752 18.2933 32.5036 17.9227 31.9211L14.0945 25.9055L1.6077 17.9593C0.318659 17.139 0.499343 15.204 1.91798 14.6365L38.2857 0.0894406C38.75 -0.0962678 39.2803 0.0125747 39.6339 0.366153ZM14.8251 23.4071L33.5599 4.67237L3.97869 16.5048L14.8251 23.4071Z", fill: "currentColor" }),
  /* @__PURE__ */ d.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M31.25 40C36.0825 40 40 36.0825 40 31.25C40 26.4175 36.0825 22.5 31.25 22.5C26.4175 22.5 22.5 26.4175 22.5 31.25C22.5 36.0825 26.4175 40 31.25 40ZM32.1339 26.6161C31.893 26.3752 31.5642 26.2431 31.2236 26.2503C30.8829 26.2575 30.56 26.4034 30.3295 26.6543L27.4584 29.7793C26.9914 30.2877 27.0248 31.0784 27.5332 31.5455C28.0416 32.0126 28.8323 31.9791 29.2994 31.4707L30 30.7081V35C30 35.6904 30.5596 36.25 31.25 36.25C31.9404 36.25 32.5 35.6904 32.5 35V30.5178L33.4911 31.5089C33.9793 31.997 34.7707 31.997 35.2589 31.5089C35.747 31.0207 35.747 30.2293 35.2589 29.7411L32.1339 26.6161Z", fill: "currentColor" })
] }), Kx = () => /* @__PURE__ */ d.jsx("svg", { viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ d.jsx("path", { d: "M7.78684 24.0628C5.97659 24.0616 4.22784 23.4057 2.86329 22.2162C1.49874 21.0267 0.610474 19.3837 0.362401 17.5906C0.114327 15.7974 0.523189 13.975 1.51354 12.4597C2.50389 10.9443 4.00889 9.83835 5.75084 9.34576C7.01696 8.98319 8.35713 8.96661 9.63184 9.29776L17.5398 1.39176C17.9596 0.969046 18.4592 0.633898 19.0096 0.405759C19.5599 0.177621 20.1501 0.0610343 20.7458 0.0627631C21.6834 0.0635575 22.5823 0.436354 23.2453 1.09931C23.9082 1.76227 24.281 2.6612 24.2818 3.59876C24.2834 4.19455 24.1668 4.78474 23.9389 5.3352C23.7109 5.88567 23.3761 6.38549 22.9538 6.80576L22.2818 7.47776C21.9058 7.8512 21.3978 8.06139 20.8678 8.06276H19.2818V9.06276C19.2818 9.5932 19.0711 10.1019 18.6961 10.477C18.321 10.852 17.8123 11.0628 17.2818 11.0628H16.2818V12.6488C16.2825 12.9115 16.2311 13.1718 16.1305 13.4145C16.0299 13.6572 15.8822 13.8776 15.6958 14.0628L15.0458 14.7128C15.3788 15.9869 15.3626 17.3271 14.9988 18.5928C14.5896 20.0348 13.7591 21.3218 12.614 22.289C11.4688 23.2562 10.061 23.8595 8.57084 24.0218C8.31038 24.0488 8.0487 24.0625 7.78684 24.0628ZM7.78684 11.0628C6.76299 11.0618 5.75918 11.3466 4.88842 11.8851C4.01767 12.4237 3.31452 13.1946 2.85814 14.1111C2.40176 15.0277 2.21027 16.0534 2.30521 17.0728C2.40016 18.0922 2.77778 19.0649 3.39556 19.8814C4.01334 20.6979 4.84676 21.3257 5.80199 21.6942C6.75723 22.0627 7.79637 22.1572 8.80243 21.9672C9.80848 21.7771 10.7415 21.31 11.4965 20.6185C12.2515 19.9269 12.7985 19.0383 13.0758 18.0528C13.3878 16.9693 13.3529 15.8153 12.9758 14.7528C12.9143 14.5753 12.904 14.3841 12.9461 14.2011C12.9882 14.018 13.081 13.8505 13.2138 13.7178L14.2818 12.6488V11.0628C14.2818 10.5323 14.4926 10.0236 14.8676 9.64855C15.2427 9.27348 15.7514 9.06276 16.2818 9.06276H17.2818V8.06276C17.2818 7.53233 17.4926 7.02362 17.8676 6.64855C18.2427 6.27348 18.7514 6.06276 19.2818 6.06276H20.8678L21.5398 5.39076C21.7758 5.15592 21.9629 4.87663 22.0902 4.56904C22.2176 4.26145 22.2827 3.93167 22.2818 3.59876C22.2816 3.19164 22.1198 2.80126 21.832 2.51329C21.5442 2.22532 21.154 2.06329 20.7468 2.06276C20.4137 2.06194 20.0837 2.12719 19.7759 2.25472C19.4682 2.38226 19.1888 2.56955 18.9538 2.80576L10.6228 11.1358C10.4899 11.2686 10.3222 11.3614 10.1389 11.4033C9.95569 11.4452 9.76434 11.4346 9.58684 11.3728C9.00691 11.1686 8.39666 11.0638 7.78184 11.0628H7.78684ZM5.28184 18.0628C5.28184 18.2605 5.34049 18.4539 5.45037 18.6183C5.56025 18.7828 5.71643 18.911 5.89915 18.9866C6.08188 19.0623 6.28295 19.0821 6.47693 19.0435C6.67091 19.005 6.84909 18.9097 6.98894 18.7699C7.1288 18.63 7.22404 18.4518 7.26262 18.2579C7.30121 18.0639 7.2814 17.8628 7.20572 17.6801C7.13003 17.4974 7.00186 17.3412 6.83741 17.2313C6.67296 17.1214 6.47962 17.0628 6.28184 17.0628C6.01662 17.0628 5.76227 17.1681 5.57473 17.3557C5.3872 17.5432 5.28184 17.7975 5.28184 18.0628Z", fill: "currentColor" }) }), Xx = () => /* @__PURE__ */ d.jsxs("svg", { viewBox: "0 0 25 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ d.jsx("path", { d: "M16.1462 0.0727539H9.82088C4.94887 0.0727539 0.984497 4.02038 0.984497 8.87182C0.984497 13.7233 4.94887 17.6709 9.82088 17.6709H10.8279C11.4486 17.6709 11.9531 17.1686 11.9531 16.5505V8.94091C11.9531 8.32281 11.4486 7.82049 10.8279 7.82049H7.07545C6.45473 7.82049 5.95027 8.32281 5.95027 8.94091C5.95027 9.55901 6.45473 10.0613 7.07545 10.0613H9.70273V15.43C6.12467 15.3665 3.23485 12.4497 3.23485 8.87182C3.23485 5.29393 6.19031 2.3136 9.82088 2.3136H16.1462C19.7787 2.3136 22.7323 5.25658 22.7323 8.87182C22.7323 12.4871 19.8424 15.3647 16.2663 15.43V10.0613H18.8935C19.5143 10.0613 20.0187 9.55901 20.0187 8.94091C20.0187 8.32281 19.5143 7.82049 18.8935 7.82049H15.1411C14.5204 7.82049 14.0159 8.32281 14.0159 8.94091V16.5505C14.0159 17.1686 14.5204 17.6709 15.1411 17.6709H16.1444C21.0164 17.6709 24.9807 13.7233 24.9807 8.87182C24.9807 4.02038 21.0201 0.0727539 16.1462 0.0727539Z", fill: "currentColor" }),
  /* @__PURE__ */ d.jsx("path", { d: "M10.8279 7.82236H7.07545C6.45473 7.82236 5.95027 8.32468 5.95027 8.94278C5.95027 9.56088 6.45473 10.0632 7.07545 10.0632H9.70273V12.6383C10.4266 12.8437 11.1786 12.9838 11.9531 13.0491V8.94091C11.9531 8.32281 11.4486 7.82049 10.8279 7.82049V7.82236Z", fill: "currentColor" }),
  /* @__PURE__ */ d.jsx("path", { d: "M18.8954 7.82236H15.143C14.5222 7.82236 14.0178 8.32468 14.0178 8.94278V13.0529C14.7904 12.9875 15.5424 12.8512 16.2681 12.6476V10.0632H18.8954C19.5161 10.0632 20.0206 9.56088 20.0206 8.94278C20.0206 8.32468 19.5161 7.82236 18.8954 7.82236Z", fill: "currentColor" }),
  /* @__PURE__ */ d.jsx("path", { d: "M16.1462 0.0727539H9.82088C6.21844 0.0727539 3.11295 2.23331 1.74024 5.32008C2.1228 6.33966 2.64226 7.29389 3.27611 8.15848C3.63429 4.87564 6.4341 2.3136 9.82275 2.3136H16.1481C19.5518 2.3136 22.3591 4.89618 22.7004 8.1977C23.338 7.3331 23.8612 6.37888 24.2475 5.35742C22.8804 2.25011 19.7656 0.0727539 16.1462 0.0727539Z", fill: "currentColor" })
] }), Qx = () => /* @__PURE__ */ d.jsx("svg", { viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ d.jsx("path", { d: "M12.9835 24.0728C11.3665 24.0728 9.84748 23.3648 8.80748 22.1528C7.22048 22.2768 5.64148 21.7018 4.49748 20.5578C3.35348 19.4128 2.78048 17.8388 2.90248 16.2478C1.69048 15.2088 0.982483 13.6898 0.982483 12.0728C0.982483 10.4558 1.69048 8.93675 2.90248 7.89775C2.78048 6.30675 3.35348 4.73175 4.49748 3.58775C5.64148 2.44475 7.22048 1.87575 8.80748 1.99275C9.84748 0.780754 11.3665 0.0727539 12.9835 0.0727539C14.6005 0.0727539 16.1195 0.780754 17.1595 1.99275C18.7465 1.87375 20.3265 2.44475 21.4695 3.58775C22.6135 4.73275 23.1865 6.30675 23.0645 7.89775C24.2765 8.93675 24.9845 10.4558 24.9845 12.0728C24.9845 13.6898 24.2765 15.2088 23.0645 16.2478C23.1865 17.8388 22.6135 19.4138 21.4695 20.5578C20.3265 21.7018 18.7475 22.2768 17.1595 22.1528C16.1195 23.3648 14.6005 24.0728 12.9835 24.0728ZM9.70948 19.9778L10.0795 20.5268C10.7325 21.4948 11.8185 22.0728 12.9835 22.0728C14.1485 22.0728 15.2345 21.4948 15.8875 20.5268L16.2575 19.9778L16.9065 20.1038C18.0545 20.3268 19.2295 19.9678 20.0535 19.1438C20.8775 18.3188 21.2365 17.1428 21.0135 15.9978L20.8865 15.3478L21.4365 14.9778C22.4045 14.3248 22.9825 13.2388 22.9825 12.0738C22.9825 10.9088 22.4045 9.82275 21.4365 9.16975L20.8865 8.79975L21.0135 8.14975C21.2365 7.00475 20.8775 5.82775 20.0535 5.00375C19.2295 4.17975 18.0535 3.82175 16.9065 4.04375L16.2575 4.16975L15.8875 3.62075C15.2345 2.65275 14.1485 2.07475 12.9835 2.07475C11.8185 2.07475 10.7325 2.65275 10.0795 3.62075L9.70948 4.16975L9.06048 4.04375C7.91348 3.82375 6.73748 4.17975 5.91348 5.00375C5.08948 5.82875 4.73048 7.00475 4.95348 8.14975L5.08048 8.79975L4.53048 9.16975C3.56248 9.82275 2.98448 10.9088 2.98448 12.0738C2.98448 13.2388 3.56248 14.3248 4.53048 14.9778L5.08048 15.3478L4.95348 15.9978C4.73048 17.1428 5.08948 18.3198 5.91348 19.1438C6.73748 19.9668 7.91148 20.3258 9.06048 20.1038L9.70948 19.9778ZM12.8935 15.4928L18.6865 9.78575L17.2825 8.36075L11.4735 14.0618L8.68048 11.3548L7.28748 12.7918L10.0695 15.4878C10.4605 15.8788 10.9725 16.0728 11.4855 16.0728C11.9985 16.0728 12.5075 15.8798 12.8935 15.4928Z", fill: "currentColor" }) }), Jx = () => /* @__PURE__ */ d.jsx("svg", { viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ d.jsx("g", { "clip-path": "url(#clip0_135_74)", children: /* @__PURE__ */ d.jsx("path", { d: "M22.853 1.22522C22.1732 0.546421 21.2517 0.165161 20.291 0.165161C19.3303 0.165161 18.4089 0.546421 17.729 1.22522L1.46502 17.4892C0.999266 17.9524 0.629977 18.5032 0.378513 19.11C0.127049 19.7168 -0.00159798 20.3674 1.49812e-05 21.0242V23.0772C1.49812e-05 23.3424 0.105372 23.5968 0.292908 23.7843C0.480445 23.9719 0.734799 24.0772 1.00002 24.0772H3.05301C3.70978 24.0791 4.36038 23.9506 4.96717 23.6993C5.57396 23.448 6.12487 23.0789 6.58801 22.6132L22.853 6.34822C23.5315 5.66842 23.9126 4.74719 23.9126 3.78672C23.9126 2.82626 23.5315 1.90503 22.853 1.22522ZM5.17401 21.1992C4.61002 21.7595 3.84798 22.0749 3.05301 22.0772H2.00002V21.0242C1.999 20.6301 2.07617 20.2397 2.22705 19.8757C2.37793 19.5116 2.59953 19.1811 2.87901 18.9032L15.222 6.56022L17.522 8.86022L5.17401 21.1992ZM21.438 4.93422L18.932 7.44122L16.632 5.14622L19.139 2.63922C19.29 2.48853 19.4693 2.36906 19.6664 2.28763C19.8636 2.20621 20.0749 2.16441 20.2883 2.16465C20.5016 2.16488 20.7128 2.20713 20.9098 2.28899C21.1069 2.37084 21.2858 2.4907 21.4365 2.64172C21.5872 2.79274 21.7067 2.97197 21.7881 3.16916C21.8695 3.36635 21.9113 3.57765 21.9111 3.79099C21.9109 4.00433 21.8686 4.21554 21.7868 4.41256C21.7049 4.60957 21.585 4.78853 21.434 4.93922L21.438 4.93422Z", fill: "currentColor" }) }) }), ew = () => /* @__PURE__ */ d.jsxs("svg", { viewBox: "0 0 41 41", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ d.jsx("path", { d: "M2.74817 40.0772H33.0565C38.8752 40.0772 42.676 34.2334 40.0703 29.2671L36.3479 22.1537C27.8843 31.5075 16.1097 38.0421 2.74817 40.0772Z", fill: "#204585" }),
  /* @__PURE__ */ d.jsx("path", { d: "M26.7877 3.95137L25.5338 1.56156C24.4955 -0.417493 21.5371 -0.417493 20.4988 1.56156L5.21725 30.706C15.209 24.3767 22.889 14.9855 26.7877 3.95137Z", fill: "#F15C41" }),
  /* @__PURE__ */ d.jsx("path", { d: "M35.6623 20.8473L27.6885 5.64966C23.2803 17.1506 14.8363 26.8032 4.0021 33.0577L0.906616 38.9762C14.7971 37.2772 27.0811 30.5932 35.6819 20.866L35.6623 20.8473Z", fill: "#2875B4" })
] }), tw = () => /* @__PURE__ */ d.jsx("svg", { viewBox: "0 0 79 61", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ d.jsxs("g", { children: [
  /* @__PURE__ */ d.jsx("path", { d: "M58.1699 46.1411H39.6543V57.0898H58.1699V46.1411Z", fill: "#293939" }),
  /* @__PURE__ */ d.jsx("path", { d: "M25.459 61.0001H2.31445C1.03533 61.0001 0 59.9506 0 58.6539V7.03854C0 5.7419 1.03533 4.69238 2.31445 4.69238H25.459C26.7366 4.69238 27.7734 5.7419 27.7734 7.03854V58.6539C27.7734 59.9506 26.7366 61.0001 25.459 61.0001Z", fill: "#3E5959" }),
  /* @__PURE__ */ d.jsx("path", { d: "M27.7734 7.03854V58.6539C27.7734 59.949 26.7366 61.0001 25.459 61.0001H13.8867V4.69238H25.459C26.7366 4.69238 27.7734 5.74346 27.7734 7.03854Z", fill: "#293939" }),
  /* @__PURE__ */ d.jsx("path", { d: "M27.7734 16.4231H0V25.8077H27.7734V16.4231Z", fill: "#547983" }),
  /* @__PURE__ */ d.jsx("path", { d: "M27.7734 16.4231H13.8867V25.8077H27.7734V16.4231Z", fill: "#3E5959" }),
  /* @__PURE__ */ d.jsx("path", { d: "M16.2012 54.4309C16.2012 55.7275 15.1658 56.777 13.8867 56.777C12.6076 56.777 11.5723 55.7275 11.5723 54.4309C11.5723 53.1342 12.6076 52.0847 13.8867 52.0847C15.1658 52.0847 16.2012 53.1342 16.2012 54.4309Z", fill: "#81E885" }),
  /* @__PURE__ */ d.jsx("mask", { id: "mask0_168_181", maskUnits: "userSpaceOnUse", x: "0", y: "0", width: "79", height: "61", children: /* @__PURE__ */ d.jsx("path", { d: "M79 0H0V61H79V0Z", fill: "white" }) }),
  /* @__PURE__ */ d.jsxs("g", { mask: "url(#mask0_168_181)", children: [
    /* @__PURE__ */ d.jsx("path", { d: "M16.2012 54.4309C16.2012 55.7259 15.1643 56.777 13.8867 56.777V52.0847C15.1643 52.0847 16.2012 53.1358 16.2012 54.4309Z", fill: "#5DC983" }),
    /* @__PURE__ */ d.jsx("path", { d: "M74.3711 46.9231H23.4531C20.9011 46.9231 18.8242 44.8178 18.8242 42.2308V4.69231C18.8242 2.10528 20.9011 0 23.4531 0H74.3711C76.9232 0 79 2.10528 79 4.69231V42.2308C79 44.8178 76.9232 46.9231 74.3711 46.9231Z", fill: "#547983" })
  ] }),
  /* @__PURE__ */ d.jsx("path", { d: "M74.3711 4.69238H23.4531V42.2308H74.3711V4.69238Z", fill: "#F3765F" }),
  /* @__PURE__ */ d.jsx("path", { d: "M62.7988 60.9999H35.0254C33.7463 60.9999 32.7109 59.9504 32.7109 58.6538C32.7109 57.3571 33.7463 56.3076 35.0254 56.3076H62.7988C64.0779 56.3076 65.1133 57.3571 65.1133 58.6538C65.1133 59.9504 64.0779 60.9999 62.7988 60.9999Z", fill: "#547983" }),
  /* @__PURE__ */ d.jsx("path", { opacity: "0.15", d: "M54.9991 42.2308H51.3747L31.5984 4.69238H35.2229L54.9991 42.2308Z", fill: "white" }),
  /* @__PURE__ */ d.jsx("path", { opacity: "0.15", d: "M62.7989 42.2308H59.1744L39.3982 4.69238H43.0226L62.7989 42.2308Z", fill: "white" })
] }) }), rw = () => /* @__PURE__ */ d.jsx("svg", { viewBox: "0 0 42 42", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ d.jsx("path", { d: "M21 0C9.40202 0 0 9.40202 0 21C0 32.598 9.40202 42 21 42C32.598 42 42 32.598 42 21C42 9.40202 32.598 0 21 0ZM5.3561 11.3562C6.20942 14.844 12.0011 18.0215 15.1108 19.7276C16.3725 20.4198 17.1927 20.8698 17.0625 21C16.8507 21.2119 16.6365 21.4157 16.4266 21.6155C15.3363 22.6534 14.3626 23.5803 14.4375 24.9375C14.5294 26.6027 16.0592 27.0996 17.6248 27.6081C19.1402 28.1004 20.6891 28.6035 21 30.1875C21.2151 31.2833 20.8043 32.7813 20.4218 34.1768C19.8586 36.2308 19.3564 38.0625 21 38.0625C24.9375 36.75 30.9708 29.7003 31.5 24.9375C31.8624 21.6756 26.25 19.6875 22.3125 18.375C21.0578 17.9568 20.3293 18.5878 19.713 19.1217C19.2611 19.5131 18.8695 19.8524 18.375 19.6875C17.2061 19.2979 11.8125 14.4375 14.4375 13.125C16.487 12.1003 16.9363 12.6757 17.6596 13.602C17.8626 13.8621 18.0873 14.1498 18.375 14.4375C19.9723 15.2362 20.1117 14.0909 20.2717 12.7761C20.3746 11.9301 20.4861 11.0139 21 10.5C22.1383 9.36176 24.3201 8.42297 26.3227 7.56133C28.1932 6.75649 29.9073 6.01896 30.4683 5.24905C35.8054 8.46421 39.375 14.3152 39.375 21C39.375 31.1482 31.1482 39.375 21 39.375C10.8518 39.375 2.625 31.1482 2.625 21C2.625 17.463 3.62435 14.1594 5.3561 11.3562Z", fill: "currentColor" }) }), nw = () => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 54 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ d.jsx("path", { d: "M46.5542 12.7677L44.7664 13.0693C43.8107 13.2328 42.8286 13.1168 41.9394 12.7338L41.8089 12.6774C40.0076 11.8991 37.9453 11.9857 36.2097 12.9139L29.9367 16.2493L17.5845 15.6324C17.4547 15.6257 17.3246 15.6543 17.2093 15.7156L14.0342 17.4039C13.777 17.5406 13.6281 17.8172 13.6552 18.1056C13.6823 18.3941 13.8819 18.6368 14.1593 18.7218L21.2433 20.8717L13.5902 24.941L4.81596 20.2326C4.60383 20.1196 4.34881 20.12 4.13607 20.2331L1.59598 21.5837C1.39171 21.6923 1.25227 21.8922 1.2201 22.1202C1.18743 22.3499 1.26833 22.5786 1.43546 22.7372L7.29022 28.2921L6.8637 28.5188C6.03499 28.9595 5.5939 29.8917 5.78195 30.8071C5.96951 31.7241 6.7398 32.4042 7.67434 32.4792L8.96799 32.5837L8.61643 36.0588C8.58938 36.3219 8.71 36.5769 8.92936 36.7239C9.14872 36.8709 9.43194 36.8853 9.6664 36.762L10.9364 36.0867C11.074 36.0135 11.1839 35.8983 11.2502 35.7576L14.3128 29.2618C14.445 28.982 14.3826 28.6501 14.1585 28.438C13.9344 28.2259 13.5996 28.1809 13.3265 28.3261L9.51636 30.3519C9.30468 30.4645 9.16175 30.6757 9.13787 30.9142L9.11299 31.1559L7.79455 31.0457C7.49819 31.0194 7.25361 30.802 7.19431 30.5117C7.13445 30.2204 7.27326 29.9249 7.53567 29.7826L36.8833 14.1782C37.6887 13.75 38.5954 13.5478 39.5057 13.5951L39.3437 13.6812C38.4664 14.1477 38.1322 15.2326 38.5969 16.1064C39.0615 16.9802 40.1477 17.3099 41.0251 16.8434L45.6459 14.3864C45.6544 14.3819 45.6606 14.3732 45.6675 14.3682L46.7882 14.1779C47.0934 14.1265 47.3974 14.2745 47.541 14.547L47.5808 14.6218C47.7254 14.8937 47.6796 15.229 47.4657 15.4523L46.3304 16.6414C45.5309 17.4816 44.5996 18.1863 43.5751 18.731L34.0074 23.8183L34.1105 23.6012C34.2427 23.3213 34.1803 22.9895 33.9562 22.7774C33.7321 22.5653 33.3973 22.5202 33.1242 22.6654L26.139 26.3795C25.9612 26.4741 25.83 26.6385 25.7804 26.8338L25.3689 28.4114L21.5419 30.4463C19.7151 31.4176 17.6501 31.8463 15.5909 31.6784L15.0488 31.6341C14.8587 31.6189 14.6705 31.6784 14.5244 31.802C14.3794 31.9251 14.2882 32.1007 14.2722 32.2903C14.2563 32.48 14.3154 32.6676 14.4388 32.8129C14.5622 32.9582 14.7373 33.0476 14.9274 33.0628L15.4695 33.1072C17.8041 33.2977 20.1458 32.8124 22.2154 31.7106L24.8783 30.2947L22.8319 38.1349C22.7596 38.41 22.8575 38.7013 23.0813 38.8771C23.3051 39.0528 23.6111 39.0794 23.8636 38.9465L27.6737 36.9206C27.8113 36.8475 27.9211 36.7323 27.9875 36.5916L32.9897 25.9818L44.2497 19.9948C45.4097 19.378 46.4641 18.578 47.3704 17.627L48.5051 16.4369C49.1468 15.7645 49.2867 14.7612 48.8524 13.9443L48.8126 13.8695C48.3777 13.0542 47.4683 12.6103 46.5558 12.7656L46.5542 12.7677ZM10.5286 31.4362L12.094 30.6039L10.2075 34.6084L10.5286 31.4362ZM8.6285 27.5791L3.14908 22.3803L4.46887 21.6786L12.065 25.7519L8.62956 27.5786L8.6285 27.5791ZM23.0393 19.9168L16.2403 17.8533L17.7072 17.0733L27.4697 17.5611L23.0393 19.9168ZM39.8669 15.4311C39.7739 15.2561 39.8406 15.0395 40.0163 14.9461L41.57 14.12C41.8879 14.243 42.2138 14.3401 42.5466 14.4119L40.3525 15.5785C40.1769 15.6719 39.9599 15.6061 39.8669 15.4311ZM26.7879 35.7705L24.632 36.9168L27.0904 27.4975L31.8912 24.9448L26.7869 35.7711L26.7879 35.7705Z", fill: "currentColor" }),
      /* @__PURE__ */ d.jsx("path", { d: "M36.5617 18.406L36.2255 17.7735C36.0399 17.4246 35.6045 17.2925 35.2542 17.4788C34.9038 17.665 34.7699 18.0999 34.9554 18.4488L35.2917 19.0813C35.4772 19.4302 35.9126 19.5623 36.263 19.376C36.6133 19.1898 36.7472 18.7549 36.5617 18.406Z", fill: "currentColor" }),
      /* @__PURE__ */ d.jsx("path", { d: "M33.722 20.7256C34.0723 20.5394 34.2062 20.1045 34.0207 19.7556L33.6844 19.1231C33.4989 18.7743 33.0635 18.6421 32.7131 18.8284C32.3628 19.0146 32.2289 19.4496 32.4144 19.7984L32.7507 20.4309C32.9362 20.7798 33.3716 20.9119 33.722 20.7256Z", fill: "currentColor" }),
      /* @__PURE__ */ d.jsx("path", { d: "M31.4807 21.1071L31.1444 20.4747C30.9589 20.1258 30.5234 19.9937 30.1731 20.1799C29.8228 20.3662 29.6888 20.8011 29.8744 21.15L30.2106 21.7824C30.3961 22.1313 30.8316 22.2635 31.1819 22.0772C31.5322 21.8909 31.6662 21.456 31.4807 21.1071Z", fill: "currentColor" }),
      /* @__PURE__ */ d.jsx("path", { d: "M28.9406 22.4567L28.6044 21.8243C28.4189 21.4754 27.9834 21.3433 27.6331 21.5295C27.2827 21.7158 27.1488 22.1507 27.3343 22.4996L27.6706 23.132C27.8561 23.4809 28.2916 23.6131 28.6419 23.4268C28.9922 23.2406 29.1261 22.8056 28.9406 22.4567Z", fill: "currentColor" }),
      /* @__PURE__ */ d.jsx("path", { d: "M26.4006 23.8083L26.0643 23.1759C25.8788 22.827 25.4434 22.6948 25.093 22.8811C24.7427 23.0674 24.6088 23.5023 24.7943 23.8512L25.1305 24.4836C25.3161 24.8325 25.7515 24.9647 26.1018 24.7784C26.4522 24.5921 26.5861 24.1572 26.4006 23.8083Z", fill: "currentColor" }),
      /* @__PURE__ */ d.jsx("path", { d: "M23.8606 25.1579L23.5243 24.5255C23.3388 24.1766 22.9033 24.0444 22.553 24.2307C22.2027 24.417 22.0687 24.8519 22.2542 25.2008L22.5905 25.8332C22.776 26.1821 23.2115 26.3143 23.5618 26.128C23.9121 25.9417 24.0461 25.5068 23.8606 25.1579Z", fill: "currentColor" }),
      /* @__PURE__ */ d.jsx("path", { d: "M21.3205 26.5095L20.9842 25.8771C20.7987 25.5282 20.3633 25.396 20.013 25.5823C19.6626 25.7685 19.5287 26.2035 19.7142 26.5523L20.0505 27.1848C20.236 27.5337 20.6714 27.6658 21.0218 27.4796C21.3721 27.2933 21.506 26.8584 21.3205 26.5095Z", fill: "currentColor" }),
      /* @__PURE__ */ d.jsx("path", { d: "M18.7805 27.8591L18.4442 27.2267C18.2587 26.8778 17.8232 26.7456 17.4729 26.9319C17.1226 27.1182 16.9887 27.5531 17.1742 27.902L17.5104 28.5344C17.6959 28.8833 18.1314 29.0154 18.4817 28.8292C18.832 28.6429 18.966 28.208 18.7805 27.8591Z", fill: "currentColor" })
    ]
  }
), aw = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsxs("g", { "clip-path": "url(#clip0_2676_51189)", children: [
      /* @__PURE__ */ d.jsx("path", { d: "M23.3023 19.6547C23.3023 19.6547 27.8473 22.4595 27.8501 22.4609C28.1771 22.6627 28.6165 22.5587 28.8176 22.2317C29.0187 21.9047 28.9161 21.466 28.5891 21.2642C28.5891 21.2642 24.0469 18.4615 24.0413 18.458C23.7143 18.2562 23.2742 18.3624 23.0731 18.6872C22.8713 19.0121 22.9782 19.4551 23.3023 19.6547Z", fill: "currentColor" }),
      /* @__PURE__ */ d.jsx("path", { d: "M20.9115 18.1735C21.0198 18.2424 21.1456 18.2832 21.2771 18.2832C21.5232 18.2832 21.7475 18.1588 21.8762 17.9492C22.1504 17.5027 21.8059 16.877 21.2785 16.877C20.8292 16.877 20.491 17.3045 20.5937 17.7411C20.6345 17.9155 20.754 18.0737 20.9115 18.1735Z", fill: "currentColor" }),
      /* @__PURE__ */ d.jsx("path", { d: "M8.88406 22.5684C9.01625 22.572 9.14774 22.5417 9.25813 22.4721C9.25813 22.4721 13.7757 19.6231 13.7785 19.6209C14.1034 19.4156 14.2025 18.9769 13.9979 18.6513C13.7996 18.3356 13.3426 18.233 13.0283 18.432C13.0283 18.432 8.51563 21.2775 8.50789 21.2824C8.18305 21.4877 8.0832 21.9265 8.28852 22.252C8.41156 22.4475 8.64922 22.5621 8.88477 22.5684H8.88406Z", fill: "currentColor" }),
      /* @__PURE__ */ d.jsx("path", { d: "M15.7823 18.2285C16.1079 18.2285 16.3961 17.9993 16.4679 17.6808C16.5663 17.2448 16.2267 16.8223 15.7809 16.8223C15.4547 16.8223 15.1685 17.0515 15.0961 17.37C14.9976 17.8031 15.3408 18.2285 15.7823 18.2285Z", fill: "currentColor" }),
      /* @__PURE__ */ d.jsx("path", { d: "M36.162 32.5251C35.9075 32.2319 35.4631 32.2009 35.1699 32.4562C34.4204 33.108 33.7264 33.7837 32.7428 34.0558C31.6494 34.3581 30.6102 34.1198 29.6202 33.6248L33.2821 21.3046C33.3735 20.998 33.2462 20.669 32.9727 20.503L29.585 18.4499V12.4558C29.585 12.0677 29.27 11.7527 28.8819 11.7527H27.4756V9.64328C27.4756 9.25516 27.1606 8.94016 26.7725 8.94016H24.5577V6.83078C24.5577 6.44266 24.2427 6.12766 23.8545 6.12766H20.4444V1.20508C20.4444 0.816953 20.1294 0.501953 19.7413 0.501953H16.9288C16.5406 0.501953 16.2256 0.816953 16.2256 1.20508V6.12695H12.8155C12.4274 6.12695 12.1124 6.44195 12.1124 6.83008V8.93945H9.89752C9.50939 8.93945 9.19439 9.25445 9.19439 9.64258V11.752H7.78814C7.40002 11.752 7.08502 12.067 7.08502 12.4551V18.4492L3.69736 20.5016C3.42385 20.6676 3.29658 20.9966 3.38799 21.3032C3.38799 21.3032 7.04072 33.5931 7.04213 33.5988C6.97955 33.3892 5.85455 33.2507 5.65557 33.2247C3.60807 32.9596 2.05135 33.9855 0.576894 35.2673C0.283691 35.5218 0.252754 35.9662 0.507285 36.2594C0.750566 36.5392 1.20338 36.5863 1.49939 36.3283C3.01885 35.0078 4.73166 34.0009 6.74189 35.0057C8.56017 35.9148 10.4431 36.3051 12.3374 35.308C13.8646 34.5044 15.3383 33.8097 17.0434 34.6218L18.7963 35.4564C20.296 36.1708 22.0074 36.1539 23.4931 35.4114C24.4086 34.9537 25.3388 34.3448 26.3844 34.273C27.4095 34.2027 28.3995 34.5845 29.3003 35.0345C30.4899 35.6294 31.8828 35.7482 33.1597 35.384C34.336 35.0486 35.1924 34.2991 36.0938 33.5158C36.387 33.2612 36.418 32.8169 36.1635 32.5237L36.162 32.5251ZM28.3208 33.0609C28.3285 32.8436 26.3492 32.845 26.217 32.8591C24.9964 32.9884 23.941 33.6163 22.8638 34.1549C21.5912 34.7912 20.282 34.6084 19.0388 34.0157V13.7031L31.7802 21.4234L28.3215 33.0609H28.3208ZM28.1788 17.5977L20.8522 13.1589H28.1788V17.5977ZM17.6312 1.9082H19.0374V6.12695H17.6312V1.9082ZM13.5179 7.5332H23.1507V8.93945H13.5179V7.5332ZM10.5999 10.3457H26.0687V11.752H10.5999V10.3457ZM8.49057 13.1582H15.8171L8.49057 17.597V13.1582ZM17.6312 13.7031V33.3456C17.6312 33.2205 16.6285 32.9905 16.4978 32.9617C15.2743 32.6966 13.9602 32.8647 12.8506 33.449C12.0456 33.8723 11.2693 34.3666 10.3482 34.4854C10.3468 34.4854 10.3447 34.4854 10.3433 34.4854C9.80541 34.5508 9.25486 34.5114 8.73455 34.3595L4.88916 21.4227L17.6305 13.7024L17.6312 13.7031Z", fill: "currentColor" })
    ] })
  }
), iw = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsxs("g", { "clip-path": "url(#clip0_2383_69953)", children: [
      /* @__PURE__ */ d.jsx("path", { d: "M26.8439 29.5664C25.492 29.5664 24.3926 30.6658 24.3926 32.0177C24.3926 33.3695 25.492 34.4689 26.8439 34.4689C28.1958 34.4689 29.2952 33.3695 29.2952 32.0177C29.2952 30.6658 28.1958 29.5664 26.8439 29.5664ZM26.8439 33.384C26.0904 33.384 25.4766 32.7711 25.4766 32.0167C25.4766 31.2622 26.0894 30.6494 26.8439 30.6494C27.5984 30.6494 28.2112 31.2622 28.2112 32.0167C28.2112 32.7711 27.5984 33.384 26.8439 33.384Z", fill: "currentColor" }),
      /* @__PURE__ */ d.jsx("path", { d: "M20.7339 23.437C21.0336 23.437 21.2754 23.1942 21.2754 22.8955V5.2251C21.2754 4.92544 21.0326 4.68359 20.7339 4.68359C20.4352 4.68359 20.1924 4.92641 20.1924 5.2251V22.8945C20.1924 23.1942 20.4352 23.436 20.7339 23.436V23.437Z", fill: "currentColor" }),
      /* @__PURE__ */ d.jsx("path", { d: "M23.3628 23.437C23.6615 23.437 23.9053 23.1942 23.9053 22.8955V5.2251C23.9053 4.92544 23.6625 4.68359 23.3628 4.68359C23.0631 4.68359 22.8213 4.92641 22.8213 5.2251V22.8945C22.8213 23.1942 23.0641 23.436 23.3628 23.436V23.437Z", fill: "currentColor" }),
      /* @__PURE__ */ d.jsx("path", { d: "M25.9907 23.437C26.2904 23.437 26.5323 23.1942 26.5323 22.8955V5.2251C26.5323 4.92544 26.2894 4.68359 25.9907 4.68359C25.692 4.68359 25.4492 4.92641 25.4492 5.2251V22.8945C25.4492 23.1942 25.692 23.436 25.9907 23.436V23.437Z", fill: "currentColor" }),
      /* @__PURE__ */ d.jsx("path", { d: "M28.6196 23.437C28.9193 23.437 29.1612 23.1942 29.1612 22.8955V5.2251C29.1612 4.92544 28.9184 4.68359 28.6196 4.68359C28.3209 4.68359 28.0781 4.92641 28.0781 5.2251V22.8945C28.0781 23.1942 28.3209 23.436 28.6196 23.436V23.437Z", fill: "currentColor" }),
      /* @__PURE__ */ d.jsx("path", { d: "M31.2466 23.437C31.5463 23.437 31.7881 23.1942 31.7881 22.8955V5.2251C31.7881 4.92544 31.5453 4.68359 31.2466 4.68359C30.9479 4.68359 30.7051 4.92641 30.7051 5.2251V22.8945C30.7051 23.1942 30.9479 23.436 31.2466 23.436V23.437Z", fill: "currentColor" }),
      /* @__PURE__ */ d.jsx("path", { d: "M33.8745 23.437C34.1742 23.437 34.4161 23.1942 34.4161 22.8955V5.2251C34.4161 4.92544 34.1732 4.68359 33.8745 4.68359C33.5758 4.68359 33.333 4.92641 33.333 5.2251V22.8945C33.333 23.1942 33.5758 23.436 33.8745 23.436V23.437Z", fill: "currentColor" }),
      /* @__PURE__ */ d.jsx("path", { d: "M16.0483 18.9138C15.8884 18.6614 15.553 18.5862 15.3006 18.7462L11.8279 20.9459C11.5754 21.1059 11.5003 21.4412 11.6602 21.6936C11.8202 21.9461 12.1555 22.0222 12.4079 21.8613L15.8806 19.6615C16.1331 19.5016 16.2083 19.1663 16.0483 18.9138Z", fill: "currentColor" }),
      /* @__PURE__ */ d.jsx("path", { d: "M15.3004 23.4497L13.9543 24.3024C13.7018 24.4624 13.6257 24.7977 13.7866 25.0501C13.9466 25.3036 14.2819 25.3778 14.5343 25.2178L15.8805 24.3651C16.1329 24.2051 16.209 23.8698 16.0481 23.6174C15.8882 23.3649 15.5528 23.2888 15.3004 23.4497Z", fill: "currentColor" }),
      /* @__PURE__ */ d.jsx("path", { d: "M16.0484 21.2654C15.8885 21.0129 15.5531 20.9378 15.3007 21.0977L12.8908 22.624C12.6384 22.7839 12.5622 23.1192 12.7231 23.3717C12.8831 23.6241 13.2184 23.6993 13.4709 23.5393L15.8808 22.0131C16.1332 21.8531 16.2084 21.5178 16.0484 21.2654Z", fill: "currentColor" }),
      /* @__PURE__ */ d.jsx("path", { d: "M2.17802 19.7725L7.35045 20.1387C8.10589 20.1917 8.60212 19.3678 8.20802 18.7261L7.60098 17.7366L12.943 14.4547C13.3882 14.1811 13.5279 13.5991 13.2542 13.154L12.2984 11.5988C12.0247 11.1546 11.4408 11.0149 10.9976 11.2885L5.65554 14.5704L5.04753 13.5808C4.6515 12.9372 3.69275 13.0104 3.39983 13.707L1.38886 18.4862C1.14219 19.072 1.54496 19.7282 2.17899 19.7735L2.17802 19.7725ZM4.28053 14.4056L4.8683 15.3624C5.1063 15.7488 5.61025 15.8682 5.99568 15.6312L11.4456 12.2829L12.2569 13.603L6.807 16.9513C6.42157 17.1873 6.30113 17.6932 6.5372 18.0786L7.12594 19.0354L2.47095 18.7068L4.28149 14.4056H4.28053Z", fill: "currentColor" }),
      /* @__PURE__ */ d.jsx("path", { d: "M36.2076 0H28.5703C28.2707 0 28.0288 0.242812 28.0288 0.54151C28.0288 0.840208 28.2716 1.08302 28.5703 1.08302H36.0842V2.62469H17.8372V1.08398H26.041C26.3407 1.08398 26.5825 0.841172 26.5825 0.542474C26.5825 0.243776 26.3397 0.000963542 26.041 0.000963542H17.7138C17.1839 0.000963542 16.7532 0.431667 16.7532 0.961614V2.74995C16.7532 3.18547 17.0451 3.55354 17.4431 3.67109V24.4508C17.1752 24.5298 16.9565 24.7226 16.8418 24.9721L13.8827 26.8472L12.79 25.1224C12.6301 24.87 12.2947 24.7948 12.0423 24.9548C11.7898 25.1147 11.7147 25.45 11.8746 25.7025L12.9673 27.4272C11.9989 28.041 7.66287 30.789 6.95947 31.2342L3.52146 25.8056L5.15375 24.7717L6.49599 26.8915C6.73978 27.2769 7.25143 27.3916 7.63686 27.1478L8.98489 26.2941C9.37031 26.0503 9.48498 25.5387 9.24119 25.1533L7.89895 23.0335L9.53123 21.9996L10.5227 23.5653C10.6827 23.8178 11.018 23.8929 11.2705 23.733C11.5229 23.573 11.599 23.2377 11.4381 22.9853L10.4042 21.3521C10.1074 20.8828 9.4869 20.7441 9.01765 21.0409L2.87491 24.9316C2.40662 25.2284 2.26786 25.8499 2.56368 26.3182L6.04504 31.8142L0.609564 35.2589C-0.185378 35.7628 0.170178 37 1.11447 37H3.51279C3.77199 37 4.02348 36.9268 4.24317 36.788L17.922 28.12H18.1195V31.2929C18.1195 31.9915 18.688 32.559 19.3866 32.559H21.8957C22.1665 35.0527 24.2834 36.999 26.8475 36.999C29.4115 36.999 31.5285 35.0527 31.7993 32.559H35.9041C36.6026 32.559 37.1702 31.9915 37.1702 31.2929V0.960651C37.1702 0.430703 36.7395 0 36.2095 0H36.2076ZM6.9797 23.6135L8.18416 25.5155L7.27166 26.0937L6.06721 24.1916C6.62704 23.8371 6.41987 23.9681 6.9797 23.6135ZM3.65925 35.8727C3.61397 35.9016 3.56193 35.916 3.50894 35.916H1.59433C2.30159 35.468 16.1442 26.6949 16.7522 26.3105V27.1593C16.7522 27.2827 16.7792 27.4176 16.8264 27.5284L3.66022 35.8717L3.65925 35.8727ZM21.8909 31.477H19.3818C19.2816 31.477 19.1997 31.3951 19.1997 31.2949V28.1219H23.7438C22.681 28.9689 22.0297 30.1935 21.8899 31.4779L21.8909 31.477ZM26.8436 35.917C24.6949 35.917 22.946 34.1681 22.946 32.0195C22.946 29.8708 24.6949 28.1219 26.8436 28.1219C28.9924 28.1219 30.7413 29.8698 30.7413 32.0195C30.7413 34.1691 28.9934 35.917 26.8436 35.917ZM36.0833 31.2949C36.0833 31.3951 36.0014 31.477 35.9012 31.477H31.7973C31.6547 30.1646 30.9822 28.9477 29.9434 28.121H36.0833V31.2949ZM36.0833 27.037H17.8362V25.4953H36.0833V27.037ZM36.0833 24.4113H18.5261V3.70964H36.0833V24.4104V24.4113Z", fill: "currentColor" })
    ] })
  }
), ow = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsxs("g", { "clip-path": "url(#clip0_2383_69969)", children: [
      /* @__PURE__ */ d.jsx("path", { d: "M2.15098 30.25H15.351C15.6552 30.25 15.901 30.0034 15.901 29.7C15.901 29.3966 15.6552 29.15 15.351 29.15H2.15098C1.84676 29.15 1.60098 28.9042 1.60098 28.6V8.8H7.65098C8.56277 8.8 9.30098 8.0618 9.30098 7.15V1.1H24.151C24.4543 1.1 24.701 1.34578 24.701 1.65V14.85C24.701 15.1542 24.9468 15.4 25.251 15.4C25.5552 15.4 25.801 15.1542 25.801 14.85V1.65C25.801 0.739063 25.0628 0 24.151 0H8.75098C8.60574 0 8.46566 0.0584375 8.36254 0.161563L0.662539 7.86156C0.559414 7.96469 0.500977 8.10477 0.500977 8.25V28.6C0.500977 29.5109 1.24004 30.25 2.15098 30.25ZM7.65098 7.7H2.37871L8.20098 1.87773V7.15C8.20098 7.45422 7.95434 7.7 7.65098 7.7Z", fill: "currentColor" }),
      /* @__PURE__ */ d.jsx("path", { d: "M3.25117 24.1992C2.94695 24.1992 2.70117 24.445 2.70117 24.7492V27.4992C2.70117 27.8034 2.94695 28.0492 3.25117 28.0492H6.00117C6.30539 28.0492 6.55117 27.8034 6.55117 27.4992C6.55117 27.195 6.30539 26.9492 6.00117 26.9492H3.80117V24.7492C3.80117 24.445 3.55539 24.1992 3.25117 24.1992Z", fill: "currentColor" }),
      /* @__PURE__ */ d.jsx("path", { d: "M23.601 5.49922V2.74922C23.601 2.445 23.3543 2.19922 23.051 2.19922H20.301C19.9976 2.19922 19.751 2.445 19.751 2.74922C19.751 3.05344 19.9976 3.29922 20.301 3.29922H22.501V5.49922C22.501 5.80344 22.7476 6.04922 23.051 6.04922C23.3543 6.04922 23.601 5.80344 23.601 5.49922Z", fill: "currentColor" }),
      /* @__PURE__ */ d.jsx("path", { d: "M31.301 16.5H19.201C17.9858 16.5 17.001 17.4848 17.001 18.7V30.8C17.001 32.0152 17.9858 33 19.201 33H31.301C32.5161 33 33.501 32.0152 33.501 30.8V18.7C33.501 17.4848 32.5161 16.5 31.301 16.5ZM28.551 17.6V22.8937C28.551 22.9668 28.5149 23.0347 28.4547 23.0759C28.3946 23.1172 28.3181 23.1249 28.2502 23.0983L25.7417 22.0945C25.4271 21.9691 25.0757 21.9691 24.7611 22.0945L22.2535 23.1009C22.1856 23.1284 22.1082 23.1198 22.0472 23.0785C21.9871 23.0373 21.951 22.9677 21.9518 22.8946V17.6009H28.5518L28.551 17.6ZM32.401 30.8C32.401 31.4076 31.9086 31.9 31.301 31.9H19.201C18.5934 31.9 18.101 31.4076 18.101 30.8V18.7C18.101 18.0924 18.5934 17.6 19.201 17.6H20.851V22.8937C20.851 23.332 21.0684 23.7411 21.4311 23.9869C21.7937 24.2327 22.2552 24.2816 22.6617 24.1192L25.1693 23.1155C25.2226 23.094 25.2811 23.094 25.3343 23.1155L27.8429 24.1192C28.2493 24.2816 28.71 24.2309 29.0718 23.986C29.4336 23.7402 29.651 23.3312 29.651 22.8937V17.6H31.301C31.9086 17.6 32.401 18.0924 32.401 18.7V30.8Z", fill: "currentColor" }),
      /* @__PURE__ */ d.jsx("path", { d: "M22.501 29.1504H20.301C19.9976 29.1504 19.751 29.397 19.751 29.7004C19.751 30.0037 19.9976 30.2504 20.301 30.2504H22.501C22.8043 30.2504 23.051 30.0037 23.051 29.7004C23.051 29.397 22.8052 29.1504 22.501 29.1504Z", fill: "currentColor" }),
      /* @__PURE__ */ d.jsx("path", { d: "M12.051 10.4492H3.80098C3.49762 10.4492 3.25098 10.695 3.25098 10.9992C3.25098 11.3034 3.49762 11.5492 3.80098 11.5492H12.051C12.3552 11.5492 12.601 11.3034 12.601 10.9992C12.601 10.695 12.3543 10.4492 12.051 10.4492Z", fill: "currentColor" }),
      /* @__PURE__ */ d.jsx("path", { d: "M22.5012 10.4492H14.2512C13.947 10.4492 13.7012 10.695 13.7012 10.9992C13.7012 11.3034 13.947 11.5492 14.2512 11.5492H22.5012C22.8045 11.5492 23.0512 11.3034 23.0512 10.9992C23.0512 10.695 22.8054 10.4492 22.5012 10.4492Z", fill: "currentColor" }),
      /* @__PURE__ */ d.jsx("path", { d: "M12.051 12.6504H3.80098C3.49762 12.6504 3.25098 12.897 3.25098 13.2004C3.25098 13.5038 3.49762 13.7504 3.80098 13.7504H12.051C12.3552 13.7504 12.601 13.5038 12.601 13.2004C12.601 12.897 12.3543 12.6504 12.051 12.6504Z", fill: "currentColor" }),
      /* @__PURE__ */ d.jsx("path", { d: "M22.5012 12.6504H14.2512C13.947 12.6504 13.7012 12.897 13.7012 13.2004C13.7012 13.5038 13.947 13.7504 14.2512 13.7504H22.5012C22.8045 13.7504 23.0512 13.5038 23.0512 13.2004C23.0512 12.897 22.8054 12.6504 22.5012 12.6504Z", fill: "currentColor" }),
      /* @__PURE__ */ d.jsx("path", { d: "M12.051 14.8496H3.80098C3.49762 14.8496 3.25098 15.0954 3.25098 15.3996C3.25098 15.7038 3.49762 15.9496 3.80098 15.9496H12.051C12.3552 15.9496 12.601 15.703 12.601 15.3996C12.601 15.0962 12.3543 14.8496 12.051 14.8496Z", fill: "currentColor" }),
      /* @__PURE__ */ d.jsx("path", { d: "M12.051 17.0508H3.80098C3.49762 17.0508 3.25098 17.2974 3.25098 17.6008C3.25098 17.9041 3.49762 18.1508 3.80098 18.1508H12.051C12.3552 18.1508 12.601 17.905 12.601 17.6008C12.601 17.2966 12.3543 17.0508 12.051 17.0508Z", fill: "currentColor" }),
      /* @__PURE__ */ d.jsx("path", { d: "M12.051 19.25H3.80098C3.49762 19.25 3.25098 19.4966 3.25098 19.8C3.25098 20.1034 3.49762 20.35 3.80098 20.35H12.051C12.3552 20.35 12.601 20.1034 12.601 19.8C12.601 19.4966 12.3543 19.25 12.051 19.25Z", fill: "currentColor" }),
      /* @__PURE__ */ d.jsx("path", { d: "M12.601 21.9992C12.601 21.695 12.3543 21.4492 12.051 21.4492H3.80098C3.49762 21.4492 3.25098 21.695 3.25098 21.9992C3.25098 22.3034 3.49762 22.5492 3.80098 22.5492H12.051C12.3552 22.5492 12.601 22.3034 12.601 21.9992Z", fill: "currentColor" })
    ] })
  }
), sw = () => /* @__PURE__ */ d.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsx("path", { d: "M0.525597 18.8546C0.654764 19.4617 1.18435 19.875 1.79143 19.875C2.83768 19.875 4.87851 18.7383 6.00226 17.6663C7.46185 19.0225 9.11518 19.875 10.8331 19.875C16.1806 19.875 18.5831 15.3412 18.5831 12.125C18.5831 9.99375 16.8393 8.25 14.7081 8.25C12.5768 8.25 10.8331 9.99375 10.8331 12.125C10.8331 13.6233 11.621 15.4317 12.8739 16.9171C12.2927 17.1496 11.621 17.2917 10.8331 17.2917C9.79976 17.2917 8.70185 16.6717 7.66851 15.6771C9.73518 12.6546 10.8331 8.65042 10.8331 5.66667C10.8331 2.68292 8.52101 0.5 5.66643 0.5C2.81185 0.5 0.499764 2.81208 0.499764 5.66667C0.499764 8.52125 1.9981 12.7192 4.28435 15.7417C3.4706 16.5425 2.5406 17.0979 1.52018 17.3175C0.82268 17.4596 0.370597 18.1442 0.525597 18.8417V18.8546ZM14.7081 10.8333C15.4185 10.8333 15.9998 11.4146 15.9998 12.125C15.9998 12.9646 15.6898 14.2433 14.9018 15.3154C13.9331 14.1917 13.4164 12.9129 13.4164 12.125C13.4164 11.4146 13.9977 10.8333 14.7081 10.8333ZM3.0831 5.66667C3.0831 4.24583 4.2456 3.08333 5.66643 3.08333C7.08726 3.08333 8.24976 4.24583 8.24976 5.66667C8.24976 8.03042 7.41018 11.1692 5.93768 13.6104C4.28435 11.195 3.0831 8.05625 3.0831 5.66667ZM18.906 5.48583C19.3839 4.95625 20.1977 4.90458 20.7273 5.3825C21.4377 6.02833 22.0448 6.76458 22.5356 7.60417C22.8973 8.22417 22.6777 9.01208 22.0706 9.37375C21.8639 9.49 21.6443 9.54167 21.4248 9.54167C20.9727 9.54167 20.5464 9.30917 20.301 8.89583C19.9523 8.30167 19.526 7.77208 19.0093 7.30708C18.4798 6.82917 18.4281 6.01542 18.906 5.48583ZM28.9164 19.2808V17.2917C28.9164 14.4371 26.6043 12.125 23.7498 12.125C20.8952 12.125 18.5831 14.4371 18.5831 17.2917V19.2808C17.046 20.1721 15.9998 21.8512 15.9998 23.75V26.3333C15.9998 29.1879 18.3118 31.5 21.1664 31.5H26.3331C29.1877 31.5 31.4998 29.1879 31.4998 26.3333V23.75C31.4998 21.8383 30.4535 20.1721 28.9164 19.2808ZM21.1664 17.2917C21.1664 15.8708 22.3289 14.7083 23.7498 14.7083C25.1706 14.7083 26.3331 15.8708 26.3331 17.2917V18.5833H21.1664V17.2917ZM28.9164 26.3333C28.9164 27.7542 27.7539 28.9167 26.3331 28.9167H21.1664C19.7456 28.9167 18.5831 27.7542 18.5831 26.3333V23.75C18.5831 22.3292 19.7456 21.1667 21.1664 21.1667H26.3331C27.7539 21.1667 28.9164 22.3292 28.9164 23.75V26.3333ZM13.4164 23.75C13.4164 24.4604 12.8352 25.0417 12.1248 25.0417H1.79143C1.08101 25.0417 0.499764 24.4604 0.499764 23.75C0.499764 23.0396 1.08101 22.4583 1.79143 22.4583H12.1248C12.8352 22.4583 13.4164 23.0396 13.4164 23.75ZM25.6873 25.0417C25.6873 26.1137 24.8218 26.9792 23.7498 26.9792C22.6777 26.9792 21.8123 26.1137 21.8123 25.0417C21.8123 23.9696 22.6777 23.1042 23.7498 23.1042C24.8218 23.1042 25.6873 23.9696 25.6873 25.0417Z", fill: "currentColor" })
  }
), lw = () => /* @__PURE__ */ d.jsxs("svg", { className: "w-full", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ d.jsx("path", { d: "M11.9543 2.06241C13.2808 2.06676 14.5933 2.33415 15.8158 2.8491C17.0383 3.36404 18.1465 4.11633 19.0763 5.06241H15.9543C15.6891 5.06241 15.4347 5.16777 15.2472 5.3553C15.0597 5.54284 14.9543 5.79719 14.9543 6.06241C14.9543 6.32763 15.0597 6.58198 15.2472 6.76952C15.4347 6.95705 15.6891 7.06241 15.9543 7.06241H20.0973C20.5897 7.06214 21.0619 6.86641 21.4101 6.51821C21.7583 6.17002 21.954 5.69784 21.9543 5.20541V1.06241C21.9543 0.797193 21.8489 0.542839 21.6614 0.355303C21.4739 0.167767 21.2195 0.0624097 20.9543 0.0624097C20.6891 0.0624097 20.4347 0.167767 20.2472 0.355303C20.0597 0.542839 19.9543 0.797193 19.9543 1.06241V3.14041C18.3015 1.65186 16.2669 0.652819 14.0784 0.255159C11.8899 -0.142502 9.63393 0.0769217 7.56309 0.888857C5.49225 1.70079 3.68832 3.07318 2.35332 4.85233C1.01831 6.63149 0.204946 8.74715 0.00430406 10.9624C-0.00861256 11.1017 0.00761984 11.2421 0.051967 11.3747C0.0963141 11.5074 0.167804 11.6293 0.26188 11.7328C0.355957 11.8363 0.470558 11.919 0.598382 11.9758C0.726206 12.0325 0.864449 12.062 1.0043 12.0624C1.24889 12.0655 1.48584 11.9772 1.66876 11.8149C1.85169 11.6525 1.96742 11.4276 1.9933 11.1844C2.21592 8.69516 3.36128 6.37911 5.20438 4.69125C7.04749 3.00338 9.45512 2.0657 11.9543 2.06241Z", fill: "currentColor" }),
  /* @__PURE__ */ d.jsx("path", { d: "M22.9051 12.0625C22.6605 12.0593 22.4236 12.1476 22.2406 12.31C22.0577 12.4724 21.942 12.6972 21.9161 12.9405C21.7508 14.8437 21.043 16.6596 19.8768 18.1727C18.7105 19.6858 17.1347 20.8326 15.3362 21.477C13.5378 22.1215 11.5923 22.2365 9.73045 21.8086C7.86861 21.3806 6.1686 20.4275 4.8321 19.0625H7.9541C8.21932 19.0625 8.47367 18.9571 8.66121 18.7696C8.84875 18.582 8.9541 18.3277 8.9541 18.0625C8.9541 17.7972 8.84875 17.5429 8.66121 17.3554C8.47367 17.1678 8.21932 17.0625 7.9541 17.0625H3.8111C3.5672 17.0623 3.32566 17.1103 3.1003 17.2035C2.87494 17.2968 2.67018 17.4336 2.49771 17.6061C2.32525 17.7785 2.18847 17.9833 2.09519 18.2087C2.00191 18.434 1.95397 18.6756 1.9541 18.9195V23.0625C1.9541 23.3277 2.05946 23.582 2.24699 23.7696C2.43453 23.9571 2.68889 24.0625 2.9541 24.0625C3.21932 24.0625 3.47367 23.9571 3.66121 23.7696C3.84875 23.582 3.9541 23.3277 3.9541 23.0625V20.9845C5.60693 22.473 7.64151 23.472 9.83 23.8697C12.0185 24.2674 14.2745 24.0479 16.3453 23.236C18.4162 22.4241 20.2201 21.0517 21.5551 19.2725C22.8901 17.4934 23.7035 15.3777 23.9041 13.1625C23.917 13.0232 23.9008 12.8828 23.8564 12.7501C23.8121 12.6175 23.7406 12.4956 23.6465 12.3921C23.5524 12.2886 23.4378 12.2058 23.31 12.1491C23.1822 12.0923 23.045 12.0628 22.9051 12.0625Z", fill: "currentColor" })
] }), cw = () => /* @__PURE__ */ d.jsxs("svg", { viewBox: "0 0 41 41", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ d.jsx("path", { d: "M20.5 41C31.8218 41 41 31.8218 41 20.5C41 9.17816 31.8218 0 20.5 0C9.17816 0 0 9.17816 0 20.5C0 31.8218 9.17816 41 20.5 41Z", fill: "#77B3D4" }),
  /* @__PURE__ */ d.jsx("path", { opacity: "0.2", d: "M7.6875 16.0156V32.0312C7.6875 33.4406 8.84062 34.5938 10.25 34.5938H30.75C32.1594 34.5938 33.3125 33.4406 33.3125 32.0312V16.0156H7.6875Z", fill: "#007AFF" }),
  /* @__PURE__ */ d.jsx("path", { d: "M7.6875 14.7344V30.75C7.6875 32.1594 8.84062 33.3125 10.25 33.3125H30.75C32.1594 33.3125 33.3125 32.1594 33.3125 30.75V14.7344H7.6875Z", fill: "white" }),
  /* @__PURE__ */ d.jsx("path", { opacity: "0.2", d: "M30.75 8.96875H10.25C8.84062 8.96875 7.6875 10.1219 7.6875 11.5312V16.0156H33.3125V11.5312C33.3125 10.1219 32.1594 8.96875 30.75 8.96875Z", fill: "#007AFF" }),
  /* @__PURE__ */ d.jsx("path", { d: "M30.75 7.6875H10.25C8.84062 7.6875 7.6875 8.84062 7.6875 10.25V14.7344H33.3125V10.25C33.3125 8.84062 32.1594 7.6875 30.75 7.6875Z", fill: "#C75C5C" }),
  /* @__PURE__ */ d.jsx("path", { d: "M20.5 30.75C19.7953 30.75 19.2188 30.1734 19.2188 29.4688C19.2188 25.9453 20.3719 23.3828 21.4609 21.7812H17.2969C16.5922 21.7812 16.0156 21.2047 16.0156 20.5C16.0156 19.7953 16.5922 19.2188 17.2969 19.2188H24.3438C24.9203 19.2188 25.3688 19.6031 25.5609 20.1156C25.7531 20.6281 25.5609 21.2047 25.1125 21.525C24.9844 21.6531 21.7812 24.0234 21.7812 29.4688C21.7812 30.1734 21.2047 30.75 20.5 30.75Z", fill: "white", "fill-opacity": "0.3" }),
  /* @__PURE__ */ d.jsx("path", { opacity: "0.2", d: "M12.8125 13.4531C12.1078 13.4531 11.5312 12.8766 11.5312 12.1719V7.6875C11.5312 6.98281 12.1078 6.40625 12.8125 6.40625C13.5172 6.40625 14.0938 6.98281 14.0938 7.6875V12.1719C14.0938 12.8766 13.5172 13.4531 12.8125 13.4531Z", fill: "#007AFF" }),
  /* @__PURE__ */ d.jsx("path", { opacity: "0.2", d: "M28.8281 13.4531C28.1234 13.4531 27.5469 12.8766 27.5469 12.1719V7.6875C27.5469 6.98281 28.1234 6.40625 28.8281 6.40625C29.5328 6.40625 30.1094 6.98281 30.1094 7.6875V12.1719C30.1094 12.8766 29.5328 13.4531 28.8281 13.4531Z", fill: "#007AFF" }),
  /* @__PURE__ */ d.jsx("path", { d: "M12.8125 12.1719C12.1078 12.1719 11.5312 11.5953 11.5312 10.8906V6.40625C11.5312 5.70156 12.1078 5.125 12.8125 5.125C13.5172 5.125 14.0938 5.70156 14.0938 6.40625V10.8906C14.0938 11.5953 13.5172 12.1719 12.8125 12.1719Z", fill: "#E0E0D1" }),
  /* @__PURE__ */ d.jsx("path", { d: "M28.8281 12.1719C28.1234 12.1719 27.5469 11.5953 27.5469 10.8906V6.40625C27.5469 5.70156 28.1234 5.125 28.8281 5.125C29.5328 5.125 30.1094 5.70156 30.1094 6.40625V10.8906C30.1094 11.5953 29.5328 12.1719 28.8281 12.1719Z", fill: "#E0E0D1" })
] }), uw = () => /* @__PURE__ */ d.jsxs("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ d.jsx("g", { "clip-path": "url(#clip0_280_423)", children: /* @__PURE__ */ d.jsx("path", { d: "M19 2H18V1C18 0.448 17.553 0 17 0C16.447 0 16 0.448 16 1V2H8V1C8 0.448 7.553 0 7 0C6.447 0 6 0.448 6 1V2H5C2.243 2 0 4.243 0 7V19C0 21.757 2.243 24 5 24H19C21.757 24 24 21.757 24 19V7C24 4.243 21.757 2 19 2ZM5 4H19C20.654 4 22 5.346 22 7V8H2V7C2 5.346 3.346 4 5 4ZM19 22H5C3.346 22 2 20.654 2 19V10H22V19C22 20.654 20.654 22 19 22ZM17.832 13.152C18.216 13.549 18.204 14.183 17.807 14.566L13.067 19.134C12.514 19.687 11.76 20 10.959 20C10.158 20 9.404 19.688 8.838 19.121L6.586 17.029C6.182 16.653 6.158 16.02 6.534 15.616C6.912 15.211 7.544 15.189 7.947 15.564L10.225 17.681C10.658 18.111 11.288 18.083 11.664 17.707L16.418 13.125C16.816 12.742 17.448 12.754 17.832 13.151V13.152Z", fill: "currentColor" }) }),
  /* @__PURE__ */ d.jsx("defs", { children: /* @__PURE__ */ d.jsx("clipPath", { id: "clip0_280_423", children: /* @__PURE__ */ d.jsx("rect", { width: "24", height: "24", fill: "currentColor" }) }) })
] }), fw = () => /* @__PURE__ */ d.jsxs("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ d.jsx("g", { "clip-path": "url(#clip0_280_421)", children: /* @__PURE__ */ d.jsx("path", { d: "M15.707 13.707L13.414 16L15.707 18.293C16.098 18.684 16.098 19.316 15.707 19.707C15.512 19.902 15.256 20 15 20C14.744 20 14.488 19.902 14.293 19.707L12 17.414L9.707 19.707C9.512 19.902 9.256 20 9 20C8.744 20 8.488 19.902 8.293 19.707C7.902 19.316 7.902 18.684 8.293 18.293L10.586 16L8.293 13.707C7.902 13.316 7.902 12.684 8.293 12.293C8.684 11.902 9.316 11.902 9.707 12.293L12 14.586L14.293 12.293C14.684 11.902 15.316 11.902 15.707 12.293C16.098 12.684 16.098 13.316 15.707 13.707ZM24 7V19C24 21.757 21.757 24 19 24H5C2.243 24 0 21.757 0 19V7C0 4.243 2.243 2 5 2H6V1C6 0.447 6.448 0 7 0C7.552 0 8 0.447 8 1V2H16V1C16 0.447 16.448 0 17 0C17.552 0 18 0.447 18 1V2H19C21.757 2 24 4.243 24 7ZM2 7V8H22V7C22 5.346 20.654 4 19 4H5C3.346 4 2 5.346 2 7ZM22 19V10H2V19C2 20.654 3.346 22 5 22H19C20.654 22 22 20.654 22 19Z", fill: "currentColor" }) }),
  /* @__PURE__ */ d.jsx("defs", { children: /* @__PURE__ */ d.jsx("clipPath", { id: "clip0_280_421", children: /* @__PURE__ */ d.jsx("rect", { width: "24", height: "24", fill: "currentColor" }) }) })
] }), dw = () => /* @__PURE__ */ d.jsxs("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ d.jsx("g", { "clip-path": "url(#clip0_280_419)", children: /* @__PURE__ */ d.jsx("path", { d: "M19 2H18V1C18 0.448 17.552 0 17 0C16.448 0 16 0.448 16 1V2H8V1C8 0.448 7.552 0 7 0C6.448 0 6 0.448 6 1V2H5C2.243 2 0 4.243 0 7V19C0 21.757 2.243 24 5 24H19C21.757 24 24 21.757 24 19V7C24 4.243 21.757 2 19 2ZM19 22H5C3.346 22 2 20.654 2 19V10H8C8.552 10 9 9.552 9 9C9 8.448 8.552 8 8 8H2V7C2 5.346 3.346 4 5 4H19C20.654 4 22 5.346 22 7V8H16C15.448 8 15 8.448 15 9C15 9.552 15.448 10 16 10H22V19C22 20.654 20.654 22 19 22ZM13 9V16C13 16.552 12.552 17 12 17C11.448 17 11 16.552 11 16V9C11 8.448 11.448 8 12 8C12.552 8 13 8.448 13 9ZM13 19C13 19.552 12.552 20 12 20C11.448 20 11 19.552 11 19C11 18.448 11.448 18 12 18C12.552 18 13 18.448 13 19Z", fill: "currentColor" }) }),
  /* @__PURE__ */ d.jsx("defs", { children: /* @__PURE__ */ d.jsx("clipPath", { id: "clip0_280_419", children: /* @__PURE__ */ d.jsx("rect", { width: "24", height: "24", fill: "currentColor" }) }) })
] }), pw = () => /* @__PURE__ */ d.jsxs("svg", { className: "w-full", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ d.jsxs("g", { children: [
    /* @__PURE__ */ d.jsx("path", { d: "M19.1666 13.3334C18.9456 13.3334 18.7337 13.4212 18.5774 13.5775C18.4211 13.7337 18.3333 13.9457 18.3333 14.1667V15.8334C18.3333 16.4964 18.0699 17.1323 17.6011 17.6011C17.1322 18.07 16.4964 18.3334 15.8333 18.3334H14.1666C13.9456 18.3334 13.7337 18.4212 13.5774 18.5775C13.4211 18.7337 13.3333 18.9457 13.3333 19.1667C13.3333 19.3877 13.4211 19.5997 13.5774 19.756C13.7337 19.9122 13.9456 20 14.1666 20H15.8333C16.938 19.9987 17.997 19.5593 18.7781 18.7782C19.5592 17.9971 19.9987 16.938 20 15.8334V14.1667C20 13.9457 19.9122 13.7337 19.7559 13.5775C19.5996 13.4212 19.3877 13.3334 19.1666 13.3334Z", fill: "currentColor" }),
    /* @__PURE__ */ d.jsx("path", { d: "M0.833333 6.66667C1.05435 6.66667 1.26631 6.57887 1.42259 6.42259C1.57887 6.26631 1.66667 6.05435 1.66667 5.83333V4.16667C1.66667 3.50363 1.93006 2.86774 2.3989 2.3989C2.86774 1.93006 3.50363 1.66667 4.16667 1.66667H5.83333C6.05435 1.66667 6.26631 1.57887 6.42259 1.42259C6.57887 1.26631 6.66667 1.05435 6.66667 0.833333C6.66667 0.61232 6.57887 0.400358 6.42259 0.244078C6.26631 0.0877974 6.05435 0 5.83333 0L4.16667 0C3.062 0.00132321 2.00296 0.440735 1.22185 1.22185C0.440735 2.00296 0.00132321 3.062 0 4.16667L0 5.83333C0 6.05435 0.0877974 6.26631 0.244078 6.42259C0.400358 6.57887 0.61232 6.66667 0.833333 6.66667Z", fill: "currentColor" }),
    /* @__PURE__ */ d.jsx("path", { d: "M5.83333 18.3334H4.16667C3.50363 18.3334 2.86774 18.07 2.3989 17.6011C1.93006 17.1323 1.66667 16.4964 1.66667 15.8334V14.1667C1.66667 13.9457 1.57887 13.7337 1.42259 13.5775C1.26631 13.4212 1.05435 13.3334 0.833333 13.3334C0.61232 13.3334 0.400358 13.4212 0.244078 13.5775C0.0877974 13.7337 0 13.9457 0 14.1667L0 15.8334C0.00132321 16.938 0.440735 17.9971 1.22185 18.7782C2.00296 19.5593 3.062 19.9987 4.16667 20H5.83333C6.05435 20 6.26631 19.9122 6.42259 19.756C6.57887 19.5997 6.66667 19.3877 6.66667 19.1667C6.66667 18.9457 6.57887 18.7337 6.42259 18.5775C6.26631 18.4212 6.05435 18.3334 5.83333 18.3334Z", fill: "currentColor" }),
    /* @__PURE__ */ d.jsx("path", { d: "M15.8333 0H14.1666C13.9456 0 13.7337 0.0877974 13.5774 0.244078C13.4211 0.400358 13.3333 0.61232 13.3333 0.833333C13.3333 1.05435 13.4211 1.26631 13.5774 1.42259C13.7337 1.57887 13.9456 1.66667 14.1666 1.66667H15.8333C16.4964 1.66667 17.1322 1.93006 17.6011 2.3989C18.0699 2.86774 18.3333 3.50363 18.3333 4.16667V5.83333C18.3333 6.05435 18.4211 6.26631 18.5774 6.42259C18.7337 6.57887 18.9456 6.66667 19.1666 6.66667C19.3877 6.66667 19.5996 6.57887 19.7559 6.42259C19.9122 6.26631 20 6.05435 20 5.83333V4.16667C19.9987 3.062 19.5592 2.00296 18.7781 1.22185C17.997 0.440735 16.938 0.00132321 15.8333 0Z", fill: "currentColor" }),
    /* @__PURE__ */ d.jsx("path", { d: "M10 9.16667C10.6593 9.16667 11.3038 8.97117 11.8519 8.6049C12.4001 8.23863 12.8273 7.71803 13.0796 7.10895C13.3319 6.49986 13.3979 5.82964 13.2693 5.18303C13.1407 4.53643 12.8232 3.94249 12.357 3.47631C11.8909 3.01014 11.2969 2.69267 10.6503 2.56405C10.0037 2.43543 9.3335 2.50144 8.72441 2.75374C8.11532 3.00603 7.59473 3.43327 7.22846 3.98143C6.86218 4.5296 6.66669 5.17406 6.66669 5.83334C6.66669 6.71739 7.01788 7.56524 7.643 8.19036C8.26812 8.81548 9.11597 9.16667 10 9.16667ZM10 4.16667C10.3297 4.16667 10.6519 4.26442 10.926 4.44755C11.2001 4.63069 11.4137 4.89099 11.5398 5.19553C11.666 5.50007 11.699 5.83518 11.6347 6.15849C11.5704 6.48179 11.4116 6.77876 11.1785 7.01185C10.9454 7.24493 10.6485 7.40367 10.3252 7.46798C10.0019 7.53229 9.66676 7.49928 9.36222 7.37313C9.05767 7.24699 8.79737 7.03337 8.61424 6.75929C8.4311 6.4852 8.33335 6.16297 8.33335 5.83334C8.33335 5.39131 8.50895 4.96738 8.82151 4.65482C9.13407 4.34226 9.55799 4.16667 10 4.16667Z", fill: "currentColor" }),
    /* @__PURE__ */ d.jsx("path", { d: "M15 16.6667C15.221 16.6667 15.433 16.5789 15.5893 16.4226C15.7456 16.2664 15.8334 16.0544 15.8334 15.8334C15.832 14.5077 15.3048 13.2367 14.3674 12.2993C13.43 11.3619 12.159 10.8347 10.8334 10.8334H9.16669C7.84101 10.8347 6.57001 11.3619 5.63262 12.2993C4.69522 13.2367 4.16801 14.5077 4.16669 15.8334C4.16669 16.0544 4.25448 16.2664 4.41076 16.4226C4.56705 16.5789 4.77901 16.6667 5.00002 16.6667C5.22103 16.6667 5.433 16.5789 5.58928 16.4226C5.74556 16.2664 5.83335 16.0544 5.83335 15.8334C5.83335 14.9493 6.18454 14.1015 6.80966 13.4764C7.43479 12.8512 8.28263 12.5 9.16669 12.5H10.8334C11.7174 12.5 12.5653 12.8512 13.1904 13.4764C13.8155 14.1015 14.1667 14.9493 14.1667 15.8334C14.1667 16.0544 14.2545 16.2664 14.4108 16.4226C14.567 16.5789 14.779 16.6667 15 16.6667Z", fill: "currentColor" })
  ] }),
  /* @__PURE__ */ d.jsx("defs", { children: /* @__PURE__ */ d.jsx("clipPath", { id: "clip0_213_175", children: /* @__PURE__ */ d.jsx("rect", { width: "20", height: "20", fill: "currentColor" }) }) })
] }), hw = () => /* @__PURE__ */ d.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 16 16", children: [
  /* @__PURE__ */ d.jsx("path", { d: "M10.854 6.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 8.793l2.646-2.647a.5.5 0 0 1 .708 0" }),
  /* @__PURE__ */ d.jsx("path", { d: "M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2" }),
  /* @__PURE__ */ d.jsx("path", { d: "M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1z" })
] }), vw = () => /* @__PURE__ */ d.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", children: [
  /* @__PURE__ */ d.jsx("path", { d: "M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z", fill: "currentColor" }),
  /* @__PURE__ */ d.jsx("path", { d: "M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1z", fill: "currentColor" }),
  /* @__PURE__ */ d.jsx("path", { d: "M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0z", fill: "currentColor" })
] }), mw = () => /* @__PURE__ */ d.jsx("svg", { viewBox: "0 0 11 11", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ d.jsx(
  "path",
  {
    d: "M5.5 10.3125C2.84213 10.3125 0.6875 8.15787 0.6875 5.5C0.6875 2.84213 2.84213 0.6875 5.5 0.6875C8.15787 0.6875 10.3125 2.84213 10.3125 5.5C10.3125 8.15787 8.15787 10.3125 5.5 10.3125ZM5.5 11C8.53757 11 11 8.53757 11 5.5C11 2.46243 8.53757 0 5.5 0C2.46243 0 0 2.46243 0 5.5C0 8.53757 2.46243 11 5.5 11Z",
    fill: "currentColor"
  }
) }), gw = () => /* @__PURE__ */ d.jsx("svg", { width: "21", height: "21", viewBox: "0 0 21 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ d.jsx(
  "path",
  {
    d: "M11.8773 0.570516C11.1167 -0.190171 9.88334 -0.190173 9.12265 0.570515L0.570516 9.12265C-0.190171 9.88334 -0.190173 11.1167 0.570515 11.8773L9.12265 20.4295C9.88334 21.1902 11.1167 21.1902 11.8773 20.4295L20.4295 11.8773C21.1902 11.1167 21.1902 9.88334 20.4295 9.12265L11.8773 0.570516ZM10.5 5.24996C11.2027 5.24996 11.7518 5.85671 11.6819 6.55595L11.2215 11.1595C11.1845 11.5302 10.8725 11.8125 10.5 11.8125C10.1275 11.8125 9.81552 11.5302 9.77845 11.1595L9.3181 6.55595C9.24817 5.85671 9.79727 5.24996 10.5 5.24996ZM10.502 13.125C11.2269 13.125 11.8145 13.7126 11.8145 14.4375C11.8145 15.1623 11.2269 15.75 10.502 15.75C9.77715 15.75 9.18952 15.1623 9.18952 14.4375C9.18952 13.7126 9.77715 13.125 10.502 13.125Z",
    fill: "#E52E2E"
  }
) }), yw = () => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16",
    children: [
      /* @__PURE__ */ d.jsx("path", { d: "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4.5a.5.5 0 0 1-1 0V5.383l-7 4.2-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h5.5a.5.5 0 0 1 0 1H2a2 2 0 0 1-2-1.99zm1 7.105 4.708-2.897L1 5.383zM1 4v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1" }),
      /* @__PURE__ */ d.jsx("path", { d: "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.354-5.354 1.25 1.25a.5.5 0 0 1-.708.708L13 12.207V14a.5.5 0 0 1-1 0v-1.717l-.28.305a.5.5 0 0 1-.737-.676l1.149-1.25a.5.5 0 0 1 .722-.016" })
    ]
  }
), bw = () => /* @__PURE__ */ d.jsx("svg", { fill: "none", viewBox: "0 0 25 25", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ d.jsx(
  "path",
  {
    d: "M10.5426 23.0627C10.5426 23.6157 10.0956 24.0627 9.54257 24.0627H5.54257C2.78557 24.0627 0.542572 21.8197 0.542572 19.0627V5.06274C0.542572 2.30574 2.78557 0.0627441 5.54257 0.0627441H13.5426C16.2996 0.0627441 18.5426 2.30574 18.5426 5.06274V7.06274C18.5426 7.61574 18.0956 8.06274 17.5426 8.06274C16.9896 8.06274 16.5426 7.61574 16.5426 7.06274V5.06274C16.5426 3.40874 15.1966 2.06274 13.5426 2.06274H5.54257C3.88857 2.06274 2.54257 3.40874 2.54257 5.06274V19.0627C2.54257 20.7167 3.88857 22.0627 5.54257 22.0627H9.54257C10.0956 22.0627 10.5426 22.5097 10.5426 23.0627ZM14.5426 6.06274C14.5426 5.50974 14.0956 5.06274 13.5426 5.06274H5.54257C4.98957 5.06274 4.54257 5.50974 4.54257 6.06274C4.54257 6.61574 4.98957 7.06274 5.54257 7.06274H13.5426C14.0956 7.06274 14.5426 6.61574 14.5426 6.06274ZM10.5426 11.0627C10.5426 10.5097 10.0956 10.0627 9.54257 10.0627H5.54257C4.98957 10.0627 4.54257 10.5097 4.54257 11.0627C4.54257 11.6157 4.98957 12.0627 5.54257 12.0627H9.54257C10.0956 12.0627 10.5426 11.6157 10.5426 11.0627ZM5.54257 15.0627C4.98957 15.0627 4.54257 15.5097 4.54257 16.0627C4.54257 16.6157 4.98957 17.0627 5.54257 17.0627H7.54257C8.09557 17.0627 8.54257 16.6157 8.54257 16.0627C8.54257 15.5097 8.09557 15.0627 7.54257 15.0627H5.54257ZM24.5426 17.0627C24.5426 20.9217 21.4016 24.0627 17.5426 24.0627C13.6836 24.0627 10.5426 20.9217 10.5426 17.0627C10.5426 13.2037 13.6836 10.0627 17.5426 10.0627C21.4016 10.0627 24.5426 13.2037 24.5426 17.0627ZM22.5426 17.0627C22.5426 14.3057 20.2996 12.0627 17.5426 12.0627C14.7856 12.0627 12.5426 14.3057 12.5426 17.0627C12.5426 19.8197 14.7856 22.0627 17.5426 22.0627C20.2996 22.0627 22.5426 19.8197 22.5426 17.0627ZM19.3506 15.8217L17.1276 17.9557C16.9836 18.0967 16.7486 18.0997 16.6056 17.9577L15.4746 16.8497C15.0786 16.4617 14.4466 16.4677 14.0606 16.8637C13.6736 17.2587 13.6796 17.8907 14.0746 18.2777L15.2066 19.3867C15.6666 19.8357 16.2686 20.0607 16.8696 20.0607C17.4706 20.0607 18.0706 19.8357 18.5226 19.3897L20.7356 17.2657C21.1336 16.8827 21.1466 16.2497 20.7646 15.8517C20.3816 15.4517 19.7476 15.4407 19.3506 15.8227V15.8217Z",
    fill: "currentColor"
  }
) }), Cw = () => /* @__PURE__ */ d.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", children: [
  /* @__PURE__ */ d.jsx("path", { d: "M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z", fill: "currentColor" }),
  /* @__PURE__ */ d.jsx("path", { d: "M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z", fill: "currentColor" })
] }), xw = () => /* @__PURE__ */ d.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", children: [
  /* @__PURE__ */ d.jsx("path", { d: "M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1", fill: "currentColor" }),
  /* @__PURE__ */ d.jsx("path", { d: "M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1", fill: "currentColor" })
] }), ww = () => /* @__PURE__ */ d.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", children: [
  /* @__PURE__ */ d.jsx("path", { d: "M10.854 7.854a.5.5 0 0 0-.708-.708L7.5 9.793 6.354 8.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0z", fill: "currentColor" }),
  /* @__PURE__ */ d.jsx("path", { d: "M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z", fill: "currentColor" })
] }), Ow = () => /* @__PURE__ */ d.jsxs("svg", { className: "w-full", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ d.jsxs("g", { children: [
    /* @__PURE__ */ d.jsx("path", { d: "M19.1666 13.3334C18.9456 13.3334 18.7337 13.4212 18.5774 13.5775C18.4211 13.7337 18.3333 13.9457 18.3333 14.1667V15.8334C18.3333 16.4964 18.0699 17.1323 17.6011 17.6011C17.1322 18.07 16.4964 18.3334 15.8333 18.3334H14.1666C13.9456 18.3334 13.7337 18.4212 13.5774 18.5775C13.4211 18.7337 13.3333 18.9457 13.3333 19.1667C13.3333 19.3877 13.4211 19.5997 13.5774 19.756C13.7337 19.9122 13.9456 20 14.1666 20H15.8333C16.938 19.9987 17.997 19.5593 18.7781 18.7782C19.5592 17.9971 19.9987 16.938 20 15.8334V14.1667C20 13.9457 19.9122 13.7337 19.7559 13.5775C19.5996 13.4212 19.3877 13.3334 19.1666 13.3334Z", fill: "currentColor" }),
    /* @__PURE__ */ d.jsx("path", { d: "M0.833333 6.66667C1.05435 6.66667 1.26631 6.57887 1.42259 6.42259C1.57887 6.26631 1.66667 6.05435 1.66667 5.83333V4.16667C1.66667 3.50363 1.93006 2.86774 2.3989 2.3989C2.86774 1.93006 3.50363 1.66667 4.16667 1.66667H5.83333C6.05435 1.66667 6.26631 1.57887 6.42259 1.42259C6.57887 1.26631 6.66667 1.05435 6.66667 0.833333C6.66667 0.61232 6.57887 0.400358 6.42259 0.244078C6.26631 0.0877974 6.05435 0 5.83333 0L4.16667 0C3.062 0.00132321 2.00296 0.440735 1.22185 1.22185C0.440735 2.00296 0.00132321 3.062 0 4.16667L0 5.83333C0 6.05435 0.0877974 6.26631 0.244078 6.42259C0.400358 6.57887 0.61232 6.66667 0.833333 6.66667Z", fill: "currentColor" }),
    /* @__PURE__ */ d.jsx("path", { d: "M5.83333 18.3334H4.16667C3.50363 18.3334 2.86774 18.07 2.3989 17.6011C1.93006 17.1323 1.66667 16.4964 1.66667 15.8334V14.1667C1.66667 13.9457 1.57887 13.7337 1.42259 13.5775C1.26631 13.4212 1.05435 13.3334 0.833333 13.3334C0.61232 13.3334 0.400358 13.4212 0.244078 13.5775C0.0877974 13.7337 0 13.9457 0 14.1667L0 15.8334C0.00132321 16.938 0.440735 17.9971 1.22185 18.7782C2.00296 19.5593 3.062 19.9987 4.16667 20H5.83333C6.05435 20 6.26631 19.9122 6.42259 19.756C6.57887 19.5997 6.66667 19.3877 6.66667 19.1667C6.66667 18.9457 6.57887 18.7337 6.42259 18.5775C6.26631 18.4212 6.05435 18.3334 5.83333 18.3334Z", fill: "currentColor" }),
    /* @__PURE__ */ d.jsx("path", { d: "M15.8333 0H14.1666C13.9456 0 13.7337 0.0877974 13.5774 0.244078C13.4211 0.400358 13.3333 0.61232 13.3333 0.833333C13.3333 1.05435 13.4211 1.26631 13.5774 1.42259C13.7337 1.57887 13.9456 1.66667 14.1666 1.66667H15.8333C16.4964 1.66667 17.1322 1.93006 17.6011 2.3989C18.0699 2.86774 18.3333 3.50363 18.3333 4.16667V5.83333C18.3333 6.05435 18.4211 6.26631 18.5774 6.42259C18.7337 6.57887 18.9456 6.66667 19.1666 6.66667C19.3877 6.66667 19.5996 6.57887 19.7559 6.42259C19.9122 6.26631 20 6.05435 20 5.83333V4.16667C19.9987 3.062 19.5592 2.00296 18.7781 1.22185C17.997 0.440735 16.938 0.00132321 15.8333 0Z", fill: "currentColor" }),
    /* @__PURE__ */ d.jsx("path", { d: "M10 9.16667C10.6593 9.16667 11.3038 8.97117 11.8519 8.6049C12.4001 8.23863 12.8273 7.71803 13.0796 7.10895C13.3319 6.49986 13.3979 5.82964 13.2693 5.18303C13.1407 4.53643 12.8232 3.94249 12.357 3.47631C11.8909 3.01014 11.2969 2.69267 10.6503 2.56405C10.0037 2.43543 9.3335 2.50144 8.72441 2.75374C8.11532 3.00603 7.59473 3.43327 7.22846 3.98143C6.86218 4.5296 6.66669 5.17406 6.66669 5.83334C6.66669 6.71739 7.01788 7.56524 7.643 8.19036C8.26812 8.81548 9.11597 9.16667 10 9.16667ZM10 4.16667C10.3297 4.16667 10.6519 4.26442 10.926 4.44755C11.2001 4.63069 11.4137 4.89099 11.5398 5.19553C11.666 5.50007 11.699 5.83518 11.6347 6.15849C11.5704 6.48179 11.4116 6.77876 11.1785 7.01185C10.9454 7.24493 10.6485 7.40367 10.3252 7.46798C10.0019 7.53229 9.66676 7.49928 9.36222 7.37313C9.05767 7.24699 8.79737 7.03337 8.61424 6.75929C8.4311 6.4852 8.33335 6.16297 8.33335 5.83334C8.33335 5.39131 8.50895 4.96738 8.82151 4.65482C9.13407 4.34226 9.55799 4.16667 10 4.16667Z", fill: "currentColor" }),
    /* @__PURE__ */ d.jsx("path", { d: "M15 16.6667C15.221 16.6667 15.433 16.5789 15.5893 16.4226C15.7456 16.2664 15.8334 16.0544 15.8334 15.8334C15.832 14.5077 15.3048 13.2367 14.3674 12.2993C13.43 11.3619 12.159 10.8347 10.8334 10.8334H9.16669C7.84101 10.8347 6.57001 11.3619 5.63262 12.2993C4.69522 13.2367 4.16801 14.5077 4.16669 15.8334C4.16669 16.0544 4.25448 16.2664 4.41076 16.4226C4.56705 16.5789 4.77901 16.6667 5.00002 16.6667C5.22103 16.6667 5.433 16.5789 5.58928 16.4226C5.74556 16.2664 5.83335 16.0544 5.83335 15.8334C5.83335 14.9493 6.18454 14.1015 6.80966 13.4764C7.43479 12.8512 8.28263 12.5 9.16669 12.5H10.8334C11.7174 12.5 12.5653 12.8512 13.1904 13.4764C13.8155 14.1015 14.1667 14.9493 14.1667 15.8334C14.1667 16.0544 14.2545 16.2664 14.4108 16.4226C14.567 16.5789 14.779 16.6667 15 16.6667Z", fill: "currentColor" })
  ] }),
  /* @__PURE__ */ d.jsx("defs", { children: /* @__PURE__ */ d.jsx("clipPath", { id: "clip0_213_175", children: /* @__PURE__ */ d.jsx("rect", { width: "20", height: "20", fill: "currentColor" }) }) })
] }), Sw = () => /* @__PURE__ */ d.jsx("svg", { viewBox: "0 0 25 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ d.jsx(
  "path",
  {
    d: "M10 1.25C11.3807 1.25 12.5 2.36929 12.5 3.75V6.25H7.50002V3.75C7.50002 2.36929 8.6193 1.25 10 1.25ZM13.75 6.25V3.75C13.75 1.67893 12.0711 0 10 0C7.92895 0 6.25002 1.67893 6.25002 3.75V6.25H4.2015C3.27338 6.25 2.48492 6.92901 2.34724 7.84686L1.06256 16.4114C0.77915 18.3008 2.24246 20 4.15298 20H15.847C17.7576 20 19.2209 18.3008 18.9375 16.4114L17.6528 7.84686C17.5151 6.92901 16.7266 6.25 15.7985 6.25H13.75ZM12.5 7.5V9.375C12.5 9.72018 12.7798 10 13.125 10C13.4702 10 13.75 9.72018 13.75 9.375V7.5H15.7985C16.1079 7.5 16.3707 7.72634 16.4166 8.03229L17.7013 16.5969C17.8713 17.7305 16.9934 18.75 15.847 18.75H4.15298C3.00667 18.75 2.12868 17.7305 2.29873 16.5969L3.58342 8.03229C3.62931 7.72634 3.89213 7.5 4.2015 7.5H6.25002V9.375C6.25002 9.72018 6.52984 10 6.87502 10C7.22019 10 7.50002 9.72018 7.50002 9.375V7.5H12.5Z",
    fill: "currentColor"
  }
) }), Pw = {
  alert: /* @__PURE__ */ d.jsx(SC, {}),
  "arrow-down": /* @__PURE__ */ d.jsx(PC, {}),
  "arrow-left": /* @__PURE__ */ d.jsx(EC, {}),
  "arrow-right": /* @__PURE__ */ d.jsx(jC, {}),
  "back-arrow": /* @__PURE__ */ d.jsx(_C, {}),
  "check-mark": /* @__PURE__ */ d.jsx(DC, {}),
  "circle-check": /* @__PURE__ */ d.jsx(AC, {}),
  "circle-plus": /* @__PURE__ */ d.jsx(MC, {}),
  close: /* @__PURE__ */ d.jsx(TC, {}),
  "collect-menu": /* @__PURE__ */ d.jsx($C, {}),
  "column-actions": /* @__PURE__ */ d.jsx(NC, {}),
  config: /* @__PURE__ */ d.jsx(IC, {}),
  dashboard: /* @__PURE__ */ d.jsx(LC, {}),
  "devices-linked": /* @__PURE__ */ d.jsx(RC, {}),
  "doc-config": /* @__PURE__ */ d.jsx(kC, {}),
  drag: /* @__PURE__ */ d.jsx(BC, {}),
  duplicate: /* @__PURE__ */ d.jsx(VC, {}),
  edit: /* @__PURE__ */ d.jsx(HC, {}),
  export: /* @__PURE__ */ d.jsx(FC, {}),
  eye: /* @__PURE__ */ d.jsx(WC, {}),
  "eye-hide": /* @__PURE__ */ d.jsx(zC, {}),
  filter: /* @__PURE__ */ d.jsx(UC, {}),
  "financing-config": /* @__PURE__ */ d.jsx(ZC, {}),
  "help-card": /* @__PURE__ */ d.jsx(qC, {}),
  home: /* @__PURE__ */ d.jsx(GC, {}),
  "home-2": /* @__PURE__ */ d.jsx(YC, {}),
  lock: /* @__PURE__ */ d.jsx(KC, {}),
  logout: /* @__PURE__ */ d.jsx(XC, {}),
  menu: /* @__PURE__ */ d.jsx(QC, {}),
  "menu-context": /* @__PURE__ */ d.jsx(JC, {}),
  notification: /* @__PURE__ */ d.jsx(ex, {}),
  play: /* @__PURE__ */ d.jsx(tx, {}),
  plus: /* @__PURE__ */ d.jsx(rx, {}),
  projects: /* @__PURE__ */ d.jsx(nx, {}),
  question: /* @__PURE__ */ d.jsx(ax, {}),
  search: /* @__PURE__ */ d.jsx(ix, {}),
  sort: /* @__PURE__ */ d.jsx(ox, {}),
  "success-password": /* @__PURE__ */ d.jsx(sx, {}),
  "traffic-config": /* @__PURE__ */ d.jsx(lx, {}),
  SiacoLogo: /* @__PURE__ */ d.jsx(Ow, {}),
  trash: /* @__PURE__ */ d.jsx(cx, {}),
  user: /* @__PURE__ */ d.jsx(ux, {}),
  "user-change": /* @__PURE__ */ d.jsx(fx, {}),
  "user-config": /* @__PURE__ */ d.jsx(dx, {}),
  "user-inactive": /* @__PURE__ */ d.jsx(px, {}),
  "user-plus": /* @__PURE__ */ d.jsx(hx, {}),
  "user-team": /* @__PURE__ */ d.jsx(vx, {}),
  "user-profile": /* @__PURE__ */ d.jsx(pw, {}),
  view: /* @__PURE__ */ d.jsx(mx, {}),
  viewvalue: /* @__PURE__ */ d.jsx(gx, {}),
  "arrow-turn-down-right": /* @__PURE__ */ d.jsx(yx, {}),
  "memo-circle-check": /* @__PURE__ */ d.jsx(bx, {}),
  "circle-forbidden": /* @__PURE__ */ d.jsx(Cx, {}),
  "circle-exclamation": /* @__PURE__ */ d.jsx(xx, {}),
  "triangle-exclamation": /* @__PURE__ */ d.jsx(wx, {}),
  "floppy-disk": /* @__PURE__ */ d.jsx(Ox, {}),
  calendar: /* @__PURE__ */ d.jsx(Sx, {}),
  "comment-pen": /* @__PURE__ */ d.jsx(Px, {}),
  "files-client": /* @__PURE__ */ d.jsx(Ex, {}),
  "files-included": /* @__PURE__ */ d.jsx(jx, {}),
  "map-location": /* @__PURE__ */ d.jsx(_x, {}),
  "phone-volume": /* @__PURE__ */ d.jsx(Dx, {}),
  envelope: /* @__PURE__ */ d.jsx(Ax, {}),
  whatsapp: /* @__PURE__ */ d.jsx(Mx, {}),
  "folder-arrow-up": /* @__PURE__ */ d.jsx(Tx, {}),
  "files-plus": /* @__PURE__ */ d.jsx($x, {}),
  boat: /* @__PURE__ */ d.jsx(Nx, {}),
  clone: /* @__PURE__ */ d.jsx(Ix, {}),
  plane: /* @__PURE__ */ d.jsx(Lx, {}),
  deposit: /* @__PURE__ */ d.jsx(Rx, {}),
  "in-arrow": /* @__PURE__ */ d.jsx(kx, {}),
  "file-donwload": /* @__PURE__ */ d.jsx(Bx, {}),
  "cloud-donwload": /* @__PURE__ */ d.jsx(Vx, {}),
  "circle-close": /* @__PURE__ */ d.jsx(Hx, {}),
  "bar-code": /* @__PURE__ */ d.jsx(Fx, {}),
  camera: /* @__PURE__ */ d.jsx(Wx, {}),
  flash: /* @__PURE__ */ d.jsx(zx, {}),
  "camera-circle": /* @__PURE__ */ d.jsx(Ux, {}),
  indicator: /* @__PURE__ */ d.jsx(Zx, {}),
  airplane: /* @__PURE__ */ d.jsx(nw, {}),
  "boat-front": /* @__PURE__ */ d.jsx(aw, {}),
  "lower-limit": /* @__PURE__ */ d.jsx(iw, {}),
  "upper-limit": /* @__PURE__ */ d.jsx(ow, {}),
  signature: /* @__PURE__ */ d.jsx(sw, {}),
  map: /* @__PURE__ */ d.jsx(qx, {}),
  coin: /* @__PURE__ */ d.jsx(Gx, {}),
  "send-arrow-up": /* @__PURE__ */ d.jsx(Yx, {}),
  key: /* @__PURE__ */ d.jsx(Kx, {}),
  genio: /* @__PURE__ */ d.jsx(Xx, {}),
  "patch-check": /* @__PURE__ */ d.jsx(Qx, {}),
  pencil: /* @__PURE__ */ d.jsx(Jx, {}),
  cima: /* @__PURE__ */ d.jsx(ew, {}),
  computer: /* @__PURE__ */ d.jsx(tw, {}),
  world: /* @__PURE__ */ d.jsx(rw, {}),
  "refresh-circle": /* @__PURE__ */ d.jsx(lw, {}),
  "calendar-icon": /* @__PURE__ */ d.jsx(cw, {}),
  "calendar-check": /* @__PURE__ */ d.jsx(uw, {}),
  "calendar-close": /* @__PURE__ */ d.jsx(fw, {}),
  "calendar-exclamation": /* @__PURE__ */ d.jsx(dw, {}),
  "journal-check": /* @__PURE__ */ d.jsx(hw, {}),
  "clipboard-check": /* @__PURE__ */ d.jsx(vw, {}),
  circle: /* @__PURE__ */ d.jsx(mw, {}),
  "exclamation-diamond-fill": /* @__PURE__ */ d.jsx(gw, {}),
  "envelope-arrow-up": /* @__PURE__ */ d.jsx(yw, {}),
  "file-text-check": /* @__PURE__ */ d.jsx(bw, {}),
  "pencil-square": /* @__PURE__ */ d.jsx(Cw, {}),
  printer: /* @__PURE__ */ d.jsx(xw, {}),
  "file-earmark-check": /* @__PURE__ */ d.jsx(ww, {}),
  "hand-bag": /* @__PURE__ */ d.jsx(Sw, {})
}, A9 = P.forwardRef((e, t) => {
  const {
    color: r,
    width: n = 20,
    widthFull: a = !1,
    isContain: i = !1,
    variant: o
  } = e, s = {
    width: a || i ? "100%" : n,
    height: i ? "100%" : void 0,
    color: r !== void 0 ? Ae[r] : void 0
  };
  return /* @__PURE__ */ d.jsx("i", { ref: t, className: `block pointer-events-none ${i ? "codeicon-contain" : ""}`, style: s, children: Pw[o] });
});
A9.displayName = "CodeIcon";
const ge = A9, M9 = P.forwardRef((e, t) => {
  const {
    variant: r,
    size: n,
    icon: a,
    children: i,
    isFull: o = !1,
    asSpan: s = !1,
    isLoading: l = !1,
    onlyIcon: c = !1,
    onlyIconMobile: u = !1,
    hideIconDesktop: f = !1,
    unroundedRight: p = !1,
    unroundedLeft: h = !1,
    minWidth: m,
    active: v = !1,
    inactive: g = !1,
    tooltip: y,
    tooltipDirection: b = "top",
    ...w
  } = e, x = "bg-neutral-200 hover:bg-neutral-300 text-neutral-600", C = {
    primary: "bg-primary-100 text-primary-600 hover:bg-primary-300",
    "primary-bold": v ? "bg-primary-500 text-white " : "bg-primary-600 text-white hover:bg-primary-500",
    secondary: v ? "bg-secondary-600 text-white" : "bg-secondary-100 text-secondary-600 hover:bg-secondary-200",
    "secondary-light": v ? "bg-secondary-600 text-white" : "bg-secondary-200 text-secondary-600 hover:bg-secondary-300",
    "secondary-light-bold": "bg-secondary-300 text-secondary-600 hover:bg-secondary-400",
    "secondary-bold": "bg-secondary-600 text-white hover:bg-secondary-500",
    terciary: "bg-secondary-800 text-white hover:bg-secondary-700",
    accent: "bg-accent-600 text-white hover:bg-accent-500",
    info: "bg-info-500 text-white hover:bg-info-400",
    warning: "bg-warning-500 text-white hover:bg-warning-400",
    success: "bg-success-500 text-white hover:bg-success-400",
    error: "bg-error-500 text-white hover:bg-error-400",
    "error-light": v ? "bg-error-100 text-error-500" : "bg-error-50 text-error-500 hover:bg-error-100",
    "error-light-bold": "bg-error-200 text-error-500 hover:bg-error-300",
    "white-secondary": "bg-white text-secondary-600 hover:bg-secondary-100"
  }, S = `h-[3rem] ${u ? "px-0 m:px-[1rem]" : `${c ? "px-0" : "px-[1rem]"}`}`, E = "fill-neutral-200", D = {
    primary: "fill-primary-100",
    "primary-bold": "fill-primary-600",
    secondary: "fill-secondary-100",
    "secondary-light": "fill-secondary-200",
    "secondary-light-bold": "fill-secondary-300",
    "secondary-bold": "fill-secondary-600",
    terciary: "fill-secondary-800",
    accent: "fill-accent-600",
    info: "fill-info-500",
    warning: "fill-warning-500",
    success: "fill-success-500",
    error: "fill-error-500",
    "error-light": "fill-error-50",
    "error-light-bold": "fill-error-200",
    "white-secondary": "fill-white"
  }, I = {
    xs: `h-[16px] ${u ? "px-0 m:px-[1rem]" : `${c ? "px-0" : "px-[1rem]"}`}`,
    s: `h-[32px] ${u ? "px-0 m:px-[1rem]" : `${c ? "px-0" : "px-[1rem]"}`}`,
    m: `h-10 ${u ? "px-0 m:px-[1rem]" : `${c ? "px-0" : "px-[1rem]"}`}`,
    l: `h-10 ${u ? "px-0 m:px-[1.25rem]" : `${c ? "px-0" : "px-[1.25rem]"}`}`,
    "2l": `h-10 ${u ? "px-0 m:px-[1.5rem]" : `${c ? "px-0" : "px-[1.5rem]"}`}`,
    xl: `h-[64px] ${u ? "px-0 m:px-[1.5rem]" : `${c ? "px-0" : "px-[1.5rem]"}`}`
  }, k = {
    top: "after:left-1/2 after:-translate-x-1/2 after:bottom-[calc(100%+15px)] before:left-1/2 before:-translate-x-1/2 before:bottom-[calc(100%+6px)] before:border-t-info-500 before:border-t-[9px] before:border-x-transparent before:border-x-[6px]",
    bottom: "after:left-1/2 after:-translate-x-1/2 after:top-[calc(100%+15px)] before:left-1/2 before:-translate-x-1/2 before:top-[calc(100%+6px)] before:border-b-info-500 before:border-b-[9px] before:border-x-transparent before:border-x-[6px]",
    left: "after:left-0 after:-translate-x-[calc(100%+15px)] after:top-1/2 after:-translate-y-1/2 before:left-0 before:-translate-x-[calc(100%+6px)] before:top-1/2 before:-translate-y-1/2 before:border-l-info-500 before:border-l-[9px] before:border-y-transparent before:border-y-[6px]",
    right: "after:right-0 after:translate-x-[calc(100%+15px)] after:top-1/2 after:-translate-y-1/2 before:right-0 before:translate-x-[calc(100%+6px)] before:top-1/2 before:-translate-y-1/2 before:border-r-info-500 before:border-r-[9px] before:border-y-transparent before:border-y-[6px]"
  }, V = Ne([
    "cursor-pointer border border-transparent flex items-center font-bold relative leading-[100%]",
    "disabled:opacity-50 disabled:pointer-events-none",
    h ? void 0 : "rounded-l-md",
    p ? void 0 : "rounded-r-md",
    r !== void 0 ? g ? "bg-neutral-300 text-neutral-400 pointer-events-none" : C[r] : x,
    a !== void 0 ? c ? "aspect-square justify-center" : u ? f ? "gap-[10px] justify-center aspect-square m:aspect-auto" : "gap-[10px] justify-center m:max-w-[fit-content] aspect-square m:aspect-auto" : "gap-[10px] justify-center max-w-[fit-content]" : "justify-center",
    n !== void 0 ? I[n] : S,
    l ? "pointer-events-none" : void 0,
    o ? "w-full max-w-full" : void 0,
    m !== void 0 ? u ? "m:w-[var(--ck-button-min-width)]" : "w-[var(--ck-button-min-width)]" : void 0,
    y !== void 0 && !v ? `${k[b]} relative after:content-[attr(data-title)] after:w-[180px] after:absolute after:z-[10] after:bg-info-500 after:h-[max-content] after:p-2 after:rounded-md after:text-s after:leading-[120%] after:text-white after:justify-center after:items-center after:hidden hover:after:flex before:absolute before:z-[10] before:hidden hover:before:block whitespace-pre-line` : void 0
  ]), W = {};
  return m !== void 0 && (W["--ck-button-min-width"] = `${m}px`), s ? /* @__PURE__ */ d.jsxs(
    "span",
    {
      ref: t,
      className: V,
      style: W,
      "data-title": y,
      ...w,
      children: [
        a !== void 0 && /* @__PURE__ */ d.jsx("span", { className: `${a === "close" ? "w-[14px]" : "w-5"} aspect-square ${f ? "block m:hidden" : "block"}`, children: /* @__PURE__ */ d.jsx(ge, { variant: a, isContain: !0 }) }),
        /* @__PURE__ */ d.jsx("p", { className: `${u ? "hidden m:block" : "block"}`, children: i })
      ]
    }
  ) : /* @__PURE__ */ d.jsxs(
    "button",
    {
      ref: t,
      className: V,
      style: W,
      "data-title": y,
      ...w,
      children: [
        a !== void 0 && /* @__PURE__ */ d.jsx("span", { className: `${a === "close" ? "w-[14px]" : "w-5"} aspect-square ${f ? "block m:hidden" : "block"}`, children: /* @__PURE__ */ d.jsx(ge, { variant: a, isContain: !0 }) }),
        /* @__PURE__ */ d.jsx("p", { className: `${u ? "hidden m:block" : "block"}`, children: i }),
        l && /* @__PURE__ */ d.jsxs("div", { className: `absolute top-0 left-0 w-full h-full flex items-center justify-center ${r !== void 0 ? C[r] : x}`, children: [
          /* @__PURE__ */ d.jsxs(
            "svg",
            {
              "aria-hidden": "true",
              className: `h-[65%] aspect-square animate-spin ${r !== void 0 ? D[r] : E}`,
              viewBox: "0 0 100 101",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: [
                /* @__PURE__ */ d.jsx("path", { d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z", fill: "currentColor" }),
                /* @__PURE__ */ d.jsx("path", { d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z", fill: "currentFill" })
              ]
            }
          ),
          /* @__PURE__ */ d.jsx("span", { className: "sr-only", children: "Loading..." })
        ] })
      ]
    }
  );
});
M9.displayName = "Button";
const Ut = M9, cn = Jn(null), Ew = ({ children: e }) => {
  const [t, r] = je(() => ({
    isCollapsedMenu: window.localStorage.getItem("cima-is-collapsed-menu") === "true",
    isOpenMenuUser: !1,
    isOpenNotifications: !1,
    isOpenMenu: !1
  })), n = () => {
    r((u) => ({
      ...u,
      isOpenMenu: !1,
      isOpenNotifications: !u.isOpenNotifications
    }));
  }, a = () => {
    r((u) => ({
      ...u,
      isOpenNotifications: !1
    }));
  }, i = () => {
    r((u) => ({
      ...u,
      isOpenNotifications: !1,
      isOpenMenu: !u.isOpenMenu
    }));
  }, o = () => {
    r((u) => ({
      ...u,
      isOpenMenu: !1
    }));
  }, s = () => {
    r((u) => {
      const f = !u.isCollapsedMenu;
      return window.localStorage.setItem("cima-is-collapsed-menu", f ? "true" : "false"), {
        ...u,
        isCollapsedMenu: f
      };
    });
  }, l = () => {
    r((u) => ({
      ...u,
      isOpenMenuUser: !u.isOpenMenuUser
    }));
  }, c = () => {
    r((u) => ({
      ...u,
      isOpenMenuUser: !1
    }));
  };
  return Me(() => {
    t.isOpenMenu ? document.body.classList.add("overflow-y-hidden-dashboard") : document.body.classList.remove("overflow-y-hidden-dashboard");
  }, [t.isOpenMenu]), /* @__PURE__ */ d.jsx(
    cn.Provider,
    {
      value: {
        isOpenMenu: t.isOpenMenu,
        isCollapsedMenu: t.isCollapsedMenu,
        isOpenNotifications: t.isOpenNotifications,
        isOpenMenuUser: t.isOpenMenuUser,
        toggleOpenMenu: i,
        closeMenu: o,
        toggleCollapsedMenu: s,
        toggleOpenNotifications: n,
        closeNotifications: a,
        toggleOpenMenuUser: l,
        closeMenuUser: c
      },
      children: e
    }
  );
};
Ew.displayName = "Dashboard";
const jw = P.forwardRef((e, t) => {
  const {
    isPadding: r = !1,
    children: n,
    ...a
  } = e, i = _t(cn), o = (i == null ? void 0 : i.isCollapsedMenu) ?? !1;
  return /* @__PURE__ */ d.jsx("main", { ref: t, className: `${r ? "px-4 py-4" : "px-0"} bg-white pb-[4.5rem] 2s:pb-4 2s:pt-[4.5rem] l:pt-[5rem] ${o ? "l:ml-[130px]" : "l:ml-72"}`, ...a, children: n });
});
jw.displayName = "DashboardMain";
const _w = P.forwardRef((e, t) => {
  const {
    text: r,
    color: n,
    children: a
  } = e, i = {
    color: n !== void 0 ? Ae[n] : void 0,
    fontWeight: n !== void 0 ? 600 : void 0
  }, o = {
    backgroundColor: n !== void 0 ? Ae[n] : Ae["neutral-300"]
  };
  return /* @__PURE__ */ d.jsxs("div", { ref: t, className: "flex flex-col 2s:flex-row 2s:justify-between gap-4 items-center", children: [
    /* @__PURE__ */ d.jsxs("div", { className: "relative text-center 2s:text-left 2s:flex-grow 2s:flex 2s:gap-4 2s:justify-between 2s:items-center", children: [
      r !== void 0 && /* @__PURE__ */ d.jsx("p", { className: "leading-[120%]", style: i, children: r }),
      /* @__PURE__ */ d.jsx("span", { className: "hidden 2s:block h-[1px] 2s:flex-grow", style: o })
    ] }),
    /* @__PURE__ */ d.jsx("div", { className: "w-full 2s:w-auto", children: a })
  ] });
});
_w.displayName = "Divider";
const _ue = () => {
  const e = new CustomEvent("codekit:closeDropdown");
  document.dispatchEvent(e);
}, Dw = {
  actions: "bg-white w-full min-w-[148px] max-w-[240px] p-4 shadow-l",
  box: "bg-white w-[287px] p-8 shadow-l text-center",
  "box-danger": "bg-error-100 w-[287px] p-8 text-center"
}, T9 = P.forwardRef((e, t) => {
  const {
    button: r,
    variant: n = "box",
    children: a
  } = e, [i, o] = je(!1), s = ye(null), l = ye(null), c = () => P.Children.map(r, (p) => P.cloneElement(p, {
    ref: s,
    active: i,
    onClick: () => {
      o((h) => !h);
    }
  })), u = () => P.Children.map(a, (p) => P.cloneElement(p, {
    closeDropdown: () => {
      o(!1);
    }
  })), f = (p) => {
    if (s.current !== null && !s.current.contains(p.target)) {
      if (l.current !== null) {
        if (l.current.contains(p.target))
          return;
        o(!1);
        return;
      }
      o(!1);
    }
  };
  return Me(() => {
    const p = () => {
      o(!1);
    };
    return document.addEventListener("codekit:closeDropdown", p, !0), () => {
      document.removeEventListener("codekit:closeDropdown", p, !0);
    };
  }, []), Me(() => (document.addEventListener("click", f, !0), () => {
    document.removeEventListener("click", f, !0);
  }), []), /* @__PURE__ */ d.jsxs("div", { ref: t, className: "relative max-w-[fit-content]", children: [
    c(),
    i && /* @__PURE__ */ d.jsx("div", { ref: l, className: "w-[max-content] absolute top-[calc(100%+5px)] z-[2] right-0 pb-[80px] pointer-events-none", children: /* @__PURE__ */ d.jsx(
      "div",
      {
        className: Ne([
          Dw[n],
          "rounded-md pointer-events-auto"
        ]),
        children: u()
      }
    ) })
  ] });
});
T9.displayName = "Dropdown";
const I2 = P.forwardRef((e, t) => {
  const {
    icon: r,
    children: n,
    onClick: a,
    closeDropdown: i,
    ...o
  } = e, s = (l) => {
    i !== void 0 && i(), a !== void 0 && a(l);
  };
  return /* @__PURE__ */ d.jsxs(
    "button",
    {
      ref: t,
      onClick: s,
      className: "text-secondary-600 gap-2 px-2 py-[10px] flex items-center hover:bg-secondary-200 w-full outline-none shadow-transparent rounded-md",
      ...o,
      children: [
        /* @__PURE__ */ d.jsx("span", { className: `${r === "close" ? "w-[14px]" : "w-5"} aspect-square block`, children: /* @__PURE__ */ d.jsx(ge, { variant: r, isContain: !0 }) }),
        /* @__PURE__ */ d.jsx("div", { className: "flex-grow", children: /* @__PURE__ */ d.jsx("p", { className: "leading-[120%] font-bold text-left", children: n }) })
      ]
    }
  );
});
I2.displayName = "DropdownAction";
const Aw = P.forwardRef((e, t) => {
  const {
    children: r
  } = e, n = "px-4 py-2 min-h-[40px] h-full leading-[120%] font-bold text-neutral-400 flex items-center";
  return /* @__PURE__ */ d.jsxs("div", { ref: t, className: "grid gap-2", children: [
    /* @__PURE__ */ d.jsxs("div", { className: "hidden m:grid grid-cols-export-table", children: [
      /* @__PURE__ */ d.jsx("div", { className: n, style: { gridArea: "name" }, children: "Nombre" }),
      /* @__PURE__ */ d.jsx("div", { className: n, style: { gridArea: "date" }, children: "Fecha de creación" }),
      /* @__PURE__ */ d.jsx("div", { className: n, style: { gridArea: "type" }, children: "Tipo de plantilla" }),
      /* @__PURE__ */ d.jsx("div", { className: n, style: { gridArea: "user" }, children: "Usuario" }),
      /* @__PURE__ */ d.jsx("div", { className: n, style: { gridArea: "actions" }, children: "Acciones" })
    ] }),
    r
  ] });
});
Aw.displayName = "ExportTable";
const Mw = P.forwardRef((e, t) => {
  const {
    name: r,
    date: n,
    type: a,
    user: i,
    children: o
  } = e, s = "m:border-r m:border-white m:h-full m:flex m:items-center m:px-4 m:py-2 m:min-h-[48px]";
  return /* @__PURE__ */ d.jsxs("div", { ref: t, className: "grid grid-cols-export-table items-center p-4 m:p-0 rounded-md bg-secondary-100 border border-neutral-100 leading-[120%]", children: [
    /* @__PURE__ */ d.jsx("div", { style: { gridArea: "name" }, className: `font-bold pr-3 ${s}`, children: r }),
    /* @__PURE__ */ d.jsx("div", { style: { gridArea: "date" }, className: `mt-2 m:mt-0 ${s}`, children: n }),
    /* @__PURE__ */ d.jsx("div", { style: { gridArea: "type" }, className: `mt-2 m:mt-0 ${s}`, children: a }),
    /* @__PURE__ */ d.jsx(
      "div",
      {
        style: { gridArea: "user" },
        className: `mt-3 pt-3 border-t border-secondary-200 m:mt-0 m:border-r-none ${s}`,
        children: /* @__PURE__ */ d.jsxs("div", { className: "flex gap-2 items-center", children: [
          /* @__PURE__ */ d.jsx("div", { className: "w-[14px] min-w-[24px]", children: /* @__PURE__ */ d.jsx(qs, { size: "xs", image: i.image }) }),
          /* @__PURE__ */ d.jsx("div", { className: "flex-grow", children: /* @__PURE__ */ d.jsx("p", { children: i.name }) })
        ] })
      }
    ),
    /* @__PURE__ */ d.jsx("div", { style: { gridArea: "actions" }, className: "s:flex s:px-4 s:h-full s:items-center s:justify-center", children: /* @__PURE__ */ d.jsx("div", { className: "flex gap-2 items-center", children: o }) })
  ] });
});
Mw.displayName = "ExportTableCol";
const Tw = {
  normal: "normal",
  start: "flex-start",
  end: "flex-end",
  center: "center",
  between: "space-between",
  around: "space-around",
  evenly: "space-evenly",
  stretch: "stretch"
}, $w = {
  start: "flex-start",
  end: "flex-end",
  center: "center",
  baseline: "baseline",
  stretch: "stretch"
}, sn = P.forwardRef((e, t) => {
  const {
    direction: r = "row",
    gap: n,
    gapY: a,
    gapX: i,
    justifyContent: o,
    alignItems: s,
    wrap: l = !1,
    minHeight: c,
    children: u,
    ...f
  } = e, p = {
    justifyContent: o !== void 0 ? Tw[o] : void 0,
    alignItems: s !== void 0 ? $w[s] : void 0,
    flexWrap: l ? "wrap" : void 0,
    flexDirection: r,
    minHeight: c
  };
  return n !== void 0 ? p.gap = n !== void 0 ? `${n / 4}rem` : void 0 : (p.columnGap = i !== void 0 ? `${i / 4}rem` : void 0, p.rowGap = a !== void 0 ? `${a / 4}rem` : void 0), /* @__PURE__ */ d.jsx(
    "div",
    {
      ref: t,
      className: "flex",
      style: p,
      ...f,
      children: u
    }
  );
});
sn.displayName = "Flexbox";
const $o = P.forwardRef((e, t) => {
  const {
    grow: r = !1,
    minWidth: n,
    children: a,
    ...i
  } = e, o = {
    flexGrow: r ? 1 : void 0
  };
  return n !== void 0 && (o.minWidth = `${n}px`), /* @__PURE__ */ d.jsx(
    "div",
    {
      ref: t,
      className: "block",
      style: o,
      ...i,
      children: a
    }
  );
});
$o.displayName = "FlexboxRow";
function $9(e, t = 500) {
  const [r, n] = je(e);
  return Me(() => {
    const a = setTimeout(() => {
      n(e);
    }, t);
    return () => {
      clearTimeout(a);
    };
  }, [e, t]), r;
}
const Nw = P.forwardRef((e, t) => {
  const {
    icon: r,
    variant: n = "default",
    isInvalid: a = !1,
    isSuccess: i = !1,
    selected: o = null,
    placeholder: s = "Search...",
    textLoading: l = "Cargando...",
    textNoResults: c = "No hay resultados",
    minLengthToSearch: u = 5,
    searchResults: f = [],
    disabled: p,
    readOnly: h,
    onChangeSearch: m,
    onItemClick: v,
    onResetSelected: g
  } = e, [y, b] = je(""), [w, x] = je(!1), [C, S] = je(!1), E = ye(!0), D = $9(y), I = () => {
    S(!1);
  };
  return Me(() => {
    if (E.current) {
      E.current = !1;
      return;
    }
    if (!(p === !0 || h === !0)) {
      if (D.trim().length < u) {
        x(!1);
        return;
      }
      x(!0), m(D.trim(), I);
    }
  }, [D]), /* @__PURE__ */ d.jsxs(
    "div",
    {
      className: Ne([
        "relative flex w-full text-neutral-600 h-10"
      ]),
      children: [
        /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
          o === null || o === "" ? /* @__PURE__ */ d.jsx(
            "input",
            {
              ref: t,
              type: "text",
              placeholder: s,
              value: y,
              onChange: (k) => {
                b(k.target.value), S(!0);
              },
              className: Ne([
                "w-full h-full flex items-center border rounded-md outline-none shadow-transparent placeholder:text-neutral-400",
                h === !0 || p === !0 ? "cursor-default pointer-events-none" : "hover:border-secondary-400 focus:border-secondary-600",
                p === !0 ? "bg-neutral-300" : n === "default" ? "bg-neutral-200" : "bg-white",
                p === !0 ? "border-neutral-300" : a ? "border-error-500" : i ? "border-success-500" : n === "default" ? "border-neutral-300" : "border-secondary-300",
                r !== void 0 ? "pl-4 pr-[2.75rem]" : "px-4"
              ])
            }
          ) : /* @__PURE__ */ d.jsx(
            "div",
            {
              className: Ne([
                "w-full h-full flex items-center border rounded-md",
                h === !0 || p === !0 ? "cursor-default pointer-events-none" : "hover:border-secondary-400",
                p === !0 ? "bg-neutral-300 border-neutral-300" : n === "default" ? "bg-neutral-200 border-neutral-300" : "bg-white border-secondary-300",
                r !== void 0 ? "pl-4 pr-[2.75rem]" : "px-4"
              ]),
              children: /* @__PURE__ */ d.jsxs(
                "div",
                {
                  className: Ne([
                    "h-8 flex gap-2 items-center pr-2 overflow-hidden rounded-[24px] border",
                    h === !0 || p === !0 ? "pl-2" : "pl-4",
                    p === !0 ? "border-neutral-400 text-neutral-400" : h === !0 ? "border-secondary-400 text-secondary-400" : "border-secondary-600 text-secondary-600"
                  ]),
                  children: [
                    /* @__PURE__ */ d.jsx("div", { className: "flex-grow cursor-default overflow-hidden", children: /* @__PURE__ */ d.jsx("p", { className: "font-bold leading-[120%] text-ellipsis overflow-hidden whitespace-nowrap", children: o }) }),
                    h !== !0 && p !== !0 && /* @__PURE__ */ d.jsx("div", { className: "w-[20px] min-w-[20px] h-[20px]", children: /* @__PURE__ */ d.jsx(
                      "button",
                      {
                        type: "button",
                        className: "w-full h-full rounded-full bg-secondary-600 flex items-center justify-center text-white",
                        onClick: () => {
                          b(""), S(!1), x(!1), g();
                        },
                        children: /* @__PURE__ */ d.jsx(ge, { variant: "close", width: 10 })
                      }
                    ) })
                  ]
                }
              )
            }
          ),
          r !== void 0 && /* @__PURE__ */ d.jsx("span", { className: "absolute right-[1rem] top-1/2 -translate-y-1/2 z-[1]", children: /* @__PURE__ */ d.jsx(ge, { variant: r, width: 18 }) })
        ] }),
        w && /* @__PURE__ */ d.jsx("div", { className: "absolute top-[calc(100%+4px)] left-0 w-full pointer-events-none min-w-[280px] z-[1] pb-[80px]", children: /* @__PURE__ */ d.jsx("div", { className: "bg-white rounded-lg p-4 shadow-l w-full pointer-events-auto overflow-y-scroll table-main-scrollbar", style: { maxHeight: "250px" }, children: /* @__PURE__ */ d.jsx(d.Fragment, { children: C ? /* @__PURE__ */ d.jsxs("div", { className: "p-4 flex flex-col gap-4 items-center justify-center", children: [
          /* @__PURE__ */ d.jsxs(
            "svg",
            {
              "aria-hidden": "true",
              className: "w-[45px] aspect-square animate-spin fill-white text-secondary-600",
              viewBox: "0 0 100 101",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: [
                /* @__PURE__ */ d.jsx("path", { d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z", fill: "currentColor" }),
                /* @__PURE__ */ d.jsx("path", { d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z", fill: "currentFill" })
              ]
            }
          ),
          /* @__PURE__ */ d.jsx("span", { children: l })
        ] }) : /* @__PURE__ */ d.jsx(d.Fragment, { children: f.length > 0 ? /* @__PURE__ */ d.jsx("ul", { children: f.map((k) => /* @__PURE__ */ d.jsxs(
          "li",
          {
            className: "flex gap-2 items-center cursor-pointer p-4 rounded-md hover:bg-secondary-100",
            onClick: () => {
              x(!1), v({ item: k });
            },
            children: [
              k.image !== void 0 && /* @__PURE__ */ d.jsx(qs, { size: "md", image: k.image }),
              /* @__PURE__ */ d.jsx("div", { className: "flex-grow", children: /* @__PURE__ */ d.jsx("p", { className: "leading-[120%] font-bold", children: k.label }) })
            ]
          },
          k.id
        )) }) : /* @__PURE__ */ d.jsxs("div", { className: "flex flex-col gap-4 items-center justify-center p-4", children: [
          /* @__PURE__ */ d.jsx(ge, { variant: "search", width: 45, color: "secondary-600" }),
          /* @__PURE__ */ d.jsx("span", { className: "block mx-auto text-center w-[90%] max-w-[500px]", children: c })
        ] }) }) }) }) })
      ]
    }
  );
});
Nw.displayName = "Autocomplete";
const N9 = P.forwardRef((e, t) => {
  const {
    disabled: r,
    readOnly: n,
    checked: a = !1,
    type: i = "default",
    variant: o = "default",
    isBold: s = !1,
    variantSize: l = "sm",
    children: c,
    onChange: u,
    ...f
  } = e, p = (h) => {
    n === !0 || r === !0 || u !== void 0 && u(h);
  };
  return /* @__PURE__ */ d.jsxs("label", { className: `flex items-center ${l === "sm" ? "gap-4" : "gap-2"} select-none`, children: [
    /* @__PURE__ */ d.jsx("input", { ref: t, type: "checkbox", className: "hidden", checked: a, onChange: p, ...f }),
    i === "default" && /* @__PURE__ */ d.jsx(
      "span",
      {
        className: Ne([
          "flex w-6 min-w-[24px] h-6 justify-center items-center border text-white overflow-hidden rounded-xs transition-colors",
          n === !0 || r === !0 ? "cursor-default pointer-events-none" : "cursor-pointer hover:border-secondary-400",
          r === !0 ? a ? "bg-neutral-400 border-neutral-400" : "bg-neutral-300 border-neutral-300" : a ? "bg-secondary-600 border-secondary-600 hover:border-secondary-600" : o === "default" ? "bg-neutral-200 border-neutral-300" : "bg-white border-secondary-300"
        ]),
        children: a && /* @__PURE__ */ d.jsx(ge, { variant: "check-mark", width: 16 })
      }
    ),
    i === "switch" && /* @__PURE__ */ d.jsx(
      "div",
      {
        className: Ne([
          "relative border rounded-[200px]",
          l === "xs" ? "h-5 w-[37px] min-w-[37px]" : "h-6 w-[54px] min-w-[54px]",
          n === !0 || r === !0 ? "cursor-default pointer-events-none" : "cursor-pointer",
          r === !0 ? a ? "bg-neutral-400 border-neutral-400" : "bg-neutral-300 border-neutral-300" : a ? "bg-secondary-600 border-secondary-600" : o === "white" ? "bg-white border-secondary-300 hover:border-secondary-400" : "bg-neutral-200 border-neutral-300 hover:border-secondary-400"
        ]),
        children: /* @__PURE__ */ d.jsx(
          "span",
          {
            className: Ne([
              "block absolute transition-all rounded-full top-1/2 -translate-y-1/2",
              l === "sm" ? "w-5 h-5" : "w-4 h-4",
              a ? l === "sm" ? "left-[31px]" : "left-[17px]" : "left-[2px]",
              o === "default" || a || r === !0 ? "bg-white" : "bg-secondary-400"
            ])
          }
        )
      }
    ),
    /* @__PURE__ */ d.jsx("span", { className: "flex-grow", children: s ? /* @__PURE__ */ d.jsx(lr, { variant: "title-2", children: c }) : /* @__PURE__ */ d.jsx(yr, { variant: "description-2", children: c }) })
  ] });
});
N9.displayName = "Checkbox";
const Iw = P.forwardRef((e, t) => {
  const {
    children: r,
    ...n
  } = e;
  return /* @__PURE__ */ d.jsx("span", { ref: t, ...n, className: "block text-s mt-1.5 leading-[120%] text-error-500", children: r });
});
Iw.displayName = "FieldError";
const I9 = P.forwardRef((e, t) => {
  const {
    variant: r = "default",
    type: n = "text",
    isInvalid: a = !1,
    isSuccess: i = !1,
    isOtp: o = !1,
    iconLeft: s,
    iconRight: l,
    ...c
  } = e, [u, f] = je(!1);
  return /* @__PURE__ */ d.jsxs(
    "div",
    {
      className: `relative w-full block text-neutral-600 ${o ? "h-[4.9rem]" : "h-10"}`,
      children: [
        /* @__PURE__ */ d.jsx(
          "input",
          {
            ref: t,
            type: n === "password" ? u ? "text" : "password" : n,
            step: n === "number" ? "any" : "",
            className: Ne([
              `
            flex items-center w-full h-full outline-none shadow-transparent
            border rounded-md text-neutral-600 leading-none
            hover:border-secondary-400
            focus:border-secondary-600
            placeholder:text-neutral-400
            disabled:text-neutral-400 disabled:bg-neutral-300 disabled:pointer-events-none
            read-only:hover:border-neutral-300 read-only:focus:border-neutral-300 read-only:text-neutral-400
          `,
              r === "white" ? "bg-white" : "bg-neutral-200",
              a ? "border-error-500" : i ? "border-success-500" : r === "white" ? "border-secondary-300" : "border-neutral-300",
              o ? "text-center" : void 0,
              n === "password" ? "pl-[1rem] pr-[2.75rem]" : o ? "px-4" : `${l !== void 0 ? "pr-[2.75rem]" : "pr-4"} ${s !== void 0 ? "pl-[2.75rem]" : "pl-4"}`
            ]),
            ...c,
            onWheel: (p) => {
              n === "number" && p.currentTarget.blur();
            },
            max: n === "date" ? "3000-01-01" : ""
          }
        ),
        n === "password" ? /* @__PURE__ */ d.jsx(
          "button",
          {
            onClick: () => {
              f((p) => !p);
            },
            type: "button",
            className: "absolute right-[1rem] top-1/2 -translate-y-1/2 z-[1]",
            children: u ? /* @__PURE__ */ d.jsx(ge, { variant: "eye-hide" }) : /* @__PURE__ */ d.jsx(ge, { variant: "eye" })
          }
        ) : l !== void 0 ? /* @__PURE__ */ d.jsx("span", { className: "absolute right-[1rem] top-1/2 -translate-y-1/2 z-[1]", children: /* @__PURE__ */ d.jsx(ge, { variant: l, width: 18 }) }) : s !== void 0 ? /* @__PURE__ */ d.jsx("span", { className: "absolute left-[1rem] top-1/2 -translate-y-1/2 z-[1]", children: /* @__PURE__ */ d.jsx(ge, { variant: s, width: 18 }) }) : null
      ]
    }
  );
});
I9.displayName = "Input";
const Z0 = P.forwardRef((e, t) => {
  const {
    alignment: r,
    children: n,
    weight: a = "bold",
    color: i,
    icon: o,
    ...s
  } = e, l = {
    textAlign: r,
    fontWeight: a !== void 0 ? Gs[a] : void 0,
    color: i !== void 0 ? Ae[i] : void 0
  };
  return /* @__PURE__ */ d.jsxs("label", { ref: t, ...s, className: "block text-[1rem] mb-2 leading-[120%]", style: l, children: [
    o !== void 0 && /* @__PURE__ */ d.jsx("span", { className: "inline-block w-7", children: /* @__PURE__ */ d.jsx(ge, { variant: o }) }),
    n
  ] });
});
Z0.displayName = "Label";
const Lw = P.forwardRef((e, t) => {
  const {
    value: r,
    readOnly: n,
    disabled: a,
    checked: i = !1,
    isBold: o = !1,
    variant: s = "default",
    children: l,
    onChange: c,
    ...u
  } = e, f = (p) => {
    n === !0 || a === !0 || c !== void 0 && c(p);
  };
  return /* @__PURE__ */ d.jsxs("label", { className: "flex items-center gap-3 select-none", children: [
    /* @__PURE__ */ d.jsx("input", { ref: t, type: "radio", className: "hidden", checked: i, onChange: f, ...u }),
    /* @__PURE__ */ d.jsx(
      "span",
      {
        className: Ne([
          "flex w-6 min-w-[24px] h-6 justify-center items-center overflow-hidden rounded-full border",
          n === !0 || a === !0 ? "cursor-default pointer-events-none" : "cursor-pointer",
          a === !0 ? `${i ? "bg-white" : "bg-neutral-300"} border-neutral-300` : s === "white" ? `bg-white ${i ? "border-secondary-600" : "border-secondary-300"}` : `bg-neutral-200 ${i ? "border-secondary-600" : "border-neutral-300"}`,
          i ? void 0 : "hover:border-secondary-400"
        ]),
        children: /* @__PURE__ */ d.jsx("span", { className: `block w-[18px] h-[18px] overflow-hidden ${a === !0 ? "bg-neutral-300" : "bg-secondary-600"} rounded-full transition-opacity ${i ? "opacity-100" : "opacity-0"}` })
      }
    ),
    /* @__PURE__ */ d.jsx("span", { className: "flex-grow", children: o ? /* @__PURE__ */ d.jsx(lr, { variant: "title-2", children: l }) : /* @__PURE__ */ d.jsx(yr, { variant: "description-2", children: l }) })
  ] });
});
Lw.displayName = "Radio";
const L2 = P.forwardRef((e, t) => {
  const {
    options: r = [],
    value: n = "",
    variant: a = "default",
    readOnly: i = !1,
    disabled: o = !1,
    isInvalid: s = !1,
    isSuccess: l = !1,
    placeholder: c = "Seleccione una opción",
    onChangeValue: u
  } = e, [f, p] = je(!1), h = ye(null), m = ye(null), v = r.find((b) => b.value === n), g = (v == null ? void 0 : v.text) ?? c, y = (b) => {
    if (h.current !== null && !h.current.contains(b.target)) {
      if (m.current !== null) {
        if (m.current.contains(b.target))
          return;
        p(!1);
        return;
      }
      p(!1);
    }
  };
  return Me(() => (document.addEventListener("click", y, !0), () => {
    document.removeEventListener("click", y, !0);
  }), []), /* @__PURE__ */ d.jsx("div", { ref: t, className: `w-full block text-neutral-600 ${a === "no-border" ? "h-[38px]" : "h-10"}`, children: /* @__PURE__ */ d.jsxs("div", { className: "relative w-full h-full", children: [
    /* @__PURE__ */ d.jsxs(
      "div",
      {
        ref: h,
        onClick: () => {
          !i && !o && r.length > 0 && p((b) => !b);
        },
        className: Ne([
          "rounded-md flex items-center w-full gap-3 h-full px-4 leading-none",
          i ? "" : "cursor-pointer select-none",
          o ? "bg-neutral-300 text-neutral-400 pointer-events-none" : a === "white" ? "bg-white text-neutral-600" : "bg-neutral-200 text-neutral-600",
          f ? "border-secondary-600" : i ? "" : "hover:border-secondary-400",
          o ? "border border-neutral-300" : a !== "no-border" ? s ? f ? "border border-secondary-600" : "border border-error-500" : l ? f ? "border border-secondary-600" : "border border-success-500" : a === "white" ? "border border-secondary-300" : "border border-neutral-300" : void 0
        ]),
        children: [
          /* @__PURE__ */ d.jsx("div", { className: "flex-grow overflow-hidden", children: /* @__PURE__ */ d.jsx("div", { className: "w-full pointer-events-none text-clamp-1 leading-[32px] break-all", children: g }) }),
          r.length > 0 && /* @__PURE__ */ d.jsx("span", { className: `w-[14px] min-w-[14px] ${f ? "rotate-180" : ""}`, children: /* @__PURE__ */ d.jsx(ge, { variant: "arrow-down", width: 14 }) })
        ]
      }
    ),
    f && r.length > 0 && !i && !o && /* @__PURE__ */ d.jsx("div", { ref: m, className: "absolute top-[calc(100%+8px)] left-0 w-full min-w-[250px] z-[1500] overflow-y-scroll table-main-scrollbar", style: { maxHeight: "250px" }, children: /* @__PURE__ */ d.jsx("ul", { className: "bg-white shadow-l rounded-md p-4 pointer-events-auto", children: r.map((b) => /* @__PURE__ */ d.jsx(
      "li",
      {
        className: `font-bold leading-[120%] p-4 cursor-pointer rounded-md ${n === b.value ? "bg-secondary-600 text-white" : "bg-white hover:bg-secondary-100"}`,
        onClick: () => {
          p(!1), n !== b.value && u !== void 0 && u({ option: b });
        },
        children: b.text
      },
      b.value
    )) }) })
  ] }) });
});
L2.displayName = "Select";
var R2 = { exports: {} }, Eu, a6;
function Rw() {
  if (a6)
    return Eu;
  a6 = 1;
  function e(_) {
    return _ && typeof _ == "object" && "default" in _ ? _.default : _;
  }
  var t = e(P), r = z0;
  function n(_, j) {
    for (var T = Object.getOwnPropertyNames(j), A = 0; A < T.length; A++) {
      var O = T[A], N = Object.getOwnPropertyDescriptor(j, O);
      N && N.configurable && _[O] === void 0 && Object.defineProperty(_, O, N);
    }
    return _;
  }
  function a() {
    return (a = Object.assign || function(_) {
      for (var j = 1; j < arguments.length; j++) {
        var T = arguments[j];
        for (var A in T)
          Object.prototype.hasOwnProperty.call(T, A) && (_[A] = T[A]);
      }
      return _;
    }).apply(this, arguments);
  }
  function i(_, j) {
    _.prototype = Object.create(j.prototype), n(_.prototype.constructor = _, j);
  }
  function o(_, j) {
    if (_ == null)
      return {};
    var T, A, O = {}, N = Object.keys(_);
    for (A = 0; A < N.length; A++)
      T = N[A], 0 <= j.indexOf(T) || (O[T] = _[T]);
    return O;
  }
  function s(_) {
    if (_ === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return _;
  }
  var l = function(_, j, T, A, O, N, q, Y) {
    if (!_) {
      var z;
      if (j === void 0)
        z = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
      else {
        var R = [T, A, O, N, q, Y], $ = 0;
        (z = new Error(j.replace(/%s/g, function() {
          return R[$++];
        }))).name = "Invariant Violation";
      }
      throw z.framesToPop = 1, z;
    }
  }, c = l;
  function u(_, j, T) {
    if ("selectionStart" in _ && "selectionEnd" in _)
      _.selectionStart = j, _.selectionEnd = T;
    else {
      var A = _.createTextRange();
      A.collapse(!0), A.moveStart("character", j), A.moveEnd("character", T - j), A.select();
    }
  }
  function f(_) {
    var j = 0, T = 0;
    if ("selectionStart" in _ && "selectionEnd" in _)
      j = _.selectionStart, T = _.selectionEnd;
    else {
      var A = document.selection.createRange();
      A.parentElement() === _ && (j = -A.moveStart("character", -_.value.length), T = -A.moveEnd("character", -_.value.length));
    }
    return { start: j, end: T, length: T - j };
  }
  var p = { 9: "[0-9]", a: "[A-Za-z]", "*": "[A-Za-z0-9]" }, h = "_";
  function m(_, j, T) {
    var A = "", O = "", N = null, q = [];
    if (j === void 0 && (j = h), T == null && (T = p), !_ || typeof _ != "string")
      return { maskChar: j, formatChars: T, mask: null, prefix: null, lastEditablePosition: null, permanents: [] };
    var Y = !1;
    return _.split("").forEach(function(z) {
      Y = !Y && z === "\\" || (Y || !T[z] ? (q.push(A.length), A.length === q.length - 1 && (O += z)) : N = A.length + 1, A += z, !1);
    }), { maskChar: j, formatChars: T, prefix: O, mask: A, lastEditablePosition: N, permanents: q };
  }
  function v(_, j) {
    return _.permanents.indexOf(j) !== -1;
  }
  function g(_, j, T) {
    var A = _.mask, O = _.formatChars;
    if (!T)
      return !1;
    if (v(_, j))
      return A[j] === T;
    var N = O[A[j]];
    return new RegExp(N).test(T);
  }
  function y(_, j) {
    return j.split("").every(function(T, A) {
      return v(_, A) || !g(_, A, T);
    });
  }
  function b(_, j) {
    var T = _.maskChar, A = _.prefix;
    if (!T) {
      for (; j.length > A.length && v(_, j.length - 1); )
        j = j.slice(0, j.length - 1);
      return j.length;
    }
    for (var O = A.length, N = j.length; N >= A.length; N--) {
      var q = j[N];
      if (!v(_, N) && g(_, N, q)) {
        O = N + 1;
        break;
      }
    }
    return O;
  }
  function w(_, j) {
    return b(_, j) === _.mask.length;
  }
  function x(_, j) {
    var T = _.maskChar, A = _.mask, O = _.prefix;
    if (!T) {
      for ((j = S(_, "", j, 0)).length < O.length && (j = O); j.length < A.length && v(_, j.length); )
        j += A[j.length];
      return j;
    }
    if (j)
      return S(_, x(_, ""), j, 0);
    for (var N = 0; N < A.length; N++)
      v(_, N) ? j += A[N] : j += T;
    return j;
  }
  function C(_, j, T, A) {
    var O = T + A, N = _.maskChar, q = _.mask, Y = _.prefix, z = j.split("");
    if (N)
      return z.map(function($, F) {
        return F < T || O <= F ? $ : v(_, F) ? q[F] : N;
      }).join("");
    for (var R = O; R < z.length; R++)
      v(_, R) && (z[R] = "");
    return T = Math.max(Y.length, T), z.splice(T, O - T), j = z.join(""), x(_, j);
  }
  function S(_, j, T, A) {
    var O = _.mask, N = _.maskChar, q = _.prefix, Y = T.split(""), z = w(_, j);
    return !N && A > j.length && (j += O.slice(j.length, A)), Y.every(function(R) {
      for (; M = R, v(_, B = A) && M !== O[B]; ) {
        if (A >= j.length && (j += O[A]), $ = R, F = A, N && v(_, F) && $ === N)
          return !0;
        if (++A >= O.length)
          return !1;
      }
      var $, F, B, M;
      return !g(_, A, R) && R !== N || (A < j.length ? j = N || z || A < q.length ? j.slice(0, A) + R + j.slice(A + 1) : (j = j.slice(0, A) + R + j.slice(A), x(_, j)) : N || (j += R), ++A < O.length);
    }), j;
  }
  function E(_, j, T, A) {
    var O = _.mask, N = _.maskChar, q = T.split(""), Y = A;
    return q.every(function(z) {
      for (; $ = z, v(_, R = A) && $ !== O[R]; )
        if (++A >= O.length)
          return !1;
      var R, $;
      return (g(_, A, z) || z === N) && A++, A < O.length;
    }), A - Y;
  }
  function D(_, j) {
    for (var T = j; 0 <= T; --T)
      if (!v(_, T))
        return T;
    return null;
  }
  function I(_, j) {
    for (var T = _.mask, A = j; A < T.length; ++A)
      if (!v(_, A))
        return A;
    return null;
  }
  function k(_) {
    return _ || _ === 0 ? _ + "" : "";
  }
  function V(_, j, T, A, O) {
    var N = _.mask, q = _.prefix, Y = _.lastEditablePosition, z = j, R = "", $ = 0, F = 0, B = Math.min(O.start, T.start);
    return T.end > O.start ? F = ($ = E(_, A, R = z.slice(O.start, T.end), B)) ? O.length : 0 : z.length < A.length && (F = A.length - z.length), z = A, F && (F === 1 && !O.length && (B = O.start === T.start ? I(_, T.start) : D(_, T.start)), z = C(_, z, B, F)), z = S(_, z, R, B), (B += $) >= N.length ? B = N.length : B < q.length && !$ ? B = q.length : B >= q.length && B < Y && $ && (B = I(_, B)), R || (R = null), { value: z = x(_, z), enteredString: R, selection: { start: B, end: B } };
  }
  function W() {
    var _ = new RegExp("windows", "i"), j = new RegExp("phone", "i"), T = navigator.userAgent;
    return _.test(T) && j.test(T);
  }
  function L(_) {
    return typeof _ == "function";
  }
  function G() {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;
  }
  function Q() {
    return window.cancelAnimationFrame || window.webkitCancelRequestAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame;
  }
  function X(_) {
    return (Q() ? G() : function() {
      return setTimeout(_, 1e3 / 60);
    })(_);
  }
  function K(_) {
    (Q() || clearTimeout)(_);
  }
  var te = function(_) {
    function j(A) {
      var O = _.call(this, A) || this;
      O.focused = !1, O.mounted = !1, O.previousSelection = null, O.selectionDeferId = null, O.saveSelectionLoopDeferId = null, O.saveSelectionLoop = function() {
        O.previousSelection = O.getSelection(), O.saveSelectionLoopDeferId = X(O.saveSelectionLoop);
      }, O.runSaveSelectionLoop = function() {
        O.saveSelectionLoopDeferId === null && O.saveSelectionLoop();
      }, O.stopSaveSelectionLoop = function() {
        O.saveSelectionLoopDeferId !== null && (K(O.saveSelectionLoopDeferId), O.saveSelectionLoopDeferId = null, O.previousSelection = null);
      }, O.getInputDOMNode = function() {
        if (!O.mounted)
          return null;
        var J = r.findDOMNode(s(s(O))), H = typeof window < "u" && J instanceof window.Element;
        if (J && !H)
          return null;
        if (J.nodeName !== "INPUT" && (J = J.querySelector("input")), !J)
          throw new Error("react-input-mask: inputComponent doesn't contain input node");
        return J;
      }, O.getInputValue = function() {
        var J = O.getInputDOMNode();
        return J ? J.value : null;
      }, O.setInputValue = function(J) {
        var H = O.getInputDOMNode();
        H && (O.value = J, H.value = J);
      }, O.setCursorToEnd = function() {
        var J = b(O.maskOptions, O.value), H = I(O.maskOptions, J);
        H !== null && O.setCursorPosition(H);
      }, O.setSelection = function(J, H, ee) {
        ee === void 0 && (ee = {});
        var ne = O.getInputDOMNode(), ae = O.isFocused();
        ne && ae && (ee.deferred || u(ne, J, H), O.selectionDeferId !== null && K(O.selectionDeferId), O.selectionDeferId = X(function() {
          O.selectionDeferId = null, u(ne, J, H);
        }), O.previousSelection = { start: J, end: H, length: Math.abs(H - J) });
      }, O.getSelection = function() {
        return f(O.getInputDOMNode());
      }, O.getCursorPosition = function() {
        return O.getSelection().start;
      }, O.setCursorPosition = function(J) {
        O.setSelection(J, J);
      }, O.isFocused = function() {
        return O.focused;
      }, O.getBeforeMaskedValueChangeConfig = function() {
        var J = O.maskOptions, H = J.mask, ee = J.maskChar, ne = J.permanents, ae = J.formatChars;
        return { mask: H, maskChar: ee, permanents: ne, alwaysShowMask: !!O.props.alwaysShowMask, formatChars: ae };
      }, O.isInputAutofilled = function(J, H, ee, ne) {
        var ae = O.getInputDOMNode();
        try {
          if (ae.matches(":-webkit-autofill"))
            return !0;
        } catch {
        }
        return !O.focused || ne.end < ee.length && H.end === J.length;
      }, O.onChange = function(J) {
        var H = s(s(O)).beforePasteState, ee = s(s(O)).previousSelection, ne = O.props.beforeMaskedValueChange, ae = O.getInputValue(), se = O.value, de = O.getSelection();
        O.isInputAutofilled(ae, de, se, ee) && (se = x(O.maskOptions, ""), ee = { start: 0, end: 0, length: 0 }), H && (ee = H.selection, se = H.value, de = { start: ee.start + ae.length, end: ee.start + ae.length, length: 0 }, ae = se.slice(0, ee.start) + ae + se.slice(ee.end), O.beforePasteState = null);
        var ve = V(O.maskOptions, ae, de, se, ee), Te = ve.enteredString, We = ve.selection, Ze = ve.value;
        if (L(ne)) {
          var yt = ne({ value: Ze, selection: We }, { value: se, selection: ee }, Te, O.getBeforeMaskedValueChangeConfig());
          Ze = yt.value, We = yt.selection;
        }
        O.setInputValue(Ze), L(O.props.onChange) && O.props.onChange(J), O.isWindowsPhoneBrowser ? O.setSelection(We.start, We.end, { deferred: !0 }) : O.setSelection(We.start, We.end);
      }, O.onFocus = function(J) {
        var H = O.props.beforeMaskedValueChange, ee = O.maskOptions, ne = ee.mask, ae = ee.prefix;
        if (O.focused = !0, O.mounted = !0, ne) {
          if (O.value)
            b(O.maskOptions, O.value) < O.maskOptions.mask.length && O.setCursorToEnd();
          else {
            var se = x(O.maskOptions, ae), de = x(O.maskOptions, se), ve = b(O.maskOptions, de), Te = I(O.maskOptions, ve), We = { start: Te, end: Te };
            if (L(H)) {
              var Ze = H({ value: de, selection: We }, { value: O.value, selection: null }, null, O.getBeforeMaskedValueChangeConfig());
              de = Ze.value, We = Ze.selection;
            }
            var yt = de !== O.getInputValue();
            yt && O.setInputValue(de), yt && L(O.props.onChange) && O.props.onChange(J), O.setSelection(We.start, We.end);
          }
          O.runSaveSelectionLoop();
        }
        L(O.props.onFocus) && O.props.onFocus(J);
      }, O.onBlur = function(J) {
        var H = O.props.beforeMaskedValueChange, ee = O.maskOptions.mask;
        if (O.stopSaveSelectionLoop(), O.focused = !1, ee && !O.props.alwaysShowMask && y(O.maskOptions, O.value)) {
          var ne = "";
          L(H) && (ne = H({ value: ne, selection: null }, { value: O.value, selection: O.previousSelection }, null, O.getBeforeMaskedValueChangeConfig()).value);
          var ae = ne !== O.getInputValue();
          ae && O.setInputValue(ne), ae && L(O.props.onChange) && O.props.onChange(J);
        }
        L(O.props.onBlur) && O.props.onBlur(J);
      }, O.onMouseDown = function(J) {
        if (!O.focused && document.addEventListener) {
          O.mouseDownX = J.clientX, O.mouseDownY = J.clientY, O.mouseDownTime = (/* @__PURE__ */ new Date()).getTime();
          var H = function ee(ne) {
            if (document.removeEventListener("mouseup", ee), O.focused) {
              var ae = Math.abs(ne.clientX - O.mouseDownX), se = Math.abs(ne.clientY - O.mouseDownY), de = Math.max(ae, se), ve = (/* @__PURE__ */ new Date()).getTime() - O.mouseDownTime;
              (de <= 10 && ve <= 200 || de <= 5 && ve <= 300) && O.setCursorToEnd();
            }
          };
          document.addEventListener("mouseup", H);
        }
        L(O.props.onMouseDown) && O.props.onMouseDown(J);
      }, O.onPaste = function(J) {
        L(O.props.onPaste) && O.props.onPaste(J), J.defaultPrevented || (O.beforePasteState = { value: O.getInputValue(), selection: O.getSelection() }, O.setInputValue(""));
      }, O.handleRef = function(J) {
        O.props.children == null && L(O.props.inputRef) && O.props.inputRef(J);
      };
      var N = A.mask, q = A.maskChar, Y = A.formatChars, z = A.alwaysShowMask, R = A.beforeMaskedValueChange, $ = A.defaultValue, F = A.value;
      O.maskOptions = m(N, q, Y), $ == null && ($ = ""), F == null && (F = $);
      var B = k(F);
      if (O.maskOptions.mask && (z || B) && (B = x(O.maskOptions, B), L(R))) {
        var M = A.value;
        A.value == null && (M = $), B = R({ value: B, selection: null }, { value: M = k(M), selection: null }, null, O.getBeforeMaskedValueChangeConfig()).value;
      }
      return O.value = B, O;
    }
    i(j, _);
    var T = j.prototype;
    return T.componentDidMount = function() {
      this.mounted = !0, this.getInputDOMNode() && (this.isWindowsPhoneBrowser = W(), this.maskOptions.mask && this.getInputValue() !== this.value && this.setInputValue(this.value));
    }, T.componentDidUpdate = function() {
      var A = this.previousSelection, O = this.props, N = O.beforeMaskedValueChange, q = O.alwaysShowMask, Y = O.mask, z = O.maskChar, R = O.formatChars, $ = this.maskOptions, F = q || this.isFocused(), B = this.props.value != null, M = B ? k(this.props.value) : this.value, J = A ? A.start : null;
      if (this.maskOptions = m(Y, z, R), this.maskOptions.mask) {
        !$.mask && this.isFocused() && this.runSaveSelectionLoop();
        var H = this.maskOptions.mask && this.maskOptions.mask !== $.mask;
        if ($.mask || B || (M = this.getInputValue()), (H || this.maskOptions.mask && (M || F)) && (M = x(this.maskOptions, M)), H) {
          var ee = b(this.maskOptions, M);
          (J === null || ee < J) && (J = w(this.maskOptions, M) ? ee : I(this.maskOptions, ee));
        }
        !this.maskOptions.mask || !y(this.maskOptions, M) || F || B && this.props.value || (M = "");
        var ne = { start: J, end: J };
        if (L(N)) {
          var ae = N({ value: M, selection: ne }, { value: this.value, selection: this.previousSelection }, null, this.getBeforeMaskedValueChangeConfig());
          M = ae.value, ne = ae.selection;
        }
        this.value = M;
        var se = this.getInputValue() !== this.value;
        se ? (this.setInputValue(this.value), this.forceUpdate()) : H && this.forceUpdate();
        var de = !1;
        ne.start != null && ne.end != null && (de = !A || A.start !== ne.start || A.end !== ne.end), (de || se) && this.setSelection(ne.start, ne.end);
      } else
        $.mask && (this.stopSaveSelectionLoop(), this.forceUpdate());
    }, T.componentWillUnmount = function() {
      this.mounted = !1, this.selectionDeferId !== null && K(this.selectionDeferId), this.stopSaveSelectionLoop();
    }, T.render = function() {
      var A, O = this.props, N = (O.mask, O.alwaysShowMask, O.maskChar, O.formatChars, O.inputRef, O.beforeMaskedValueChange, O.children), q = o(O, ["mask", "alwaysShowMask", "maskChar", "formatChars", "inputRef", "beforeMaskedValueChange", "children"]);
      if (N) {
        L(N) || c(!1);
        var Y = ["onChange", "onPaste", "onMouseDown", "onFocus", "onBlur", "value", "disabled", "readOnly"], z = a({}, q);
        Y.forEach(function($) {
          return delete z[$];
        }), A = N(z), Y.filter(function($) {
          return A.props[$] != null && A.props[$] !== q[$];
        }).length && c(!1);
      } else
        A = t.createElement("input", a({ ref: this.handleRef }, q));
      var R = { onFocus: this.onFocus, onBlur: this.onBlur };
      return this.maskOptions.mask && (q.disabled || q.readOnly || (R.onChange = this.onChange, R.onPaste = this.onPaste, R.onMouseDown = this.onMouseDown), q.value != null && (R.value = this.value)), A = t.cloneElement(A, R);
    }, j;
  }(t.Component);
  return Eu = te, Eu;
}
var ju, i6;
function kw() {
  if (i6)
    return ju;
  i6 = 1;
  var e = function(t, r, n, a, i, o, s, l) {
    if (process.env.NODE_ENV !== "production" && r === void 0)
      throw new Error("invariant requires an error message argument");
    if (!t) {
      var c;
      if (r === void 0)
        c = new Error(
          "Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings."
        );
      else {
        var u = [n, a, i, o, s, l], f = 0;
        c = new Error(
          r.replace(/%s/g, function() {
            return u[f++];
          })
        ), c.name = "Invariant Violation";
      }
      throw c.framesToPop = 1, c;
    }
  };
  return ju = e, ju;
}
var _u, o6;
function Bw() {
  if (o6)
    return _u;
  o6 = 1;
  var e = process.env.NODE_ENV !== "production", t = function() {
  };
  if (e) {
    var r = function(a, i) {
      var o = arguments.length;
      i = new Array(o > 1 ? o - 1 : 0);
      for (var s = 1; s < o; s++)
        i[s - 1] = arguments[s];
      var l = 0, c = "Warning: " + a.replace(/%s/g, function() {
        return i[l++];
      });
      typeof console < "u" && console.error(c);
      try {
        throw new Error(c);
      } catch {
      }
    };
    t = function(n, a, i) {
      var o = arguments.length;
      i = new Array(o > 2 ? o - 2 : 0);
      for (var s = 2; s < o; s++)
        i[s - 2] = arguments[s];
      if (a === void 0)
        throw new Error(
          "`warning(condition, format, ...args)` requires a warning message argument"
        );
      n || r.apply(null, [a].concat(i));
    };
  }
  return _u = t, _u;
}
var Du, s6;
function Vw() {
  if (s6)
    return Du;
  s6 = 1;
  function e(_) {
    return _ && typeof _ == "object" && "default" in _ ? _.default : _;
  }
  var t = e(P), r = z0, n = e(kw()), a = e(Bw());
  function i(_, j) {
    for (var T = Object.getOwnPropertyNames(j), A = 0; A < T.length; A++) {
      var O = T[A], N = Object.getOwnPropertyDescriptor(j, O);
      N && N.configurable && _[O] === void 0 && Object.defineProperty(_, O, N);
    }
    return _;
  }
  function o() {
    return o = Object.assign || function(_) {
      for (var j = 1; j < arguments.length; j++) {
        var T = arguments[j];
        for (var A in T)
          Object.prototype.hasOwnProperty.call(T, A) && (_[A] = T[A]);
      }
      return _;
    }, o.apply(this, arguments);
  }
  function s(_, j) {
    _.prototype = Object.create(j.prototype), _.prototype.constructor = _, i(_, j);
  }
  function l(_, j) {
    if (_ == null)
      return {};
    var T = {}, A = Object.keys(_), O, N;
    for (N = 0; N < A.length; N++)
      O = A[N], !(j.indexOf(O) >= 0) && (T[O] = _[O]);
    return T;
  }
  function c(_) {
    if (_ === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return _;
  }
  function u(_, j, T) {
    if ("selectionStart" in _ && "selectionEnd" in _)
      _.selectionStart = j, _.selectionEnd = T;
    else {
      var A = _.createTextRange();
      A.collapse(!0), A.moveStart("character", j), A.moveEnd("character", T - j), A.select();
    }
  }
  function f(_) {
    var j = 0, T = 0;
    if ("selectionStart" in _ && "selectionEnd" in _)
      j = _.selectionStart, T = _.selectionEnd;
    else {
      var A = document.selection.createRange();
      A.parentElement() === _ && (j = -A.moveStart("character", -_.value.length), T = -A.moveEnd("character", -_.value.length));
    }
    return {
      start: j,
      end: T,
      length: T - j
    };
  }
  var p = {
    9: "[0-9]",
    a: "[A-Za-z]",
    "*": "[A-Za-z0-9]"
  }, h = "_";
  function m(_, j, T) {
    var A = "", O = "", N = null, q = [];
    if (j === void 0 && (j = h), T == null && (T = p), !_ || typeof _ != "string")
      return {
        maskChar: j,
        formatChars: T,
        mask: null,
        prefix: null,
        lastEditablePosition: null,
        permanents: []
      };
    var Y = !1;
    return _.split("").forEach(function(z) {
      !Y && z === "\\" ? Y = !0 : (Y || !T[z] ? (q.push(A.length), A.length === q.length - 1 && (O += z)) : N = A.length + 1, A += z, Y = !1);
    }), {
      maskChar: j,
      formatChars: T,
      prefix: O,
      mask: A,
      lastEditablePosition: N,
      permanents: q
    };
  }
  function v(_, j) {
    return _.permanents.indexOf(j) !== -1;
  }
  function g(_, j, T) {
    var A = _.mask, O = _.formatChars;
    if (!T)
      return !1;
    if (v(_, j))
      return A[j] === T;
    var N = A[j], q = O[N];
    return new RegExp(q).test(T);
  }
  function y(_, j) {
    return j.split("").every(function(T, A) {
      return v(_, A) || !g(_, A, T);
    });
  }
  function b(_, j) {
    var T = _.maskChar, A = _.prefix;
    if (!T) {
      for (; j.length > A.length && v(_, j.length - 1); )
        j = j.slice(0, j.length - 1);
      return j.length;
    }
    for (var O = A.length, N = j.length; N >= A.length; N--) {
      var q = j[N], Y = !v(_, N) && g(_, N, q);
      if (Y) {
        O = N + 1;
        break;
      }
    }
    return O;
  }
  function w(_, j) {
    return b(_, j) === _.mask.length;
  }
  function x(_, j) {
    var T = _.maskChar, A = _.mask, O = _.prefix;
    if (!T) {
      for (j = S(_, "", j, 0), j.length < O.length && (j = O); j.length < A.length && v(_, j.length); )
        j += A[j.length];
      return j;
    }
    if (j) {
      var N = x(_, "");
      return S(_, N, j, 0);
    }
    for (var q = 0; q < A.length; q++)
      v(_, q) ? j += A[q] : j += T;
    return j;
  }
  function C(_, j, T, A) {
    var O = T + A, N = _.maskChar, q = _.mask, Y = _.prefix, z = j.split("");
    if (!N) {
      for (var R = O; R < z.length; R++)
        v(_, R) && (z[R] = "");
      return T = Math.max(Y.length, T), z.splice(T, O - T), j = z.join(""), x(_, j);
    }
    return z.map(function($, F) {
      return F < T || F >= O ? $ : v(_, F) ? q[F] : N;
    }).join("");
  }
  function S(_, j, T, A) {
    var O = _.mask, N = _.maskChar, q = _.prefix, Y = T.split(""), z = w(_, j), R = function(B, M) {
      return !v(_, B) || M === O[B];
    }, $ = function(B, M) {
      return !N || !v(_, M) || B !== N;
    };
    return !N && A > j.length && (j += O.slice(j.length, A)), Y.every(function(F) {
      for (; !R(A, F); ) {
        if (A >= j.length && (j += O[A]), !$(F, A))
          return !0;
        if (A++, A >= O.length)
          return !1;
      }
      var B = g(_, A, F) || F === N;
      return B ? (A < j.length ? N || z || A < q.length ? j = j.slice(0, A) + F + j.slice(A + 1) : (j = j.slice(0, A) + F + j.slice(A), j = x(_, j)) : N || (j += F), A++, A < O.length) : !0;
    }), j;
  }
  function E(_, j, T, A) {
    var O = _.mask, N = _.maskChar, q = T.split(""), Y = A, z = function($, F) {
      return !v(_, $) || F === O[$];
    };
    return q.every(function(R) {
      for (; !z(A, R); )
        if (A++, A >= O.length)
          return !1;
      var $ = g(_, A, R) || R === N;
      return $ && A++, A < O.length;
    }), A - Y;
  }
  function D(_, j) {
    for (var T = j; T >= 0; --T)
      if (!v(_, T))
        return T;
    return null;
  }
  function I(_, j) {
    for (var T = _.mask, A = j; A < T.length; ++A)
      if (!v(_, A))
        return A;
    return null;
  }
  function k(_) {
    return !_ && _ !== 0 ? "" : _ + "";
  }
  function V(_, j, T, A, O) {
    var N = _.mask, q = _.prefix, Y = _.lastEditablePosition, z = j, R = "", $ = 0, F = 0, B = Math.min(O.start, T.start);
    if (T.end > O.start ? (R = z.slice(O.start, T.end), $ = E(_, A, R, B), $ ? F = O.length : F = 0) : z.length < A.length && (F = A.length - z.length), z = A, F) {
      if (F === 1 && !O.length) {
        var M = O.start === T.start;
        B = M ? I(_, T.start) : D(_, T.start);
      }
      z = C(_, z, B, F);
    }
    return z = S(_, z, R, B), B = B + $, B >= N.length ? B = N.length : B < q.length && !$ ? B = q.length : B >= q.length && B < Y && $ && (B = I(_, B)), z = x(_, z), R || (R = null), {
      value: z,
      enteredString: R,
      selection: {
        start: B,
        end: B
      }
    };
  }
  function W() {
    var _ = new RegExp("windows", "i"), j = new RegExp("phone", "i"), T = navigator.userAgent;
    return _.test(T) && j.test(T);
  }
  function L(_) {
    return typeof _ == "function";
  }
  function G() {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;
  }
  function Q() {
    return window.cancelAnimationFrame || window.webkitCancelRequestAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame;
  }
  function X(_) {
    var j = !!Q(), T;
    return j ? T = G() : T = function() {
      return setTimeout(_, 1e3 / 60);
    }, T(_);
  }
  function K(_) {
    var j = Q() || clearTimeout;
    j(_);
  }
  var te = /* @__PURE__ */ function(_) {
    s(j, _);
    function j(A) {
      var O;
      O = _.call(this, A) || this, O.focused = !1, O.mounted = !1, O.previousSelection = null, O.selectionDeferId = null, O.saveSelectionLoopDeferId = null, O.saveSelectionLoop = function() {
        O.previousSelection = O.getSelection(), O.saveSelectionLoopDeferId = X(O.saveSelectionLoop);
      }, O.runSaveSelectionLoop = function() {
        O.saveSelectionLoopDeferId === null && O.saveSelectionLoop();
      }, O.stopSaveSelectionLoop = function() {
        O.saveSelectionLoopDeferId !== null && (K(O.saveSelectionLoopDeferId), O.saveSelectionLoopDeferId = null, O.previousSelection = null);
      }, O.getInputDOMNode = function() {
        if (!O.mounted)
          return null;
        var H = r.findDOMNode(c(c(O))), ee = typeof window < "u" && H instanceof window.Element;
        if (H && !ee)
          return null;
        if (H.nodeName !== "INPUT" && (H = H.querySelector("input")), !H)
          throw new Error("react-input-mask: inputComponent doesn't contain input node");
        return H;
      }, O.getInputValue = function() {
        var H = O.getInputDOMNode();
        return H ? H.value : null;
      }, O.setInputValue = function(H) {
        var ee = O.getInputDOMNode();
        ee && (O.value = H, ee.value = H);
      }, O.setCursorToEnd = function() {
        var H = b(O.maskOptions, O.value), ee = I(O.maskOptions, H);
        ee !== null && O.setCursorPosition(ee);
      }, O.setSelection = function(H, ee, ne) {
        ne === void 0 && (ne = {});
        var ae = O.getInputDOMNode(), se = O.isFocused();
        if (!(!ae || !se)) {
          var de = ne, ve = de.deferred;
          ve || u(ae, H, ee), O.selectionDeferId !== null && K(O.selectionDeferId), O.selectionDeferId = X(function() {
            O.selectionDeferId = null, u(ae, H, ee);
          }), O.previousSelection = {
            start: H,
            end: ee,
            length: Math.abs(ee - H)
          };
        }
      }, O.getSelection = function() {
        var H = O.getInputDOMNode();
        return f(H);
      }, O.getCursorPosition = function() {
        return O.getSelection().start;
      }, O.setCursorPosition = function(H) {
        O.setSelection(H, H);
      }, O.isFocused = function() {
        return O.focused;
      }, O.getBeforeMaskedValueChangeConfig = function() {
        var H = O.maskOptions, ee = H.mask, ne = H.maskChar, ae = H.permanents, se = H.formatChars, de = O.props.alwaysShowMask;
        return {
          mask: ee,
          maskChar: ne,
          permanents: ae,
          alwaysShowMask: !!de,
          formatChars: se
        };
      }, O.isInputAutofilled = function(H, ee, ne, ae) {
        var se = O.getInputDOMNode();
        try {
          if (se.matches(":-webkit-autofill"))
            return !0;
        } catch {
        }
        return O.focused ? ae.end < ne.length && ee.end === H.length : !0;
      }, O.onChange = function(H) {
        var ee = c(c(O)), ne = ee.beforePasteState, ae = c(c(O)), se = ae.previousSelection, de = O.props.beforeMaskedValueChange, ve = O.getInputValue(), Te = O.value, We = O.getSelection();
        O.isInputAutofilled(ve, We, Te, se) && (Te = x(O.maskOptions, ""), se = {
          start: 0,
          end: 0,
          length: 0
        }), ne && (se = ne.selection, Te = ne.value, We = {
          start: se.start + ve.length,
          end: se.start + ve.length,
          length: 0
        }, ve = Te.slice(0, se.start) + ve + Te.slice(se.end), O.beforePasteState = null);
        var Ze = V(O.maskOptions, ve, We, Te, se), yt = Ze.enteredString, Tt = Ze.selection, kr = Ze.value;
        if (L(de)) {
          var vn = de({
            value: kr,
            selection: Tt
          }, {
            value: Te,
            selection: se
          }, yt, O.getBeforeMaskedValueChangeConfig());
          kr = vn.value, Tt = vn.selection;
        }
        O.setInputValue(kr), L(O.props.onChange) && O.props.onChange(H), O.isWindowsPhoneBrowser ? O.setSelection(Tt.start, Tt.end, {
          deferred: !0
        }) : O.setSelection(Tt.start, Tt.end);
      }, O.onFocus = function(H) {
        var ee = O.props.beforeMaskedValueChange, ne = O.maskOptions, ae = ne.mask, se = ne.prefix;
        if (O.focused = !0, O.mounted = !0, ae) {
          if (O.value)
            b(O.maskOptions, O.value) < O.maskOptions.mask.length && O.setCursorToEnd();
          else {
            var de = x(O.maskOptions, se), ve = x(O.maskOptions, de), Te = b(O.maskOptions, ve), We = I(O.maskOptions, Te), Ze = {
              start: We,
              end: We
            };
            if (L(ee)) {
              var yt = ee({
                value: ve,
                selection: Ze
              }, {
                value: O.value,
                selection: null
              }, null, O.getBeforeMaskedValueChangeConfig());
              ve = yt.value, Ze = yt.selection;
            }
            var Tt = ve !== O.getInputValue();
            Tt && O.setInputValue(ve), Tt && L(O.props.onChange) && O.props.onChange(H), O.setSelection(Ze.start, Ze.end);
          }
          O.runSaveSelectionLoop();
        }
        L(O.props.onFocus) && O.props.onFocus(H);
      }, O.onBlur = function(H) {
        var ee = O.props.beforeMaskedValueChange, ne = O.maskOptions.mask;
        if (O.stopSaveSelectionLoop(), O.focused = !1, ne && !O.props.alwaysShowMask && y(O.maskOptions, O.value)) {
          var ae = "";
          if (L(ee)) {
            var se = ee({
              value: ae,
              selection: null
            }, {
              value: O.value,
              selection: O.previousSelection
            }, null, O.getBeforeMaskedValueChangeConfig());
            ae = se.value;
          }
          var de = ae !== O.getInputValue();
          de && O.setInputValue(ae), de && L(O.props.onChange) && O.props.onChange(H);
        }
        L(O.props.onBlur) && O.props.onBlur(H);
      }, O.onMouseDown = function(H) {
        if (!O.focused && document.addEventListener) {
          O.mouseDownX = H.clientX, O.mouseDownY = H.clientY, O.mouseDownTime = (/* @__PURE__ */ new Date()).getTime();
          var ee = function ne(ae) {
            if (document.removeEventListener("mouseup", ne), !!O.focused) {
              var se = Math.abs(ae.clientX - O.mouseDownX), de = Math.abs(ae.clientY - O.mouseDownY), ve = Math.max(se, de), Te = (/* @__PURE__ */ new Date()).getTime() - O.mouseDownTime;
              (ve <= 10 && Te <= 200 || ve <= 5 && Te <= 300) && O.setCursorToEnd();
            }
          };
          document.addEventListener("mouseup", ee);
        }
        L(O.props.onMouseDown) && O.props.onMouseDown(H);
      }, O.onPaste = function(H) {
        L(O.props.onPaste) && O.props.onPaste(H), H.defaultPrevented || (O.beforePasteState = {
          value: O.getInputValue(),
          selection: O.getSelection()
        }, O.setInputValue(""));
      }, O.handleRef = function(H) {
        O.props.children == null && L(O.props.inputRef) && O.props.inputRef(H);
      };
      var N = A.mask, q = A.maskChar, Y = A.formatChars, z = A.alwaysShowMask, R = A.beforeMaskedValueChange, $ = A.defaultValue, F = A.value;
      O.maskOptions = m(N, q, Y), $ == null && ($ = ""), F == null && (F = $);
      var B = k(F);
      if (O.maskOptions.mask && (z || B) && (B = x(O.maskOptions, B), L(R))) {
        var M = A.value;
        A.value == null && (M = $), M = k(M);
        var J = R({
          value: B,
          selection: null
        }, {
          value: M,
          selection: null
        }, null, O.getBeforeMaskedValueChangeConfig());
        B = J.value;
      }
      return O.value = B, O;
    }
    var T = j.prototype;
    return T.componentDidMount = function() {
      this.mounted = !0, this.getInputDOMNode() && (this.isWindowsPhoneBrowser = W(), this.maskOptions.mask && this.getInputValue() !== this.value && this.setInputValue(this.value));
    }, T.componentDidUpdate = function() {
      var O = this.previousSelection, N = this.props, q = N.beforeMaskedValueChange, Y = N.alwaysShowMask, z = N.mask, R = N.maskChar, $ = N.formatChars, F = this.maskOptions, B = Y || this.isFocused(), M = this.props.value != null, J = M ? k(this.props.value) : this.value, H = O ? O.start : null;
      if (this.maskOptions = m(z, R, $), this.maskOptions.mask)
        !F.mask && this.isFocused() && this.runSaveSelectionLoop();
      else {
        F.mask && (this.stopSaveSelectionLoop(), this.forceUpdate());
        return;
      }
      var ee = this.maskOptions.mask && this.maskOptions.mask !== F.mask;
      if (!F.mask && !M && (J = this.getInputValue()), (ee || this.maskOptions.mask && (J || B)) && (J = x(this.maskOptions, J)), ee) {
        var ne = b(this.maskOptions, J);
        (H === null || ne < H) && (w(this.maskOptions, J) ? H = ne : H = I(this.maskOptions, ne));
      }
      this.maskOptions.mask && y(this.maskOptions, J) && !B && (!M || !this.props.value) && (J = "");
      var ae = {
        start: H,
        end: H
      };
      if (L(q)) {
        var se = q({
          value: J,
          selection: ae
        }, {
          value: this.value,
          selection: this.previousSelection
        }, null, this.getBeforeMaskedValueChangeConfig());
        J = se.value, ae = se.selection;
      }
      this.value = J;
      var de = this.getInputValue() !== this.value;
      de ? (this.setInputValue(this.value), this.forceUpdate()) : ee && this.forceUpdate();
      var ve = !1;
      ae.start != null && ae.end != null && (ve = !O || O.start !== ae.start || O.end !== ae.end), (ve || de) && this.setSelection(ae.start, ae.end);
    }, T.componentWillUnmount = function() {
      this.mounted = !1, this.selectionDeferId !== null && K(this.selectionDeferId), this.stopSaveSelectionLoop();
    }, T.render = function() {
      var O = this.props, N = O.mask;
      O.alwaysShowMask;
      var q = O.maskChar, Y = O.formatChars, z = O.inputRef;
      O.beforeMaskedValueChange;
      var R = O.children, $ = l(O, ["mask", "alwaysShowMask", "maskChar", "formatChars", "inputRef", "beforeMaskedValueChange", "children"]), F;
      if (process.env.NODE_ENV !== "production" && a(
        // parse mask to test against actual mask prop as this.maskOptions
        // will be updated later in componentDidUpdate
        !$.maxLength || !m(N, q, Y).mask,
        "react-input-mask: maxLength property shouldn't be passed to the masked input. It breaks masking and unnecessary because length is limited by the mask length."
      ), R) {
        L(R) || (process.env.NODE_ENV !== "production" ? n(!1, "react-input-mask: children must be a function") : n(!1));
        var B = ["onChange", "onPaste", "onMouseDown", "onFocus", "onBlur", "value", "disabled", "readOnly"], M = o({}, $);
        B.forEach(function(ee) {
          return delete M[ee];
        }), F = R(M);
        var J = B.filter(function(ee) {
          return F.props[ee] != null && F.props[ee] !== $[ee];
        });
        J.length && (process.env.NODE_ENV !== "production" ? n(!1, "react-input-mask: the following props should be passed to the react-input-mask's component and should not be altered in children's function: " + J.join(", ")) : n(!1)), process.env.NODE_ENV !== "production" && a(!z, "react-input-mask: inputRef is ignored when children is passed, attach ref to the children instead");
      } else
        F = t.createElement("input", o({
          ref: this.handleRef
        }, $));
      var H = {
        onFocus: this.onFocus,
        onBlur: this.onBlur
      };
      return this.maskOptions.mask && (!$.disabled && !$.readOnly && (H.onChange = this.onChange, H.onPaste = this.onPaste, H.onMouseDown = this.onMouseDown), $.value != null && (H.value = this.value)), F = t.cloneElement(F, H), F;
    }, j;
  }(t.Component);
  return Du = te, Du;
}
process.env.NODE_ENV === "production" ? R2.exports = Rw() : R2.exports = Vw();
var Hw = R2.exports;
const Fw = /* @__PURE__ */ Je(Hw), Ww = P.forwardRef((e, t) => {
  const {
    variant: r = "default",
    mask: n = "",
    maskChar: a = "",
    isInvalid: i = !1,
    isSuccess: o = !1,
    ...s
  } = e, l = ye(null);
  return /* @__PURE__ */ d.jsx("div", { className: "relative w-full block text-neutral-600 h-10", ref: t, children: /* @__PURE__ */ d.jsx(
    Fw,
    {
      inputRef: l,
      mask: n,
      maskChar: a,
      className: Ne([
        `
            flex items-center w-full h-full outline-none shadow-transparent
            border rounded-md text-neutral-600 leading-none
            hover:border-secondary-400
            focus:border-secondary-600
            placeholder:text-neutral-400
            disabled:text-neutral-400 disabled:bg-neutral-300 disabled:pointer-events-none
            read-only:hover:border-neutral-300 read-only:focus:border-neutral-300 read-only:text-neutral-400 pl-4
          `,
        r === "white" ? "bg-white" : "bg-neutral-200",
        i ? "border-error-500" : o ? "border-success-500" : r === "white" ? "border-secondary-300" : "border-neutral-300"
      ]),
      ...s
    }
  ) });
});
Ww.displayName = "InputMask";
const zw = P.forwardRef((e, t) => {
  const {
    variant: r = "default",
    isInvalid: n = !1,
    isSuccess: a = !1,
    ...i
  } = e;
  return /* @__PURE__ */ d.jsx(
    "div",
    {
      className: "relative w-full block text-neutral-600",
      children: /* @__PURE__ */ d.jsx(
        "textarea",
        {
          ref: t,
          className: Ne([
            `
            flex items-center w-full h-full outline-none shadow-transparent
            border rounded-md text-neutral-600 leading-none
            hover:border-secondary-400
            focus:border-secondary-600
            placeholder:text-neutral-400
            disabled:text-neutral-400 disabled:bg-neutral-300 disabled:pointer-events-none
            read-only:hover:border-neutral-300 read-only:focus:border-neutral-300 read-only:text-neutral-400
            p-2 resize-none
          `,
            r === "white" ? "bg-white" : "bg-neutral-200",
            n ? "border-error-500" : a ? "border-success-500" : r === "white" ? "border-secondary-300" : "border-neutral-300"
          ]),
          ...i,
          style: { height: "100px" }
        }
      )
    }
  );
});
zw.displayName = "Textarea";
const Uw = P.forwardRef((e, t) => {
  const {
    options: r = [],
    value: n = "",
    variant: a = "default",
    readOnly: i = !1,
    disabled: o = !1,
    isInvalid: s = !1,
    isSuccess: l = !1,
    placeholder: c = "Seleccione una opción",
    onChangeValue: u
  } = e, [f, p] = je(!1), h = ye(null), m = ye(null);
  let v = {};
  r.forEach((b) => {
    const { options: w } = b, x = w.find((C) => C.value === n);
    if (x !== void 0) {
      v = x;
      return;
    }
  });
  const g = (v == null ? void 0 : v.text) ?? c, y = (b) => {
    if (h.current !== null && !h.current.contains(b.target)) {
      if (m.current !== null) {
        if (m.current.contains(b.target))
          return;
        p(!1);
        return;
      }
      p(!1);
    }
  };
  return Me(() => (document.addEventListener("click", y, !0), () => {
    document.removeEventListener("click", y, !0);
  }), []), /* @__PURE__ */ d.jsx("div", { ref: t, className: `w-full block text-neutral-600 ${a === "no-border" ? "h-[38px]" : "h-10"}`, children: /* @__PURE__ */ d.jsxs("div", { className: "relative w-full h-full", children: [
    /* @__PURE__ */ d.jsxs(
      "div",
      {
        ref: h,
        onClick: () => {
          !i && !o && r.length > 0 && p((b) => !b);
        },
        className: Ne([
          "rounded-md flex items-center w-full gap-3 h-full px-4 leading-none",
          i ? "" : "cursor-pointer select-none",
          o ? "bg-neutral-300 text-neutral-400 pointer-events-none" : a === "white" ? "bg-white text-neutral-600" : "bg-neutral-200 text-neutral-600",
          f ? "border-secondary-600" : i ? "" : "hover:border-secondary-400",
          o ? "border border-neutral-300" : a !== "no-border" ? s ? f ? "border border-secondary-600" : "border border-error-500" : l ? f ? "border border-secondary-600" : "border border-success-500" : a === "white" ? "border border-secondary-300" : "border border-neutral-300" : void 0
        ]),
        children: [
          /* @__PURE__ */ d.jsx("div", { className: "flex-grow overflow-hidden", children: /* @__PURE__ */ d.jsx("div", { className: "w-full pointer-events-none text-clamp-1 leading-[32px] break-all", children: g }) }),
          r.length > 0 && /* @__PURE__ */ d.jsx("span", { className: `w-[14px] min-w-[14px] ${f ? "rotate-180" : ""}`, children: /* @__PURE__ */ d.jsx(ge, { variant: "arrow-down", width: 14 }) })
        ]
      }
    ),
    f && r.length > 0 && !i && !o && /* @__PURE__ */ d.jsx(
      "div",
      {
        ref: m,
        className: "absolute top-[calc(100%+8px)] left-0 w-full min-w-[250px] z-[1500] overflow-y-scroll table-main-scrollbar",
        style: { maxHeight: "250px" },
        children: /* @__PURE__ */ d.jsx("div", { className: "bg-white rounded-md p-4 pointer-events-auto", children: r.map((b, w) => {
          const { label: x, options: C } = b;
          return /* @__PURE__ */ d.jsxs(ea, { children: [
            /* @__PURE__ */ d.jsx(Z0, { className: "text-xl font-bold mb-4", children: x }),
            /* @__PURE__ */ d.jsx("ul", { className: "bg-white rounded-md p-4 pointer-events-auto", children: C.map((S) => /* @__PURE__ */ d.jsx(
              "li",
              {
                className: `font-bold leading-[120%] p-4 cursor-pointer rounded-md ${n === S.value ? "bg-secondary-600 text-white" : "bg-white hover:bg-secondary-100"}`,
                onClick: () => {
                  p(!1), n !== S.value && u !== void 0 && u({ option: S });
                },
                children: S.text
              },
              S.value
            )) })
          ] }, `${w}-${x}`);
        }) })
      }
    )
  ] }) });
});
Uw.displayName = "SelectGroup";
var L9 = {}, Ys = {}, k2 = { exports: {} }, vl = { exports: {} }, qe = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var l6;
function Zw() {
  if (l6)
    return qe;
  l6 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, y = e ? Symbol.for("react.responder") : 60118, b = e ? Symbol.for("react.scope") : 60119;
  function w(C) {
    if (typeof C == "object" && C !== null) {
      var S = C.$$typeof;
      switch (S) {
        case t:
          switch (C = C.type, C) {
            case l:
            case c:
            case n:
            case i:
            case a:
            case f:
              return C;
            default:
              switch (C = C && C.$$typeof, C) {
                case s:
                case u:
                case m:
                case h:
                case o:
                  return C;
                default:
                  return S;
              }
          }
        case r:
          return S;
      }
    }
  }
  function x(C) {
    return w(C) === c;
  }
  return qe.AsyncMode = l, qe.ConcurrentMode = c, qe.ContextConsumer = s, qe.ContextProvider = o, qe.Element = t, qe.ForwardRef = u, qe.Fragment = n, qe.Lazy = m, qe.Memo = h, qe.Portal = r, qe.Profiler = i, qe.StrictMode = a, qe.Suspense = f, qe.isAsyncMode = function(C) {
    return x(C) || w(C) === l;
  }, qe.isConcurrentMode = x, qe.isContextConsumer = function(C) {
    return w(C) === s;
  }, qe.isContextProvider = function(C) {
    return w(C) === o;
  }, qe.isElement = function(C) {
    return typeof C == "object" && C !== null && C.$$typeof === t;
  }, qe.isForwardRef = function(C) {
    return w(C) === u;
  }, qe.isFragment = function(C) {
    return w(C) === n;
  }, qe.isLazy = function(C) {
    return w(C) === m;
  }, qe.isMemo = function(C) {
    return w(C) === h;
  }, qe.isPortal = function(C) {
    return w(C) === r;
  }, qe.isProfiler = function(C) {
    return w(C) === i;
  }, qe.isStrictMode = function(C) {
    return w(C) === a;
  }, qe.isSuspense = function(C) {
    return w(C) === f;
  }, qe.isValidElementType = function(C) {
    return typeof C == "string" || typeof C == "function" || C === n || C === c || C === i || C === a || C === f || C === p || typeof C == "object" && C !== null && (C.$$typeof === m || C.$$typeof === h || C.$$typeof === o || C.$$typeof === s || C.$$typeof === u || C.$$typeof === g || C.$$typeof === y || C.$$typeof === b || C.$$typeof === v);
  }, qe.typeOf = w, qe;
}
var Ge = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var c6;
function qw() {
  return c6 || (c6 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, y = e ? Symbol.for("react.responder") : 60118, b = e ? Symbol.for("react.scope") : 60119;
    function w(M) {
      return typeof M == "string" || typeof M == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      M === n || M === c || M === i || M === a || M === f || M === p || typeof M == "object" && M !== null && (M.$$typeof === m || M.$$typeof === h || M.$$typeof === o || M.$$typeof === s || M.$$typeof === u || M.$$typeof === g || M.$$typeof === y || M.$$typeof === b || M.$$typeof === v);
    }
    function x(M) {
      if (typeof M == "object" && M !== null) {
        var J = M.$$typeof;
        switch (J) {
          case t:
            var H = M.type;
            switch (H) {
              case l:
              case c:
              case n:
              case i:
              case a:
              case f:
                return H;
              default:
                var ee = H && H.$$typeof;
                switch (ee) {
                  case s:
                  case u:
                  case m:
                  case h:
                  case o:
                    return ee;
                  default:
                    return J;
                }
            }
          case r:
            return J;
        }
      }
    }
    var C = l, S = c, E = s, D = o, I = t, k = u, V = n, W = m, L = h, G = r, Q = i, X = a, K = f, te = !1;
    function _(M) {
      return te || (te = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), j(M) || x(M) === l;
    }
    function j(M) {
      return x(M) === c;
    }
    function T(M) {
      return x(M) === s;
    }
    function A(M) {
      return x(M) === o;
    }
    function O(M) {
      return typeof M == "object" && M !== null && M.$$typeof === t;
    }
    function N(M) {
      return x(M) === u;
    }
    function q(M) {
      return x(M) === n;
    }
    function Y(M) {
      return x(M) === m;
    }
    function z(M) {
      return x(M) === h;
    }
    function R(M) {
      return x(M) === r;
    }
    function $(M) {
      return x(M) === i;
    }
    function F(M) {
      return x(M) === a;
    }
    function B(M) {
      return x(M) === f;
    }
    Ge.AsyncMode = C, Ge.ConcurrentMode = S, Ge.ContextConsumer = E, Ge.ContextProvider = D, Ge.Element = I, Ge.ForwardRef = k, Ge.Fragment = V, Ge.Lazy = W, Ge.Memo = L, Ge.Portal = G, Ge.Profiler = Q, Ge.StrictMode = X, Ge.Suspense = K, Ge.isAsyncMode = _, Ge.isConcurrentMode = j, Ge.isContextConsumer = T, Ge.isContextProvider = A, Ge.isElement = O, Ge.isForwardRef = N, Ge.isFragment = q, Ge.isLazy = Y, Ge.isMemo = z, Ge.isPortal = R, Ge.isProfiler = $, Ge.isStrictMode = F, Ge.isSuspense = B, Ge.isValidElementType = w, Ge.typeOf = x;
  }()), Ge;
}
var u6;
function R9() {
  return u6 || (u6 = 1, process.env.NODE_ENV === "production" ? vl.exports = Zw() : vl.exports = qw()), vl.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Au, f6;
function Gw() {
  if (f6)
    return Au;
  f6 = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function n(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var o = {}, s = 0; s < 10; s++)
        o["_" + String.fromCharCode(s)] = s;
      var l = Object.getOwnPropertyNames(o).map(function(u) {
        return o[u];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        c[u] = u;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Au = a() ? Object.assign : function(i, o) {
    for (var s, l = n(i), c, u = 1; u < arguments.length; u++) {
      s = Object(arguments[u]);
      for (var f in s)
        t.call(s, f) && (l[f] = s[f]);
      if (e) {
        c = e(s);
        for (var p = 0; p < c.length; p++)
          r.call(s, c[p]) && (l[c[p]] = s[c[p]]);
      }
    }
    return l;
  }, Au;
}
var Mu, d6;
function q0() {
  if (d6)
    return Mu;
  d6 = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Mu = e, Mu;
}
var Tu, p6;
function k9() {
  return p6 || (p6 = 1, Tu = Function.call.bind(Object.prototype.hasOwnProperty)), Tu;
}
var $u, h6;
function Yw() {
  if (h6)
    return $u;
  h6 = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = q0(), r = {}, n = k9();
    e = function(i) {
      var o = "Warning: " + i;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function a(i, o, s, l, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in i)
        if (n(i, u)) {
          var f;
          try {
            if (typeof i[u] != "function") {
              var p = Error(
                (l || "React class") + ": " + s + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw p.name = "Invariant Violation", p;
            }
            f = i[u](o, u, l, s, null, t);
          } catch (m) {
            f = m;
          }
          if (f && !(f instanceof Error) && e(
            (l || "React class") + ": type specification of " + s + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in r)) {
            r[f.message] = !0;
            var h = c ? c() : "";
            e(
              "Failed " + s + " type: " + f.message + (h ?? "")
            );
          }
        }
    }
  }
  return a.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, $u = a, $u;
}
var Nu, v6;
function Kw() {
  if (v6)
    return Nu;
  v6 = 1;
  var e = R9(), t = Gw(), r = q0(), n = k9(), a = Yw(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(s) {
    var l = "Warning: " + s;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return Nu = function(s, l) {
    var c = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function f(j) {
      var T = j && (c && j[c] || j[u]);
      if (typeof T == "function")
        return T;
    }
    var p = "<<anonymous>>", h = {
      array: y("array"),
      bigint: y("bigint"),
      bool: y("boolean"),
      func: y("function"),
      number: y("number"),
      object: y("object"),
      string: y("string"),
      symbol: y("symbol"),
      any: b(),
      arrayOf: w,
      element: x(),
      elementType: C(),
      instanceOf: S,
      node: k(),
      objectOf: D,
      oneOf: E,
      oneOfType: I,
      shape: W,
      exact: L
    };
    function m(j, T) {
      return j === T ? j !== 0 || 1 / j === 1 / T : j !== j && T !== T;
    }
    function v(j, T) {
      this.message = j, this.data = T && typeof T == "object" ? T : {}, this.stack = "";
    }
    v.prototype = Error.prototype;
    function g(j) {
      if (process.env.NODE_ENV !== "production")
        var T = {}, A = 0;
      function O(q, Y, z, R, $, F, B) {
        if (R = R || p, F = F || z, B !== r) {
          if (l) {
            var M = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw M.name = "Invariant Violation", M;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var J = R + ":" + z;
            !T[J] && // Avoid spamming the console because they are often not actionable except for lib authors
            A < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + F + "` prop on `" + R + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), T[J] = !0, A++);
          }
        }
        return Y[z] == null ? q ? Y[z] === null ? new v("The " + $ + " `" + F + "` is marked as required " + ("in `" + R + "`, but its value is `null`.")) : new v("The " + $ + " `" + F + "` is marked as required in " + ("`" + R + "`, but its value is `undefined`.")) : null : j(Y, z, R, $, F);
      }
      var N = O.bind(null, !1);
      return N.isRequired = O.bind(null, !0), N;
    }
    function y(j) {
      function T(A, O, N, q, Y, z) {
        var R = A[O], $ = X(R);
        if ($ !== j) {
          var F = K(R);
          return new v(
            "Invalid " + q + " `" + Y + "` of type " + ("`" + F + "` supplied to `" + N + "`, expected ") + ("`" + j + "`."),
            { expectedType: j }
          );
        }
        return null;
      }
      return g(T);
    }
    function b() {
      return g(o);
    }
    function w(j) {
      function T(A, O, N, q, Y) {
        if (typeof j != "function")
          return new v("Property `" + Y + "` of component `" + N + "` has invalid PropType notation inside arrayOf.");
        var z = A[O];
        if (!Array.isArray(z)) {
          var R = X(z);
          return new v("Invalid " + q + " `" + Y + "` of type " + ("`" + R + "` supplied to `" + N + "`, expected an array."));
        }
        for (var $ = 0; $ < z.length; $++) {
          var F = j(z, $, N, q, Y + "[" + $ + "]", r);
          if (F instanceof Error)
            return F;
        }
        return null;
      }
      return g(T);
    }
    function x() {
      function j(T, A, O, N, q) {
        var Y = T[A];
        if (!s(Y)) {
          var z = X(Y);
          return new v("Invalid " + N + " `" + q + "` of type " + ("`" + z + "` supplied to `" + O + "`, expected a single ReactElement."));
        }
        return null;
      }
      return g(j);
    }
    function C() {
      function j(T, A, O, N, q) {
        var Y = T[A];
        if (!e.isValidElementType(Y)) {
          var z = X(Y);
          return new v("Invalid " + N + " `" + q + "` of type " + ("`" + z + "` supplied to `" + O + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return g(j);
    }
    function S(j) {
      function T(A, O, N, q, Y) {
        if (!(A[O] instanceof j)) {
          var z = j.name || p, R = _(A[O]);
          return new v("Invalid " + q + " `" + Y + "` of type " + ("`" + R + "` supplied to `" + N + "`, expected ") + ("instance of `" + z + "`."));
        }
        return null;
      }
      return g(T);
    }
    function E(j) {
      if (!Array.isArray(j))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), o;
      function T(A, O, N, q, Y) {
        for (var z = A[O], R = 0; R < j.length; R++)
          if (m(z, j[R]))
            return null;
        var $ = JSON.stringify(j, function(B, M) {
          var J = K(M);
          return J === "symbol" ? String(M) : M;
        });
        return new v("Invalid " + q + " `" + Y + "` of value `" + String(z) + "` " + ("supplied to `" + N + "`, expected one of " + $ + "."));
      }
      return g(T);
    }
    function D(j) {
      function T(A, O, N, q, Y) {
        if (typeof j != "function")
          return new v("Property `" + Y + "` of component `" + N + "` has invalid PropType notation inside objectOf.");
        var z = A[O], R = X(z);
        if (R !== "object")
          return new v("Invalid " + q + " `" + Y + "` of type " + ("`" + R + "` supplied to `" + N + "`, expected an object."));
        for (var $ in z)
          if (n(z, $)) {
            var F = j(z, $, N, q, Y + "." + $, r);
            if (F instanceof Error)
              return F;
          }
        return null;
      }
      return g(T);
    }
    function I(j) {
      if (!Array.isArray(j))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var T = 0; T < j.length; T++) {
        var A = j[T];
        if (typeof A != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + te(A) + " at index " + T + "."
          ), o;
      }
      function O(N, q, Y, z, R) {
        for (var $ = [], F = 0; F < j.length; F++) {
          var B = j[F], M = B(N, q, Y, z, R, r);
          if (M == null)
            return null;
          M.data && n(M.data, "expectedType") && $.push(M.data.expectedType);
        }
        var J = $.length > 0 ? ", expected one of type [" + $.join(", ") + "]" : "";
        return new v("Invalid " + z + " `" + R + "` supplied to " + ("`" + Y + "`" + J + "."));
      }
      return g(O);
    }
    function k() {
      function j(T, A, O, N, q) {
        return G(T[A]) ? null : new v("Invalid " + N + " `" + q + "` supplied to " + ("`" + O + "`, expected a ReactNode."));
      }
      return g(j);
    }
    function V(j, T, A, O, N) {
      return new v(
        (j || "React class") + ": " + T + " type `" + A + "." + O + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + N + "`."
      );
    }
    function W(j) {
      function T(A, O, N, q, Y) {
        var z = A[O], R = X(z);
        if (R !== "object")
          return new v("Invalid " + q + " `" + Y + "` of type `" + R + "` " + ("supplied to `" + N + "`, expected `object`."));
        for (var $ in j) {
          var F = j[$];
          if (typeof F != "function")
            return V(N, q, Y, $, K(F));
          var B = F(z, $, N, q, Y + "." + $, r);
          if (B)
            return B;
        }
        return null;
      }
      return g(T);
    }
    function L(j) {
      function T(A, O, N, q, Y) {
        var z = A[O], R = X(z);
        if (R !== "object")
          return new v("Invalid " + q + " `" + Y + "` of type `" + R + "` " + ("supplied to `" + N + "`, expected `object`."));
        var $ = t({}, A[O], j);
        for (var F in $) {
          var B = j[F];
          if (n(j, F) && typeof B != "function")
            return V(N, q, Y, F, K(B));
          if (!B)
            return new v(
              "Invalid " + q + " `" + Y + "` key `" + F + "` supplied to `" + N + "`.\nBad object: " + JSON.stringify(A[O], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(j), null, "  ")
            );
          var M = B(z, F, N, q, Y + "." + F, r);
          if (M)
            return M;
        }
        return null;
      }
      return g(T);
    }
    function G(j) {
      switch (typeof j) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !j;
        case "object":
          if (Array.isArray(j))
            return j.every(G);
          if (j === null || s(j))
            return !0;
          var T = f(j);
          if (T) {
            var A = T.call(j), O;
            if (T !== j.entries) {
              for (; !(O = A.next()).done; )
                if (!G(O.value))
                  return !1;
            } else
              for (; !(O = A.next()).done; ) {
                var N = O.value;
                if (N && !G(N[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function Q(j, T) {
      return j === "symbol" ? !0 : T ? T["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && T instanceof Symbol : !1;
    }
    function X(j) {
      var T = typeof j;
      return Array.isArray(j) ? "array" : j instanceof RegExp ? "object" : Q(T, j) ? "symbol" : T;
    }
    function K(j) {
      if (typeof j > "u" || j === null)
        return "" + j;
      var T = X(j);
      if (T === "object") {
        if (j instanceof Date)
          return "date";
        if (j instanceof RegExp)
          return "regexp";
      }
      return T;
    }
    function te(j) {
      var T = K(j);
      switch (T) {
        case "array":
        case "object":
          return "an " + T;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + T;
        default:
          return T;
      }
    }
    function _(j) {
      return !j.constructor || !j.constructor.name ? p : j.constructor.name;
    }
    return h.checkPropTypes = a, h.resetWarningCache = a.resetWarningCache, h.PropTypes = h, h;
  }, Nu;
}
var Iu, m6;
function Xw() {
  if (m6)
    return Iu;
  m6 = 1;
  var e = q0();
  function t() {
  }
  function r() {
  }
  return r.resetWarningCache = t, Iu = function() {
    function n(o, s, l, c, u, f) {
      if (f !== e) {
        var p = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw p.name = "Invariant Violation", p;
      }
    }
    n.isRequired = n;
    function a() {
      return n;
    }
    var i = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: a,
      element: n,
      elementType: n,
      instanceOf: a,
      node: n,
      objectOf: a,
      oneOf: a,
      oneOfType: a,
      shape: a,
      exact: a,
      checkPropTypes: r,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, Iu;
}
if (process.env.NODE_ENV !== "production") {
  var Qw = R9(), Jw = !0;
  k2.exports = Kw()(Qw.isElement, Jw);
} else
  k2.exports = Xw()();
var Yr = k2.exports;
const Se = /* @__PURE__ */ Je(Yr);
var Ks = {}, _n = {}, B9 = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function r() {
      for (var i = "", o = 0; o < arguments.length; o++) {
        var s = arguments[o];
        s && (i = a(i, n(s)));
      }
      return i;
    }
    function n(i) {
      if (typeof i == "string" || typeof i == "number")
        return i;
      if (typeof i != "object")
        return "";
      if (Array.isArray(i))
        return r.apply(null, i);
      if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
        return i.toString();
      var o = "";
      for (var s in i)
        t.call(i, s) && i[s] && (o = a(o, s));
      return o;
    }
    function a(i, o) {
      return o ? i ? i + " " + o : i + o : i;
    }
    e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
  })();
})(B9);
var Ba = B9.exports;
function qr(e) {
  "@babel/helpers - typeof";
  return qr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, qr(e);
}
function Ee(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function Oe(e) {
  Ee(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || qr(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function eO(e) {
  Ee(1, arguments);
  var t = Oe(e);
  return t.setHours(23, 59, 59, 999), t;
}
const tO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: eO
}, Symbol.toStringTag, { value: "Module" })), G0 = /* @__PURE__ */ et(tO);
function rO(e, t) {
  Ee(2, arguments);
  var r = Oe(e), n = Oe(t);
  return r.getTime() < n.getTime();
}
const nO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: rO
}, Symbol.toStringTag, { value: "Module" })), Y0 = /* @__PURE__ */ et(nO);
function aO(e, t) {
  Ee(2, arguments);
  var r = Oe(e), n = Oe(t);
  return r.getTime() > n.getTime();
}
const iO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: aO
}, Symbol.toStringTag, { value: "Module" })), V9 = /* @__PURE__ */ et(iO);
function as(e) {
  Ee(1, arguments);
  var t = Oe(e);
  return t.setHours(0, 0, 0, 0), t;
}
const oO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: as
}, Symbol.toStringTag, { value: "Module" }));
function sO(e, t) {
  Ee(2, arguments);
  var r = as(e), n = as(t);
  return r.getTime() === n.getTime();
}
const lO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sO
}, Symbol.toStringTag, { value: "Module" })), bc = /* @__PURE__ */ et(lO);
function cO(e) {
  return Ee(1, arguments), e instanceof Date || qr(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function H9(e) {
  if (Ee(1, arguments), !cO(e) && typeof e != "number")
    return !1;
  var t = Oe(e);
  return !isNaN(Number(t));
}
const uO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: H9
}, Symbol.toStringTag, { value: "Module" }));
function Ot(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function fO(e, t) {
  Ee(2, arguments);
  var r = Oe(e).getTime(), n = Ot(t);
  return new Date(r + n);
}
function F9(e, t) {
  Ee(2, arguments);
  var r = Ot(t);
  return fO(e, -r);
}
var dO = 864e5;
function pO(e) {
  Ee(1, arguments);
  var t = Oe(e), r = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var n = t.getTime(), a = r - n;
  return Math.floor(a / dO) + 1;
}
function mi(e) {
  Ee(1, arguments);
  var t = 1, r = Oe(e), n = r.getUTCDay(), a = (n < t ? 7 : 0) + n - t;
  return r.setUTCDate(r.getUTCDate() - a), r.setUTCHours(0, 0, 0, 0), r;
}
function W9(e) {
  Ee(1, arguments);
  var t = Oe(e), r = t.getUTCFullYear(), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(r + 1, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var a = mi(n), i = /* @__PURE__ */ new Date(0);
  i.setUTCFullYear(r, 0, 4), i.setUTCHours(0, 0, 0, 0);
  var o = mi(i);
  return t.getTime() >= a.getTime() ? r + 1 : t.getTime() >= o.getTime() ? r : r - 1;
}
function hO(e) {
  Ee(1, arguments);
  var t = W9(e), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(t, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var n = mi(r);
  return n;
}
var vO = 6048e5;
function z9(e) {
  Ee(1, arguments);
  var t = Oe(e), r = mi(t).getTime() - hO(t).getTime();
  return Math.round(r / vO) + 1;
}
var mO = {};
function ta() {
  return mO;
}
function Na(e, t) {
  var r, n, a, i, o, s, l, c;
  Ee(1, arguments);
  var u = ta(), f = Ot((r = (n = (a = (i = t == null ? void 0 : t.weekStartsOn) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && a !== void 0 ? a : u.weekStartsOn) !== null && n !== void 0 ? n : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(f >= 0 && f <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var p = Oe(e), h = p.getUTCDay(), m = (h < f ? 7 : 0) + h - f;
  return p.setUTCDate(p.getUTCDate() - m), p.setUTCHours(0, 0, 0, 0), p;
}
function K0(e, t) {
  var r, n, a, i, o, s, l, c;
  Ee(1, arguments);
  var u = Oe(e), f = u.getUTCFullYear(), p = ta(), h = Ot((r = (n = (a = (i = t == null ? void 0 : t.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && a !== void 0 ? a : p.firstWeekContainsDate) !== null && n !== void 0 ? n : (l = p.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && r !== void 0 ? r : 1);
  if (!(h >= 1 && h <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var m = /* @__PURE__ */ new Date(0);
  m.setUTCFullYear(f + 1, 0, h), m.setUTCHours(0, 0, 0, 0);
  var v = Na(m, t), g = /* @__PURE__ */ new Date(0);
  g.setUTCFullYear(f, 0, h), g.setUTCHours(0, 0, 0, 0);
  var y = Na(g, t);
  return u.getTime() >= v.getTime() ? f + 1 : u.getTime() >= y.getTime() ? f : f - 1;
}
function gO(e, t) {
  var r, n, a, i, o, s, l, c;
  Ee(1, arguments);
  var u = ta(), f = Ot((r = (n = (a = (i = t == null ? void 0 : t.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && a !== void 0 ? a : u.firstWeekContainsDate) !== null && n !== void 0 ? n : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && r !== void 0 ? r : 1), p = K0(e, t), h = /* @__PURE__ */ new Date(0);
  h.setUTCFullYear(p, 0, f), h.setUTCHours(0, 0, 0, 0);
  var m = Na(h, t);
  return m;
}
var yO = 6048e5;
function U9(e, t) {
  Ee(1, arguments);
  var r = Oe(e), n = Na(r, t).getTime() - gO(r, t).getTime();
  return Math.round(n / yO) + 1;
}
function tt(e, t) {
  for (var r = e < 0 ? "-" : "", n = Math.abs(e).toString(); n.length < t; )
    n = "0" + n;
  return r + n;
}
var bO = {
  // Year
  y: function(t, r) {
    var n = t.getUTCFullYear(), a = n > 0 ? n : 1 - n;
    return tt(r === "yy" ? a % 100 : a, r.length);
  },
  // Month
  M: function(t, r) {
    var n = t.getUTCMonth();
    return r === "M" ? String(n + 1) : tt(n + 1, 2);
  },
  // Day of the month
  d: function(t, r) {
    return tt(t.getUTCDate(), r.length);
  },
  // AM or PM
  a: function(t, r) {
    var n = t.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(t, r) {
    return tt(t.getUTCHours() % 12 || 12, r.length);
  },
  // Hour [0-23]
  H: function(t, r) {
    return tt(t.getUTCHours(), r.length);
  },
  // Minute
  m: function(t, r) {
    return tt(t.getUTCMinutes(), r.length);
  },
  // Second
  s: function(t, r) {
    return tt(t.getUTCSeconds(), r.length);
  },
  // Fraction of second
  S: function(t, r) {
    var n = r.length, a = t.getUTCMilliseconds(), i = Math.floor(a * Math.pow(10, n - 3));
    return tt(i, r.length);
  }
};
const Ln = bO;
var Ya = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, CO = {
  // Era
  G: function(t, r, n) {
    var a = t.getUTCFullYear() > 0 ? 1 : 0;
    switch (r) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(a, {
          width: "abbreviated"
        });
      case "GGGGG":
        return n.era(a, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return n.era(a, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(t, r, n) {
    if (r === "yo") {
      var a = t.getUTCFullYear(), i = a > 0 ? a : 1 - a;
      return n.ordinalNumber(i, {
        unit: "year"
      });
    }
    return Ln.y(t, r);
  },
  // Local week-numbering year
  Y: function(t, r, n, a) {
    var i = K0(t, a), o = i > 0 ? i : 1 - i;
    if (r === "YY") {
      var s = o % 100;
      return tt(s, 2);
    }
    return r === "Yo" ? n.ordinalNumber(o, {
      unit: "year"
    }) : tt(o, r.length);
  },
  // ISO week-numbering year
  R: function(t, r) {
    var n = W9(t);
    return tt(n, r.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, r) {
    var n = t.getUTCFullYear();
    return tt(n, r.length);
  },
  // Quarter
  Q: function(t, r, n) {
    var a = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (r) {
      case "Q":
        return String(a);
      case "QQ":
        return tt(a, 2);
      case "Qo":
        return n.ordinalNumber(a, {
          unit: "quarter"
        });
      case "QQQ":
        return n.quarter(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(a, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, r, n) {
    var a = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (r) {
      case "q":
        return String(a);
      case "qq":
        return tt(a, 2);
      case "qo":
        return n.ordinalNumber(a, {
          unit: "quarter"
        });
      case "qqq":
        return n.quarter(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(a, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, r, n) {
    var a = t.getUTCMonth();
    switch (r) {
      case "M":
      case "MM":
        return Ln.M(t, r);
      case "Mo":
        return n.ordinalNumber(a + 1, {
          unit: "month"
        });
      case "MMM":
        return n.month(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(a, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(t, r, n) {
    var a = t.getUTCMonth();
    switch (r) {
      case "L":
        return String(a + 1);
      case "LL":
        return tt(a + 1, 2);
      case "Lo":
        return n.ordinalNumber(a + 1, {
          unit: "month"
        });
      case "LLL":
        return n.month(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(a, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(t, r, n, a) {
    var i = U9(t, a);
    return r === "wo" ? n.ordinalNumber(i, {
      unit: "week"
    }) : tt(i, r.length);
  },
  // ISO week of year
  I: function(t, r, n) {
    var a = z9(t);
    return r === "Io" ? n.ordinalNumber(a, {
      unit: "week"
    }) : tt(a, r.length);
  },
  // Day of the month
  d: function(t, r, n) {
    return r === "do" ? n.ordinalNumber(t.getUTCDate(), {
      unit: "date"
    }) : Ln.d(t, r);
  },
  // Day of year
  D: function(t, r, n) {
    var a = pO(t);
    return r === "Do" ? n.ordinalNumber(a, {
      unit: "dayOfYear"
    }) : tt(a, r.length);
  },
  // Day of week
  E: function(t, r, n) {
    var a = t.getUTCDay();
    switch (r) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, r, n, a) {
    var i = t.getUTCDay(), o = (i - a.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "e":
        return String(o);
      case "ee":
        return tt(o, 2);
      case "eo":
        return n.ordinalNumber(o, {
          unit: "day"
        });
      case "eee":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, r, n, a) {
    var i = t.getUTCDay(), o = (i - a.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "c":
        return String(o);
      case "cc":
        return tt(o, r.length);
      case "co":
        return n.ordinalNumber(o, {
          unit: "day"
        });
      case "ccc":
        return n.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(i, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(i, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, r, n) {
    var a = t.getUTCDay(), i = a === 0 ? 7 : a;
    switch (r) {
      case "i":
        return String(i);
      case "ii":
        return tt(i, r.length);
      case "io":
        return n.ordinalNumber(i, {
          unit: "day"
        });
      case "iii":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, r, n) {
    var a = t.getUTCHours(), i = a / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, r, n) {
    var a = t.getUTCHours(), i;
    switch (a === 12 ? i = Ya.noon : a === 0 ? i = Ya.midnight : i = a / 12 >= 1 ? "pm" : "am", r) {
      case "b":
      case "bb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, r, n) {
    var a = t.getUTCHours(), i;
    switch (a >= 17 ? i = Ya.evening : a >= 12 ? i = Ya.afternoon : a >= 4 ? i = Ya.morning : i = Ya.night, r) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, r, n) {
    if (r === "ho") {
      var a = t.getUTCHours() % 12;
      return a === 0 && (a = 12), n.ordinalNumber(a, {
        unit: "hour"
      });
    }
    return Ln.h(t, r);
  },
  // Hour [0-23]
  H: function(t, r, n) {
    return r === "Ho" ? n.ordinalNumber(t.getUTCHours(), {
      unit: "hour"
    }) : Ln.H(t, r);
  },
  // Hour [0-11]
  K: function(t, r, n) {
    var a = t.getUTCHours() % 12;
    return r === "Ko" ? n.ordinalNumber(a, {
      unit: "hour"
    }) : tt(a, r.length);
  },
  // Hour [1-24]
  k: function(t, r, n) {
    var a = t.getUTCHours();
    return a === 0 && (a = 24), r === "ko" ? n.ordinalNumber(a, {
      unit: "hour"
    }) : tt(a, r.length);
  },
  // Minute
  m: function(t, r, n) {
    return r === "mo" ? n.ordinalNumber(t.getUTCMinutes(), {
      unit: "minute"
    }) : Ln.m(t, r);
  },
  // Second
  s: function(t, r, n) {
    return r === "so" ? n.ordinalNumber(t.getUTCSeconds(), {
      unit: "second"
    }) : Ln.s(t, r);
  },
  // Fraction of second
  S: function(t, r) {
    return Ln.S(t, r);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, r, n, a) {
    var i = a._originalDate || t, o = i.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (r) {
      case "X":
        return y6(o);
      case "XXXX":
      case "XX":
        return ya(o);
      case "XXXXX":
      case "XXX":
      default:
        return ya(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, r, n, a) {
    var i = a._originalDate || t, o = i.getTimezoneOffset();
    switch (r) {
      case "x":
        return y6(o);
      case "xxxx":
      case "xx":
        return ya(o);
      case "xxxxx":
      case "xxx":
      default:
        return ya(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, r, n, a) {
    var i = a._originalDate || t, o = i.getTimezoneOffset();
    switch (r) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + g6(o, ":");
      case "OOOO":
      default:
        return "GMT" + ya(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, r, n, a) {
    var i = a._originalDate || t, o = i.getTimezoneOffset();
    switch (r) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + g6(o, ":");
      case "zzzz":
      default:
        return "GMT" + ya(o, ":");
    }
  },
  // Seconds timestamp
  t: function(t, r, n, a) {
    var i = a._originalDate || t, o = Math.floor(i.getTime() / 1e3);
    return tt(o, r.length);
  },
  // Milliseconds timestamp
  T: function(t, r, n, a) {
    var i = a._originalDate || t, o = i.getTime();
    return tt(o, r.length);
  }
};
function g6(e, t) {
  var r = e > 0 ? "-" : "+", n = Math.abs(e), a = Math.floor(n / 60), i = n % 60;
  if (i === 0)
    return r + String(a);
  var o = t || "";
  return r + String(a) + o + tt(i, 2);
}
function y6(e, t) {
  if (e % 60 === 0) {
    var r = e > 0 ? "-" : "+";
    return r + tt(Math.abs(e) / 60, 2);
  }
  return ya(e, t);
}
function ya(e, t) {
  var r = t || "", n = e > 0 ? "-" : "+", a = Math.abs(e), i = tt(Math.floor(a / 60), 2), o = tt(a % 60, 2);
  return n + i + r + o;
}
const xO = CO;
var b6 = function(t, r) {
  switch (t) {
    case "P":
      return r.date({
        width: "short"
      });
    case "PP":
      return r.date({
        width: "medium"
      });
    case "PPP":
      return r.date({
        width: "long"
      });
    case "PPPP":
    default:
      return r.date({
        width: "full"
      });
  }
}, Z9 = function(t, r) {
  switch (t) {
    case "p":
      return r.time({
        width: "short"
      });
    case "pp":
      return r.time({
        width: "medium"
      });
    case "ppp":
      return r.time({
        width: "long"
      });
    case "pppp":
    default:
      return r.time({
        width: "full"
      });
  }
}, wO = function(t, r) {
  var n = t.match(/(P+)(p+)?/) || [], a = n[1], i = n[2];
  if (!i)
    return b6(t, r);
  var o;
  switch (a) {
    case "P":
      o = r.dateTime({
        width: "short"
      });
      break;
    case "PP":
      o = r.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      o = r.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      o = r.dateTime({
        width: "full"
      });
      break;
  }
  return o.replace("{{date}}", b6(a, r)).replace("{{time}}", Z9(i, r));
}, OO = {
  p: Z9,
  P: wO
};
const B2 = OO;
function zl(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
var SO = ["D", "DD"], PO = ["YY", "YYYY"];
function q9(e) {
  return SO.indexOf(e) !== -1;
}
function G9(e) {
  return PO.indexOf(e) !== -1;
}
function Ul(e, t, r) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var EO = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, jO = function(t, r, n) {
  var a, i = EO[t];
  return typeof i == "string" ? a = i : r === 1 ? a = i.one : a = i.other.replace("{{count}}", r.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + a : a + " ago" : a;
};
const _O = jO;
function fi(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = t.width ? String(t.width) : e.defaultWidth, n = e.formats[r] || e.formats[e.defaultWidth];
    return n;
  };
}
var DO = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, AO = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, MO = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, TO = {
  date: fi({
    formats: DO,
    defaultWidth: "full"
  }),
  time: fi({
    formats: AO,
    defaultWidth: "full"
  }),
  dateTime: fi({
    formats: MO,
    defaultWidth: "full"
  })
};
const $O = TO;
var NO = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, IO = function(t, r, n, a) {
  return NO[t];
};
const LO = IO;
function Qr(e) {
  return function(t, r) {
    var n = r != null && r.context ? String(r.context) : "standalone", a;
    if (n === "formatting" && e.formattingValues) {
      var i = e.defaultFormattingWidth || e.defaultWidth, o = r != null && r.width ? String(r.width) : i;
      a = e.formattingValues[o] || e.formattingValues[i];
    } else {
      var s = e.defaultWidth, l = r != null && r.width ? String(r.width) : e.defaultWidth;
      a = e.values[l] || e.values[s];
    }
    var c = e.argumentCallback ? e.argumentCallback(t) : t;
    return a[c];
  };
}
var RO = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, kO = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, BO = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, VO = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, HO = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, FO = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, WO = function(t, r) {
  var n = Number(t), a = n % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, zO = {
  ordinalNumber: WO,
  era: Qr({
    values: RO,
    defaultWidth: "wide"
  }),
  quarter: Qr({
    values: kO,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: Qr({
    values: BO,
    defaultWidth: "wide"
  }),
  day: Qr({
    values: VO,
    defaultWidth: "wide"
  }),
  dayPeriod: Qr({
    values: HO,
    defaultWidth: "wide",
    formattingValues: FO,
    defaultFormattingWidth: "wide"
  })
};
const UO = zO;
function Jr(e) {
  return function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.width, a = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], i = t.match(a);
    if (!i)
      return null;
    var o = i[0], s = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(s) ? qO(s, function(f) {
      return f.test(o);
    }) : ZO(s, function(f) {
      return f.test(o);
    }), c;
    c = e.valueCallback ? e.valueCallback(l) : l, c = r.valueCallback ? r.valueCallback(c) : c;
    var u = t.slice(o.length);
    return {
      value: c,
      rest: u
    };
  };
}
function ZO(e, t) {
  for (var r in e)
    if (e.hasOwnProperty(r) && t(e[r]))
      return r;
}
function qO(e, t) {
  for (var r = 0; r < e.length; r++)
    if (t(e[r]))
      return r;
}
function Y9(e) {
  return function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.match(e.matchPattern);
    if (!n)
      return null;
    var a = n[0], i = t.match(e.parsePattern);
    if (!i)
      return null;
    var o = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    o = r.valueCallback ? r.valueCallback(o) : o;
    var s = t.slice(a.length);
    return {
      value: o,
      rest: s
    };
  };
}
var GO = /^(\d+)(th|st|nd|rd)?/i, YO = /\d+/i, KO = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, XO = {
  any: [/^b/i, /^(a|c)/i]
}, QO = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, JO = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, eS = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, tS = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, rS = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, nS = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, aS = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, iS = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, oS = {
  ordinalNumber: Y9({
    matchPattern: GO,
    parsePattern: YO,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: Jr({
    matchPatterns: KO,
    defaultMatchWidth: "wide",
    parsePatterns: XO,
    defaultParseWidth: "any"
  }),
  quarter: Jr({
    matchPatterns: QO,
    defaultMatchWidth: "wide",
    parsePatterns: JO,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: Jr({
    matchPatterns: eS,
    defaultMatchWidth: "wide",
    parsePatterns: tS,
    defaultParseWidth: "any"
  }),
  day: Jr({
    matchPatterns: rS,
    defaultMatchWidth: "wide",
    parsePatterns: nS,
    defaultParseWidth: "any"
  }),
  dayPeriod: Jr({
    matchPatterns: aS,
    defaultMatchWidth: "any",
    parsePatterns: iS,
    defaultParseWidth: "any"
  })
};
const sS = oS;
var lS = {
  code: "en-US",
  formatDistance: _O,
  formatLong: $O,
  formatRelative: LO,
  localize: UO,
  match: sS,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const X0 = lS, cS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: X0
}, Symbol.toStringTag, { value: "Module" }));
var uS = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, fS = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, dS = /^'([^]*?)'?$/, pS = /''/g, hS = /[a-zA-Z]/;
function V2(e, t, r) {
  var n, a, i, o, s, l, c, u, f, p, h, m, v, g, y, b, w, x;
  Ee(2, arguments);
  var C = String(t), S = ta(), E = (n = (a = r == null ? void 0 : r.locale) !== null && a !== void 0 ? a : S.locale) !== null && n !== void 0 ? n : X0, D = Ot((i = (o = (s = (l = r == null ? void 0 : r.firstWeekContainsDate) !== null && l !== void 0 ? l : r == null || (c = r.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && s !== void 0 ? s : S.firstWeekContainsDate) !== null && o !== void 0 ? o : (f = S.locale) === null || f === void 0 || (p = f.options) === null || p === void 0 ? void 0 : p.firstWeekContainsDate) !== null && i !== void 0 ? i : 1);
  if (!(D >= 1 && D <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var I = Ot((h = (m = (v = (g = r == null ? void 0 : r.weekStartsOn) !== null && g !== void 0 ? g : r == null || (y = r.locale) === null || y === void 0 || (b = y.options) === null || b === void 0 ? void 0 : b.weekStartsOn) !== null && v !== void 0 ? v : S.weekStartsOn) !== null && m !== void 0 ? m : (w = S.locale) === null || w === void 0 || (x = w.options) === null || x === void 0 ? void 0 : x.weekStartsOn) !== null && h !== void 0 ? h : 0);
  if (!(I >= 0 && I <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!E.localize)
    throw new RangeError("locale must contain localize property");
  if (!E.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var k = Oe(e);
  if (!H9(k))
    throw new RangeError("Invalid time value");
  var V = zl(k), W = F9(k, V), L = {
    firstWeekContainsDate: D,
    weekStartsOn: I,
    locale: E,
    _originalDate: k
  }, G = C.match(fS).map(function(Q) {
    var X = Q[0];
    if (X === "p" || X === "P") {
      var K = B2[X];
      return K(Q, E.formatLong);
    }
    return Q;
  }).join("").match(uS).map(function(Q) {
    if (Q === "''")
      return "'";
    var X = Q[0];
    if (X === "'")
      return vS(Q);
    var K = xO[X];
    if (K)
      return !(r != null && r.useAdditionalWeekYearTokens) && G9(Q) && Ul(Q, t, String(e)), !(r != null && r.useAdditionalDayOfYearTokens) && q9(Q) && Ul(Q, t, String(e)), K(W, Q, E.localize, L);
    if (X.match(hS))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + X + "`");
    return Q;
  }).join("");
  return G;
}
function vS(e) {
  var t = e.match(dS);
  return t ? t[1].replace(pS, "'") : e;
}
const mS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: V2
}, Symbol.toStringTag, { value: "Module" })), Cc = /* @__PURE__ */ et(mS), Q0 = /* @__PURE__ */ et(oO);
function Ro(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Ro = function(r) {
    return typeof r;
  } : Ro = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, Ro(e);
}
Object.defineProperty(_n, "__esModule", {
  value: !0
});
_n.default = _n.rangeShape = void 0;
var ua = yS(P), ke = ra(Yr), Lu = ra(Ba), C6 = ra(G0), Ru = ra(Y0), x6 = ra(V9), go = ra(bc), gS = ra(Cc), w6 = ra(Q0);
function ra(e) {
  return e && e.__esModule ? e : { default: e };
}
function K9(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (K9 = function(a) {
    return a ? r : t;
  })(e);
}
function yS(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || Ro(e) !== "object" && typeof e != "function")
    return { default: e };
  var r = K9(t);
  if (r && r.has(e))
    return r.get(e);
  var n = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(e, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(n, i, o) : n[i] = e[i];
    }
  return n.default = e, r && r.set(e, n), n;
}
function H2() {
  return H2 = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, H2.apply(this, arguments);
}
function O6(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function bS(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? O6(Object(r), !0).forEach(function(n) {
      xt(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : O6(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function CS(e) {
  return SS(e) || OS(e) || wS(e) || xS();
}
function xS() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function wS(e, t) {
  if (e) {
    if (typeof e == "string")
      return F2(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return F2(e, t);
  }
}
function OS(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function SS(e) {
  if (Array.isArray(e))
    return F2(e);
}
function F2(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function PS(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function S6(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function ES(e, t, r) {
  return t && S6(e.prototype, t), r && S6(e, r), e;
}
function jS(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && W2(e, t);
}
function W2(e, t) {
  return W2 = Object.setPrototypeOf || function(n, a) {
    return n.__proto__ = a, n;
  }, W2(e, t);
}
function _S(e) {
  var t = AS();
  return function() {
    var n = Zl(e), a;
    if (t) {
      var i = Zl(this).constructor;
      a = Reflect.construct(n, arguments, i);
    } else
      a = n.apply(this, arguments);
    return DS(this, a);
  };
}
function DS(e, t) {
  return t && (Ro(t) === "object" || typeof t == "function") ? t : ni(e);
}
function ni(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function AS() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Zl(e) {
  return Zl = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Zl(e);
}
function xt(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var J0 = /* @__PURE__ */ function(e) {
  jS(r, e);
  var t = _S(r);
  function r(n, a) {
    var i;
    return PS(this, r), i = t.call(this, n, a), xt(ni(i), "handleKeyEvent", function(o) {
      var s = i.props, l = s.day, c = s.onMouseDown, u = s.onMouseUp;
      [
        13,
        32
        /* enter */
      ].includes(o.keyCode) && (o.type === "keydown" ? c(l) : u(l));
    }), xt(ni(i), "handleMouseEvent", function(o) {
      var s = i.props, l = s.day, c = s.disabled, u = s.onPreviewChange, f = s.onMouseEnter, p = s.onMouseDown, h = s.onMouseUp, m = {};
      if (c) {
        u();
        return;
      }
      switch (o.type) {
        case "mouseenter":
          f(l), u(l), m.hover = !0;
          break;
        case "blur":
        case "mouseleave":
          m.hover = !1;
          break;
        case "mousedown":
          m.active = !0, p(l);
          break;
        case "mouseup":
          o.stopPropagation(), m.active = !1, h(l);
          break;
        case "focus":
          u(l);
          break;
      }
      Object.keys(m).length && i.setState(m);
    }), xt(ni(i), "getClassNames", function() {
      var o, s = i.props, l = s.isPassive, c = s.isToday, u = s.isWeekend, f = s.isStartOfWeek, p = s.isEndOfWeek, h = s.isStartOfMonth, m = s.isEndOfMonth, v = s.disabled, g = s.styles;
      return (0, Lu.default)(g.day, (o = {}, xt(o, g.dayPassive, l), xt(o, g.dayDisabled, v), xt(o, g.dayToday, c), xt(o, g.dayWeekend, u), xt(o, g.dayStartOfWeek, f), xt(o, g.dayEndOfWeek, p), xt(o, g.dayStartOfMonth, h), xt(o, g.dayEndOfMonth, m), xt(o, g.dayHovered, i.state.hover), xt(o, g.dayActive, i.state.active), o));
    }), xt(ni(i), "renderPreviewPlaceholder", function() {
      var o, s = i.props, l = s.preview, c = s.day, u = s.styles;
      if (!l)
        return null;
      var f = l.startDate ? (0, C6.default)(l.startDate) : null, p = l.endDate ? (0, w6.default)(l.endDate) : null, h = (!f || (0, x6.default)(c, f)) && (!p || (0, Ru.default)(c, p)), m = !h && (0, go.default)(c, f), v = !h && (0, go.default)(c, p);
      return /* @__PURE__ */ ua.default.createElement("span", {
        className: (0, Lu.default)((o = {}, xt(o, u.dayStartPreview, m), xt(o, u.dayInPreview, h), xt(o, u.dayEndPreview, v), o)),
        style: {
          color: l.color
        }
      });
    }), xt(ni(i), "renderSelectionPlaceholders", function() {
      var o = i.props, s = o.styles, l = o.ranges, c = o.day;
      if (i.props.displayMode === "date") {
        var u = (0, go.default)(i.props.day, i.props.date);
        return u ? /* @__PURE__ */ ua.default.createElement("span", {
          className: s.selected,
          style: {
            color: i.props.color
          }
        }) : null;
      }
      var f = l.reduce(function(p, h) {
        var m = h.startDate, v = h.endDate;
        if (m && v && (0, Ru.default)(v, m)) {
          var g = [v, m];
          m = g[0], v = g[1];
        }
        m = m ? (0, C6.default)(m) : null, v = v ? (0, w6.default)(v) : null;
        var y = (!m || (0, x6.default)(c, m)) && (!v || (0, Ru.default)(c, v)), b = !y && (0, go.default)(c, m), w = !y && (0, go.default)(c, v);
        return y || b || w ? [].concat(CS(p), [bS({
          isStartEdge: b,
          isEndEdge: w,
          isInRange: y
        }, h)]) : p;
      }, []);
      return f.map(function(p, h) {
        var m;
        return /* @__PURE__ */ ua.default.createElement("span", {
          key: h,
          className: (0, Lu.default)((m = {}, xt(m, s.startEdge, p.isStartEdge), xt(m, s.endEdge, p.isEndEdge), xt(m, s.inRange, p.isInRange), m)),
          style: {
            color: p.color || i.props.color
          }
        });
      });
    }), i.state = {
      hover: !1,
      active: !1
    }, i;
  }
  return ES(r, [{
    key: "render",
    value: function() {
      var a = this.props.dayContentRenderer;
      return /* @__PURE__ */ ua.default.createElement("button", H2({
        type: "button",
        onMouseEnter: this.handleMouseEvent,
        onMouseLeave: this.handleMouseEvent,
        onFocus: this.handleMouseEvent,
        onMouseDown: this.handleMouseEvent,
        onMouseUp: this.handleMouseEvent,
        onBlur: this.handleMouseEvent,
        onPauseCapture: this.handleMouseEvent,
        onKeyDown: this.handleKeyEvent,
        onKeyUp: this.handleKeyEvent,
        className: this.getClassNames(this.props.styles)
      }, this.props.disabled || this.props.isPassive ? {
        tabIndex: -1
      } : {}, {
        style: {
          color: this.props.color
        }
      }), this.renderSelectionPlaceholders(), this.renderPreviewPlaceholder(), /* @__PURE__ */ ua.default.createElement("span", {
        className: this.props.styles.dayNumber
      }, (a == null ? void 0 : a(this.props.day)) || /* @__PURE__ */ ua.default.createElement("span", null, (0, gS.default)(this.props.day, this.props.dayDisplayFormat))));
    }
  }]), r;
}(ua.Component);
J0.defaultProps = {};
var X9 = ke.default.shape({
  startDate: ke.default.object,
  endDate: ke.default.object,
  color: ke.default.string,
  key: ke.default.string,
  autoFocus: ke.default.bool,
  disabled: ke.default.bool,
  showDateDisplay: ke.default.bool
});
_n.rangeShape = X9;
J0.propTypes = {
  day: ke.default.object.isRequired,
  dayDisplayFormat: ke.default.string,
  date: ke.default.object,
  ranges: ke.default.arrayOf(X9),
  preview: ke.default.shape({
    startDate: ke.default.object,
    endDate: ke.default.object,
    color: ke.default.string
  }),
  onPreviewChange: ke.default.func,
  previewColor: ke.default.string,
  disabled: ke.default.bool,
  isPassive: ke.default.bool,
  isToday: ke.default.bool,
  isWeekend: ke.default.bool,
  isStartOfWeek: ke.default.bool,
  isEndOfWeek: ke.default.bool,
  isStartOfMonth: ke.default.bool,
  isEndOfMonth: ke.default.bool,
  color: ke.default.string,
  displayMode: ke.default.oneOf(["dateRange", "date"]),
  styles: ke.default.object,
  onMouseDown: ke.default.func,
  onMouseUp: ke.default.func,
  onMouseEnter: ke.default.func,
  dayContentRenderer: ke.default.func
};
var MS = J0;
_n.default = MS;
var xc = {};
function TS(e, t) {
  var r;
  Ee(1, arguments);
  var n = e || {}, a = Oe(n.start), i = Oe(n.end), o = i.getTime();
  if (!(a.getTime() <= o))
    throw new RangeError("Invalid interval");
  var s = [], l = a;
  l.setHours(0, 0, 0, 0);
  var c = Number((r = t == null ? void 0 : t.step) !== null && r !== void 0 ? r : 1);
  if (c < 1 || isNaN(c))
    throw new RangeError("`options.step` must be a number greater than 1");
  for (; l.getTime() <= o; )
    s.push(Oe(l)), l.setDate(l.getDate() + c), l.setHours(0, 0, 0, 0);
  return s;
}
const $S = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: TS
}, Symbol.toStringTag, { value: "Module" })), Q9 = /* @__PURE__ */ et($S);
function NS(e, t) {
  Ee(2, arguments);
  var r = Oe(e).getTime(), n = Oe(t.start).getTime(), a = Oe(t.end).getTime();
  if (!(n <= a))
    throw new RangeError("Invalid interval");
  return r >= n && r <= a;
}
const IS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: NS
}, Symbol.toStringTag, { value: "Module" })), J9 = /* @__PURE__ */ et(IS);
function LS(e) {
  Ee(1, arguments);
  var t = Oe(e), r = t.getDay();
  return r === 0 || r === 6;
}
const RS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: LS
}, Symbol.toStringTag, { value: "Module" })), kS = /* @__PURE__ */ et(RS);
function BS(e, t) {
  var r, n, a, i, o, s, l, c;
  Ee(1, arguments);
  var u = ta(), f = Ot((r = (n = (a = (i = t == null ? void 0 : t.weekStartsOn) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && a !== void 0 ? a : u.weekStartsOn) !== null && n !== void 0 ? n : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(f >= 0 && f <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var p = Oe(e), h = p.getDay(), m = (h < f ? -7 : 0) + 6 - (h - f);
  return p.setDate(p.getDate() + m), p.setHours(23, 59, 59, 999), p;
}
const VS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: BS
}, Symbol.toStringTag, { value: "Module" })), wc = /* @__PURE__ */ et(VS);
function HS(e, t) {
  var r, n, a, i, o, s, l, c;
  Ee(1, arguments);
  var u = ta(), f = Ot((r = (n = (a = (i = t == null ? void 0 : t.weekStartsOn) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && a !== void 0 ? a : u.weekStartsOn) !== null && n !== void 0 ? n : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(f >= 0 && f <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var p = Oe(e), h = p.getDay(), m = (h < f ? 7 : 0) + h - f;
  return p.setDate(p.getDate() - m), p.setHours(0, 0, 0, 0), p;
}
const FS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: HS
}, Symbol.toStringTag, { value: "Module" })), Oc = /* @__PURE__ */ et(FS);
var Tn = {};
function WS(e, t) {
  Ee(2, arguments);
  var r = Oe(e), n = Ot(t);
  return isNaN(n) ? /* @__PURE__ */ new Date(NaN) : (n && r.setDate(r.getDate() + n), r);
}
const zS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: WS
}, Symbol.toStringTag, { value: "Module" })), Sc = /* @__PURE__ */ et(zS);
function US(e, t) {
  Ee(2, arguments);
  var r = Oe(e), n = Oe(t), a = r.getFullYear() - n.getFullYear(), i = r.getMonth() - n.getMonth();
  return a * 12 + i;
}
const ZS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: US
}, Symbol.toStringTag, { value: "Module" })), eh = /* @__PURE__ */ et(ZS);
var qS = 864e5;
function th(e, t) {
  Ee(2, arguments);
  var r = as(e), n = as(t), a = r.getTime() - zl(r), i = n.getTime() - zl(n);
  return Math.round((a - i) / qS);
}
const GS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: th
}, Symbol.toStringTag, { value: "Module" })), ef = /* @__PURE__ */ et(GS);
function YS(e) {
  Ee(1, arguments);
  var t = Oe(e), r = t.getMonth();
  return t.setFullYear(t.getFullYear(), r + 1, 0), t.setHours(23, 59, 59, 999), t;
}
const KS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: YS
}, Symbol.toStringTag, { value: "Module" })), tf = /* @__PURE__ */ et(KS);
function XS(e) {
  Ee(1, arguments);
  var t = Oe(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
const QS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: XS
}, Symbol.toStringTag, { value: "Module" })), rf = /* @__PURE__ */ et(QS);
Object.defineProperty(Tn, "__esModule", {
  value: !0
});
Tn.calcFocusDate = iP;
Tn.findNextRangeIndex = oP;
Tn.getMonthDisplayRange = sP;
Tn.generateStyles = lP;
var JS = na(Ba), eP = na(Sc), tP = na(eh), rP = na(ef), nP = na(wc), aP = na(Oc), rh = na(tf), nh = na(rf);
function na(e) {
  return e && e.__esModule ? e : { default: e };
}
function iP(e, t) {
  var r = t.shownDate, n = t.date, a = t.months, i = t.ranges, o = t.focusedRange, s = t.displayMode, l;
  if (s === "dateRange") {
    var c = i[o[0]] || {};
    l = {
      start: c.startDate,
      end: c.endDate
    };
  } else
    l = {
      start: n,
      end: n
    };
  l.start = (0, nh.default)(l.start || /* @__PURE__ */ new Date()), l.end = (0, rh.default)(l.end || l.start);
  var u = l.start || l.end || r || /* @__PURE__ */ new Date();
  return e ? (0, tP.default)(l.start, l.end) > a ? e : u : r || u;
}
function oP(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1, r = e.findIndex(function(n, a) {
    return a > t && n.autoFocus !== !1 && !n.disabled;
  });
  return r !== -1 ? r : e.findIndex(function(n) {
    return n.autoFocus !== !1 && !n.disabled;
  });
}
function sP(e, t, r) {
  var n = (0, nh.default)(e, t), a = (0, rh.default)(e, t), i = (0, aP.default)(n, t), o = (0, nP.default)(a, t);
  return r && (0, rP.default)(o, i) <= 34 && (o = (0, eP.default)(o, 7)), {
    start: i,
    end: o,
    startDateOfMonth: n,
    endDateOfMonth: a
  };
}
function lP(e) {
  if (!e.length)
    return {};
  var t = e.filter(function(r) {
    return !!r;
  }).reduce(function(r, n) {
    return Object.keys(n).forEach(function(a) {
      r[a] = (0, JS.default)(r[a], n[a]);
    }), r;
  }, {});
  return t;
}
function ko(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? ko = function(r) {
    return typeof r;
  } : ko = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, ko(e);
}
Object.defineProperty(xc, "__esModule", {
  value: !0
});
xc.default = void 0;
var Sa = uh(P), st = Lr(Yr), ah = uh(_n), ih = Lr(Q9), cP = Lr(J9), uP = Lr(kS), fP = Lr(V9), Ka = Lr(bc), dP = Lr(Y0), oh = Lr(wc), sh = Lr(Oc), pP = Lr(G0), hP = Lr(Q0), lh = Lr(Cc), vP = Tn;
function Lr(e) {
  return e && e.__esModule ? e : { default: e };
}
function ch(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (ch = function(a) {
    return a ? r : t;
  })(e);
}
function uh(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || ko(e) !== "object" && typeof e != "function")
    return { default: e };
  var r = ch(t);
  if (r && r.has(e))
    return r.get(e);
  var n = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(e, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(n, i, o) : n[i] = e[i];
    }
  return n.default = e, r && r.set(e, n), n;
}
function z2() {
  return z2 = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, z2.apply(this, arguments);
}
function P6(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function E6(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? P6(Object(r), !0).forEach(function(n) {
      mP(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : P6(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function mP(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function gP(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function j6(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function yP(e, t, r) {
  return t && j6(e.prototype, t), r && j6(e, r), e;
}
function bP(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && U2(e, t);
}
function U2(e, t) {
  return U2 = Object.setPrototypeOf || function(n, a) {
    return n.__proto__ = a, n;
  }, U2(e, t);
}
function CP(e) {
  var t = OP();
  return function() {
    var n = ql(e), a;
    if (t) {
      var i = ql(this).constructor;
      a = Reflect.construct(n, arguments, i);
    } else
      a = n.apply(this, arguments);
    return xP(this, a);
  };
}
function xP(e, t) {
  return t && (ko(t) === "object" || typeof t == "function") ? t : wP(e);
}
function wP(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function OP() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function ql(e) {
  return ql = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, ql(e);
}
function SP(e, t, r) {
  var n = /* @__PURE__ */ new Date();
  return /* @__PURE__ */ Sa.default.createElement("div", {
    className: e.weekDays
  }, (0, ih.default)({
    start: (0, sh.default)(n, t),
    end: (0, oh.default)(n, t)
  }).map(function(a, i) {
    return /* @__PURE__ */ Sa.default.createElement("span", {
      className: e.weekDay,
      key: i
    }, (0, lh.default)(a, r, t));
  }));
}
var nf = /* @__PURE__ */ function(e) {
  bP(r, e);
  var t = CP(r);
  function r() {
    return gP(this, r), t.apply(this, arguments);
  }
  return yP(r, [{
    key: "render",
    value: function() {
      var a = this, i = /* @__PURE__ */ new Date(), o = this.props, s = o.displayMode, l = o.focusedRange, c = o.drag, u = o.styles, f = o.disabledDates, p = o.disabledDay, h = this.props.minDate && (0, hP.default)(this.props.minDate), m = this.props.maxDate && (0, pP.default)(this.props.maxDate), v = (0, vP.getMonthDisplayRange)(this.props.month, this.props.dateOptions, this.props.fixedHeight), g = this.props.ranges;
      if (s === "dateRange" && c.status) {
        var y = c.range, b = y.startDate, w = y.endDate;
        g = g.map(function(C, S) {
          return S !== l[0] ? C : E6(E6({}, C), {}, {
            startDate: b,
            endDate: w
          });
        });
      }
      var x = this.props.showPreview && !c.disablePreview;
      return /* @__PURE__ */ Sa.default.createElement("div", {
        className: u.month,
        style: this.props.style
      }, this.props.showMonthName ? /* @__PURE__ */ Sa.default.createElement("div", {
        className: u.monthName
      }, (0, lh.default)(this.props.month, this.props.monthDisplayFormat, this.props.dateOptions)) : null, this.props.showWeekDays && SP(u, this.props.dateOptions, this.props.weekdayDisplayFormat), /* @__PURE__ */ Sa.default.createElement("div", {
        className: u.days,
        onMouseLeave: this.props.onMouseLeave
      }, (0, ih.default)({
        start: v.start,
        end: v.end
      }).map(function(C, S) {
        var E = (0, Ka.default)(C, v.startDateOfMonth), D = (0, Ka.default)(C, v.endDateOfMonth), I = h && (0, dP.default)(C, h) || m && (0, fP.default)(C, m), k = f.some(function(W) {
          return (0, Ka.default)(W, C);
        }), V = p(C);
        return /* @__PURE__ */ Sa.default.createElement(ah.default, z2({}, a.props, {
          ranges: g,
          day: C,
          preview: x ? a.props.preview : null,
          isWeekend: (0, uP.default)(C, a.props.dateOptions),
          isToday: (0, Ka.default)(C, i),
          isStartOfWeek: (0, Ka.default)(C, (0, sh.default)(C, a.props.dateOptions)),
          isEndOfWeek: (0, Ka.default)(C, (0, oh.default)(C, a.props.dateOptions)),
          isStartOfMonth: E,
          isEndOfMonth: D,
          key: S,
          disabled: I || k || V,
          isPassive: !(0, cP.default)(C, {
            start: v.startDateOfMonth,
            end: v.endDateOfMonth
          }),
          styles: u,
          onMouseDown: a.props.onDragSelectionStart,
          onMouseUp: a.props.onDragSelectionEnd,
          onMouseEnter: a.props.onDragSelectionMove,
          dragRange: c.range,
          drag: c.status
        }));
      })));
    }
  }]), r;
}(Sa.PureComponent);
nf.defaultProps = {};
nf.propTypes = {
  style: st.default.object,
  styles: st.default.object,
  month: st.default.object,
  drag: st.default.object,
  dateOptions: st.default.object,
  disabledDates: st.default.array,
  disabledDay: st.default.func,
  preview: st.default.shape({
    startDate: st.default.object,
    endDate: st.default.object
  }),
  showPreview: st.default.bool,
  displayMode: st.default.oneOf(["dateRange", "date"]),
  minDate: st.default.object,
  maxDate: st.default.object,
  ranges: st.default.arrayOf(ah.rangeShape),
  focusedRange: st.default.arrayOf(st.default.number),
  onDragSelectionStart: st.default.func,
  onDragSelectionEnd: st.default.func,
  onDragSelectionMove: st.default.func,
  onMouseLeave: st.default.func,
  monthDisplayFormat: st.default.string,
  weekdayDisplayFormat: st.default.string,
  dayDisplayFormat: st.default.string,
  showWeekDays: st.default.bool,
  showMonthName: st.default.bool,
  fixedHeight: st.default.bool
};
var PP = nf;
xc.default = PP;
var Pc = {};
function EP(e, t) {
  Ee(2, arguments);
  var r = Oe(e), n = Oe(t);
  return r.getTime() === n.getTime();
}
const jP = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: EP
}, Symbol.toStringTag, { value: "Module" })), _P = /* @__PURE__ */ et(jP), DP = /* @__PURE__ */ et(uO);
function _6(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function AP(e, t) {
  if (e) {
    if (typeof e == "string")
      return _6(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? _6(e, t) : void 0;
  }
}
function D6(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!r) {
    if (Array.isArray(e) || (r = AP(e)) || t && e && typeof e.length == "number") {
      r && (e = r);
      var n = 0, a = function() {
      };
      return {
        s: a,
        n: function() {
          return n >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[n++]
          };
        },
        e: function(c) {
          throw c;
        },
        f: a
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i, o = !0, s = !1;
  return {
    s: function() {
      r = r.call(e);
    },
    n: function() {
      var c = r.next();
      return o = c.done, c;
    },
    e: function(c) {
      s = !0, i = c;
    },
    f: function() {
      try {
        o || r.return == null || r.return();
      } finally {
        if (s)
          throw i;
      }
    }
  };
}
function MP(e, t) {
  if (e == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
  return e;
}
function ue(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Gl(e, t) {
  return Gl = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, n) {
    return r.__proto__ = n, r;
  }, Gl(e, t);
}
function Ve(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && Gl(e, t);
}
function Yl(e) {
  return Yl = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, Yl(e);
}
function fh() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (fh = function() {
    return !!e;
  })();
}
function TP(e, t) {
  if (t && (qr(t) == "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return ue(e);
}
function He(e) {
  var t = fh();
  return function() {
    var r, n = Yl(e);
    if (t) {
      var a = Yl(this).constructor;
      r = Reflect.construct(n, arguments, a);
    } else
      r = n.apply(this, arguments);
    return TP(this, r);
  };
}
function Ie(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function $P(e, t) {
  if (qr(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (qr(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function dh(e) {
  var t = $P(e, "string");
  return qr(t) == "symbol" ? t : t + "";
}
function A6(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, dh(n.key), n);
  }
}
function Le(e, t, r) {
  return t && A6(e.prototype, t), r && A6(e, r), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function ce(e, t, r) {
  return (t = dh(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
var NP = 10, ph = /* @__PURE__ */ function() {
  function e() {
    Ie(this, e), ce(this, "priority", void 0), ce(this, "subPriority", 0);
  }
  return Le(e, [{
    key: "validate",
    value: function(r, n) {
      return !0;
    }
  }]), e;
}(), IP = /* @__PURE__ */ function(e) {
  Ve(r, e);
  var t = He(r);
  function r(n, a, i, o, s) {
    var l;
    return Ie(this, r), l = t.call(this), l.value = n, l.validateValue = a, l.setValue = i, l.priority = o, s && (l.subPriority = s), l;
  }
  return Le(r, [{
    key: "validate",
    value: function(a, i) {
      return this.validateValue(a, this.value, i);
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return this.setValue(a, i, this.value, o);
    }
  }]), r;
}(ph), LP = /* @__PURE__ */ function(e) {
  Ve(r, e);
  var t = He(r);
  function r() {
    var n;
    Ie(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(ue(n), "priority", NP), ce(ue(n), "subPriority", -1), n;
  }
  return Le(r, [{
    key: "set",
    value: function(a, i) {
      if (i.timestampIsSet)
        return a;
      var o = /* @__PURE__ */ new Date(0);
      return o.setFullYear(a.getUTCFullYear(), a.getUTCMonth(), a.getUTCDate()), o.setHours(a.getUTCHours(), a.getUTCMinutes(), a.getUTCSeconds(), a.getUTCMilliseconds()), o;
    }
  }]), r;
}(ph), Ue = /* @__PURE__ */ function() {
  function e() {
    Ie(this, e), ce(this, "incompatibleTokens", void 0), ce(this, "priority", void 0), ce(this, "subPriority", void 0);
  }
  return Le(e, [{
    key: "run",
    value: function(r, n, a, i) {
      var o = this.parse(r, n, a, i);
      return o ? {
        setter: new IP(o.value, this.validate, this.set, this.priority, this.subPriority),
        rest: o.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function(r, n, a) {
      return !0;
    }
  }]), e;
}(), RP = /* @__PURE__ */ function(e) {
  Ve(r, e);
  var t = He(r);
  function r() {
    var n;
    Ie(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(ue(n), "priority", 140), ce(ue(n), "incompatibleTokens", ["R", "u", "t", "T"]), n;
  }
  return Le(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "G":
        case "GG":
        case "GGG":
          return o.era(a, {
            width: "abbreviated"
          }) || o.era(a, {
            width: "narrow"
          });
        case "GGGGG":
          return o.era(a, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return o.era(a, {
            width: "wide"
          }) || o.era(a, {
            width: "abbreviated"
          }) || o.era(a, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return i.era = o, a.setUTCFullYear(o, 0, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(Ue), kP = 6e4, BP = 36e5, VP = 1e3, Et = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, en = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function jt(e, t) {
  return e && {
    value: t(e.value),
    rest: e.rest
  };
}
function Ct(e, t) {
  var r = t.match(e);
  return r ? {
    value: parseInt(r[0], 10),
    rest: t.slice(r[0].length)
  } : null;
}
function tn(e, t) {
  var r = t.match(e);
  if (!r)
    return null;
  if (r[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  var n = r[1] === "+" ? 1 : -1, a = r[2] ? parseInt(r[2], 10) : 0, i = r[3] ? parseInt(r[3], 10) : 0, o = r[5] ? parseInt(r[5], 10) : 0;
  return {
    value: n * (a * BP + i * kP + o * VP),
    rest: t.slice(r[0].length)
  };
}
function hh(e) {
  return Ct(Et.anyDigitsSigned, e);
}
function St(e, t) {
  switch (e) {
    case 1:
      return Ct(Et.singleDigit, t);
    case 2:
      return Ct(Et.twoDigits, t);
    case 3:
      return Ct(Et.threeDigits, t);
    case 4:
      return Ct(Et.fourDigits, t);
    default:
      return Ct(new RegExp("^\\d{1," + e + "}"), t);
  }
}
function Kl(e, t) {
  switch (e) {
    case 1:
      return Ct(Et.singleDigitSigned, t);
    case 2:
      return Ct(Et.twoDigitsSigned, t);
    case 3:
      return Ct(Et.threeDigitsSigned, t);
    case 4:
      return Ct(Et.fourDigitsSigned, t);
    default:
      return Ct(new RegExp("^-?\\d{1," + e + "}"), t);
  }
}
function af(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function vh(e, t) {
  var r = t > 0, n = r ? t : 1 - t, a;
  if (n <= 50)
    a = e || 100;
  else {
    var i = n + 50, o = Math.floor(i / 100) * 100, s = e >= i % 100;
    a = e + o - (s ? 100 : 0);
  }
  return r ? a : 1 - a;
}
function mh(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
var HP = /* @__PURE__ */ function(e) {
  Ve(r, e);
  var t = He(r);
  function r() {
    var n;
    Ie(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(ue(n), "priority", 130), ce(ue(n), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), n;
  }
  return Le(r, [{
    key: "parse",
    value: function(a, i, o) {
      var s = function(c) {
        return {
          year: c,
          isTwoDigitYear: i === "yy"
        };
      };
      switch (i) {
        case "y":
          return jt(St(4, a), s);
        case "yo":
          return jt(o.ordinalNumber(a, {
            unit: "year"
          }), s);
        default:
          return jt(St(i.length, a), s);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i.isTwoDigitYear || i.year > 0;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      var s = a.getUTCFullYear();
      if (o.isTwoDigitYear) {
        var l = vh(o.year, s);
        return a.setUTCFullYear(l, 0, 1), a.setUTCHours(0, 0, 0, 0), a;
      }
      var c = !("era" in i) || i.era === 1 ? o.year : 1 - o.year;
      return a.setUTCFullYear(c, 0, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(Ue), FP = /* @__PURE__ */ function(e) {
  Ve(r, e);
  var t = He(r);
  function r() {
    var n;
    Ie(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(ue(n), "priority", 130), ce(ue(n), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), n;
  }
  return Le(r, [{
    key: "parse",
    value: function(a, i, o) {
      var s = function(c) {
        return {
          year: c,
          isTwoDigitYear: i === "YY"
        };
      };
      switch (i) {
        case "Y":
          return jt(St(4, a), s);
        case "Yo":
          return jt(o.ordinalNumber(a, {
            unit: "year"
          }), s);
        default:
          return jt(St(i.length, a), s);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i.isTwoDigitYear || i.year > 0;
    }
  }, {
    key: "set",
    value: function(a, i, o, s) {
      var l = K0(a, s);
      if (o.isTwoDigitYear) {
        var c = vh(o.year, l);
        return a.setUTCFullYear(c, 0, s.firstWeekContainsDate), a.setUTCHours(0, 0, 0, 0), Na(a, s);
      }
      var u = !("era" in i) || i.era === 1 ? o.year : 1 - o.year;
      return a.setUTCFullYear(u, 0, s.firstWeekContainsDate), a.setUTCHours(0, 0, 0, 0), Na(a, s);
    }
  }]), r;
}(Ue), WP = /* @__PURE__ */ function(e) {
  Ve(r, e);
  var t = He(r);
  function r() {
    var n;
    Ie(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(ue(n), "priority", 130), ce(ue(n), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), n;
  }
  return Le(r, [{
    key: "parse",
    value: function(a, i) {
      return Kl(i === "R" ? 4 : i.length, a);
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      var s = /* @__PURE__ */ new Date(0);
      return s.setUTCFullYear(o, 0, 4), s.setUTCHours(0, 0, 0, 0), mi(s);
    }
  }]), r;
}(Ue), zP = /* @__PURE__ */ function(e) {
  Ve(r, e);
  var t = He(r);
  function r() {
    var n;
    Ie(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(ue(n), "priority", 130), ce(ue(n), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), n;
  }
  return Le(r, [{
    key: "parse",
    value: function(a, i) {
      return Kl(i === "u" ? 4 : i.length, a);
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCFullYear(o, 0, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(Ue), UP = /* @__PURE__ */ function(e) {
  Ve(r, e);
  var t = He(r);
  function r() {
    var n;
    Ie(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(ue(n), "priority", 120), ce(ue(n), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), n;
  }
  return Le(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "Q":
        case "QQ":
          return St(i.length, a);
        case "Qo":
          return o.ordinalNumber(a, {
            unit: "quarter"
          });
        case "QQQ":
          return o.quarter(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.quarter(a, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return o.quarter(a, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return o.quarter(a, {
            width: "wide",
            context: "formatting"
          }) || o.quarter(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.quarter(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 1 && i <= 4;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCMonth((o - 1) * 3, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(Ue), ZP = /* @__PURE__ */ function(e) {
  Ve(r, e);
  var t = He(r);
  function r() {
    var n;
    Ie(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(ue(n), "priority", 120), ce(ue(n), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), n;
  }
  return Le(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "q":
        case "qq":
          return St(i.length, a);
        case "qo":
          return o.ordinalNumber(a, {
            unit: "quarter"
          });
        case "qqq":
          return o.quarter(a, {
            width: "abbreviated",
            context: "standalone"
          }) || o.quarter(a, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return o.quarter(a, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return o.quarter(a, {
            width: "wide",
            context: "standalone"
          }) || o.quarter(a, {
            width: "abbreviated",
            context: "standalone"
          }) || o.quarter(a, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 1 && i <= 4;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCMonth((o - 1) * 3, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(Ue), qP = /* @__PURE__ */ function(e) {
  Ve(r, e);
  var t = He(r);
  function r() {
    var n;
    Ie(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(ue(n), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), ce(ue(n), "priority", 110), n;
  }
  return Le(r, [{
    key: "parse",
    value: function(a, i, o) {
      var s = function(c) {
        return c - 1;
      };
      switch (i) {
        case "M":
          return jt(Ct(Et.month, a), s);
        case "MM":
          return jt(St(2, a), s);
        case "Mo":
          return jt(o.ordinalNumber(a, {
            unit: "month"
          }), s);
        case "MMM":
          return o.month(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.month(a, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return o.month(a, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return o.month(a, {
            width: "wide",
            context: "formatting"
          }) || o.month(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.month(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCMonth(o, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(Ue), GP = /* @__PURE__ */ function(e) {
  Ve(r, e);
  var t = He(r);
  function r() {
    var n;
    Ie(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(ue(n), "priority", 110), ce(ue(n), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), n;
  }
  return Le(r, [{
    key: "parse",
    value: function(a, i, o) {
      var s = function(c) {
        return c - 1;
      };
      switch (i) {
        case "L":
          return jt(Ct(Et.month, a), s);
        case "LL":
          return jt(St(2, a), s);
        case "Lo":
          return jt(o.ordinalNumber(a, {
            unit: "month"
          }), s);
        case "LLL":
          return o.month(a, {
            width: "abbreviated",
            context: "standalone"
          }) || o.month(a, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLLL":
          return o.month(a, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return o.month(a, {
            width: "wide",
            context: "standalone"
          }) || o.month(a, {
            width: "abbreviated",
            context: "standalone"
          }) || o.month(a, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCMonth(o, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(Ue);
function YP(e, t, r) {
  Ee(2, arguments);
  var n = Oe(e), a = Ot(t), i = U9(n, r) - a;
  return n.setUTCDate(n.getUTCDate() - i * 7), n;
}
var KP = /* @__PURE__ */ function(e) {
  Ve(r, e);
  var t = He(r);
  function r() {
    var n;
    Ie(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(ue(n), "priority", 100), ce(ue(n), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), n;
  }
  return Le(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "w":
          return Ct(Et.week, a);
        case "wo":
          return o.ordinalNumber(a, {
            unit: "week"
          });
        default:
          return St(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 1 && i <= 53;
    }
  }, {
    key: "set",
    value: function(a, i, o, s) {
      return Na(YP(a, o, s), s);
    }
  }]), r;
}(Ue);
function XP(e, t) {
  Ee(2, arguments);
  var r = Oe(e), n = Ot(t), a = z9(r) - n;
  return r.setUTCDate(r.getUTCDate() - a * 7), r;
}
var QP = /* @__PURE__ */ function(e) {
  Ve(r, e);
  var t = He(r);
  function r() {
    var n;
    Ie(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(ue(n), "priority", 100), ce(ue(n), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), n;
  }
  return Le(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "I":
          return Ct(Et.week, a);
        case "Io":
          return o.ordinalNumber(a, {
            unit: "week"
          });
        default:
          return St(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 1 && i <= 53;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return mi(XP(a, o));
    }
  }]), r;
}(Ue), JP = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], eE = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], tE = /* @__PURE__ */ function(e) {
  Ve(r, e);
  var t = He(r);
  function r() {
    var n;
    Ie(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(ue(n), "priority", 90), ce(ue(n), "subPriority", 1), ce(ue(n), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), n;
  }
  return Le(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "d":
          return Ct(Et.date, a);
        case "do":
          return o.ordinalNumber(a, {
            unit: "date"
          });
        default:
          return St(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      var o = a.getUTCFullYear(), s = mh(o), l = a.getUTCMonth();
      return s ? i >= 1 && i <= eE[l] : i >= 1 && i <= JP[l];
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCDate(o), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(Ue), rE = /* @__PURE__ */ function(e) {
  Ve(r, e);
  var t = He(r);
  function r() {
    var n;
    Ie(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(ue(n), "priority", 90), ce(ue(n), "subpriority", 1), ce(ue(n), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), n;
  }
  return Le(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "D":
        case "DD":
          return Ct(Et.dayOfYear, a);
        case "Do":
          return o.ordinalNumber(a, {
            unit: "date"
          });
        default:
          return St(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      var o = a.getUTCFullYear(), s = mh(o);
      return s ? i >= 1 && i <= 366 : i >= 1 && i <= 365;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCMonth(0, o), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(Ue);
function of(e, t, r) {
  var n, a, i, o, s, l, c, u;
  Ee(2, arguments);
  var f = ta(), p = Ot((n = (a = (i = (o = r == null ? void 0 : r.weekStartsOn) !== null && o !== void 0 ? o : r == null || (s = r.locale) === null || s === void 0 || (l = s.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && i !== void 0 ? i : f.weekStartsOn) !== null && a !== void 0 ? a : (c = f.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(p >= 0 && p <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var h = Oe(e), m = Ot(t), v = h.getUTCDay(), g = m % 7, y = (g + 7) % 7, b = (y < p ? 7 : 0) + m - v;
  return h.setUTCDate(h.getUTCDate() + b), h;
}
var nE = /* @__PURE__ */ function(e) {
  Ve(r, e);
  var t = He(r);
  function r() {
    var n;
    Ie(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(ue(n), "priority", 90), ce(ue(n), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), n;
  }
  return Le(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "E":
        case "EE":
        case "EEE":
          return o.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEE":
          return o.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEE":
        default:
          return o.day(a, {
            width: "wide",
            context: "formatting"
          }) || o.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(a, i, o, s) {
      return a = of(a, o, s), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(Ue), aE = /* @__PURE__ */ function(e) {
  Ve(r, e);
  var t = He(r);
  function r() {
    var n;
    Ie(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(ue(n), "priority", 90), ce(ue(n), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), n;
  }
  return Le(r, [{
    key: "parse",
    value: function(a, i, o, s) {
      var l = function(u) {
        var f = Math.floor((u - 1) / 7) * 7;
        return (u + s.weekStartsOn + 6) % 7 + f;
      };
      switch (i) {
        case "e":
        case "ee":
          return jt(St(i.length, a), l);
        case "eo":
          return jt(o.ordinalNumber(a, {
            unit: "day"
          }), l);
        case "eee":
          return o.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return o.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return o.day(a, {
            width: "wide",
            context: "formatting"
          }) || o.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(a, i, o, s) {
      return a = of(a, o, s), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(Ue), iE = /* @__PURE__ */ function(e) {
  Ve(r, e);
  var t = He(r);
  function r() {
    var n;
    Ie(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(ue(n), "priority", 90), ce(ue(n), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), n;
  }
  return Le(r, [{
    key: "parse",
    value: function(a, i, o, s) {
      var l = function(u) {
        var f = Math.floor((u - 1) / 7) * 7;
        return (u + s.weekStartsOn + 6) % 7 + f;
      };
      switch (i) {
        case "c":
        case "cc":
          return jt(St(i.length, a), l);
        case "co":
          return jt(o.ordinalNumber(a, {
            unit: "day"
          }), l);
        case "ccc":
          return o.day(a, {
            width: "abbreviated",
            context: "standalone"
          }) || o.day(a, {
            width: "short",
            context: "standalone"
          }) || o.day(a, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return o.day(a, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return o.day(a, {
            width: "short",
            context: "standalone"
          }) || o.day(a, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return o.day(a, {
            width: "wide",
            context: "standalone"
          }) || o.day(a, {
            width: "abbreviated",
            context: "standalone"
          }) || o.day(a, {
            width: "short",
            context: "standalone"
          }) || o.day(a, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(a, i, o, s) {
      return a = of(a, o, s), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(Ue);
function oE(e, t) {
  Ee(2, arguments);
  var r = Ot(t);
  r % 7 === 0 && (r = r - 7);
  var n = 1, a = Oe(e), i = a.getUTCDay(), o = r % 7, s = (o + 7) % 7, l = (s < n ? 7 : 0) + r - i;
  return a.setUTCDate(a.getUTCDate() + l), a;
}
var sE = /* @__PURE__ */ function(e) {
  Ve(r, e);
  var t = He(r);
  function r() {
    var n;
    Ie(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(ue(n), "priority", 90), ce(ue(n), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), n;
  }
  return Le(r, [{
    key: "parse",
    value: function(a, i, o) {
      var s = function(c) {
        return c === 0 ? 7 : c;
      };
      switch (i) {
        case "i":
        case "ii":
          return St(i.length, a);
        case "io":
          return o.ordinalNumber(a, {
            unit: "day"
          });
        case "iii":
          return jt(o.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          }), s);
        case "iiiii":
          return jt(o.day(a, {
            width: "narrow",
            context: "formatting"
          }), s);
        case "iiiiii":
          return jt(o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          }), s);
        case "iiii":
        default:
          return jt(o.day(a, {
            width: "wide",
            context: "formatting"
          }) || o.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          }), s);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 1 && i <= 7;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a = oE(a, o), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(Ue), lE = /* @__PURE__ */ function(e) {
  Ve(r, e);
  var t = He(r);
  function r() {
    var n;
    Ie(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(ue(n), "priority", 80), ce(ue(n), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), n;
  }
  return Le(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "a":
        case "aa":
        case "aaa":
          return o.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return o.dayPeriod(a, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCHours(af(o), 0, 0, 0), a;
    }
  }]), r;
}(Ue), cE = /* @__PURE__ */ function(e) {
  Ve(r, e);
  var t = He(r);
  function r() {
    var n;
    Ie(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(ue(n), "priority", 80), ce(ue(n), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), n;
  }
  return Le(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "b":
        case "bb":
        case "bbb":
          return o.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return o.dayPeriod(a, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCHours(af(o), 0, 0, 0), a;
    }
  }]), r;
}(Ue), uE = /* @__PURE__ */ function(e) {
  Ve(r, e);
  var t = He(r);
  function r() {
    var n;
    Ie(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(ue(n), "priority", 80), ce(ue(n), "incompatibleTokens", ["a", "b", "t", "T"]), n;
  }
  return Le(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "B":
        case "BB":
        case "BBB":
          return o.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return o.dayPeriod(a, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCHours(af(o), 0, 0, 0), a;
    }
  }]), r;
}(Ue), fE = /* @__PURE__ */ function(e) {
  Ve(r, e);
  var t = He(r);
  function r() {
    var n;
    Ie(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(ue(n), "priority", 70), ce(ue(n), "incompatibleTokens", ["H", "K", "k", "t", "T"]), n;
  }
  return Le(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "h":
          return Ct(Et.hour12h, a);
        case "ho":
          return o.ordinalNumber(a, {
            unit: "hour"
          });
        default:
          return St(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 1 && i <= 12;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      var s = a.getUTCHours() >= 12;
      return s && o < 12 ? a.setUTCHours(o + 12, 0, 0, 0) : !s && o === 12 ? a.setUTCHours(0, 0, 0, 0) : a.setUTCHours(o, 0, 0, 0), a;
    }
  }]), r;
}(Ue), dE = /* @__PURE__ */ function(e) {
  Ve(r, e);
  var t = He(r);
  function r() {
    var n;
    Ie(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(ue(n), "priority", 70), ce(ue(n), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), n;
  }
  return Le(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "H":
          return Ct(Et.hour23h, a);
        case "Ho":
          return o.ordinalNumber(a, {
            unit: "hour"
          });
        default:
          return St(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 23;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCHours(o, 0, 0, 0), a;
    }
  }]), r;
}(Ue), pE = /* @__PURE__ */ function(e) {
  Ve(r, e);
  var t = He(r);
  function r() {
    var n;
    Ie(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(ue(n), "priority", 70), ce(ue(n), "incompatibleTokens", ["h", "H", "k", "t", "T"]), n;
  }
  return Le(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "K":
          return Ct(Et.hour11h, a);
        case "Ko":
          return o.ordinalNumber(a, {
            unit: "hour"
          });
        default:
          return St(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      var s = a.getUTCHours() >= 12;
      return s && o < 12 ? a.setUTCHours(o + 12, 0, 0, 0) : a.setUTCHours(o, 0, 0, 0), a;
    }
  }]), r;
}(Ue), hE = /* @__PURE__ */ function(e) {
  Ve(r, e);
  var t = He(r);
  function r() {
    var n;
    Ie(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(ue(n), "priority", 70), ce(ue(n), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), n;
  }
  return Le(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "k":
          return Ct(Et.hour24h, a);
        case "ko":
          return o.ordinalNumber(a, {
            unit: "hour"
          });
        default:
          return St(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 1 && i <= 24;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      var s = o <= 24 ? o % 24 : o;
      return a.setUTCHours(s, 0, 0, 0), a;
    }
  }]), r;
}(Ue), vE = /* @__PURE__ */ function(e) {
  Ve(r, e);
  var t = He(r);
  function r() {
    var n;
    Ie(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(ue(n), "priority", 60), ce(ue(n), "incompatibleTokens", ["t", "T"]), n;
  }
  return Le(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "m":
          return Ct(Et.minute, a);
        case "mo":
          return o.ordinalNumber(a, {
            unit: "minute"
          });
        default:
          return St(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 59;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCMinutes(o, 0, 0), a;
    }
  }]), r;
}(Ue), mE = /* @__PURE__ */ function(e) {
  Ve(r, e);
  var t = He(r);
  function r() {
    var n;
    Ie(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(ue(n), "priority", 50), ce(ue(n), "incompatibleTokens", ["t", "T"]), n;
  }
  return Le(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "s":
          return Ct(Et.second, a);
        case "so":
          return o.ordinalNumber(a, {
            unit: "second"
          });
        default:
          return St(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 59;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCSeconds(o, 0), a;
    }
  }]), r;
}(Ue), gE = /* @__PURE__ */ function(e) {
  Ve(r, e);
  var t = He(r);
  function r() {
    var n;
    Ie(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(ue(n), "priority", 30), ce(ue(n), "incompatibleTokens", ["t", "T"]), n;
  }
  return Le(r, [{
    key: "parse",
    value: function(a, i) {
      var o = function(l) {
        return Math.floor(l * Math.pow(10, -i.length + 3));
      };
      return jt(St(i.length, a), o);
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCMilliseconds(o), a;
    }
  }]), r;
}(Ue), yE = /* @__PURE__ */ function(e) {
  Ve(r, e);
  var t = He(r);
  function r() {
    var n;
    Ie(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(ue(n), "priority", 10), ce(ue(n), "incompatibleTokens", ["t", "T", "x"]), n;
  }
  return Le(r, [{
    key: "parse",
    value: function(a, i) {
      switch (i) {
        case "X":
          return tn(en.basicOptionalMinutes, a);
        case "XX":
          return tn(en.basic, a);
        case "XXXX":
          return tn(en.basicOptionalSeconds, a);
        case "XXXXX":
          return tn(en.extendedOptionalSeconds, a);
        case "XXX":
        default:
          return tn(en.extended, a);
      }
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return i.timestampIsSet ? a : new Date(a.getTime() - o);
    }
  }]), r;
}(Ue), bE = /* @__PURE__ */ function(e) {
  Ve(r, e);
  var t = He(r);
  function r() {
    var n;
    Ie(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(ue(n), "priority", 10), ce(ue(n), "incompatibleTokens", ["t", "T", "X"]), n;
  }
  return Le(r, [{
    key: "parse",
    value: function(a, i) {
      switch (i) {
        case "x":
          return tn(en.basicOptionalMinutes, a);
        case "xx":
          return tn(en.basic, a);
        case "xxxx":
          return tn(en.basicOptionalSeconds, a);
        case "xxxxx":
          return tn(en.extendedOptionalSeconds, a);
        case "xxx":
        default:
          return tn(en.extended, a);
      }
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return i.timestampIsSet ? a : new Date(a.getTime() - o);
    }
  }]), r;
}(Ue), CE = /* @__PURE__ */ function(e) {
  Ve(r, e);
  var t = He(r);
  function r() {
    var n;
    Ie(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(ue(n), "priority", 40), ce(ue(n), "incompatibleTokens", "*"), n;
  }
  return Le(r, [{
    key: "parse",
    value: function(a) {
      return hh(a);
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return [new Date(o * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), r;
}(Ue), xE = /* @__PURE__ */ function(e) {
  Ve(r, e);
  var t = He(r);
  function r() {
    var n;
    Ie(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(ue(n), "priority", 20), ce(ue(n), "incompatibleTokens", "*"), n;
  }
  return Le(r, [{
    key: "parse",
    value: function(a) {
      return hh(a);
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return [new Date(o), {
        timestampIsSet: !0
      }];
    }
  }]), r;
}(Ue), wE = {
  G: new RP(),
  y: new HP(),
  Y: new FP(),
  R: new WP(),
  u: new zP(),
  Q: new UP(),
  q: new ZP(),
  M: new qP(),
  L: new GP(),
  w: new KP(),
  I: new QP(),
  d: new tE(),
  D: new rE(),
  E: new nE(),
  e: new aE(),
  c: new iE(),
  i: new sE(),
  a: new lE(),
  b: new cE(),
  B: new uE(),
  h: new fE(),
  H: new dE(),
  K: new pE(),
  k: new hE(),
  m: new vE(),
  s: new mE(),
  S: new gE(),
  X: new yE(),
  x: new bE(),
  t: new CE(),
  T: new xE()
}, OE = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, SE = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, PE = /^'([^]*?)'?$/, EE = /''/g, jE = /\S/, _E = /[a-zA-Z]/;
function DE(e, t, r, n) {
  var a, i, o, s, l, c, u, f, p, h, m, v, g, y, b, w, x, C;
  Ee(3, arguments);
  var S = String(e), E = String(t), D = ta(), I = (a = (i = n == null ? void 0 : n.locale) !== null && i !== void 0 ? i : D.locale) !== null && a !== void 0 ? a : X0;
  if (!I.match)
    throw new RangeError("locale must contain match property");
  var k = Ot((o = (s = (l = (c = n == null ? void 0 : n.firstWeekContainsDate) !== null && c !== void 0 ? c : n == null || (u = n.locale) === null || u === void 0 || (f = u.options) === null || f === void 0 ? void 0 : f.firstWeekContainsDate) !== null && l !== void 0 ? l : D.firstWeekContainsDate) !== null && s !== void 0 ? s : (p = D.locale) === null || p === void 0 || (h = p.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && o !== void 0 ? o : 1);
  if (!(k >= 1 && k <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var V = Ot((m = (v = (g = (y = n == null ? void 0 : n.weekStartsOn) !== null && y !== void 0 ? y : n == null || (b = n.locale) === null || b === void 0 || (w = b.options) === null || w === void 0 ? void 0 : w.weekStartsOn) !== null && g !== void 0 ? g : D.weekStartsOn) !== null && v !== void 0 ? v : (x = D.locale) === null || x === void 0 || (C = x.options) === null || C === void 0 ? void 0 : C.weekStartsOn) !== null && m !== void 0 ? m : 0);
  if (!(V >= 0 && V <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (E === "")
    return S === "" ? Oe(r) : /* @__PURE__ */ new Date(NaN);
  var W = {
    firstWeekContainsDate: k,
    weekStartsOn: V,
    locale: I
  }, L = [new LP()], G = E.match(SE).map(function(R) {
    var $ = R[0];
    if ($ in B2) {
      var F = B2[$];
      return F(R, I.formatLong);
    }
    return R;
  }).join("").match(OE), Q = [], X = D6(G), K;
  try {
    var te = function() {
      var $ = K.value;
      !(n != null && n.useAdditionalWeekYearTokens) && G9($) && Ul($, E, e), !(n != null && n.useAdditionalDayOfYearTokens) && q9($) && Ul($, E, e);
      var F = $[0], B = wE[F];
      if (B) {
        var M = B.incompatibleTokens;
        if (Array.isArray(M)) {
          var J = Q.find(function(ee) {
            return M.includes(ee.token) || ee.token === F;
          });
          if (J)
            throw new RangeError("The format string mustn't contain `".concat(J.fullToken, "` and `").concat($, "` at the same time"));
        } else if (B.incompatibleTokens === "*" && Q.length > 0)
          throw new RangeError("The format string mustn't contain `".concat($, "` and any other token at the same time"));
        Q.push({
          token: F,
          fullToken: $
        });
        var H = B.run(S, $, I.match, W);
        if (!H)
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        L.push(H.setter), S = H.rest;
      } else {
        if (F.match(_E))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + F + "`");
        if ($ === "''" ? $ = "'" : F === "'" && ($ = AE($)), S.indexOf($) === 0)
          S = S.slice($.length);
        else
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
      }
    };
    for (X.s(); !(K = X.n()).done; ) {
      var _ = te();
      if (qr(_) === "object")
        return _.v;
    }
  } catch (R) {
    X.e(R);
  } finally {
    X.f();
  }
  if (S.length > 0 && jE.test(S))
    return /* @__PURE__ */ new Date(NaN);
  var j = L.map(function(R) {
    return R.priority;
  }).sort(function(R, $) {
    return $ - R;
  }).filter(function(R, $, F) {
    return F.indexOf(R) === $;
  }).map(function(R) {
    return L.filter(function($) {
      return $.priority === R;
    }).sort(function($, F) {
      return F.subPriority - $.subPriority;
    });
  }).map(function(R) {
    return R[0];
  }), T = Oe(r);
  if (isNaN(T.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var A = F9(T, zl(T)), O = {}, N = D6(j), q;
  try {
    for (N.s(); !(q = N.n()).done; ) {
      var Y = q.value;
      if (!Y.validate(A, W))
        return /* @__PURE__ */ new Date(NaN);
      var z = Y.set(A, O, W);
      Array.isArray(z) ? (A = z[0], MP(O, z[1])) : A = z;
    }
  } catch (R) {
    N.e(R);
  } finally {
    N.f();
  }
  return A;
}
function AE(e) {
  return e.match(PE)[1].replace(EE, "'");
}
const ME = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: DE
}, Symbol.toStringTag, { value: "Module" })), TE = /* @__PURE__ */ et(ME);
function Bo(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Bo = function(r) {
    return typeof r;
  } : Bo = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, Bo(e);
}
Object.defineProperty(Pc, "__esModule", {
  value: !0
});
Pc.default = void 0;
var ml = RE(P), Xr = Ki(Yr), $E = Ki(Ba), NE = Ki(_P), M6 = Ki(DP), IE = Ki(TE), LE = Ki(Cc);
function Ki(e) {
  return e && e.__esModule ? e : { default: e };
}
function gh(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (gh = function(a) {
    return a ? r : t;
  })(e);
}
function RE(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || Bo(e) !== "object" && typeof e != "function")
    return { default: e };
  var r = gh(t);
  if (r && r.has(e))
    return r.get(e);
  var n = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(e, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(n, i, o) : n[i] = e[i];
    }
  return n.default = e, r && r.set(e, n), n;
}
function kE(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function T6(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function BE(e, t, r) {
  return t && T6(e.prototype, t), r && T6(e, r), e;
}
function VE(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && Z2(e, t);
}
function Z2(e, t) {
  return Z2 = Object.setPrototypeOf || function(n, a) {
    return n.__proto__ = a, n;
  }, Z2(e, t);
}
function HE(e) {
  var t = WE();
  return function() {
    var n = Xl(e), a;
    if (t) {
      var i = Xl(this).constructor;
      a = Reflect.construct(n, arguments, i);
    } else
      a = n.apply(this, arguments);
    return FE(this, a);
  };
}
function FE(e, t) {
  return t && (Bo(t) === "object" || typeof t == "function") ? t : Bl(e);
}
function Bl(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function WE() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Xl(e) {
  return Xl = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Xl(e);
}
function ku(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var sf = /* @__PURE__ */ function(e) {
  VE(r, e);
  var t = HE(r);
  function r(n, a) {
    var i;
    return kE(this, r), i = t.call(this, n, a), ku(Bl(i), "onKeyDown", function(o) {
      var s = i.state.value;
      o.key === "Enter" && i.update(s);
    }), ku(Bl(i), "onChange", function(o) {
      i.setState({
        value: o.target.value,
        changed: !0,
        invalid: !1
      });
    }), ku(Bl(i), "onBlur", function() {
      var o = i.state.value;
      i.update(o);
    }), i.state = {
      invalid: !1,
      changed: !1,
      value: i.formatDate(n)
    }, i;
  }
  return BE(r, [{
    key: "componentDidUpdate",
    value: function(a) {
      var i = a.value;
      (0, NE.default)(i, this.props.value) || this.setState({
        value: this.formatDate(this.props)
      });
    }
  }, {
    key: "formatDate",
    value: function(a) {
      var i = a.value, o = a.dateDisplayFormat, s = a.dateOptions;
      return i && (0, M6.default)(i) ? (0, LE.default)(i, o, s) : "";
    }
  }, {
    key: "update",
    value: function(a) {
      var i = this.state, o = i.invalid, s = i.changed;
      if (!(o || !s || !a)) {
        var l = this.props, c = l.onChange, u = l.dateDisplayFormat, f = l.dateOptions, p = (0, IE.default)(a, u, /* @__PURE__ */ new Date(), f);
        (0, M6.default)(p) ? this.setState({
          changed: !1
        }, function() {
          return c(p);
        }) : this.setState({
          invalid: !0
        });
      }
    }
  }, {
    key: "render",
    value: function() {
      var a = this.props, i = a.className, o = a.readOnly, s = a.placeholder, l = a.ariaLabel, c = a.disabled, u = a.onFocus, f = this.state, p = f.value, h = f.invalid;
      return /* @__PURE__ */ ml.default.createElement("span", {
        className: (0, $E.default)("rdrDateInput", i)
      }, /* @__PURE__ */ ml.default.createElement("input", {
        readOnly: o,
        disabled: c,
        value: p,
        placeholder: s,
        "aria-label": l,
        onKeyDown: this.onKeyDown,
        onChange: this.onChange,
        onBlur: this.onBlur,
        onFocus: u
      }), h && /* @__PURE__ */ ml.default.createElement("span", {
        className: "rdrWarning"
      }, "⚠"));
    }
  }]), r;
}(ml.PureComponent);
sf.propTypes = {
  value: Xr.default.object,
  placeholder: Xr.default.string,
  disabled: Xr.default.bool,
  readOnly: Xr.default.bool,
  dateOptions: Xr.default.object,
  dateDisplayFormat: Xr.default.string,
  ariaLabel: Xr.default.string,
  className: Xr.default.string,
  onFocus: Xr.default.func.isRequired,
  onChange: Xr.default.func.isRequired
};
sf.defaultProps = {
  readOnly: !0,
  disabled: !1,
  dateDisplayFormat: "MMM D, YYYY"
};
var zE = sf;
Pc.default = zE;
var yh = { exports: {} };
(function(e, t) {
  (function(r, n) {
    n(Yr, P);
  })(typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : To, function(r, n) {
    r = l(r), n = s(n);
    var a, i;
    function o() {
      if (typeof WeakMap != "function")
        return null;
      var N = /* @__PURE__ */ new WeakMap();
      return o = function() {
        return N;
      }, N;
    }
    function s(N) {
      if (N && N.__esModule)
        return N;
      if (N === null || c(N) !== "object" && typeof N != "function")
        return { default: N };
      var q = o();
      if (q && q.has(N))
        return q.get(N);
      var Y = {}, z = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var R in N)
        if (Object.prototype.hasOwnProperty.call(N, R)) {
          var $ = z ? Object.getOwnPropertyDescriptor(N, R) : null;
          $ && ($.get || $.set) ? Object.defineProperty(Y, R, $) : Y[R] = N[R];
        }
      return Y.default = N, q && q.set(N, Y), Y;
    }
    function l(N) {
      return N && N.__esModule ? N : { default: N };
    }
    function c(N) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? c = function(Y) {
        return typeof Y;
      } : c = function(Y) {
        return Y && typeof Symbol == "function" && Y.constructor === Symbol && Y !== Symbol.prototype ? "symbol" : typeof Y;
      }, c(N);
    }
    function u(N, q) {
      if (!(N instanceof q))
        throw new TypeError("Cannot call a class as a function");
    }
    function f(N, q) {
      for (var Y = 0; Y < q.length; Y++) {
        var z = q[Y];
        z.enumerable = z.enumerable || !1, z.configurable = !0, "value" in z && (z.writable = !0), Object.defineProperty(N, z.key, z);
      }
    }
    function p(N, q, Y) {
      return q && f(N.prototype, q), Y && f(N, Y), N;
    }
    function h(N, q) {
      if (typeof q != "function" && q !== null)
        throw new TypeError("Super expression must either be null or a function");
      N.prototype = Object.create(q && q.prototype, { constructor: { value: N, writable: !0, configurable: !0 } }), q && m(N, q);
    }
    function m(N, q) {
      return m = Object.setPrototypeOf || function(z, R) {
        return z.__proto__ = R, z;
      }, m(N, q);
    }
    function v(N) {
      var q = b();
      return function() {
        var z = w(N), R;
        if (q) {
          var $ = w(this).constructor;
          R = Reflect.construct(z, arguments, $);
        } else
          R = z.apply(this, arguments);
        return g(this, R);
      };
    }
    function g(N, q) {
      return q && (c(q) === "object" || typeof q == "function") ? q : y(N);
    }
    function y(N) {
      if (N === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return N;
    }
    function b() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    function w(N) {
      return w = Object.setPrototypeOf ? Object.getPrototypeOf : function(Y) {
        return Y.__proto__ || Object.getPrototypeOf(Y);
      }, w(N);
    }
    function x(N, q) {
      var Y = Object.keys(N);
      if (Object.getOwnPropertySymbols) {
        var z = Object.getOwnPropertySymbols(N);
        q && (z = z.filter(function(R) {
          return Object.getOwnPropertyDescriptor(N, R).enumerable;
        })), Y.push.apply(Y, z);
      }
      return Y;
    }
    function C(N) {
      for (var q = 1; q < arguments.length; q++) {
        var Y = arguments[q] != null ? arguments[q] : {};
        q % 2 ? x(Object(Y), !0).forEach(function(z) {
          S(N, z, Y[z]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(N, Object.getOwnPropertyDescriptors(Y)) : x(Object(Y)).forEach(function(z) {
          Object.defineProperty(N, z, Object.getOwnPropertyDescriptor(Y, z));
        });
      }
      return N;
    }
    function S(N, q, Y) {
      return q in N ? Object.defineProperty(N, q, { value: Y, enumerable: !0, configurable: !0, writable: !0 }) : N[q] = Y, N;
    }
    var E = {
      x: "clientWidth",
      y: "clientHeight"
    }, D = {
      x: "clientTop",
      y: "clientLeft"
    }, I = {
      x: "innerWidth",
      y: "innerHeight"
    }, k = {
      x: "offsetWidth",
      y: "offsetHeight"
    }, V = {
      x: "offsetLeft",
      y: "offsetTop"
    }, W = {
      x: "overflowX",
      y: "overflowY"
    }, L = {
      x: "scrollWidth",
      y: "scrollHeight"
    }, G = {
      x: "scrollLeft",
      y: "scrollTop"
    }, Q = {
      x: "width",
      y: "height"
    }, X = function() {
    }, K = function() {
      if (typeof window > "u")
        return !1;
      var N = !1;
      try {
        document.createElement("div").addEventListener("test", X, {
          get passive() {
            return N = !0, !1;
          }
        });
      } catch {
      }
      return N;
    }() ? {
      passive: !0
    } : !1, te = "ReactList failed to reach a stable state.", _ = 40, j = function(q, Y) {
      for (var z in Y)
        if (q[z] !== Y[z])
          return !1;
      return !0;
    }, T = function(q) {
      for (var Y = q.props.axis, z = q.getEl(), R = W[Y]; z = z.parentElement; )
        switch (window.getComputedStyle(z)[R]) {
          case "auto":
          case "scroll":
          case "overlay":
            return z;
        }
      return window;
    }, A = function(q) {
      var Y = q.props.axis, z = q.scrollParent;
      return z === window ? window[I[Y]] : z[E[Y]];
    }, O = function(q, Y) {
      var z = q.length, R = q.minSize, $ = q.type, F = Y.from, B = Y.size, M = Y.itemsPerRow;
      B = Math.max(B, R);
      var J = B % M;
      return J && (B += M - J), B > z && (B = z), F = $ === "simple" || !F ? 0 : Math.max(Math.min(F, z - B), 0), (J = F % M) && (F -= J, B += J), F === Y.from && B == Y.size ? Y : C(C({}, Y), {}, {
        from: F,
        size: B
      });
    };
    e.exports = (i = a = /* @__PURE__ */ function(N) {
      h(Y, N);
      var q = v(Y);
      p(Y, null, [{
        key: "getDerivedStateFromProps",
        value: function(R, $) {
          var F = O(R, $);
          return F === $ ? null : F;
        }
      }]);
      function Y(z) {
        var R;
        return u(this, Y), R = q.call(this, z), R.state = O(z, {
          itemsPerRow: 1,
          from: z.initialIndex,
          size: 0
        }), R.cache = {}, R.cachedScrollPosition = null, R.prevPrevState = {}, R.unstable = !1, R.updateCounter = 0, R;
      }
      return p(Y, [{
        key: "componentDidMount",
        value: function() {
          this.updateFrameAndClearCache = this.updateFrameAndClearCache.bind(this), window.addEventListener("resize", this.updateFrameAndClearCache), this.updateFrame(this.scrollTo.bind(this, this.props.initialIndex));
        }
      }, {
        key: "componentDidUpdate",
        value: function(R) {
          var $ = this;
          if (this.props.axis !== R.axis && this.clearSizeCache(), !this.unstable) {
            if (++this.updateCounter > _)
              return this.unstable = !0, console.error(te);
            this.updateCounterTimeoutId || (this.updateCounterTimeoutId = setTimeout(function() {
              $.updateCounter = 0, delete $.updateCounterTimeoutId;
            }, 0)), this.updateFrame();
          }
        }
      }, {
        key: "maybeSetState",
        value: function(R, $) {
          if (j(this.state, R))
            return $();
          this.setState(R, $);
        }
      }, {
        key: "componentWillUnmount",
        value: function() {
          window.removeEventListener("resize", this.updateFrameAndClearCache), this.scrollParent.removeEventListener("scroll", this.updateFrameAndClearCache, K), this.scrollParent.removeEventListener("mousewheel", X, K);
        }
      }, {
        key: "getOffset",
        value: function(R) {
          var $ = this.props.axis, F = R[D[$]] || 0, B = V[$];
          do
            F += R[B] || 0;
          while (R = R.offsetParent);
          return F;
        }
      }, {
        key: "getEl",
        value: function() {
          return this.el || this.items;
        }
      }, {
        key: "getScrollPosition",
        value: function() {
          if (typeof this.cachedScrollPosition == "number")
            return this.cachedScrollPosition;
          var R = this.scrollParent, $ = this.props.axis, F = G[$], B = R === window ? (
            // Firefox always returns document.body[scrollKey] as 0 and Chrome/Safari
            // always return document.documentElement[scrollKey] as 0, so take
            // whichever has a value.
            document.body[F] || document.documentElement[F]
          ) : R[F], M = this.getScrollSize() - this.props.scrollParentViewportSizeGetter(this), J = Math.max(0, Math.min(B, M)), H = this.getEl();
          return this.cachedScrollPosition = this.getOffset(R) + J - this.getOffset(H), this.cachedScrollPosition;
        }
      }, {
        key: "setScroll",
        value: function(R) {
          var $ = this.scrollParent, F = this.props.axis;
          if (R += this.getOffset(this.getEl()), $ === window)
            return window.scrollTo(0, R);
          R -= this.getOffset(this.scrollParent), $[G[F]] = R;
        }
      }, {
        key: "getScrollSize",
        value: function() {
          var R = this.scrollParent, $ = document, F = $.body, B = $.documentElement, M = L[this.props.axis];
          return R === window ? Math.max(F[M], B[M]) : R[M];
        }
      }, {
        key: "hasDeterminateSize",
        value: function() {
          var R = this.props, $ = R.itemSizeGetter, F = R.type;
          return F === "uniform" || $;
        }
      }, {
        key: "getStartAndEnd",
        value: function() {
          var R = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props.threshold, $ = this.getScrollPosition(), F = Math.max(0, $ - R), B = $ + this.props.scrollParentViewportSizeGetter(this) + R;
          return this.hasDeterminateSize() && (B = Math.min(B, this.getSpaceBefore(this.props.length))), {
            start: F,
            end: B
          };
        }
      }, {
        key: "getItemSizeAndItemsPerRow",
        value: function() {
          var R = this.props, $ = R.axis, F = R.useStaticSize, B = this.state, M = B.itemSize, J = B.itemsPerRow;
          if (F && M && J)
            return {
              itemSize: M,
              itemsPerRow: J
            };
          var H = this.items.children;
          if (!H.length)
            return {};
          var ee = H[0], ne = ee[k[$]], ae = Math.abs(ne - M);
          if ((isNaN(ae) || ae >= 1) && (M = ne), !M)
            return {};
          var se = V[$], de = ee[se];
          J = 1;
          for (var ve = H[J]; ve && ve[se] === de; ve = H[J])
            ++J;
          return {
            itemSize: M,
            itemsPerRow: J
          };
        }
      }, {
        key: "clearSizeCache",
        value: function() {
          this.cachedScrollPosition = null;
        }
        // Called by 'scroll' and 'resize' events, clears scroll position cache.
      }, {
        key: "updateFrameAndClearCache",
        value: function(R) {
          return this.clearSizeCache(), this.updateFrame(R);
        }
      }, {
        key: "updateFrame",
        value: function(R) {
          switch (this.updateScrollParent(), typeof R != "function" && (R = X), this.props.type) {
            case "simple":
              return this.updateSimpleFrame(R);
            case "variable":
              return this.updateVariableFrame(R);
            case "uniform":
              return this.updateUniformFrame(R);
          }
        }
      }, {
        key: "updateScrollParent",
        value: function() {
          var R = this.scrollParent;
          this.scrollParent = this.props.scrollParentGetter(this), R !== this.scrollParent && (R && (R.removeEventListener("scroll", this.updateFrameAndClearCache), R.removeEventListener("mousewheel", X)), this.clearSizeCache(), this.scrollParent.addEventListener("scroll", this.updateFrameAndClearCache, K), this.scrollParent.addEventListener("mousewheel", X, K));
        }
      }, {
        key: "updateSimpleFrame",
        value: function(R) {
          var $ = this.getStartAndEnd(), F = $.end, B = this.items.children, M = 0;
          if (B.length) {
            var J = this.props.axis, H = B[0], ee = B[B.length - 1];
            M = this.getOffset(ee) + ee[k[J]] - this.getOffset(H);
          }
          if (M > F)
            return R();
          var ne = this.props, ae = ne.pageSize, se = ne.length, de = Math.min(this.state.size + ae, se);
          this.maybeSetState({
            size: de
          }, R);
        }
      }, {
        key: "updateVariableFrame",
        value: function(R) {
          this.props.itemSizeGetter || this.cacheSizes();
          for (var $ = this.getStartAndEnd(), F = $.start, B = $.end, M = this.props, J = M.length, H = M.pageSize, ee = 0, ne = 0, ae = 0, se = J - 1; ne < se; ) {
            var de = this.getSizeOfItem(ne);
            if (de == null || ee + de > F)
              break;
            ee += de, ++ne;
          }
          for (var ve = J - ne; ae < ve && ee < B; ) {
            var Te = this.getSizeOfItem(ne + ae);
            if (Te == null) {
              ae = Math.min(ae + H, ve);
              break;
            }
            ee += Te, ++ae;
          }
          this.maybeSetState(O(this.props, {
            from: ne,
            itemsPerRow: 1,
            size: ae
          }), R);
        }
      }, {
        key: "updateUniformFrame",
        value: function(R) {
          var $ = this.getItemSizeAndItemsPerRow(), F = $.itemSize, B = $.itemsPerRow;
          if (!F || !B)
            return R();
          var M = this.getStartAndEnd(), J = M.start, H = M.end, ee = O(this.props, {
            from: Math.floor(J / F) * B,
            size: (Math.ceil((H - J) / F) + 1) * B,
            itemsPerRow: B
          }), ne = ee.from, ae = ee.size;
          return this.maybeSetState({
            itemsPerRow: B,
            from: ne,
            itemSize: F,
            size: ae
          }, R);
        }
      }, {
        key: "getSpaceBefore",
        value: function(R) {
          var $ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
          if ($[R] != null)
            return $[R];
          var F = this.state, B = F.itemSize, M = F.itemsPerRow;
          if (B)
            return $[R] = Math.floor(R / M) * B;
          for (var J = R; J > 0 && $[--J] == null; )
            ;
          for (var H = $[J] || 0, ee = J; ee < R; ++ee) {
            $[ee] = H;
            var ne = this.getSizeOfItem(ee);
            if (ne == null)
              break;
            H += ne;
          }
          return $[R] = H;
        }
      }, {
        key: "cacheSizes",
        value: function() {
          for (var R = this.cache, $ = this.state.from, F = this.items.children, B = k[this.props.axis], M = 0, J = F.length; M < J; ++M)
            R[$ + M] = F[M][B];
        }
      }, {
        key: "getSizeOfItem",
        value: function(R) {
          var $ = this.cache, F = this.items, B = this.props, M = B.axis, J = B.itemSizeGetter, H = B.itemSizeEstimator, ee = B.type, ne = this.state, ae = ne.from, se = ne.itemSize, de = ne.size;
          if (se)
            return se;
          if (J)
            return J(R);
          if (R in $)
            return $[R];
          if (ee === "simple" && R >= ae && R < ae + de && F) {
            var ve = F.children[R - ae];
            if (ve)
              return ve[k[M]];
          }
          if (H)
            return H(R, $);
        }
      }, {
        key: "scrollTo",
        value: function(R) {
          R != null && this.setScroll(this.getSpaceBefore(R));
        }
      }, {
        key: "scrollAround",
        value: function(R) {
          var $ = this.getScrollPosition(), F = this.getSpaceBefore(R), B = F - this.props.scrollParentViewportSizeGetter(this) + this.getSizeOfItem(R), M = Math.min(B, F), J = Math.max(B, F);
          if ($ <= M)
            return this.setScroll(M);
          if ($ > J)
            return this.setScroll(J);
        }
      }, {
        key: "getVisibleRange",
        value: function() {
          for (var R = this.state, $ = R.from, F = R.size, B = this.getStartAndEnd(0), M = B.start, J = B.end, H = {}, ee, ne, ae = $; ae < $ + F; ++ae) {
            var se = this.getSpaceBefore(ae, H), de = se + this.getSizeOfItem(ae);
            ee == null && de > M && (ee = ae), ee != null && se < J && (ne = ae);
          }
          return [ee, ne];
        }
      }, {
        key: "renderItems",
        value: function() {
          for (var R = this, $ = this.props, F = $.itemRenderer, B = $.itemsRenderer, M = this.state, J = M.from, H = M.size, ee = [], ne = 0; ne < H; ++ne)
            ee.push(F(J + ne, ne));
          return B(ee, function(ae) {
            return R.items = ae;
          });
        }
      }, {
        key: "render",
        value: function() {
          var R = this, $ = this.props, F = $.axis, B = $.length, M = $.type, J = $.useTranslate3d, H = this.state, ee = H.from, ne = H.itemsPerRow, ae = this.renderItems();
          if (M === "simple")
            return ae;
          var se = {
            position: "relative"
          }, de = {}, ve = Math.ceil(B / ne) * ne, Te = this.getSpaceBefore(ve, de);
          Te && (se[Q[F]] = Te, F === "x" && (se.overflowX = "hidden"));
          var We = this.getSpaceBefore(ee, de), Ze = F === "x" ? We : 0, yt = F === "y" ? We : 0, Tt = J ? "translate3d(".concat(Ze, "px, ").concat(yt, "px, 0)") : "translate(".concat(Ze, "px, ").concat(yt, "px)"), kr = {
            msTransform: Tt,
            WebkitTransform: Tt,
            transform: Tt
          };
          return /* @__PURE__ */ n.default.createElement("div", {
            style: se,
            ref: function(xu) {
              return R.el = xu;
            }
          }, /* @__PURE__ */ n.default.createElement("div", {
            style: kr
          }, ae));
        }
      }]), Y;
    }(n.Component), S(a, "displayName", "ReactList"), S(a, "propTypes", {
      axis: r.default.oneOf(["x", "y"]),
      initialIndex: r.default.number,
      itemRenderer: r.default.func,
      itemSizeEstimator: r.default.func,
      itemSizeGetter: r.default.func,
      itemsRenderer: r.default.func,
      length: r.default.number,
      minSize: r.default.number,
      pageSize: r.default.number,
      scrollParentGetter: r.default.func,
      scrollParentViewportSizeGetter: r.default.func,
      threshold: r.default.number,
      type: r.default.oneOf(["simple", "variable", "uniform"]),
      useStaticSize: r.default.bool,
      useTranslate3d: r.default.bool
    }), S(a, "defaultProps", {
      axis: "y",
      itemRenderer: function(q, Y) {
        return /* @__PURE__ */ n.default.createElement("div", {
          key: Y
        }, q);
      },
      itemsRenderer: function(q, Y) {
        return /* @__PURE__ */ n.default.createElement("div", {
          ref: Y
        }, q);
      },
      length: 0,
      minSize: 1,
      pageSize: 10,
      scrollParentGetter: T,
      scrollParentViewportSizeGetter: A,
      threshold: 100,
      type: "simple",
      useStaticSize: !1,
      useTranslate3d: !1
    }), i);
  });
})(yh);
var UE = yh.exports;
function ZE(e, t) {
  if (e === t)
    return !0;
  if (!e || !t)
    return !1;
  var r = Object.keys(e), n = Object.keys(t), a = r.length;
  if (n.length !== a)
    return !1;
  for (var i = 0; i < a; i++) {
    var o = r[i];
    if (e[o] !== t[o] || !Object.prototype.hasOwnProperty.call(t, o))
      return !1;
  }
  return !0;
}
function qE(e, t) {
  if (e === t)
    return !0;
  if (!e || !t)
    return !1;
  var r = e.length;
  if (t.length !== r)
    return !1;
  for (var n = 0; n < r; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
const GE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  shallowEqualArrays: qE,
  shallowEqualObjects: ZE
}, Symbol.toStringTag, { value: "Module" })), YE = /* @__PURE__ */ et(GE);
function KE(e) {
  Ee(1, arguments);
  var t;
  if (e && typeof e.forEach == "function")
    t = e;
  else if (qr(e) === "object" && e !== null)
    t = Array.prototype.slice.call(e);
  else
    return /* @__PURE__ */ new Date(NaN);
  var r;
  return t.forEach(function(n) {
    var a = Oe(n);
    (r === void 0 || r < a || isNaN(Number(a))) && (r = a);
  }), r || /* @__PURE__ */ new Date(NaN);
}
const XE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: KE
}, Symbol.toStringTag, { value: "Module" })), bh = /* @__PURE__ */ et(XE);
function QE(e) {
  Ee(1, arguments);
  var t;
  if (e && typeof e.forEach == "function")
    t = e;
  else if (qr(e) === "object" && e !== null)
    t = Array.prototype.slice.call(e);
  else
    return /* @__PURE__ */ new Date(NaN);
  var r;
  return t.forEach(function(n) {
    var a = Oe(n);
    (r === void 0 || r > a || isNaN(a.getDate())) && (r = a);
  }), r || /* @__PURE__ */ new Date(NaN);
}
const JE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: QE
}, Symbol.toStringTag, { value: "Module" })), Ch = /* @__PURE__ */ et(JE);
function $6(e, t) {
  var r = e.getFullYear() - t.getFullYear() || e.getMonth() - t.getMonth() || e.getDate() - t.getDate() || e.getHours() - t.getHours() || e.getMinutes() - t.getMinutes() || e.getSeconds() - t.getSeconds() || e.getMilliseconds() - t.getMilliseconds();
  return r < 0 ? -1 : r > 0 ? 1 : r;
}
function ej(e, t) {
  Ee(2, arguments);
  var r = Oe(e), n = Oe(t), a = $6(r, n), i = Math.abs(th(r, n));
  r.setDate(r.getDate() - a * i);
  var o = +($6(r, n) === -a), s = a * (i - o);
  return s === 0 ? 0 : s;
}
const tj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ej
}, Symbol.toStringTag, { value: "Module" })), rj = /* @__PURE__ */ et(tj);
function nj(e, t) {
  Ee(2, arguments);
  var r = Oe(e), n = Oe(t);
  return r.getFullYear() === n.getFullYear() && r.getMonth() === n.getMonth();
}
const aj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: nj
}, Symbol.toStringTag, { value: "Module" })), ij = /* @__PURE__ */ et(aj);
function oj(e) {
  Ee(1, arguments);
  var t = Oe(e), r = t.getFullYear(), n = t.getMonth(), a = /* @__PURE__ */ new Date(0);
  return a.setFullYear(r, n + 1, 0), a.setHours(0, 0, 0, 0), a.getDate();
}
function sj(e, t) {
  Ee(2, arguments);
  var r = Oe(e), n = Ot(t), a = r.getFullYear(), i = r.getDate(), o = /* @__PURE__ */ new Date(0);
  o.setFullYear(a, n, 15), o.setHours(0, 0, 0, 0);
  var s = oj(o);
  return r.setMonth(n, Math.min(i, s)), r;
}
const lj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sj
}, Symbol.toStringTag, { value: "Module" })), cj = /* @__PURE__ */ et(lj);
function uj(e, t) {
  Ee(2, arguments);
  var r = Oe(e), n = Ot(t);
  return isNaN(r.getTime()) ? /* @__PURE__ */ new Date(NaN) : (r.setFullYear(n), r);
}
const fj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: uj
}, Symbol.toStringTag, { value: "Module" })), dj = /* @__PURE__ */ et(fj);
function lf(e, t) {
  Ee(2, arguments);
  var r = Oe(e), n = Ot(t);
  if (isNaN(n))
    return /* @__PURE__ */ new Date(NaN);
  if (!n)
    return r;
  var a = r.getDate(), i = new Date(r.getTime());
  i.setMonth(r.getMonth() + n + 1, 0);
  var o = i.getDate();
  return a >= o ? i : (r.setFullYear(i.getFullYear(), i.getMonth(), a), r);
}
const pj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: lf
}, Symbol.toStringTag, { value: "Module" }));
function hj(e, t) {
  Ee(2, arguments);
  var r = Ot(t);
  return lf(e, r * 12);
}
const vj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: hj
}, Symbol.toStringTag, { value: "Module" })), mj = /* @__PURE__ */ et(vj);
function gj(e, t) {
  Ee(2, arguments);
  var r = Ot(t);
  return lf(e, -r);
}
const yj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gj
}, Symbol.toStringTag, { value: "Module" })), bj = /* @__PURE__ */ et(yj), xh = /* @__PURE__ */ et(pj), Cj = /* @__PURE__ */ et(cS);
var Va = {};
Object.defineProperty(Va, "__esModule", {
  value: !0
});
Va.default = void 0;
var xj = {
  dateRangeWrapper: "rdrDateRangeWrapper",
  calendarWrapper: "rdrCalendarWrapper",
  dateDisplay: "rdrDateDisplay",
  dateDisplayItem: "rdrDateDisplayItem",
  dateDisplayItemActive: "rdrDateDisplayItemActive",
  monthAndYearWrapper: "rdrMonthAndYearWrapper",
  monthAndYearPickers: "rdrMonthAndYearPickers",
  nextPrevButton: "rdrNextPrevButton",
  month: "rdrMonth",
  weekDays: "rdrWeekDays",
  weekDay: "rdrWeekDay",
  days: "rdrDays",
  day: "rdrDay",
  dayNumber: "rdrDayNumber",
  dayPassive: "rdrDayPassive",
  dayToday: "rdrDayToday",
  dayStartOfWeek: "rdrDayStartOfWeek",
  dayEndOfWeek: "rdrDayEndOfWeek",
  daySelected: "rdrDaySelected",
  dayDisabled: "rdrDayDisabled",
  dayStartOfMonth: "rdrDayStartOfMonth",
  dayEndOfMonth: "rdrDayEndOfMonth",
  dayWeekend: "rdrDayWeekend",
  dayStartPreview: "rdrDayStartPreview",
  dayInPreview: "rdrDayInPreview",
  dayEndPreview: "rdrDayEndPreview",
  dayHovered: "rdrDayHovered",
  dayActive: "rdrDayActive",
  inRange: "rdrInRange",
  endEdge: "rdrEndEdge",
  startEdge: "rdrStartEdge",
  prevButton: "rdrPprevButton",
  nextButton: "rdrNextButton",
  selected: "rdrSelected",
  months: "rdrMonths",
  monthPicker: "rdrMonthPicker",
  yearPicker: "rdrYearPicker",
  dateDisplayWrapper: "rdrDateDisplayWrapper",
  definedRangesWrapper: "rdrDefinedRangesWrapper",
  staticRanges: "rdrStaticRanges",
  staticRange: "rdrStaticRange",
  inputRanges: "rdrInputRanges",
  inputRange: "rdrInputRange",
  inputRangeInput: "rdrInputRangeInput",
  dateRangePickerWrapper: "rdrDateRangePickerWrapper",
  staticRangeLabel: "rdrStaticRangeLabel",
  staticRangeSelected: "rdrStaticRangeSelected",
  monthName: "rdrMonthName",
  infiniteMonths: "rdrInfiniteMonths",
  monthsVertical: "rdrMonthsVertical",
  monthsHorizontal: "rdrMonthsHorizontal"
};
Va.default = xj;
var Ec = {};
Object.defineProperty(Ec, "__esModule", {
  value: !0
});
Ec.ariaLabelsShape = void 0;
var gn = wj(Yr);
function wj(e) {
  return e && e.__esModule ? e : { default: e };
}
var Oj = gn.default.shape({
  dateInput: gn.default.objectOf(gn.default.shape({
    startDate: gn.default.string,
    endDate: gn.default.string
  })),
  monthPicker: gn.default.string,
  yearPicker: gn.default.string,
  prevButton: gn.default.string,
  nextButton: gn.default.string
});
Ec.ariaLabelsShape = Oj;
function Vo(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Vo = function(r) {
    return typeof r;
  } : Vo = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, Vo(e);
}
Object.defineProperty(Ks, "__esModule", {
  value: !0
});
Ks.default = void 0;
var rt = Uj(P), me = mt(Yr), Sj = _n, N6 = mt(xc), I6 = mt(Pc), gl = Tn, fa = mt(Ba), Pj = mt(UE), Ej = YE, jj = mt(bh), _j = mt(Ch), Dj = mt(rj), Aj = mt(ij), Mj = mt(Sc), Tj = mt(tf), $j = mt(rf), Bu = mt(eh), Nj = mt(cj), Ij = mt(dj), L6 = mt(mj), Lj = mt(bc), Rj = mt(wc), kj = mt(Oc), Bj = mt(Q9), Vj = mt(Cc), Hj = mt(bj), yo = mt(xh), Fj = mt(Cj), Wj = mt(Va), zj = Ec;
function mt(e) {
  return e && e.__esModule ? e : { default: e };
}
function wh(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (wh = function(a) {
    return a ? r : t;
  })(e);
}
function Uj(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || Vo(e) !== "object" && typeof e != "function")
    return { default: e };
  var r = wh(t);
  if (r && r.has(e))
    return r.get(e);
  var n = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(e, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(n, i, o) : n[i] = e[i];
    }
  return n.default = e, r && r.set(e, n), n;
}
function Ql() {
  return Ql = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ql.apply(this, arguments);
}
function Zj(e) {
  return Kj(e) || Yj(e) || Gj(e) || qj();
}
function qj() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Gj(e, t) {
  if (e) {
    if (typeof e == "string")
      return q2(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return q2(e, t);
  }
}
function Yj(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function Kj(e) {
  if (Array.isArray(e))
    return q2(e);
}
function q2(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function R6(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function yl(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? R6(Object(r), !0).forEach(function(n) {
      Qt(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : R6(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Xj(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function k6(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function Qj(e, t, r) {
  return t && k6(e.prototype, t), r && k6(e, r), e;
}
function Jj(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && G2(e, t);
}
function G2(e, t) {
  return G2 = Object.setPrototypeOf || function(n, a) {
    return n.__proto__ = a, n;
  }, G2(e, t);
}
function e_(e) {
  var t = r_();
  return function() {
    var n = Jl(e), a;
    if (t) {
      var i = Jl(this).constructor;
      a = Reflect.construct(n, arguments, i);
    } else
      a = n.apply(this, arguments);
    return t_(this, a);
  };
}
function t_(e, t) {
  return t && (Vo(t) === "object" || typeof t == "function") ? t : ar(e);
}
function ar(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function r_() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Jl(e) {
  return Jl = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Jl(e);
}
function Qt(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var cf = /* @__PURE__ */ function(e) {
  Jj(r, e);
  var t = e_(r);
  function r(n, a) {
    var i;
    return Xj(this, r), i = t.call(this, n, a), Qt(ar(i), "focusToDate", function(o) {
      var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : i.props, l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
      if (!s.scroll.enabled) {
        if (l && s.preventSnapRefocus) {
          var c = (0, Bu.default)(o, i.state.focusedDate), u = s.calendarFocus === "forwards" && c >= 0, f = s.calendarFocus === "backwards" && c <= 0;
          if ((u || f) && Math.abs(c) < s.months)
            return;
        }
        i.setState({
          focusedDate: o
        });
        return;
      }
      var p = (0, Bu.default)(o, s.minDate, i.dateOptions), h = i.list.getVisibleRange();
      l && h.includes(p) || (i.isFirstRender = !0, i.list.scrollTo(p), i.setState({
        focusedDate: o
      }));
    }), Qt(ar(i), "updateShownDate", function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i.props, s = o.scroll.enabled ? yl(yl({}, o), {}, {
        months: i.list.getVisibleRange().length
      }) : o, l = (0, gl.calcFocusDate)(i.state.focusedDate, s);
      i.focusToDate(l, s);
    }), Qt(ar(i), "updatePreview", function(o) {
      if (!o) {
        i.setState({
          preview: null
        });
        return;
      }
      var s = {
        startDate: o,
        endDate: o,
        color: i.props.color
      };
      i.setState({
        preview: s
      });
    }), Qt(ar(i), "changeShownDate", function(o) {
      var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "set", l = i.state.focusedDate, c = i.props, u = c.onShownDateChange, f = c.minDate, p = c.maxDate, h = {
        monthOffset: function() {
          return (0, yo.default)(l, o);
        },
        setMonth: function(v) {
          function g() {
            return v.apply(this, arguments);
          }
          return g.toString = function() {
            return v.toString();
          }, g;
        }(function() {
          return (0, Nj.default)(l, o);
        }),
        setYear: function(v) {
          function g() {
            return v.apply(this, arguments);
          }
          return g.toString = function() {
            return v.toString();
          }, g;
        }(function() {
          return (0, Ij.default)(l, o);
        }),
        set: function() {
          return o;
        }
      }, m = (0, _j.default)([(0, jj.default)([h[s](), f]), p]);
      i.focusToDate(m, i.props, !1), u && u(m);
    }), Qt(ar(i), "handleRangeFocusChange", function(o, s) {
      i.props.onRangeFocusChange && i.props.onRangeFocusChange([o, s]);
    }), Qt(ar(i), "handleScroll", function() {
      var o = i.props, s = o.onShownDateChange, l = o.minDate, c = i.state.focusedDate, u = ar(i), f = u.isFirstRender, p = i.list.getVisibleRange();
      if (p[0] !== void 0) {
        var h = (0, yo.default)(l, p[0] || 0), m = !(0, Aj.default)(h, c);
        m && !f && (i.setState({
          focusedDate: h
        }), s && s(h)), i.isFirstRender = !1;
      }
    }), Qt(ar(i), "renderMonthAndYear", function(o, s, l) {
      var c = l.showMonthArrow, u = l.minDate, f = l.maxDate, p = l.showMonthAndYearPickers, h = l.ariaLabels, m = (f || r.defaultProps.maxDate).getFullYear(), v = (u || r.defaultProps.minDate).getFullYear(), g = i.styles;
      return /* @__PURE__ */ rt.default.createElement("div", {
        onMouseUp: function(b) {
          return b.stopPropagation();
        },
        className: g.monthAndYearWrapper
      }, c ? /* @__PURE__ */ rt.default.createElement("button", {
        type: "button",
        className: (0, fa.default)(g.nextPrevButton, g.prevButton),
        onClick: function() {
          return s(-1, "monthOffset");
        },
        "aria-label": h.prevButton
      }, /* @__PURE__ */ rt.default.createElement("i", null)) : null, p ? /* @__PURE__ */ rt.default.createElement("span", {
        className: g.monthAndYearPickers
      }, /* @__PURE__ */ rt.default.createElement("span", {
        className: g.monthPicker
      }, /* @__PURE__ */ rt.default.createElement("select", {
        value: o.getMonth(),
        onChange: function(b) {
          return s(b.target.value, "setMonth");
        },
        "aria-label": h.monthPicker
      }, i.state.monthNames.map(function(y, b) {
        return /* @__PURE__ */ rt.default.createElement("option", {
          key: b,
          value: b
        }, y);
      }))), /* @__PURE__ */ rt.default.createElement("span", {
        className: g.monthAndYearDivider
      }), /* @__PURE__ */ rt.default.createElement("span", {
        className: g.yearPicker
      }, /* @__PURE__ */ rt.default.createElement("select", {
        value: o.getFullYear(),
        onChange: function(b) {
          return s(b.target.value, "setYear");
        },
        "aria-label": h.yearPicker
      }, new Array(m - v + 1).fill(m).map(function(y, b) {
        var w = y - b;
        return /* @__PURE__ */ rt.default.createElement("option", {
          key: w,
          value: w
        }, w);
      })))) : /* @__PURE__ */ rt.default.createElement("span", {
        className: g.monthAndYearPickers
      }, i.state.monthNames[o.getMonth()], " ", o.getFullYear()), c ? /* @__PURE__ */ rt.default.createElement("button", {
        type: "button",
        className: (0, fa.default)(g.nextPrevButton, g.nextButton),
        onClick: function() {
          return s(1, "monthOffset");
        },
        "aria-label": h.nextButton
      }, /* @__PURE__ */ rt.default.createElement("i", null)) : null);
    }), Qt(ar(i), "renderDateDisplay", function() {
      var o = i.props, s = o.focusedRange, l = o.color, c = o.ranges, u = o.rangeColors, f = o.dateDisplayFormat, p = o.editableDateInputs, h = o.startDatePlaceholder, m = o.endDatePlaceholder, v = o.ariaLabels, g = u[s[0]] || l, y = i.styles;
      return /* @__PURE__ */ rt.default.createElement("div", {
        className: y.dateDisplayWrapper
      }, c.map(function(b, w) {
        return b.showDateDisplay === !1 || b.disabled && !b.showDateDisplay ? null : /* @__PURE__ */ rt.default.createElement("div", {
          className: y.dateDisplay,
          key: w,
          style: {
            color: b.color || g
          }
        }, /* @__PURE__ */ rt.default.createElement(I6.default, {
          className: (0, fa.default)(y.dateDisplayItem, Qt({}, y.dateDisplayItemActive, s[0] === w && s[1] === 0)),
          readOnly: !p,
          disabled: b.disabled,
          value: b.startDate,
          placeholder: h,
          dateOptions: i.dateOptions,
          dateDisplayFormat: f,
          ariaLabel: v.dateInput && v.dateInput[b.key] && v.dateInput[b.key].startDate,
          onChange: i.onDragSelectionEnd,
          onFocus: function() {
            return i.handleRangeFocusChange(w, 0);
          }
        }), /* @__PURE__ */ rt.default.createElement(I6.default, {
          className: (0, fa.default)(y.dateDisplayItem, Qt({}, y.dateDisplayItemActive, s[0] === w && s[1] === 1)),
          readOnly: !p,
          disabled: b.disabled,
          value: b.endDate,
          placeholder: m,
          dateOptions: i.dateOptions,
          dateDisplayFormat: f,
          ariaLabel: v.dateInput && v.dateInput[b.key] && v.dateInput[b.key].endDate,
          onChange: i.onDragSelectionEnd,
          onFocus: function() {
            return i.handleRangeFocusChange(w, 1);
          }
        }));
      }));
    }), Qt(ar(i), "onDragSelectionStart", function(o) {
      var s = i.props, l = s.onChange, c = s.dragSelectionEnabled;
      c ? i.setState({
        drag: {
          status: !0,
          range: {
            startDate: o,
            endDate: o
          },
          disablePreview: !0
        }
      }) : l && l(o);
    }), Qt(ar(i), "onDragSelectionEnd", function(o) {
      var s = i.props, l = s.updateRange, c = s.displayMode, u = s.onChange, f = s.dragSelectionEnabled;
      if (f) {
        if (c === "date" || !i.state.drag.status) {
          u && u(o);
          return;
        }
        var p = {
          startDate: i.state.drag.range.startDate,
          endDate: o
        };
        c !== "dateRange" || (0, Lj.default)(p.startDate, o) ? i.setState({
          drag: {
            status: !1,
            range: {}
          }
        }, function() {
          return u && u(o);
        }) : i.setState({
          drag: {
            status: !1,
            range: {}
          }
        }, function() {
          l && l(p);
        });
      }
    }), Qt(ar(i), "onDragSelectionMove", function(o) {
      var s = i.state.drag;
      !s.status || !i.props.dragSelectionEnabled || i.setState({
        drag: {
          status: s.status,
          range: {
            startDate: s.range.startDate,
            endDate: o
          },
          disablePreview: !0
        }
      });
    }), Qt(ar(i), "estimateMonthSize", function(o, s) {
      var l = i.props, c = l.direction, u = l.minDate, f = i.state.scrollArea;
      if (s && (i.listSizeCache = s, s[o]))
        return s[o];
      if (c === "horizontal")
        return f.monthWidth;
      var p = (0, yo.default)(u, o), h = (0, gl.getMonthDisplayRange)(p, i.dateOptions), m = h.start, v = h.end, g = (0, Dj.default)(v, m, i.dateOptions) + 1 > 7 * 5;
      return g ? f.longMonthHeight : f.monthHeight;
    }), i.dateOptions = {
      locale: n.locale
    }, n.weekStartsOn !== void 0 && (i.dateOptions.weekStartsOn = n.weekStartsOn), i.styles = (0, gl.generateStyles)([Wj.default, n.classNames]), i.listSizeCache = {}, i.isFirstRender = !0, i.state = {
      monthNames: i.getMonthNames(),
      focusedDate: (0, gl.calcFocusDate)(null, n),
      drag: {
        status: !1,
        range: {
          startDate: null,
          endDate: null
        },
        disablePreview: !1
      },
      scrollArea: i.calcScrollArea(n)
    }, i;
  }
  return Qj(r, [{
    key: "getMonthNames",
    value: function() {
      var a = this;
      return Zj(Array(12).keys()).map(function(i) {
        return a.props.locale.localize.month(i);
      });
    }
  }, {
    key: "calcScrollArea",
    value: function(a) {
      var i = a.direction, o = a.months, s = a.scroll;
      if (!s.enabled)
        return {
          enabled: !1
        };
      var l = s.longMonthHeight || s.monthHeight;
      return i === "vertical" ? {
        enabled: !0,
        monthHeight: s.monthHeight || 220,
        longMonthHeight: l || 260,
        calendarWidth: "auto",
        calendarHeight: (s.calendarHeight || l || 240) * o
      } : {
        enabled: !0,
        monthWidth: s.monthWidth || 332,
        calendarWidth: (s.calendarWidth || s.monthWidth || 332) * o,
        monthHeight: l || 300,
        calendarHeight: l || 300
      };
    }
  }, {
    key: "componentDidMount",
    value: function() {
      var a = this;
      this.props.scroll.enabled && setTimeout(function() {
        return a.focusToDate(a.state.focusedDate);
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function(a) {
      var i = {
        dateRange: "ranges",
        date: "date"
      }, o = i[this.props.displayMode];
      this.props[o] !== a[o] && this.updateShownDate(this.props), (a.locale !== this.props.locale || a.weekStartsOn !== this.props.weekStartsOn) && (this.dateOptions = {
        locale: this.props.locale
      }, this.props.weekStartsOn !== void 0 && (this.dateOptions.weekStartsOn = this.props.weekStartsOn), this.setState({
        monthNames: this.getMonthNames()
      })), (0, Ej.shallowEqualObjects)(a.scroll, this.props.scroll) || this.setState({
        scrollArea: this.calcScrollArea(this.props)
      });
    }
  }, {
    key: "renderWeekdays",
    value: function() {
      var a = this, i = /* @__PURE__ */ new Date();
      return /* @__PURE__ */ rt.default.createElement("div", {
        className: this.styles.weekDays
      }, (0, Bj.default)({
        start: (0, kj.default)(i, this.dateOptions),
        end: (0, Rj.default)(i, this.dateOptions)
      }).map(function(o, s) {
        return /* @__PURE__ */ rt.default.createElement("span", {
          className: a.styles.weekDay,
          key: s
        }, (0, Vj.default)(o, a.props.weekdayDisplayFormat, a.dateOptions));
      }));
    }
  }, {
    key: "render",
    value: function() {
      var a = this, i = this.props, o = i.showDateDisplay, s = i.onPreviewChange, l = i.scroll, c = i.direction, u = i.disabledDates, f = i.disabledDay, p = i.maxDate, h = i.minDate, m = i.rangeColors, v = i.color, g = i.navigatorRenderer, y = i.className, b = i.preview, w = this.state, x = w.scrollArea, C = w.focusedDate, S = c === "vertical", E = g || this.renderMonthAndYear, D = this.props.ranges.map(function(I, k) {
        return yl(yl({}, I), {}, {
          color: I.color || m[k] || v
        });
      });
      return /* @__PURE__ */ rt.default.createElement("div", {
        className: (0, fa.default)(this.styles.calendarWrapper, y),
        onMouseUp: function() {
          return a.setState({
            drag: {
              status: !1,
              range: {}
            }
          });
        },
        onMouseLeave: function() {
          a.setState({
            drag: {
              status: !1,
              range: {}
            }
          });
        }
      }, o && this.renderDateDisplay(), E(C, this.changeShownDate, this.props), l.enabled ? /* @__PURE__ */ rt.default.createElement("div", null, S && this.renderWeekdays(this.dateOptions), /* @__PURE__ */ rt.default.createElement("div", {
        className: (0, fa.default)(this.styles.infiniteMonths, S ? this.styles.monthsVertical : this.styles.monthsHorizontal),
        onMouseLeave: function() {
          return s && s();
        },
        style: {
          width: x.calendarWidth + 11,
          height: x.calendarHeight + 11
        },
        onScroll: this.handleScroll
      }, /* @__PURE__ */ rt.default.createElement(Pj.default, {
        length: (0, Bu.default)((0, Tj.default)(p), (0, Mj.default)((0, $j.default)(h), -1), this.dateOptions),
        treshold: 500,
        type: "variable",
        ref: function(k) {
          return a.list = k;
        },
        itemSizeEstimator: this.estimateMonthSize,
        axis: S ? "y" : "x",
        itemRenderer: function(k, V) {
          var W = (0, yo.default)(h, k);
          return /* @__PURE__ */ rt.default.createElement(N6.default, Ql({}, a.props, {
            onPreviewChange: s || a.updatePreview,
            preview: b || a.state.preview,
            ranges: D,
            key: V,
            drag: a.state.drag,
            dateOptions: a.dateOptions,
            disabledDates: u,
            disabledDay: f,
            month: W,
            onDragSelectionStart: a.onDragSelectionStart,
            onDragSelectionEnd: a.onDragSelectionEnd,
            onDragSelectionMove: a.onDragSelectionMove,
            onMouseLeave: function() {
              return s && s();
            },
            styles: a.styles,
            style: S ? {
              height: a.estimateMonthSize(k)
            } : {
              height: x.monthHeight,
              width: a.estimateMonthSize(k)
            },
            showMonthName: !0,
            showWeekDays: !S
          }));
        }
      }))) : /* @__PURE__ */ rt.default.createElement("div", {
        className: (0, fa.default)(this.styles.months, S ? this.styles.monthsVertical : this.styles.monthsHorizontal)
      }, new Array(this.props.months).fill(null).map(function(I, k) {
        var V = (0, yo.default)(a.state.focusedDate, k);
        return a.props.calendarFocus === "backwards" && (V = (0, Hj.default)(a.state.focusedDate, a.props.months - 1 - k)), /* @__PURE__ */ rt.default.createElement(N6.default, Ql({}, a.props, {
          onPreviewChange: s || a.updatePreview,
          preview: b || a.state.preview,
          ranges: D,
          key: k,
          drag: a.state.drag,
          dateOptions: a.dateOptions,
          disabledDates: u,
          disabledDay: f,
          month: V,
          onDragSelectionStart: a.onDragSelectionStart,
          onDragSelectionEnd: a.onDragSelectionEnd,
          onDragSelectionMove: a.onDragSelectionMove,
          onMouseLeave: function() {
            return s && s();
          },
          styles: a.styles,
          showWeekDays: !S || k === 0,
          showMonthName: !S || k > 0
        }));
      })));
    }
  }]), r;
}(rt.PureComponent);
cf.defaultProps = {
  showMonthArrow: !0,
  showMonthAndYearPickers: !0,
  disabledDates: [],
  disabledDay: function() {
  },
  classNames: {},
  locale: Fj.default,
  ranges: [],
  focusedRange: [0, 0],
  dateDisplayFormat: "MMM d, yyyy",
  monthDisplayFormat: "MMM yyyy",
  weekdayDisplayFormat: "E",
  dayDisplayFormat: "d",
  showDateDisplay: !0,
  showPreview: !0,
  displayMode: "date",
  months: 1,
  color: "#3d91ff",
  scroll: {
    enabled: !1
  },
  direction: "vertical",
  maxDate: (0, L6.default)(/* @__PURE__ */ new Date(), 20),
  minDate: (0, L6.default)(/* @__PURE__ */ new Date(), -100),
  rangeColors: ["#3d91ff", "#3ecf8e", "#fed14c"],
  startDatePlaceholder: "Early",
  endDatePlaceholder: "Continuous",
  editableDateInputs: !1,
  dragSelectionEnabled: !0,
  fixedHeight: !1,
  calendarFocus: "forwards",
  preventSnapRefocus: !1,
  ariaLabels: {}
};
cf.propTypes = {
  showMonthArrow: me.default.bool,
  showMonthAndYearPickers: me.default.bool,
  disabledDates: me.default.array,
  disabledDay: me.default.func,
  minDate: me.default.object,
  maxDate: me.default.object,
  date: me.default.object,
  onChange: me.default.func,
  onPreviewChange: me.default.func,
  onRangeFocusChange: me.default.func,
  classNames: me.default.object,
  locale: me.default.object,
  shownDate: me.default.object,
  onShownDateChange: me.default.func,
  ranges: me.default.arrayOf(Sj.rangeShape),
  preview: me.default.shape({
    startDate: me.default.object,
    endDate: me.default.object,
    color: me.default.string
  }),
  dateDisplayFormat: me.default.string,
  monthDisplayFormat: me.default.string,
  weekdayDisplayFormat: me.default.string,
  weekStartsOn: me.default.number,
  dayDisplayFormat: me.default.string,
  focusedRange: me.default.arrayOf(me.default.number),
  initialFocusedRange: me.default.arrayOf(me.default.number),
  months: me.default.number,
  className: me.default.string,
  showDateDisplay: me.default.bool,
  showPreview: me.default.bool,
  displayMode: me.default.oneOf(["dateRange", "date"]),
  color: me.default.string,
  updateRange: me.default.func,
  scroll: me.default.shape({
    enabled: me.default.bool,
    monthHeight: me.default.number,
    longMonthHeight: me.default.number,
    monthWidth: me.default.number,
    calendarWidth: me.default.number,
    calendarHeight: me.default.number
  }),
  direction: me.default.oneOf(["vertical", "horizontal"]),
  startDatePlaceholder: me.default.string,
  endDatePlaceholder: me.default.string,
  navigatorRenderer: me.default.func,
  rangeColors: me.default.arrayOf(me.default.string),
  editableDateInputs: me.default.bool,
  dragSelectionEnabled: me.default.bool,
  fixedHeight: me.default.bool,
  calendarFocus: me.default.string,
  preventSnapRefocus: me.default.bool,
  ariaLabels: zj.ariaLabelsShape
};
var n_ = cf;
Ks.default = n_;
function Ho(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Ho = function(r) {
    return typeof r;
  } : Ho = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, Ho(e);
}
Object.defineProperty(Ys, "__esModule", {
  value: !0
});
Ys.default = void 0;
var B6 = u_(P), Xa = un(Yr), Oh = un(Ks), a_ = _n, Vu = Tn, i_ = un(bh), o_ = un(J9), V6 = un(Ch), Hu = un(Sc), s_ = un(ef), H6 = un(Y0), l_ = un(Ba), c_ = un(Va);
function un(e) {
  return e && e.__esModule ? e : { default: e };
}
function Sh(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (Sh = function(a) {
    return a ? r : t;
  })(e);
}
function u_(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || Ho(e) !== "object" && typeof e != "function")
    return { default: e };
  var r = Sh(t);
  if (r && r.has(e))
    return r.get(e);
  var n = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(e, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(n, i, o) : n[i] = e[i];
    }
  return n.default = e, r && r.set(e, n), n;
}
function Y2() {
  return Y2 = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Y2.apply(this, arguments);
}
function F6(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ii(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? F6(Object(r), !0).forEach(function(n) {
      ai(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : F6(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function f_(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function W6(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function d_(e, t, r) {
  return t && W6(e.prototype, t), r && W6(e, r), e;
}
function p_(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && K2(e, t);
}
function K2(e, t) {
  return K2 = Object.setPrototypeOf || function(n, a) {
    return n.__proto__ = a, n;
  }, K2(e, t);
}
function h_(e) {
  var t = m_();
  return function() {
    var n = e1(e), a;
    if (t) {
      var i = e1(this).constructor;
      a = Reflect.construct(n, arguments, i);
    } else
      a = n.apply(this, arguments);
    return v_(this, a);
  };
}
function v_(e, t) {
  return t && (Ho(t) === "object" || typeof t == "function") ? t : No(e);
}
function No(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function m_() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function e1(e) {
  return e1 = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, e1(e);
}
function ai(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var uf = /* @__PURE__ */ function(e) {
  p_(r, e);
  var t = h_(r);
  function r(n, a) {
    var i;
    return f_(this, r), i = t.call(this, n, a), ai(No(i), "calcNewSelection", function(o) {
      var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, l = i.props.focusedRange || i.state.focusedRange, c = i.props, u = c.ranges, f = c.onChange, p = c.maxDate, h = c.moveRangeOnFirstSelection, m = c.retainEndDateOnFirstSelection, v = c.disabledDates, g = l[0], y = u[g];
      if (!y || !f)
        return {};
      var b = y.startDate, w = y.endDate, x = /* @__PURE__ */ new Date(), C;
      if (!s)
        b = o.startDate, w = o.endDate;
      else if (l[1] === 0) {
        var S = (0, s_.default)(w || x, b), E = function() {
          return h ? (0, Hu.default)(o, S) : m ? !w || (0, H6.default)(o, w) ? w : o : o || x;
        };
        b = o, w = E(), p && (w = (0, V6.default)([w, p])), C = [l[0], 1];
      } else
        w = o;
      var D = l[1] === 0;
      if ((0, H6.default)(w, b)) {
        D = !D;
        var I = [w, b];
        b = I[0], w = I[1];
      }
      var k = v.filter(function(W) {
        return (0, o_.default)(W, {
          start: b,
          end: w
        });
      });
      if (k.length > 0 && (D ? b = (0, Hu.default)((0, i_.default)(k), 1) : w = (0, Hu.default)((0, V6.default)(k), -1)), !C) {
        var V = (0, Vu.findNextRangeIndex)(i.props.ranges, l[0]);
        C = [V, 0];
      }
      return {
        wasValid: !(k.length > 0),
        range: {
          startDate: b,
          endDate: w
        },
        nextFocusRange: C
      };
    }), ai(No(i), "setSelection", function(o, s) {
      var l = i.props, c = l.onChange, u = l.ranges, f = l.onRangeFocusChange, p = i.props.focusedRange || i.state.focusedRange, h = p[0], m = u[h];
      if (m) {
        var v = i.calcNewSelection(o, s);
        c(ai({}, m.key || "range".concat(h + 1), ii(ii({}, m), v.range))), i.setState({
          focusedRange: v.nextFocusRange,
          preview: null
        }), f && f(v.nextFocusRange);
      }
    }), ai(No(i), "handleRangeFocusChange", function(o) {
      i.setState({
        focusedRange: o
      }), i.props.onRangeFocusChange && i.props.onRangeFocusChange(o);
    }), ai(No(i), "updatePreview", function(o) {
      var s;
      if (!o) {
        i.setState({
          preview: null
        });
        return;
      }
      var l = i.props, c = l.rangeColors, u = l.ranges, f = i.props.focusedRange || i.state.focusedRange, p = ((s = u[f[0]]) === null || s === void 0 ? void 0 : s.color) || c[f[0]] || p;
      i.setState({
        preview: ii(ii({}, o.range), {}, {
          color: p
        })
      });
    }), i.state = {
      focusedRange: n.initialFocusedRange || [(0, Vu.findNextRangeIndex)(n.ranges), 0],
      preview: null
    }, i.styles = (0, Vu.generateStyles)([c_.default, n.classNames]), i;
  }
  return d_(r, [{
    key: "render",
    value: function() {
      var a = this;
      return /* @__PURE__ */ B6.default.createElement(Oh.default, Y2({
        focusedRange: this.state.focusedRange,
        onRangeFocusChange: this.handleRangeFocusChange,
        preview: this.state.preview,
        onPreviewChange: function(o) {
          a.updatePreview(o ? a.calcNewSelection(o) : null);
        }
      }, this.props, {
        displayMode: "dateRange",
        className: (0, l_.default)(this.styles.dateRangeWrapper, this.props.className),
        onChange: this.setSelection,
        updateRange: function(o) {
          return a.setSelection(o, !1);
        },
        ref: function(o) {
          a.calendar = o;
        }
      }));
    }
  }]), r;
}(B6.Component);
uf.defaultProps = {
  classNames: {},
  ranges: [],
  moveRangeOnFirstSelection: !1,
  retainEndDateOnFirstSelection: !1,
  rangeColors: ["#3d91ff", "#3ecf8e", "#fed14c"],
  disabledDates: []
};
uf.propTypes = ii(ii({}, Oh.default.propTypes), {}, {
  onChange: Xa.default.func,
  onRangeFocusChange: Xa.default.func,
  className: Xa.default.string,
  ranges: Xa.default.arrayOf(a_.rangeShape),
  moveRangeOnFirstSelection: Xa.default.bool,
  retainEndDateOnFirstSelection: Xa.default.bool
});
var g_ = uf;
Ys.default = g_;
var jc = {}, Xs = {}, Gn = {};
Object.defineProperty(Gn, "__esModule", {
  value: !0
});
Gn.createStaticRanges = Ph;
Gn.defaultInputRanges = Gn.defaultStaticRanges = void 0;
var z6 = fn(ef), t1 = fn(bc), U6 = fn(wc), Z6 = fn(Oc), q6 = fn(xh), G6 = fn(tf), Y6 = fn(rf), K6 = fn(Q0), X6 = fn(G0), oi = fn(Sc);
function fn(e) {
  return e && e.__esModule ? e : { default: e };
}
function Q6(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function J6(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q6(Object(r), !0).forEach(function(n) {
      y_(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Q6(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function y_(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var kt = {
  startOfWeek: (0, Z6.default)(/* @__PURE__ */ new Date()),
  endOfWeek: (0, U6.default)(/* @__PURE__ */ new Date()),
  startOfLastWeek: (0, Z6.default)((0, oi.default)(/* @__PURE__ */ new Date(), -7)),
  endOfLastWeek: (0, U6.default)((0, oi.default)(/* @__PURE__ */ new Date(), -7)),
  startOfToday: (0, K6.default)(/* @__PURE__ */ new Date()),
  endOfToday: (0, X6.default)(/* @__PURE__ */ new Date()),
  startOfYesterday: (0, K6.default)((0, oi.default)(/* @__PURE__ */ new Date(), -1)),
  endOfYesterday: (0, X6.default)((0, oi.default)(/* @__PURE__ */ new Date(), -1)),
  startOfMonth: (0, Y6.default)(/* @__PURE__ */ new Date()),
  endOfMonth: (0, G6.default)(/* @__PURE__ */ new Date()),
  startOfLastMonth: (0, Y6.default)((0, q6.default)(/* @__PURE__ */ new Date(), -1)),
  endOfLastMonth: (0, G6.default)((0, q6.default)(/* @__PURE__ */ new Date(), -1))
}, b_ = {
  range: {},
  isSelected: function(t) {
    var r = this.range();
    return (0, t1.default)(t.startDate, r.startDate) && (0, t1.default)(t.endDate, r.endDate);
  }
};
function Ph(e) {
  return e.map(function(t) {
    return J6(J6({}, b_), t);
  });
}
var C_ = Ph([{
  label: "Today",
  range: function() {
    return {
      startDate: kt.startOfToday,
      endDate: kt.endOfToday
    };
  }
}, {
  label: "Yesterday",
  range: function() {
    return {
      startDate: kt.startOfYesterday,
      endDate: kt.endOfYesterday
    };
  }
}, {
  label: "This Week",
  range: function() {
    return {
      startDate: kt.startOfWeek,
      endDate: kt.endOfWeek
    };
  }
}, {
  label: "Last Week",
  range: function() {
    return {
      startDate: kt.startOfLastWeek,
      endDate: kt.endOfLastWeek
    };
  }
}, {
  label: "This Month",
  range: function() {
    return {
      startDate: kt.startOfMonth,
      endDate: kt.endOfMonth
    };
  }
}, {
  label: "Last Month",
  range: function() {
    return {
      startDate: kt.startOfLastMonth,
      endDate: kt.endOfLastMonth
    };
  }
}]);
Gn.defaultStaticRanges = C_;
var x_ = [{
  label: "days up to today",
  range: function(t) {
    return {
      startDate: (0, oi.default)(kt.startOfToday, (Math.max(Number(t), 1) - 1) * -1),
      endDate: kt.endOfToday
    };
  },
  getCurrentValue: function(t) {
    return (0, t1.default)(t.endDate, kt.endOfToday) ? t.startDate ? (0, z6.default)(kt.endOfToday, t.startDate) + 1 : "∞" : "-";
  }
}, {
  label: "days starting today",
  range: function(t) {
    var r = /* @__PURE__ */ new Date();
    return {
      startDate: r,
      endDate: (0, oi.default)(r, Math.max(Number(t), 1) - 1)
    };
  },
  getCurrentValue: function(t) {
    return (0, t1.default)(t.startDate, kt.startOfToday) ? t.endDate ? (0, z6.default)(t.endDate, kt.startOfToday) + 1 : "∞" : "-";
  }
}];
Gn.defaultInputRanges = x_;
var _c = {};
function Fo(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Fo = function(r) {
    return typeof r;
  } : Fo = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, Fo(e);
}
Object.defineProperty(_c, "__esModule", {
  value: !0
});
_c.default = void 0;
var bl = O_(P), nr = w_(Yr);
function w_(e) {
  return e && e.__esModule ? e : { default: e };
}
function Eh(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (Eh = function(a) {
    return a ? r : t;
  })(e);
}
function O_(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || Fo(e) !== "object" && typeof e != "function")
    return { default: e };
  var r = Eh(t);
  if (r && r.has(e))
    return r.get(e);
  var n = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(e, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(n, i, o) : n[i] = e[i];
    }
  return n.default = e, r && r.set(e, n), n;
}
function S_(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function e5(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function P_(e, t, r) {
  return t && e5(e.prototype, t), r && e5(e, r), e;
}
function E_(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && X2(e, t);
}
function X2(e, t) {
  return X2 = Object.setPrototypeOf || function(n, a) {
    return n.__proto__ = a, n;
  }, X2(e, t);
}
function j_(e) {
  var t = D_();
  return function() {
    var n = r1(e), a;
    if (t) {
      var i = r1(this).constructor;
      a = Reflect.construct(n, arguments, i);
    } else
      a = n.apply(this, arguments);
    return __(this, a);
  };
}
function __(e, t) {
  return t && (Fo(t) === "object" || typeof t == "function") ? t : jh(e);
}
function jh(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function D_() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function r1(e) {
  return r1 = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, r1(e);
}
function A_(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var t5 = 0, r5 = 99999, ff = /* @__PURE__ */ function(e) {
  E_(r, e);
  var t = j_(r);
  function r(n, a) {
    var i;
    return S_(this, r), i = t.call(this, n, a), A_(jh(i), "onChange", function(o) {
      var s = i.props.onChange, l = parseInt(o.target.value, 10);
      l = isNaN(l) ? 0 : Math.max(Math.min(r5, l), t5), s(l);
    }), i;
  }
  return P_(r, [{
    key: "shouldComponentUpdate",
    value: function(a) {
      var i = this.props, o = i.value, s = i.label, l = i.placeholder;
      return o !== a.value || s !== a.label || l !== a.placeholder;
    }
  }, {
    key: "render",
    value: function() {
      var a = this.props, i = a.label, o = a.placeholder, s = a.value, l = a.styles, c = a.onBlur, u = a.onFocus;
      return /* @__PURE__ */ bl.default.createElement("div", {
        className: l.inputRange
      }, /* @__PURE__ */ bl.default.createElement("input", {
        className: l.inputRangeInput,
        placeholder: o,
        value: s,
        min: t5,
        max: r5,
        onChange: this.onChange,
        onFocus: u,
        onBlur: c
      }), /* @__PURE__ */ bl.default.createElement("span", {
        className: l.inputRangeLabel
      }, i));
    }
  }]), r;
}(bl.Component);
ff.propTypes = {
  value: nr.default.oneOfType([nr.default.string, nr.default.number]),
  label: nr.default.oneOfType([nr.default.element, nr.default.node]).isRequired,
  placeholder: nr.default.string,
  styles: nr.default.shape({
    inputRange: nr.default.string,
    inputRangeInput: nr.default.string,
    inputRangeLabel: nr.default.string
  }).isRequired,
  onBlur: nr.default.func.isRequired,
  onFocus: nr.default.func.isRequired,
  onChange: nr.default.func.isRequired
};
ff.defaultProps = {
  value: "",
  placeholder: "-"
};
var M_ = ff;
_c.default = M_;
function Wo(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Wo = function(r) {
    return typeof r;
  } : Wo = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, Wo(e);
}
Object.defineProperty(Xs, "__esModule", {
  value: !0
});
Xs.default = void 0;
var da = N_(P), ur = Dc(Yr), pa = Dc(Va), n5 = Gn, T_ = _n, $_ = Dc(_c), a5 = Dc(Ba);
function Dc(e) {
  return e && e.__esModule ? e : { default: e };
}
function _h(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (_h = function(a) {
    return a ? r : t;
  })(e);
}
function N_(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || Wo(e) !== "object" && typeof e != "function")
    return { default: e };
  var r = _h(t);
  if (r && r.has(e))
    return r.get(e);
  var n = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(e, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(n, i, o) : n[i] = e[i];
    }
  return n.default = e, r && r.set(e, n), n;
}
function i5(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function o5(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? i5(Object(r), !0).forEach(function(n) {
      Vl(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i5(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function I_(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function s5(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function L_(e, t, r) {
  return t && s5(e.prototype, t), r && s5(e, r), e;
}
function R_(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && Q2(e, t);
}
function Q2(e, t) {
  return Q2 = Object.setPrototypeOf || function(n, a) {
    return n.__proto__ = a, n;
  }, Q2(e, t);
}
function k_(e) {
  var t = V_();
  return function() {
    var n = n1(e), a;
    if (t) {
      var i = n1(this).constructor;
      a = Reflect.construct(n, arguments, i);
    } else
      a = n.apply(this, arguments);
    return B_(this, a);
  };
}
function B_(e, t) {
  return t && (Wo(t) === "object" || typeof t == "function") ? t : Dh(e);
}
function Dh(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function V_() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function n1(e) {
  return n1 = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, n1(e);
}
function Vl(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var df = /* @__PURE__ */ function(e) {
  R_(r, e);
  var t = k_(r);
  function r(n) {
    var a;
    return I_(this, r), a = t.call(this, n), Vl(Dh(a), "handleRangeChange", function(i) {
      var o = a.props, s = o.onChange, l = o.ranges, c = o.focusedRange, u = l[c[0]];
      !s || !u || s(Vl({}, u.key || "range".concat(c[0] + 1), o5(o5({}, u), i)));
    }), a.state = {
      rangeOffset: 0,
      focusedInput: -1
    }, a;
  }
  return L_(r, [{
    key: "getRangeOptionValue",
    value: function(a) {
      var i = this.props, o = i.ranges, s = o === void 0 ? [] : o, l = i.focusedRange, c = l === void 0 ? [] : l;
      if (typeof a.getCurrentValue != "function")
        return "";
      var u = s[c[0]] || {};
      return a.getCurrentValue(u) || "";
    }
  }, {
    key: "getSelectedRange",
    value: function(a, i) {
      var o = a.findIndex(function(l) {
        return !l.startDate || !l.endDate || l.disabled ? !1 : i.isSelected(l);
      }), s = a[o];
      return {
        selectedRange: s,
        focusedRangeIndex: o
      };
    }
  }, {
    key: "render",
    value: function() {
      var a = this, i = this.props, o = i.headerContent, s = i.footerContent, l = i.onPreviewChange, c = i.inputRanges, u = i.staticRanges, f = i.ranges, p = i.renderStaticRangeLabel, h = i.rangeColors, m = i.className;
      return /* @__PURE__ */ da.default.createElement("div", {
        className: (0, a5.default)(pa.default.definedRangesWrapper, m)
      }, o, /* @__PURE__ */ da.default.createElement("div", {
        className: pa.default.staticRanges
      }, u.map(function(v, g) {
        var y = a.getSelectedRange(f, v), b = y.selectedRange, w = y.focusedRangeIndex, x;
        return v.hasCustomRendering ? x = p(v) : x = v.label, /* @__PURE__ */ da.default.createElement("button", {
          type: "button",
          className: (0, a5.default)(pa.default.staticRange, Vl({}, pa.default.staticRangeSelected, !!b)),
          style: {
            color: b ? b.color || h[w] : null
          },
          key: g,
          onClick: function() {
            return a.handleRangeChange(v.range(a.props));
          },
          onFocus: function() {
            return l && l(v.range(a.props));
          },
          onMouseOver: function() {
            return l && l(v.range(a.props));
          },
          onMouseLeave: function() {
            l && l();
          }
        }, /* @__PURE__ */ da.default.createElement("span", {
          tabIndex: -1,
          className: pa.default.staticRangeLabel
        }, x));
      })), /* @__PURE__ */ da.default.createElement("div", {
        className: pa.default.inputRanges
      }, c.map(function(v, g) {
        return /* @__PURE__ */ da.default.createElement($_.default, {
          key: g,
          styles: pa.default,
          label: v.label,
          onFocus: function() {
            return a.setState({
              focusedInput: g,
              rangeOffset: 0
            });
          },
          onBlur: function() {
            return a.setState({
              rangeOffset: 0
            });
          },
          onChange: function(b) {
            return a.handleRangeChange(v.range(b, a.props));
          },
          value: a.getRangeOptionValue(v)
        });
      })), s);
    }
  }]), r;
}(da.Component);
df.propTypes = {
  inputRanges: ur.default.array,
  staticRanges: ur.default.array,
  ranges: ur.default.arrayOf(T_.rangeShape),
  focusedRange: ur.default.arrayOf(ur.default.number),
  onPreviewChange: ur.default.func,
  onChange: ur.default.func,
  footerContent: ur.default.any,
  headerContent: ur.default.any,
  rangeColors: ur.default.arrayOf(ur.default.string),
  className: ur.default.string,
  renderStaticRangeLabel: ur.default.func
};
df.defaultProps = {
  inputRanges: n5.defaultInputRanges,
  staticRanges: n5.defaultStaticRanges,
  ranges: [],
  rangeColors: ["#3d91ff", "#3ecf8e", "#fed14c"],
  focusedRange: [0, 0]
};
var H_ = df;
Xs.default = H_;
function zo(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? zo = function(r) {
    return typeof r;
  } : zo = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, zo(e);
}
Object.defineProperty(jc, "__esModule", {
  value: !0
});
jc.default = void 0;
var Cl = U_(P), F_ = Qs(Yr), Ah = Qs(Ys), Mh = Qs(Xs), l5 = Tn, W_ = Qs(Ba), z_ = Qs(Va);
function Qs(e) {
  return e && e.__esModule ? e : { default: e };
}
function Th(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (Th = function(a) {
    return a ? r : t;
  })(e);
}
function U_(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || zo(e) !== "object" && typeof e != "function")
    return { default: e };
  var r = Th(t);
  if (r && r.has(e))
    return r.get(e);
  var n = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(e, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(n, i, o) : n[i] = e[i];
    }
  return n.default = e, r && r.set(e, n), n;
}
function c5(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Fu(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? c5(Object(r), !0).forEach(function(n) {
      Z_(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : c5(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Z_(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function a1() {
  return a1 = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, a1.apply(this, arguments);
}
function q_(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function u5(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function G_(e, t, r) {
  return t && u5(e.prototype, t), r && u5(e, r), e;
}
function Y_(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && J2(e, t);
}
function J2(e, t) {
  return J2 = Object.setPrototypeOf || function(n, a) {
    return n.__proto__ = a, n;
  }, J2(e, t);
}
function K_(e) {
  var t = J_();
  return function() {
    var n = i1(e), a;
    if (t) {
      var i = i1(this).constructor;
      a = Reflect.construct(n, arguments, i);
    } else
      a = n.apply(this, arguments);
    return X_(this, a);
  };
}
function X_(e, t) {
  return t && (zo(t) === "object" || typeof t == "function") ? t : Q_(e);
}
function Q_(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function J_() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function i1(e) {
  return i1 = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, i1(e);
}
var pf = /* @__PURE__ */ function(e) {
  Y_(r, e);
  var t = K_(r);
  function r(n) {
    var a;
    return q_(this, r), a = t.call(this, n), a.state = {
      focusedRange: [(0, l5.findNextRangeIndex)(n.ranges), 0]
    }, a.styles = (0, l5.generateStyles)([z_.default, n.classNames]), a;
  }
  return G_(r, [{
    key: "render",
    value: function() {
      var a = this, i = this.state.focusedRange;
      return /* @__PURE__ */ Cl.default.createElement("div", {
        className: (0, W_.default)(this.styles.dateRangePickerWrapper, this.props.className)
      }, /* @__PURE__ */ Cl.default.createElement(Mh.default, a1({
        focusedRange: i,
        onPreviewChange: function(s) {
          return a.dateRange.updatePreview(s ? a.dateRange.calcNewSelection(s, typeof s == "string") : null);
        }
      }, this.props, {
        range: this.props.ranges[i[0]],
        className: void 0
      })), /* @__PURE__ */ Cl.default.createElement(Ah.default, a1({
        onRangeFocusChange: function(s) {
          return a.setState({
            focusedRange: s
          });
        },
        focusedRange: i
      }, this.props, {
        ref: function(s) {
          return a.dateRange = s;
        },
        className: void 0
      })));
    }
  }]), r;
}(Cl.Component);
pf.defaultProps = {};
pf.propTypes = Fu(Fu(Fu({}, Ah.default.propTypes), Mh.default.propTypes), {}, {
  className: F_.default.string
});
var eD = pf;
jc.default = eD;
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "DateRange", {
    enumerable: !0,
    get: function() {
      return t.default;
    }
  }), Object.defineProperty(e, "Calendar", {
    enumerable: !0,
    get: function() {
      return r.default;
    }
  }), Object.defineProperty(e, "DateRangePicker", {
    enumerable: !0,
    get: function() {
      return n.default;
    }
  }), Object.defineProperty(e, "DefinedRange", {
    enumerable: !0,
    get: function() {
      return a.default;
    }
  }), Object.defineProperty(e, "defaultInputRanges", {
    enumerable: !0,
    get: function() {
      return i.defaultInputRanges;
    }
  }), Object.defineProperty(e, "defaultStaticRanges", {
    enumerable: !0,
    get: function() {
      return i.defaultStaticRanges;
    }
  }), Object.defineProperty(e, "createStaticRanges", {
    enumerable: !0,
    get: function() {
      return i.createStaticRanges;
    }
  });
  var t = o(Ys), r = o(Ks), n = o(jc), a = o(Xs), i = Gn;
  function o(s) {
    return s && s.__esModule ? s : { default: s };
  }
})(L9);
var tD = {
  lessThanXSeconds: {
    one: "menos de un segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "medio minuto",
  lessThanXMinutes: {
    one: "menos de un minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "alrededor de 1 hora",
    other: "alrededor de {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 día",
    other: "{{count}} días"
  },
  aboutXWeeks: {
    one: "alrededor de 1 semana",
    other: "alrededor de {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "alrededor de 1 mes",
    other: "alrededor de {{count}} meses"
  },
  xMonths: {
    one: "1 mes",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "alrededor de 1 año",
    other: "alrededor de {{count}} años"
  },
  xYears: {
    one: "1 año",
    other: "{{count}} años"
  },
  overXYears: {
    one: "más de 1 año",
    other: "más de {{count}} años"
  },
  almostXYears: {
    one: "casi 1 año",
    other: "casi {{count}} años"
  }
}, rD = function(t, r, n) {
  var a, i = tD[t];
  return typeof i == "string" ? a = i : r === 1 ? a = i.one : a = i.other.replace("{{count}}", r.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "en " + a : "hace " + a : a;
};
const nD = rD;
var aD = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, iD = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, oD = {
  full: "{{date}} 'a las' {{time}}",
  long: "{{date}} 'a las' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, sD = {
  date: fi({
    formats: aD,
    defaultWidth: "full"
  }),
  time: fi({
    formats: iD,
    defaultWidth: "full"
  }),
  dateTime: fi({
    formats: oD,
    defaultWidth: "full"
  })
};
const lD = sD;
var cD = {
  lastWeek: "'el' eeee 'pasado a la' p",
  yesterday: "'ayer a la' p",
  today: "'hoy a la' p",
  tomorrow: "'mañana a la' p",
  nextWeek: "eeee 'a la' p",
  other: "P"
}, uD = {
  lastWeek: "'el' eeee 'pasado a las' p",
  yesterday: "'ayer a las' p",
  today: "'hoy a las' p",
  tomorrow: "'mañana a las' p",
  nextWeek: "eeee 'a las' p",
  other: "P"
}, fD = function(t, r, n, a) {
  return r.getUTCHours() !== 1 ? uD[t] : cD[t];
};
const dD = fD;
var pD = {
  narrow: ["AC", "DC"],
  abbreviated: ["AC", "DC"],
  wide: ["antes de cristo", "después de cristo"]
}, hD = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, vD = {
  narrow: ["e", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
  wide: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"]
}, mD = {
  narrow: ["d", "l", "m", "m", "j", "v", "s"],
  short: ["do", "lu", "ma", "mi", "ju", "vi", "sá"],
  abbreviated: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
  wide: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"]
}, gD = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  }
}, yD = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  }
}, bD = function(t, r) {
  var n = Number(t);
  return n + "º";
}, CD = {
  ordinalNumber: bD,
  era: Qr({
    values: pD,
    defaultWidth: "wide"
  }),
  quarter: Qr({
    values: hD,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return Number(t) - 1;
    }
  }),
  month: Qr({
    values: vD,
    defaultWidth: "wide"
  }),
  day: Qr({
    values: mD,
    defaultWidth: "wide"
  }),
  dayPeriod: Qr({
    values: gD,
    defaultWidth: "wide",
    formattingValues: yD,
    defaultFormattingWidth: "wide"
  })
};
const xD = CD;
var wD = /^(\d+)(º)?/i, OD = /\d+/i, SD = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
}, PD = {
  any: [/^ac/i, /^dc/i],
  wide: [/^(antes de cristo|antes de la era com[uú]n)/i, /^(despu[eé]s de cristo|era com[uú]n)/i]
}, ED = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, jD = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, _D = {
  narrow: /^[efmajsond]/i,
  abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
  wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
}, DD = {
  narrow: [/^e/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^en/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i]
}, AD = {
  narrow: /^[dlmjvs]/i,
  short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
  abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
  wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
}, MD = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^do/i, /^lu/i, /^ma/i, /^mi/i, /^ju/i, /^vi/i, /^sa/i]
}, TD = {
  narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
  any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
}, $D = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /^md/i,
    morning: /mañana/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noche/i
  }
}, ND = {
  ordinalNumber: Y9({
    matchPattern: wD,
    parsePattern: OD,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: Jr({
    matchPatterns: SD,
    defaultMatchWidth: "wide",
    parsePatterns: PD,
    defaultParseWidth: "any"
  }),
  quarter: Jr({
    matchPatterns: ED,
    defaultMatchWidth: "wide",
    parsePatterns: jD,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: Jr({
    matchPatterns: _D,
    defaultMatchWidth: "wide",
    parsePatterns: DD,
    defaultParseWidth: "any"
  }),
  day: Jr({
    matchPatterns: AD,
    defaultMatchWidth: "wide",
    parsePatterns: MD,
    defaultParseWidth: "any"
  }),
  dayPeriod: Jr({
    matchPatterns: TD,
    defaultMatchWidth: "any",
    parsePatterns: $D,
    defaultParseWidth: "any"
  })
};
const ID = ND;
var LD = {
  code: "es",
  formatDistance: nD,
  formatLong: lD,
  formatRelative: dD,
  localize: xD,
  match: ID,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const RD = LD;
const $h = P.forwardRef((e) => {
  const { onChangeValueFilterDate: t, valueFilterDate: r } = e, n = /* @__PURE__ */ new Date(), [a, i] = je([
    {
      startDate: void 0,
      endDate: void 0,
      key: "selection"
    }
  ]), [o, s] = je(!1), l = ye(null);
  Me(() => (document.addEventListener("keydown", c, !0), document.addEventListener("click", u, !0), () => {
    document.removeEventListener("keydown", c, !0), document.removeEventListener("click", u, !0);
  }), []);
  const c = (v) => {
    v.key === "Escape" && s(!1);
  }, u = (v) => {
    l.current != null && !l.current.contains(v.target) && s(!1);
  }, f = (v, g) => v != null && g != null ? `${v} - ${g}` : "", p = () => {
    i([
      {
        startDate: n,
        endDate: n,
        key: "selection"
      }
    ]), s(!0);
  }, h = () => {
    s(!1), t != null && t({ option: a[0] });
  }, m = () => {
    s(!1);
  };
  return /* @__PURE__ */ d.jsxs("div", { className: "block relative w-full", children: [
    /* @__PURE__ */ d.jsx(
      I9,
      {
        iconRight: "calendar",
        placeholder: "dd/mm/aaaa",
        value: r != null && r.length === 2 ? f(r[0], r[1]) : "",
        readOnly: !0,
        onClick: p
      }
    ),
    /* @__PURE__ */ d.jsx("div", { ref: l, children: o && /* @__PURE__ */ d.jsx(d.Fragment, { children: /* @__PURE__ */ d.jsxs("div", { className: "absolute mb-8 left-2/4 -translate-x-1/2 2s:right-0 2s:left-auto 2s:-translate-x-0 top-10 text-[13px] z-20", children: [
      /* @__PURE__ */ d.jsx(
        L9.DateRangePicker,
        {
          onChange: (v) => {
            i([v.selection]);
          },
          editableDateInputs: !0,
          moveRangeOnFirstSelection: !1,
          ranges: a,
          months: 1,
          direction: "horizontal",
          className: "w-[334px] sm:w-auto border rounded-tr-md rounded-tl-md",
          locale: RD
        }
      ),
      /* @__PURE__ */ d.jsxs("div", { className: "flex justify-end gap-4 p-2 border-l border-b border-r rounded-bl-md rounded-br-md bg-[#fff]", children: [
        /* @__PURE__ */ d.jsx("button", { className: "bg-neutral-300 hover:bg-neutral-200 rounded-md px-5 py-1", onClick: m, children: "Cancelar" }),
        /* @__PURE__ */ d.jsx("button", { className: "bg-secondary-500 hover:bg-secondary-600 rounded-md px-5 py-1 text-white", onClick: h, children: "Aplicar" })
      ] })
    ] }) }) })
  ] });
});
$h.displayName = "DateRangeInput";
const kD = P.forwardRef((e, t) => {
  const {
    children: r,
    ...n
  } = e;
  return /* @__PURE__ */ d.jsxs("div", { ref: t, ...n, className: "flex gap-16 flex-grow items-center", children: [
    /* @__PURE__ */ d.jsxs("svg", { className: "w-[100px] flex-shrink-0", viewBox: "0 0 100 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
      /* @__PURE__ */ d.jsxs("g", { clipPath: "url(#clip0_1353_11639)", children: [
        /* @__PURE__ */ d.jsx("path", { d: "M41.9066 29.5001C38.8579 29.5001 36.5455 28.742 34.9695 27.2121C33.3935 25.6822 32.6055 23.4754 32.6055 20.5781C32.6055 14.4857 35.6671 11.4395 41.8032 11.4395C43.7797 11.4395 45.5237 11.7915 47.0222 12.509L45.95 15.5688C45.0586 15.3251 44.374 15.1491 43.8831 15.0678C43.3922 14.9866 42.7075 14.9325 41.842 14.9189C40.2789 14.8918 39.0258 15.3386 38.0957 16.2592C37.1656 17.1934 36.7005 18.5473 36.7005 20.3344C36.7005 22.1215 37.2044 23.5296 38.212 24.5043C39.2196 25.4791 40.5889 25.9665 42.32 25.9665C43.6893 25.9665 44.994 25.8041 46.2084 25.4656L47.061 28.6472C45.6012 29.2158 43.8831 29.4866 41.8937 29.4866L41.9066 29.5001Z", fill: "white" }),
        /* @__PURE__ */ d.jsx("path", { d: "M50.8975 29.2427V11.6694H54.9279V29.2427H50.8975Z", fill: "white" }),
        /* @__PURE__ */ d.jsx("path", { d: "M59.8115 29.2427V11.6694H64.7204L69.3969 25.4654L74.7579 11.6694H79.4343V29.2427H75.4038V22.7035L75.5201 18.5742L71.5413 29.2292H67.0328L63.5966 18.2763L63.8549 22.7035V29.2427H59.8244H59.8115Z", fill: "white" }),
        /* @__PURE__ */ d.jsx("path", { d: "M82.7158 29.2427L89.162 11.6694H94.3551L100 29.2427H95.8278L94.2389 24.098H88.5678L86.7463 29.2427H82.7158ZM89.64 21.0382H93.2959L91.6165 14.2824L89.6529 21.0382H89.64Z", fill: "white" }),
        /* @__PURE__ */ d.jsx("path", { d: "M1.22754 29.5001H21.212C25.0488 29.5001 27.5549 25.2625 25.8368 21.6612L23.3823 16.5029C17.8016 23.2858 10.0378 28.0244 1.22754 29.5001Z", fill: "#204585" }),
        /* @__PURE__ */ d.jsx("path", { d: "M17.0775 3.30245L16.2507 1.56949C15.566 0.134387 13.6154 0.134387 12.9307 1.56949L2.85449 22.7035C9.44279 18.1138 14.5067 11.3039 17.0775 3.30245Z", fill: "#F15C41" }),
        /* @__PURE__ */ d.jsx("path", { d: "M22.9296 15.5552L17.6719 4.53467C14.7653 12.8745 9.19755 19.8741 2.05378 24.4096L0.0126953 28.7013C9.17172 27.4693 17.2714 22.6224 22.9425 15.5687L22.9296 15.5552Z", fill: "#2875B4" })
      ] }),
      /* @__PURE__ */ d.jsx("defs", { children: /* @__PURE__ */ d.jsx("clipPath", { id: "clip0_1353_11639", children: /* @__PURE__ */ d.jsx("rect", { width: "100", height: "29", fill: "white", transform: "translate(0 0.5)" }) }) })
    ] }),
    r
  ] });
});
kD.displayName = "HedaerBoxLeft";
const BD = P.forwardRef((e, t) => {
  const {
    children: r,
    ...n
  } = e, a = _t(cn), i = (a == null ? void 0 : a.isOpenMenu) ?? !1;
  return /* @__PURE__ */ d.jsxs("div", { ref: t, ...n, className: "flex gap-4 items-center", children: [
    r,
    /* @__PURE__ */ d.jsx(
      "button",
      {
        type: "button",
        className: "l:hidden flex items-center justify-center rounded-[0.5rem] bg-secondary-800 hover:bg-primary-600 min-w-[40px] aspect-square text-white",
        children: /* @__PURE__ */ d.jsx(ge, { variant: "search", width: 18 })
      }
    ),
    /* @__PURE__ */ d.jsx(
      "button",
      {
        type: "button",
        onClick: a == null ? void 0 : a.toggleOpenMenu,
        className: `l:hidden flex items-center justify-center rounded-[0.5rem] ${i ? "bg-primary-600" : "bg-secondary-800"} hover:bg-primary-600 min-w-[40px] aspect-square text-white`,
        children: i ? /* @__PURE__ */ d.jsx(ge, { variant: "close", width: 14 }) : /* @__PURE__ */ d.jsx(ge, { variant: "menu" })
      }
    )
  ] });
});
BD.displayName = "HeaderBoxRight";
const VD = P.forwardRef((e, t) => {
  const {
    image: r,
    mb: n,
    mt: a,
    bg: i,
    rounded: o,
    spacing: s,
    children: l,
    onMarkAsRead: c,
    isRead: u,
    section: f,
    ...p
  } = e, h = {
    marginBottom: n !== void 0 ? `${n / 4}rem` : void 0,
    marginTop: a !== void 0 ? `${a / 4}rem` : void 0,
    backgroundColor: i !== void 0 ? Ae[i] : void 0,
    padding: s !== void 0 ? `${s / 4}rem` : void 0,
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)"
  };
  return /* @__PURE__ */ d.jsxs(
    "div",
    {
      ref: t,
      className: "flex justify-between gap-2 cursor-pointer select-none p-4 rounded-md hover:bg-primary-200 ",
      ...p,
      style: h,
      children: [
        /* @__PURE__ */ d.jsx("div", { className: "justify-start", children: l }),
        /* @__PURE__ */ d.jsxs("div", { className: "flex flex-col justify-between gap-4", children: [
          /* @__PURE__ */ d.jsx("div", { children: /* @__PURE__ */ d.jsx(ge, { variant: f === "URGENTE" ? "exclamation-diamond-fill" : "menu", color: f === "URGENTE" ? "error-600" : "secondary-200", width: 20 }) }),
          /* @__PURE__ */ d.jsx("div", { children: /* @__PURE__ */ d.jsx(
            Ut,
            {
              size: "xs",
              variant: "secondary",
              icon: u ? "circle-check" : "circle",
              onlyIcon: !0,
              tooltip: u ? "Marcar como no leído" : "Marcar como leído",
              tooltipDirection: "left",
              onClick: () => c && c(u)
            }
          ) })
        ] })
      ]
    }
  );
});
VD.displayName = "HeaderNotificationItem";
const HD = P.forwardRef((e, t) => {
  const { children: r, quantity: n, unRead: a, section: i, onSetSection: o, onMarkMasive: s, ...l } = e, c = _t(cn), u = (c == null ? void 0 : c.isOpenNotifications) ?? !1, f = ye(null), p = ye(null), h = (y) => {
    if (f.current !== null && !f.current.contains(y.target)) {
      if (p.current !== null) {
        if (p.current.contains(y.target))
          return;
        c == null || c.closeNotifications();
        return;
      }
      c == null || c.closeNotifications();
    }
  };
  Me(() => (document.addEventListener("click", h, !0), () => {
    document.removeEventListener("click", h, !0);
  }), []);
  const [m, v] = je(i), g = (y) => {
    v(y), o && o(y);
  };
  return /* @__PURE__ */ d.jsxs("div", { ref: t, className: "relative", ...l, children: [
    /* @__PURE__ */ d.jsx(
      "button",
      {
        ref: f,
        type: "button",
        className: `flex items-center justify-center rounded-[0.5rem] ${u ? "bg-primary-600" : "bg-secondary-800"} hover:bg-primary-600 min-w-[40px] aspect-square text-white`,
        onClick: c == null ? void 0 : c.toggleOpenNotifications,
        children: /* @__PURE__ */ d.jsxs("div", { className: "relative", children: [
          Number.isInteger(a) && /* @__PURE__ */ d.jsx("div", { className: "absolute top-0 right-0 bg-error-500 w-[19px] aspect-square rounded-full overflow-hidden inline-flex items-center justify-center text-xs translate-x-1/2 -translate-y-1/2", children: a }),
          /* @__PURE__ */ d.jsx(ge, { variant: "notification", width: 18 })
        ] })
      }
    ),
    /* @__PURE__ */ d.jsx(
      "aside",
      {
        ref: p,
        className: `fixed z-[1] w-full right-0 top-0 bottom-[4.5rem] 2s:bottom-0 2s:top-[4.5rem] l:top-[5rem] ${u && n > 0 ? "block" : "hidden"} bg-secondary-100`,
        style: { maxWidth: "450px" },
        children: /* @__PURE__ */ d.jsxs("div", { className: "flex flex-col h-full w-full", children: [
          /* @__PURE__ */ d.jsxs("div", { className: "pt-2 px-4 pb-4 border-b border-neutral-300 bg-secondary-100", children: [
            /* @__PURE__ */ d.jsxs("div", { className: "flex items-center justify-between px-4 text-white border-b pb-2", children: [
              /* @__PURE__ */ d.jsxs("div", { className: "flex items-center gap-2", children: [
                /* @__PURE__ */ d.jsx(ge, { variant: "notification", color: "neutral-600" }),
                /* @__PURE__ */ d.jsx(Sn, { variant: "heading-6", color: "neutral-600", children: "Notificaciones" })
              ] }),
              /* @__PURE__ */ d.jsx(
                "button",
                {
                  type: "button",
                  onClick: c == null ? void 0 : c.closeNotifications,
                  children: /* @__PURE__ */ d.jsx(ge, { variant: "circle-close", color: "neutral-600" })
                }
              )
            ] }),
            /* @__PURE__ */ d.jsxs("div", { className: "flex items-center justify-center px-2 text-white pt-2 gap-2", children: [
              /* @__PURE__ */ d.jsx(yr, { variant: "description-2", color: "secondary-950", children: "Marcar todo como leido" }),
              /* @__PURE__ */ d.jsx(
                "button",
                {
                  type: "button",
                  onClick: () => s && s(),
                  children: /* @__PURE__ */ d.jsx(ge, { variant: "circle-check", color: "secondary-800" })
                }
              )
            ] }),
            /* @__PURE__ */ d.jsxs("div", { className: "flex items-center px-2 pt-2 text-white gap-4", children: [
              /* @__PURE__ */ d.jsx(
                Ut,
                {
                  type: "button",
                  variant: m === "URGENTE" ? "secondary-light-bold" : "white-secondary",
                  icon: "exclamation-diamond-fill",
                  onClick: () => g("URGENTE"),
                  isFull: !0,
                  children: "Urgente"
                }
              ),
              /* @__PURE__ */ d.jsx(
                Ut,
                {
                  type: "button",
                  variant: m !== "URGENTE" ? "secondary-light-bold" : "white-secondary",
                  icon: "menu",
                  onClick: () => g(""),
                  isFull: !0,
                  children: "General"
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ d.jsx("div", { className: "flex-grow max-h-[calc(90%-72px-56px-32px)] l:max-h-[calc(90%-56px-56px-32px)] w-full max-w-[600px] my-4 mx-auto", children: /* @__PURE__ */ d.jsx("div", { className: "h-full overflow-y-auto menu-wrapper-scrollbar", id: "scrollableDiv", children: /* @__PURE__ */ d.jsx("div", { className: "flex flex-col gap-4 p-2", children: r }) }) })
        ] })
      }
    )
  ] });
});
HD.displayName = "HeaderNotifications";
const FD = P.forwardRef((e, t) => {
  const {
    ...r
  } = e;
  return /* @__PURE__ */ d.jsxs(
    "button",
    {
      type: "button",
      ref: t,
      className: "hidden l:flex h-10 items-center justify-between w-[240px] rounded-md bg-secondary-800 hover:bg-primary-600 text-white px-4",
      ...r,
      children: [
        /* @__PURE__ */ d.jsx("p", { className: "font-semibold", children: "Plataforma tradicional" }),
        /* @__PURE__ */ d.jsx("span", { className: "rotate-180", children: /* @__PURE__ */ d.jsx(ge, { variant: "back-arrow" }) })
      ]
    }
  );
});
FD.displayName = "HeaderOldButton";
const WD = P.forwardRef((e, t) => {
  const {
    ...r
  } = e, n = F0();
  return /* @__PURE__ */ d.jsx("form", { ref: t, ...r, className: "hidden w-full max-w-[416px] l:block", children: /* @__PURE__ */ d.jsxs("div", { className: "h-10 bg-white rounded-md relative", children: [
    /* @__PURE__ */ d.jsx(
      "input",
      {
        id: n,
        type: "text",
        className: "h-full pl-4 pr-12 w-full outline-none shadow-transparent rounded-md border border-transparent focus:border-secondary-400",
        placeholder: "Busca cotizaciones, clientes y más",
        style: { textTransform: "none" }
      }
    ),
    /* @__PURE__ */ d.jsx("label", { htmlFor: n, className: "absolute top-1/2 right-4 cursor-pointer -translate-y-1/2", children: /* @__PURE__ */ d.jsx(ge, { variant: "search" }) })
  ] }) });
});
WD.displayName = "HeaderSearch";
const zD = P.forwardRef((e, t) => {
  const {
    image: r,
    name: n,
    email: a,
    isInsideMenu: i = !1,
    isReplace: o = !1,
    children: s,
    ...l
  } = e, c = _t(cn), u = (c == null ? void 0 : c.isOpenMenuUser) ?? !1, f = ye(null), p = ye(null), h = (v) => {
    if (!i && !(window.innerWidth < 1280) && f.current !== null && !f.current.contains(v.target)) {
      if (p.current !== null) {
        if (p.current.contains(v.target))
          return;
        c == null || c.closeMenuUser();
        return;
      }
      c == null || c.closeMenuUser();
    }
  };
  Me(() => (document.addEventListener("click", h, !0), () => {
    document.removeEventListener("click", h, !0);
  }), []);
  const m = o ? "bg-accent-600" : "bg-primary-600";
  return /* @__PURE__ */ d.jsxs(
    "div",
    {
      ref: t,
      className: `w-full relative ${i ? "block l:hidden max-w-none px-4" : "hidden l:block w-[350px]"}`,
      ...l,
      children: [
        /* @__PURE__ */ d.jsxs(
          "div",
          {
            ref: f,
            className: `h-10 w-full ${u || o ? m : "bg-secondary-800"} hover:${m} cursor-pointer flex gap-2 items-center rounded-md text-white px-2 select-none`,
            onClick: c == null ? void 0 : c.toggleOpenMenuUser,
            children: [
              /* @__PURE__ */ d.jsx(qs, { size: "sm", image: r }),
              /* @__PURE__ */ d.jsxs("div", { className: "flex-grow max-w-[calc(100%-28px-15px-16px)]", children: [
                /* @__PURE__ */ d.jsx("p", { className: "font-bold leading-none text-ellipsis whitespace-nowrap overflow-hidden w-full", children: n }),
                /* @__PURE__ */ d.jsx("p", { className: "text-s leading-none text-ellipsis whitespace-nowrap overflow-hidden w-full", children: a })
              ] }),
              /* @__PURE__ */ d.jsx("span", { className: `flex-shrink ${u ? "-rotate-180" : ""}`, children: /* @__PURE__ */ d.jsx(ge, { variant: "arrow-down", width: 14 }) })
            ]
          }
        ),
        u && /* @__PURE__ */ d.jsx("div", { ref: p, className: "relative mt-3 w-full l:absolute l:top-[100%] l:z-[1]", children: /* @__PURE__ */ d.jsx("ul", { className: "bg-secondary-800 l:bg-white px-4 py-3 rounded-md l:shadow-l", children: s }) })
      ]
    }
  );
});
zD.displayName = "HeaderUser";
const UD = P.forwardRef((e, t) => {
  const {
    icon: r,
    children: n,
    onClick: a,
    ...i
  } = e, o = _t(cn), s = (l) => {
    o == null || o.closeMenu(), o == null || o.closeMenuUser(), a !== void 0 && a(l);
  };
  return /* @__PURE__ */ d.jsxs(
    "li",
    {
      ref: t,
      onClick: s,
      className: "flex justify-between gap-2 items-center text-white l:text-secondary-600 p-2 cursor-pointer rounded-md hover:bg-secondary-600 l:hover:bg-secondary-200",
      ...i,
      children: [
        /* @__PURE__ */ d.jsx("span", { className: "w-[20px] min-w-[20px]", children: /* @__PURE__ */ d.jsx(ge, { variant: r, width: 20 }) }),
        /* @__PURE__ */ d.jsx("span", { className: "flex-grow font-bold", children: n })
      ]
    }
  );
});
UD.displayName = "HeaderUserItem";
const ZD = P.forwardRef((e, t) => {
  const {
    children: r,
    ...n
  } = e;
  return /* @__PURE__ */ d.jsx("header", { ref: t, ...n, className: "w-full bg-secondary-850 px-6 flex items-center justify-between gap-4 fixed bottom-0 2s:top-0 h-[4.5rem] l:h-[5rem] z-[1600]", children: r });
});
ZD.displayName = "HeaderWrapper";
const Nh = ({ width: e = 130 }) => /* @__PURE__ */ d.jsx(
  "svg",
  {
    width: e,
    viewBox: "0 0 410 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ d.jsxs("g", { clipPath: "url(#clip0_1111_2402)", children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M171.818 119c-12.5 0-21.981-3.111-28.442-9.389-6.462-6.278-9.693-15.333-9.693-27.222 0-25 12.553-37.5 37.711-37.5 8.104 0 15.254 1.444 21.398 4.389l-4.396 12.555c-3.655-1-6.462-1.722-8.475-2.055-2.012-.334-4.819-.556-8.368-.611-6.409-.111-11.546 1.722-15.36 5.5-3.813 3.833-5.72 9.389-5.72 16.722 0 7.333 2.066 13.111 6.197 17.111s9.745 6 16.843 6c5.614 0 10.963-.667 15.942-2.056l3.496 13.056c-5.985 2.333-13.03 3.444-21.186 3.444l.053.056zM208.681 117.944v-72.11h16.525v72.11h-16.525zM245.227 117.944v-72.11h20.126l19.173 56.61 21.981-56.61h19.173v72.11h-16.525V91.111l.477-16.944-16.313 43.722h-18.485l-14.089-44.945 1.06 18.167v26.833h-16.578zM339.133 117.944l26.43-72.11h21.292L410 117.943h-17.107l-6.515-21.11h-23.252l-7.468 21.11h-16.525zm28.389-33.666h14.989l-6.885-27.722-8.051 27.722h-.053z",
          fill: "#2875B4"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M5.032 119h81.936c15.731 0 26.006-17.389 18.962-32.167L95.866 65.667C72.986 93.5 41.154 112.944 5.032 119z",
          fill: "#204585"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M70.02 11.5l-3.39-7.111c-2.808-5.889-10.805-5.889-13.612 0L11.705 91.11C38.717 72.278 59.48 44.333 70.02 11.5z",
          fill: "#F15C41"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M94.012 61.778L72.456 16.556C60.538 50.778 37.71 79.5 8.42 98.11L.053 115.722c37.552-5.055 70.76-24.944 94.012-53.889l-.053-.055z",
          fill: "#2875B4"
        }
      )
    ] })
  }
), qD = ({ width: e = 63 }) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    width: e,
    viewBox: "0 0 63 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M29.086 29.927c-1.06 0-1.926-.18-2.586-.546l.525-1.33c.67.235 1.35.35 2.041.35.9 0 1.35-.25 1.35-.75 0-.19-.09-.36-.274-.51a2.08 2.08 0 00-.676-.376c-.27-.1-.565-.22-.885-.37a8.16 8.16 0 01-.886-.476 1.961 1.961 0 01-.675-.72c-.18-.31-.275-.67-.275-1.08 0-.691.275-1.216.82-1.581.545-.366 1.196-.546 1.951-.546.38 0 .73.03 1.05.085.326.06.566.115.721.175.155.06.37.145.64.26l-.535 1.286c-.735-.21-1.34-.315-1.82-.315-.676 0-1.016.205-1.016.62 0 .16.095.31.28.446.185.135.415.26.69.365.275.105.576.235.896.395.32.155.62.325.895.505.276.18.506.426.69.73.186.306.28.651.28 1.036 0 .406-.09.766-.274 1.076-.18.31-.425.555-.736.736-.31.18-.65.315-1.02.405-.37.085-.766.13-1.176.13h.005zM34.103 29.806v-7.714h1.857v7.714h-1.857zM37.47 29.806l2.967-7.714h2.391l2.597 7.714h-1.921l-.73-2.256h-2.607l-.84 2.256H37.47zm3.187-3.602h1.681l-.775-2.966-.906 2.966zM50.508 29.918c-1.405 0-2.466-.335-3.191-1.006-.726-.67-1.086-1.64-1.086-2.911 0-2.677 1.41-4.013 4.232-4.013.911 0 1.711.155 2.402.47l-.49 1.341c-.406-.11-.726-.18-.951-.22a6.929 6.929 0 00-.94-.065c-.721-.015-1.296.18-1.727.59-.43.406-.645 1.006-.645 1.792 0 .785.235 1.405.7 1.83.466.43 1.096.646 1.887.646.63 0 1.23-.075 1.79-.22l.39 1.396c-.67.245-1.46.37-2.376.37h.005zM58.298 29.937c-1.33 0-2.336-.35-3.017-1.05-.68-.7-1.02-1.686-1.02-2.952s.38-2.186 1.14-2.897c.76-.71 1.796-1.065 3.102-1.065 1.306 0 2.352.36 3.017 1.08.665.72 1 1.686 1 2.902 0 1.216-.365 2.216-1.09 2.922-.725.705-1.771 1.06-3.132 1.06zm.035-1.46c.806 0 1.39-.226 1.756-.68.365-.456.546-1.072.546-1.852s-.186-1.37-.55-1.826c-.366-.455-.926-.68-1.677-.68-.75 0-1.35.225-1.716.675-.365.45-.55 1.055-.55 1.811 0 .755.18 1.37.54 1.846.36.47.91.71 1.651.71v-.005z",
          fill: "#2875B4"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M15.873 27.485l-1.22-1.42c-.186.014-.381.014-.581.014h-.796v3.703l4.998 4.997 1.736-4.807c-1.946-.18-3.057-1.231-4.137-2.492v.005z",
          fill: "#F15C41"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          d: "M10.665 19.006h4.202c2.427 0 4.168 1.116 4.168 3.527 0 1.206-.58 2.261-1.741 2.917l1.1 1.19c.576.62 1.231 1.041 2.337 1.346L30.84 0 .48 16.985 10.665 27.17v-8.165z",
          fill: "#F15C41"
        }
      )
    ]
  }
);
function Ih(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, Gl(e, t);
}
function be() {
  return be = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, be.apply(null, arguments);
}
function f5(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function d5(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? f5(Object(r), !0).forEach(function(n) {
      ce(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : f5(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function ir(e) {
  return "Minified Redux error #" + e + "; visit https://redux.js.org/Errors?code=" + e + " for the full message or use the non-minified dev environment for full errors. ";
}
var p5 = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}(), Wu = function() {
  return Math.random().toString(36).substring(7).split("").join(".");
}, h5 = {
  INIT: "@@redux/INIT" + Wu(),
  REPLACE: "@@redux/REPLACE" + Wu(),
  PROBE_UNKNOWN_ACTION: function() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + Wu();
  }
};
function GD(e) {
  if (typeof e != "object" || e === null)
    return !1;
  for (var t = e; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}
function YD(e) {
  if (e === void 0)
    return "undefined";
  if (e === null)
    return "null";
  var t = typeof e;
  switch (t) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function":
      return t;
  }
  if (Array.isArray(e))
    return "array";
  if (QD(e))
    return "date";
  if (XD(e))
    return "error";
  var r = KD(e);
  switch (r) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return r;
  }
  return t.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function KD(e) {
  return typeof e.constructor == "function" ? e.constructor.name : null;
}
function XD(e) {
  return e instanceof Error || typeof e.message == "string" && e.constructor && typeof e.constructor.stackTraceLimit == "number";
}
function QD(e) {
  return e instanceof Date ? !0 : typeof e.toDateString == "function" && typeof e.getDate == "function" && typeof e.setDate == "function";
}
function ba(e) {
  var t = typeof e;
  return process.env.NODE_ENV !== "production" && (t = YD(e)), t;
}
function Lh(e, t, r) {
  var n;
  if (typeof t == "function" && typeof r == "function" || typeof r == "function" && typeof arguments[3] == "function")
    throw new Error(process.env.NODE_ENV === "production" ? ir(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  if (typeof t == "function" && typeof r > "u" && (r = t, t = void 0), typeof r < "u") {
    if (typeof r != "function")
      throw new Error(process.env.NODE_ENV === "production" ? ir(1) : "Expected the enhancer to be a function. Instead, received: '" + ba(r) + "'");
    return r(Lh)(e, t);
  }
  if (typeof e != "function")
    throw new Error(process.env.NODE_ENV === "production" ? ir(2) : "Expected the root reducer to be a function. Instead, received: '" + ba(e) + "'");
  var a = e, i = t, o = [], s = o, l = !1;
  function c() {
    s === o && (s = o.slice());
  }
  function u() {
    if (l)
      throw new Error(process.env.NODE_ENV === "production" ? ir(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    return i;
  }
  function f(v) {
    if (typeof v != "function")
      throw new Error(process.env.NODE_ENV === "production" ? ir(4) : "Expected the listener to be a function. Instead, received: '" + ba(v) + "'");
    if (l)
      throw new Error(process.env.NODE_ENV === "production" ? ir(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    var g = !0;
    return c(), s.push(v), function() {
      if (g) {
        if (l)
          throw new Error(process.env.NODE_ENV === "production" ? ir(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
        g = !1, c();
        var b = s.indexOf(v);
        s.splice(b, 1), o = null;
      }
    };
  }
  function p(v) {
    if (!GD(v))
      throw new Error(process.env.NODE_ENV === "production" ? ir(7) : "Actions must be plain objects. Instead, the actual type was: '" + ba(v) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    if (typeof v.type > "u")
      throw new Error(process.env.NODE_ENV === "production" ? ir(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    if (l)
      throw new Error(process.env.NODE_ENV === "production" ? ir(9) : "Reducers may not dispatch actions.");
    try {
      l = !0, i = a(i, v);
    } finally {
      l = !1;
    }
    for (var g = o = s, y = 0; y < g.length; y++) {
      var b = g[y];
      b();
    }
    return v;
  }
  function h(v) {
    if (typeof v != "function")
      throw new Error(process.env.NODE_ENV === "production" ? ir(10) : "Expected the nextReducer to be a function. Instead, received: '" + ba(v));
    a = v, p({
      type: h5.REPLACE
    });
  }
  function m() {
    var v, g = f;
    return v = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function(b) {
        if (typeof b != "object" || b === null)
          throw new Error(process.env.NODE_ENV === "production" ? ir(11) : "Expected the observer to be an object. Instead, received: '" + ba(b) + "'");
        function w() {
          b.next && b.next(u());
        }
        w();
        var x = g(w);
        return {
          unsubscribe: x
        };
      }
    }, v[p5] = function() {
      return this;
    }, v;
  }
  return p({
    type: h5.INIT
  }), n = {
    dispatch: p,
    subscribe: f,
    getState: u,
    replaceReducer: h
  }, n[p5] = m, n;
}
function v5(e, t) {
  return function() {
    return t(e.apply(this, arguments));
  };
}
function m5(e, t) {
  if (typeof e == "function")
    return v5(e, t);
  if (typeof e != "object" || e === null)
    throw new Error(process.env.NODE_ENV === "production" ? ir(16) : "bindActionCreators expected an object or a function, but instead received: '" + ba(e) + `'. Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?`);
  var r = {};
  for (var n in e) {
    var a = e[n];
    typeof a == "function" && (r[n] = v5(a, t));
  }
  return r;
}
function Rh() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return t.length === 0 ? function(n) {
    return n;
  } : t.length === 1 ? t[0] : t.reduce(function(n, a) {
    return function() {
      return n(a.apply(void 0, arguments));
    };
  });
}
function JD() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return function(n) {
    return function() {
      var a = n.apply(void 0, arguments), i = function() {
        throw new Error(process.env.NODE_ENV === "production" ? ir(15) : "Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
      }, o = {
        getState: a.getState,
        dispatch: function() {
          return i.apply(void 0, arguments);
        }
      }, s = t.map(function(l) {
        return l(o);
      });
      return i = Rh.apply(void 0, s)(a.dispatch), d5(d5({}, a), {}, {
        dispatch: i
      });
    };
  };
}
var hf = /* @__PURE__ */ P.createContext(null);
process.env.NODE_ENV !== "production" && (hf.displayName = "ReactRedux");
function eA(e) {
  e();
}
var kh = eA, tA = function(t) {
  return kh = t;
}, rA = function() {
  return kh;
};
function nA() {
  var e = rA(), t = null, r = null;
  return {
    clear: function() {
      t = null, r = null;
    },
    notify: function() {
      e(function() {
        for (var a = t; a; )
          a.callback(), a = a.next;
      });
    },
    get: function() {
      for (var a = [], i = t; i; )
        a.push(i), i = i.next;
      return a;
    },
    subscribe: function(a) {
      var i = !0, o = r = {
        callback: a,
        next: null,
        prev: r
      };
      return o.prev ? o.prev.next = o : t = o, function() {
        !i || t === null || (i = !1, o.next ? o.next.prev = o.prev : r = o.prev, o.prev ? o.prev.next = o.next : t = o.next);
      };
    }
  };
}
var g5 = {
  notify: function() {
  },
  get: function() {
    return [];
  }
};
function Bh(e, t) {
  var r, n = g5;
  function a(f) {
    return l(), n.subscribe(f);
  }
  function i() {
    n.notify();
  }
  function o() {
    u.onStateChange && u.onStateChange();
  }
  function s() {
    return !!r;
  }
  function l() {
    r || (r = t ? t.addNestedSub(o) : e.subscribe(o), n = nA());
  }
  function c() {
    r && (r(), r = void 0, n.clear(), n = g5);
  }
  var u = {
    addNestedSub: a,
    notifyNestedSubs: i,
    handleChangeWrapper: o,
    isSubscribed: s,
    trySubscribe: l,
    tryUnsubscribe: c,
    getListeners: function() {
      return n;
    }
  };
  return u;
}
var Vh = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? _9 : Me;
function Hh(e) {
  var t = e.store, r = e.context, n = e.children, a = jr(function() {
    var s = Bh(t);
    return {
      store: t,
      subscription: s
    };
  }, [t]), i = jr(function() {
    return t.getState();
  }, [t]);
  Vh(function() {
    var s = a.subscription;
    return s.onStateChange = s.notifyNestedSubs, s.trySubscribe(), i !== t.getState() && s.notifyNestedSubs(), function() {
      s.tryUnsubscribe(), s.onStateChange = null;
    };
  }, [a, i]);
  var o = r || hf;
  return /* @__PURE__ */ P.createElement(o.Provider, {
    value: a
  }, n);
}
process.env.NODE_ENV !== "production" && (Hh.propTypes = {
  store: Se.shape({
    subscribe: Se.func.isRequired,
    dispatch: Se.func.isRequired,
    getState: Se.func.isRequired
  }),
  context: Se.object,
  children: Se.any
});
function o1(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if ({}.hasOwnProperty.call(e, n)) {
      if (t.includes(n))
        continue;
      r[n] = e[n];
    }
  return r;
}
var e3 = { exports: {} }, Ye = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var y5;
function aA() {
  if (y5)
    return Ye;
  y5 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, y = e ? Symbol.for("react.responder") : 60118, b = e ? Symbol.for("react.scope") : 60119;
  function w(C) {
    if (typeof C == "object" && C !== null) {
      var S = C.$$typeof;
      switch (S) {
        case t:
          switch (C = C.type, C) {
            case l:
            case c:
            case n:
            case i:
            case a:
            case f:
              return C;
            default:
              switch (C = C && C.$$typeof, C) {
                case s:
                case u:
                case m:
                case h:
                case o:
                  return C;
                default:
                  return S;
              }
          }
        case r:
          return S;
      }
    }
  }
  function x(C) {
    return w(C) === c;
  }
  return Ye.AsyncMode = l, Ye.ConcurrentMode = c, Ye.ContextConsumer = s, Ye.ContextProvider = o, Ye.Element = t, Ye.ForwardRef = u, Ye.Fragment = n, Ye.Lazy = m, Ye.Memo = h, Ye.Portal = r, Ye.Profiler = i, Ye.StrictMode = a, Ye.Suspense = f, Ye.isAsyncMode = function(C) {
    return x(C) || w(C) === l;
  }, Ye.isConcurrentMode = x, Ye.isContextConsumer = function(C) {
    return w(C) === s;
  }, Ye.isContextProvider = function(C) {
    return w(C) === o;
  }, Ye.isElement = function(C) {
    return typeof C == "object" && C !== null && C.$$typeof === t;
  }, Ye.isForwardRef = function(C) {
    return w(C) === u;
  }, Ye.isFragment = function(C) {
    return w(C) === n;
  }, Ye.isLazy = function(C) {
    return w(C) === m;
  }, Ye.isMemo = function(C) {
    return w(C) === h;
  }, Ye.isPortal = function(C) {
    return w(C) === r;
  }, Ye.isProfiler = function(C) {
    return w(C) === i;
  }, Ye.isStrictMode = function(C) {
    return w(C) === a;
  }, Ye.isSuspense = function(C) {
    return w(C) === f;
  }, Ye.isValidElementType = function(C) {
    return typeof C == "string" || typeof C == "function" || C === n || C === c || C === i || C === a || C === f || C === p || typeof C == "object" && C !== null && (C.$$typeof === m || C.$$typeof === h || C.$$typeof === o || C.$$typeof === s || C.$$typeof === u || C.$$typeof === g || C.$$typeof === y || C.$$typeof === b || C.$$typeof === v);
  }, Ye.typeOf = w, Ye;
}
var Ke = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b5;
function iA() {
  return b5 || (b5 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, y = e ? Symbol.for("react.responder") : 60118, b = e ? Symbol.for("react.scope") : 60119;
    function w(M) {
      return typeof M == "string" || typeof M == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      M === n || M === c || M === i || M === a || M === f || M === p || typeof M == "object" && M !== null && (M.$$typeof === m || M.$$typeof === h || M.$$typeof === o || M.$$typeof === s || M.$$typeof === u || M.$$typeof === g || M.$$typeof === y || M.$$typeof === b || M.$$typeof === v);
    }
    function x(M) {
      if (typeof M == "object" && M !== null) {
        var J = M.$$typeof;
        switch (J) {
          case t:
            var H = M.type;
            switch (H) {
              case l:
              case c:
              case n:
              case i:
              case a:
              case f:
                return H;
              default:
                var ee = H && H.$$typeof;
                switch (ee) {
                  case s:
                  case u:
                  case m:
                  case h:
                  case o:
                    return ee;
                  default:
                    return J;
                }
            }
          case r:
            return J;
        }
      }
    }
    var C = l, S = c, E = s, D = o, I = t, k = u, V = n, W = m, L = h, G = r, Q = i, X = a, K = f, te = !1;
    function _(M) {
      return te || (te = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), j(M) || x(M) === l;
    }
    function j(M) {
      return x(M) === c;
    }
    function T(M) {
      return x(M) === s;
    }
    function A(M) {
      return x(M) === o;
    }
    function O(M) {
      return typeof M == "object" && M !== null && M.$$typeof === t;
    }
    function N(M) {
      return x(M) === u;
    }
    function q(M) {
      return x(M) === n;
    }
    function Y(M) {
      return x(M) === m;
    }
    function z(M) {
      return x(M) === h;
    }
    function R(M) {
      return x(M) === r;
    }
    function $(M) {
      return x(M) === i;
    }
    function F(M) {
      return x(M) === a;
    }
    function B(M) {
      return x(M) === f;
    }
    Ke.AsyncMode = C, Ke.ConcurrentMode = S, Ke.ContextConsumer = E, Ke.ContextProvider = D, Ke.Element = I, Ke.ForwardRef = k, Ke.Fragment = V, Ke.Lazy = W, Ke.Memo = L, Ke.Portal = G, Ke.Profiler = Q, Ke.StrictMode = X, Ke.Suspense = K, Ke.isAsyncMode = _, Ke.isConcurrentMode = j, Ke.isContextConsumer = T, Ke.isContextProvider = A, Ke.isElement = O, Ke.isForwardRef = N, Ke.isFragment = q, Ke.isLazy = Y, Ke.isMemo = z, Ke.isPortal = R, Ke.isProfiler = $, Ke.isStrictMode = F, Ke.isSuspense = B, Ke.isValidElementType = w, Ke.typeOf = x;
  }()), Ke;
}
process.env.NODE_ENV === "production" ? e3.exports = aA() : e3.exports = iA();
var oA = e3.exports, vf = oA, sA = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, lA = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, cA = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Fh = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, mf = {};
mf[vf.ForwardRef] = cA;
mf[vf.Memo] = Fh;
function C5(e) {
  return vf.isMemo(e) ? Fh : mf[e.$$typeof] || sA;
}
var uA = Object.defineProperty, fA = Object.getOwnPropertyNames, x5 = Object.getOwnPropertySymbols, dA = Object.getOwnPropertyDescriptor, pA = Object.getPrototypeOf, w5 = Object.prototype;
function Wh(e, t, r) {
  if (typeof t != "string") {
    if (w5) {
      var n = pA(t);
      n && n !== w5 && Wh(e, n, r);
    }
    var a = fA(t);
    x5 && (a = a.concat(x5(t)));
    for (var i = C5(e), o = C5(t), s = 0; s < a.length; ++s) {
      var l = a[s];
      if (!lA[l] && !(r && r[l]) && !(o && o[l]) && !(i && i[l])) {
        var c = dA(t, l);
        try {
          uA(e, l, c);
        } catch {
        }
      }
    }
  }
  return e;
}
var hA = Wh;
const O5 = /* @__PURE__ */ Je(hA);
var t3 = { exports: {} }, nt = {};
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var S5;
function vA() {
  if (S5)
    return nt;
  S5 = 1;
  var e = 60103, t = 60106, r = 60107, n = 60108, a = 60114, i = 60109, o = 60110, s = 60112, l = 60113, c = 60120, u = 60115, f = 60116, p = 60121, h = 60122, m = 60117, v = 60129, g = 60131;
  if (typeof Symbol == "function" && Symbol.for) {
    var y = Symbol.for;
    e = y("react.element"), t = y("react.portal"), r = y("react.fragment"), n = y("react.strict_mode"), a = y("react.profiler"), i = y("react.provider"), o = y("react.context"), s = y("react.forward_ref"), l = y("react.suspense"), c = y("react.suspense_list"), u = y("react.memo"), f = y("react.lazy"), p = y("react.block"), h = y("react.server.block"), m = y("react.fundamental"), v = y("react.debug_trace_mode"), g = y("react.legacy_hidden");
  }
  function b(L) {
    if (typeof L == "object" && L !== null) {
      var G = L.$$typeof;
      switch (G) {
        case e:
          switch (L = L.type, L) {
            case r:
            case a:
            case n:
            case l:
            case c:
              return L;
            default:
              switch (L = L && L.$$typeof, L) {
                case o:
                case s:
                case f:
                case u:
                case i:
                  return L;
                default:
                  return G;
              }
          }
        case t:
          return G;
      }
    }
  }
  var w = i, x = e, C = s, S = r, E = f, D = u, I = t, k = a, V = n, W = l;
  return nt.ContextConsumer = o, nt.ContextProvider = w, nt.Element = x, nt.ForwardRef = C, nt.Fragment = S, nt.Lazy = E, nt.Memo = D, nt.Portal = I, nt.Profiler = k, nt.StrictMode = V, nt.Suspense = W, nt.isAsyncMode = function() {
    return !1;
  }, nt.isConcurrentMode = function() {
    return !1;
  }, nt.isContextConsumer = function(L) {
    return b(L) === o;
  }, nt.isContextProvider = function(L) {
    return b(L) === i;
  }, nt.isElement = function(L) {
    return typeof L == "object" && L !== null && L.$$typeof === e;
  }, nt.isForwardRef = function(L) {
    return b(L) === s;
  }, nt.isFragment = function(L) {
    return b(L) === r;
  }, nt.isLazy = function(L) {
    return b(L) === f;
  }, nt.isMemo = function(L) {
    return b(L) === u;
  }, nt.isPortal = function(L) {
    return b(L) === t;
  }, nt.isProfiler = function(L) {
    return b(L) === a;
  }, nt.isStrictMode = function(L) {
    return b(L) === n;
  }, nt.isSuspense = function(L) {
    return b(L) === l;
  }, nt.isValidElementType = function(L) {
    return typeof L == "string" || typeof L == "function" || L === r || L === a || L === v || L === n || L === l || L === c || L === g || typeof L == "object" && L !== null && (L.$$typeof === f || L.$$typeof === u || L.$$typeof === i || L.$$typeof === o || L.$$typeof === s || L.$$typeof === m || L.$$typeof === p || L[0] === h);
  }, nt.typeOf = b, nt;
}
var at = {};
/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var P5;
function mA() {
  return P5 || (P5 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = 60103, t = 60106, r = 60107, n = 60108, a = 60114, i = 60109, o = 60110, s = 60112, l = 60113, c = 60120, u = 60115, f = 60116, p = 60121, h = 60122, m = 60117, v = 60129, g = 60131;
    if (typeof Symbol == "function" && Symbol.for) {
      var y = Symbol.for;
      e = y("react.element"), t = y("react.portal"), r = y("react.fragment"), n = y("react.strict_mode"), a = y("react.profiler"), i = y("react.provider"), o = y("react.context"), s = y("react.forward_ref"), l = y("react.suspense"), c = y("react.suspense_list"), u = y("react.memo"), f = y("react.lazy"), p = y("react.block"), h = y("react.server.block"), m = y("react.fundamental"), y("react.scope"), y("react.opaque.id"), v = y("react.debug_trace_mode"), y("react.offscreen"), g = y("react.legacy_hidden");
    }
    var b = !1;
    function w(B) {
      return !!(typeof B == "string" || typeof B == "function" || B === r || B === a || B === v || B === n || B === l || B === c || B === g || b || typeof B == "object" && B !== null && (B.$$typeof === f || B.$$typeof === u || B.$$typeof === i || B.$$typeof === o || B.$$typeof === s || B.$$typeof === m || B.$$typeof === p || B[0] === h));
    }
    function x(B) {
      if (typeof B == "object" && B !== null) {
        var M = B.$$typeof;
        switch (M) {
          case e:
            var J = B.type;
            switch (J) {
              case r:
              case a:
              case n:
              case l:
              case c:
                return J;
              default:
                var H = J && J.$$typeof;
                switch (H) {
                  case o:
                  case s:
                  case f:
                  case u:
                  case i:
                    return H;
                  default:
                    return M;
                }
            }
          case t:
            return M;
        }
      }
    }
    var C = o, S = i, E = e, D = s, I = r, k = f, V = u, W = t, L = a, G = n, Q = l, X = !1, K = !1;
    function te(B) {
      return X || (X = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function _(B) {
      return K || (K = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function j(B) {
      return x(B) === o;
    }
    function T(B) {
      return x(B) === i;
    }
    function A(B) {
      return typeof B == "object" && B !== null && B.$$typeof === e;
    }
    function O(B) {
      return x(B) === s;
    }
    function N(B) {
      return x(B) === r;
    }
    function q(B) {
      return x(B) === f;
    }
    function Y(B) {
      return x(B) === u;
    }
    function z(B) {
      return x(B) === t;
    }
    function R(B) {
      return x(B) === a;
    }
    function $(B) {
      return x(B) === n;
    }
    function F(B) {
      return x(B) === l;
    }
    at.ContextConsumer = C, at.ContextProvider = S, at.Element = E, at.ForwardRef = D, at.Fragment = I, at.Lazy = k, at.Memo = V, at.Portal = W, at.Profiler = L, at.StrictMode = G, at.Suspense = Q, at.isAsyncMode = te, at.isConcurrentMode = _, at.isContextConsumer = j, at.isContextProvider = T, at.isElement = A, at.isForwardRef = O, at.isFragment = N, at.isLazy = q, at.isMemo = Y, at.isPortal = z, at.isProfiler = R, at.isStrictMode = $, at.isSuspense = F, at.isValidElementType = w, at.typeOf = x;
  }()), at;
}
process.env.NODE_ENV === "production" ? t3.exports = vA() : t3.exports = mA();
var E5 = t3.exports, gA = ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"], yA = ["reactReduxForwardedRef"], bA = [], CA = [null, null], xA = function(t) {
  try {
    return JSON.stringify(t);
  } catch {
    return String(t);
  }
};
function wA(e, t) {
  var r = e[1];
  return [t.payload, r + 1];
}
function j5(e, t, r) {
  Vh(function() {
    return e.apply(void 0, t);
  }, r);
}
function OA(e, t, r, n, a, i, o) {
  e.current = n, t.current = a, r.current = !1, i.current && (i.current = null, o());
}
function SA(e, t, r, n, a, i, o, s, l, c) {
  if (e) {
    var u = !1, f = null, p = function() {
      if (!u) {
        var v = t.getState(), g, y;
        try {
          g = n(v, a.current);
        } catch (b) {
          y = b, f = b;
        }
        y || (f = null), g === i.current ? o.current || l() : (i.current = g, s.current = g, o.current = !0, c({
          type: "STORE_UPDATED",
          payload: {
            error: y
          }
        }));
      }
    };
    r.onStateChange = p, r.trySubscribe(), p();
    var h = function() {
      if (u = !0, r.tryUnsubscribe(), r.onStateChange = null, f)
        throw f;
    };
    return h;
  }
}
var PA = function() {
  return [null, 0];
};
function EA(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.getDisplayName, a = n === void 0 ? function(S) {
    return "ConnectAdvanced(" + S + ")";
  } : n, i = r.methodName, o = i === void 0 ? "connectAdvanced" : i, s = r.renderCountProp, l = s === void 0 ? void 0 : s, c = r.shouldHandleStateChanges, u = c === void 0 ? !0 : c, f = r.storeKey, p = f === void 0 ? "store" : f, h = r.withRef, m = h === void 0 ? !1 : h, v = r.forwardRef, g = v === void 0 ? !1 : v, y = r.context, b = y === void 0 ? hf : y, w = o1(r, gA);
  if (process.env.NODE_ENV !== "production") {
    if (l !== void 0)
      throw new Error("renderCountProp is removed. render counting is built into the latest React Dev Tools profiling extension");
    if (m)
      throw new Error("withRef is removed. To access the wrapped instance, use a ref on the connected component");
    var x = "To use a custom Redux store for specific components, create a custom React context with React.createContext(), and pass the context object to React Redux's Provider and specific components like: <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. You may also pass a {context : MyContext} option to connect";
    if (p !== "store")
      throw new Error("storeKey has been removed and does not do anything. " + x);
  }
  var C = b;
  return function(E) {
    if (process.env.NODE_ENV !== "production" && !E5.isValidElementType(E))
      throw new Error("You must pass a component to the function returned by " + (o + ". Instead received " + xA(E)));
    var D = E.displayName || E.name || "Component", I = a(D), k = be({}, w, {
      getDisplayName: a,
      methodName: o,
      renderCountProp: l,
      shouldHandleStateChanges: u,
      storeKey: p,
      displayName: I,
      wrappedComponentName: D,
      WrappedComponent: E
    }), V = w.pure;
    function W(K) {
      return e(K.dispatch, k);
    }
    var L = V ? jr : function(K) {
      return K();
    };
    function G(K) {
      var te = jr(function() {
        var Ze = K.reactReduxForwardedRef, yt = o1(K, yA);
        return [K.context, Ze, yt];
      }, [K]), _ = te[0], j = te[1], T = te[2], A = jr(function() {
        return _ && _.Consumer && E5.isContextConsumer(/* @__PURE__ */ P.createElement(_.Consumer, null)) ? _ : C;
      }, [_, C]), O = _t(A), N = !!K.store && !!K.store.getState && !!K.store.dispatch, q = !!O && !!O.store;
      if (process.env.NODE_ENV !== "production" && !N && !q)
        throw new Error('Could not find "store" in the context of ' + ('"' + I + '". Either wrap the root component in a <Provider>, ') + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + I + " in connect options."));
      var Y = N ? K.store : O.store, z = jr(function() {
        return W(Y);
      }, [Y]), R = jr(function() {
        if (!u)
          return CA;
        var Ze = Bh(Y, N ? null : O.subscription), yt = Ze.notifyNestedSubs.bind(Ze);
        return [Ze, yt];
      }, [Y, N, O]), $ = R[0], F = R[1], B = jr(function() {
        return N ? O : be({}, O, {
          subscription: $
        });
      }, [N, O, $]), M = vC(wA, bA, PA), J = M[0], H = J[0], ee = M[1];
      if (H && H.error)
        throw H.error;
      var ne = ye(), ae = ye(T), se = ye(), de = ye(!1), ve = L(function() {
        return se.current && T === ae.current ? se.current : z(Y.getState(), T);
      }, [Y, H, T]);
      j5(OA, [ae, ne, de, T, ve, se, F]), j5(SA, [u, Y, $, z, ae, ne, de, se, F, ee], [Y, $, z]);
      var Te = jr(function() {
        return /* @__PURE__ */ P.createElement(E, be({}, ve, {
          ref: j
        }));
      }, [j, E, ve]), We = jr(function() {
        return u ? /* @__PURE__ */ P.createElement(A.Provider, {
          value: B
        }, Te) : Te;
      }, [A, Te, B]);
      return We;
    }
    var Q = V ? P.memo(G) : G;
    if (Q.WrappedComponent = E, Q.displayName = G.displayName = I, g) {
      var X = P.forwardRef(function(te, _) {
        return /* @__PURE__ */ P.createElement(Q, be({}, te, {
          reactReduxForwardedRef: _
        }));
      });
      return X.displayName = I, X.WrappedComponent = E, O5(X, E);
    }
    return O5(Q, E);
  };
}
function _5(e, t) {
  return e === t ? e !== 0 || t !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function zu(e, t) {
  if (_5(e, t))
    return !0;
  if (typeof e != "object" || e === null || typeof t != "object" || t === null)
    return !1;
  var r = Object.keys(e), n = Object.keys(t);
  if (r.length !== n.length)
    return !1;
  for (var a = 0; a < r.length; a++)
    if (!Object.prototype.hasOwnProperty.call(t, r[a]) || !_5(e[r[a]], t[r[a]]))
      return !1;
  return !0;
}
function jA(e, t) {
  var r = {}, n = function(o) {
    var s = e[o];
    typeof s == "function" && (r[o] = function() {
      return t(s.apply(void 0, arguments));
    });
  };
  for (var a in e)
    n(a);
  return r;
}
function _A(e) {
  if (typeof e != "object" || e === null)
    return !1;
  var t = Object.getPrototypeOf(e);
  if (t === null)
    return !0;
  for (var r = t; Object.getPrototypeOf(r) !== null; )
    r = Object.getPrototypeOf(r);
  return t === r;
}
function zh(e) {
  typeof console < "u" && typeof console.error == "function" && console.error(e);
  try {
    throw new Error(e);
  } catch {
  }
}
function Uh(e, t, r) {
  _A(e) || zh(r + "() in " + t + " must return a plain object. Instead received " + e + ".");
}
function gf(e) {
  return function(r, n) {
    var a = e(r, n);
    function i() {
      return a;
    }
    return i.dependsOnOwnProps = !1, i;
  };
}
function D5(e) {
  return e.dependsOnOwnProps !== null && e.dependsOnOwnProps !== void 0 ? !!e.dependsOnOwnProps : e.length !== 1;
}
function Zh(e, t) {
  return function(n, a) {
    var i = a.displayName, o = function(l, c) {
      return o.dependsOnOwnProps ? o.mapToProps(l, c) : o.mapToProps(l);
    };
    return o.dependsOnOwnProps = !0, o.mapToProps = function(l, c) {
      o.mapToProps = e, o.dependsOnOwnProps = D5(e);
      var u = o(l, c);
      return typeof u == "function" && (o.mapToProps = u, o.dependsOnOwnProps = D5(u), u = o(l, c)), process.env.NODE_ENV !== "production" && Uh(u, i, t), u;
    }, o;
  };
}
function DA(e) {
  return typeof e == "function" ? Zh(e, "mapDispatchToProps") : void 0;
}
function AA(e) {
  return e ? void 0 : gf(function(t) {
    return {
      dispatch: t
    };
  });
}
function MA(e) {
  return e && typeof e == "object" ? gf(function(t) {
    return jA(e, t);
  }) : void 0;
}
const TA = [DA, AA, MA];
function $A(e) {
  return typeof e == "function" ? Zh(e, "mapStateToProps") : void 0;
}
function NA(e) {
  return e ? void 0 : gf(function() {
    return {};
  });
}
const IA = [$A, NA];
function LA(e, t, r) {
  return be({}, r, e, t);
}
function RA(e) {
  return function(r, n) {
    var a = n.displayName, i = n.pure, o = n.areMergedPropsEqual, s = !1, l;
    return function(u, f, p) {
      var h = e(u, f, p);
      return s ? (!i || !o(h, l)) && (l = h) : (s = !0, l = h, process.env.NODE_ENV !== "production" && Uh(l, a, "mergeProps")), l;
    };
  };
}
function kA(e) {
  return typeof e == "function" ? RA(e) : void 0;
}
function BA(e) {
  return e ? void 0 : function() {
    return LA;
  };
}
const VA = [kA, BA];
function Uu(e, t, r) {
  if (e)
    (t === "mapStateToProps" || t === "mapDispatchToProps") && (Object.prototype.hasOwnProperty.call(e, "dependsOnOwnProps") || zh("The selector for " + t + " of " + r + " did not specify a value for dependsOnOwnProps."));
  else
    throw new Error("Unexpected value for " + t + " in " + r + ".");
}
function HA(e, t, r, n) {
  Uu(e, "mapStateToProps", n), Uu(t, "mapDispatchToProps", n), Uu(r, "mergeProps", n);
}
var FA = ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"];
function WA(e, t, r, n) {
  return function(i, o) {
    return r(e(i, o), t(n, o), o);
  };
}
function zA(e, t, r, n, a) {
  var i = a.areStatesEqual, o = a.areOwnPropsEqual, s = a.areStatePropsEqual, l = !1, c, u, f, p, h;
  function m(w, x) {
    return c = w, u = x, f = e(c, u), p = t(n, u), h = r(f, p, u), l = !0, h;
  }
  function v() {
    return f = e(c, u), t.dependsOnOwnProps && (p = t(n, u)), h = r(f, p, u), h;
  }
  function g() {
    return e.dependsOnOwnProps && (f = e(c, u)), t.dependsOnOwnProps && (p = t(n, u)), h = r(f, p, u), h;
  }
  function y() {
    var w = e(c, u), x = !s(w, f);
    return f = w, x && (h = r(f, p, u)), h;
  }
  function b(w, x) {
    var C = !o(x, u), S = !i(w, c, x, u);
    return c = w, u = x, C && S ? v() : C ? g() : S ? y() : h;
  }
  return function(x, C) {
    return l ? b(x, C) : m(x, C);
  };
}
function UA(e, t) {
  var r = t.initMapStateToProps, n = t.initMapDispatchToProps, a = t.initMergeProps, i = o1(t, FA), o = r(e, i), s = n(e, i), l = a(e, i);
  process.env.NODE_ENV !== "production" && HA(o, s, l, i.displayName);
  var c = i.pure ? zA : WA;
  return c(o, s, l, e, i);
}
var ZA = ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"];
function Zu(e, t, r) {
  for (var n = t.length - 1; n >= 0; n--) {
    var a = t[n](e);
    if (a)
      return a;
  }
  return function(i, o) {
    throw new Error("Invalid value of type " + typeof e + " for " + r + " argument when connecting component " + o.wrappedComponentName + ".");
  };
}
function qA(e, t) {
  return e === t;
}
function GA(e) {
  var t = e === void 0 ? {} : e, r = t.connectHOC, n = r === void 0 ? EA : r, a = t.mapStateToPropsFactories, i = a === void 0 ? IA : a, o = t.mapDispatchToPropsFactories, s = o === void 0 ? TA : o, l = t.mergePropsFactories, c = l === void 0 ? VA : l, u = t.selectorFactory, f = u === void 0 ? UA : u;
  return function(h, m, v, g) {
    g === void 0 && (g = {});
    var y = g, b = y.pure, w = b === void 0 ? !0 : b, x = y.areStatesEqual, C = x === void 0 ? qA : x, S = y.areOwnPropsEqual, E = S === void 0 ? zu : S, D = y.areStatePropsEqual, I = D === void 0 ? zu : D, k = y.areMergedPropsEqual, V = k === void 0 ? zu : k, W = o1(y, ZA), L = Zu(h, i, "mapStateToProps"), G = Zu(m, s, "mapDispatchToProps"), Q = Zu(v, c, "mergeProps");
    return n(f, be({
      // used in error messages
      methodName: "connect",
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function(K) {
        return "Connect(" + K + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: !!h,
      // passed through to selectorFactory
      initMapStateToProps: L,
      initMapDispatchToProps: G,
      initMergeProps: Q,
      pure: w,
      areStatesEqual: C,
      areOwnPropsEqual: E,
      areStatePropsEqual: I,
      areMergedPropsEqual: V
    }, W));
  };
}
const qh = /* @__PURE__ */ GA();
tA(bC);
function YA(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var r = 0; r < e.length; r++)
    if (e[r] !== t[r])
      return !1;
  return !0;
}
function Gh(e, t) {
  var r = je(function() {
    return {
      inputs: t,
      result: e()
    };
  })[0], n = ye(!0), a = ye(r), i = n.current || !!(t && a.current.inputs && YA(t, a.current.inputs)), o = i ? a.current : {
    inputs: t,
    result: e()
  };
  return Me(function() {
    n.current = !1, a.current = o;
  }, [o]), o.result;
}
function KA(e, t) {
  return Gh(function() {
    return e;
  }, t);
}
var Be = Gh, he = KA, XA = process.env.NODE_ENV === "production", qu = "Invariant failed";
function Gt(e, t) {
  if (!e) {
    if (XA)
      throw new Error(qu);
    var r = typeof t == "function" ? t() : t, n = r ? "".concat(qu, ": ").concat(r) : qu;
    throw new Error(n);
  }
}
var Wr = function(t) {
  var r = t.top, n = t.right, a = t.bottom, i = t.left, o = n - i, s = a - r, l = {
    top: r,
    right: n,
    bottom: a,
    left: i,
    width: o,
    height: s,
    x: i,
    y: r,
    center: {
      x: (n + i) / 2,
      y: (a + r) / 2
    }
  };
  return l;
}, yf = function(t, r) {
  return {
    top: t.top - r.top,
    left: t.left - r.left,
    bottom: t.bottom + r.bottom,
    right: t.right + r.right
  };
}, A5 = function(t, r) {
  return {
    top: t.top + r.top,
    left: t.left + r.left,
    bottom: t.bottom - r.bottom,
    right: t.right - r.right
  };
}, QA = function(t, r) {
  return {
    top: t.top + r.y,
    left: t.left + r.x,
    bottom: t.bottom + r.y,
    right: t.right + r.x
  };
}, Gu = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
}, bf = function(t) {
  var r = t.borderBox, n = t.margin, a = n === void 0 ? Gu : n, i = t.border, o = i === void 0 ? Gu : i, s = t.padding, l = s === void 0 ? Gu : s, c = Wr(yf(r, a)), u = Wr(A5(r, o)), f = Wr(A5(u, l));
  return {
    marginBox: c,
    borderBox: Wr(r),
    paddingBox: u,
    contentBox: f,
    margin: a,
    border: o,
    padding: l
  };
}, wr = function(t) {
  var r = t.slice(0, -2), n = t.slice(-2);
  if (n !== "px")
    return 0;
  var a = Number(r);
  return isNaN(a) && (process.env.NODE_ENV !== "production" ? Gt(!1, "Could not parse value [raw: " + t + ", without suffix: " + r + "]") : Gt(!1)), a;
}, JA = function() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
}, s1 = function(t, r) {
  var n = t.borderBox, a = t.border, i = t.margin, o = t.padding, s = QA(n, r);
  return bf({
    borderBox: s,
    border: a,
    margin: i,
    padding: o
  });
}, l1 = function(t, r) {
  return r === void 0 && (r = JA()), s1(t, r);
}, Yh = function(t, r) {
  var n = {
    top: wr(r.marginTop),
    right: wr(r.marginRight),
    bottom: wr(r.marginBottom),
    left: wr(r.marginLeft)
  }, a = {
    top: wr(r.paddingTop),
    right: wr(r.paddingRight),
    bottom: wr(r.paddingBottom),
    left: wr(r.paddingLeft)
  }, i = {
    top: wr(r.borderTopWidth),
    right: wr(r.borderRightWidth),
    bottom: wr(r.borderBottomWidth),
    left: wr(r.borderLeftWidth)
  };
  return bf({
    borderBox: t,
    margin: n,
    padding: a,
    border: i
  });
}, Kh = function(t) {
  var r = t.getBoundingClientRect(), n = window.getComputedStyle(t);
  return Yh(r, n);
}, M5 = Number.isNaN || function(t) {
  return typeof t == "number" && t !== t;
};
function eM(e, t) {
  return !!(e === t || M5(e) && M5(t));
}
function tM(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var r = 0; r < e.length; r++)
    if (!eM(e[r], t[r]))
      return !1;
  return !0;
}
function Vt(e, t) {
  t === void 0 && (t = tM);
  var r, n = [], a, i = !1;
  function o() {
    for (var s = [], l = 0; l < arguments.length; l++)
      s[l] = arguments[l];
    return i && r === this && t(s, n) || (a = e.apply(this, s), i = !0, r = this, n = s), a;
  }
  return o;
}
var rM = function(t) {
  var r = [], n = null, a = function() {
    for (var o = arguments.length, s = new Array(o), l = 0; l < o; l++)
      s[l] = arguments[l];
    r = s, !n && (n = requestAnimationFrame(function() {
      n = null, t.apply(void 0, r);
    }));
  };
  return a.cancel = function() {
    n && (cancelAnimationFrame(n), n = null);
  }, a;
};
const is = rM;
var nM = process.env.NODE_ENV === "production", aM = /[ \t]{2,}/g, iM = /^[ \t]*/gm, T5 = function(t) {
  return t.replace(aM, " ").replace(iM, "").trim();
}, oM = function(t) {
  return T5(`
  %creact-beautiful-dnd

  %c` + T5(t) + `

  %c👷‍ This is a development only message. It will be removed in production builds.
`);
}, sM = function(t) {
  return [oM(t), "color: #00C584; font-size: 1.2em; font-weight: bold;", "line-height: 1.5", "color: #723874;"];
}, lM = "__react-beautiful-dnd-disable-dev-warnings";
function Xh(e, t) {
  var r;
  nM || typeof window < "u" && window[lM] || (r = console)[e].apply(r, sM(t));
}
var dt = Xh.bind(null, "warn"), r3 = Xh.bind(null, "error");
function Wn() {
}
function cM(e, t) {
  return be({}, e, {}, t);
}
function Dr(e, t, r) {
  var n = t.map(function(a) {
    var i = cM(r, a.options);
    return e.addEventListener(a.eventName, a.fn, i), function() {
      e.removeEventListener(a.eventName, a.fn, i);
    };
  });
  return function() {
    n.forEach(function(i) {
      i();
    });
  };
}
var uM = process.env.NODE_ENV === "production", $5 = "Invariant failed";
function os(e) {
  this.message = e;
}
os.prototype.toString = function() {
  return this.message;
};
function Z(e, t) {
  if (!e)
    throw uM ? new os($5) : new os($5 + ": " + (t || ""));
}
var fM = function(e) {
  Ih(t, e);
  function t() {
    for (var n, a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = e.call.apply(e, [this].concat(i)) || this, n.callbacks = null, n.unbind = Wn, n.onWindowError = function(s) {
      var l = n.getCallbacks();
      l.isDragging() && (l.tryAbort(), process.env.NODE_ENV !== "production" && dt(`
        An error was caught by our window 'error' event listener while a drag was occurring.
        The active drag has been aborted.
      `));
      var c = s.error;
      c instanceof os && (s.preventDefault(), process.env.NODE_ENV !== "production" && r3(c.message));
    }, n.getCallbacks = function() {
      if (!n.callbacks)
        throw new Error("Unable to find AppCallbacks in <ErrorBoundary/>");
      return n.callbacks;
    }, n.setCallbacks = function(s) {
      n.callbacks = s;
    }, n;
  }
  var r = t.prototype;
  return r.componentDidMount = function() {
    this.unbind = Dr(window, [{
      eventName: "error",
      fn: this.onWindowError
    }]);
  }, r.componentDidCatch = function(a) {
    if (a instanceof os) {
      process.env.NODE_ENV !== "production" && r3(a.message), this.setState({});
      return;
    }
    throw a;
  }, r.componentWillUnmount = function() {
    this.unbind();
  }, r.render = function() {
    return this.props.children(this.setCallbacks);
  }, t;
}(P.Component), dM = `
  Press space bar to start a drag.
  When dragging you can use the arrow keys to move the item around and escape to cancel.
  Some screen readers may require you to be in focus mode or to use your pass through key
`, c1 = function(t) {
  return t + 1;
}, pM = function(t) {
  return `
  You have lifted an item in position ` + c1(t.source.index) + `
`;
}, Qh = function(t, r) {
  var n = t.droppableId === r.droppableId, a = c1(t.index), i = c1(r.index);
  return n ? `
      You have moved the item from position ` + a + `
      to position ` + i + `
    ` : `
    You have moved the item from position ` + a + `
    in list ` + t.droppableId + `
    to list ` + r.droppableId + `
    in position ` + i + `
  `;
}, Jh = function(t, r, n) {
  var a = r.droppableId === n.droppableId;
  return a ? `
      The item ` + t + `
      has been combined with ` + n.draggableId : `
      The item ` + t + `
      in list ` + r.droppableId + `
      has been combined with ` + n.draggableId + `
      in list ` + n.droppableId + `
    `;
}, hM = function(t) {
  var r = t.destination;
  if (r)
    return Qh(t.source, r);
  var n = t.combine;
  return n ? Jh(t.draggableId, t.source, n) : "You are over an area that cannot be dropped on";
}, N5 = function(t) {
  return `
  The item has returned to its starting position
  of ` + c1(t.index) + `
`;
}, vM = function(t) {
  if (t.reason === "CANCEL")
    return `
      Movement cancelled.
      ` + N5(t.source) + `
    `;
  var r = t.destination, n = t.combine;
  return r ? `
      You have dropped the item.
      ` + Qh(t.source, r) + `
    ` : n ? `
      You have dropped the item.
      ` + Jh(t.draggableId, t.source, n) + `
    ` : `
    The item has been dropped while not over a drop area.
    ` + N5(t.source) + `
  `;
}, Hl = {
  dragHandleUsageInstructions: dM,
  onDragStart: pM,
  onDragUpdate: hM,
  onDragEnd: vM
}, Ht = {
  x: 0,
  y: 0
}, zt = function(t, r) {
  return {
    x: t.x + r.x,
    y: t.y + r.y
  };
}, vr = function(t, r) {
  return {
    x: t.x - r.x,
    y: t.y - r.y
  };
}, zn = function(t, r) {
  return t.x === r.x && t.y === r.y;
}, Xi = function(t) {
  return {
    x: t.x !== 0 ? -t.x : 0,
    y: t.y !== 0 ? -t.y : 0
  };
}, Ia = function(t, r, n) {
  var a;
  return n === void 0 && (n = 0), a = {}, a[t] = r, a[t === "x" ? "y" : "x"] = n, a;
}, ss = function(t, r) {
  return Math.sqrt(Math.pow(r.x - t.x, 2) + Math.pow(r.y - t.y, 2));
}, I5 = function(t, r) {
  return Math.min.apply(Math, r.map(function(n) {
    return ss(t, n);
  }));
}, ev = function(t) {
  return function(r) {
    return {
      x: t(r.x),
      y: t(r.y)
    };
  };
}, mM = function(e, t) {
  var r = Wr({
    top: Math.max(t.top, e.top),
    right: Math.min(t.right, e.right),
    bottom: Math.min(t.bottom, e.bottom),
    left: Math.max(t.left, e.left)
  });
  return r.width <= 0 || r.height <= 0 ? null : r;
}, Js = function(t, r) {
  return {
    top: t.top + r.y,
    left: t.left + r.x,
    bottom: t.bottom + r.y,
    right: t.right + r.x
  };
}, L5 = function(t) {
  return [{
    x: t.left,
    y: t.top
  }, {
    x: t.right,
    y: t.top
  }, {
    x: t.left,
    y: t.bottom
  }, {
    x: t.right,
    y: t.bottom
  }];
}, gM = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
}, yM = function(t, r) {
  return r ? Js(t, r.scroll.diff.displacement) : t;
}, bM = function(t, r, n) {
  if (n && n.increasedBy) {
    var a;
    return be({}, t, (a = {}, a[r.end] = t[r.end] + n.increasedBy[r.line], a));
  }
  return t;
}, CM = function(t, r) {
  return r && r.shouldClipSubject ? mM(r.pageMarginBox, t) : Wr(t);
}, gi = function(e) {
  var t = e.page, r = e.withPlaceholder, n = e.axis, a = e.frame, i = yM(t.marginBox, a), o = bM(i, n, r), s = CM(o, a);
  return {
    page: t,
    withPlaceholder: r,
    active: s
  };
}, Cf = function(e, t) {
  e.frame || (process.env.NODE_ENV, Z(!1));
  var r = e.frame, n = vr(t, r.scroll.initial), a = Xi(n), i = be({}, r, {
    scroll: {
      initial: r.scroll.initial,
      current: t,
      diff: {
        value: n,
        displacement: a
      },
      max: r.scroll.max
    }
  }), o = gi({
    page: e.subject.page,
    withPlaceholder: e.subject.withPlaceholder,
    axis: e.axis,
    frame: i
  }), s = be({}, e, {
    frame: i,
    subject: o
  });
  return s;
};
function xM(e) {
  return Number.isInteger ? Number.isInteger(e) : typeof e == "number" && isFinite(e) && Math.floor(e) === e;
}
function u1(e) {
  return Object.values ? Object.values(e) : Object.keys(e).map(function(t) {
    return e[t];
  });
}
function xf(e, t) {
  if (e.findIndex)
    return e.findIndex(t);
  for (var r = 0; r < e.length; r++)
    if (t(e[r]))
      return r;
  return -1;
}
function aa(e, t) {
  if (e.find)
    return e.find(t);
  var r = xf(e, t);
  if (r !== -1)
    return e[r];
}
function tv(e) {
  return Array.prototype.slice.call(e);
}
var rv = Vt(function(e) {
  return e.reduce(function(t, r) {
    return t[r.descriptor.id] = r, t;
  }, {});
}), nv = Vt(function(e) {
  return e.reduce(function(t, r) {
    return t[r.descriptor.id] = r, t;
  }, {});
}), Ac = Vt(function(e) {
  return u1(e);
}), wM = Vt(function(e) {
  return u1(e);
}), Ha = Vt(function(e, t) {
  var r = wM(t).filter(function(n) {
    return e === n.descriptor.droppableId;
  }).sort(function(n, a) {
    return n.descriptor.index - a.descriptor.index;
  });
  return r;
});
function wf(e) {
  return e.at && e.at.type === "REORDER" ? e.at.destination : null;
}
function Mc(e) {
  return e.at && e.at.type === "COMBINE" ? e.at.combine : null;
}
var Tc = Vt(function(e, t) {
  return t.filter(function(r) {
    return r.descriptor.id !== e.descriptor.id;
  });
}), OM = function(e) {
  var t = e.isMovingForward, r = e.draggable, n = e.destination, a = e.insideDestination, i = e.previousImpact;
  if (!n.isCombineEnabled)
    return null;
  var o = wf(i);
  if (!o)
    return null;
  function s(v) {
    var g = {
      type: "COMBINE",
      combine: {
        draggableId: v,
        droppableId: n.descriptor.id
      }
    };
    return be({}, i, {
      at: g
    });
  }
  var l = i.displaced.all, c = l.length ? l[0] : null;
  if (t)
    return c ? s(c) : null;
  var u = Tc(r, a);
  if (!c) {
    if (!u.length)
      return null;
    var f = u[u.length - 1];
    return s(f.descriptor.id);
  }
  var p = xf(u, function(v) {
    return v.descriptor.id === c;
  });
  p === -1 && (process.env.NODE_ENV !== "production" ? Z(!1, "Could not find displaced item in set") : Z(!1));
  var h = p - 1;
  if (h < 0)
    return null;
  var m = u[h];
  return s(m.descriptor.id);
}, Qi = function(e, t) {
  return e.descriptor.droppableId === t.descriptor.id;
}, av = {
  point: Ht,
  value: 0
}, ls = {
  invisible: {},
  visible: {},
  all: []
}, SM = {
  displaced: ls,
  displacedBy: av,
  at: null
}, Mr = function(e, t) {
  return function(r) {
    return e <= r && r <= t;
  };
}, iv = function(e) {
  var t = Mr(e.top, e.bottom), r = Mr(e.left, e.right);
  return function(n) {
    var a = t(n.top) && t(n.bottom) && r(n.left) && r(n.right);
    if (a)
      return !0;
    var i = t(n.top) || t(n.bottom), o = r(n.left) || r(n.right), s = i && o;
    if (s)
      return !0;
    var l = n.top < e.top && n.bottom > e.bottom, c = n.left < e.left && n.right > e.right, u = l && c;
    if (u)
      return !0;
    var f = l && o || c && i;
    return f;
  };
}, PM = function(e) {
  var t = Mr(e.top, e.bottom), r = Mr(e.left, e.right);
  return function(n) {
    var a = t(n.top) && t(n.bottom) && r(n.left) && r(n.right);
    return a;
  };
}, Of = {
  direction: "vertical",
  line: "y",
  crossAxisLine: "x",
  start: "top",
  end: "bottom",
  size: "height",
  crossAxisStart: "left",
  crossAxisEnd: "right",
  crossAxisSize: "width"
}, ov = {
  direction: "horizontal",
  line: "x",
  crossAxisLine: "y",
  start: "left",
  end: "right",
  size: "width",
  crossAxisStart: "top",
  crossAxisEnd: "bottom",
  crossAxisSize: "height"
}, EM = function(e) {
  return function(t) {
    var r = Mr(t.top, t.bottom), n = Mr(t.left, t.right);
    return function(a) {
      return e === Of ? r(a.top) && r(a.bottom) : n(a.left) && n(a.right);
    };
  };
}, jM = function(t, r) {
  var n = r.frame ? r.frame.scroll.diff.displacement : Ht;
  return Js(t, n);
}, _M = function(t, r, n) {
  return r.subject.active ? n(r.subject.active)(t) : !1;
}, DM = function(t, r, n) {
  return n(r)(t);
}, Sf = function(t) {
  var r = t.target, n = t.destination, a = t.viewport, i = t.withDroppableDisplacement, o = t.isVisibleThroughFrameFn, s = i ? jM(r, n) : r;
  return _M(s, n, o) && DM(s, a, o);
}, AM = function(t) {
  return Sf(be({}, t, {
    isVisibleThroughFrameFn: iv
  }));
}, sv = function(t) {
  return Sf(be({}, t, {
    isVisibleThroughFrameFn: PM
  }));
}, MM = function(t) {
  return Sf(be({}, t, {
    isVisibleThroughFrameFn: EM(t.destination.axis)
  }));
}, TM = function(t, r, n) {
  if (typeof n == "boolean")
    return n;
  if (!r)
    return !0;
  var a = r.invisible, i = r.visible;
  if (a[t])
    return !1;
  var o = i[t];
  return o ? o.shouldAnimate : !0;
};
function $M(e, t) {
  var r = e.page.marginBox, n = {
    top: t.point.y,
    right: 0,
    bottom: 0,
    left: t.point.x
  };
  return Wr(yf(r, n));
}
function cs(e) {
  var t = e.afterDragging, r = e.destination, n = e.displacedBy, a = e.viewport, i = e.forceShouldAnimate, o = e.last;
  return t.reduce(function(l, c) {
    var u = $M(c, n), f = c.descriptor.id;
    l.all.push(f);
    var p = AM({
      target: u,
      destination: r,
      viewport: a,
      withDroppableDisplacement: !0
    });
    if (!p)
      return l.invisible[c.descriptor.id] = !0, l;
    var h = TM(f, o, i), m = {
      draggableId: f,
      shouldAnimate: h
    };
    return l.visible[f] = m, l;
  }, {
    all: [],
    visible: {},
    invisible: {}
  });
}
function NM(e, t) {
  if (!e.length)
    return 0;
  var r = e[e.length - 1].descriptor.index;
  return t.inHomeList ? r : r + 1;
}
function R5(e) {
  var t = e.insideDestination, r = e.inHomeList, n = e.displacedBy, a = e.destination, i = NM(t, {
    inHomeList: r
  });
  return {
    displaced: ls,
    displacedBy: n,
    at: {
      type: "REORDER",
      destination: {
        droppableId: a.descriptor.id,
        index: i
      }
    }
  };
}
function f1(e) {
  var t = e.draggable, r = e.insideDestination, n = e.destination, a = e.viewport, i = e.displacedBy, o = e.last, s = e.index, l = e.forceShouldAnimate, c = Qi(t, n);
  if (s == null)
    return R5({
      insideDestination: r,
      inHomeList: c,
      displacedBy: i,
      destination: n
    });
  var u = aa(r, function(v) {
    return v.descriptor.index === s;
  });
  if (!u)
    return R5({
      insideDestination: r,
      inHomeList: c,
      displacedBy: i,
      destination: n
    });
  var f = Tc(t, r), p = r.indexOf(u), h = f.slice(p), m = cs({
    afterDragging: h,
    destination: n,
    displacedBy: i,
    last: o,
    viewport: a.frame,
    forceShouldAnimate: l
  });
  return {
    displaced: m,
    displacedBy: i,
    at: {
      type: "REORDER",
      destination: {
        droppableId: n.descriptor.id,
        index: s
      }
    }
  };
}
function Yn(e, t) {
  return !!t.effected[e];
}
var IM = function(e) {
  var t = e.isMovingForward, r = e.destination, n = e.draggables, a = e.combine, i = e.afterCritical;
  if (!r.isCombineEnabled)
    return null;
  var o = a.draggableId, s = n[o], l = s.descriptor.index, c = Yn(o, i);
  return c ? t ? l : l - 1 : t ? l + 1 : l;
}, LM = function(e) {
  var t = e.isMovingForward, r = e.isInHomeList, n = e.insideDestination, a = e.location;
  if (!n.length)
    return null;
  var i = a.index, o = t ? i + 1 : i - 1, s = n[0].descriptor.index, l = n[n.length - 1].descriptor.index, c = r ? l : l + 1;
  return o < s || o > c ? null : o;
}, RM = function(e) {
  var t = e.isMovingForward, r = e.isInHomeList, n = e.draggable, a = e.draggables, i = e.destination, o = e.insideDestination, s = e.previousImpact, l = e.viewport, c = e.afterCritical, u = s.at;
  if (u || (process.env.NODE_ENV !== "production" ? Z(!1, "Cannot move in direction without previous impact location") : Z(!1)), u.type === "REORDER") {
    var f = LM({
      isMovingForward: t,
      isInHomeList: r,
      location: u.destination,
      insideDestination: o
    });
    return f == null ? null : f1({
      draggable: n,
      insideDestination: o,
      destination: i,
      viewport: l,
      last: s.displaced,
      displacedBy: s.displacedBy,
      index: f
    });
  }
  var p = IM({
    isMovingForward: t,
    destination: i,
    displaced: s.displaced,
    draggables: a,
    combine: u.combine,
    afterCritical: c
  });
  return p == null ? null : f1({
    draggable: n,
    insideDestination: o,
    destination: i,
    viewport: l,
    last: s.displaced,
    displacedBy: s.displacedBy,
    index: p
  });
}, kM = function(e) {
  var t = e.displaced, r = e.afterCritical, n = e.combineWith, a = e.displacedBy, i = !!(t.visible[n] || t.invisible[n]);
  return Yn(n, r) ? i ? Ht : Xi(a.point) : i ? a.point : Ht;
}, BM = function(e) {
  var t = e.afterCritical, r = e.impact, n = e.draggables, a = Mc(r);
  a || (process.env.NODE_ENV, Z(!1));
  var i = a.draggableId, o = n[i].page.borderBox.center, s = kM({
    displaced: r.displaced,
    afterCritical: t,
    combineWith: i,
    displacedBy: r.displacedBy
  });
  return zt(o, s);
}, lv = function(t, r) {
  return r.margin[t.start] + r.borderBox[t.size] / 2;
}, VM = function(t, r) {
  return r.margin[t.end] + r.borderBox[t.size] / 2;
}, Pf = function(t, r, n) {
  return r[t.crossAxisStart] + n.margin[t.crossAxisStart] + n.borderBox[t.crossAxisSize] / 2;
}, k5 = function(t) {
  var r = t.axis, n = t.moveRelativeTo, a = t.isMoving;
  return Ia(r.line, n.marginBox[r.end] + lv(r, a), Pf(r, n.marginBox, a));
}, B5 = function(t) {
  var r = t.axis, n = t.moveRelativeTo, a = t.isMoving;
  return Ia(r.line, n.marginBox[r.start] - VM(r, a), Pf(r, n.marginBox, a));
}, HM = function(t) {
  var r = t.axis, n = t.moveInto, a = t.isMoving;
  return Ia(r.line, n.contentBox[r.start] + lv(r, a), Pf(r, n.contentBox, a));
}, FM = function(e) {
  var t = e.impact, r = e.draggable, n = e.draggables, a = e.droppable, i = e.afterCritical, o = Ha(a.descriptor.id, n), s = r.page, l = a.axis;
  if (!o.length)
    return HM({
      axis: l,
      moveInto: a.page,
      isMoving: s
    });
  var c = t.displaced, u = t.displacedBy, f = c.all[0];
  if (f) {
    var p = n[f];
    if (Yn(f, i))
      return B5({
        axis: l,
        moveRelativeTo: p.page,
        isMoving: s
      });
    var h = s1(p.page, u.point);
    return B5({
      axis: l,
      moveRelativeTo: h,
      isMoving: s
    });
  }
  var m = o[o.length - 1];
  if (m.descriptor.id === r.descriptor.id)
    return s.borderBox.center;
  if (Yn(m.descriptor.id, i)) {
    var v = s1(m.page, Xi(i.displacedBy.point));
    return k5({
      axis: l,
      moveRelativeTo: v,
      isMoving: s
    });
  }
  return k5({
    axis: l,
    moveRelativeTo: m.page,
    isMoving: s
  });
}, n3 = function(e, t) {
  var r = e.frame;
  return r ? zt(t, r.scroll.diff.displacement) : t;
}, WM = function(t) {
  var r = t.impact, n = t.draggable, a = t.droppable, i = t.draggables, o = t.afterCritical, s = n.page.borderBox.center, l = r.at;
  return !a || !l ? s : l.type === "REORDER" ? FM({
    impact: r,
    draggable: n,
    draggables: i,
    droppable: a,
    afterCritical: o
  }) : BM({
    impact: r,
    draggables: i,
    afterCritical: o
  });
}, $c = function(e) {
  var t = WM(e), r = e.droppable, n = r ? n3(r, t) : t;
  return n;
}, cv = function(e, t) {
  var r = vr(t, e.scroll.initial), n = Xi(r), a = Wr({
    top: t.y,
    bottom: t.y + e.frame.height,
    left: t.x,
    right: t.x + e.frame.width
  }), i = {
    frame: a,
    scroll: {
      initial: e.scroll.initial,
      max: e.scroll.max,
      current: t,
      diff: {
        value: r,
        displacement: n
      }
    }
  };
  return i;
};
function V5(e, t) {
  return e.map(function(r) {
    return t[r];
  });
}
function zM(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r].visible[e];
    if (n)
      return n;
  }
  return null;
}
var UM = function(e) {
  var t = e.impact, r = e.viewport, n = e.destination, a = e.draggables, i = e.maxScrollChange, o = cv(r, zt(r.scroll.current, i)), s = n.frame ? Cf(n, zt(n.frame.scroll.current, i)) : n, l = t.displaced, c = cs({
    afterDragging: V5(l.all, a),
    destination: n,
    displacedBy: t.displacedBy,
    viewport: o.frame,
    last: l,
    forceShouldAnimate: !1
  }), u = cs({
    afterDragging: V5(l.all, a),
    destination: s,
    displacedBy: t.displacedBy,
    viewport: r.frame,
    last: l,
    forceShouldAnimate: !1
  }), f = {}, p = {}, h = [l, c, u];
  l.all.forEach(function(v) {
    var g = zM(v, h);
    if (g) {
      p[v] = g;
      return;
    }
    f[v] = !0;
  });
  var m = be({}, t, {
    displaced: {
      all: l.all,
      invisible: f,
      visible: p
    }
  });
  return m;
}, ZM = function(e, t) {
  return zt(e.scroll.diff.displacement, t);
}, Ef = function(e) {
  var t = e.pageBorderBoxCenter, r = e.draggable, n = e.viewport, a = ZM(n, t), i = vr(a, r.page.borderBox.center);
  return zt(r.client.borderBox.center, i);
}, uv = function(e) {
  var t = e.draggable, r = e.destination, n = e.newPageBorderBoxCenter, a = e.viewport, i = e.withDroppableDisplacement, o = e.onlyOnMainAxis, s = o === void 0 ? !1 : o, l = vr(n, t.page.borderBox.center), c = Js(t.page.borderBox, l), u = {
    target: c,
    destination: r,
    withDroppableDisplacement: i,
    viewport: a
  };
  return s ? MM(u) : sv(u);
}, qM = function(e) {
  var t = e.isMovingForward, r = e.draggable, n = e.destination, a = e.draggables, i = e.previousImpact, o = e.viewport, s = e.previousPageBorderBoxCenter, l = e.previousClientSelection, c = e.afterCritical;
  if (!n.isEnabled)
    return null;
  var u = Ha(n.descriptor.id, a), f = Qi(r, n), p = OM({
    isMovingForward: t,
    draggable: r,
    destination: n,
    insideDestination: u,
    previousImpact: i
  }) || RM({
    isMovingForward: t,
    isInHomeList: f,
    draggable: r,
    draggables: a,
    destination: n,
    insideDestination: u,
    previousImpact: i,
    viewport: o,
    afterCritical: c
  });
  if (!p)
    return null;
  var h = $c({
    impact: p,
    draggable: r,
    droppable: n,
    draggables: a,
    afterCritical: c
  }), m = uv({
    draggable: r,
    destination: n,
    newPageBorderBoxCenter: h,
    viewport: o.frame,
    withDroppableDisplacement: !1,
    onlyOnMainAxis: !0
  });
  if (m) {
    var v = Ef({
      pageBorderBoxCenter: h,
      draggable: r,
      viewport: o
    });
    return {
      clientSelection: v,
      impact: p,
      scrollJumpRequest: null
    };
  }
  var g = vr(h, s), y = UM({
    impact: p,
    viewport: o,
    destination: n,
    draggables: a,
    maxScrollChange: g
  });
  return {
    clientSelection: l,
    impact: y,
    scrollJumpRequest: g
  };
}, Kt = function(t) {
  var r = t.subject.active;
  return r || (process.env.NODE_ENV !== "production" ? Z(!1, "Cannot get clipped area from droppable") : Z(!1)), r;
}, GM = function(e) {
  var t = e.isMovingForward, r = e.pageBorderBoxCenter, n = e.source, a = e.droppables, i = e.viewport, o = n.subject.active;
  if (!o)
    return null;
  var s = n.axis, l = Mr(o[s.start], o[s.end]), c = Ac(a).filter(function(f) {
    return f !== n;
  }).filter(function(f) {
    return f.isEnabled;
  }).filter(function(f) {
    return !!f.subject.active;
  }).filter(function(f) {
    return iv(i.frame)(Kt(f));
  }).filter(function(f) {
    var p = Kt(f);
    return t ? o[s.crossAxisEnd] < p[s.crossAxisEnd] : p[s.crossAxisStart] < o[s.crossAxisStart];
  }).filter(function(f) {
    var p = Kt(f), h = Mr(p[s.start], p[s.end]);
    return l(p[s.start]) || l(p[s.end]) || h(o[s.start]) || h(o[s.end]);
  }).sort(function(f, p) {
    var h = Kt(f)[s.crossAxisStart], m = Kt(p)[s.crossAxisStart];
    return t ? h - m : m - h;
  }).filter(function(f, p, h) {
    return Kt(f)[s.crossAxisStart] === Kt(h[0])[s.crossAxisStart];
  });
  if (!c.length)
    return null;
  if (c.length === 1)
    return c[0];
  var u = c.filter(function(f) {
    var p = Mr(Kt(f)[s.start], Kt(f)[s.end]);
    return p(r[s.line]);
  });
  return u.length === 1 ? u[0] : u.length > 1 ? u.sort(function(f, p) {
    return Kt(f)[s.start] - Kt(p)[s.start];
  })[0] : c.sort(function(f, p) {
    var h = I5(r, L5(Kt(f))), m = I5(r, L5(Kt(p)));
    return h !== m ? h - m : Kt(f)[s.start] - Kt(p)[s.start];
  })[0];
}, H5 = function(t, r) {
  var n = t.page.borderBox.center;
  return Yn(t.descriptor.id, r) ? vr(n, r.displacedBy.point) : n;
}, YM = function(t, r) {
  var n = t.page.borderBox;
  return Yn(t.descriptor.id, r) ? Js(n, Xi(r.displacedBy.point)) : n;
}, KM = function(e) {
  var t = e.pageBorderBoxCenter, r = e.viewport, n = e.destination, a = e.insideDestination, i = e.afterCritical, o = a.filter(function(s) {
    return sv({
      target: YM(s, i),
      destination: n,
      viewport: r.frame,
      withDroppableDisplacement: !0
    });
  }).sort(function(s, l) {
    var c = ss(t, n3(n, H5(s, i))), u = ss(t, n3(n, H5(l, i)));
    return c < u ? -1 : u < c ? 1 : s.descriptor.index - l.descriptor.index;
  });
  return o[0] || null;
}, el = Vt(function(t, r) {
  var n = r[t.line];
  return {
    value: n,
    point: Ia(t.line, n)
  };
}), XM = function(t, r, n) {
  var a = t.axis;
  if (t.descriptor.mode === "virtual")
    return Ia(a.line, r[a.line]);
  var i = t.subject.page.contentBox[a.size], o = Ha(t.descriptor.id, n), s = o.reduce(function(u, f) {
    return u + f.client.marginBox[a.size];
  }, 0), l = s + r[a.line], c = l - i;
  return c <= 0 ? null : Ia(a.line, c);
}, fv = function(t, r) {
  return be({}, t, {
    scroll: be({}, t.scroll, {
      max: r
    })
  });
}, dv = function(t, r, n) {
  var a = t.frame;
  Qi(r, t) && (process.env.NODE_ENV !== "production" ? Z(!1, "Should not add placeholder space to home list") : Z(!1)), t.subject.withPlaceholder && (process.env.NODE_ENV !== "production" ? Z(!1, "Cannot add placeholder size to a subject when it already has one") : Z(!1));
  var i = el(t.axis, r.displaceBy).point, o = XM(t, i, n), s = {
    placeholderSize: i,
    increasedBy: o,
    oldFrameMaxScroll: t.frame ? t.frame.scroll.max : null
  };
  if (!a) {
    var l = gi({
      page: t.subject.page,
      withPlaceholder: s,
      axis: t.axis,
      frame: t.frame
    });
    return be({}, t, {
      subject: l
    });
  }
  var c = o ? zt(a.scroll.max, o) : a.scroll.max, u = fv(a, c), f = gi({
    page: t.subject.page,
    withPlaceholder: s,
    axis: t.axis,
    frame: u
  });
  return be({}, t, {
    subject: f,
    frame: u
  });
}, QM = function(t) {
  var r = t.subject.withPlaceholder;
  r || (process.env.NODE_ENV !== "production" ? Z(!1, "Cannot remove placeholder form subject when there was none") : Z(!1));
  var n = t.frame;
  if (!n) {
    var a = gi({
      page: t.subject.page,
      axis: t.axis,
      frame: null,
      withPlaceholder: null
    });
    return be({}, t, {
      subject: a
    });
  }
  var i = r.oldFrameMaxScroll;
  i || (process.env.NODE_ENV !== "production" ? Z(!1, "Expected droppable with frame to have old max frame scroll when removing placeholder") : Z(!1));
  var o = fv(n, i), s = gi({
    page: t.subject.page,
    axis: t.axis,
    frame: o,
    withPlaceholder: null
  });
  return be({}, t, {
    subject: s,
    frame: o
  });
}, JM = function(e) {
  var t = e.previousPageBorderBoxCenter, r = e.moveRelativeTo, n = e.insideDestination, a = e.draggable, i = e.draggables, o = e.destination, s = e.viewport, l = e.afterCritical;
  if (!r) {
    if (n.length)
      return null;
    var c = {
      displaced: ls,
      displacedBy: av,
      at: {
        type: "REORDER",
        destination: {
          droppableId: o.descriptor.id,
          index: 0
        }
      }
    }, u = $c({
      impact: c,
      draggable: a,
      droppable: o,
      draggables: i,
      afterCritical: l
    }), f = Qi(a, o) ? o : dv(o, a, i), p = uv({
      draggable: a,
      destination: f,
      newPageBorderBoxCenter: u,
      viewport: s.frame,
      withDroppableDisplacement: !1,
      onlyOnMainAxis: !0
    });
    return p ? c : null;
  }
  var h = t[o.axis.line] <= r.page.borderBox.center[o.axis.line], m = function() {
    var g = r.descriptor.index;
    return r.descriptor.id === a.descriptor.id || h ? g : g + 1;
  }(), v = el(o.axis, a.displaceBy);
  return f1({
    draggable: a,
    insideDestination: n,
    destination: o,
    viewport: s,
    displacedBy: v,
    last: ls,
    index: m
  });
}, eT = function(e) {
  var t = e.isMovingForward, r = e.previousPageBorderBoxCenter, n = e.draggable, a = e.isOver, i = e.draggables, o = e.droppables, s = e.viewport, l = e.afterCritical, c = GM({
    isMovingForward: t,
    pageBorderBoxCenter: r,
    source: a,
    droppables: o,
    viewport: s
  });
  if (!c)
    return null;
  var u = Ha(c.descriptor.id, i), f = KM({
    pageBorderBoxCenter: r,
    viewport: s,
    destination: c,
    insideDestination: u,
    afterCritical: l
  }), p = JM({
    previousPageBorderBoxCenter: r,
    destination: c,
    draggable: n,
    draggables: i,
    moveRelativeTo: f,
    insideDestination: u,
    viewport: s,
    afterCritical: l
  });
  if (!p)
    return null;
  var h = $c({
    impact: p,
    draggable: n,
    droppable: c,
    draggables: i,
    afterCritical: l
  }), m = Ef({
    pageBorderBoxCenter: h,
    draggable: n,
    viewport: s
  });
  return {
    clientSelection: m,
    impact: p,
    scrollJumpRequest: null
  };
}, mr = function(e) {
  var t = e.at;
  return t ? t.type === "REORDER" ? t.destination.droppableId : t.combine.droppableId : null;
}, tT = function(t, r) {
  var n = mr(t);
  return n ? r[n] : null;
}, rT = function(e) {
  var t = e.state, r = e.type, n = tT(t.impact, t.dimensions.droppables), a = !!n, i = t.dimensions.droppables[t.critical.droppable.id], o = n || i, s = o.axis.direction, l = s === "vertical" && (r === "MOVE_UP" || r === "MOVE_DOWN") || s === "horizontal" && (r === "MOVE_LEFT" || r === "MOVE_RIGHT");
  if (l && !a)
    return null;
  var c = r === "MOVE_DOWN" || r === "MOVE_RIGHT", u = t.dimensions.draggables[t.critical.draggable.id], f = t.current.page.borderBoxCenter, p = t.dimensions, h = p.draggables, m = p.droppables;
  return l ? qM({
    isMovingForward: c,
    previousPageBorderBoxCenter: f,
    draggable: u,
    destination: o,
    draggables: h,
    viewport: t.viewport,
    previousClientSelection: t.current.client.selection,
    previousImpact: t.impact,
    afterCritical: t.afterCritical
  }) : eT({
    isMovingForward: c,
    previousPageBorderBoxCenter: f,
    draggable: u,
    isOver: o,
    draggables: h,
    droppables: m,
    viewport: t.viewport,
    afterCritical: t.afterCritical
  });
};
function Ca(e) {
  return e.phase === "DRAGGING" || e.phase === "COLLECTING";
}
function pv(e) {
  var t = Mr(e.top, e.bottom), r = Mr(e.left, e.right);
  return function(a) {
    return t(a.y) && r(a.x);
  };
}
function nT(e, t) {
  return e.left < t.right && e.right > t.left && e.top < t.bottom && e.bottom > t.top;
}
function aT(e) {
  var t = e.pageBorderBox, r = e.draggable, n = e.candidates, a = r.page.borderBox.center, i = n.map(function(o) {
    var s = o.axis, l = Ia(o.axis.line, t.center[s.line], o.page.borderBox.center[s.crossAxisLine]);
    return {
      id: o.descriptor.id,
      distance: ss(a, l)
    };
  }).sort(function(o, s) {
    return s.distance - o.distance;
  });
  return i[0] ? i[0].id : null;
}
function iT(e) {
  var t = e.pageBorderBox, r = e.draggable, n = e.droppables, a = Ac(n).filter(function(i) {
    if (!i.isEnabled)
      return !1;
    var o = i.subject.active;
    if (!o || !nT(t, o))
      return !1;
    if (pv(o)(t.center))
      return !0;
    var s = i.axis, l = o.center[s.crossAxisLine], c = t[s.crossAxisStart], u = t[s.crossAxisEnd], f = Mr(o[s.crossAxisStart], o[s.crossAxisEnd]), p = f(c), h = f(u);
    return !p && !h ? !0 : p ? c < l : u > l;
  });
  return a.length ? a.length === 1 ? a[0].descriptor.id : aT({
    pageBorderBox: t,
    draggable: r,
    candidates: a
  }) : null;
}
var hv = function(t, r) {
  return Wr(Js(t, r));
}, oT = function(e, t) {
  var r = e.frame;
  return r ? hv(t, r.scroll.diff.value) : t;
};
function vv(e) {
  var t = e.displaced, r = e.id;
  return !!(t.visible[r] || t.invisible[r]);
}
function sT(e) {
  var t = e.draggable, r = e.closest, n = e.inHomeList;
  return r ? n && r.descriptor.index > t.descriptor.index ? r.descriptor.index - 1 : r.descriptor.index : null;
}
var lT = function(e) {
  var t = e.pageBorderBoxWithDroppableScroll, r = e.draggable, n = e.destination, a = e.insideDestination, i = e.last, o = e.viewport, s = e.afterCritical, l = n.axis, c = el(n.axis, r.displaceBy), u = c.value, f = t[l.start], p = t[l.end], h = Tc(r, a), m = aa(h, function(g) {
    var y = g.descriptor.id, b = g.page.borderBox.center[l.line], w = Yn(y, s), x = vv({
      displaced: i,
      id: y
    });
    return w ? x ? p <= b : f < b - u : x ? p <= b + u : f < b;
  }), v = sT({
    draggable: r,
    closest: m,
    inHomeList: Qi(r, n)
  });
  return f1({
    draggable: r,
    insideDestination: a,
    destination: n,
    viewport: o,
    last: i,
    displacedBy: c,
    index: v
  });
}, cT = 4, uT = function(e) {
  var t = e.draggable, r = e.pageBorderBoxWithDroppableScroll, n = e.previousImpact, a = e.destination, i = e.insideDestination, o = e.afterCritical;
  if (!a.isCombineEnabled)
    return null;
  var s = a.axis, l = el(a.axis, t.displaceBy), c = l.value, u = r[s.start], f = r[s.end], p = Tc(t, i), h = aa(p, function(v) {
    var g = v.descriptor.id, y = v.page.borderBox, b = y[s.size], w = b / cT, x = Yn(g, o), C = vv({
      displaced: n.displaced,
      id: g
    });
    return x ? C ? f > y[s.start] + w && f < y[s.end] - w : u > y[s.start] - c + w && u < y[s.end] - c - w : C ? f > y[s.start] + c + w && f < y[s.end] + c - w : u > y[s.start] + w && u < y[s.end] - w;
  });
  if (!h)
    return null;
  var m = {
    displacedBy: l,
    displaced: n.displaced,
    at: {
      type: "COMBINE",
      combine: {
        draggableId: h.descriptor.id,
        droppableId: a.descriptor.id
      }
    }
  };
  return m;
}, mv = function(e) {
  var t = e.pageOffset, r = e.draggable, n = e.draggables, a = e.droppables, i = e.previousImpact, o = e.viewport, s = e.afterCritical, l = hv(r.page.borderBox, t), c = iT({
    pageBorderBox: l,
    draggable: r,
    droppables: a
  });
  if (!c)
    return SM;
  var u = a[c], f = Ha(u.descriptor.id, n), p = oT(u, l);
  return uT({
    pageBorderBoxWithDroppableScroll: p,
    draggable: r,
    previousImpact: i,
    destination: u,
    insideDestination: f,
    afterCritical: s
  }) || lT({
    pageBorderBoxWithDroppableScroll: p,
    draggable: r,
    destination: u,
    insideDestination: f,
    last: i.displaced,
    viewport: o,
    afterCritical: s
  });
}, jf = function(e, t) {
  var r;
  return be({}, e, (r = {}, r[t.descriptor.id] = t, r));
}, fT = function(t) {
  var r = t.previousImpact, n = t.impact, a = t.droppables, i = mr(r), o = mr(n);
  if (!i || i === o)
    return a;
  var s = a[i];
  if (!s.subject.withPlaceholder)
    return a;
  var l = QM(s);
  return jf(a, l);
}, dT = function(e) {
  var t = e.draggable, r = e.draggables, n = e.droppables, a = e.previousImpact, i = e.impact, o = fT({
    previousImpact: a,
    impact: i,
    droppables: n
  }), s = mr(i);
  if (!s)
    return o;
  var l = n[s];
  if (Qi(t, l) || l.subject.withPlaceholder)
    return o;
  var c = dv(l, t, r);
  return jf(o, c);
}, Uo = function(e) {
  var t = e.state, r = e.clientSelection, n = e.dimensions, a = e.viewport, i = e.impact, o = e.scrollJumpRequest, s = a || t.viewport, l = n || t.dimensions, c = r || t.current.client.selection, u = vr(c, t.initial.client.selection), f = {
    offset: u,
    selection: c,
    borderBoxCenter: zt(t.initial.client.borderBoxCenter, u)
  }, p = {
    selection: zt(f.selection, s.scroll.current),
    borderBoxCenter: zt(f.borderBoxCenter, s.scroll.current),
    offset: zt(f.offset, s.scroll.diff.value)
  }, h = {
    client: f,
    page: p
  };
  if (t.phase === "COLLECTING")
    return be({
      phase: "COLLECTING"
    }, t, {
      dimensions: l,
      viewport: s,
      current: h
    });
  var m = l.draggables[t.critical.draggable.id], v = i || mv({
    pageOffset: p.offset,
    draggable: m,
    draggables: l.draggables,
    droppables: l.droppables,
    previousImpact: t.impact,
    viewport: s,
    afterCritical: t.afterCritical
  }), g = dT({
    draggable: m,
    impact: v,
    previousImpact: t.impact,
    draggables: l.draggables,
    droppables: l.droppables
  }), y = be({}, t, {
    current: h,
    dimensions: {
      draggables: l.draggables,
      droppables: g
    },
    impact: v,
    viewport: s,
    scrollJumpRequest: o || null,
    forceShouldAnimate: o ? !1 : null
  });
  return y;
};
function pT(e, t) {
  return e.map(function(r) {
    return t[r];
  });
}
var gv = function(e) {
  var t = e.impact, r = e.viewport, n = e.draggables, a = e.destination, i = e.forceShouldAnimate, o = t.displaced, s = pT(o.all, n), l = cs({
    afterDragging: s,
    destination: a,
    displacedBy: t.displacedBy,
    viewport: r.frame,
    forceShouldAnimate: i,
    last: o
  });
  return be({}, t, {
    displaced: l
  });
}, yv = function(e) {
  var t = e.impact, r = e.draggable, n = e.droppable, a = e.draggables, i = e.viewport, o = e.afterCritical, s = $c({
    impact: t,
    draggable: r,
    draggables: a,
    droppable: n,
    afterCritical: o
  });
  return Ef({
    pageBorderBoxCenter: s,
    draggable: r,
    viewport: i
  });
}, bv = function(e) {
  var t = e.state, r = e.dimensions, n = e.viewport;
  t.movementMode !== "SNAP" && (process.env.NODE_ENV, Z(!1));
  var a = t.impact, i = n || t.viewport, o = r || t.dimensions, s = o.draggables, l = o.droppables, c = s[t.critical.draggable.id], u = mr(a);
  u || (process.env.NODE_ENV !== "production" ? Z(!1, "Must be over a destination in SNAP movement mode") : Z(!1));
  var f = l[u], p = gv({
    impact: a,
    viewport: i,
    destination: f,
    draggables: s
  }), h = yv({
    impact: p,
    draggable: c,
    droppable: f,
    draggables: s,
    viewport: i,
    afterCritical: t.afterCritical
  });
  return Uo({
    impact: p,
    clientSelection: h,
    state: t,
    dimensions: o,
    viewport: i
  });
}, hT = function(e) {
  return {
    index: e.index,
    droppableId: e.droppableId
  };
}, Cv = function(e) {
  var t = e.draggable, r = e.home, n = e.draggables, a = e.viewport, i = el(r.axis, t.displaceBy), o = Ha(r.descriptor.id, n), s = o.indexOf(t);
  s === -1 && (process.env.NODE_ENV !== "production" ? Z(!1, "Expected draggable to be inside home list") : Z(!1));
  var l = o.slice(s + 1), c = l.reduce(function(h, m) {
    return h[m.descriptor.id] = !0, h;
  }, {}), u = {
    inVirtualList: r.descriptor.mode === "virtual",
    displacedBy: i,
    effected: c
  }, f = cs({
    afterDragging: l,
    destination: r,
    displacedBy: i,
    last: null,
    viewport: a.frame,
    forceShouldAnimate: !1
  }), p = {
    displaced: f,
    displacedBy: i,
    at: {
      type: "REORDER",
      destination: hT(t.descriptor)
    }
  };
  return {
    impact: p,
    afterCritical: u
  };
}, vT = function(e, t) {
  return {
    draggables: e.draggables,
    droppables: jf(e.droppables, t)
  };
}, tl = function(t) {
  process.env.NODE_ENV;
}, rl = function(t) {
  process.env.NODE_ENV;
}, mT = function(e) {
  var t = e.draggable, r = e.offset, n = e.initialWindowScroll, a = s1(t.client, r), i = l1(a, n), o = be({}, t, {
    placeholder: be({}, t.placeholder, {
      client: a
    }),
    client: a,
    page: i
  });
  return o;
}, gT = function(e) {
  var t = e.frame;
  return t || (process.env.NODE_ENV !== "production" ? Z(!1, "Expected Droppable to have a frame") : Z(!1)), t;
}, yT = function(e) {
  var t = e.additions, r = e.updatedDroppables, n = e.viewport, a = n.scroll.diff.value;
  return t.map(function(i) {
    var o = i.descriptor.droppableId, s = r[o], l = gT(s), c = l.scroll.diff.value, u = zt(a, c), f = mT({
      draggable: i,
      offset: u,
      initialWindowScroll: n.scroll.initial
    });
    return f;
  });
}, bT = function(e) {
  var t = e.state, r = e.published;
  tl();
  var n = r.modified.map(function(w) {
    var x = t.dimensions.droppables[w.droppableId], C = Cf(x, w.scroll);
    return C;
  }), a = be({}, t.dimensions.droppables, {}, rv(n)), i = nv(yT({
    additions: r.additions,
    updatedDroppables: a,
    viewport: t.viewport
  })), o = be({}, t.dimensions.draggables, {}, i);
  r.removals.forEach(function(w) {
    delete o[w];
  });
  var s = {
    droppables: a,
    draggables: o
  }, l = mr(t.impact), c = l ? s.droppables[l] : null, u = s.draggables[t.critical.draggable.id], f = s.droppables[t.critical.droppable.id], p = Cv({
    draggable: u,
    home: f,
    draggables: o,
    viewport: t.viewport
  }), h = p.impact, m = p.afterCritical, v = c && c.isCombineEnabled ? t.impact : h, g = mv({
    pageOffset: t.current.page.offset,
    draggable: s.draggables[t.critical.draggable.id],
    draggables: s.draggables,
    droppables: s.droppables,
    previousImpact: v,
    viewport: t.viewport,
    afterCritical: m
  });
  rl();
  var y = be({
    phase: "DRAGGING"
  }, t, {
    phase: "DRAGGING",
    impact: g,
    onLiftImpact: h,
    dimensions: s,
    afterCritical: m,
    forceShouldAnimate: !1
  });
  if (t.phase === "COLLECTING")
    return y;
  var b = be({
    phase: "DROP_PENDING"
  }, y, {
    phase: "DROP_PENDING",
    reason: t.reason,
    isWaiting: !1
  });
  return b;
}, a3 = function(t) {
  return t.movementMode === "SNAP";
}, Yu = function(t, r, n) {
  var a = vT(t.dimensions, r);
  return !a3(t) || n ? Uo({
    state: t,
    dimensions: a
  }) : bv({
    state: t,
    dimensions: a
  });
};
function Ku(e) {
  return e.isDragging && e.movementMode === "SNAP" ? be({
    phase: "DRAGGING"
  }, e, {
    scrollJumpRequest: null
  }) : e;
}
var F5 = {
  phase: "IDLE",
  completed: null,
  shouldFlush: !1
}, CT = function(e, t) {
  if (e === void 0 && (e = F5), t.type === "FLUSH")
    return be({}, F5, {
      shouldFlush: !0
    });
  if (t.type === "INITIAL_PUBLISH") {
    e.phase !== "IDLE" && (process.env.NODE_ENV !== "production" ? Z(!1, "INITIAL_PUBLISH must come after a IDLE phase") : Z(!1));
    var r = t.payload, n = r.critical, a = r.clientSelection, i = r.viewport, o = r.dimensions, s = r.movementMode, l = o.draggables[n.draggable.id], c = o.droppables[n.droppable.id], u = {
      selection: a,
      borderBoxCenter: l.client.borderBox.center,
      offset: Ht
    }, f = {
      client: u,
      page: {
        selection: zt(u.selection, i.scroll.initial),
        borderBoxCenter: zt(u.selection, i.scroll.initial),
        offset: zt(u.selection, i.scroll.diff.value)
      }
    }, p = Ac(o.droppables).every(function(B) {
      return !B.isFixedOnPage;
    }), h = Cv({
      draggable: l,
      home: c,
      draggables: o.draggables,
      viewport: i
    }), m = h.impact, v = h.afterCritical, g = {
      phase: "DRAGGING",
      isDragging: !0,
      critical: n,
      movementMode: s,
      dimensions: o,
      initial: f,
      current: f,
      isWindowScrollAllowed: p,
      impact: m,
      afterCritical: v,
      onLiftImpact: m,
      viewport: i,
      scrollJumpRequest: null,
      forceShouldAnimate: null
    };
    return g;
  }
  if (t.type === "COLLECTION_STARTING") {
    if (e.phase === "COLLECTING" || e.phase === "DROP_PENDING")
      return e;
    e.phase !== "DRAGGING" && (process.env.NODE_ENV !== "production" ? Z(!1, "Collection cannot start from phase " + e.phase) : Z(!1));
    var y = be({
      phase: "COLLECTING"
    }, e, {
      phase: "COLLECTING"
    });
    return y;
  }
  if (t.type === "PUBLISH_WHILE_DRAGGING")
    return e.phase === "COLLECTING" || e.phase === "DROP_PENDING" || (process.env.NODE_ENV !== "production" ? Z(!1, "Unexpected " + t.type + " received in phase " + e.phase) : Z(!1)), bT({
      state: e,
      published: t.payload
    });
  if (t.type === "MOVE") {
    if (e.phase === "DROP_PENDING")
      return e;
    Ca(e) || (process.env.NODE_ENV !== "production" ? Z(!1, t.type + " not permitted in phase " + e.phase) : Z(!1));
    var b = t.payload.client;
    return zn(b, e.current.client.selection) ? e : Uo({
      state: e,
      clientSelection: b,
      impact: a3(e) ? e.impact : null
    });
  }
  if (t.type === "UPDATE_DROPPABLE_SCROLL") {
    if (e.phase === "DROP_PENDING" || e.phase === "COLLECTING")
      return Ku(e);
    Ca(e) || (process.env.NODE_ENV !== "production" ? Z(!1, t.type + " not permitted in phase " + e.phase) : Z(!1));
    var w = t.payload, x = w.id, C = w.newScroll, S = e.dimensions.droppables[x];
    if (!S)
      return e;
    var E = Cf(S, C);
    return Yu(e, E, !1);
  }
  if (t.type === "UPDATE_DROPPABLE_IS_ENABLED") {
    if (e.phase === "DROP_PENDING")
      return e;
    Ca(e) || (process.env.NODE_ENV !== "production" ? Z(!1, "Attempting to move in an unsupported phase " + e.phase) : Z(!1));
    var D = t.payload, I = D.id, k = D.isEnabled, V = e.dimensions.droppables[I];
    V || (process.env.NODE_ENV !== "production" ? Z(!1, "Cannot find Droppable[id: " + I + "] to toggle its enabled state") : Z(!1)), V.isEnabled === k && (process.env.NODE_ENV !== "production" ? Z(!1, "Trying to set droppable isEnabled to " + String(k) + `
      but it is already ` + String(V.isEnabled)) : Z(!1));
    var W = be({}, V, {
      isEnabled: k
    });
    return Yu(e, W, !0);
  }
  if (t.type === "UPDATE_DROPPABLE_IS_COMBINE_ENABLED") {
    if (e.phase === "DROP_PENDING")
      return e;
    Ca(e) || (process.env.NODE_ENV !== "production" ? Z(!1, "Attempting to move in an unsupported phase " + e.phase) : Z(!1));
    var L = t.payload, G = L.id, Q = L.isCombineEnabled, X = e.dimensions.droppables[G];
    X || (process.env.NODE_ENV !== "production" ? Z(!1, "Cannot find Droppable[id: " + G + "] to toggle its isCombineEnabled state") : Z(!1)), X.isCombineEnabled === Q && (process.env.NODE_ENV !== "production" ? Z(!1, "Trying to set droppable isCombineEnabled to " + String(Q) + `
      but it is already ` + String(X.isCombineEnabled)) : Z(!1));
    var K = be({}, X, {
      isCombineEnabled: Q
    });
    return Yu(e, K, !0);
  }
  if (t.type === "MOVE_BY_WINDOW_SCROLL") {
    if (e.phase === "DROP_PENDING" || e.phase === "DROP_ANIMATING")
      return e;
    Ca(e) || (process.env.NODE_ENV !== "production" ? Z(!1, "Cannot move by window in phase " + e.phase) : Z(!1)), e.isWindowScrollAllowed || (process.env.NODE_ENV !== "production" ? Z(!1, "Window scrolling is currently not supported for fixed lists") : Z(!1));
    var te = t.payload.newScroll;
    if (zn(e.viewport.scroll.current, te))
      return Ku(e);
    var _ = cv(e.viewport, te);
    return a3(e) ? bv({
      state: e,
      viewport: _
    }) : Uo({
      state: e,
      viewport: _
    });
  }
  if (t.type === "UPDATE_VIEWPORT_MAX_SCROLL") {
    if (!Ca(e))
      return e;
    var j = t.payload.maxScroll;
    if (zn(j, e.viewport.scroll.max))
      return e;
    var T = be({}, e.viewport, {
      scroll: be({}, e.viewport.scroll, {
        max: j
      })
    });
    return be({
      phase: "DRAGGING"
    }, e, {
      viewport: T
    });
  }
  if (t.type === "MOVE_UP" || t.type === "MOVE_DOWN" || t.type === "MOVE_LEFT" || t.type === "MOVE_RIGHT") {
    if (e.phase === "COLLECTING" || e.phase === "DROP_PENDING")
      return e;
    e.phase !== "DRAGGING" && (process.env.NODE_ENV !== "production" ? Z(!1, t.type + " received while not in DRAGGING phase") : Z(!1));
    var A = rT({
      state: e,
      type: t.type
    });
    return A ? Uo({
      state: e,
      impact: A.impact,
      clientSelection: A.clientSelection,
      scrollJumpRequest: A.scrollJumpRequest
    }) : e;
  }
  if (t.type === "DROP_PENDING") {
    var O = t.payload.reason;
    e.phase !== "COLLECTING" && (process.env.NODE_ENV !== "production" ? Z(!1, "Can only move into the DROP_PENDING phase from the COLLECTING phase") : Z(!1));
    var N = be({
      phase: "DROP_PENDING"
    }, e, {
      phase: "DROP_PENDING",
      isWaiting: !0,
      reason: O
    });
    return N;
  }
  if (t.type === "DROP_ANIMATE") {
    var q = t.payload, Y = q.completed, z = q.dropDuration, R = q.newHomeClientOffset;
    e.phase === "DRAGGING" || e.phase === "DROP_PENDING" || (process.env.NODE_ENV !== "production" ? Z(!1, "Cannot animate drop from phase " + e.phase) : Z(!1));
    var $ = {
      phase: "DROP_ANIMATING",
      completed: Y,
      dropDuration: z,
      newHomeClientOffset: R,
      dimensions: e.dimensions
    };
    return $;
  }
  if (t.type === "DROP_COMPLETE") {
    var F = t.payload.completed;
    return {
      phase: "IDLE",
      completed: F,
      shouldFlush: !1
    };
  }
  return e;
}, xT = function(t) {
  return {
    type: "BEFORE_INITIAL_CAPTURE",
    payload: t
  };
}, wT = function(t) {
  return {
    type: "LIFT",
    payload: t
  };
}, OT = function(t) {
  return {
    type: "INITIAL_PUBLISH",
    payload: t
  };
}, ST = function(t) {
  return {
    type: "PUBLISH_WHILE_DRAGGING",
    payload: t
  };
}, PT = function() {
  return {
    type: "COLLECTION_STARTING",
    payload: null
  };
}, ET = function(t) {
  return {
    type: "UPDATE_DROPPABLE_SCROLL",
    payload: t
  };
}, jT = function(t) {
  return {
    type: "UPDATE_DROPPABLE_IS_ENABLED",
    payload: t
  };
}, _T = function(t) {
  return {
    type: "UPDATE_DROPPABLE_IS_COMBINE_ENABLED",
    payload: t
  };
}, xv = function(t) {
  return {
    type: "MOVE",
    payload: t
  };
}, DT = function(t) {
  return {
    type: "MOVE_BY_WINDOW_SCROLL",
    payload: t
  };
}, AT = function(t) {
  return {
    type: "UPDATE_VIEWPORT_MAX_SCROLL",
    payload: t
  };
}, MT = function() {
  return {
    type: "MOVE_UP",
    payload: null
  };
}, TT = function() {
  return {
    type: "MOVE_DOWN",
    payload: null
  };
}, $T = function() {
  return {
    type: "MOVE_RIGHT",
    payload: null
  };
}, NT = function() {
  return {
    type: "MOVE_LEFT",
    payload: null
  };
}, _f = function() {
  return {
    type: "FLUSH",
    payload: null
  };
}, IT = function(t) {
  return {
    type: "DROP_ANIMATE",
    payload: t
  };
}, Df = function(t) {
  return {
    type: "DROP_COMPLETE",
    payload: t
  };
}, wv = function(t) {
  return {
    type: "DROP",
    payload: t
  };
}, LT = function(t) {
  return {
    type: "DROP_PENDING",
    payload: t
  };
}, Ov = function() {
  return {
    type: "DROP_ANIMATION_FINISHED",
    payload: null
  };
};
function RT(e) {
  if (!(e.length <= 1)) {
    for (var t = e.map(function(s) {
      return s.descriptor.index;
    }), r = {}, n = 1; n < t.length; n++) {
      var a = t[n], i = t[n - 1];
      a !== i + 1 && (r[a] = !0);
    }
    if (Object.keys(r).length) {
      var o = t.map(function(s) {
        var l = !!r[s];
        return l ? "[🔥" + s + "]" : "" + s;
      }).join(", ");
      process.env.NODE_ENV !== "production" && dt(`
    Detected non-consecutive <Draggable /> indexes.

    (This can cause unexpected bugs)

    ` + o + `
  `);
    }
  }
}
function kT(e, t) {
  if (process.env.NODE_ENV !== "production") {
    var r = Ha(e.droppable.id, t.draggables);
    RT(r);
  }
}
var BT = function(e) {
  return function(t) {
    var r = t.getState, n = t.dispatch;
    return function(a) {
      return function(i) {
        if (i.type !== "LIFT") {
          a(i);
          return;
        }
        var o = i.payload, s = o.id, l = o.clientSelection, c = o.movementMode, u = r();
        u.phase === "DROP_ANIMATING" && n(Df({
          completed: u.completed
        })), r().phase !== "IDLE" && (process.env.NODE_ENV !== "production" ? Z(!1, "Unexpected phase to start a drag") : Z(!1)), n(_f()), n(xT({
          draggableId: s,
          movementMode: c
        }));
        var f = {
          shouldPublishImmediately: c === "SNAP"
        }, p = {
          draggableId: s,
          scrollOptions: f
        }, h = e.startPublishing(p), m = h.critical, v = h.dimensions, g = h.viewport;
        kT(m, v), n(OT({
          critical: m,
          dimensions: v,
          clientSelection: l,
          movementMode: c,
          viewport: g
        }));
      };
    };
  };
}, VT = function(e) {
  return function() {
    return function(t) {
      return function(r) {
        r.type === "INITIAL_PUBLISH" && e.dragging(), r.type === "DROP_ANIMATE" && e.dropping(r.payload.completed.result.reason), (r.type === "FLUSH" || r.type === "DROP_COMPLETE") && e.resting(), t(r);
      };
    };
  };
}, Af = {
  outOfTheWay: "cubic-bezier(0.2, 0, 0, 1)",
  drop: "cubic-bezier(.2,1,.1,1)"
}, us = {
  opacity: {
    drop: 0,
    combining: 0.7
  },
  scale: {
    drop: 0.75
  }
}, Mf = {
  outOfTheWay: 0.2,
  minDropTime: 0.33,
  maxDropTime: 0.55
}, ha = Mf.outOfTheWay + "s " + Af.outOfTheWay, Zo = {
  fluid: "opacity " + ha,
  snap: "transform " + ha + ", opacity " + ha,
  drop: function(t) {
    var r = t + "s " + Af.drop;
    return "transform " + r + ", opacity " + r;
  },
  outOfTheWay: "transform " + ha,
  placeholder: "height " + ha + ", width " + ha + ", margin " + ha
}, W5 = function(t) {
  return zn(t, Ht) ? null : "translate(" + t.x + "px, " + t.y + "px)";
}, i3 = {
  moveTo: W5,
  drop: function(t, r) {
    var n = W5(t);
    return n ? r ? n + " scale(" + us.scale.drop + ")" : n : null;
  }
}, o3 = Mf.minDropTime, Sv = Mf.maxDropTime, HT = Sv - o3, z5 = 1500, FT = 0.6, WT = function(e) {
  var t = e.current, r = e.destination, n = e.reason, a = ss(t, r);
  if (a <= 0)
    return o3;
  if (a >= z5)
    return Sv;
  var i = a / z5, o = o3 + HT * i, s = n === "CANCEL" ? o * FT : o;
  return Number(s.toFixed(2));
}, zT = function(e) {
  var t = e.impact, r = e.draggable, n = e.dimensions, a = e.viewport, i = e.afterCritical, o = n.draggables, s = n.droppables, l = mr(t), c = l ? s[l] : null, u = s[r.descriptor.droppableId], f = yv({
    impact: t,
    draggable: r,
    draggables: o,
    afterCritical: i,
    droppable: c || u,
    viewport: a
  }), p = vr(f, r.client.borderBox.center);
  return p;
}, UT = function(e) {
  var t = e.draggables, r = e.reason, n = e.lastImpact, a = e.home, i = e.viewport, o = e.onLiftImpact;
  if (!n.at || r !== "DROP") {
    var s = gv({
      draggables: t,
      impact: o,
      destination: a,
      viewport: i,
      forceShouldAnimate: !0
    });
    return {
      impact: s,
      didDropInsideDroppable: !1
    };
  }
  if (n.at.type === "REORDER")
    return {
      impact: n,
      didDropInsideDroppable: !0
    };
  var l = be({}, n, {
    displaced: ls
  });
  return {
    impact: l,
    didDropInsideDroppable: !0
  };
}, ZT = function(e) {
  var t = e.getState, r = e.dispatch;
  return function(n) {
    return function(a) {
      if (a.type !== "DROP") {
        n(a);
        return;
      }
      var i = t(), o = a.payload.reason;
      if (i.phase === "COLLECTING") {
        r(LT({
          reason: o
        }));
        return;
      }
      if (i.phase !== "IDLE") {
        var s = i.phase === "DROP_PENDING" && i.isWaiting;
        s && (process.env.NODE_ENV !== "production" ? Z(!1, "A DROP action occurred while DROP_PENDING and still waiting") : Z(!1)), i.phase === "DRAGGING" || i.phase === "DROP_PENDING" || (process.env.NODE_ENV !== "production" ? Z(!1, "Cannot drop in phase: " + i.phase) : Z(!1));
        var l = i.critical, c = i.dimensions, u = c.draggables[i.critical.draggable.id], f = UT({
          reason: o,
          lastImpact: i.impact,
          afterCritical: i.afterCritical,
          onLiftImpact: i.onLiftImpact,
          home: i.dimensions.droppables[i.critical.droppable.id],
          viewport: i.viewport,
          draggables: i.dimensions.draggables
        }), p = f.impact, h = f.didDropInsideDroppable, m = h ? wf(p) : null, v = h ? Mc(p) : null, g = {
          index: l.draggable.index,
          droppableId: l.droppable.id
        }, y = {
          draggableId: u.descriptor.id,
          type: u.descriptor.type,
          source: g,
          reason: o,
          mode: i.movementMode,
          destination: m,
          combine: v
        }, b = zT({
          impact: p,
          draggable: u,
          dimensions: c,
          viewport: i.viewport,
          afterCritical: i.afterCritical
        }), w = {
          critical: i.critical,
          afterCritical: i.afterCritical,
          result: y,
          impact: p
        }, x = !zn(i.current.client.offset, b) || !!y.combine;
        if (!x) {
          r(Df({
            completed: w
          }));
          return;
        }
        var C = WT({
          current: i.current.client.offset,
          destination: b,
          reason: o
        }), S = {
          newHomeClientOffset: b,
          dropDuration: C,
          completed: w
        };
        r(IT(S));
      }
    };
  };
}, Pv = function() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
};
function qT(e) {
  return {
    eventName: "scroll",
    options: {
      passive: !0,
      capture: !1
    },
    fn: function(r) {
      r.target !== window && r.target !== window.document || e();
    }
  };
}
function GT(e) {
  var t = e.onWindowScroll;
  function r() {
    t(Pv());
  }
  var n = is(r), a = qT(n), i = Wn;
  function o() {
    return i !== Wn;
  }
  function s() {
    o() && (process.env.NODE_ENV !== "production" ? Z(!1, "Cannot start scroll listener when already active") : Z(!1)), i = Dr(window, [a]);
  }
  function l() {
    o() || (process.env.NODE_ENV !== "production" ? Z(!1, "Cannot stop scroll listener when not active") : Z(!1)), n.cancel(), i(), i = Wn;
  }
  return {
    start: s,
    stop: l,
    isActive: o
  };
}
var YT = function(t) {
  return t.type === "DROP_COMPLETE" || t.type === "DROP_ANIMATE" || t.type === "FLUSH";
}, KT = function(e) {
  var t = GT({
    onWindowScroll: function(n) {
      e.dispatch(DT({
        newScroll: n
      }));
    }
  });
  return function(r) {
    return function(n) {
      !t.isActive() && n.type === "INITIAL_PUBLISH" && t.start(), t.isActive() && YT(n) && t.stop(), r(n);
    };
  };
}, XT = function(e) {
  var t = !1, r = !1, n = setTimeout(function() {
    r = !0;
  }), a = function(o) {
    if (t) {
      process.env.NODE_ENV !== "production" && dt("Announcement already made. Not making a second announcement");
      return;
    }
    if (r) {
      process.env.NODE_ENV !== "production" && dt(`
        Announcements cannot be made asynchronously.
        Default message has already been announced.
      `);
      return;
    }
    t = !0, e(o), clearTimeout(n);
  };
  return a.wasCalled = function() {
    return t;
  }, a;
}, QT = function() {
  var e = [], t = function(i) {
    var o = xf(e, function(c) {
      return c.timerId === i;
    });
    o === -1 && (process.env.NODE_ENV !== "production" ? Z(!1, "Could not find timer") : Z(!1));
    var s = e.splice(o, 1), l = s[0];
    l.callback();
  }, r = function(i) {
    var o = setTimeout(function() {
      return t(o);
    }), s = {
      timerId: o,
      callback: i
    };
    e.push(s);
  }, n = function() {
    if (e.length) {
      var i = [].concat(e);
      e.length = 0, i.forEach(function(o) {
        clearTimeout(o.timerId), o.callback();
      });
    }
  };
  return {
    add: r,
    flush: n
  };
}, JT = function(t, r) {
  return t == null && r == null ? !0 : t == null || r == null ? !1 : t.droppableId === r.droppableId && t.index === r.index;
}, e$ = function(t, r) {
  return t == null && r == null ? !0 : t == null || r == null ? !1 : t.draggableId === r.draggableId && t.droppableId === r.droppableId;
}, t$ = function(t, r) {
  if (t === r)
    return !0;
  var n = t.draggable.id === r.draggable.id && t.draggable.droppableId === r.draggable.droppableId && t.draggable.type === r.draggable.type && t.draggable.index === r.draggable.index, a = t.droppable.id === r.droppable.id && t.droppable.type === r.droppable.type;
  return n && a;
}, bo = function(t, r) {
  tl(), r(), rl();
}, xl = function(t, r) {
  return {
    draggableId: t.draggable.id,
    type: t.droppable.type,
    source: {
      droppableId: t.droppable.id,
      index: t.draggable.index
    },
    mode: r
  };
}, Xu = function(t, r, n, a) {
  if (!t) {
    n(a(r));
    return;
  }
  var i = XT(n), o = {
    announce: i
  };
  t(r, o), i.wasCalled() || n(a(r));
}, r$ = function(e, t) {
  var r = QT(), n = null, a = function(p, h) {
    n && (process.env.NODE_ENV !== "production" ? Z(!1, "Cannot fire onBeforeCapture as a drag start has already been published") : Z(!1)), bo("onBeforeCapture", function() {
      var m = e().onBeforeCapture;
      if (m) {
        var v = {
          draggableId: p,
          mode: h
        };
        m(v);
      }
    });
  }, i = function(p, h) {
    n && (process.env.NODE_ENV !== "production" ? Z(!1, "Cannot fire onBeforeDragStart as a drag start has already been published") : Z(!1)), bo("onBeforeDragStart", function() {
      var m = e().onBeforeDragStart;
      m && m(xl(p, h));
    });
  }, o = function(p, h) {
    n && (process.env.NODE_ENV !== "production" ? Z(!1, "Cannot fire onBeforeDragStart as a drag start has already been published") : Z(!1));
    var m = xl(p, h);
    n = {
      mode: h,
      lastCritical: p,
      lastLocation: m.source,
      lastCombine: null
    }, r.add(function() {
      bo("onDragStart", function() {
        return Xu(e().onDragStart, m, t, Hl.onDragStart);
      });
    });
  }, s = function(p, h) {
    var m = wf(h), v = Mc(h);
    n || (process.env.NODE_ENV !== "production" ? Z(!1, "Cannot fire onDragMove when onDragStart has not been called") : Z(!1));
    var g = !t$(p, n.lastCritical);
    g && (n.lastCritical = p);
    var y = !JT(n.lastLocation, m);
    y && (n.lastLocation = m);
    var b = !e$(n.lastCombine, v);
    if (b && (n.lastCombine = v), !(!g && !y && !b)) {
      var w = be({}, xl(p, n.mode), {
        combine: v,
        destination: m
      });
      r.add(function() {
        bo("onDragUpdate", function() {
          return Xu(e().onDragUpdate, w, t, Hl.onDragUpdate);
        });
      });
    }
  }, l = function() {
    n || (process.env.NODE_ENV !== "production" ? Z(!1, "Can only flush responders while dragging") : Z(!1)), r.flush();
  }, c = function(p) {
    n || (process.env.NODE_ENV !== "production" ? Z(!1, "Cannot fire onDragEnd when there is no matching onDragStart") : Z(!1)), n = null, bo("onDragEnd", function() {
      return Xu(e().onDragEnd, p, t, Hl.onDragEnd);
    });
  }, u = function() {
    if (n) {
      var p = be({}, xl(n.lastCritical, n.mode), {
        combine: null,
        destination: null,
        reason: "CANCEL"
      });
      c(p);
    }
  };
  return {
    beforeCapture: a,
    beforeStart: i,
    start: o,
    update: s,
    flush: l,
    drop: c,
    abort: u
  };
}, n$ = function(e, t) {
  var r = r$(e, t);
  return function(n) {
    return function(a) {
      return function(i) {
        if (i.type === "BEFORE_INITIAL_CAPTURE") {
          r.beforeCapture(i.payload.draggableId, i.payload.movementMode);
          return;
        }
        if (i.type === "INITIAL_PUBLISH") {
          var o = i.payload.critical;
          r.beforeStart(o, i.payload.movementMode), a(i), r.start(o, i.payload.movementMode);
          return;
        }
        if (i.type === "DROP_COMPLETE") {
          var s = i.payload.completed.result;
          r.flush(), a(i), r.drop(s);
          return;
        }
        if (a(i), i.type === "FLUSH") {
          r.abort();
          return;
        }
        var l = n.getState();
        l.phase === "DRAGGING" && r.update(l.critical, l.impact);
      };
    };
  };
}, a$ = function(e) {
  return function(t) {
    return function(r) {
      if (r.type !== "DROP_ANIMATION_FINISHED") {
        t(r);
        return;
      }
      var n = e.getState();
      n.phase !== "DROP_ANIMATING" && (process.env.NODE_ENV !== "production" ? Z(!1, "Cannot finish a drop animating when no drop is occurring") : Z(!1)), e.dispatch(Df({
        completed: n.completed
      }));
    };
  };
}, i$ = function(e) {
  var t = null, r = null;
  function n() {
    r && (cancelAnimationFrame(r), r = null), t && (t(), t = null);
  }
  return function(a) {
    return function(i) {
      if ((i.type === "FLUSH" || i.type === "DROP_COMPLETE" || i.type === "DROP_ANIMATION_FINISHED") && n(), a(i), i.type === "DROP_ANIMATE") {
        var o = {
          eventName: "scroll",
          options: {
            capture: !0,
            passive: !1,
            once: !0
          },
          fn: function() {
            var l = e.getState();
            l.phase === "DROP_ANIMATING" && e.dispatch(Ov());
          }
        };
        r = requestAnimationFrame(function() {
          r = null, t = Dr(window, [o]);
        });
      }
    };
  };
}, o$ = function(e) {
  return function() {
    return function(t) {
      return function(r) {
        (r.type === "DROP_COMPLETE" || r.type === "FLUSH" || r.type === "DROP_ANIMATE") && e.stopPublishing(), t(r);
      };
    };
  };
}, s$ = function(e) {
  var t = !1;
  return function() {
    return function(r) {
      return function(n) {
        if (n.type === "INITIAL_PUBLISH") {
          t = !0, e.tryRecordFocus(n.payload.critical.draggable.id), r(n), e.tryRestoreFocusRecorded();
          return;
        }
        if (r(n), !!t) {
          if (n.type === "FLUSH") {
            t = !1, e.tryRestoreFocusRecorded();
            return;
          }
          if (n.type === "DROP_COMPLETE") {
            t = !1;
            var a = n.payload.completed.result;
            a.combine && e.tryShiftRecord(a.draggableId, a.combine.draggableId), e.tryRestoreFocusRecorded();
          }
        }
      };
    };
  };
}, l$ = function(t) {
  return t.type === "DROP_COMPLETE" || t.type === "DROP_ANIMATE" || t.type === "FLUSH";
}, c$ = function(e) {
  return function(t) {
    return function(r) {
      return function(n) {
        if (l$(n)) {
          e.stop(), r(n);
          return;
        }
        if (n.type === "INITIAL_PUBLISH") {
          r(n);
          var a = t.getState();
          a.phase !== "DRAGGING" && (process.env.NODE_ENV !== "production" ? Z(!1, "Expected phase to be DRAGGING after INITIAL_PUBLISH") : Z(!1)), e.start(a);
          return;
        }
        r(n), e.scroll(t.getState());
      };
    };
  };
}, u$ = function(e) {
  return function(t) {
    return function(r) {
      if (t(r), r.type === "PUBLISH_WHILE_DRAGGING") {
        var n = e.getState();
        n.phase === "DROP_PENDING" && (n.isWaiting || e.dispatch(wv({
          reason: n.reason
        })));
      }
    };
  };
}, f$ = process.env.NODE_ENV !== "production" && typeof window < "u" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
  name: "react-beautiful-dnd"
}) : Rh, d$ = function(e) {
  var t = e.dimensionMarshal, r = e.focusMarshal, n = e.styleMarshal, a = e.getResponders, i = e.announce, o = e.autoScroller;
  return Lh(CT, f$(JD(VT(n), o$(t), BT(t), ZT, a$, i$, u$, c$(o), KT, s$(r), n$(a, i))));
}, Qu = function() {
  return {
    additions: {},
    removals: {},
    modified: {}
  };
};
function p$(e) {
  var t = e.registry, r = e.callbacks, n = Qu(), a = null, i = function() {
    a || (r.collectionStarting(), a = requestAnimationFrame(function() {
      a = null, tl();
      var u = n, f = u.additions, p = u.removals, h = u.modified, m = Object.keys(f).map(function(y) {
        return t.draggable.getById(y).getDimension(Ht);
      }).sort(function(y, b) {
        return y.descriptor.index - b.descriptor.index;
      }), v = Object.keys(h).map(function(y) {
        var b = t.droppable.getById(y), w = b.callbacks.getScrollWhileDragging();
        return {
          droppableId: y,
          scroll: w
        };
      }), g = {
        additions: m,
        removals: Object.keys(p),
        modified: v
      };
      n = Qu(), rl(), r.publish(g);
    }));
  }, o = function(u) {
    var f = u.descriptor.id;
    n.additions[f] = u, n.modified[u.descriptor.droppableId] = !0, n.removals[f] && delete n.removals[f], i();
  }, s = function(u) {
    var f = u.descriptor;
    n.removals[f.id] = !0, n.modified[f.droppableId] = !0, n.additions[f.id] && delete n.additions[f.id], i();
  }, l = function() {
    a && (cancelAnimationFrame(a), a = null, n = Qu());
  };
  return {
    add: o,
    remove: s,
    stop: l
  };
}
var Ev = function(e) {
  var t = e.scrollHeight, r = e.scrollWidth, n = e.height, a = e.width, i = vr({
    x: r,
    y: t
  }, {
    x: a,
    y: n
  }), o = {
    x: Math.max(0, i.x),
    y: Math.max(0, i.y)
  };
  return o;
}, jv = function() {
  var e = document.documentElement;
  return e || (process.env.NODE_ENV !== "production" ? Z(!1, "Cannot find document.documentElement") : Z(!1)), e;
}, _v = function() {
  var e = jv(), t = Ev({
    scrollHeight: e.scrollHeight,
    scrollWidth: e.scrollWidth,
    width: e.clientWidth,
    height: e.clientHeight
  });
  return t;
}, h$ = function() {
  var e = Pv(), t = _v(), r = e.y, n = e.x, a = jv(), i = a.clientWidth, o = a.clientHeight, s = n + i, l = r + o, c = Wr({
    top: r,
    left: n,
    right: s,
    bottom: l
  }), u = {
    frame: c,
    scroll: {
      initial: e,
      current: e,
      max: t,
      diff: {
        value: Ht,
        displacement: Ht
      }
    }
  };
  return u;
}, v$ = function(e) {
  var t = e.critical, r = e.scrollOptions, n = e.registry;
  tl();
  var a = h$(), i = a.scroll.current, o = t.droppable, s = n.droppable.getAllByType(o.type).map(function(f) {
    return f.callbacks.getDimensionAndWatchScroll(i, r);
  }), l = n.draggable.getAllByType(t.draggable.type).map(function(f) {
    return f.getDimension(i);
  }), c = {
    draggables: nv(l),
    droppables: rv(s)
  };
  rl();
  var u = {
    dimensions: c,
    critical: t,
    viewport: a
  };
  return u;
};
function U5(e, t, r) {
  if (r.descriptor.id === t.id || r.descriptor.type !== t.type)
    return !1;
  var n = e.droppable.getById(r.descriptor.droppableId);
  return n.descriptor.mode !== "virtual" ? (process.env.NODE_ENV !== "production" && dt(`
      You are attempting to add or remove a Draggable [id: ` + r.descriptor.id + `]
      while a drag is occurring. This is only supported for virtual lists.

      See https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/patterns/virtual-lists.md
    `), !1) : !0;
}
var m$ = function(e, t) {
  var r = null, n = p$({
    callbacks: {
      publish: t.publishWhileDragging,
      collectionStarting: t.collectionStarting
    },
    registry: e
  }), a = function(h, m) {
    e.droppable.exists(h) || (process.env.NODE_ENV !== "production" ? Z(!1, "Cannot update is enabled flag of Droppable " + h + " as it is not registered") : Z(!1)), r && t.updateDroppableIsEnabled({
      id: h,
      isEnabled: m
    });
  }, i = function(h, m) {
    r && (e.droppable.exists(h) || (process.env.NODE_ENV !== "production" ? Z(!1, "Cannot update isCombineEnabled flag of Droppable " + h + " as it is not registered") : Z(!1)), t.updateDroppableIsCombineEnabled({
      id: h,
      isCombineEnabled: m
    }));
  }, o = function(h, m) {
    r && (e.droppable.exists(h) || (process.env.NODE_ENV !== "production" ? Z(!1, "Cannot update the scroll on Droppable " + h + " as it is not registered") : Z(!1)), t.updateDroppableScroll({
      id: h,
      newScroll: m
    }));
  }, s = function(h, m) {
    r && e.droppable.getById(h).callbacks.scroll(m);
  }, l = function() {
    if (r) {
      n.stop();
      var h = r.critical.droppable;
      e.droppable.getAllByType(h.type).forEach(function(m) {
        return m.callbacks.dragStopped();
      }), r.unsubscribe(), r = null;
    }
  }, c = function(h) {
    r || (process.env.NODE_ENV !== "production" ? Z(!1, "Should only be subscribed when a collection is occurring") : Z(!1));
    var m = r.critical.draggable;
    h.type === "ADDITION" && U5(e, m, h.value) && n.add(h.value), h.type === "REMOVAL" && U5(e, m, h.value) && n.remove(h.value);
  }, u = function(h) {
    r && (process.env.NODE_ENV !== "production" ? Z(!1, "Cannot start capturing critical dimensions as there is already a collection") : Z(!1));
    var m = e.draggable.getById(h.draggableId), v = e.droppable.getById(m.descriptor.droppableId), g = {
      draggable: m.descriptor,
      droppable: v.descriptor
    }, y = e.subscribe(c);
    return r = {
      critical: g,
      unsubscribe: y
    }, v$({
      critical: g,
      registry: e,
      scrollOptions: h.scrollOptions
    });
  }, f = {
    updateDroppableIsEnabled: a,
    updateDroppableIsCombineEnabled: i,
    scrollDroppable: s,
    updateDroppableScroll: o,
    startPublishing: u,
    stopPublishing: l
  };
  return f;
}, Dv = function(e, t) {
  return e.phase === "IDLE" ? !0 : e.phase !== "DROP_ANIMATING" || e.completed.result.draggableId === t ? !1 : e.completed.result.reason === "DROP";
}, g$ = function(e) {
  window.scrollBy(e.x, e.y);
}, y$ = Vt(function(e) {
  return Ac(e).filter(function(t) {
    return !(!t.isEnabled || !t.frame);
  });
}), b$ = function(t, r) {
  var n = aa(y$(r), function(a) {
    return a.frame || (process.env.NODE_ENV !== "production" ? Z(!1, "Invalid result") : Z(!1)), pv(a.frame.pageMarginBox)(t);
  });
  return n;
}, C$ = function(e) {
  var t = e.center, r = e.destination, n = e.droppables;
  if (r) {
    var a = n[r];
    return a.frame ? a : null;
  }
  var i = b$(t, n);
  return i;
}, Un = {
  startFromPercentage: 0.25,
  maxScrollAtPercentage: 0.05,
  maxPixelScroll: 28,
  ease: function(t) {
    return Math.pow(t, 2);
  },
  durationDampening: {
    stopDampeningAt: 1200,
    accelerateAt: 360
  }
}, x$ = function(e, t) {
  var r = e[t.size] * Un.startFromPercentage, n = e[t.size] * Un.maxScrollAtPercentage, a = {
    startScrollingFrom: r,
    maxScrollValueAt: n
  };
  return a;
}, Av = function(e) {
  var t = e.startOfRange, r = e.endOfRange, n = e.current, a = r - t;
  if (a === 0)
    return process.env.NODE_ENV !== "production" && dt(`
      Detected distance range of 0 in the fluid auto scroller
      This is unexpected and would cause a divide by 0 issue.
      Not allowing an auto scroll
    `), 0;
  var i = n - t, o = i / a;
  return o;
}, Tf = 1, w$ = function(e, t) {
  if (e > t.startScrollingFrom)
    return 0;
  if (e <= t.maxScrollValueAt)
    return Un.maxPixelScroll;
  if (e === t.startScrollingFrom)
    return Tf;
  var r = Av({
    startOfRange: t.maxScrollValueAt,
    endOfRange: t.startScrollingFrom,
    current: e
  }), n = 1 - r, a = Un.maxPixelScroll * Un.ease(n);
  return Math.ceil(a);
}, Z5 = Un.durationDampening.accelerateAt, q5 = Un.durationDampening.stopDampeningAt, O$ = function(e, t) {
  var r = t, n = q5, a = Date.now(), i = a - r;
  if (i >= q5)
    return e;
  if (i < Z5)
    return Tf;
  var o = Av({
    startOfRange: Z5,
    endOfRange: n,
    current: i
  }), s = e * Un.ease(o);
  return Math.ceil(s);
}, G5 = function(e) {
  var t = e.distanceToEdge, r = e.thresholds, n = e.dragStartTime, a = e.shouldUseTimeDampening, i = w$(t, r);
  return i === 0 ? 0 : a ? Math.max(O$(i, n), Tf) : i;
}, Y5 = function(e) {
  var t = e.container, r = e.distanceToEdges, n = e.dragStartTime, a = e.axis, i = e.shouldUseTimeDampening, o = x$(t, a), s = r[a.end] < r[a.start];
  return s ? G5({
    distanceToEdge: r[a.end],
    thresholds: o,
    dragStartTime: n,
    shouldUseTimeDampening: i
  }) : -1 * G5({
    distanceToEdge: r[a.start],
    thresholds: o,
    dragStartTime: n,
    shouldUseTimeDampening: i
  });
}, S$ = function(e) {
  var t = e.container, r = e.subject, n = e.proposedScroll, a = r.height > t.height, i = r.width > t.width;
  return !i && !a ? n : i && a ? null : {
    x: i ? 0 : n.x,
    y: a ? 0 : n.y
  };
}, P$ = ev(function(e) {
  return e === 0 ? 0 : e;
}), Mv = function(e) {
  var t = e.dragStartTime, r = e.container, n = e.subject, a = e.center, i = e.shouldUseTimeDampening, o = {
    top: a.y - r.top,
    right: r.right - a.x,
    bottom: r.bottom - a.y,
    left: a.x - r.left
  }, s = Y5({
    container: r,
    distanceToEdges: o,
    dragStartTime: t,
    axis: Of,
    shouldUseTimeDampening: i
  }), l = Y5({
    container: r,
    distanceToEdges: o,
    dragStartTime: t,
    axis: ov,
    shouldUseTimeDampening: i
  }), c = P$({
    x: l,
    y: s
  });
  if (zn(c, Ht))
    return null;
  var u = S$({
    container: r,
    subject: n,
    proposedScroll: c
  });
  return u ? zn(u, Ht) ? null : u : null;
}, E$ = ev(function(e) {
  return e === 0 ? 0 : e > 0 ? 1 : -1;
}), $f = function() {
  var e = function(r, n) {
    return r < 0 ? r : r > n ? r - n : 0;
  };
  return function(t) {
    var r = t.current, n = t.max, a = t.change, i = zt(r, a), o = {
      x: e(i.x, n.x),
      y: e(i.y, n.y)
    };
    return zn(o, Ht) ? null : o;
  };
}(), Tv = function(t) {
  var r = t.max, n = t.current, a = t.change, i = {
    x: Math.max(n.x, r.x),
    y: Math.max(n.y, r.y)
  }, o = E$(a), s = $f({
    max: i,
    current: n,
    change: o
  });
  return !s || o.x !== 0 && s.x === 0 || o.y !== 0 && s.y === 0;
}, Nf = function(t, r) {
  return Tv({
    current: t.scroll.current,
    max: t.scroll.max,
    change: r
  });
}, j$ = function(t, r) {
  if (!Nf(t, r))
    return null;
  var n = t.scroll.max, a = t.scroll.current;
  return $f({
    current: a,
    max: n,
    change: r
  });
}, If = function(t, r) {
  var n = t.frame;
  return n ? Tv({
    current: n.scroll.current,
    max: n.scroll.max,
    change: r
  }) : !1;
}, _$ = function(t, r) {
  var n = t.frame;
  return !n || !If(t, r) ? null : $f({
    current: n.scroll.current,
    max: n.scroll.max,
    change: r
  });
}, D$ = function(e) {
  var t = e.viewport, r = e.subject, n = e.center, a = e.dragStartTime, i = e.shouldUseTimeDampening, o = Mv({
    dragStartTime: a,
    container: t.frame,
    subject: r,
    center: n,
    shouldUseTimeDampening: i
  });
  return o && Nf(t, o) ? o : null;
}, A$ = function(e) {
  var t = e.droppable, r = e.subject, n = e.center, a = e.dragStartTime, i = e.shouldUseTimeDampening, o = t.frame;
  if (!o)
    return null;
  var s = Mv({
    dragStartTime: a,
    container: o.pageMarginBox,
    subject: r,
    center: n,
    shouldUseTimeDampening: i
  });
  return s && If(t, s) ? s : null;
}, K5 = function(e) {
  var t = e.state, r = e.dragStartTime, n = e.shouldUseTimeDampening, a = e.scrollWindow, i = e.scrollDroppable, o = t.current.page.borderBoxCenter, s = t.dimensions.draggables[t.critical.draggable.id], l = s.page.marginBox;
  if (t.isWindowScrollAllowed) {
    var c = t.viewport, u = D$({
      dragStartTime: r,
      viewport: c,
      subject: l,
      center: o,
      shouldUseTimeDampening: n
    });
    if (u) {
      a(u);
      return;
    }
  }
  var f = C$({
    center: o,
    destination: mr(t.impact),
    droppables: t.dimensions.droppables
  });
  if (f) {
    var p = A$({
      dragStartTime: r,
      droppable: f,
      subject: l,
      center: o,
      shouldUseTimeDampening: n
    });
    p && i(f.descriptor.id, p);
  }
}, M$ = function(e) {
  var t = e.scrollWindow, r = e.scrollDroppable, n = is(t), a = is(r), i = null, o = function(u) {
    i || (process.env.NODE_ENV !== "production" ? Z(!1, "Cannot fluid scroll if not dragging") : Z(!1));
    var f = i, p = f.shouldUseTimeDampening, h = f.dragStartTime;
    K5({
      state: u,
      scrollWindow: n,
      scrollDroppable: a,
      dragStartTime: h,
      shouldUseTimeDampening: p
    });
  }, s = function(u) {
    tl(), i && (process.env.NODE_ENV !== "production" ? Z(!1, "Cannot start auto scrolling when already started") : Z(!1));
    var f = Date.now(), p = !1, h = function() {
      p = !0;
    };
    K5({
      state: u,
      dragStartTime: 0,
      shouldUseTimeDampening: !1,
      scrollWindow: h,
      scrollDroppable: h
    }), i = {
      dragStartTime: f,
      shouldUseTimeDampening: p
    }, rl(), p && o(u);
  }, l = function() {
    i && (n.cancel(), a.cancel(), i = null);
  };
  return {
    start: s,
    stop: l,
    scroll: o
  };
}, T$ = function(e) {
  var t = e.move, r = e.scrollDroppable, n = e.scrollWindow, a = function(c, u) {
    var f = zt(c.current.client.selection, u);
    t({
      client: f
    });
  }, i = function(c, u) {
    if (!If(c, u))
      return u;
    var f = _$(c, u);
    if (!f)
      return r(c.descriptor.id, u), null;
    var p = vr(u, f);
    r(c.descriptor.id, p);
    var h = vr(u, p);
    return h;
  }, o = function(c, u, f) {
    if (!c || !Nf(u, f))
      return f;
    var p = j$(u, f);
    if (!p)
      return n(f), null;
    var h = vr(f, p);
    n(h);
    var m = vr(f, h);
    return m;
  }, s = function(c) {
    var u = c.scrollJumpRequest;
    if (u) {
      var f = mr(c.impact);
      f || (process.env.NODE_ENV !== "production" ? Z(!1, "Cannot perform a jump scroll when there is no destination") : Z(!1));
      var p = i(c.dimensions.droppables[f], u);
      if (p) {
        var h = c.viewport, m = o(c.isWindowScrollAllowed, h, p);
        m && a(c, m);
      }
    }
  };
  return s;
}, $$ = function(e) {
  var t = e.scrollDroppable, r = e.scrollWindow, n = e.move, a = M$({
    scrollWindow: r,
    scrollDroppable: t
  }), i = T$({
    move: n,
    scrollWindow: r,
    scrollDroppable: t
  }), o = function(c) {
    if (c.phase === "DRAGGING") {
      if (c.movementMode === "FLUID") {
        a.scroll(c);
        return;
      }
      c.scrollJumpRequest && i(c);
    }
  }, s = {
    scroll: o,
    start: a.start,
    stop: a.stop
  };
  return s;
}, yi = "data-rbd", bi = function() {
  var e = yi + "-drag-handle";
  return {
    base: e,
    draggableId: e + "-draggable-id",
    contextId: e + "-context-id"
  };
}(), s3 = function() {
  var e = yi + "-draggable";
  return {
    base: e,
    contextId: e + "-context-id",
    id: e + "-id"
  };
}(), N$ = function() {
  var e = yi + "-droppable";
  return {
    base: e,
    contextId: e + "-context-id",
    id: e + "-id"
  };
}(), X5 = {
  contextId: yi + "-scroll-container-context-id"
}, I$ = function(t) {
  return function(r) {
    return "[" + r + '="' + t + '"]';
  };
}, Co = function(t, r) {
  return t.map(function(n) {
    var a = n.styles[r];
    return a ? n.selector + " { " + a + " }" : "";
  }).join(" ");
}, L$ = "pointer-events: none;", R$ = function(e) {
  var t = I$(e), r = function() {
    var s = `
      cursor: -webkit-grab;
      cursor: grab;
    `;
    return {
      selector: t(bi.contextId),
      styles: {
        always: `
          -webkit-touch-callout: none;
          -webkit-tap-highlight-color: rgba(0,0,0,0);
          touch-action: manipulation;
        `,
        resting: s,
        dragging: L$,
        dropAnimating: s
      }
    };
  }(), n = function() {
    var s = `
      transition: ` + Zo.outOfTheWay + `;
    `;
    return {
      selector: t(s3.contextId),
      styles: {
        dragging: s,
        dropAnimating: s,
        userCancel: s
      }
    };
  }(), a = {
    selector: t(N$.contextId),
    styles: {
      always: "overflow-anchor: none;"
    }
  }, i = {
    selector: "body",
    styles: {
      dragging: `
        cursor: grabbing;
        cursor: -webkit-grabbing;
        user-select: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        overflow-anchor: none;
      `
    }
  }, o = [n, r, a, i];
  return {
    always: Co(o, "always"),
    resting: Co(o, "resting"),
    dragging: Co(o, "dragging"),
    dropAnimating: Co(o, "dropAnimating"),
    userCancel: Co(o, "userCancel")
  };
}, gr = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? _9 : Me, Ju = function() {
  var t = document.querySelector("head");
  return t || (process.env.NODE_ENV !== "production" ? Z(!1, "Cannot find the head to append a style to") : Z(!1)), t;
}, Q5 = function(t) {
  var r = document.createElement("style");
  return t && r.setAttribute("nonce", t), r.type = "text/css", r;
};
function k$(e, t) {
  var r = Be(function() {
    return R$(e);
  }, [e]), n = ye(null), a = ye(null), i = he(Vt(function(f) {
    var p = a.current;
    p || (process.env.NODE_ENV !== "production" ? Z(!1, "Cannot set dynamic style element if it is not set") : Z(!1)), p.textContent = f;
  }), []), o = he(function(f) {
    var p = n.current;
    p || (process.env.NODE_ENV !== "production" ? Z(!1, "Cannot set dynamic style element if it is not set") : Z(!1)), p.textContent = f;
  }, []);
  gr(function() {
    !n.current && !a.current || (process.env.NODE_ENV !== "production" ? Z(!1, "style elements already mounted") : Z(!1));
    var f = Q5(t), p = Q5(t);
    return n.current = f, a.current = p, f.setAttribute(yi + "-always", e), p.setAttribute(yi + "-dynamic", e), Ju().appendChild(f), Ju().appendChild(p), o(r.always), i(r.resting), function() {
      var h = function(v) {
        var g = v.current;
        g || (process.env.NODE_ENV !== "production" ? Z(!1, "Cannot unmount ref as it is not set") : Z(!1)), Ju().removeChild(g), v.current = null;
      };
      h(n), h(a);
    };
  }, [t, o, i, r.always, r.resting, e]);
  var s = he(function() {
    return i(r.dragging);
  }, [i, r.dragging]), l = he(function(f) {
    if (f === "DROP") {
      i(r.dropAnimating);
      return;
    }
    i(r.userCancel);
  }, [i, r.dropAnimating, r.userCancel]), c = he(function() {
    a.current && i(r.resting);
  }, [i, r.resting]), u = Be(function() {
    return {
      dragging: s,
      dropping: l,
      resting: c
    };
  }, [s, l, c]);
  return u;
}
var $v = function(e) {
  return e && e.ownerDocument ? e.ownerDocument.defaultView : window;
};
function nl(e) {
  return e instanceof $v(e).HTMLElement;
}
function Nv(e, t) {
  var r = "[" + bi.contextId + '="' + e + '"]', n = tv(document.querySelectorAll(r));
  if (!n.length)
    return process.env.NODE_ENV !== "production" && dt('Unable to find any drag handles in the context "' + e + '"'), null;
  var a = aa(n, function(i) {
    return i.getAttribute(bi.draggableId) === t;
  });
  return a ? nl(a) ? a : (process.env.NODE_ENV !== "production" && dt("drag handle needs to be a HTMLElement"), null) : (process.env.NODE_ENV !== "production" && dt('Unable to find drag handle with id "' + t + '" as no handle with a matching id was found'), null);
}
function B$(e) {
  var t = ye({}), r = ye(null), n = ye(null), a = ye(!1), i = he(function(p, h) {
    var m = {
      id: p,
      focus: h
    };
    return t.current[p] = m, function() {
      var g = t.current, y = g[p];
      y !== m && delete g[p];
    };
  }, []), o = he(function(p) {
    var h = Nv(e, p);
    h && h !== document.activeElement && h.focus();
  }, [e]), s = he(function(p, h) {
    r.current === p && (r.current = h);
  }, []), l = he(function() {
    n.current || a.current && (n.current = requestAnimationFrame(function() {
      n.current = null;
      var p = r.current;
      p && o(p);
    }));
  }, [o]), c = he(function(p) {
    r.current = null;
    var h = document.activeElement;
    h && h.getAttribute(bi.draggableId) === p && (r.current = p);
  }, []);
  gr(function() {
    return a.current = !0, function() {
      a.current = !1;
      var p = n.current;
      p && cancelAnimationFrame(p);
    };
  }, []);
  var u = Be(function() {
    return {
      register: i,
      tryRecordFocus: c,
      tryRestoreFocusRecorded: l,
      tryShiftRecord: s
    };
  }, [i, c, l, s]);
  return u;
}
function V$() {
  var e = {
    draggables: {},
    droppables: {}
  }, t = [];
  function r(f) {
    return t.push(f), function() {
      var h = t.indexOf(f);
      h !== -1 && t.splice(h, 1);
    };
  }
  function n(f) {
    t.length && t.forEach(function(p) {
      return p(f);
    });
  }
  function a(f) {
    return e.draggables[f] || null;
  }
  function i(f) {
    var p = a(f);
    return p || (process.env.NODE_ENV !== "production" ? Z(!1, "Cannot find draggable entry with id [" + f + "]") : Z(!1)), p;
  }
  var o = {
    register: function(p) {
      e.draggables[p.descriptor.id] = p, n({
        type: "ADDITION",
        value: p
      });
    },
    update: function(p, h) {
      var m = e.draggables[h.descriptor.id];
      m && m.uniqueId === p.uniqueId && (delete e.draggables[h.descriptor.id], e.draggables[p.descriptor.id] = p);
    },
    unregister: function(p) {
      var h = p.descriptor.id, m = a(h);
      m && p.uniqueId === m.uniqueId && (delete e.draggables[h], n({
        type: "REMOVAL",
        value: p
      }));
    },
    getById: i,
    findById: a,
    exists: function(p) {
      return !!a(p);
    },
    getAllByType: function(p) {
      return u1(e.draggables).filter(function(h) {
        return h.descriptor.type === p;
      });
    }
  };
  function s(f) {
    return e.droppables[f] || null;
  }
  function l(f) {
    var p = s(f);
    return p || (process.env.NODE_ENV !== "production" ? Z(!1, "Cannot find droppable entry with id [" + f + "]") : Z(!1)), p;
  }
  var c = {
    register: function(p) {
      e.droppables[p.descriptor.id] = p;
    },
    unregister: function(p) {
      var h = s(p.descriptor.id);
      h && p.uniqueId === h.uniqueId && delete e.droppables[p.descriptor.id];
    },
    getById: l,
    findById: s,
    exists: function(p) {
      return !!s(p);
    },
    getAllByType: function(p) {
      return u1(e.droppables).filter(function(h) {
        return h.descriptor.type === p;
      });
    }
  };
  function u() {
    e.draggables = {}, e.droppables = {}, t.length = 0;
  }
  return {
    draggable: o,
    droppable: c,
    subscribe: r,
    clean: u
  };
}
function H$() {
  var e = Be(V$, []);
  return Me(function() {
    return function() {
      requestAnimationFrame(e.clean);
    };
  }, [e]), e;
}
var Lf = P.createContext(null), fs = function() {
  var e = document.body;
  return e || (process.env.NODE_ENV !== "production" ? Z(!1, "Cannot find document.body") : Z(!1)), e;
}, F$ = {
  position: "absolute",
  width: "1px",
  height: "1px",
  margin: "-1px",
  border: "0",
  padding: "0",
  overflow: "hidden",
  clip: "rect(0 0 0 0)",
  "clip-path": "inset(100%)"
}, W$ = function(t) {
  return "rbd-announcement-" + t;
};
function z$(e) {
  var t = Be(function() {
    return W$(e);
  }, [e]), r = ye(null);
  Me(function() {
    var i = document.createElement("div");
    return r.current = i, i.id = t, i.setAttribute("aria-live", "assertive"), i.setAttribute("aria-atomic", "true"), be(i.style, F$), fs().appendChild(i), function() {
      setTimeout(function() {
        var l = fs();
        l.contains(i) && l.removeChild(i), i === r.current && (r.current = null);
      });
    };
  }, [t]);
  var n = he(function(a) {
    var i = r.current;
    if (i) {
      i.textContent = a;
      return;
    }
    process.env.NODE_ENV !== "production" && dt(`
      A screen reader message was trying to be announced but it was unable to do so.
      This can occur if you unmount your <DragDropContext /> in your onDragEnd.
      Consider calling provided.announce() before the unmount so that the instruction will
      not be lost for users relying on a screen reader.

      Message not passed to screen reader:

      "` + a + `"
    `);
  }, []);
  return n;
}
var U$ = 0, Z$ = {
  separator: "::"
};
function Rf(e, t) {
  return t === void 0 && (t = Z$), Be(function() {
    return "" + e + t.separator + U$++;
  }, [t.separator, e]);
}
function q$(e) {
  var t = e.contextId, r = e.uniqueId;
  return "rbd-hidden-text-" + t + "-" + r;
}
function G$(e) {
  var t = e.contextId, r = e.text, n = Rf("hidden-text", {
    separator: "-"
  }), a = Be(function() {
    return q$({
      contextId: t,
      uniqueId: n
    });
  }, [n, t]);
  return Me(function() {
    var o = document.createElement("div");
    return o.id = a, o.textContent = r, o.style.display = "none", fs().appendChild(o), function() {
      var l = fs();
      l.contains(o) && l.removeChild(o);
    };
  }, [a, r]), a;
}
var Nc = P.createContext(null), Y$ = {
  react: "^16.8.5 || ^17.0.0 || ^18.0.0",
  "react-dom": "^16.8.5 || ^17.0.0 || ^18.0.0"
}, K$ = /(\d+)\.(\d+)\.(\d+)/, J5 = function(t) {
  var r = K$.exec(t);
  r == null && (process.env.NODE_ENV !== "production" ? Z(!1, "Unable to parse React version " + t) : Z(!1));
  var n = Number(r[1]), a = Number(r[2]), i = Number(r[3]);
  return {
    major: n,
    minor: a,
    patch: i,
    raw: t
  };
}, X$ = function(t, r) {
  return r.major > t.major ? !0 : r.major < t.major ? !1 : r.minor > t.minor ? !0 : r.minor < t.minor ? !1 : r.patch >= t.patch;
}, Q$ = function(e, t) {
  var r = J5(e), n = J5(t);
  X$(r, n) || process.env.NODE_ENV !== "production" && dt(`
    React version: [` + n.raw + `]
    does not satisfy expected peer dependency version: [` + r.raw + `]

    This can result in run time bugs, and even fatal crashes
  `);
}, e2 = `
  We expect a html5 doctype: <!doctype html>
  This is to ensure consistent browser layout and measurement

  More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/doctype.md
`, J$ = function(e) {
  var t = e.doctype;
  if (!t) {
    process.env.NODE_ENV !== "production" && dt(`
      No <!doctype html> found.

      ` + e2 + `
    `);
    return;
  }
  t.name.toLowerCase() !== "html" && process.env.NODE_ENV !== "production" && dt(`
      Unexpected <!doctype> found: (` + t.name + `)

      ` + e2 + `
    `), t.publicId !== "" && process.env.NODE_ENV !== "production" && dt(`
      Unexpected <!doctype> publicId found: (` + t.publicId + `)
      A html5 doctype does not have a publicId

      ` + e2 + `
    `);
};
function kf(e) {
  process.env.NODE_ENV !== "production" && e();
}
function al(e, t) {
  kf(function() {
    Me(function() {
      try {
        e();
      } catch (r) {
        r3(`
          A setup problem was encountered.

          > ` + r.message + `
        `);
      }
    }, t);
  });
}
function eN() {
  al(function() {
    Q$(Y$.react, P.version), J$(document);
  }, []);
}
function Bf(e) {
  var t = ye(e);
  return Me(function() {
    t.current = e;
  }), t;
}
function tN() {
  var e = null;
  function t() {
    return !!e;
  }
  function r(o) {
    return o === e;
  }
  function n(o) {
    e && (process.env.NODE_ENV !== "production" ? Z(!1, "Cannot claim lock as it is already claimed") : Z(!1));
    var s = {
      abandon: o
    };
    return e = s, s;
  }
  function a() {
    e || (process.env.NODE_ENV !== "production" ? Z(!1, "Cannot release lock when there is no lock") : Z(!1)), e = null;
  }
  function i() {
    e && (e.abandon(), a());
  }
  return {
    isClaimed: t,
    isActive: r,
    claim: n,
    release: a,
    tryAbandon: i
  };
}
var rN = 9, nN = 13, Vf = 27, Iv = 32, aN = 33, iN = 34, oN = 35, sN = 36, lN = 37, cN = 38, uN = 39, fN = 40, wl, dN = (wl = {}, wl[nN] = !0, wl[rN] = !0, wl), Lv = function(e) {
  dN[e.keyCode] && e.preventDefault();
}, Ic = function() {
  var e = "visibilitychange";
  if (typeof document > "u")
    return e;
  var t = [e, "ms" + e, "webkit" + e, "moz" + e, "o" + e], r = aa(t, function(n) {
    return "on" + n in document;
  });
  return r || e;
}(), Rv = 0, ep = 5;
function pN(e, t) {
  return Math.abs(t.x - e.x) >= ep || Math.abs(t.y - e.y) >= ep;
}
var tp = {
  type: "IDLE"
};
function hN(e) {
  var t = e.cancel, r = e.completed, n = e.getPhase, a = e.setPhase;
  return [{
    eventName: "mousemove",
    fn: function(o) {
      var s = o.button, l = o.clientX, c = o.clientY;
      if (s === Rv) {
        var u = {
          x: l,
          y: c
        }, f = n();
        if (f.type === "DRAGGING") {
          o.preventDefault(), f.actions.move(u);
          return;
        }
        f.type !== "PENDING" && (process.env.NODE_ENV !== "production" ? Z(!1, "Cannot be IDLE") : Z(!1));
        var p = f.point;
        if (pN(p, u)) {
          o.preventDefault();
          var h = f.actions.fluidLift(u);
          a({
            type: "DRAGGING",
            actions: h
          });
        }
      }
    }
  }, {
    eventName: "mouseup",
    fn: function(o) {
      var s = n();
      if (s.type !== "DRAGGING") {
        t();
        return;
      }
      o.preventDefault(), s.actions.drop({
        shouldBlockNextClick: !0
      }), r();
    }
  }, {
    eventName: "mousedown",
    fn: function(o) {
      n().type === "DRAGGING" && o.preventDefault(), t();
    }
  }, {
    eventName: "keydown",
    fn: function(o) {
      var s = n();
      if (s.type === "PENDING") {
        t();
        return;
      }
      if (o.keyCode === Vf) {
        o.preventDefault(), t();
        return;
      }
      Lv(o);
    }
  }, {
    eventName: "resize",
    fn: t
  }, {
    eventName: "scroll",
    options: {
      passive: !0,
      capture: !1
    },
    fn: function() {
      n().type === "PENDING" && t();
    }
  }, {
    eventName: "webkitmouseforcedown",
    fn: function(o) {
      var s = n();
      if (s.type === "IDLE" && (process.env.NODE_ENV !== "production" ? Z(!1, "Unexpected phase") : Z(!1)), s.actions.shouldRespectForcePress()) {
        t();
        return;
      }
      o.preventDefault();
    }
  }, {
    eventName: Ic,
    fn: t
  }];
}
function vN(e) {
  var t = ye(tp), r = ye(Wn), n = Be(function() {
    return {
      eventName: "mousedown",
      fn: function(f) {
        if (!f.defaultPrevented && f.button === Rv && !(f.ctrlKey || f.metaKey || f.shiftKey || f.altKey)) {
          var p = e.findClosestDraggableId(f);
          if (p) {
            var h = e.tryGetLock(p, o, {
              sourceEvent: f
            });
            if (h) {
              f.preventDefault();
              var m = {
                x: f.clientX,
                y: f.clientY
              };
              r.current(), c(h, m);
            }
          }
        }
      }
    };
  }, [e]), a = Be(function() {
    return {
      eventName: "webkitmouseforcewillbegin",
      fn: function(f) {
        if (!f.defaultPrevented) {
          var p = e.findClosestDraggableId(f);
          if (p) {
            var h = e.findOptionsForDraggable(p);
            h && (h.shouldRespectForcePress || e.canGetLock(p) && f.preventDefault());
          }
        }
      }
    };
  }, [e]), i = he(function() {
    var f = {
      passive: !1,
      capture: !0
    };
    r.current = Dr(window, [a, n], f);
  }, [a, n]), o = he(function() {
    var u = t.current;
    u.type !== "IDLE" && (t.current = tp, r.current(), i());
  }, [i]), s = he(function() {
    var u = t.current;
    o(), u.type === "DRAGGING" && u.actions.cancel({
      shouldBlockNextClick: !0
    }), u.type === "PENDING" && u.actions.abort();
  }, [o]), l = he(function() {
    var f = {
      capture: !0,
      passive: !1
    }, p = hN({
      cancel: s,
      completed: o,
      getPhase: function() {
        return t.current;
      },
      setPhase: function(m) {
        t.current = m;
      }
    });
    r.current = Dr(window, p, f);
  }, [s, o]), c = he(function(f, p) {
    t.current.type !== "IDLE" && (process.env.NODE_ENV !== "production" ? Z(!1, "Expected to move from IDLE to PENDING drag") : Z(!1)), t.current = {
      type: "PENDING",
      point: p,
      actions: f
    }, l();
  }, [l]);
  gr(function() {
    return i(), function() {
      r.current();
    };
  }, [i]);
}
var Qa;
function mN() {
}
var gN = (Qa = {}, Qa[iN] = !0, Qa[aN] = !0, Qa[sN] = !0, Qa[oN] = !0, Qa);
function yN(e, t) {
  function r() {
    t(), e.cancel();
  }
  function n() {
    t(), e.drop();
  }
  return [{
    eventName: "keydown",
    fn: function(i) {
      if (i.keyCode === Vf) {
        i.preventDefault(), r();
        return;
      }
      if (i.keyCode === Iv) {
        i.preventDefault(), n();
        return;
      }
      if (i.keyCode === fN) {
        i.preventDefault(), e.moveDown();
        return;
      }
      if (i.keyCode === cN) {
        i.preventDefault(), e.moveUp();
        return;
      }
      if (i.keyCode === uN) {
        i.preventDefault(), e.moveRight();
        return;
      }
      if (i.keyCode === lN) {
        i.preventDefault(), e.moveLeft();
        return;
      }
      if (gN[i.keyCode]) {
        i.preventDefault();
        return;
      }
      Lv(i);
    }
  }, {
    eventName: "mousedown",
    fn: r
  }, {
    eventName: "mouseup",
    fn: r
  }, {
    eventName: "click",
    fn: r
  }, {
    eventName: "touchstart",
    fn: r
  }, {
    eventName: "resize",
    fn: r
  }, {
    eventName: "wheel",
    fn: r,
    options: {
      passive: !0
    }
  }, {
    eventName: Ic,
    fn: r
  }];
}
function bN(e) {
  var t = ye(mN), r = Be(function() {
    return {
      eventName: "keydown",
      fn: function(i) {
        if (i.defaultPrevented || i.keyCode !== Iv)
          return;
        var o = e.findClosestDraggableId(i);
        if (!o)
          return;
        var s = e.tryGetLock(o, u, {
          sourceEvent: i
        });
        if (!s)
          return;
        i.preventDefault();
        var l = !0, c = s.snapLift();
        t.current();
        function u() {
          l || (process.env.NODE_ENV !== "production" ? Z(!1, "Cannot stop capturing a keyboard drag when not capturing") : Z(!1)), l = !1, t.current(), n();
        }
        t.current = Dr(window, yN(c, u), {
          capture: !0,
          passive: !1
        });
      }
    };
  }, [e]), n = he(function() {
    var i = {
      passive: !1,
      capture: !0
    };
    t.current = Dr(window, [r], i);
  }, [r]);
  gr(function() {
    return n(), function() {
      t.current();
    };
  }, [n]);
}
var t2 = {
  type: "IDLE"
}, CN = 120, xN = 0.15;
function wN(e) {
  var t = e.cancel, r = e.getPhase;
  return [{
    eventName: "orientationchange",
    fn: t
  }, {
    eventName: "resize",
    fn: t
  }, {
    eventName: "contextmenu",
    fn: function(a) {
      a.preventDefault();
    }
  }, {
    eventName: "keydown",
    fn: function(a) {
      if (r().type !== "DRAGGING") {
        t();
        return;
      }
      a.keyCode === Vf && a.preventDefault(), t();
    }
  }, {
    eventName: Ic,
    fn: t
  }];
}
function ON(e) {
  var t = e.cancel, r = e.completed, n = e.getPhase;
  return [{
    eventName: "touchmove",
    options: {
      capture: !1
    },
    fn: function(i) {
      var o = n();
      if (o.type !== "DRAGGING") {
        t();
        return;
      }
      o.hasMoved = !0;
      var s = i.touches[0], l = s.clientX, c = s.clientY, u = {
        x: l,
        y: c
      };
      i.preventDefault(), o.actions.move(u);
    }
  }, {
    eventName: "touchend",
    fn: function(i) {
      var o = n();
      if (o.type !== "DRAGGING") {
        t();
        return;
      }
      i.preventDefault(), o.actions.drop({
        shouldBlockNextClick: !0
      }), r();
    }
  }, {
    eventName: "touchcancel",
    fn: function(i) {
      if (n().type !== "DRAGGING") {
        t();
        return;
      }
      i.preventDefault(), t();
    }
  }, {
    eventName: "touchforcechange",
    fn: function(i) {
      var o = n();
      o.type === "IDLE" && (process.env.NODE_ENV, Z(!1));
      var s = i.touches[0];
      if (s) {
        var l = s.force >= xN;
        if (l) {
          var c = o.actions.shouldRespectForcePress();
          if (o.type === "PENDING") {
            c && t();
            return;
          }
          if (c) {
            if (o.hasMoved) {
              i.preventDefault();
              return;
            }
            t();
            return;
          }
          i.preventDefault();
        }
      }
    }
  }, {
    eventName: Ic,
    fn: t
  }];
}
function SN(e) {
  var t = ye(t2), r = ye(Wn), n = he(function() {
    return t.current;
  }, []), a = he(function(h) {
    t.current = h;
  }, []), i = Be(function() {
    return {
      eventName: "touchstart",
      fn: function(h) {
        if (!h.defaultPrevented) {
          var m = e.findClosestDraggableId(h);
          if (m) {
            var v = e.tryGetLock(m, s, {
              sourceEvent: h
            });
            if (v) {
              var g = h.touches[0], y = g.clientX, b = g.clientY, w = {
                x: y,
                y: b
              };
              r.current(), f(v, w);
            }
          }
        }
      }
    };
  }, [e]), o = he(function() {
    var h = {
      capture: !0,
      passive: !1
    };
    r.current = Dr(window, [i], h);
  }, [i]), s = he(function() {
    var p = t.current;
    p.type !== "IDLE" && (p.type === "PENDING" && clearTimeout(p.longPressTimerId), a(t2), r.current(), o());
  }, [o, a]), l = he(function() {
    var p = t.current;
    s(), p.type === "DRAGGING" && p.actions.cancel({
      shouldBlockNextClick: !0
    }), p.type === "PENDING" && p.actions.abort();
  }, [s]), c = he(function() {
    var h = {
      capture: !0,
      passive: !1
    }, m = {
      cancel: l,
      completed: s,
      getPhase: n
    }, v = Dr(window, ON(m), h), g = Dr(window, wN(m), h);
    r.current = function() {
      v(), g();
    };
  }, [l, n, s]), u = he(function() {
    var h = n();
    h.type !== "PENDING" && (process.env.NODE_ENV !== "production" ? Z(!1, "Cannot start dragging from phase " + h.type) : Z(!1));
    var m = h.actions.fluidLift(h.point);
    a({
      type: "DRAGGING",
      actions: m,
      hasMoved: !1
    });
  }, [n, a]), f = he(function(h, m) {
    n().type !== "IDLE" && (process.env.NODE_ENV !== "production" ? Z(!1, "Expected to move from IDLE to PENDING drag") : Z(!1));
    var v = setTimeout(u, CN);
    a({
      type: "PENDING",
      point: m,
      actions: h,
      longPressTimerId: v
    }), c();
  }, [c, n, a, u]);
  gr(function() {
    return o(), function() {
      r.current();
      var m = n();
      m.type === "PENDING" && (clearTimeout(m.longPressTimerId), a(t2));
    };
  }, [n, o, a]), gr(function() {
    var h = Dr(window, [{
      eventName: "touchmove",
      fn: function() {
      },
      options: {
        capture: !1,
        passive: !1
      }
    }]);
    return h;
  }, []);
}
function PN(e) {
  kf(function() {
    var t = Bf(e);
    al(function() {
      t.current.length !== e.length && (process.env.NODE_ENV !== "production" ? Z(!1, "Cannot change the amount of sensor hooks after mounting") : Z(!1));
    });
  });
}
var EN = {
  input: !0,
  button: !0,
  textarea: !0,
  select: !0,
  option: !0,
  optgroup: !0,
  video: !0,
  audio: !0
};
function kv(e, t) {
  if (t == null)
    return !1;
  var r = !!EN[t.tagName.toLowerCase()];
  if (r)
    return !0;
  var n = t.getAttribute("contenteditable");
  return n === "true" || n === "" ? !0 : t === e ? !1 : kv(e, t.parentElement);
}
function jN(e, t) {
  var r = t.target;
  return nl(r) ? kv(e, r) : !1;
}
var _N = function(e) {
  return Wr(e.getBoundingClientRect()).center;
};
function DN(e) {
  return e instanceof $v(e).Element;
}
var AN = function() {
  var e = "matches";
  if (typeof document > "u")
    return e;
  var t = [e, "msMatchesSelector", "webkitMatchesSelector"], r = aa(t, function(n) {
    return n in Element.prototype;
  });
  return r || e;
}();
function Bv(e, t) {
  return e == null ? null : e[AN](t) ? e : Bv(e.parentElement, t);
}
function MN(e, t) {
  return e.closest ? e.closest(t) : Bv(e, t);
}
function TN(e) {
  return "[" + bi.contextId + '="' + e + '"]';
}
function $N(e, t) {
  var r = t.target;
  if (!DN(r))
    return process.env.NODE_ENV !== "production" && dt("event.target must be a Element"), null;
  var n = TN(e), a = MN(r, n);
  return a ? nl(a) ? a : (process.env.NODE_ENV !== "production" && dt("drag handle must be a HTMLElement"), null) : null;
}
function NN(e, t) {
  var r = $N(e, t);
  return r ? r.getAttribute(bi.draggableId) : null;
}
function IN(e, t) {
  var r = "[" + s3.contextId + '="' + e + '"]', n = tv(document.querySelectorAll(r)), a = aa(n, function(i) {
    return i.getAttribute(s3.id) === t;
  });
  return a ? nl(a) ? a : (process.env.NODE_ENV !== "production" && dt("Draggable element is not a HTMLElement"), null) : null;
}
function LN(e) {
  e.preventDefault();
}
function Ol(e) {
  var t = e.expected, r = e.phase, n = e.isLockActive, a = e.shouldWarn;
  return n() ? t !== r ? (a && process.env.NODE_ENV !== "production" && dt(`
        Cannot perform action.
        The actions you used belong to an outdated phase

        Current phase: ` + t + `
        You called an action from outdated phase: ` + r + `

        Tips:

        - Do not use preDragActions actions after calling preDragActions.lift()
      `), !1) : !0 : (a && process.env.NODE_ENV !== "production" && dt(`
        Cannot perform action.
        The sensor no longer has an action lock.

        Tips:

        - Throw away your action handlers when forceStop() is called
        - Check actions.isActive() if you really need to
      `), !1);
}
function Vv(e) {
  var t = e.lockAPI, r = e.store, n = e.registry, a = e.draggableId;
  if (t.isClaimed())
    return !1;
  var i = n.draggable.findById(a);
  return i ? !(!i.options.isEnabled || !Dv(r.getState(), a)) : (process.env.NODE_ENV !== "production" && dt("Unable to find draggable with id: " + a), !1);
}
function RN(e) {
  var t = e.lockAPI, r = e.contextId, n = e.store, a = e.registry, i = e.draggableId, o = e.forceSensorStop, s = e.sourceEvent, l = Vv({
    lockAPI: t,
    store: n,
    registry: a,
    draggableId: i
  });
  if (!l)
    return null;
  var c = a.draggable.getById(i), u = IN(r, c.descriptor.id);
  if (!u)
    return process.env.NODE_ENV !== "production" && dt("Unable to find draggable element with id: " + i), null;
  if (s && !c.options.canDragInteractiveElements && jN(u, s))
    return null;
  var f = t.claim(o || Wn), p = "PRE_DRAG";
  function h() {
    return c.options.shouldRespectForcePress;
  }
  function m() {
    return t.isActive(f);
  }
  function v(S, E) {
    Ol({
      expected: S,
      phase: p,
      isLockActive: m,
      shouldWarn: !0
    }) && n.dispatch(E());
  }
  var g = v.bind(null, "DRAGGING");
  function y(S) {
    function E() {
      t.release(), p = "COMPLETED";
    }
    p !== "PRE_DRAG" && (E(), p !== "PRE_DRAG" && (process.env.NODE_ENV !== "production" ? Z(!1, "Cannot lift in phase " + p) : Z(!1))), n.dispatch(wT(S.liftActionArgs)), p = "DRAGGING";
    function D(I, k) {
      if (k === void 0 && (k = {
        shouldBlockNextClick: !1
      }), S.cleanup(), k.shouldBlockNextClick) {
        var V = Dr(window, [{
          eventName: "click",
          fn: LN,
          options: {
            once: !0,
            passive: !1,
            capture: !0
          }
        }]);
        setTimeout(V);
      }
      E(), n.dispatch(wv({
        reason: I
      }));
    }
    return be({
      isActive: function() {
        return Ol({
          expected: "DRAGGING",
          phase: p,
          isLockActive: m,
          shouldWarn: !1
        });
      },
      shouldRespectForcePress: h,
      drop: function(k) {
        return D("DROP", k);
      },
      cancel: function(k) {
        return D("CANCEL", k);
      }
    }, S.actions);
  }
  function b(S) {
    var E = is(function(I) {
      g(function() {
        return xv({
          client: I
        });
      });
    }), D = y({
      liftActionArgs: {
        id: i,
        clientSelection: S,
        movementMode: "FLUID"
      },
      cleanup: function() {
        return E.cancel();
      },
      actions: {
        move: E
      }
    });
    return be({}, D, {
      move: E
    });
  }
  function w() {
    var S = {
      moveUp: function() {
        return g(MT);
      },
      moveRight: function() {
        return g($T);
      },
      moveDown: function() {
        return g(TT);
      },
      moveLeft: function() {
        return g(NT);
      }
    };
    return y({
      liftActionArgs: {
        id: i,
        clientSelection: _N(u),
        movementMode: "SNAP"
      },
      cleanup: Wn,
      actions: S
    });
  }
  function x() {
    var S = Ol({
      expected: "PRE_DRAG",
      phase: p,
      isLockActive: m,
      shouldWarn: !0
    });
    S && t.release();
  }
  var C = {
    isActive: function() {
      return Ol({
        expected: "PRE_DRAG",
        phase: p,
        isLockActive: m,
        shouldWarn: !1
      });
    },
    shouldRespectForcePress: h,
    fluidLift: b,
    snapLift: w,
    abort: x
  };
  return C;
}
var kN = [vN, bN, SN];
function BN(e) {
  var t = e.contextId, r = e.store, n = e.registry, a = e.customSensors, i = e.enableDefaultSensors, o = [].concat(i ? kN : [], a || []), s = je(function() {
    return tN();
  })[0], l = he(function(b, w) {
    b.isDragging && !w.isDragging && s.tryAbandon();
  }, [s]);
  gr(function() {
    var b = r.getState(), w = r.subscribe(function() {
      var x = r.getState();
      l(b, x), b = x;
    });
    return w;
  }, [s, r, l]), gr(function() {
    return s.tryAbandon;
  }, [s.tryAbandon]);
  var c = he(function(y) {
    return Vv({
      lockAPI: s,
      registry: n,
      store: r,
      draggableId: y
    });
  }, [s, n, r]), u = he(function(y, b, w) {
    return RN({
      lockAPI: s,
      registry: n,
      contextId: t,
      store: r,
      draggableId: y,
      forceSensorStop: b,
      sourceEvent: w && w.sourceEvent ? w.sourceEvent : null
    });
  }, [t, s, n, r]), f = he(function(y) {
    return NN(t, y);
  }, [t]), p = he(function(y) {
    var b = n.draggable.findById(y);
    return b ? b.options : null;
  }, [n.draggable]), h = he(function() {
    s.isClaimed() && (s.tryAbandon(), r.getState().phase !== "IDLE" && r.dispatch(_f()));
  }, [s, r]), m = he(s.isClaimed, [s]), v = Be(function() {
    return {
      canGetLock: c,
      tryGetLock: u,
      findClosestDraggableId: f,
      findOptionsForDraggable: p,
      tryReleaseLock: h,
      isLockClaimed: m
    };
  }, [c, u, f, p, h, m]);
  PN(o);
  for (var g = 0; g < o.length; g++)
    o[g](v);
}
var VN = function(t) {
  return {
    onBeforeCapture: t.onBeforeCapture,
    onBeforeDragStart: t.onBeforeDragStart,
    onDragStart: t.onDragStart,
    onDragEnd: t.onDragEnd,
    onDragUpdate: t.onDragUpdate
  };
};
function xo(e) {
  return e.current || (process.env.NODE_ENV !== "production" ? Z(!1, "Could not find store from lazy ref") : Z(!1)), e.current;
}
function HN(e) {
  var t = e.contextId, r = e.setCallbacks, n = e.sensors, a = e.nonce, i = e.dragHandleUsageInstructions, o = ye(null);
  eN();
  var s = Bf(e), l = he(function() {
    return VN(s.current);
  }, [s]), c = z$(t), u = G$({
    contextId: t,
    text: i
  }), f = k$(t, a), p = he(function(I) {
    xo(o).dispatch(I);
  }, []), h = Be(function() {
    return m5({
      publishWhileDragging: ST,
      updateDroppableScroll: ET,
      updateDroppableIsEnabled: jT,
      updateDroppableIsCombineEnabled: _T,
      collectionStarting: PT
    }, p);
  }, [p]), m = H$(), v = Be(function() {
    return m$(m, h);
  }, [m, h]), g = Be(function() {
    return $$(be({
      scrollWindow: g$,
      scrollDroppable: v.scrollDroppable
    }, m5({
      move: xv
    }, p)));
  }, [v.scrollDroppable, p]), y = B$(t), b = Be(function() {
    return d$({
      announce: c,
      autoScroller: g,
      dimensionMarshal: v,
      focusMarshal: y,
      getResponders: l,
      styleMarshal: f
    });
  }, [c, g, v, y, l, f]);
  process.env.NODE_ENV !== "production" && o.current && o.current !== b && process.env.NODE_ENV !== "production" && dt("unexpected store change"), o.current = b;
  var w = he(function() {
    var I = xo(o), k = I.getState();
    k.phase !== "IDLE" && I.dispatch(_f());
  }, []), x = he(function() {
    var I = xo(o).getState();
    return I.isDragging || I.phase === "DROP_ANIMATING";
  }, []), C = Be(function() {
    return {
      isDragging: x,
      tryAbort: w
    };
  }, [x, w]);
  r(C);
  var S = he(function(I) {
    return Dv(xo(o).getState(), I);
  }, []), E = he(function() {
    return Ca(xo(o).getState());
  }, []), D = Be(function() {
    return {
      marshal: v,
      focus: y,
      contextId: t,
      canLift: S,
      isMovementAllowed: E,
      dragHandleUsageInstructionsId: u,
      registry: m
    };
  }, [t, v, u, y, S, E, m]);
  return BN({
    contextId: t,
    store: b,
    registry: m,
    customSensors: n,
    enableDefaultSensors: e.enableDefaultSensors !== !1
  }), Me(function() {
    return w;
  }, [w]), P.createElement(Nc.Provider, {
    value: D
  }, P.createElement(Hh, {
    context: Lf,
    store: b
  }, e.children));
}
var FN = 0;
function WN() {
  return Be(function() {
    return "" + FN++;
  }, []);
}
function zN(e) {
  var t = WN(), r = e.dragHandleUsageInstructions || Hl.dragHandleUsageInstructions;
  return P.createElement(fM, null, function(n) {
    return P.createElement(HN, {
      nonce: e.nonce,
      contextId: t,
      setCallbacks: n,
      dragHandleUsageInstructions: r,
      enableDefaultSensors: e.enableDefaultSensors,
      sensors: e.sensors,
      onBeforeCapture: e.onBeforeCapture,
      onBeforeDragStart: e.onBeforeDragStart,
      onDragStart: e.onDragStart,
      onDragUpdate: e.onDragUpdate,
      onDragEnd: e.onDragEnd
    }, e.children);
  });
}
var Hf = function(t) {
  return function(r) {
    return t === r;
  };
}, UN = Hf("scroll"), ZN = Hf("auto"), qN = Hf("visible"), rp = function(t, r) {
  return r(t.overflowX) || r(t.overflowY);
}, GN = function(t, r) {
  return r(t.overflowX) && r(t.overflowY);
}, Hv = function(t) {
  var r = window.getComputedStyle(t), n = {
    overflowX: r.overflowX,
    overflowY: r.overflowY
  };
  return rp(n, UN) || rp(n, ZN);
}, YN = function() {
  if (process.env.NODE_ENV === "production")
    return !1;
  var t = fs(), r = document.documentElement;
  if (r || (process.env.NODE_ENV, Z(!1)), !Hv(t))
    return !1;
  var n = window.getComputedStyle(r), a = {
    overflowX: n.overflowX,
    overflowY: n.overflowY
  };
  return GN(a, qN) || process.env.NODE_ENV !== "production" && dt(`
    We have detected that your <body> element might be a scroll container.
    We have found no reliable way of detecting whether the <body> element is a scroll container.
    Under most circumstances a <body> scroll bar will be on the <html> element (document.documentElement)

    Because we cannot determine if the <body> is a scroll container, and generally it is not one,
    we will be treating the <body> as *not* a scroll container

    More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/how-we-detect-scroll-containers.md
  `), !1;
}, Fv = function e(t) {
  return t == null ? null : t === document.body ? YN() ? t : null : t === document.documentElement ? null : Hv(t) ? t : e(t.parentElement);
}, KN = function(e) {
  if (e) {
    var t = Fv(e.parentElement);
    t && process.env.NODE_ENV !== "production" && dt(`
    Droppable: unsupported nested scroll container detected.
    A Droppable can only have one scroll parent (which can be itself)
    Nested scroll containers are currently not supported.

    We hope to support nested scroll containers soon: https://github.com/atlassian/react-beautiful-dnd/issues/131
  `);
  }
}, l3 = function(e) {
  return {
    x: e.scrollLeft,
    y: e.scrollTop
  };
}, XN = function e(t) {
  if (!t)
    return !1;
  var r = window.getComputedStyle(t);
  return r.position === "fixed" ? !0 : e(t.parentElement);
}, QN = function(e) {
  var t = Fv(e), r = XN(e);
  return {
    closestScrollable: t,
    isFixedOnPage: r
  };
}, JN = function(e) {
  var t = e.descriptor, r = e.isEnabled, n = e.isCombineEnabled, a = e.isFixedOnPage, i = e.direction, o = e.client, s = e.page, l = e.closest, c = function() {
    if (!l)
      return null;
    var h = l.scrollSize, m = l.client, v = Ev({
      scrollHeight: h.scrollHeight,
      scrollWidth: h.scrollWidth,
      height: m.paddingBox.height,
      width: m.paddingBox.width
    });
    return {
      pageMarginBox: l.page.marginBox,
      frameClient: m,
      scrollSize: h,
      shouldClipSubject: l.shouldClipSubject,
      scroll: {
        initial: l.scroll,
        current: l.scroll,
        max: v,
        diff: {
          value: Ht,
          displacement: Ht
        }
      }
    };
  }(), u = i === "vertical" ? Of : ov, f = gi({
    page: s,
    withPlaceholder: null,
    axis: u,
    frame: c
  }), p = {
    descriptor: t,
    isCombineEnabled: n,
    isFixedOnPage: a,
    axis: u,
    isEnabled: r,
    client: o,
    page: s,
    frame: c,
    subject: f
  };
  return p;
}, eI = function(t, r) {
  var n = Kh(t);
  if (!r || t !== r)
    return n;
  var a = n.paddingBox.top - r.scrollTop, i = n.paddingBox.left - r.scrollLeft, o = a + r.scrollHeight, s = i + r.scrollWidth, l = {
    top: a,
    right: s,
    bottom: o,
    left: i
  }, c = yf(l, n.border), u = bf({
    borderBox: c,
    margin: n.margin,
    border: n.border,
    padding: n.padding
  });
  return u;
}, tI = function(e) {
  var t = e.ref, r = e.descriptor, n = e.env, a = e.windowScroll, i = e.direction, o = e.isDropDisabled, s = e.isCombineEnabled, l = e.shouldClipSubject, c = n.closestScrollable, u = eI(t, c), f = l1(u, a), p = function() {
    if (!c)
      return null;
    var m = Kh(c), v = {
      scrollHeight: c.scrollHeight,
      scrollWidth: c.scrollWidth
    };
    return {
      client: m,
      page: l1(m, a),
      scroll: l3(c),
      scrollSize: v,
      shouldClipSubject: l
    };
  }(), h = JN({
    descriptor: r,
    isEnabled: !o,
    isCombineEnabled: s,
    isFixedOnPage: n.isFixedOnPage,
    direction: i,
    client: u,
    page: f,
    closest: p
  });
  return h;
}, rI = {
  passive: !1
}, nI = {
  passive: !0
}, np = function(e) {
  return e.shouldPublishImmediately ? rI : nI;
};
function d1(e) {
  var t = _t(e);
  return t || (process.env.NODE_ENV !== "production" ? Z(!1, "Could not find required context") : Z(!1)), t;
}
var Sl = function(t) {
  return t && t.env.closestScrollable || null;
};
function aI(e) {
  var t = ye(null), r = d1(Nc), n = Rf("droppable"), a = r.registry, i = r.marshal, o = Bf(e), s = Be(function() {
    return {
      id: e.droppableId,
      type: e.type,
      mode: e.mode
    };
  }, [e.droppableId, e.mode, e.type]), l = ye(s), c = Be(function() {
    return Vt(function(x, C) {
      t.current || (process.env.NODE_ENV !== "production" ? Z(!1, "Can only update scroll when dragging") : Z(!1));
      var S = {
        x,
        y: C
      };
      i.updateDroppableScroll(s.id, S);
    });
  }, [s.id, i]), u = he(function() {
    var x = t.current;
    return !x || !x.env.closestScrollable ? Ht : l3(x.env.closestScrollable);
  }, []), f = he(function() {
    var x = u();
    c(x.x, x.y);
  }, [u, c]), p = Be(function() {
    return is(f);
  }, [f]), h = he(function() {
    var x = t.current, C = Sl(x);
    x && C || (process.env.NODE_ENV !== "production" ? Z(!1, "Could not find scroll options while scrolling") : Z(!1));
    var S = x.scrollOptions;
    if (S.shouldPublishImmediately) {
      f();
      return;
    }
    p();
  }, [p, f]), m = he(function(x, C) {
    t.current && (process.env.NODE_ENV !== "production" ? Z(!1, "Cannot collect a droppable while a drag is occurring") : Z(!1));
    var S = o.current, E = S.getDroppableRef();
    E || (process.env.NODE_ENV !== "production" ? Z(!1, "Cannot collect without a droppable ref") : Z(!1));
    var D = QN(E), I = {
      ref: E,
      descriptor: s,
      env: D,
      scrollOptions: C
    };
    t.current = I;
    var k = tI({
      ref: E,
      descriptor: s,
      env: D,
      windowScroll: x,
      direction: S.direction,
      isDropDisabled: S.isDropDisabled,
      isCombineEnabled: S.isCombineEnabled,
      shouldClipSubject: !S.ignoreContainerClipping
    }), V = D.closestScrollable;
    return V && (V.setAttribute(X5.contextId, r.contextId), V.addEventListener("scroll", h, np(I.scrollOptions)), process.env.NODE_ENV !== "production" && KN(V)), k;
  }, [r.contextId, s, h, o]), v = he(function() {
    var x = t.current, C = Sl(x);
    return x && C || (process.env.NODE_ENV !== "production" ? Z(!1, "Can only recollect Droppable client for Droppables that have a scroll container") : Z(!1)), l3(C);
  }, []), g = he(function() {
    var x = t.current;
    x || (process.env.NODE_ENV !== "production" ? Z(!1, "Cannot stop drag when no active drag") : Z(!1));
    var C = Sl(x);
    t.current = null, C && (p.cancel(), C.removeAttribute(X5.contextId), C.removeEventListener("scroll", h, np(x.scrollOptions)));
  }, [h, p]), y = he(function(x) {
    var C = t.current;
    C || (process.env.NODE_ENV !== "production" ? Z(!1, "Cannot scroll when there is no drag") : Z(!1));
    var S = Sl(C);
    S || (process.env.NODE_ENV !== "production" ? Z(!1, "Cannot scroll a droppable with no closest scrollable") : Z(!1)), S.scrollTop += x.y, S.scrollLeft += x.x;
  }, []), b = Be(function() {
    return {
      getDimensionAndWatchScroll: m,
      getScrollWhileDragging: v,
      dragStopped: g,
      scroll: y
    };
  }, [g, m, v, y]), w = Be(function() {
    return {
      uniqueId: n,
      descriptor: s,
      callbacks: b
    };
  }, [b, s, n]);
  gr(function() {
    return l.current = w.descriptor, a.droppable.register(w), function() {
      t.current && (process.env.NODE_ENV !== "production" && dt("Unsupported: changing the droppableId or type of a Droppable during a drag"), g()), a.droppable.unregister(w);
    };
  }, [b, s, g, w, i, a.droppable]), gr(function() {
    t.current && i.updateDroppableIsEnabled(l.current.id, !e.isDropDisabled);
  }, [e.isDropDisabled, i]), gr(function() {
    t.current && i.updateDroppableIsCombineEnabled(l.current.id, e.isCombineEnabled);
  }, [e.isCombineEnabled, i]);
}
function r2() {
}
var ap = {
  width: 0,
  height: 0,
  margin: gM
}, iI = function(t) {
  var r = t.isAnimatingOpenOnMount, n = t.placeholder, a = t.animate;
  return r || a === "close" ? ap : {
    height: n.client.borderBox.height,
    width: n.client.borderBox.width,
    margin: n.client.margin
  };
}, oI = function(t) {
  var r = t.isAnimatingOpenOnMount, n = t.placeholder, a = t.animate, i = iI({
    isAnimatingOpenOnMount: r,
    placeholder: n,
    animate: a
  });
  return {
    display: n.display,
    boxSizing: "border-box",
    width: i.width,
    height: i.height,
    marginTop: i.margin.top,
    marginRight: i.margin.right,
    marginBottom: i.margin.bottom,
    marginLeft: i.margin.left,
    flexShrink: "0",
    flexGrow: "0",
    pointerEvents: "none",
    transition: a !== "none" ? Zo.placeholder : null
  };
};
function sI(e) {
  var t = ye(null), r = he(function() {
    t.current && (clearTimeout(t.current), t.current = null);
  }, []), n = e.animate, a = e.onTransitionEnd, i = e.onClose, o = e.contextId, s = je(e.animate === "open"), l = s[0], c = s[1];
  Me(function() {
    return l ? n !== "open" ? (r(), c(!1), r2) : t.current ? r2 : (t.current = setTimeout(function() {
      t.current = null, c(!1);
    }), r) : r2;
  }, [n, l, r]);
  var u = he(function(p) {
    p.propertyName === "height" && (a(), n === "close" && i());
  }, [n, i, a]), f = oI({
    isAnimatingOpenOnMount: l,
    animate: e.animate,
    placeholder: e.placeholder
  });
  return P.createElement(e.placeholder.tagName, {
    style: f,
    "data-rbd-placeholder-context-id": o,
    onTransitionEnd: u,
    ref: e.innerRef
  });
}
var lI = P.memo(sI), Ff = P.createContext(null);
function Wv(e) {
  e && nl(e) || (process.env.NODE_ENV !== "production" ? Z(!1, `
    provided.innerRef has not been provided with a HTMLElement.

    You can find a guide on using the innerRef callback functions at:
    https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/using-inner-ref.md
  `) : Z(!1));
}
function n2(e) {
  return typeof e == "boolean";
}
function a2(e, t) {
  t.forEach(function(r) {
    return r(e);
  });
}
var cI = [function(t) {
  var r = t.props;
  r.droppableId || (process.env.NODE_ENV !== "production" ? Z(!1, "A Droppable requires a droppableId prop") : Z(!1)), typeof r.droppableId != "string" && (process.env.NODE_ENV !== "production" ? Z(!1, "A Droppable requires a [string] droppableId. Provided: [" + typeof r.droppableId + "]") : Z(!1));
}, function(t) {
  var r = t.props;
  n2(r.isDropDisabled) || (process.env.NODE_ENV !== "production" ? Z(!1, "isDropDisabled must be a boolean") : Z(!1)), n2(r.isCombineEnabled) || (process.env.NODE_ENV !== "production" ? Z(!1, "isCombineEnabled must be a boolean") : Z(!1)), n2(r.ignoreContainerClipping) || (process.env.NODE_ENV !== "production" ? Z(!1, "ignoreContainerClipping must be a boolean") : Z(!1));
}, function(t) {
  var r = t.getDroppableRef;
  Wv(r());
}], uI = [function(t) {
  var r = t.props, n = t.getPlaceholderRef;
  if (r.placeholder) {
    var a = n();
    a || process.env.NODE_ENV !== "production" && dt(`
      Droppable setup issue [droppableId: "` + r.droppableId + `"]:
      DroppableProvided > placeholder could not be found.

      Please be sure to add the {provided.placeholder} React Node as a child of your Droppable.
      More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/api/droppable.md
    `);
  }
}], fI = [function(t) {
  var r = t.props;
  r.renderClone || (process.env.NODE_ENV !== "production" ? Z(!1, "Must provide a clone render function (renderClone) for virtual lists") : Z(!1));
}, function(t) {
  var r = t.getPlaceholderRef;
  r() && (process.env.NODE_ENV !== "production" ? Z(!1, "Expected virtual list to not have a placeholder") : Z(!1));
}];
function dI(e) {
  al(function() {
    a2(e, cI), e.props.mode === "standard" && a2(e, uI), e.props.mode === "virtual" && a2(e, fI);
  });
}
var pI = function(e) {
  Ih(t, e);
  function t() {
    for (var n, a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = e.call.apply(e, [this].concat(i)) || this, n.state = {
      isVisible: !!n.props.on,
      data: n.props.on,
      animate: n.props.shouldAnimate && n.props.on ? "open" : "none"
    }, n.onClose = function() {
      n.state.animate === "close" && n.setState({
        isVisible: !1
      });
    }, n;
  }
  t.getDerivedStateFromProps = function(a, i) {
    return a.shouldAnimate ? a.on ? {
      isVisible: !0,
      data: a.on,
      animate: "open"
    } : i.isVisible ? {
      isVisible: !0,
      data: i.data,
      animate: "close"
    } : {
      isVisible: !1,
      animate: "close",
      data: null
    } : {
      isVisible: !!a.on,
      data: a.on,
      animate: "none"
    };
  };
  var r = t.prototype;
  return r.render = function() {
    if (!this.state.isVisible)
      return null;
    var a = {
      onClose: this.onClose,
      data: this.state.data,
      animate: this.state.animate
    };
    return this.props.children(a);
  }, t;
}(P.PureComponent), ip = {
  dragging: 5e3,
  dropAnimating: 4500
}, hI = function(t, r) {
  return r ? Zo.drop(r.duration) : t ? Zo.snap : Zo.fluid;
}, vI = function(t, r) {
  return t ? r ? us.opacity.drop : us.opacity.combining : null;
}, mI = function(t) {
  return t.forceShouldAnimate != null ? t.forceShouldAnimate : t.mode === "SNAP";
};
function gI(e) {
  var t = e.dimension, r = t.client, n = e.offset, a = e.combineWith, i = e.dropping, o = !!a, s = mI(e), l = !!i, c = l ? i3.drop(n, o) : i3.moveTo(n), u = {
    position: "fixed",
    top: r.marginBox.top,
    left: r.marginBox.left,
    boxSizing: "border-box",
    width: r.borderBox.width,
    height: r.borderBox.height,
    transition: hI(s, i),
    transform: c,
    opacity: vI(o, l),
    zIndex: l ? ip.dropAnimating : ip.dragging,
    pointerEvents: "none"
  };
  return u;
}
function yI(e) {
  return {
    transform: i3.moveTo(e.offset),
    transition: e.shouldAnimateDisplacement ? null : "none"
  };
}
function bI(e) {
  return e.type === "DRAGGING" ? gI(e) : yI(e);
}
function CI(e, t, r) {
  r === void 0 && (r = Ht);
  var n = window.getComputedStyle(t), a = t.getBoundingClientRect(), i = Yh(a, n), o = l1(i, r), s = {
    client: i,
    tagName: t.tagName.toLowerCase(),
    display: n.display
  }, l = {
    x: i.marginBox.width,
    y: i.marginBox.height
  }, c = {
    descriptor: e,
    placeholder: s,
    displaceBy: l,
    client: i,
    page: o
  };
  return c;
}
function xI(e) {
  var t = Rf("draggable"), r = e.descriptor, n = e.registry, a = e.getDraggableRef, i = e.canDragInteractiveElements, o = e.shouldRespectForcePress, s = e.isEnabled, l = Be(function() {
    return {
      canDragInteractiveElements: i,
      shouldRespectForcePress: o,
      isEnabled: s
    };
  }, [i, s, o]), c = he(function(h) {
    var m = a();
    return m || (process.env.NODE_ENV !== "production" ? Z(!1, "Cannot get dimension when no ref is set") : Z(!1)), CI(r, m, h);
  }, [r, a]), u = Be(function() {
    return {
      uniqueId: t,
      descriptor: r,
      options: l,
      getDimension: c
    };
  }, [r, c, l, t]), f = ye(u), p = ye(!0);
  gr(function() {
    return n.draggable.register(f.current), function() {
      return n.draggable.unregister(f.current);
    };
  }, [n.draggable]), gr(function() {
    if (p.current) {
      p.current = !1;
      return;
    }
    var h = f.current;
    f.current = u, n.draggable.update(u, h);
  }, [u, n.draggable]);
}
function wI(e, t, r) {
  al(function() {
    function n(i) {
      return "Draggable[id: " + i + "]: ";
    }
    var a = e.draggableId;
    a || (process.env.NODE_ENV !== "production" ? Z(!1, "Draggable requires a draggableId") : Z(!1)), typeof a != "string" && (process.env.NODE_ENV !== "production" ? Z(!1, `Draggable requires a [string] draggableId.
      Provided: [type: ` + typeof a + "] (value: " + a + ")") : Z(!1)), xM(e.index) || (process.env.NODE_ENV !== "production" ? Z(!1, n(a) + " requires an integer index prop") : Z(!1)), e.mapped.type !== "DRAGGING" && (Wv(r()), e.isEnabled && (Nv(t, a) || (process.env.NODE_ENV !== "production" ? Z(!1, n(a) + " Unable to find drag handle") : Z(!1))));
  });
}
function OI(e) {
  kf(function() {
    var t = ye(e);
    al(function() {
      e !== t.current && (process.env.NODE_ENV !== "production" ? Z(!1, "Draggable isClone prop value changed during component life") : Z(!1));
    }, [e]);
  });
}
function SI(e) {
  e.preventDefault();
}
function PI(e) {
  var t = ye(null), r = he(function(I) {
    t.current = I;
  }, []), n = he(function() {
    return t.current;
  }, []), a = d1(Nc), i = a.contextId, o = a.dragHandleUsageInstructionsId, s = a.registry, l = d1(Ff), c = l.type, u = l.droppableId, f = Be(function() {
    return {
      id: e.draggableId,
      index: e.index,
      type: c,
      droppableId: u
    };
  }, [e.draggableId, e.index, c, u]), p = e.children, h = e.draggableId, m = e.isEnabled, v = e.shouldRespectForcePress, g = e.canDragInteractiveElements, y = e.isClone, b = e.mapped, w = e.dropAnimationFinished;
  if (wI(e, i, n), OI(y), !y) {
    var x = Be(function() {
      return {
        descriptor: f,
        registry: s,
        getDraggableRef: n,
        canDragInteractiveElements: g,
        shouldRespectForcePress: v,
        isEnabled: m
      };
    }, [f, s, n, g, v, m]);
    xI(x);
  }
  var C = Be(function() {
    return m ? {
      tabIndex: 0,
      role: "button",
      "aria-describedby": o,
      "data-rbd-drag-handle-draggable-id": h,
      "data-rbd-drag-handle-context-id": i,
      draggable: !1,
      onDragStart: SI
    } : null;
  }, [i, o, h, m]), S = he(function(I) {
    b.type === "DRAGGING" && b.dropping && I.propertyName === "transform" && w();
  }, [w, b]), E = Be(function() {
    var I = bI(b), k = b.type === "DRAGGING" && b.dropping ? S : null, V = {
      innerRef: r,
      draggableProps: {
        "data-rbd-draggable-context-id": i,
        "data-rbd-draggable-id": h,
        style: I,
        onTransitionEnd: k
      },
      dragHandleProps: C
    };
    return V;
  }, [i, C, h, b, S, r]), D = Be(function() {
    return {
      draggableId: f.id,
      type: f.type,
      source: {
        index: f.index,
        droppableId: f.droppableId
      }
    };
  }, [f.droppableId, f.id, f.index, f.type]);
  return p(E, b.snapshot, D);
}
var zv = function(e, t) {
  return e === t;
}, Uv = function(e) {
  var t = e.combine, r = e.destination;
  return r ? r.droppableId : t ? t.droppableId : null;
}, EI = function(t) {
  return t.combine ? t.combine.draggableId : null;
}, jI = function(t) {
  return t.at && t.at.type === "COMBINE" ? t.at.combine.draggableId : null;
};
function _I() {
  var e = Vt(function(a, i) {
    return {
      x: a,
      y: i
    };
  }), t = Vt(function(a, i, o, s, l) {
    return {
      isDragging: !0,
      isClone: i,
      isDropAnimating: !!l,
      dropAnimation: l,
      mode: a,
      draggingOver: o,
      combineWith: s,
      combineTargetFor: null
    };
  }), r = Vt(function(a, i, o, s, l, c, u) {
    return {
      mapped: {
        type: "DRAGGING",
        dropping: null,
        draggingOver: l,
        combineWith: c,
        mode: i,
        offset: a,
        dimension: o,
        forceShouldAnimate: u,
        snapshot: t(i, s, l, c, null)
      }
    };
  }), n = function(i, o) {
    if (i.isDragging) {
      if (i.critical.draggable.id !== o.draggableId)
        return null;
      var s = i.current.client.offset, l = i.dimensions.draggables[o.draggableId], c = mr(i.impact), u = jI(i.impact), f = i.forceShouldAnimate;
      return r(e(s.x, s.y), i.movementMode, l, o.isClone, c, u, f);
    }
    if (i.phase === "DROP_ANIMATING") {
      var p = i.completed;
      if (p.result.draggableId !== o.draggableId)
        return null;
      var h = o.isClone, m = i.dimensions.draggables[o.draggableId], v = p.result, g = v.mode, y = Uv(v), b = EI(v), w = i.dropDuration, x = {
        duration: w,
        curve: Af.drop,
        moveTo: i.newHomeClientOffset,
        opacity: b ? us.opacity.drop : null,
        scale: b ? us.scale.drop : null
      };
      return {
        mapped: {
          type: "DRAGGING",
          offset: i.newHomeClientOffset,
          dimension: m,
          dropping: x,
          draggingOver: y,
          combineWith: b,
          mode: g,
          forceShouldAnimate: null,
          snapshot: t(g, h, y, b, x)
        }
      };
    }
    return null;
  };
  return n;
}
function Zv(e) {
  return {
    isDragging: !1,
    isDropAnimating: !1,
    isClone: !1,
    dropAnimation: null,
    mode: null,
    draggingOver: null,
    combineTargetFor: e,
    combineWith: null
  };
}
var DI = {
  mapped: {
    type: "SECONDARY",
    offset: Ht,
    combineTargetFor: null,
    shouldAnimateDisplacement: !0,
    snapshot: Zv(null)
  }
};
function AI() {
  var e = Vt(function(o, s) {
    return {
      x: o,
      y: s
    };
  }), t = Vt(Zv), r = Vt(function(o, s, l) {
    return s === void 0 && (s = null), {
      mapped: {
        type: "SECONDARY",
        offset: o,
        combineTargetFor: s,
        shouldAnimateDisplacement: l,
        snapshot: t(s)
      }
    };
  }), n = function(s) {
    return s ? r(Ht, s, !0) : null;
  }, a = function(s, l, c, u) {
    var f = c.displaced.visible[s], p = !!(u.inVirtualList && u.effected[s]), h = Mc(c), m = h && h.draggableId === s ? l : null;
    if (!f) {
      if (!p)
        return n(m);
      if (c.displaced.invisible[s])
        return null;
      var v = Xi(u.displacedBy.point), g = e(v.x, v.y);
      return r(g, m, !0);
    }
    if (p)
      return n(m);
    var y = c.displacedBy.point, b = e(y.x, y.y);
    return r(b, m, f.shouldAnimate);
  }, i = function(s, l) {
    if (s.isDragging)
      return s.critical.draggable.id === l.draggableId ? null : a(l.draggableId, s.critical.draggable.id, s.impact, s.afterCritical);
    if (s.phase === "DROP_ANIMATING") {
      var c = s.completed;
      return c.result.draggableId === l.draggableId ? null : a(l.draggableId, c.result.draggableId, c.impact, c.afterCritical);
    }
    return null;
  };
  return i;
}
var MI = function() {
  var t = _I(), r = AI(), n = function(i, o) {
    return t(i, o) || r(i, o) || DI;
  };
  return n;
}, TI = {
  dropAnimationFinished: Ov
}, $I = qh(MI, TI, null, {
  context: Lf,
  pure: !0,
  areStatePropsEqual: zv
})(PI);
function qv(e) {
  var t = d1(Ff), r = t.isUsingCloneFor;
  return r === e.draggableId && !e.isClone ? null : P.createElement($I, e);
}
function NI(e) {
  var t = typeof e.isDragDisabled == "boolean" ? !e.isDragDisabled : !0, r = !!e.disableInteractiveElementBlocking, n = !!e.shouldRespectForcePress;
  return P.createElement(qv, be({}, e, {
    isClone: !1,
    isEnabled: t,
    canDragInteractiveElements: r,
    shouldRespectForcePress: n
  }));
}
function II(e) {
  var t = _t(Nc);
  t || (process.env.NODE_ENV !== "production" ? Z(!1, "Could not find app context") : Z(!1));
  var r = t.contextId, n = t.isMovementAllowed, a = ye(null), i = ye(null), o = e.children, s = e.droppableId, l = e.type, c = e.mode, u = e.direction, f = e.ignoreContainerClipping, p = e.isDropDisabled, h = e.isCombineEnabled, m = e.snapshot, v = e.useClone, g = e.updateViewportMaxScroll, y = e.getContainerForClone, b = he(function() {
    return a.current;
  }, []), w = he(function(W) {
    a.current = W;
  }, []), x = he(function() {
    return i.current;
  }, []), C = he(function(W) {
    i.current = W;
  }, []);
  dI({
    props: e,
    getDroppableRef: b,
    getPlaceholderRef: x
  });
  var S = he(function() {
    n() && g({
      maxScroll: _v()
    });
  }, [n, g]);
  aI({
    droppableId: s,
    type: l,
    mode: c,
    direction: u,
    isDropDisabled: p,
    isCombineEnabled: h,
    ignoreContainerClipping: f,
    getDroppableRef: b
  });
  var E = P.createElement(pI, {
    on: e.placeholder,
    shouldAnimate: e.shouldAnimatePlaceholder
  }, function(W) {
    var L = W.onClose, G = W.data, Q = W.animate;
    return P.createElement(lI, {
      placeholder: G,
      onClose: L,
      innerRef: C,
      animate: Q,
      contextId: r,
      onTransitionEnd: S
    });
  }), D = Be(function() {
    return {
      innerRef: w,
      placeholder: E,
      droppableProps: {
        "data-rbd-droppable-id": s,
        "data-rbd-droppable-context-id": r
      }
    };
  }, [r, s, E, w]), I = v ? v.dragging.draggableId : null, k = Be(function() {
    return {
      droppableId: s,
      type: l,
      isUsingCloneFor: I
    };
  }, [s, I, l]);
  function V() {
    if (!v)
      return null;
    var W = v.dragging, L = v.render, G = P.createElement(qv, {
      draggableId: W.draggableId,
      index: W.source.index,
      isClone: !0,
      isEnabled: !0,
      shouldRespectForcePress: !1,
      canDragInteractiveElements: !0
    }, function(Q, X) {
      return L(Q, X, W);
    });
    return z0.createPortal(G, y());
  }
  return P.createElement(Ff.Provider, {
    value: k
  }, o(D, m), V());
}
var i2 = function(t, r) {
  return t === r.droppable.type;
}, op = function(t, r) {
  return r.draggables[t.draggable.id];
}, LI = function() {
  var t = {
    placeholder: null,
    shouldAnimatePlaceholder: !0,
    snapshot: {
      isDraggingOver: !1,
      draggingOverWith: null,
      draggingFromThisWith: null,
      isUsingPlaceholder: !1
    },
    useClone: null
  }, r = be({}, t, {
    shouldAnimatePlaceholder: !1
  }), n = Vt(function(o) {
    return {
      draggableId: o.id,
      type: o.type,
      source: {
        index: o.index,
        droppableId: o.droppableId
      }
    };
  }), a = Vt(function(o, s, l, c, u, f) {
    var p = u.descriptor.id, h = u.descriptor.droppableId === o;
    if (h) {
      var m = f ? {
        render: f,
        dragging: n(u.descriptor)
      } : null, v = {
        isDraggingOver: l,
        draggingOverWith: l ? p : null,
        draggingFromThisWith: p,
        isUsingPlaceholder: !0
      };
      return {
        placeholder: u.placeholder,
        shouldAnimatePlaceholder: !1,
        snapshot: v,
        useClone: m
      };
    }
    if (!s)
      return r;
    if (!c)
      return t;
    var g = {
      isDraggingOver: l,
      draggingOverWith: p,
      draggingFromThisWith: null,
      isUsingPlaceholder: !0
    };
    return {
      placeholder: u.placeholder,
      shouldAnimatePlaceholder: !0,
      snapshot: g,
      useClone: null
    };
  }), i = function(s, l) {
    var c = l.droppableId, u = l.type, f = !l.isDropDisabled, p = l.renderClone;
    if (s.isDragging) {
      var h = s.critical;
      if (!i2(u, h))
        return r;
      var m = op(h, s.dimensions), v = mr(s.impact) === c;
      return a(c, f, v, v, m, p);
    }
    if (s.phase === "DROP_ANIMATING") {
      var g = s.completed;
      if (!i2(u, g.critical))
        return r;
      var y = op(g.critical, s.dimensions);
      return a(c, f, Uv(g.result) === c, mr(g.impact) === c, y, p);
    }
    if (s.phase === "IDLE" && s.completed && !s.shouldFlush) {
      var b = s.completed;
      if (!i2(u, b.critical))
        return r;
      var w = mr(b.impact) === c, x = !!(b.impact.at && b.impact.at.type === "COMBINE"), C = b.critical.droppable.id === c;
      return w ? x ? t : r : C ? t : r;
    }
    return r;
  };
  return i;
}, RI = {
  updateViewportMaxScroll: AT
};
function kI() {
  return document.body || (process.env.NODE_ENV !== "production" ? Z(!1, "document.body is not ready") : Z(!1)), document.body;
}
var BI = {
  mode: "standard",
  type: "DEFAULT",
  direction: "vertical",
  isDropDisabled: !1,
  isCombineEnabled: !1,
  ignoreContainerClipping: !1,
  renderClone: null,
  getContainerForClone: kI
}, Gv = qh(LI, RI, null, {
  context: Lf,
  pure: !0,
  areStatePropsEqual: zv
})(II);
Gv.defaultProps = BI;
const Yv = P.forwardRef((e, t) => {
  const {
    item: r,
    currentItem: n,
    resetCurrentItem: a
  } = e, i = _t(cn), o = (i == null ? void 0 : i.isCollapsedMenu) ?? !1, s = (r == null ? void 0 : r.items) ?? [];
  return /* @__PURE__ */ d.jsx(d.Fragment, { children: n !== null && n.id === r.id && s.length > 0 && /* @__PURE__ */ d.jsx("div", { ref: t, className: `fixed left-0 z-[30] w-full m:max-w-[288px] bg-secondary-200 top-0 bottom-[4.5rem] 2s:bottom-0 2s:top-[4.5rem] l:top-[5rem] ${o ? "m:left-[288px] l:left-[130px]" : "m:left-[288px]"}`, children: /* @__PURE__ */ d.jsxs("div", { className: "flex h-full flex-col", children: [
    /* @__PURE__ */ d.jsxs("div", { className: "flex items-center gap-4 justify-between p-4 border-b border-secondary-300 m:px-8", children: [
      /* @__PURE__ */ d.jsx("div", { className: "w-10 min-w-[40px] h-10 m:hidden", children: /* @__PURE__ */ d.jsx(
        "button",
        {
          type: "button",
          onClick: a,
          className: "bg-secondary-300 hover:bg-secondary-400 w-full h-full flex items-center justify-center rounded-md text-secondary-600",
          children: /* @__PURE__ */ d.jsx(ge, { variant: "back-arrow", width: 18 })
        }
      ) }),
      /* @__PURE__ */ d.jsx("div", { className: "flex-grow font-bold text-neutral-600 leading-[120%]", children: n.description }),
      /* @__PURE__ */ d.jsx("div", { className: "w-10 min-w-[40px] h-10 m:hidden", children: /* @__PURE__ */ d.jsx(
        "button",
        {
          type: "button",
          onClick: i == null ? void 0 : i.closeMenu,
          className: "bg-secondary-300 hover:bg-secondary-400 w-full h-full flex items-center justify-center rounded-md text-secondary-600",
          children: /* @__PURE__ */ d.jsx(ge, { variant: "close", width: 14 })
        }
      ) })
    ] }),
    /* @__PURE__ */ d.jsx("div", { className: "flex-grow overflow-hidden px-4", children: /* @__PURE__ */ d.jsx("div", { className: "h-full max-h-[calc(100%-32px)] w-full max-w-[568px] my-4 mx-auto overflow-y-auto menu-subitems-scrollbar", children: /* @__PURE__ */ d.jsx("ul", { children: s.map((l) => /* @__PURE__ */ d.jsx(
      "li",
      {
        className: "px-4 py-2 font-bold text-secondary-600 cursor-pointer rounded-md hover:bg-secondary-300",
        onClick: () => {
          l.onClick !== void 0 && (l == null || l.onClick()), i == null || i.closeMenu(), a();
        },
        children: l.description
      },
      l.id
    )) }) }) })
  ] }) }) });
});
Yv.displayName = "MenuSubitems";
const Kv = (e) => {
  const {
    idx: t,
    item: r,
    currentItem: n,
    changeCurrentItem: a,
    resetCurrentItem: i
  } = e, {
    id: o,
    icon: s,
    items: l,
    isActive: c,
    description: u,
    onClick: f = () => {
    }
  } = r, p = n !== null && n.id === r.id, h = l !== void 0, m = l ?? [], v = _t(cn), g = (v == null ? void 0 : v.isCollapsedMenu) ?? !1, y = () => {
    window.innerWidth >= 1024 && a(r);
  }, b = () => {
    window.innerWidth >= 1024 && i();
  };
  return /* @__PURE__ */ d.jsx(NI, { draggableId: `${o}`, index: t, children: (w, x) => /* @__PURE__ */ d.jsxs(
    "div",
    {
      ref: w.innerRef,
      ...w.draggableProps,
      ...w.dragHandleProps,
      style: {
        cursor: "default",
        ...w.draggableProps.style
      },
      className: "select-none px-4",
      onMouseEnter: y,
      onMouseLeave: b,
      children: [
        /* @__PURE__ */ d.jsxs(
          "div",
          {
            title: u,
            className: Ne([
              "min-h-[40px] py-2 flex items-center justify-between font-bold gap-2 cursor-pointer rounded-md px-2",
              p ? c ? "bg-primary-500" : "bg-secondary-800" : c ? x.isDragging ? "bg-primary-500" : "bg-primary-600" : x.isDragging ? "bg-secondary-800" : "bg-secondary-900"
            ]),
            onClick: () => {
              f(), a(r), h || v == null || v.closeMenu();
            },
            children: [
              /* @__PURE__ */ d.jsxs("div", { className: "flex gap-2 items-center", children: [
                /* @__PURE__ */ d.jsx("span", { className: "opacity-[0.15] cursor-grab", children: /* @__PURE__ */ d.jsx(ge, { variant: "drag" }) }),
                /* @__PURE__ */ d.jsxs("div", { className: "flex gap-2 items-center leading-none capitalize", children: [
                  /* @__PURE__ */ d.jsx("span", { className: "w-[20px] min-w-[20px]", children: /* @__PURE__ */ d.jsx(ge, { variant: s, width: 20 }) }),
                  /* @__PURE__ */ d.jsx("span", { className: `${g ? "block l:hidden" : "block"}`, children: u })
                ] })
              ] }),
              h && m.length > 0 && /* @__PURE__ */ d.jsx("span", { className: "-rotate-90", children: /* @__PURE__ */ d.jsx(ge, { variant: "arrow-down", width: 14 }) })
            ]
          }
        ),
        /* @__PURE__ */ d.jsx(
          Yv,
          {
            item: r,
            currentItem: n,
            resetCurrentItem: i
          }
        )
      ]
    }
  ) }, o);
};
Kv.displayName = "MenuItem";
const VI = ({ children: e, ...t }) => {
  const [r, n] = je(!1);
  return Me(() => {
    const a = requestAnimationFrame(() => n(!0));
    return () => {
      cancelAnimationFrame(a), n(!1);
    };
  }, []), r ? /* @__PURE__ */ d.jsx(Gv, { ...t, children: e }) : null;
}, HI = (e, t, r) => {
  const n = Array.from(e), [a] = n.splice(t, 1);
  return n.splice(r, 0, a), n;
}, FI = P.forwardRef((e, t) => {
  const {
    className: r,
    items: n,
    activeHome: a,
    labelHome: i = "Inicio",
    onClickHome: o = () => {
    },
    onMenuDragged: s = () => {
    },
    ...l
  } = e, [c, u] = je(n), [f, p] = je(null), h = _t(cn), m = (h == null ? void 0 : h.isOpenMenu) ?? !1, v = (h == null ? void 0 : h.isCollapsedMenu) ?? !1, g = (w) => {
    p(w);
  }, y = () => {
    p(null);
  }, b = ({ source: w, destination: x }) => {
    if (x == null)
      return;
    const C = HI(
      c,
      w.index,
      x.index
    );
    s({
      _newItems: C,
      item: {
        payload: C[x.index],
        indexes: {
          previous: w.index,
          new: x.index
        }
      }
    }), u(C);
  };
  return Me(() => {
    m || p(null);
  }, [m]), Me(() => {
    u(n);
  }, [n]), /* @__PURE__ */ d.jsxs(
    "ul",
    {
      ref: t,
      className: Ne(["flex flex-col text-white select-none", r]),
      ...l,
      children: [
        /* @__PURE__ */ d.jsx("li", { className: "h-10 px-4", children: /* @__PURE__ */ d.jsx(
          "div",
          {
            className: `h-full flex gap-2 items-center justify-between font-bold cursor-pointer rounded-md pl-2 l:pl-[36px] pr-2 ${a === !0 ? "bg-primary-600 hover:bg-primary-500" : "hover:bg-secondary-800"}`,
            title: i,
            onClick: () => {
              o(), h == null || h.closeMenu();
            },
            children: /* @__PURE__ */ d.jsxs("div", { className: "flex gap-2 items-center", children: [
              /* @__PURE__ */ d.jsx(ge, { variant: "home", width: 20 }),
              /* @__PURE__ */ d.jsx("span", { className: `${v ? "block l:hidden" : "block"}`, children: i })
            ] })
          }
        ) }),
        /* @__PURE__ */ d.jsx(zN, { onDragEnd: b, children: /* @__PURE__ */ d.jsx(VI, { droppableId: "droppable", children: (w) => /* @__PURE__ */ d.jsxs(
          "div",
          {
            ...w.droppableProps,
            ref: w.innerRef,
            children: [
              c.map((x, C) => /* @__PURE__ */ d.jsx(
                Kv,
                {
                  idx: C,
                  item: x,
                  currentItem: f,
                  changeCurrentItem: g,
                  resetCurrentItem: y
                },
                x.id
              )),
              w.placeholder
            ]
          }
        ) }) })
      ]
    }
  );
});
FI.displayName = "MenuItems";
const WI = P.forwardRef((e, t) => {
  const {
    children: r,
    ...n
  } = e, a = _t(cn), i = (a == null ? void 0 : a.isOpenMenu) ?? !1, o = (a == null ? void 0 : a.isCollapsedMenu) ?? !1;
  return /* @__PURE__ */ d.jsx("aside", { ref: t, ...n, className: `fixed z-[1000] w-full bg-secondary-900 top-0 bottom-[4.5rem] 2s:bottom-0 2s:top-[4.5rem] l:top-[5rem] ${i ? "left-0" : "-left-[100vw] m:-left-[288px] l:left-0"} ${o ? "m:max-w-[288px] l:max-w-[130px]" : "m:max-w-[288px]"}`, children: /* @__PURE__ */ d.jsxs("div", { className: "flex flex-col h-full w-full", children: [
    /* @__PURE__ */ d.jsxs("div", { className: "flex l:hidden items-center justify-between px-4 h-[72px] text-white border-b border-secondary-850", children: [
      /* @__PURE__ */ d.jsx(Sn, { variant: "heading-6", children: "Menú" }),
      /* @__PURE__ */ d.jsx(
        "button",
        {
          type: "button",
          onClick: a == null ? void 0 : a.closeMenu,
          className: "w-10 aspect-square bg-secondary-850 hover:bg-secondary-600 rounded-md flex justify-center items-center",
          children: /* @__PURE__ */ d.jsx(ge, { variant: "close", width: 14 })
        }
      )
    ] }),
    /* @__PURE__ */ d.jsx("div", { className: "hidden l:flex items-center justify-end px-4 h-[56px] text-white border-b border-secondary-850", children: /* @__PURE__ */ d.jsx(
      "button",
      {
        type: "button",
        onClick: a == null ? void 0 : a.toggleCollapsedMenu,
        className: "w-10 aspect-square bg-secondary-850 hover:bg-secondary-600 rounded-md flex justify-center items-center",
        children: /* @__PURE__ */ d.jsx("span", { className: `${o ? "-rotate-180" : ""}`, children: /* @__PURE__ */ d.jsx(ge, { variant: "collect-menu", width: 20 }) })
      }
    ) }),
    /* @__PURE__ */ d.jsx("div", { className: "flex-grow max-h-[calc(100%-72px-56px-32px)] l:max-h-[calc(100%-56px-56px-32px)] w-full max-w-[600px] my-4 mx-auto", children: /* @__PURE__ */ d.jsx("div", { className: "h-full overflow-y-auto menu-wrapper-scrollbar", children: /* @__PURE__ */ d.jsx("div", { className: "flex flex-col gap-4", children: r }) }) }),
    /* @__PURE__ */ d.jsx("div", { className: "flex items-center justify-center px-4 h-[56px] text-white border-t border-secondary-850", children: /* @__PURE__ */ d.jsxs(
      "svg",
      {
        className: "w-[64px]",
        viewBox: "0 0 60 34",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
          /* @__PURE__ */ d.jsx(
            "path",
            {
              d: "M29.3638 0.179688L0 16.6058L17.2099 33.8205L29.3638 0.179688Z",
              fill: "#E15B3E"
            }
          ),
          /* @__PURE__ */ d.jsx(
            "path",
            {
              d: "M27.6655 29.1228C26.6398 29.1228 25.8027 28.9486 25.1641 28.5954L25.6721 27.3084C26.3204 27.5358 26.9784 27.6471 27.6461 27.6471C28.517 27.6471 28.9525 27.4052 28.9525 26.9214C28.9525 26.7375 28.8654 26.573 28.6912 26.4278C28.517 26.2779 28.2993 26.1569 28.038 26.065C27.7768 25.9682 27.4913 25.8521 27.1816 25.7069C26.872 25.5618 26.5865 25.4118 26.3253 25.2473C26.064 25.0876 25.8463 24.8554 25.6721 24.5506C25.4979 24.2506 25.406 23.9022 25.406 23.5055C25.406 22.8378 25.6721 22.3298 26.1995 21.9766C26.7268 21.6234 27.3558 21.4492 28.0864 21.4492C28.4541 21.4492 28.7928 21.4782 29.1025 21.5315C29.4169 21.5895 29.6492 21.6428 29.7992 21.7008C29.9492 21.7589 30.1572 21.8411 30.4185 21.9524L29.9008 23.1959C29.1895 22.9926 28.6041 22.891 28.1396 22.891C27.4865 22.891 27.1575 23.0894 27.1575 23.491C27.1575 23.6458 27.2494 23.791 27.4284 23.9216C27.6074 24.0571 27.83 24.1732 28.0961 24.2748C28.3622 24.3764 28.6525 24.5022 28.9621 24.6522C29.2718 24.8022 29.5621 24.9667 29.8282 25.1409C30.0943 25.315 30.3169 25.5521 30.4959 25.8473C30.6749 26.1424 30.7668 26.4762 30.7668 26.8488C30.7668 27.2407 30.6797 27.589 30.5056 27.889C30.3314 28.189 30.0943 28.4261 29.7943 28.6003C29.4944 28.7744 29.1654 28.9051 28.8073 28.9922C28.4493 29.0744 28.0671 29.118 27.6703 29.118L27.6655 29.1228Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ d.jsx("path", { d: "M32.5186 29.0056V21.5449H34.3136V29.0056H32.5186Z", fill: "white" }),
          /* @__PURE__ */ d.jsx(
            "path",
            {
              d: "M35.7744 29.0056L38.6435 21.5449H40.9563L43.4673 29.0056H41.6094L40.903 26.8235H38.3823L37.5694 29.0056H35.7744ZM38.8564 25.522H40.4821L39.7322 22.6529L38.8564 25.522Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ d.jsx(
            "path",
            {
              d: "M48.3829 29.1121C47.0233 29.1121 45.9976 28.7879 45.296 28.1396C44.5945 27.4913 44.2461 26.5526 44.2461 25.3237C44.2461 22.7352 45.6105 21.4434 48.3393 21.4434C49.2199 21.4434 49.994 21.5933 50.6617 21.8982L50.1876 23.1948C49.7956 23.0884 49.486 23.0207 49.2683 22.9819C49.0505 22.9481 48.7457 22.9239 48.3587 22.919C47.6619 22.9045 47.1055 23.0932 46.6943 23.49C46.2782 23.8819 46.0701 24.4625 46.0701 25.2221C46.0701 25.9817 46.2927 26.5817 46.7475 26.9929C47.1975 27.409 47.8071 27.6171 48.5716 27.6171C49.1812 27.6171 49.7618 27.5445 50.3037 27.4042L50.6859 28.7541C50.0376 28.9911 49.2731 29.1121 48.3877 29.1121H48.3829Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ d.jsx(
            "path",
            {
              d: "M55.9162 29.1323C54.6292 29.1323 53.6567 28.7936 52.9987 28.1162C52.3407 27.4389 52.0117 26.4857 52.0117 25.2616C52.0117 24.0375 52.3794 23.1473 53.1149 22.4603C53.8503 21.7732 54.8518 21.4297 56.1146 21.4297C57.3774 21.4297 58.3886 21.778 59.0321 22.4748C59.6756 23.1715 59.9998 24.1053 59.9998 25.281C59.9998 26.4567 59.6466 27.4244 58.945 28.1066C58.2435 28.7888 57.2323 29.1323 55.9162 29.1323ZM55.9501 27.7195C56.7291 27.7195 57.2952 27.5018 57.6484 27.0615C58.0016 26.6212 58.1757 26.0261 58.1757 25.2713C58.1757 24.5165 57.9967 23.9456 57.6435 23.5053C57.2903 23.065 56.7484 22.8473 56.0227 22.8473C55.2969 22.8473 54.7163 23.065 54.3631 23.5005C54.0099 23.9359 53.8309 24.5214 53.8309 25.252C53.8309 25.9825 54.0051 26.5777 54.3535 27.0373C54.7018 27.4969 55.234 27.7243 55.9501 27.7243V27.7195Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ d.jsx(
            "path",
            {
              d: "M14.8873 26.7615L13.7067 25.3874C13.5277 25.4019 13.339 25.4019 13.1455 25.4019H12.3762V29.0065H9.85059V18.5605H13.9148C16.2662 18.5605 17.9451 19.6395 17.9451 21.9716C17.9451 23.1376 17.3838 24.1585 16.2614 24.7923L17.3258 25.9438C17.9016 26.5631 18.5499 26.9792 19.6869 27.2744L19.1256 29.1952C17.0887 29.0936 15.9807 28.0291 14.8873 26.7567",
              fill: "white"
            }
          )
        ]
      }
    ) })
  ] }) });
});
WI.displayName = "MenuWrapper";
const zI = P.forwardRef((e, t) => {
  const {
    size: r = "xl",
    isTop: n = !1,
    isOpen: a,
    children: i
  } = e, o = {
    sm: "px-4 max-w-[calc(474px+32px)]",
    xl: "px-0 2s:px-4 w-full 2s:max-w-[calc(944px+32px)]"
  };
  return Me(() => {
    if (!n)
      return a ? document.body.classList.add("overflow-y-hidden-modal") : document.body.classList.remove("overflow-y-hidden-modal"), () => {
        document.body.classList.remove("overflow-y-hidden-modal");
      };
  }, [a]), /* @__PURE__ */ d.jsx(
    "div",
    {
      ref: t,
      className: `
        fixed overflow-x-hidden overflow-y-auto modal-scrollbar
        ${n ? "z-[1710]" : "z-[1700]"}
        ${r === "xl" ? "bg-white 2s:bg-[rgba(3,56,108,0.6)] left-0 top-0 bottom-[4.5rem] 2s:bottom-0" : "bg-[rgba(3,56,108,0.6)] inset-0"}
        ${a ? "visible w-full" : "invisible w-0 h-0"}
      `,
      children: /* @__PURE__ */ d.jsx("div", { className: `flex ${r === "xl" ? "items-start 2s:items-center" : "items-center"} ${r === "xl" ? "my-0 2s:my-[28px]" : "my-[28px]"} mx-auto ${r === "xl" ? "min-h-full 2s:min-h-[calc(100%-56px)]" : "min-h-[calc(100%-56px)]"} w-full relative ${o[r]}`, children: /* @__PURE__ */ d.jsx("div", { className: `bg-white rounded-lg relative w-full ${a ? "scale-[1] transition-all" : "scale-[0.9]"}`, children: i }) })
    }
  );
});
zI.displayName = "Modal";
const UI = P.forwardRef((e, t) => {
  const {
    size: r = "sm",
    children: n
  } = e, a = {
    sm: "p-4 s:p-8",
    xl: "p-4 2s:p-12"
  };
  return /* @__PURE__ */ d.jsx(
    "div",
    {
      ref: t,
      className: a[r],
      children: n
    }
  );
});
UI.displayName = "ModalBody";
const ZI = P.forwardRef((e, t) => {
  const {
    isOpen: r,
    children: n
  } = e;
  return Me(() => (r ? document.body.classList.add("overflow-y-hidden-modal") : document.body.classList.remove("overflow-y-hidden-modal"), () => {
    document.body.classList.remove("overflow-y-hidden-modal");
  }), [r]), /* @__PURE__ */ d.jsx(
    "div",
    {
      ref: t,
      className: `
        fixed z-[900] l:z-[1500] left-0 top-0 bottom-[4.5rem] 2s:bottom-0 2s:top-[4.5rem] l:top-[5rem] overflow-x-hidden overflow-y-auto modal-focus-scrollbar bg-white
        ${r ? "visible w-full" : "invisible w-0 h-0"}
      `,
      children: /* @__PURE__ */ d.jsx("div", { className: "flex mx-autom mb-[80px] min-h-[calc(100%-80px)] w-full relative", children: /* @__PURE__ */ d.jsx("div", { className: `relative w-full ${r ? "scale-[1] transition-all" : "scale-[0.9]"}`, children: n }) })
    }
  );
});
ZI.displayName = "ModalFocus";
const qI = P.forwardRef((e, t) => {
  const {
    size: r = "xl",
    children: n
  } = e, a = {
    xl: "p-4 2s:p-8"
  };
  return /* @__PURE__ */ d.jsx(
    "div",
    {
      ref: t,
      className: `${a[r]} border-b border-neutral-200`,
      children: n
    }
  );
});
qI.displayName = "ModalHeader";
const GI = P.forwardRef((e, t) => {
  const {
    size: r = "xl",
    children: n
  } = e, a = {
    xl: "p-4 2s:px-8 2s:pt-8 2s:pb-16"
  };
  return /* @__PURE__ */ d.jsx(
    "div",
    {
      ref: t,
      className: `${a[r]} border-t border-neutral-200`,
      children: n
    }
  );
});
GI.displayName = "ModalFooter";
const YI = P.forwardRef((e, t) => {
  const {
    children: r
  } = e;
  return /* @__PURE__ */ d.jsx("div", { ref: t, className: "w-full max-w-[1300px] mx-auto", children: r });
});
YI.displayName = "ModalFocusContainer";
const KI = P.forwardRef((e, t) => {
  const {
    variant: r,
    children: n,
    srcBgImage: a,
    className: i,
    ...o
  } = e, s = {
    login: "bg-h-full bg-image relative",
    "password-recovery": "relative bg-h-full bg-image m:py-20",
    "change-password": "relative bg-h-full bg-image m:py-20"
  }, l = {
    login: "m:flex m:justify-center m:items-center m:min-h-[100vh] m:w-[45rem] m:pl-[3.2rem]",
    "password-recovery": "m-auto m:max-w-[51rem]",
    "change-password": "m-auto m:max-w-[51rem]"
  }, c = {
    login: "m:grid m:grid-cols-2",
    "password-recovery": "bg-white m:px-8 pt-8 m:pb-16 m:rounded-lg",
    "change-password": "bg-white pt-8 m:pb-16 m:rounded-lg"
  };
  return /* @__PURE__ */ d.jsx(
    "div",
    {
      ref: t,
      className: Ne([s[r], i]),
      style: { backgroundImage: `url(${a})` },
      ...o,
      children: /* @__PURE__ */ d.jsx("div", { className: l[r], children: /* @__PURE__ */ d.jsxs("div", { className: c[r], children: [
        n,
        /* @__PURE__ */ d.jsx("footer", { ref: t, className: "bg-white border border-t m:absolute m:border-0 m:top-0 m:right-0 m:rounded-bl-lg", ...o, children: /* @__PURE__ */ d.jsx("div", { className: "brand p-4 flex justify-center", children: /* @__PURE__ */ d.jsx(qD, {}) }) })
      ] }) })
    }
  );
});
KI.displayName = "Spreen";
const XI = P.forwardRef((e, t) => {
  const {
    variant: r,
    children: n,
    className: a,
    isSuccessPasswordRecovery: i = !1,
    ...o
  } = e, s = {
    login: "my-[2rem] px-[1rem] m:px-[2rem] grid gap-[2rem]",
    "password-recovery": `grid gap-8 px-4 mb-4 m:mb-0 m:px-0 ${i ? "m:grid-cols-1 m-auto m:max-w-[17rem] py-8" : "m:grid-cols-2"}`,
    "change-password": `grid gap-8 px-4 mb-4 m:mb-0 ${i ? "m:grid-cols-1 m-auto m:max-w-[17rem] py-8 m:px-0" : "m:grid-cols-2 m:px-8"}`
  };
  return /* @__PURE__ */ d.jsx(
    "div",
    {
      ref: t,
      className: Ne([s[r], a]),
      ...o,
      children: n
    }
  );
});
XI.displayName = "SpreenBody";
const QI = P.forwardRef((e, t) => {
  const {
    children: r,
    className: n,
    ...a
  } = e;
  return /* @__PURE__ */ d.jsx(
    "div",
    {
      ref: t,
      className: Ne(["border-t py-[4rem] text-center", n]),
      ...a,
      children: r
    }
  );
});
QI.displayName = "SpreenFooter";
const JI = P.forwardRef((e, t) => {
  const {
    children: r,
    className: n,
    ...a
  } = e;
  return /* @__PURE__ */ d.jsxs(
    "div",
    {
      ref: t,
      className: Ne(["bg-white m:rounded-l-lg", n]),
      ...a,
      children: [
        /* @__PURE__ */ d.jsx("div", { className: "border-b py-8 flex justify-center", id: "LOGO", children: /* @__PURE__ */ d.jsx(Nh, {}) }),
        r
      ]
    }
  );
});
JI.displayName = "SpreenLeft";
const eL = P.forwardRef((e, t) => {
  const {
    children: r,
    className: n,
    ...a
  } = e;
  return /* @__PURE__ */ d.jsx(
    "div",
    {
      ref: t,
      className: Ne(["bg-secondary-800 text-white py-[2rem] px-[1rem] m:px-[2rem] m:rounded-r-lg", n]),
      ...a,
      children: r
    }
  );
});
eL.displayName = "SpreenRight";
const tL = P.forwardRef((e, t) => {
  const {
    variant: r,
    children: n,
    className: a,
    ...i
  } = e, o = {
    "password-recovery": "flex items-center justify-between border-b border-100 px-5 pb-8 mb-8 m:px-0",
    "change-password": "flex items-center justify-between border-b border-100 px-5 pb-8 mb-8 m:px-8"
  };
  return /* @__PURE__ */ d.jsxs(
    "div",
    {
      ref: t,
      className: Ne([o[r], a]),
      ...i,
      children: [
        n,
        /* @__PURE__ */ d.jsx("div", { className: "flex justify-center", children: /* @__PURE__ */ d.jsx(Nh, { width: 120 }) })
      ]
    }
  );
});
tL.displayName = "SpreenHeader";
const Xv = P.forwardRef((e, t) => {
  const {
    gap: r,
    gapY: n,
    gapX: a,
    bg: i,
    rounded: o,
    columns: s,
    columnsVariant: l,
    spacing: c,
    alignItems: u,
    justifyItems: f,
    responsiveColumns: p,
    children: h,
    className: m,
    ...v
  } = e, g = {
    gridTemplateColumns: l === void 0 && s !== void 0 ? `repeat(${s}, 1fr)` : void 0,
    backgroundColor: i !== void 0 ? Ae[i] : void 0,
    borderRadius: o !== void 0 ? U0[o] : void 0,
    padding: c !== void 0 ? `${c / 4}rem` : void 0,
    justifyItems: f,
    alignItems: u
  };
  r !== void 0 ? g.gap = r !== void 0 ? `${r / 4}rem` : void 0 : (g.columnGap = a !== void 0 ? `${a / 4}rem` : void 0, g.rowGap = n !== void 0 ? `${n / 4}rem` : void 0);
  const y = {
    "form-4": "grid-cols-1 2s:grid-cols-2 l:grid-cols-4 gap-x-4 gap-y-8 label-form-4",
    "form-2": "grid-cols-1 2s:grid-cols-2 gap-x-4 gap-y-8 label-form-2"
  };
  p !== void 0 && Object.entries(p).forEach(([w, x]) => {
    const C = `--ck-cols-${w}`;
    typeof x == "number" && (g[C] = `repeat(${x},1fr)`), typeof x == "string" && (g[C] = x);
  });
  const b = {
    initial: "grid-cols-[var(--ck-cols-initial)]",
    small: "s:grid-cols-[var(--ck-cols-small)]",
    extraSmall: "2s:grid-cols-[var(--ck-cols-extraSmall)]",
    medium: "m:grid-cols-[var(--ck-cols-medium)]",
    large: "l:grid-cols-[var(--ck-cols-large)]",
    extraLarge: "xl:grid-cols-[var(--ck-cols-extraLarge)]"
  };
  return /* @__PURE__ */ d.jsx(
    "div",
    {
      ref: t,
      className: Ne([
        "grid",
        l !== void 0 ? y[l] : void 0,
        p !== void 0 ? `${Object.keys(p).map((w) => b[w]).join(" ")}` : void 0
      ]),
      style: g,
      ...v,
      children: h
    }
  );
});
Xv.displayName = "Stack";
const ds = Xv, Qv = P.forwardRef((e, t) => {
  const {
    responsiveColSpan: r,
    showDesktopOnly: n,
    forceWidth: a = !1,
    children: i,
    ...o
  } = e, s = {};
  r !== void 0 && Object.entries(r).forEach(([c, u]) => {
    if (typeof u == "number") {
      const f = `--ck-col-span-${c}`;
      s[f] = `span ${u} / span ${u}`;
    }
  });
  const l = {
    initial: "col-[var(--ck-col-span-initial)]",
    small: "s:col-[var(--ck-col-span-small)]",
    extraSmall: "2s:col-[var(--ck-col-span-extraSmall)]",
    medium: "m:col-[var(--ck-col-span-medium)]",
    large: "l:col-[var(--ck-col-span-large)]",
    extraLarge: "xl:col-[var(--ck-col-span-extraLarge)]"
  };
  return /* @__PURE__ */ d.jsx(
    "div",
    {
      ref: t,
      style: s,
      className: Ne([
        `${n === !0 ? "hidden m:block" : "block"} ${a ? "max-w-full overflow-x-hidden" : ""}`,
        r !== void 0 ? `${Object.keys(r).map((c) => l[c]).join(" ")}` : void 0
      ]),
      ...o,
      children: i
    }
  );
});
Qv.displayName = "StackRow";
const Io = Qv, rL = P.forwardRef((e, t) => {
  const {
    steps: r,
    value: n,
    onClickStepper: a
  } = e, i = Array.from({ length: r }, (o, s) => s + 1);
  return /* @__PURE__ */ d.jsx("ul", { ref: t, className: "flex items-center justify-between w-full m-auto m:max-w-[15rem]", children: i.map((o) => /* @__PURE__ */ d.jsxs(ea, { children: [
    /* @__PURE__ */ d.jsx(
      "li",
      {
        className: `text-neutral-100 px-3 py-1 rounded-full ${n >= o ? "bg-accent-500" : "bg-neutral-300"}`,
        style: { cursor: n >= o ? "pointer" : "" },
        onClick: n >= o && a !== void 0 ? () => a(o) : () => !0,
        children: o
      }
    ),
    o !== i.length && /* @__PURE__ */ d.jsx("hr", { className: `w-full h-[2px] border-0 ${n > o ? "bg-accent-500" : "bg-neutral-300"}` })
  ] }, o)) });
});
rL.displayName = "StepperSimple";
const nL = P.forwardRef((e) => {
  const { steps: t, tooltipDirection: r = "bottom" } = e, n = {
    top: "after:left-1/2 after:-translate-x-1/2 after:bottom-[calc(100%+15px)] before:left-1/2 before:-translate-x-1/2 before:bottom-[calc(100%+6px)] before:border-t-info-500 before:border-t-[9px] before:border-x-transparent before:border-x-[6px]",
    bottom: "after:left-1/2 after:-translate-x-1/2 after:top-[calc(100%+15px)] before:left-1/2 before:-translate-x-1/2 before:top-[calc(100%+6px)] before:border-b-info-500 before:border-b-[9px] before:border-x-transparent before:border-x-[6px]",
    left: "after:left-0 after:-translate-x-[calc(100%+15px)] after:top-1/2 after:-translate-y-1/2 before:left-0 before:-translate-x-[calc(100%+6px)] before:top-1/2 before:-translate-y-1/2 before:border-l-info-500 before:border-l-[9px] before:border-y-transparent before:border-y-[6px]",
    right: "after:right-0 after:translate-x-[calc(100%+15px)] after:top-1/2 after:-translate-y-1/2 before:right-0 before:translate-x-[calc(100%+6px)] before:top-1/2 before:-translate-y-1/2 before:border-r-info-500 before:border-r-[9px] before:border-y-transparent before:border-y-[6px]"
  };
  return /* @__PURE__ */ d.jsx("ol", { className: "flex items-center justify-between w-full", children: t.map((a, i) => /* @__PURE__ */ d.jsxs(ea, { children: [
    /* @__PURE__ */ d.jsx("li", { className: "text-neutral-100 py-1 rounded-full", children: /* @__PURE__ */ d.jsx(
      "div",
      {
        className: `flex items-center justify-center w-10 h-10 rounded-full lg:h-15 lg:w-15 bg-${Ae[a.color]} shrink-0`,
        style: { backgroundColor: Ae[a.color] },
        children: /* @__PURE__ */ d.jsx(
          "span",
          {
            "data-title": a.label,
            className: `${n[r]} relative after:content-[attr(data-title)] after:w-[180px] after:absolute after:z-[10] after:bg-info-500 after:h-[max-content] after:p-2 after:rounded-md after:text-s after:leading-[120%] after:text-white after:justify-center after:items-center after:hidden hover:after:flex before:absolute before:z-[10] before:hidden hover:before:block whitespace-pre-line`,
            children: /* @__PURE__ */ d.jsx(ge, { variant: a.variant, width: 25, color: "white" })
          }
        )
      }
    ) }),
    i <= t.length - 2 && /* @__PURE__ */ d.jsx("hr", { className: "w-full h-[2px] border-0", style: { backgroundColor: Ae[a.color] } })
  ] }, `stepicon-${i}`)) });
});
nL.displayName = "StepperIcon";
const aL = P.forwardRef((e, t) => {
  const {
    children: r,
    className: n
  } = e;
  return /* @__PURE__ */ d.jsx("div", { ref: t, className: Ne(["bg-secondary-100 flex items-center justify-center p-5 rounded-md min-h-[70vh]", n]), children: /* @__PURE__ */ d.jsxs("div", { className: "flex flex-col items-center justify-center w-full max-w-[300px] gap-4 text-center", children: [
    /* @__PURE__ */ d.jsx("div", { className: "flex justify-center select-none", children: /* @__PURE__ */ d.jsx(
      "svg",
      {
        width: 90,
        height: 101,
        viewBox: "0 0 90 101",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ d.jsxs("g", { clipPath: "url(#clip0_2127_49432)", children: [
          /* @__PURE__ */ d.jsx(
            "path",
            {
              d: "M89.9844 52.4766C89.8853 51.6849 89.314 51.0339 88.5418 50.8307L80.2566 48.6484L86.6766 41.5833C87.0783 41.1406 87.2531 40.5417 87.1566 39.9531C87.0601 39.3646 86.7001 38.8542 86.1783 38.5625L62.2618 25.276C61.3644 23.6068 60.2166 22.0573 58.834 20.6823C55.1401 16.9922 50.2253 14.9609 45.0001 14.9609C39.7748 14.9609 34.8601 16.9922 31.1661 20.6823C29.7731 22.0729 28.6357 23.6224 27.7514 25.2708L3.82441 38.5651C3.30267 38.8542 2.94267 39.3672 2.84614 39.9557C2.74962 40.5443 2.92701 41.1432 3.32875 41.5859L9.74615 48.651L1.45832 50.8333C0.686145 51.0365 0.11484 51.6875 0.0157101 52.4792C-0.0834204 53.2708 0.307884 54.0417 1.00701 54.4297L11.4027 60.2057V80.974C11.4027 81.6823 11.7888 82.3359 12.407 82.6797L44.0505 100.258C44.3479 100.422 44.674 100.505 45.0027 100.505C45.3314 100.505 45.6601 100.424 45.9548 100.258L77.5983 82.6797C78.2192 82.3359 78.6027 81.6823 78.6027 80.974V60.2057L88.9983 54.4297C89.6948 54.0417 90.0888 53.2708 89.987 52.4792L89.9844 52.4766ZM82.1192 40.7839L76.2366 47.2578L63.694 40.2917C64.2679 38.4401 64.5653 36.4896 64.5653 34.4974C64.5653 33.2578 64.4505 32.0365 64.2261 30.8438L82.1218 40.7839H82.1192ZM33.9314 23.4479C36.887 20.4974 40.8183 18.8724 45.0001 18.8724C49.1818 18.8724 53.1105 20.4974 56.0688 23.4479C59.027 26.3984 60.6522 30.3229 60.6522 34.4974C60.6522 38.6719 59.0244 42.5938 56.0688 45.5469C54.0235 47.5885 51.4644 49.0208 48.6653 49.6901C48.1435 49.8151 47.6948 50.1484 47.4261 50.612L45.0001 54.8099C44.1914 53.4089 43.3827 52.0104 42.574 50.612C42.3053 50.1484 41.8566 49.8151 41.3348 49.6875C38.5383 49.0182 35.9792 47.5859 33.934 45.5443C27.8322 39.4531 27.8322 29.5391 33.934 23.4479H33.9314ZM7.88093 40.7839L25.7896 30.8359C25.1948 33.9714 25.3696 37.2214 26.3192 40.2865L13.7661 47.2604L7.88354 40.7865L7.88093 40.7839ZM13.0957 51.8073L20.5331 55.9401C20.8357 56.1068 21.1618 56.1875 21.4827 56.1875C22.1714 56.1875 22.8366 55.8255 23.194 55.1823C23.7209 54.2396 23.3792 53.0495 22.4348 52.526L17.3818 49.7188L27.8531 43.9036C28.7218 45.4844 29.8279 46.9688 31.1661 48.3073C33.5192 50.6563 36.4148 52.3594 39.5922 53.2682C40.4348 54.7266 41.2774 56.1849 42.1227 57.6458C42.7253 58.6823 43.7975 59.2995 44.9975 59.2995H45.0235C46.2131 59.2917 47.3114 58.6484 47.8957 57.6172L50.4105 53.2682C53.5853 52.3568 56.4835 50.6536 58.8366 48.3073C60.1618 46.9818 61.2757 45.5026 62.1575 43.9063L72.6209 49.7188L45.0027 65.0599L37.8261 61.0729C36.8818 60.5495 35.6896 60.888 35.1653 61.8307C34.6383 62.7734 34.9801 63.9635 35.9244 64.487L39.8061 66.6432L33.8661 68.2057L7.15571 53.3672L13.0957 51.8047V51.8073ZM15.3157 62.375L32.6505 72.0052C33.0914 72.25 33.6105 72.3151 34.1009 72.1875L43.0461 69.8333V95.2266L15.3157 79.8229V62.3776V62.375ZM74.687 79.8203L46.9566 95.224V69.8307L55.9018 72.1849C56.0661 72.2266 56.2331 72.25 56.4001 72.25C56.7314 72.25 57.0574 72.1667 57.3496 72.0026L74.6844 62.3724V79.8177L74.687 79.8203ZM56.1392 68.2083L50.1992 66.6432L76.907 51.8073L82.847 53.3698L56.1392 68.2083Z",
              fill: "#2875B4"
            }
          ),
          /* @__PURE__ */ d.jsx(
            "path",
            {
              d: "M35.2173 36.7422C36.2973 36.7422 37.1738 35.8672 37.1738 34.7891C37.1738 33.7109 36.2973 32.8359 35.2173 32.8359C34.1373 32.8359 33.2607 33.7109 33.2607 34.7891C33.2607 35.8672 34.1373 36.7422 35.2173 36.7422Z",
              fill: "#2875B4"
            }
          ),
          /* @__PURE__ */ d.jsx(
            "path",
            {
              d: "M45 36.7422C46.08 36.7422 46.9565 35.8672 46.9565 34.7891C46.9565 33.7109 46.08 32.8359 45 32.8359C43.92 32.8359 43.0435 33.7109 43.0435 34.7891C43.0435 35.8672 43.92 36.7422 45 36.7422Z",
              fill: "#2875B4"
            }
          ),
          /* @__PURE__ */ d.jsx(
            "path",
            {
              d: "M54.7827 36.7422C55.8627 36.7422 56.7392 35.8672 56.7392 34.7891C56.7392 33.7109 55.8627 32.8359 54.7827 32.8359C53.7027 32.8359 52.8262 33.7109 52.8262 34.7891C52.8262 35.8672 53.7027 36.7422 54.7827 36.7422Z",
              fill: "#2875B4"
            }
          ),
          /* @__PURE__ */ d.jsx(
            "path",
            {
              d: "M45 8.89844C46.08 8.89844 46.9565 8.02344 46.9565 6.94531V2.45312C46.9565 1.375 46.08 0.5 45 0.5C43.92 0.5 43.0435 1.375 43.0435 2.45312V6.94531C43.0435 8.02344 43.92 8.89844 45 8.89844Z",
              fill: "#2875B4"
            }
          ),
          /* @__PURE__ */ d.jsx(
            "path",
            {
              d: "M33.0573 10.6639C33.4199 11.2915 34.0773 11.6405 34.7529 11.6405C35.0842 11.6405 35.4207 11.5571 35.7286 11.38C36.6651 10.841 36.9859 9.64566 36.4459 8.71077L34.1973 4.82014C33.6573 3.88525 32.4599 3.56494 31.5259 4.104C30.5894 4.64306 30.2686 5.83837 30.8086 6.77327L33.0573 10.6639Z",
              fill: "#2875B4"
            }
          ),
          /* @__PURE__ */ d.jsx(
            "path",
            {
              d: "M54.2685 11.3776C54.5764 11.5547 54.9129 11.638 55.2468 11.638C55.9225 11.638 56.5799 11.2891 56.9425 10.6615L59.1912 6.77083C59.7312 5.83593 59.4103 4.64062 58.4738 4.10156C57.5372 3.56249 56.3425 3.88281 55.8025 4.8177L53.5538 8.70833C53.0138 9.64322 53.3346 10.8359 54.2685 11.3776Z",
              fill: "#2875B4"
            }
          ),
          /* @__PURE__ */ d.jsx(
            "path",
            {
              d: "M29.1782 56.5547C28.0982 56.5547 27.2217 57.4297 27.2217 58.5078C27.2217 59.5859 28.0982 60.4609 29.1782 60.4609C30.2582 60.4609 31.1347 59.5885 31.1347 58.5078C31.1347 57.4271 30.2582 56.5547 29.1782 56.5547Z",
              fill: "#2875B4"
            }
          )
        ] })
      }
    ) }),
    r
  ] }) });
});
aL.displayName = "TableEmpty";
const iL = P.forwardRef((e, t) => {
  const {
    children: r,
    className: n
  } = e;
  return /* @__PURE__ */ d.jsx("div", { ref: t, className: Ne(["pt-4 px-4 border-t border-neutral-300 m:border-none", n]), children: /* @__PURE__ */ d.jsx("div", { className: "flex flex-col-reverse m:flex-row m:justify-between flex-wrap gap-4", children: r }) });
});
iL.displayName = "TableFooter";
const Jv = (e) => {
  const {
    idSearch: t,
    placeholder: r,
    minLengthToSearch: n = 5,
    onSearch: a
  } = e, [i, o] = je(""), s = ye(!0), l = $9(i), c = (f) => {
    const p = f.target.value;
    p.startsWith(" ") || o(p);
  }, u = () => {
    o(""), a !== void 0 && a({
      value: "",
      canSearch: !1
    });
  };
  return Me(() => {
    if (s.current) {
      s.current = !1;
      return;
    }
    a !== void 0 && (l.trim().length >= n ? a({
      value: l.trim(),
      canSearch: !0
    }) : a({
      value: l.trim(),
      canSearch: !1
    }));
  }, [l]), /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
    /* @__PURE__ */ d.jsx("div", { className: "flex-grow", children: /* @__PURE__ */ d.jsx(
      "input",
      {
        type: "text",
        id: t,
        placeholder: r,
        value: i,
        onChange: c,
        className: "w-full h-full px-3 bg-transparent text-neutral-600 placeholder:text-neutral-400 outline-none shadow-transparent",
        style: { textTransform: "none" }
      }
    ) }),
    i.trim().length >= n ? /* @__PURE__ */ d.jsx(
      "button",
      {
        type: "button",
        onClick: u,
        className: "w-[48px] min-w-[48px] flex items-center justify-center border-l border-neutral-300 cursor-pointer",
        children: /* @__PURE__ */ d.jsx(ge, { variant: "close", width: 14 })
      }
    ) : /* @__PURE__ */ d.jsx("label", { htmlFor: t, className: "w-[48px] min-w-[48px] flex items-center justify-center border-l border-neutral-300 cursor-pointer", children: /* @__PURE__ */ d.jsx(ge, { variant: "search", width: 20 }) })
  ] });
}, oL = P.forwardRef((e, t) => {
  const {
    search: r,
    consult: n,
    selectFilter: a,
    permissions: i,
    onClickExport: o,
    onClickReports: s,
    onClickRefresh: l
  } = e, {
    placeholder: c = "Search...",
    minLengthToSearch: u = 5,
    onSearch: f
  } = r, p = F0(), h = (n == null ? void 0 : n.filled) ?? 0, m = () => {
    (n == null ? void 0 : n.onClick) !== void 0 && n.onClick();
  }, v = () => {
    (n == null ? void 0 : n.onReset) !== void 0 && n.onReset();
  }, g = () => {
    s !== void 0 && s();
  }, y = () => {
    o !== void 0 && o();
  }, b = () => {
    l !== void 0 && l();
  }, w = Object.values(i).reduce((x, C) => C ? x + 1 : x, 0);
  return /* @__PURE__ */ d.jsx("div", { ref: t, className: "border-b border-neutral-300 m:border-none px-4 pt-4", children: /* @__PURE__ */ d.jsxs("div", { className: "flex flex-col m:flex-row m:justify-between gap-4", children: [
    /* @__PURE__ */ d.jsxs("div", { className: "flex flex-grow gap-2", children: [
      /* @__PURE__ */ d.jsxs("div", { className: "flex m:flex-grow m:max-w-[800px] justify-between h-[40px] border border-neutral-300 rounded-md bg-neutral-200 w-[100%]", children: [
        /* @__PURE__ */ d.jsx("div", { className: "w-[110px] min-w-[110px] s:w-[140px] s:min-w-[140px] 2s:min-w-[30%] relative h-full border-r border-neutral-300", children: a }),
        /* @__PURE__ */ d.jsx(
          Jv,
          {
            idSearch: p,
            placeholder: c,
            minLengthToSearch: u,
            onSearch: f
          }
        )
      ] }),
      /* @__PURE__ */ d.jsx("div", { className: "border border-white rounded-md bg-secondary-200 flex items-center", children: /* @__PURE__ */ d.jsx("div", { ref: t, className: "flex m:flex-grow", children: /* @__PURE__ */ d.jsx(
        Ut,
        {
          size: "s",
          icon: "refresh-circle",
          onlyIcon: !0,
          variant: "secondary-light",
          onClick: b
        }
      ) }) })
    ] }),
    w > 0 && /* @__PURE__ */ d.jsx("div", { className: "flex flex-col m:flex-row gap-4", children: /* @__PURE__ */ d.jsxs("div", { className: `grid ${w < 2 ? "grid-cols-1" : "grid-table-main-header"} m:flex gap-4`, children: [
      i.consult && /* @__PURE__ */ d.jsxs("div", { className: "relative", children: [
        /* @__PURE__ */ d.jsx(
          "button",
          {
            type: "button",
            onClick: m,
            className: `h-10 w-full bg-secondary-100 text-secondary-600 hover:bg-secondary-200 font-bold flex gap-4 items-center rounded-md border ${h > 0 ? "justify-center s:justify-between pl-4 pr-4 s:pr-[4.5rem] border-secondary-600" : "justify-center px-4 border-transparent"}`,
            children: /* @__PURE__ */ d.jsxs("div", { className: "flex items-center gap-2", children: [
              /* @__PURE__ */ d.jsx("span", { className: "w-[20px] min-w-[20px]", children: /* @__PURE__ */ d.jsx(ge, { variant: "filter" }) }),
              /* @__PURE__ */ d.jsx("span", { children: "Consulta" })
            ] })
          }
        ),
        h > 0 && /* @__PURE__ */ d.jsxs("div", { className: "absolute top-1/2 -translate-y-1/2 right-4 hidden s:flex items-center gap-2 z-[1] pointer-events-none font-bold", children: [
          /* @__PURE__ */ d.jsx("span", { className: "flex w-5 h-5 rounded-full bg-secondary-600 text-white text-xs items-center justify-center", children: h }),
          /* @__PURE__ */ d.jsx(
            "span",
            {
              onClick: v,
              className: "w-[14px] min-w-[14px] hover:scale-110 active:scale-95 pointer-events-auto cursor-pointer text-secondary-600",
              children: /* @__PURE__ */ d.jsx(ge, { variant: "close", width: 14 })
            }
          )
        ] })
      ] }),
      i.reports && /* @__PURE__ */ d.jsx("div", { className: "m:w-[215px]", children: /* @__PURE__ */ d.jsx(Ut, { variant: "secondary", size: "m", isFull: !0, onClick: g, children: /* @__PURE__ */ d.jsx("span", { className: `block ${w > 1 ? "w-[35vw] m:w-auto text-ellipsis overflow-hidden whitespace-nowrap h-[30px] leading-[30px]" : "whitespace-nowrap"}`, children: "Reportes programados" }) }) }),
      i.export && /* @__PURE__ */ d.jsx("div", { className: "m:min-w-[140px]", children: /* @__PURE__ */ d.jsx(Ut, { variant: "secondary-bold", size: "m", isFull: !0, onClick: y, children: "Exportar" }) })
    ] }) })
  ] }) });
});
oL.displayName = "TableHeaderDeclarant";
const sL = P.forwardRef((e, t) => {
  const {
    text: r = "Cargando...",
    className: n
  } = e;
  return /* @__PURE__ */ d.jsx("div", { ref: t, className: Ne(["bg-secondary-100 flex items-center justify-center p-5 rounded-md min-h-[70vh] select-none", n]), children: /* @__PURE__ */ d.jsxs("div", { className: "text-center animate-pulse", children: [
    /* @__PURE__ */ d.jsx("div", { className: "bg-white flex justify-center items-center w-[64px] h-[64px] rounded-md mb-4", children: /* @__PURE__ */ d.jsxs(
      "svg",
      {
        width: 36,
        height: 40,
        viewBox: "0 0 36 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
          /* @__PURE__ */ d.jsx(
            "path",
            {
              d: "M1.65723 39.2676H28.9346C34.1715 39.2676 37.5922 33.638 35.247 28.8537L31.8969 22.001C24.2797 31.012 13.6826 37.3071 1.65723 39.2676Z",
              fill: "#165892"
            }
          ),
          /* @__PURE__ */ d.jsx(
            "path",
            {
              d: "M23.2922 4.46453L22.1638 2.16232C21.2292 0.255791 18.5667 0.255791 17.6322 2.16232L3.87891 30.2386C12.8715 24.1413 19.7834 15.0943 23.2922 4.46453Z",
              fill: "#F15C41"
            }
          ),
          /* @__PURE__ */ d.jsx(
            "path",
            {
              d: "M31.28 20.7422L24.1036 6.10156C20.1363 17.181 12.5367 26.4798 2.78593 32.5051L0 38.2067C12.5014 36.57 23.5569 30.131 31.2976 20.7602L31.28 20.7422Z",
              fill: "#2875B4"
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ d.jsx(yr, { variant: "description-3", children: r })
  ] }) });
});
sL.displayName = "TableLoader";
const em = (e) => {
  const {
    actions: t = [],
    row: r,
    canEdit: n,
    onEditClick: a,
    onActionClick: i,
    onRowClick: o,
    handleDisplayDetail: s,
    handleClickDetail: l,
    showDetail: c
  } = e, [u, f] = je(!1), p = ye(null), h = ye(null), m = () => {
    f(!1), a !== void 0 && a({ row: r });
  }, v = (x) => () => {
    i !== void 0 && i({ row: r, action: x }), f(!1);
  }, g = () => {
    o !== void 0 && o({ row: r });
  }, y = (x) => {
    if (p.current !== null && !p.current.contains(x.target)) {
      if (h.current !== null) {
        if (h.current.contains(x.target))
          return;
        f(!1);
        return;
      }
      f(!1);
    }
  };
  Me(() => (document.addEventListener("click", y, !0), () => {
    document.removeEventListener("click", y, !0);
  }), []);
  const [b, w] = je(!0);
  return /* @__PURE__ */ d.jsxs("div", { className: "relative", children: [
    /* @__PURE__ */ d.jsx(
      Ut,
      {
        type: "button",
        variant: "secondary-light-bold",
        icon: "menu-context",
        tooltip: "Acciones",
        tooltipDirection: "left",
        disabled: t.length === 0,
        ref: p,
        size: "s",
        onlyIcon: !0,
        onClick: () => {
          f((x) => !x);
        }
      }
    ),
    u && /* @__PURE__ */ d.jsx("div", { ref: h, className: "absolute top-[calc(100%+8px)] right-0 z-[20] cursor-default pb-[20px] pointer-events-none", children: /* @__PURE__ */ d.jsx("div", { className: "bg-white min-w-[165px] max-w-[250px] p-4 rounded-md shadow-l pointer-events-auto", children: /* @__PURE__ */ d.jsxs("ul", { children: [
      n && /* @__PURE__ */ d.jsxs(
        "li",
        {
          onClick: m,
          className: "p-2 rounded-md font-bold text-secondary-600 cursor-pointer min-h-[40px] flex items-center gap-2 hover:bg-secondary-200 2s:hidden",
          children: [
            /* @__PURE__ */ d.jsx("span", { className: "w-5 h-5 object-contain min-w-[20px]", children: /* @__PURE__ */ d.jsx(ge, { variant: "edit", isContain: !0 }) }),
            /* @__PURE__ */ d.jsx("p", { className: "leading-[120%] grow w-full text-ellipsis overflow-hidden whitespace-nowrap", children: "Editar" })
          ]
        }
      ),
      t.map((x) => /* @__PURE__ */ d.jsxs(
        "li",
        {
          onClick: v(x),
          className: "p-2 rounded-md font-bold text-secondary-600 cursor-pointer min-h-[40px] flex items-center gap-2 hover:bg-secondary-200",
          children: [
            /* @__PURE__ */ d.jsx("span", { className: "w-5 h-5 object-contain min-w-[20px]", children: /* @__PURE__ */ d.jsx(ge, { variant: x.icon, isContain: !0 }) }),
            /* @__PURE__ */ d.jsx("p", { className: "leading-[120%] grow w-full text-ellipsis overflow-hidden whitespace-nowrap", children: x.title })
          ]
        },
        x.id
      )),
      c && /* @__PURE__ */ d.jsxs(
        "li",
        {
          onClick: () => {
            s !== void 0 && (s({ row: r, isShowDetail: b }), l !== void 0 && l({ row: r }), w((x) => !x));
          },
          className: "p-2 rounded-md font-bold text-secondary-600 cursor-pointer min-h-[40px] flex items-center gap-2 hover:bg-secondary-200 2s:hidden",
          children: [
            /* @__PURE__ */ d.jsx("span", { className: "w-5 h-5 object-contain min-w-[20px]", children: /* @__PURE__ */ d.jsx(ge, { variant: "arrow-down", isContain: !0 }) }),
            /* @__PURE__ */ d.jsx("p", { className: "leading-[120%] grow w-full text-ellipsis overflow-hidden whitespace-nowrap", children: "Ver detalle" })
          ]
        }
      ),
      t.length === 0 && /* @__PURE__ */ d.jsxs(
        "li",
        {
          onClick: g,
          className: "p-2 rounded-md font-bold text-secondary-600 cursor-pointer min-h-[40px] flex items-center gap-2 hover:bg-secondary-200",
          children: [
            /* @__PURE__ */ d.jsx("span", { className: "w-5 h-5 object-contain min-w-[20px]", children: /* @__PURE__ */ d.jsx(ge, { variant: "eye", isContain: !0 }) }),
            /* @__PURE__ */ d.jsx("p", { className: "leading-[120%] grow w-full text-ellipsis overflow-hidden whitespace-nowrap", children: "Ver" })
          ]
        }
      )
    ] }) }) })
  ] });
}, lL = (e) => {
  const {
    actions: t,
    row: r,
    index: n,
    detailData: a = [],
    detailColumns: i = [],
    handleDeleteDetatail: o,
    rowDetail: s,
    NOMCOLXX: l,
    onRowDetailClick: c
  } = e, u = t.filter((f) => f.id === 104);
  return /* @__PURE__ */ d.jsx(d.Fragment, { children: a.map((f, p) => s !== r[l] ? null : /* @__PURE__ */ d.jsxs(
    "div",
    {
      className: "relative p-4 rounded-md bg-secondary-400 hover:bg-secondary-300 hover:text-secondary-600 w-full cursor-pointer",
      onClick: () => {
        c !== void 0 && c({ row: f });
      },
      children: [
        Object.entries(f).map(([h, m]) => i.find((g) => g.id === h) === void 0 ? null : /* @__PURE__ */ d.jsx("p", { className: "w-full text-ellipsis overflow-hidden whitespace-nowrap", children: m })),
        /* @__PURE__ */ d.jsx("div", { className: "absolute top-4 right-4", children: /* @__PURE__ */ d.jsx("div", { className: "bg-secondary-400", children: u && /* @__PURE__ */ d.jsx(
          Ut,
          {
            type: "button",
            variant: "secondary-light-bold",
            icon: "trash",
            tooltip: "Eliminar",
            tooltipDirection: "left",
            size: "s",
            onlyIcon: !0,
            onClick: () => {
              o !== void 0 && o({ item: f, row: r });
            }
          }
        ) }) })
      ]
    },
    `detail-${n}-${p}`
  )) });
}, cL = (e) => {
  const {
    actions: t = [],
    columns: r = [],
    data: n = [],
    canEdit: a,
    onEditClick: i,
    onActionClick: o,
    onRowClick: s,
    handleDisplayDetail: l,
    detailData: c,
    detailColumns: u = [],
    showDetail: f,
    handleDeleteDetatail: p
  } = e, h = u.length > 0 ? u[0].id : "", [m, v] = je(null), g = (y) => {
    const { row: b } = y;
    v(b[h]);
  };
  return /* @__PURE__ */ d.jsx("div", { className: "grid gap-2 2s:hidden", children: n.map((y, b) => /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
    /* @__PURE__ */ d.jsxs(
      "div",
      {
        className: "relative p-4 rounded-md bg-secondary-100 hover:bg-secondary-200 hover:text-secondary-600 w-full cursor-pointer",
        children: [
          /* @__PURE__ */ d.jsx(
            "div",
            {
              className: "flex flex-wrap gap-y-1.5 gap-x-6",
              onClick: () => {
                s !== void 0 && s({ row: y });
              },
              children: Object.entries(y).filter(([w]) => r.some((x) => x.id === w && x.isMobileShow)).map(([w, x]) => {
                const C = r.find((D) => D.id === w);
                if (C === void 0)
                  return null;
                const {
                  isMobileShow: S = !1,
                  isTextBold: E = !1
                } = C;
                return S ? /* @__PURE__ */ d.jsx(
                  "p",
                  {
                    className: `leading-[120%] ${E ? "font-bold" : ""} w-full pr-12`,
                    children: x
                  },
                  w
                ) : null;
              })
            }
          ),
          /* @__PURE__ */ d.jsx("div", { className: "absolute top-4 right-4", children: /* @__PURE__ */ d.jsx(
            em,
            {
              actions: t,
              row: y,
              canEdit: a,
              onEditClick: i,
              onActionClick: o,
              onRowClick: s,
              handleDisplayDetail: l,
              detailColumns: u,
              showDetail: f,
              handleClickDetail: g
            }
          ) })
        ]
      },
      y.id
    ),
    c.length > 0 && /* @__PURE__ */ d.jsx(
      lL,
      {
        actions: t,
        row: y,
        index: b,
        detailData: c,
        detailColumns: u,
        handleDeleteDetatail: p,
        rowDetail: m,
        NOMCOLXX: h,
        onRowDetailClick: s
      }
    )
  ] })) });
}, uL = (e) => {
  const {
    columns: t = [],
    onChangeShowColumn: r
  } = e, [n, a] = je(!1), [i, o] = je(!1), s = ye(null), l = ye(null), c = (u) => {
    if (s.current !== null && !s.current.contains(u.target)) {
      if (l.current !== null) {
        if (l.current.contains(u.target))
          return;
        a(!1);
        return;
      }
      a(!1);
    }
  };
  return Me(() => (document.addEventListener("click", c, !0), () => {
    document.removeEventListener("click", c, !0);
  }), []), Me(() => {
    t.filter((f) => f.canToggleShow).length > 0 ? o(!0) : o(!1);
  }, [t]), i ? /* @__PURE__ */ d.jsxs("div", { className: "relative", children: [
    /* @__PURE__ */ d.jsx(
      Ut,
      {
        type: "button",
        ref: s,
        variant: "secondary",
        icon: "column-actions",
        active: n,
        size: "s",
        onlyIcon: !0,
        tooltip: "Visualizar columnas",
        tooltipDirection: "left",
        onClick: () => {
          a((u) => !u);
        }
      }
    ),
    n && /* @__PURE__ */ d.jsx("div", { ref: l, className: "absolute top-[calc(100%+4px)] right-0 z-[30]", children: /* @__PURE__ */ d.jsxs("div", { className: "bg-white rounded-md shadow-xl w-[330px]", children: [
      /* @__PURE__ */ d.jsx("div", { className: "px-4 py-3.5 border-b border-b-neutral-300", children: /* @__PURE__ */ d.jsx(lr, { variant: "title-2", children: "Ver / esconder columnas" }) }),
      /* @__PURE__ */ d.jsx("div", { className: "p-4", children: /* @__PURE__ */ d.jsx(ds, { gap: 2, children: t.map((u) => u.canToggleShow ? /* @__PURE__ */ d.jsx(
        N9,
        {
          type: "switch",
          variantSize: "xs",
          isBold: !0,
          checked: u.isShow,
          onChange: () => {
            r !== void 0 && r({ column: u });
          },
          children: u.title
        },
        u.id
      ) : null) }) })
    ] }) })
  ] }) : /* @__PURE__ */ d.jsx(d.Fragment, {});
}, fL = (e) => {
  const {
    columns: t = [],
    onColumnClick: r,
    onChangeShowColumn: n,
    isCheckedRow: a,
    setIndiceChecked: i,
    data: o
  } = e, s = (l) => {
    let c = [];
    if (l)
      for (const u of o.keys())
        c.push(u);
    i !== void 0 && i(c);
  };
  return /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
    a && /* @__PURE__ */ d.jsx(
      "div",
      {
        style: { gridArea: "col-reserved-check" },
        className: "min-w-[50px] flex gap-2 justify-between items-center px-4",
        children: /* @__PURE__ */ d.jsx(
          "input",
          {
            type: "checkbox",
            id: "checkAll",
            title: "Seleccionar todos",
            className: "w-full overflow-hidden whitespace-nowrap",
            onClick: (l) => {
              s(l.target.checked);
            }
          }
        )
      }
    ),
    t.filter((l) => l.isShow).map((l) => /* @__PURE__ */ d.jsxs(
      "div",
      {
        style: { gridArea: `col-${l.id}` },
        title: l.title,
        className: `min-w-[205px] flex gap-2 justify-between items-center px-4 font-bold leading-[120%] select-none ${l.sorted && l.orderBy !== null ? "text-secondary-600" : "hover:text-secondary-500"}`,
        children: [
          /* @__PURE__ */ d.jsx("p", { className: "w-full text-ellipsis overflow-hidden whitespace-nowrap", children: l.title }),
          l.sortable && /* @__PURE__ */ d.jsx(
            "button",
            {
              type: "button",
              className: "w-6 h-6 flex items-center justify-center",
              onClick: () => {
                r !== void 0 && r({ column: l });
              },
              children: /* @__PURE__ */ d.jsxs(
                "svg",
                {
                  className: "w-5",
                  viewBox: "0 0 25 24",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                  children: [
                    /* @__PURE__ */ d.jsx(
                      "path",
                      {
                        d: "M16.743 10L8.25505 10C8.1049 9.9994 7.95831 9.95665 7.83381 9.87715C7.70931 9.79765 7.6125 9.68497 7.55561 9.55336C7.49873 9.42176 7.48433 9.27713 7.51423 9.13777C7.54413 8.99841 7.61699 8.87057 7.7236 8.77043L11.96 4.75815C12.0306 4.69075 12.1145 4.63726 12.207 4.60075C12.2996 4.56425 12.3988 4.54545 12.499 4.54545C12.5992 4.54545 12.6985 4.56425 12.791 4.60075C12.8835 4.63726 12.9675 4.69075 13.0381 4.75815L17.2744 8.77043C17.3811 8.87057 17.4539 8.99841 17.4838 9.13777C17.5137 9.27713 17.4993 9.42176 17.4424 9.55337C17.3855 9.68497 17.2887 9.79765 17.1642 9.87715C17.0397 9.95665 16.8931 9.9994 16.743 10Z",
                        fill: l.sorted && l.orderBy === "asc" ? "#2875B4" : "#E6E6E6"
                      }
                    ),
                    /* @__PURE__ */ d.jsx(
                      "path",
                      {
                        d: "M8.25505 14H16.743C16.8931 14.0006 17.0397 14.0433 17.1642 14.1228C17.2887 14.2023 17.3855 14.315 17.4424 14.4466C17.4993 14.5782 17.5137 14.7229 17.4838 14.8622C17.4539 15.0016 17.3811 15.1294 17.2744 15.2296L13.0381 19.2419C12.9675 19.3092 12.8835 19.3627 12.791 19.3992C12.6985 19.4358 12.5992 19.4545 12.499 19.4545C12.3988 19.4545 12.2996 19.4358 12.207 19.3992C12.1145 19.3627 12.0306 19.3092 11.96 19.2419L7.7236 15.2296C7.61699 15.1294 7.54413 15.0016 7.51423 14.8622C7.48433 14.7229 7.49873 14.5782 7.55561 14.4466C7.6125 14.315 7.70931 14.2023 7.83381 14.1228C7.95831 14.0433 8.1049 14.0006 8.25505 14Z",
                        fill: l.sorted && l.orderBy === "desc" ? "#2875B4" : "#E6E6E6"
                      }
                    )
                  ]
                }
              )
            }
          )
        ]
      },
      l.id
    )),
    /* @__PURE__ */ d.jsx("div", { className: "sticky right-0 bg-white", style: { gridArea: "col-reserved-actions" }, children: /* @__PURE__ */ d.jsxs("div", { className: "flex items-center justify-between pl-4 pr-2 h-10 select-none", children: [
      /* @__PURE__ */ d.jsx("p", { className: "font-bold", children: "Acciones" }),
      /* @__PURE__ */ d.jsx(
        uL,
        {
          columns: t,
          onChangeShowColumn: n
        }
      )
    ] }) })
  ] });
}, dL = (e) => {
  const {
    actions: t,
    row: r,
    index: n,
    detailData: a = [],
    detailColumns: i = [],
    handleDeleteDetatail: o,
    rowDetail: s,
    NOMCOLXX: l,
    onRowDetailClick: c
  } = e, u = i.map((v) => `col-${v.id}`).concat("col-reserved-actions").join(" ").toString();
  let f = 0;
  const p = Array.from({ length: i.length }, () => {
    let v = "1fr";
    return f === 0 && (v = "0.2fr"), f++, v;
  }).join(" ").toString(), h = { gridTemplateAreas: `'${u}'`, gridTemplateColumns: p + " 150px" }, m = t.filter((v) => v.id === "toggle");
  return /* @__PURE__ */ d.jsx(d.Fragment, { children: a.map((v, g) => s !== r[l] ? null : /* @__PURE__ */ d.jsxs(
    "div",
    {
      style: h,
      className: "bg-secondary-400 hover:bg-secondary-300 hover:text-secondary-600 cursor-pointer border-b border-white last:border-none h-[48px] grid w-full",
      children: [
        /* @__PURE__ */ d.jsx("div", { className: "bg-white", children: /* @__PURE__ */ d.jsx("div", { className: "flex items-center gap-2 h-[48px]", children: /* @__PURE__ */ d.jsx(ge, { variant: "arrow-turn-down-right" }) }) }),
        Object.entries(v).map(([y, b]) => {
          const w = i.find((x) => x.id === y);
          return w === void 0 ? null : /* @__PURE__ */ d.jsx(
            "div",
            {
              style: { gridArea: `col-${w.id}` },
              title: b,
              className: "min-w-[205px] flex items-center px-4 border-l border-white first:border-none leading-[120%]",
              onClick: () => {
                c !== void 0 && c({ row: v });
              },
              children: /* @__PURE__ */ d.jsx("p", { className: "w-full text-ellipsis overflow-hidden whitespace-nowrap", children: b })
            },
            y
          );
        }),
        /* @__PURE__ */ d.jsx("div", { className: "bg-white sticky block right-0 border-l border-white cursor-default pr-1", children: /* @__PURE__ */ d.jsx("div", { className: "bg-secondary-400", children: /* @__PURE__ */ d.jsx("div", { className: "flex items-center gap-2 h-[48px] px-4", children: m.length > 0 && /* @__PURE__ */ d.jsx(
          Ut,
          {
            type: "button",
            variant: "secondary-light-bold",
            icon: "trash",
            tooltip: "Eliminar",
            tooltipDirection: "left",
            size: "s",
            onlyIcon: !0,
            onClick: () => {
              o !== void 0 && o({ item: v, row: r });
            }
          }
        ) }) }) })
      ]
    },
    `detail-${n}-${g}`
  )) });
}, pL = (e) => {
  const {
    actions: t = [],
    columns: r = [],
    data: n = [],
    canEdit: a,
    activeRowValidation: i,
    onEditClick: o,
    onActionClick: s,
    onRowClick: l,
    onColumnClick: c,
    onChangeShowColumn: u,
    handleDisplayDetail: f,
    detailData: p = [],
    detailColumns: h = [],
    showDetail: m,
    handleDeleteDetatail: v,
    isCheckedRow: g,
    handleCheckedRow: y,
    colorColumn: b,
    intermediateContent: w
  } = e, x = (g ? "col-reserved-check " : "") + r.filter((K) => K.isShow).map((K) => `col-${K.id}`).concat("col-reserved-actions").join(" ").toString(), C = (g ? "50px " : "") + Array.from({ length: r.filter((K) => K.isShow).length }, () => "1fr").concat("150px").join(" ").toString(), S = { gridTemplateAreas: `'${x}'`, gridTemplateColumns: C }, [E, D] = je(null), I = h.length > 0 ? h[0].id : "", [k, V] = je(!0), W = (K) => {
    const { row: te } = K;
    D(te[I]);
  }, L = [], [G, Q] = je(L), X = (K, te) => {
    Q(K ? (_) => [..._, te] : (_) => _.filter((j) => j !== te));
  };
  return Me(() => {
    let K = [];
    G.length > 0 && G.forEach((te) => {
      K.push(n[te]);
    }), y !== void 0 && y({ rows: K });
  }, [G]), /* @__PURE__ */ d.jsx("div", { className: "grid gap-2 hidden 2s:block", children: /* @__PURE__ */ d.jsx("div", { className: `${w ? "" : "max-h-[calc(100vh-461px)] min-h-[calc(100vh-461px)]"}
                        ${w ? "" : "m:max-h-[calc(100vh-305px)] m:min-h-[calc(100vh-305px)]"}
                        ${w ? "" : "l:max-h-[calc(100vh-312px)] l:min-h-[calc(100vh-312px)]"}
                        ${w ? "table-max-height" : ""}
                        w-full overflow-x-auto overflow-y-auto table-main-scrollbar pb-1`, children: /* @__PURE__ */ d.jsxs("div", { className: "min-w-[min-content]", children: [
    /* @__PURE__ */ d.jsx("div", { className: "bg-white grid w-full h-10 sticky top-0", style: { ...S, zIndex: n.length + 10 }, children: /* @__PURE__ */ d.jsx(
      fL,
      {
        columns: r,
        onColumnClick: c,
        onChangeShowColumn: u,
        isCheckedRow: g,
        setIndiceChecked: Q,
        data: n
      }
    ) }),
    /* @__PURE__ */ d.jsx("div", { className: "bg-secondary-100 w-full", children: /* @__PURE__ */ d.jsx("div", { children: n.map((K, te) => {
      const _ = te % 2 === 0, T = (i === void 0 || K[i.field] === void 0 ? !0 : K[i.field] === i.value) ? _ ? "bg-secondary-200" : "bg-secondary-100" : "bg-neutral-200 text-neutral-400";
      return /* @__PURE__ */ d.jsxs(ea, { children: [
        /* @__PURE__ */ d.jsxs(
          "div",
          {
            style: S,
            className: `${T} hover:bg-secondary-300 hover:text-secondary-600 cursor-pointer border-b border-white last:border-none h-[48px] grid w-full`,
            children: [
              g && /* @__PURE__ */ d.jsx("div", { className: "min-w-[50px] flex justify-between items-center pr-1", children: /* @__PURE__ */ d.jsx(
                "input",
                {
                  type: "checkbox",
                  title: "Seleccionar",
                  checked: G.includes(te),
                  value: te,
                  className: "checkbox w-full overflow-hidden whitespace-nowrap",
                  onChange: (A) => {
                    X(A.target.checked, te);
                  }
                }
              ) }),
              Object.entries(K).map(([A, O]) => {
                const N = r.find(($) => $.id === A);
                if (N === void 0 || !N.isShow)
                  return null;
                const {
                  isTextBold: q = !1
                } = N;
                let Y = !1, z = "", R = b ? b.filter(($) => $.title === A) : [];
                if (R.length > 0) {
                  Y = !0;
                  const $ = R[0].params.filter((B) => B.value === O), F = $.length > 0 ? $[0].color : "transparent";
                  z = Ae[F];
                }
                return /* @__PURE__ */ d.jsx(
                  "div",
                  {
                    style: { gridArea: `col-${N.id}` },
                    title: O,
                    className: `min-w-[205px] flex items-center px-4 border-l border-white first:border-none leading-[120%] ${q ? "font-bold" : ""}`,
                    onClick: () => {
                      l !== void 0 && !N.onClickCell && l({ row: K });
                    },
                    children: Y ? /* @__PURE__ */ d.jsx("div", { className: "w-full h-8 px-4 justify-center items-center gap-2 flex", style: { borderRadius: "8px", backgroundColor: z }, children: /* @__PURE__ */ d.jsx("div", { className: "grow text-center text-white text-xs font-bold leading-[14.40px]", children: O }) }) : /* @__PURE__ */ d.jsx(
                      "p",
                      {
                        className: `w-full text-ellipsis overflow-hidden whitespace-nowrap ${N.isHyperlink ? "underline text-secondary-600" : ""}`,
                        onClick: () => N.onClickCell && N.onClickCell(K),
                        children: O
                      }
                    )
                  },
                  A
                );
              }),
              /* @__PURE__ */ d.jsx("div", { className: "bg-white sticky block right-0 border-l border-white cursor-default pr-1", style: { zIndex: n.length - te + 1 }, children: /* @__PURE__ */ d.jsx("div", { className: T, children: /* @__PURE__ */ d.jsxs("div", { className: `flex items-center gap-2 h-[48px] ${a ? "px-4" : "pl-6 pr-4"} ${te + 1 === n.length ? "" : "border-b border-white"}`, children: [
                a && /* @__PURE__ */ d.jsx(
                  Ut,
                  {
                    type: "button",
                    variant: "secondary-light-bold",
                    icon: "edit",
                    tooltip: "Editar",
                    tooltipDirection: "left",
                    size: "s",
                    onlyIcon: !0,
                    onClick: () => {
                      o !== void 0 && o({ row: K });
                    }
                  }
                ),
                /* @__PURE__ */ d.jsx(
                  em,
                  {
                    actions: t,
                    row: K,
                    canEdit: a,
                    onEditClick: o,
                    onActionClick: s,
                    onRowClick: l,
                    handleDisplayDetail: f,
                    detailColumns: h,
                    showDetail: m,
                    handleClickDetail: W
                  }
                ),
                m && /* @__PURE__ */ d.jsx(d.Fragment, { children: /* @__PURE__ */ d.jsx(
                  Ut,
                  {
                    type: "button",
                    variant: "secondary-light-bold",
                    icon: "arrow-down",
                    tooltip: "Ver Detalle",
                    tooltipDirection: "left",
                    size: "s",
                    onlyIcon: !0,
                    onClick: () => {
                      f !== void 0 && (f({ row: K, isShowDetail: k }), W({ row: K }), V((A) => !A));
                    }
                  }
                ) })
              ] }) }) })
            ]
          },
          K.id
        ),
        p.length > 0 && /* @__PURE__ */ d.jsx(
          dL,
          {
            actions: t,
            row: K,
            index: te,
            detailData: p,
            detailColumns: h,
            handleDeleteDetatail: v,
            rowDetail: E,
            NOMCOLXX: I,
            onRowDetailClick: l
          }
        )
      ] }, `fragment-${te}`);
    }) }) })
  ] }) }) });
}, hL = P.forwardRef((e, t) => {
  const {
    actions: r = [],
    columns: n = [],
    data: a = [],
    canEdit: i = !1,
    activeRowValidation: o,
    className: s,
    onEditClick: l,
    onActionClick: c,
    onRowClick: u,
    onColumnClick: f,
    onChangeShowColumn: p,
    handleDisplayDetail: h,
    detailData: m = [],
    detailColumns: v = [],
    showDetail: g = !1,
    handleDeleteDetatail: y,
    isCheckedRow: b = !1,
    handleCheckedRow: w,
    colorColumn: x,
    intermediateContent: C
  } = e;
  return n.length < 1 ? null : /* @__PURE__ */ d.jsxs("div", { ref: t, className: Ne(["block", s]), children: [
    /* @__PURE__ */ d.jsx(
      cL,
      {
        actions: r,
        columns: n,
        data: a,
        canEdit: i,
        onEditClick: l,
        onActionClick: c,
        onRowClick: u,
        handleDisplayDetail: h,
        detailData: m,
        detailColumns: v,
        showDetail: g,
        handleDeleteDetatail: y
      }
    ),
    /* @__PURE__ */ d.jsx(
      pL,
      {
        actions: r,
        columns: n,
        data: a,
        activeRowValidation: o,
        canEdit: i,
        onEditClick: l,
        onActionClick: c,
        onRowClick: u,
        onColumnClick: f,
        onChangeShowColumn: p,
        handleDisplayDetail: h,
        detailData: m,
        detailColumns: v,
        showDetail: g,
        handleDeleteDetatail: y,
        isCheckedRow: b,
        handleCheckedRow: w,
        colorColumn: x,
        intermediateContent: C
      }
    )
  ] });
});
hL.displayName = "TableMain";
function Fl() {
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
}
const vL = P.forwardRef((e, t) => {
  const {
    items: r = [],
    prevActive: n = !1,
    nextActive: a = !1,
    className: i,
    onItemClick: o,
    onPrevClick: s = () => {
    },
    onNextClick: l = () => {
    },
    trackingMeta: c
  } = e;
  return /* @__PURE__ */ d.jsxs("div", { ref: t, className: Ne(["flex flex-wrap justify-center gap-4", i]), children: [
    /* @__PURE__ */ d.jsx(
      "button",
      {
        type: "button",
        className: "bg-secondary-600 rounded-md w-8 h-8 flex items-center justify-center text-white disabled:bg-neutral-300 disabled:pointer-events-none",
        disabled: !n,
        onClick: () => {
          n && (s(), Fl());
        },
        children: /* @__PURE__ */ d.jsx("span", { className: "w-[20px] min-w-[20px]", children: /* @__PURE__ */ d.jsx(ge, { variant: "back-arrow", width: 18 }) })
      }
    ),
    r.map((u) => {
      const f = (u == null ? void 0 : u.isActive) ?? !0, p = (u == null ? void 0 : u.isDisabled) ?? !1;
      return /* @__PURE__ */ d.jsx(
        "button",
        {
          type: "button",
          className: `w-8 h-8 flex justify-center items-center rounded-md font-bold ${f ? "bg-secondary-600 text-white pointer-events-none" : "bg-secondary-100 text-secondary-600 hover:bg-secondary-600 hover:text-white"} disabled:pointer-events-none`,
          disabled: p,
          onClick: () => {
            p || f || o !== void 0 && (o({ item: u }), Fl());
          },
          children: u.label
        },
        u.label
      );
    }),
    /* @__PURE__ */ d.jsx(
      "button",
      {
        type: "button",
        className: "bg-secondary-600 rounded-md w-8 h-8 flex items-center justify-center text-white disabled:bg-neutral-300 disabled:pointer-events-none",
        disabled: !a,
        onClick: () => {
          a && (l(), Fl());
        },
        children: /* @__PURE__ */ d.jsx("span", { className: "w-[20px] min-w-[20px] -rotate-180", children: /* @__PURE__ */ d.jsx(ge, { variant: "back-arrow", width: 18 }) })
      }
    ),
    /* @__PURE__ */ d.jsxs("p", { className: "text-ellipsis text-secondary-600 font-bold", children: [
      "Mostrando registros del ",
      c.from,
      " a ",
      c.to,
      " de un total de ",
      c.total,
      " registros"
    ] })
  ] });
});
vL.displayName = "TablePagination";
const mL = P.forwardRef((e, t) => {
  const {
    pages: r = [],
    onChangePage: n,
    className: a
  } = e, [i, o] = je(!1), [s, l] = je([]), c = s.find((u) => u.isActive);
  return Me(() => {
    l(r);
  }, [r]), /* @__PURE__ */ d.jsxs("div", { ref: t, className: Ne(["flex items-center justify-center gap-4", a]), children: [
    /* @__PURE__ */ d.jsx(lr, { variant: "title-2", children: "Items por página" }),
    /* @__PURE__ */ d.jsxs("div", { className: "flex-grow max-w-[100px] m:min-w-[100px] relative", children: [
      /* @__PURE__ */ d.jsxs(
        "button",
        {
          type: "button",
          className: `h-8 bg-neutral-200 border ${i ? "border-secondary-600" : "border-neutral-300 hover:border-secondary-400"} rounded-md w-full flex items-center justify-between gap-2 px-4`,
          onClick: () => {
            o((u) => !u);
          },
          children: [
            /* @__PURE__ */ d.jsx("span", { className: "block flex-grow text-left", children: (c == null ? void 0 : c.size) ?? "-" }),
            s.length > 0 && /* @__PURE__ */ d.jsx("span", { className: `w-[15px] min-w-[15px] ${i ? "-rotate-180" : ""}`, children: /* @__PURE__ */ d.jsx(ge, { variant: "arrow-down", width: 15 }) })
          ]
        }
      ),
      s.length > 0 && i && /* @__PURE__ */ d.jsx("ul", { className: "absolute left-0 w-full bg-neutral-200 border border-neutral-300 rounded-md bottom-[calc(100%+8px)] shadow-m z-[1000] p-2 overflow-hidden", children: s.map((u) => /* @__PURE__ */ d.jsx(
        "li",
        {
          className: `px-4 py-3 rounded-md cursor-pointer leading-[120%] ${u.isActive ? "text-white bg-secondary-600" : "hover:bg-secondary-200"}`,
          onClick: () => {
            o(!1), !u.isActive && (l((f) => f.map((p) => p.size === u.size ? { ...p, isActive: !0 } : { ...p, isActive: !1 })), n !== void 0 && n({ page: u }), Fl());
          },
          children: u.size
        },
        u.size
      )) })
    ] })
  ] });
});
mL.displayName = "TableShowPages";
const gL = "animation-toast-in flex items-center justify-between gap-3 text-white font-bold py-4 px-5 rounded-[16px]", yL = {
  error: "bg-error-600",
  success: "bg-success-600",
  info: "bg-secondary-600",
  warning: "bg-warning-500"
}, bL = {
  error: `
    <svg width="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke-width="1.8" stroke="white">
      <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
    </svg>
  `,
  success: `
    <svg width="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.0674 20.3836L23.3861 14.2929C23.9154 13.7822 23.9314 12.9369 23.4194 12.4076C22.9087 11.8782 22.0647 11.8622 21.5341 12.3729L15.1981 18.4809C14.6767 19.0022 13.8354 19.0022 13.2781 18.4476L10.2407 15.6249C9.70473 15.1249 8.8594 15.1542 8.35673 15.6942C7.8554 16.2329 7.88607 17.0769 8.42607 17.5782L11.4287 20.3676C12.2101 21.1489 13.2381 21.5396 14.2634 21.5396C15.2834 21.5396 16.2981 21.1542 17.0687 20.3849L17.0674 20.3836Z" fill="white"/>
      <path d="M32 16C32 24.8227 24.8227 32 16 32C7.17733 32 0 24.8227 0 16C0 7.17733 7.17733 0 16 0C24.8227 0 32 7.17733 32 16ZM29.3333 16C29.3333 8.648 23.352 2.66667 16 2.66667C8.648 2.66667 2.66667 8.648 2.66667 16C2.66667 23.352 8.648 29.3333 16 29.3333C23.352 29.3333 29.3333 23.352 29.3333 16Z" fill="white"/>
    </svg>
  `,
  info: `
    <svg width="32" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16 0.727295C12.8355 0.727295 9.74207 1.66568 7.11088 3.42378C4.4797 5.18188 2.42894 7.68074 1.21793 10.6044C0.00693257 13.528 -0.309921 16.745 0.307443 19.8487C0.924806 22.9524 2.44866 25.8034 4.6863 28.041C6.92394 30.2786 9.77486 31.8025 12.8786 32.4199C15.9823 33.0372 19.1993 32.7204 22.1229 31.5094C25.0466 30.2984 27.5454 28.2476 29.3035 25.6164C31.0616 22.9852 32 19.8918 32 16.7273C31.9954 12.4852 30.3082 8.41824 27.3086 5.41865C24.3091 2.41907 20.2421 0.731883 16 0.727295ZM16 30.0606C13.3629 30.0606 10.7851 29.2786 8.5924 27.8135C6.39975 26.3485 4.69078 24.2661 3.68161 21.8297C2.67244 19.3934 2.4084 16.7125 2.92287 14.1261C3.43734 11.5397 4.70722 9.1639 6.57192 7.2992C8.43661 5.4345 10.8124 4.16463 13.3988 3.65016C15.9852 3.13569 18.6661 3.39973 21.1024 4.4089C23.5388 5.41807 25.6212 7.12704 27.0863 9.31969C28.5513 11.5123 29.3333 14.0902 29.3333 16.7273C29.3295 20.2623 27.9234 23.6514 25.4238 26.1511C22.9242 28.6507 19.535 30.0567 16 30.0606Z" fill="white"/>
      <path d="M16.9563 7.47798C16.1874 7.33789 15.3971 7.3685 14.6414 7.56764C13.8856 7.76678 13.1829 8.12959 12.5829 8.63039C11.9828 9.13119 11.5002 9.75774 11.1691 10.4657C10.8381 11.1737 10.6666 11.9458 10.667 12.7273C10.667 13.0809 10.8075 13.4201 11.0575 13.6701C11.3076 13.9202 11.6467 14.0606 12.0003 14.0606C12.3539 14.0606 12.6931 13.9202 12.9431 13.6701C13.1932 13.4201 13.3337 13.0809 13.3337 12.7273C13.3333 12.335 13.4195 11.9475 13.5862 11.5923C13.7528 11.2372 13.9958 10.9232 14.2977 10.6727C14.5996 10.4222 14.9531 10.2414 15.3329 10.1432C15.7127 10.0451 16.1095 10.0319 16.495 10.1046C17.0217 10.2069 17.506 10.4638 17.886 10.8426C18.266 11.2214 18.5244 11.7049 18.6283 12.2313C18.7333 12.7839 18.6608 13.3554 18.4213 13.8643C18.1819 14.3732 17.7876 14.7933 17.295 15.0646C16.4792 15.5373 15.8051 16.22 15.3429 17.0417C14.8807 17.8634 14.6473 18.7941 14.667 19.7366V20.7273C14.667 21.0809 14.8075 21.4201 15.0575 21.6701C15.3076 21.9202 15.6467 22.0606 16.0003 22.0606C16.3539 22.0606 16.6931 21.9202 16.9431 21.6701C17.1932 21.4201 17.3337 21.0809 17.3337 20.7273V19.7366C17.3169 19.2727 17.4227 18.8125 17.6404 18.4024C17.8581 17.9923 18.18 17.6468 18.5737 17.4006C19.5397 16.8701 20.3176 16.0533 20.8004 15.0625C21.2833 14.0718 21.4473 12.9558 21.27 11.868C21.0927 10.7802 20.5828 9.7741 19.8103 8.98798C19.0379 8.20185 18.0408 7.67433 16.9563 7.47798Z" fill="white"/>
      <path d="M17.3337 24.7279C17.3337 23.9915 16.7367 23.3945 16.0003 23.3945C15.2639 23.3945 14.667 23.9915 14.667 24.7279C14.667 25.4642 15.2639 26.0612 16.0003 26.0612C16.7367 26.0612 17.3337 25.4642 17.3337 24.7279Z" fill="white"/>
    </svg>
  `,
  warning: `
    <svg width="32" viewBox="0 0 32 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.6636 16.7283V8.72391C14.6636 7.99017 15.2639 7.38984 15.9977 7.38984C16.7314 7.38984 17.3317 7.99017 17.3317 8.72391V16.7283C17.3317 17.4621 16.7314 18.0624 15.9977 18.0624C15.2639 18.0624 14.6636 17.4621 14.6636 16.7283ZM15.9977 19.3965C14.8904 19.3965 13.9965 20.2903 13.9965 21.3976C13.9965 22.5049 14.8904 23.3987 15.9977 23.3987C17.1049 23.3987 17.9988 22.5049 17.9988 21.3976C17.9988 20.2903 17.1049 19.3965 15.9977 19.3965ZM31.4462 25.9067C30.5123 27.7077 28.5513 28.735 26.0966 28.735H5.91207C3.44404 28.735 1.4963 27.7077 0.562449 25.9067C-0.384741 24.0924 -0.117927 21.7711 1.22948 19.8234L11.9554 2.854C12.9026 1.49324 14.3968 0.719482 15.9977 0.719482C17.5985 0.719482 19.0927 1.49324 19.9999 2.81397L30.7792 19.8501C32.1266 21.7978 32.38 24.1057 31.4328 25.9067H31.4462ZM28.5779 21.3442C28.5779 21.3442 28.5513 21.3175 28.5513 21.2909L17.7853 4.28145C17.3984 3.73448 16.7314 3.38762 15.9977 3.38762C15.2639 3.38762 14.5969 3.73448 14.1833 4.33482L3.44404 21.2909C2.61692 22.4648 2.43015 23.7456 2.91041 24.6661C3.37734 25.5732 4.44459 26.0668 5.89873 26.0668H26.0699C27.524 26.0668 28.5913 25.5732 29.0582 24.6661C29.5385 23.7456 29.3517 22.4648 28.5646 21.3442H28.5779Z" fill="white"/>
    </svg>
  `
}, CL = `
  <svg width="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.9998 0.999818C12.8123 0.812347 12.558 0.707031 12.2928 0.707031C12.0277 0.707031 11.7733 0.812347 11.5858 0.999818L6.99982 5.58582L2.41382 0.999818C2.22629 0.812347 1.97198 0.707031 1.70682 0.707031C1.44165 0.707031 1.18735 0.812347 0.999818 0.999818C0.812347 1.18735 0.707031 1.44165 0.707031 1.70682C0.707031 1.97198 0.812347 2.22629 0.999818 2.41382L5.58582 6.99982L0.999818 11.5858C0.812347 11.7733 0.707031 12.0277 0.707031 12.2928C0.707031 12.558 0.812347 12.8123 0.999818 12.9998C1.18735 13.1873 1.44165 13.2926 1.70682 13.2926C1.97198 13.2926 2.22629 13.1873 2.41382 12.9998L6.99982 8.41382L11.5858 12.9998C11.7733 13.1873 12.0277 13.2926 12.2928 13.2926C12.558 13.2926 12.8123 13.1873 12.9998 12.9998C13.1873 12.8123 13.2926 12.558 13.2926 12.2928C13.2926 12.0277 13.1873 11.7733 12.9998 11.5858L8.41382 6.99982L12.9998 2.41382C13.1873 2.22629 13.2926 1.97198 13.2926 1.70682C13.2926 1.44165 13.1873 1.18735 12.9998 0.999818Z" fill="white"/>
  </svg>
`, xL = P.forwardRef((e, t) => {
  const {
    className: r
  } = e, n = ye(null);
  return Me(() => {
    const a = (i) => {
      var g;
      let o;
      const l = i.detail, c = l.duration ?? 6e3, u = (l == null ? void 0 : l.autoHide) ?? !0, f = document.createElement("div"), p = `${gL} ${yL[l.variant]}`.trim();
      f.setAttribute("class", p), u && (o = setTimeout(() => {
        f.classList.add("animation-toast-out"), l.onClose !== void 0 && l.onClose(), setTimeout(() => {
          f.style.display = "none";
        }, 250);
      }, c));
      const h = document.createElement("div");
      h.setAttribute("class", "w-8 min-w-[32px]"), h.innerHTML = `${bL[l.variant]}`;
      const m = document.createElement("p");
      m.setAttribute("class", "cursor-default flex-grow leading-[120%]"), m.innerText = l.text;
      const v = document.createElement("button");
      v.setAttribute("class", "w-10 min-w-[40px] h-10 rounded-md flex items-center justify-center bg-[rgba(255,255,255,0.18)]"), v.innerHTML = CL, v.onclick = () => {
        f.classList.add("animation-toast-out"), l.onClose !== void 0 && l.onClose(), clearTimeout(o), setTimeout(() => {
          f.style.display = "none";
        }, 250);
      }, f.append(h), f.append(m), f.append(v), (g = n.current) == null || g.append(f);
    };
    return document.addEventListener("codekit:shootToast", a, !0), () => {
      document.removeEventListener("codekit:shootToast", a, !0);
    };
  }, []), /* @__PURE__ */ d.jsx("div", { ref: t, className: Ne(["fixed bottom-6 left-0 w-full pointer-events-none z-[2000] px-4", r]), children: /* @__PURE__ */ d.jsx("div", { ref: n, className: "grid gap-2 w-full max-w-[610px] mx-auto" }) });
});
xL.displayName = "Toast";
const Due = (e) => {
  const t = new CustomEvent("codekit:shootToast", {
    detail: e
  });
  document.dispatchEvent(t);
}, wL = P.forwardRef((e, t) => {
  const {
    children: r,
    variant: n,
    color: a,
    alignment: i,
    asSpan: o = !1,
    ...s
  } = e, c = `${{
    "body-1": "text-[20px]",
    "body-2": "text-[16px]",
    "body-3": "text-[14px]",
    "body-4": "text-[12px]"
  }[n]} not-italic font-normal leading-[160%]`, u = {
    textAlign: i,
    color: a !== void 0 ? Ae[a] : void 0
  };
  return o ? /* @__PURE__ */ d.jsx("span", { ref: t, className: c, style: u, ...s, children: r }) : /* @__PURE__ */ d.jsx("p", { ref: t, className: c, style: u, ...s, children: r });
});
wL.displayName = "Body";
const tm = P.forwardRef((e, t) => {
  const {
    children: r,
    variant: n,
    color: a,
    alignment: i,
    asSpan: o = !1,
    ...s
  } = e, c = `${{
    "description-1": "text-[20px]",
    "description-2": "text-[16px]",
    "description-3": "text-[14px]",
    "description-4": "text-[12px]"
  }[n]} not-italic font-normal leading-[120%]`, u = {
    textAlign: i,
    color: a !== void 0 ? Ae[a] : void 0
  };
  return o ? /* @__PURE__ */ d.jsx("span", { ref: t, className: c, style: u, ...s, children: r }) : /* @__PURE__ */ d.jsx("p", { ref: t, className: c, style: u, ...s, children: r });
});
tm.displayName = "Description";
const yr = tm, rm = P.forwardRef((e, t) => {
  const {
    children: r,
    variant: n,
    color: a,
    alignment: i,
    asSpan: o = !1,
    ...s
  } = e, l = "not-italic font-bold leading-[120%]", c = {
    textAlign: i,
    color: a !== void 0 ? Ae[a] : void 0
  };
  if (n === "heading-1") {
    const u = `${l} text-[48px]`;
    return o ? /* @__PURE__ */ d.jsx("span", { ref: t, className: u, style: c, ...s, children: r }) : /* @__PURE__ */ d.jsx("h1", { ref: t, className: u, style: c, ...s, children: r });
  }
  if (n === "heading-2") {
    const u = `${l} text-[40px]`;
    return o ? /* @__PURE__ */ d.jsx("span", { ref: t, className: u, style: c, ...s, children: r }) : /* @__PURE__ */ d.jsx("h2", { ref: t, className: u, style: c, ...s, children: r });
  }
  if (n === "heading-3") {
    const u = `${l} text-[34px]`;
    return o ? /* @__PURE__ */ d.jsx("span", { ref: t, className: u, style: c, ...s, children: r }) : /* @__PURE__ */ d.jsx("h3", { ref: t, className: u, style: c, ...s, children: r });
  }
  if (n === "heading-4") {
    const u = `${l} text-[28px]`;
    return o ? /* @__PURE__ */ d.jsx("span", { ref: t, className: u, style: c, ...s, children: r }) : /* @__PURE__ */ d.jsx("h4", { ref: t, className: u, style: c, ...s, children: r });
  }
  if (n === "heading-5") {
    const u = `${l} text-[24px]`;
    return o ? /* @__PURE__ */ d.jsx("span", { ref: t, className: u, style: c, ...s, children: r }) : /* @__PURE__ */ d.jsx("h5", { ref: t, className: u, style: c, ...s, children: r });
  }
  if (n === "heading-6") {
    const u = `${l} text-[20px]`;
    return o ? /* @__PURE__ */ d.jsx("span", { ref: t, className: u, style: c, ...s, children: r }) : /* @__PURE__ */ d.jsx("h6", { ref: t, className: u, style: c, ...s, children: r });
  }
  return null;
});
rm.displayName = "Heading";
const Sn = rm, OL = P.forwardRef((e, t) => {
  const {
    children: r,
    variant: n,
    color: a,
    alignment: i,
    asSpan: o = !1,
    ...s
  } = e, c = `${{
    "overheading-1": "font-normal text-[14px] tracking-[0.44em]",
    "hyperlink-1": "font-bold text-[16px] underline"
  }[n]} not-italic leading-[100%]`, u = {
    textAlign: i,
    color: a !== void 0 ? Ae[a] : void 0
  };
  return o ? /* @__PURE__ */ d.jsx("span", { ref: t, className: c, style: u, ...s, children: r }) : /* @__PURE__ */ d.jsx("p", { ref: t, className: c, style: u, ...s, children: r });
});
OL.displayName = "TextOther";
const nm = P.forwardRef((e, t) => {
  const {
    children: r,
    variant: n,
    color: a,
    alignment: i,
    asSpan: o = !1,
    ...s
  } = e, c = `${{
    "title-1": "text-[20px]",
    "title-2": "text-[16px]",
    "title-3": "text-[14px]",
    "title-4": "text-[12px]"
  }[n]} not-italic font-bold leading-[120%]`, u = {
    textAlign: i,
    color: a !== void 0 ? Ae[a] : void 0
  };
  return o ? /* @__PURE__ */ d.jsx("span", { ref: t, className: c, style: u, ...s, children: r }) : /* @__PURE__ */ d.jsx("p", { ref: t, className: c, style: u, ...s, children: r });
});
nm.displayName = "Title";
const lr = nm, SL = P.forwardRef((e, t) => {
  const {
    alignment: r,
    children: n,
    weight: a = "bold",
    color: i,
    ...o
  } = e, s = {
    textAlign: r,
    fontWeight: a !== void 0 ? Gs[a] : void 0,
    color: i !== void 0 ? Ae[i] : void 0
  };
  return /* @__PURE__ */ d.jsx("div", { ...o, ref: t, children: /* @__PURE__ */ d.jsx("div", { className: "p-2", style: s, children: /* @__PURE__ */ d.jsx(On, { spacingX: 5, children: /* @__PURE__ */ d.jsx(yr, { variant: "description-2", children: n }) }) }) });
});
SL.displayName = "TarjetBody";
const PL = P.forwardRef((e, t) => {
  const {
    alignment: r,
    children: n,
    weight: a = "bold",
    color: i,
    colorbox: o,
    icon: s,
    iconBooton: l,
    textLb: c,
    onClickAction: u,
    row: f,
    textToltip: p,
    directionToltip: h,
    ...m
  } = e, v = {
    textAlign: r,
    fontWeight: a !== void 0 ? Gs[a] : void 0,
    color: i !== void 0 ? Ae[i] : void 0
  }, g = () => {
    u !== void 0 && u({ row: f });
  };
  return /* @__PURE__ */ d.jsx("div", { ...m, ref: t, children: /* @__PURE__ */ d.jsxs("div", { children: [
    /* @__PURE__ */ d.jsxs("div", { className: "float-right col-span-2 flex justify-end ", children: [
      /* @__PURE__ */ d.jsx(
        Ut,
        {
          icon: l,
          variant: "secondary",
          size: "s",
          onlyIcon: !0,
          tooltip: p,
          tooltipDirection: h,
          onClick: g
        }
      ),
      /* @__PURE__ */ d.jsx(On, { bg: o, color: "white", rounded: "xl", spacingX: 6, spacingY: 1, children: /* @__PURE__ */ d.jsx(sn, { alignItems: "center", children: /* @__PURE__ */ d.jsx("strong", { children: c.label }) }) })
    ] }),
    /* @__PURE__ */ d.jsx("div", { className: "p-2", style: v, children: /* @__PURE__ */ d.jsxs(On, { spacingX: 5, children: [
      s !== void 0 && /* @__PURE__ */ d.jsx("span", { className: "inline-block w-7", children: /* @__PURE__ */ d.jsx(ge, { variant: s }) }),
      /* @__PURE__ */ d.jsxs(Sn, { variant: "heading-6", children: [
        /* @__PURE__ */ d.jsx("div", { className: "hidden m:flex ", children: /* @__PURE__ */ d.jsx("p", { className: "line-clamp-1 hover:line-clamp-2", children: n }) }),
        /* @__PURE__ */ d.jsx("div", { className: "m:hidden", children: n })
      ] })
    ] }) })
  ] }) });
});
PL.displayName = "TarjetTitle";
const EL = P.forwardRef((e, t) => {
  const {
    alignment: r,
    children: n,
    weight: a = "bold",
    color: i,
    targetoo: o,
    icon2: s,
    urlphoto1: l,
    variant: c,
    ...u
  } = e, f = {
    textAlign: r,
    fontWeight: a !== void 0 ? Gs[a] : void 0,
    color: i !== void 0 ? Ae[i] : void 0
  }, p = {
    primary: "bg-primary-700 ",
    secondary: "bg-secondary-600 ",
    accent: "bg-accent-700 ",
    info: "bg-info-700 ",
    warning: "bg-warning-600 ",
    success: "bg-success-600 ",
    error: "bg-error-600 "
  }, h = "bg-neutral-600";
  return /* @__PURE__ */ d.jsx("div", { ...u, ref: t, children: /* @__PURE__ */ d.jsx(On, { spacingX: 2, children: /* @__PURE__ */ d.jsxs(ds, { columnsVariant: "form-2", spacing: 3, children: [
    /* @__PURE__ */ d.jsx(Io, { children: /* @__PURE__ */ d.jsx("div", { className: "p-2 flex items-center space-2", children: /* @__PURE__ */ d.jsxs(Io, { children: [
      /* @__PURE__ */ d.jsx(On, { mb: 2, children: /* @__PURE__ */ d.jsx(Sn, { variant: "heading-6", children: o.title1 }) }),
      /* @__PURE__ */ d.jsxs(sn, { alignItems: "start", justifyContent: "between", gap: 3, children: [
        /* @__PURE__ */ d.jsx($o, { minWidth: 28, children: /* @__PURE__ */ d.jsx(qs, { size: "md", image: l, grayscale: !0 }) }),
        /* @__PURE__ */ d.jsx($o, { grow: !0, children: /* @__PURE__ */ d.jsxs(ds, { children: [
          /* @__PURE__ */ d.jsx(lr, { variant: "title-2", children: o.respons1 }),
          /* @__PURE__ */ d.jsx("p", { className: "truncate text-[14px] not-italic font-normal leading-[120%]", children: o.descrip1 })
        ] }) })
      ] })
    ] }) }) }),
    /* @__PURE__ */ d.jsx(Io, { children: /* @__PURE__ */ d.jsx("div", { className: "p-2 flex items-center space-2", style: f, children: /* @__PURE__ */ d.jsxs(Io, { children: [
      /* @__PURE__ */ d.jsx(On, { mb: 2, children: /* @__PURE__ */ d.jsx(Sn, { variant: "heading-6", children: o.title2 }) }),
      /* @__PURE__ */ d.jsxs(sn, { alignItems: "start", justifyContent: "between", gap: 2, children: [
        /* @__PURE__ */ d.jsx($o, { minWidth: 32, children: /* @__PURE__ */ d.jsx("span", { className: `h-[32px] w-[32px] min-w-[32px] flex items-center justify-center aspect-square rounded-full ${c !== void 0 ? p[c] : h} border border-white`, children: /* @__PURE__ */ d.jsx(ge, { variant: s, width: 20, color: i ? "neutral-100" : "neutral-600" }) }) }),
        /* @__PURE__ */ d.jsxs($o, { grow: !0, children: [
          /* @__PURE__ */ d.jsx(yr, { variant: "description-2", children: o.respons2 }),
          /* @__PURE__ */ d.jsx("p", { className: "truncate text-[14px] not-italic font-normal leading-[120%]", children: o.descrip2 })
        ] })
      ] })
    ] }) }) })
  ] }) }) });
});
EL.displayName = "TarjetFooter";
const jL = P.forwardRef((e, t) => {
  const {
    alignment: r,
    weight: n = "bold",
    color: a,
    children: i,
    parametrs: o,
    colorTitle: s,
    colorBody: l,
    icon: c,
    maxHeigth: u,
    isOpen: f,
    colorLabel: p,
    borderColor: h,
    badge: m,
    shadow: v,
    alignTitle: g,
    ...y
  } = e, b = {
    textAlign: r,
    fontWeight: n !== void 0 ? Gs[n] : void 0,
    color: a !== void 0 ? Ae[a] : void 0,
    borderColor: h !== void 0 ? Ae[h] : Ae["neutral-300"]
  }, w = {
    backgroundColor: s !== void 0 ? Ae[s] : void 0
  }, [x, C] = je(f);
  return /* @__PURE__ */ d.jsx("div", { ...y, ref: t, className: "w-full mx-auto ", children: /* @__PURE__ */ d.jsxs("div", { className: "border rounded-lg mb-2", style: b, children: [
    /* @__PURE__ */ d.jsx("div", { className: `${x ? " rounded-t-lg " : " rounded-lg "} `, style: w, children: /* @__PURE__ */ d.jsxs(
      "div",
      {
        onClick: () => C((S) => !S),
        className: `w-full p-4 flex ${g === "right" ? "justify-end" : "justify-between"} items-center focus:outline-none`,
        children: [
          /* @__PURE__ */ d.jsx("span", { className: `${g === "center" ? "mx-auto" : ""}`, children: /* @__PURE__ */ d.jsxs(Z0, { icon: c, color: p, children: [
            o.title,
            " ",
            m ? ` / ${m}` : ""
          ] }) }),
          /* @__PURE__ */ d.jsx(
            "svg",
            {
              xmlns: "http://www.w3.org/2000/svg",
              className: `h-6 w-6 transition-transform transform ${x ? "rotate-180" : "rotate-0"}`,
              fill: "none",
              viewBox: "0 0 24 24",
              stroke: "currentColor",
              style: { color: p ? Ae[p] : Ae.DEFAULT },
              children: /* @__PURE__ */ d.jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M19 9l-7 7-7-7" })
            }
          )
        ]
      }
    ) }),
    x && /* @__PURE__ */ d.jsx(On, { spacing: 5, bg: l, borderTop: 1, borderColor: h, children: /* @__PURE__ */ d.jsx(
      "div",
      {
        className: `overflow-y-auto ${x ? `${u !== void 0 ? `max-h-${u}` : ""}` : "max-h-0"}`,
        children: i
      }
    ) })
  ] }) });
});
jL.displayName = "Acordeon";
const _L = P.forwardRef((e, t) => {
  const {
    EMPNITXX: r,
    AREAIDXX: n,
    SERIEIDX: a,
    TIPOIDXX: i,
    JSONMETX: o,
    children: s,
    ...l
  } = e, c = () => {
    let u = "EMPNITXX=" + r + "&AREAIDXX=" + n + "&SERIEIDX=" + a;
    u += i ? "&TIPOIDXX=" + i : "", u += o ? "&JSONMETX=" + JSON.stringify(o) : "", window.open("https://genio.repremundo.com.co/#/home?" + u);
  };
  return /* @__PURE__ */ d.jsx("div", { ...l, ref: t, children: /* @__PURE__ */ d.jsx("div", { onClick: c, children: s }) });
});
_L.displayName = "Genlingx";
const DL = P.forwardRef((e, t) => {
  const {
    filters: r,
    ...n
  } = e, a = () => {
    window.open("https://geniovisor.repremundo.com.co/home/" + r);
  };
  return /* @__PURE__ */ d.jsx("div", { ...n, ref: t, children: /* @__PURE__ */ d.jsx("div", { className: "max-w-[50px] rounded-md hover:bg-neutral-200", onClick: a, children: /* @__PURE__ */ d.jsx(On, { spacing: 3, border: 1, borderColor: "neutral-300", rounded: "md", children: /* @__PURE__ */ d.jsx(ge, { variant: "genio", color: "warning-1000", width: 25 }) }) }) });
});
DL.displayName = "Visrlink";
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var c3 = function(e, t) {
  return c3 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var a in n)
      n.hasOwnProperty(a) && (r[a] = n[a]);
  }, c3(e, t);
};
function AL(e, t) {
  c3(e, t);
  function r() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
}
var qo = function() {
  return qo = Object.assign || function(t) {
    for (var r, n = 1, a = arguments.length; n < a; n++) {
      r = arguments[n];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
    }
    return t;
  }, qo.apply(this, arguments);
};
function ML(e, t, r, n) {
  var a, i = !1, o = 0;
  function s() {
    a && clearTimeout(a);
  }
  function l() {
    s(), i = !0;
  }
  typeof t != "boolean" && (n = r, r = t, t = void 0);
  function c() {
    var u = this, f = Date.now() - o, p = arguments;
    if (i)
      return;
    function h() {
      o = Date.now(), r.apply(u, p);
    }
    function m() {
      a = void 0;
    }
    n && !a && h(), s(), n === void 0 && f > e ? h() : t !== !0 && (a = setTimeout(n ? m : h, n === void 0 ? e - f : e));
  }
  return c.cancel = l, c;
}
var di = {
  Pixel: "Pixel",
  Percent: "Percent"
}, sp = {
  unit: di.Percent,
  value: 0.8
};
function lp(e) {
  return typeof e == "number" ? {
    unit: di.Percent,
    value: e * 100
  } : typeof e == "string" ? e.match(/^(\d*(\.\d+)?)px$/) ? {
    unit: di.Pixel,
    value: parseFloat(e)
  } : e.match(/^(\d*(\.\d+)?)%$/) ? {
    unit: di.Percent,
    value: parseFloat(e)
  } : (console.warn('scrollThreshold format is invalid. Valid formats: "120px", "50%"...'), sp) : (console.warn("scrollThreshold should be string or number"), sp);
}
var Lc = (
  /** @class */
  function(e) {
    AL(t, e);
    function t(r) {
      var n = e.call(this, r) || this;
      return n.lastScrollTop = 0, n.actionTriggered = !1, n.startY = 0, n.currentY = 0, n.dragging = !1, n.maxPullDownDistance = 0, n.getScrollableTarget = function() {
        return n.props.scrollableTarget instanceof HTMLElement ? n.props.scrollableTarget : typeof n.props.scrollableTarget == "string" ? document.getElementById(n.props.scrollableTarget) : (n.props.scrollableTarget === null && console.warn(`You are trying to pass scrollableTarget but it is null. This might
        happen because the element may not have been added to DOM yet.
        See https://github.com/ankeetmaini/react-infinite-scroll-component/issues/59 for more info.
      `), null);
      }, n.onStart = function(a) {
        n.lastScrollTop || (n.dragging = !0, a instanceof MouseEvent ? n.startY = a.pageY : a instanceof TouchEvent && (n.startY = a.touches[0].pageY), n.currentY = n.startY, n._infScroll && (n._infScroll.style.willChange = "transform", n._infScroll.style.transition = "transform 0.2s cubic-bezier(0,0,0.31,1)"));
      }, n.onMove = function(a) {
        n.dragging && (a instanceof MouseEvent ? n.currentY = a.pageY : a instanceof TouchEvent && (n.currentY = a.touches[0].pageY), !(n.currentY < n.startY) && (n.currentY - n.startY >= Number(n.props.pullDownToRefreshThreshold) && n.setState({
          pullToRefreshThresholdBreached: !0
        }), !(n.currentY - n.startY > n.maxPullDownDistance * 1.5) && n._infScroll && (n._infScroll.style.overflow = "visible", n._infScroll.style.transform = "translate3d(0px, " + (n.currentY - n.startY) + "px, 0px)")));
      }, n.onEnd = function() {
        n.startY = 0, n.currentY = 0, n.dragging = !1, n.state.pullToRefreshThresholdBreached && (n.props.refreshFunction && n.props.refreshFunction(), n.setState({
          pullToRefreshThresholdBreached: !1
        })), requestAnimationFrame(function() {
          n._infScroll && (n._infScroll.style.overflow = "auto", n._infScroll.style.transform = "none", n._infScroll.style.willChange = "unset");
        });
      }, n.onScrollListener = function(a) {
        typeof n.props.onScroll == "function" && setTimeout(function() {
          return n.props.onScroll && n.props.onScroll(a);
        }, 0);
        var i = n.props.height || n._scrollableNode ? a.target : document.documentElement.scrollTop ? document.documentElement : document.body;
        if (!n.actionTriggered) {
          var o = n.props.inverse ? n.isElementAtTop(i, n.props.scrollThreshold) : n.isElementAtBottom(i, n.props.scrollThreshold);
          o && n.props.hasMore && (n.actionTriggered = !0, n.setState({ showLoader: !0 }), n.props.next && n.props.next()), n.lastScrollTop = i.scrollTop;
        }
      }, n.state = {
        showLoader: !1,
        pullToRefreshThresholdBreached: !1,
        prevDataLength: r.dataLength
      }, n.throttledOnScrollListener = ML(150, n.onScrollListener).bind(n), n.onStart = n.onStart.bind(n), n.onMove = n.onMove.bind(n), n.onEnd = n.onEnd.bind(n), n;
    }
    return t.prototype.componentDidMount = function() {
      if (typeof this.props.dataLength > "u")
        throw new Error('mandatory prop "dataLength" is missing. The prop is needed when loading more content. Check README.md for usage');
      if (this._scrollableNode = this.getScrollableTarget(), this.el = this.props.height ? this._infScroll : this._scrollableNode || window, this.el && this.el.addEventListener("scroll", this.throttledOnScrollListener), typeof this.props.initialScrollY == "number" && this.el && this.el instanceof HTMLElement && this.el.scrollHeight > this.props.initialScrollY && this.el.scrollTo(0, this.props.initialScrollY), this.props.pullDownToRefresh && this.el && (this.el.addEventListener("touchstart", this.onStart), this.el.addEventListener("touchmove", this.onMove), this.el.addEventListener("touchend", this.onEnd), this.el.addEventListener("mousedown", this.onStart), this.el.addEventListener("mousemove", this.onMove), this.el.addEventListener("mouseup", this.onEnd), this.maxPullDownDistance = this._pullDown && this._pullDown.firstChild && this._pullDown.firstChild.getBoundingClientRect().height || 0, this.forceUpdate(), typeof this.props.refreshFunction != "function"))
        throw new Error(`Mandatory prop "refreshFunction" missing.
          Pull Down To Refresh functionality will not work
          as expected. Check README.md for usage'`);
    }, t.prototype.componentWillUnmount = function() {
      this.el && (this.el.removeEventListener("scroll", this.throttledOnScrollListener), this.props.pullDownToRefresh && (this.el.removeEventListener("touchstart", this.onStart), this.el.removeEventListener("touchmove", this.onMove), this.el.removeEventListener("touchend", this.onEnd), this.el.removeEventListener("mousedown", this.onStart), this.el.removeEventListener("mousemove", this.onMove), this.el.removeEventListener("mouseup", this.onEnd)));
    }, t.prototype.componentDidUpdate = function(r) {
      this.props.dataLength !== r.dataLength && (this.actionTriggered = !1, this.setState({
        showLoader: !1
      }));
    }, t.getDerivedStateFromProps = function(r, n) {
      var a = r.dataLength !== n.prevDataLength;
      return a ? qo(qo({}, n), { prevDataLength: r.dataLength }) : null;
    }, t.prototype.isElementAtTop = function(r, n) {
      n === void 0 && (n = 0.8);
      var a = r === document.body || r === document.documentElement ? window.screen.availHeight : r.clientHeight, i = lp(n);
      return i.unit === di.Pixel ? r.scrollTop <= i.value + a - r.scrollHeight + 1 : r.scrollTop <= i.value / 100 + a - r.scrollHeight + 1;
    }, t.prototype.isElementAtBottom = function(r, n) {
      n === void 0 && (n = 0.8);
      var a = r === document.body || r === document.documentElement ? window.screen.availHeight : r.clientHeight, i = lp(n);
      return i.unit === di.Pixel ? r.scrollTop + a >= r.scrollHeight - i.value : r.scrollTop + a >= i.value / 100 * r.scrollHeight;
    }, t.prototype.render = function() {
      var r = this, n = qo({ height: this.props.height || "auto", overflow: "auto", WebkitOverflowScrolling: "touch" }, this.props.style), a = this.props.hasChildren || !!(this.props.children && this.props.children instanceof Array && this.props.children.length), i = this.props.pullDownToRefresh && this.props.height ? { overflow: "auto" } : {};
      return P.createElement(
        "div",
        { style: i, className: "infinite-scroll-component__outerdiv" },
        P.createElement(
          "div",
          { className: "infinite-scroll-component " + (this.props.className || ""), ref: function(o) {
            return r._infScroll = o;
          }, style: n },
          this.props.pullDownToRefresh && P.createElement(
            "div",
            { style: { position: "relative" }, ref: function(o) {
              return r._pullDown = o;
            } },
            P.createElement("div", { style: {
              position: "absolute",
              left: 0,
              right: 0,
              top: -1 * this.maxPullDownDistance
            } }, this.state.pullToRefreshThresholdBreached ? this.props.releaseToRefreshContent : this.props.pullDownToRefreshContent)
          ),
          this.props.children,
          !this.state.showLoader && !a && this.props.hasMore && this.props.loader,
          this.state.showLoader && this.props.hasMore && this.props.loader,
          !this.props.hasMore && this.props.endMessage
        )
      );
    }, t;
  }(W0)
);
const TL = (e) => {
  const { columns: t = [], data: r = [], onColumnClick: n, dataLength: a = 0, fetchData: i, hasMore: o = !1 } = e, s = t.map((f) => `col-${f.id}`).join(" ").toString(), l = Array.from({ length: t.length }, () => "1fr").join(" ").toString(), c = { gridTemplateAreas: `'${s}'`, gridTemplateColumns: l }, u = () => i !== void 0 ? i() : null;
  return /* @__PURE__ */ d.jsx("div", { className: "grid gap-2 hidden 2s:block", children: /* @__PURE__ */ d.jsx(
    "div",
    {
      className: `max-h-[calc(100vh-461px)] min-h-[calc(100vh-461px)] m:max-h-[calc(100vh-305px)] m:min-h-[calc(100vh-305px)]
        l:max-h-[calc(100vh-312px)] l:min-h-[calc(100vh-312px)] table-max-height w-full overflow-auto table-main-scrollbar pb-1`,
      id: "scrollableTable",
      children: /* @__PURE__ */ d.jsx(
        Lc,
        {
          dataLength: a,
          hasMore: o,
          next: u,
          scrollableTarget: "scrollableTable",
          style: { overflow: "hidden" },
          loader: /* @__PURE__ */ d.jsx(lr, { variant: "title-2", children: "Cargando nueva información..." }),
          children: /* @__PURE__ */ d.jsxs("div", { className: "min-w-[min-content]", children: [
            /* @__PURE__ */ d.jsx(
              "div",
              {
                className: "bg-white grid w-full h-10 sticky top-0",
                style: { ...c, zIndex: r.length + 10 },
                children: t.map((f) => /* @__PURE__ */ d.jsxs(
                  "div",
                  {
                    style: { gridArea: `col-${f.id}` },
                    title: f.title,
                    className: "min-w-[205px] bg-neutral-200 flex gap-2 justify-between items-center px-4 font-bold leading-[120%] select-none",
                    children: [
                      /* @__PURE__ */ d.jsx("p", { className: "w-full text-ellipsis overflow-hidden whitespace-nowrap", children: f.title }),
                      /* @__PURE__ */ d.jsx(
                        "button",
                        {
                          type: "button",
                          className: "w-6 h-6 flex items-center justify-center",
                          onClick: () => {
                            n !== void 0 && n({ column: f });
                          },
                          children: /* @__PURE__ */ d.jsxs("svg", { className: "w-5", viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
                            /* @__PURE__ */ d.jsx(
                              "path",
                              {
                                d: "M16.743 10L8.25505 10C8.1049 9.9994 7.95831 9.95665 7.83381 9.87715C7.70931 9.79765 7.6125 9.68497 7.55561 9.55336C7.49873 9.42176 7.48433 9.27713 7.51423 9.13777C7.54413 8.99841 7.61699 8.87057 7.7236 8.77043L11.96 4.75815C12.0306 4.69075 12.1145 4.63726 12.207 4.60075C12.2996 4.56425 12.3988 4.54545 12.499 4.54545C12.5992 4.54545 12.6985 4.56425 12.791 4.60075C12.8835 4.63726 12.9675 4.69075 13.0381 4.75815L17.2744 8.77043C17.3811 8.87057 17.4539 8.99841 17.4838 9.13777C17.5137 9.27713 17.4993 9.42176 17.4424 9.55337C17.3855 9.68497 17.2887 9.79765 17.1642 9.87715C17.0397 9.95665 16.8931 9.9994 16.743 10Z",
                                fill: f.sorted && f.orderBy === "asc" ? "#2875B4" : "#E6E6E6"
                              }
                            ),
                            /* @__PURE__ */ d.jsx(
                              "path",
                              {
                                d: "M8.25505 14H16.743C16.8931 14.0006 17.0397 14.0433 17.1642 14.1228C17.2887 14.2023 17.3855 14.315 17.4424 14.4466C17.4993 14.5782 17.5137 14.7229 17.4838 14.8622C17.4539 15.0016 17.3811 15.1294 17.2744 15.2296L13.0381 19.2419C12.9675 19.3092 12.8835 19.3627 12.791 19.3992C12.6985 19.4358 12.5992 19.4545 12.499 19.4545C12.3988 19.4545 12.2996 19.4358 12.207 19.3992C12.1145 19.3627 12.0306 19.3092 11.96 19.2419L7.7236 15.2296C7.61699 15.1294 7.54413 15.0016 7.51423 14.8622C7.48433 14.7229 7.49873 14.5782 7.55561 14.4466C7.6125 14.315 7.70931 14.2023 7.83381 14.1228C7.95831 14.0433 8.1049 14.0006 8.25505 14Z",
                                fill: f.sorted && f.orderBy === "desc" ? "#2875B4" : "#E6E6E6"
                              }
                            )
                          ] })
                        }
                      )
                    ]
                  },
                  f.id
                ))
              }
            ),
            /* @__PURE__ */ d.jsx("div", { className: "bg-secondary-100 w-full", children: /* @__PURE__ */ d.jsx("div", { children: r.map((f, p) => {
              const m = p % 2 === 0 ? "bg-white" : "bg-neutral-200";
              return /* @__PURE__ */ d.jsx(ea, { children: /* @__PURE__ */ d.jsx(
                "div",
                {
                  style: c,
                  className: `${m} hover:bg-secondary-300 hover:text-secondary-600 border-b border-white last:border-none h-[48px] grid w-full`,
                  children: Object.entries(f).map(([v, g]) => {
                    const y = t.find((w) => w.id === v);
                    let b = !1;
                    if (y)
                      b = y == null ? void 0 : y.center;
                    else
                      return null;
                    return /* @__PURE__ */ d.jsx(
                      "div",
                      {
                        style: { gridArea: `col-${y.id}` },
                        title: g,
                        className: `min-w-[205px] flex items-center ${b ? "text-center" : "text-left"} px-4 border-l border-white first:border-none leading-[120%]`,
                        children: /* @__PURE__ */ d.jsx("p", { className: "w-full text-ellipsis overflow-hidden whitespace-nowrap", children: g })
                      },
                      v
                    );
                  })
                },
                f.id
              ) }, `fragment-${p}`);
            }) }) })
          ] })
        }
      )
    }
  ) });
}, $L = (e) => {
  const { columns: t = [], data: r = [], dataLength: n = 0, fetchData: a, hasMore: i = !1 } = e, o = () => a !== void 0 ? a() : null;
  return /* @__PURE__ */ d.jsx("div", { className: "grid gap-2 2s:hidden", children: /* @__PURE__ */ d.jsx(
    "div",
    {
      className: `max-h-[calc(100vh-461px)] min-h-[calc(100vh-461px)] m:max-h-[calc(100vh-305px)] m:min-h-[calc(100vh-305px)]
        l:max-h-[calc(100vh-312px)] l:min-h-[calc(100vh-312px)] table-max-height w-full overflow-auto table-main-scrollbar pb-1`,
      id: "scrollableTableMobile",
      children: /* @__PURE__ */ d.jsx(
        Lc,
        {
          dataLength: n,
          hasMore: i,
          next: o,
          scrollableTarget: "scrollableTableMobile",
          style: { overflow: "hidden" },
          loader: /* @__PURE__ */ d.jsx(lr, { variant: "title-2", children: "Cargando nueva información..." }),
          className: "grid gap-2",
          scrollThreshold: "300px",
          children: r.map((s, l) => /* @__PURE__ */ d.jsx(ea, { children: /* @__PURE__ */ d.jsx(
            "div",
            {
              className: "relative p-4 rounded-md bg-neutral-200 hover:bg-secondary-200 hover:text-secondary-600 w-full cursor-pointer",
              children: /* @__PURE__ */ d.jsx("div", { className: "flex flex-wrap gap-y-1.5 gap-x-6", children: Object.entries(s).filter(([c]) => t.some((u) => u.id === c)).map(([c, u]) => t.find((p) => p.id === c) === void 0 ? null : /* @__PURE__ */ d.jsx("p", { className: "leading-[120%] w-full pr-12", children: u }, c)) })
            },
            s.id
          ) }, `fragment-${l}`))
        }
      )
    }
  ) });
}, NL = P.forwardRef((e, t) => {
  const { columns: r = [], data: n = [], className: a, onColumnClick: i, dataLength: o = 0, hasMore: s = !1, fetchData: l } = e;
  return r.length < 1 ? null : /* @__PURE__ */ d.jsxs("div", { ref: t, className: Ne(["block", a]), children: [
    /* @__PURE__ */ d.jsx(
      TL,
      {
        columns: r,
        data: n,
        onColumnClick: i,
        dataLength: o,
        hasMore: s,
        fetchData: l
      }
    ),
    /* @__PURE__ */ d.jsx(
      $L,
      {
        columns: r,
        data: n,
        dataLength: o,
        hasMore: s,
        fetchData: l
      }
    )
  ] });
});
NL.displayName = "TableBasic";
function am(e) {
  var t, r, n = "";
  if (typeof e == "string" || typeof e == "number")
    n += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var a = e.length;
      for (t = 0; t < a; t++)
        e[t] && (r = am(e[t])) && (n && (n += " "), n += r);
    } else
      for (r in e)
        e[r] && (n && (n += " "), n += r);
  return n;
}
function _e() {
  for (var e, t, r = 0, n = "", a = arguments.length; r < a; r++)
    (e = arguments[r]) && (t = am(e)) && (n && (n += " "), n += t);
  return n;
}
var IL = Array.isArray, cr = IL, LL = typeof To == "object" && To && To.Object === Object && To, im = LL, RL = im, kL = typeof self == "object" && self && self.Object === Object && self, BL = RL || kL || Function("return this")(), dn = BL, VL = dn, HL = VL.Symbol, il = HL, cp = il, om = Object.prototype, FL = om.hasOwnProperty, WL = om.toString, wo = cp ? cp.toStringTag : void 0;
function zL(e) {
  var t = FL.call(e, wo), r = e[wo];
  try {
    e[wo] = void 0;
    var n = !0;
  } catch {
  }
  var a = WL.call(e);
  return n && (t ? e[wo] = r : delete e[wo]), a;
}
var UL = zL, ZL = Object.prototype, qL = ZL.toString;
function GL(e) {
  return qL.call(e);
}
var YL = GL, up = il, KL = UL, XL = YL, QL = "[object Null]", JL = "[object Undefined]", fp = up ? up.toStringTag : void 0;
function eR(e) {
  return e == null ? e === void 0 ? JL : QL : fp && fp in Object(e) ? KL(e) : XL(e);
}
var $n = eR;
function tR(e) {
  return e != null && typeof e == "object";
}
var Nn = tR, rR = $n, nR = Nn, aR = "[object Symbol]";
function iR(e) {
  return typeof e == "symbol" || nR(e) && rR(e) == aR;
}
var Ji = iR, oR = cr, sR = Ji, lR = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, cR = /^\w*$/;
function uR(e, t) {
  if (oR(e))
    return !1;
  var r = typeof e;
  return r == "number" || r == "symbol" || r == "boolean" || e == null || sR(e) ? !0 : cR.test(e) || !lR.test(e) || t != null && e in Object(t);
}
var Wf = uR;
function fR(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var ia = fR;
const eo = /* @__PURE__ */ Je(ia);
var dR = $n, pR = ia, hR = "[object AsyncFunction]", vR = "[object Function]", mR = "[object GeneratorFunction]", gR = "[object Proxy]";
function yR(e) {
  if (!pR(e))
    return !1;
  var t = dR(e);
  return t == vR || t == mR || t == hR || t == gR;
}
var zf = yR;
const xe = /* @__PURE__ */ Je(zf);
var bR = dn, CR = bR["__core-js_shared__"], xR = CR, o2 = xR, dp = function() {
  var e = /[^.]+$/.exec(o2 && o2.keys && o2.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function wR(e) {
  return !!dp && dp in e;
}
var OR = wR, SR = Function.prototype, PR = SR.toString;
function ER(e) {
  if (e != null) {
    try {
      return PR.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var sm = ER, jR = zf, _R = OR, DR = ia, AR = sm, MR = /[\\^$.*+?()[\]{}|]/g, TR = /^\[object .+?Constructor\]$/, $R = Function.prototype, NR = Object.prototype, IR = $R.toString, LR = NR.hasOwnProperty, RR = RegExp(
  "^" + IR.call(LR).replace(MR, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function kR(e) {
  if (!DR(e) || _R(e))
    return !1;
  var t = jR(e) ? RR : TR;
  return t.test(AR(e));
}
var BR = kR;
function VR(e, t) {
  return e == null ? void 0 : e[t];
}
var HR = VR, FR = BR, WR = HR;
function zR(e, t) {
  var r = WR(e, t);
  return FR(r) ? r : void 0;
}
var Fa = zR, UR = Fa, ZR = UR(Object, "create"), Rc = ZR, pp = Rc;
function qR() {
  this.__data__ = pp ? pp(null) : {}, this.size = 0;
}
var GR = qR;
function YR(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var KR = YR, XR = Rc, QR = "__lodash_hash_undefined__", JR = Object.prototype, ek = JR.hasOwnProperty;
function tk(e) {
  var t = this.__data__;
  if (XR) {
    var r = t[e];
    return r === QR ? void 0 : r;
  }
  return ek.call(t, e) ? t[e] : void 0;
}
var rk = tk, nk = Rc, ak = Object.prototype, ik = ak.hasOwnProperty;
function ok(e) {
  var t = this.__data__;
  return nk ? t[e] !== void 0 : ik.call(t, e);
}
var sk = ok, lk = Rc, ck = "__lodash_hash_undefined__";
function uk(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = lk && t === void 0 ? ck : t, this;
}
var fk = uk, dk = GR, pk = KR, hk = rk, vk = sk, mk = fk;
function to(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
to.prototype.clear = dk;
to.prototype.delete = pk;
to.prototype.get = hk;
to.prototype.has = vk;
to.prototype.set = mk;
var gk = to;
function yk() {
  this.__data__ = [], this.size = 0;
}
var bk = yk;
function Ck(e, t) {
  return e === t || e !== e && t !== t;
}
var Uf = Ck, xk = Uf;
function wk(e, t) {
  for (var r = e.length; r--; )
    if (xk(e[r][0], t))
      return r;
  return -1;
}
var kc = wk, Ok = kc, Sk = Array.prototype, Pk = Sk.splice;
function Ek(e) {
  var t = this.__data__, r = Ok(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : Pk.call(t, r, 1), --this.size, !0;
}
var jk = Ek, _k = kc;
function Dk(e) {
  var t = this.__data__, r = _k(t, e);
  return r < 0 ? void 0 : t[r][1];
}
var Ak = Dk, Mk = kc;
function Tk(e) {
  return Mk(this.__data__, e) > -1;
}
var $k = Tk, Nk = kc;
function Ik(e, t) {
  var r = this.__data__, n = Nk(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
var Lk = Ik, Rk = bk, kk = jk, Bk = Ak, Vk = $k, Hk = Lk;
function ro(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
ro.prototype.clear = Rk;
ro.prototype.delete = kk;
ro.prototype.get = Bk;
ro.prototype.has = Vk;
ro.prototype.set = Hk;
var Bc = ro, Fk = Fa, Wk = dn, zk = Fk(Wk, "Map"), Zf = zk, hp = gk, Uk = Bc, Zk = Zf;
function qk() {
  this.size = 0, this.__data__ = {
    hash: new hp(),
    map: new (Zk || Uk)(),
    string: new hp()
  };
}
var Gk = qk;
function Yk(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var Kk = Yk, Xk = Kk;
function Qk(e, t) {
  var r = e.__data__;
  return Xk(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
var Vc = Qk, Jk = Vc;
function eB(e) {
  var t = Jk(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var tB = eB, rB = Vc;
function nB(e) {
  return rB(this, e).get(e);
}
var aB = nB, iB = Vc;
function oB(e) {
  return iB(this, e).has(e);
}
var sB = oB, lB = Vc;
function cB(e, t) {
  var r = lB(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
var uB = cB, fB = Gk, dB = tB, pB = aB, hB = sB, vB = uB;
function no(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
no.prototype.clear = fB;
no.prototype.delete = dB;
no.prototype.get = pB;
no.prototype.has = hB;
no.prototype.set = vB;
var qf = no, lm = qf, mB = "Expected a function";
function Gf(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(mB);
  var r = function() {
    var n = arguments, a = t ? t.apply(this, n) : n[0], i = r.cache;
    if (i.has(a))
      return i.get(a);
    var o = e.apply(this, n);
    return r.cache = i.set(a, o) || i, o;
  };
  return r.cache = new (Gf.Cache || lm)(), r;
}
Gf.Cache = lm;
var cm = Gf;
const gB = /* @__PURE__ */ Je(cm);
var yB = cm, bB = 500;
function CB(e) {
  var t = yB(e, function(n) {
    return r.size === bB && r.clear(), n;
  }), r = t.cache;
  return t;
}
var xB = CB, wB = xB, OB = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, SB = /\\(\\)?/g, PB = wB(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(OB, function(r, n, a, i) {
    t.push(a ? i.replace(SB, "$1") : n || r);
  }), t;
}), EB = PB;
function jB(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = Array(n); ++r < n; )
    a[r] = t(e[r], r, e);
  return a;
}
var Yf = jB, vp = il, _B = Yf, DB = cr, AB = Ji, MB = 1 / 0, mp = vp ? vp.prototype : void 0, gp = mp ? mp.toString : void 0;
function um(e) {
  if (typeof e == "string")
    return e;
  if (DB(e))
    return _B(e, um) + "";
  if (AB(e))
    return gp ? gp.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -MB ? "-0" : t;
}
var TB = um, $B = TB;
function NB(e) {
  return e == null ? "" : $B(e);
}
var fm = NB, IB = cr, LB = Wf, RB = EB, kB = fm;
function BB(e, t) {
  return IB(e) ? e : LB(e, t) ? [e] : RB(kB(e));
}
var dm = BB, VB = Ji, HB = 1 / 0;
function FB(e) {
  if (typeof e == "string" || VB(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -HB ? "-0" : t;
}
var Hc = FB, WB = dm, zB = Hc;
function UB(e, t) {
  t = WB(t, e);
  for (var r = 0, n = t.length; e != null && r < n; )
    e = e[zB(t[r++])];
  return r && r == n ? e : void 0;
}
var Kf = UB, ZB = Kf;
function qB(e, t, r) {
  var n = e == null ? void 0 : ZB(e, t);
  return n === void 0 ? r : n;
}
var pm = qB;
const br = /* @__PURE__ */ Je(pm);
function GB(e) {
  return e == null;
}
var YB = GB;
const Ce = /* @__PURE__ */ Je(YB);
var KB = $n, XB = cr, QB = Nn, JB = "[object String]";
function eV(e) {
  return typeof e == "string" || !XB(e) && QB(e) && KB(e) == JB;
}
var tV = eV;
const ol = /* @__PURE__ */ Je(tV);
var u3 = { exports: {} }, Xe = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var yp;
function rV() {
  if (yp)
    return Xe;
  yp = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), o = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), m;
  m = Symbol.for("react.module.reference");
  function v(g) {
    if (typeof g == "object" && g !== null) {
      var y = g.$$typeof;
      switch (y) {
        case e:
          switch (g = g.type, g) {
            case r:
            case a:
            case n:
            case c:
            case u:
              return g;
            default:
              switch (g = g && g.$$typeof, g) {
                case s:
                case o:
                case l:
                case p:
                case f:
                case i:
                  return g;
                default:
                  return y;
              }
          }
        case t:
          return y;
      }
    }
  }
  return Xe.ContextConsumer = o, Xe.ContextProvider = i, Xe.Element = e, Xe.ForwardRef = l, Xe.Fragment = r, Xe.Lazy = p, Xe.Memo = f, Xe.Portal = t, Xe.Profiler = a, Xe.StrictMode = n, Xe.Suspense = c, Xe.SuspenseList = u, Xe.isAsyncMode = function() {
    return !1;
  }, Xe.isConcurrentMode = function() {
    return !1;
  }, Xe.isContextConsumer = function(g) {
    return v(g) === o;
  }, Xe.isContextProvider = function(g) {
    return v(g) === i;
  }, Xe.isElement = function(g) {
    return typeof g == "object" && g !== null && g.$$typeof === e;
  }, Xe.isForwardRef = function(g) {
    return v(g) === l;
  }, Xe.isFragment = function(g) {
    return v(g) === r;
  }, Xe.isLazy = function(g) {
    return v(g) === p;
  }, Xe.isMemo = function(g) {
    return v(g) === f;
  }, Xe.isPortal = function(g) {
    return v(g) === t;
  }, Xe.isProfiler = function(g) {
    return v(g) === a;
  }, Xe.isStrictMode = function(g) {
    return v(g) === n;
  }, Xe.isSuspense = function(g) {
    return v(g) === c;
  }, Xe.isSuspenseList = function(g) {
    return v(g) === u;
  }, Xe.isValidElementType = function(g) {
    return typeof g == "string" || typeof g == "function" || g === r || g === a || g === n || g === c || g === u || g === h || typeof g == "object" && g !== null && (g.$$typeof === p || g.$$typeof === f || g.$$typeof === i || g.$$typeof === o || g.$$typeof === l || g.$$typeof === m || g.getModuleId !== void 0);
  }, Xe.typeOf = v, Xe;
}
var Qe = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var bp;
function nV() {
  return bp || (bp = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), o = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), m = !1, v = !1, g = !1, y = !1, b = !1, w;
    w = Symbol.for("react.module.reference");
    function x(H) {
      return !!(typeof H == "string" || typeof H == "function" || H === r || H === a || b || H === n || H === c || H === u || y || H === h || m || v || g || typeof H == "object" && H !== null && (H.$$typeof === p || H.$$typeof === f || H.$$typeof === i || H.$$typeof === o || H.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      H.$$typeof === w || H.getModuleId !== void 0));
    }
    function C(H) {
      if (typeof H == "object" && H !== null) {
        var ee = H.$$typeof;
        switch (ee) {
          case e:
            var ne = H.type;
            switch (ne) {
              case r:
              case a:
              case n:
              case c:
              case u:
                return ne;
              default:
                var ae = ne && ne.$$typeof;
                switch (ae) {
                  case s:
                  case o:
                  case l:
                  case p:
                  case f:
                  case i:
                    return ae;
                  default:
                    return ee;
                }
            }
          case t:
            return ee;
        }
      }
    }
    var S = o, E = i, D = e, I = l, k = r, V = p, W = f, L = t, G = a, Q = n, X = c, K = u, te = !1, _ = !1;
    function j(H) {
      return te || (te = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function T(H) {
      return _ || (_ = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function A(H) {
      return C(H) === o;
    }
    function O(H) {
      return C(H) === i;
    }
    function N(H) {
      return typeof H == "object" && H !== null && H.$$typeof === e;
    }
    function q(H) {
      return C(H) === l;
    }
    function Y(H) {
      return C(H) === r;
    }
    function z(H) {
      return C(H) === p;
    }
    function R(H) {
      return C(H) === f;
    }
    function $(H) {
      return C(H) === t;
    }
    function F(H) {
      return C(H) === a;
    }
    function B(H) {
      return C(H) === n;
    }
    function M(H) {
      return C(H) === c;
    }
    function J(H) {
      return C(H) === u;
    }
    Qe.ContextConsumer = S, Qe.ContextProvider = E, Qe.Element = D, Qe.ForwardRef = I, Qe.Fragment = k, Qe.Lazy = V, Qe.Memo = W, Qe.Portal = L, Qe.Profiler = G, Qe.StrictMode = Q, Qe.Suspense = X, Qe.SuspenseList = K, Qe.isAsyncMode = j, Qe.isConcurrentMode = T, Qe.isContextConsumer = A, Qe.isContextProvider = O, Qe.isElement = N, Qe.isForwardRef = q, Qe.isFragment = Y, Qe.isLazy = z, Qe.isMemo = R, Qe.isPortal = $, Qe.isProfiler = F, Qe.isStrictMode = B, Qe.isSuspense = M, Qe.isSuspenseList = J, Qe.isValidElementType = x, Qe.typeOf = C;
  }()), Qe;
}
process.env.NODE_ENV === "production" ? u3.exports = rV() : u3.exports = nV();
var hm = u3.exports, aV = $n, iV = Nn, oV = "[object Number]";
function sV(e) {
  return typeof e == "number" || iV(e) && aV(e) == oV;
}
var vm = sV;
const lV = /* @__PURE__ */ Je(vm);
var cV = vm;
function uV(e) {
  return cV(e) && e != +e;
}
var fV = uV;
const ao = /* @__PURE__ */ Je(fV);
var Jt = function(t) {
  return t === 0 ? 0 : t > 0 ? 1 : -1;
}, Ea = function(t) {
  return ol(t) && t.indexOf("%") === t.length - 1;
}, oe = function(t) {
  return lV(t) && !ao(t);
}, Lt = function(t) {
  return oe(t) || ol(t);
}, dV = 0, oa = function(t) {
  var r = ++dV;
  return "".concat(t || "").concat(r);
}, er = function(t, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  if (!oe(t) && !ol(t))
    return n;
  var i;
  if (Ea(t)) {
    var o = t.indexOf("%");
    i = r * parseFloat(t.slice(0, o)) / 100;
  } else
    i = +t;
  return ao(i) && (i = n), a && i > r && (i = r), i;
}, Bn = function(t) {
  if (!t)
    return null;
  var r = Object.keys(t);
  return r && r.length ? t[r[0]] : null;
}, pV = function(t) {
  if (!Array.isArray(t))
    return !1;
  for (var r = t.length, n = {}, a = 0; a < r; a++)
    if (!n[t[a]])
      n[t[a]] = !0;
    else
      return !0;
  return !1;
}, bt = function(t, r) {
  return oe(t) && oe(r) ? function(n) {
    return t + n * (r - t);
  } : function() {
    return r;
  };
};
function p1(e, t, r) {
  return !e || !e.length ? null : e.find(function(n) {
    return n && (typeof t == "function" ? t(n) : br(n, t)) === r;
  });
}
var hV = function(t) {
  if (!t || !t.length)
    return null;
  for (var r = t.length, n = 0, a = 0, i = 0, o = 0, s = 1 / 0, l = -1 / 0, c = 0, u = 0, f = 0; f < r; f++)
    c = t[f].cx || 0, u = t[f].cy || 0, n += c, a += u, i += c * u, o += c * c, s = Math.min(s, c), l = Math.max(l, c);
  var p = r * o !== n * n ? (r * i - n * a) / (r * o - n * n) : 0;
  return {
    xmin: s,
    xmax: l,
    a: p,
    b: (a - p * n) / r
  };
};
function pi(e, t) {
  for (var r in e)
    if ({}.hasOwnProperty.call(e, r) && (!{}.hasOwnProperty.call(t, r) || e[r] !== t[r]))
      return !1;
  for (var n in t)
    if ({}.hasOwnProperty.call(t, n) && !{}.hasOwnProperty.call(e, n))
      return !1;
  return !0;
}
function f3(e) {
  "@babel/helpers - typeof";
  return f3 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, f3(e);
}
var vV = ["viewBox", "children"], mV = [
  "aria-activedescendant",
  "aria-atomic",
  "aria-autocomplete",
  "aria-busy",
  "aria-checked",
  "aria-colcount",
  "aria-colindex",
  "aria-colspan",
  "aria-controls",
  "aria-current",
  "aria-describedby",
  "aria-details",
  "aria-disabled",
  "aria-errormessage",
  "aria-expanded",
  "aria-flowto",
  "aria-haspopup",
  "aria-hidden",
  "aria-invalid",
  "aria-keyshortcuts",
  "aria-label",
  "aria-labelledby",
  "aria-level",
  "aria-live",
  "aria-modal",
  "aria-multiline",
  "aria-multiselectable",
  "aria-orientation",
  "aria-owns",
  "aria-placeholder",
  "aria-posinset",
  "aria-pressed",
  "aria-readonly",
  "aria-relevant",
  "aria-required",
  "aria-roledescription",
  "aria-rowcount",
  "aria-rowindex",
  "aria-rowspan",
  "aria-selected",
  "aria-setsize",
  "aria-sort",
  "aria-valuemax",
  "aria-valuemin",
  "aria-valuenow",
  "aria-valuetext",
  "className",
  "color",
  "height",
  "id",
  "lang",
  "max",
  "media",
  "method",
  "min",
  "name",
  "style",
  /*
   * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
   * that can use it and it conflicts with the recharts prop 'type'
   * https://github.com/recharts/recharts/pull/3327
   * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
   */
  // 'type',
  "target",
  "width",
  "role",
  "tabIndex",
  "accentHeight",
  "accumulate",
  "additive",
  "alignmentBaseline",
  "allowReorder",
  "alphabetic",
  "amplitude",
  "arabicForm",
  "ascent",
  "attributeName",
  "attributeType",
  "autoReverse",
  "azimuth",
  "baseFrequency",
  "baselineShift",
  "baseProfile",
  "bbox",
  "begin",
  "bias",
  "by",
  "calcMode",
  "capHeight",
  "clip",
  "clipPath",
  "clipPathUnits",
  "clipRule",
  "colorInterpolation",
  "colorInterpolationFilters",
  "colorProfile",
  "colorRendering",
  "contentScriptType",
  "contentStyleType",
  "cursor",
  "cx",
  "cy",
  "d",
  "decelerate",
  "descent",
  "diffuseConstant",
  "direction",
  "display",
  "divisor",
  "dominantBaseline",
  "dur",
  "dx",
  "dy",
  "edgeMode",
  "elevation",
  "enableBackground",
  "end",
  "exponent",
  "externalResourcesRequired",
  "fill",
  "fillOpacity",
  "fillRule",
  "filter",
  "filterRes",
  "filterUnits",
  "floodColor",
  "floodOpacity",
  "focusable",
  "fontFamily",
  "fontSize",
  "fontSizeAdjust",
  "fontStretch",
  "fontStyle",
  "fontVariant",
  "fontWeight",
  "format",
  "from",
  "fx",
  "fy",
  "g1",
  "g2",
  "glyphName",
  "glyphOrientationHorizontal",
  "glyphOrientationVertical",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "hanging",
  "horizAdvX",
  "horizOriginX",
  "href",
  "ideographic",
  "imageRendering",
  "in2",
  "in",
  "intercept",
  "k1",
  "k2",
  "k3",
  "k4",
  "k",
  "kernelMatrix",
  "kernelUnitLength",
  "kerning",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "letterSpacing",
  "lightingColor",
  "limitingConeAngle",
  "local",
  "markerEnd",
  "markerHeight",
  "markerMid",
  "markerStart",
  "markerUnits",
  "markerWidth",
  "mask",
  "maskContentUnits",
  "maskUnits",
  "mathematical",
  "mode",
  "numOctaves",
  "offset",
  "opacity",
  "operator",
  "order",
  "orient",
  "orientation",
  "origin",
  "overflow",
  "overlinePosition",
  "overlineThickness",
  "paintOrder",
  "panose1",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointerEvents",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "r",
  "radius",
  "refX",
  "refY",
  "renderingIntent",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "restart",
  "result",
  "rotate",
  "rx",
  "ry",
  "seed",
  "shapeRendering",
  "slope",
  "spacing",
  "specularConstant",
  "specularExponent",
  "speed",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stemh",
  "stemv",
  "stitchTiles",
  "stopColor",
  "stopOpacity",
  "strikethroughPosition",
  "strikethroughThickness",
  "string",
  "stroke",
  "strokeDasharray",
  "strokeDashoffset",
  "strokeLinecap",
  "strokeLinejoin",
  "strokeMiterlimit",
  "strokeOpacity",
  "strokeWidth",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textAnchor",
  "textDecoration",
  "textLength",
  "textRendering",
  "to",
  "transform",
  "u1",
  "u2",
  "underlinePosition",
  "underlineThickness",
  "unicode",
  "unicodeBidi",
  "unicodeRange",
  "unitsPerEm",
  "vAlphabetic",
  "values",
  "vectorEffect",
  "version",
  "vertAdvY",
  "vertOriginX",
  "vertOriginY",
  "vHanging",
  "vIdeographic",
  "viewTarget",
  "visibility",
  "vMathematical",
  "widths",
  "wordSpacing",
  "writingMode",
  "x1",
  "x2",
  "x",
  "xChannelSelector",
  "xHeight",
  "xlinkActuate",
  "xlinkArcrole",
  "xlinkHref",
  "xlinkRole",
  "xlinkShow",
  "xlinkTitle",
  "xlinkType",
  "xmlBase",
  "xmlLang",
  "xmlns",
  "xmlnsXlink",
  "xmlSpace",
  "y1",
  "y2",
  "y",
  "yChannelSelector",
  "z",
  "zoomAndPan",
  "ref",
  "key",
  "angle"
], Cp = ["points", "pathLength"], s2 = {
  svg: vV,
  polygon: Cp,
  polyline: Cp
}, Xf = ["dangerouslySetInnerHTML", "onCopy", "onCopyCapture", "onCut", "onCutCapture", "onPaste", "onPasteCapture", "onCompositionEnd", "onCompositionEndCapture", "onCompositionStart", "onCompositionStartCapture", "onCompositionUpdate", "onCompositionUpdateCapture", "onFocus", "onFocusCapture", "onBlur", "onBlurCapture", "onChange", "onChangeCapture", "onBeforeInput", "onBeforeInputCapture", "onInput", "onInputCapture", "onReset", "onResetCapture", "onSubmit", "onSubmitCapture", "onInvalid", "onInvalidCapture", "onLoad", "onLoadCapture", "onError", "onErrorCapture", "onKeyDown", "onKeyDownCapture", "onKeyPress", "onKeyPressCapture", "onKeyUp", "onKeyUpCapture", "onAbort", "onAbortCapture", "onCanPlay", "onCanPlayCapture", "onCanPlayThrough", "onCanPlayThroughCapture", "onDurationChange", "onDurationChangeCapture", "onEmptied", "onEmptiedCapture", "onEncrypted", "onEncryptedCapture", "onEnded", "onEndedCapture", "onLoadedData", "onLoadedDataCapture", "onLoadedMetadata", "onLoadedMetadataCapture", "onLoadStart", "onLoadStartCapture", "onPause", "onPauseCapture", "onPlay", "onPlayCapture", "onPlaying", "onPlayingCapture", "onProgress", "onProgressCapture", "onRateChange", "onRateChangeCapture", "onSeeked", "onSeekedCapture", "onSeeking", "onSeekingCapture", "onStalled", "onStalledCapture", "onSuspend", "onSuspendCapture", "onTimeUpdate", "onTimeUpdateCapture", "onVolumeChange", "onVolumeChangeCapture", "onWaiting", "onWaitingCapture", "onAuxClick", "onAuxClickCapture", "onClick", "onClickCapture", "onContextMenu", "onContextMenuCapture", "onDoubleClick", "onDoubleClickCapture", "onDrag", "onDragCapture", "onDragEnd", "onDragEndCapture", "onDragEnter", "onDragEnterCapture", "onDragExit", "onDragExitCapture", "onDragLeave", "onDragLeaveCapture", "onDragOver", "onDragOverCapture", "onDragStart", "onDragStartCapture", "onDrop", "onDropCapture", "onMouseDown", "onMouseDownCapture", "onMouseEnter", "onMouseLeave", "onMouseMove", "onMouseMoveCapture", "onMouseOut", "onMouseOutCapture", "onMouseOver", "onMouseOverCapture", "onMouseUp", "onMouseUpCapture", "onSelect", "onSelectCapture", "onTouchCancel", "onTouchCancelCapture", "onTouchEnd", "onTouchEndCapture", "onTouchMove", "onTouchMoveCapture", "onTouchStart", "onTouchStartCapture", "onPointerDown", "onPointerDownCapture", "onPointerMove", "onPointerMoveCapture", "onPointerUp", "onPointerUpCapture", "onPointerCancel", "onPointerCancelCapture", "onPointerEnter", "onPointerEnterCapture", "onPointerLeave", "onPointerLeaveCapture", "onPointerOver", "onPointerOverCapture", "onPointerOut", "onPointerOutCapture", "onGotPointerCapture", "onGotPointerCaptureCapture", "onLostPointerCapture", "onLostPointerCaptureCapture", "onScroll", "onScrollCapture", "onWheel", "onWheelCapture", "onAnimationStart", "onAnimationStartCapture", "onAnimationEnd", "onAnimationEndCapture", "onAnimationIteration", "onAnimationIterationCapture", "onTransitionEnd", "onTransitionEndCapture"], h1 = function(t, r) {
  if (!t || typeof t == "function" || typeof t == "boolean")
    return null;
  var n = t;
  if (/* @__PURE__ */ zr(t) && (n = t.props), !eo(n))
    return null;
  var a = {};
  return Object.keys(n).forEach(function(i) {
    Xf.includes(i) && (a[i] = r || function(o) {
      return n[i](n, o);
    });
  }), a;
}, gV = function(t, r, n) {
  return function(a) {
    return t(r, n, a), null;
  };
}, Kn = function(t, r, n) {
  if (!eo(t) || f3(t) !== "object")
    return null;
  var a = null;
  return Object.keys(t).forEach(function(i) {
    var o = t[i];
    Xf.includes(i) && typeof o == "function" && (a || (a = {}), a[i] = gV(o, r, n));
  }), a;
}, yV = ["children"], bV = ["children"];
function xp(e, t) {
  if (e == null)
    return {};
  var r = CV(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function CV(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function d3(e) {
  "@babel/helpers - typeof";
  return d3 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, d3(e);
}
var wp = {
  click: "onClick",
  mousedown: "onMouseDown",
  mouseup: "onMouseUp",
  mouseover: "onMouseOver",
  mousemove: "onMouseMove",
  mouseout: "onMouseOut",
  mouseenter: "onMouseEnter",
  mouseleave: "onMouseLeave",
  touchcancel: "onTouchCancel",
  touchend: "onTouchEnd",
  touchmove: "onTouchMove",
  touchstart: "onTouchStart"
}, Pn = function(t) {
  return typeof t == "string" ? t : t ? t.displayName || t.name || "Component" : "";
}, Op = null, l2 = null, Qf = function e(t) {
  if (t === Op && Array.isArray(l2))
    return l2;
  var r = [];
  return Ma.forEach(t, function(n) {
    Ce(n) || (hm.isFragment(n) ? r = r.concat(e(n.props.children)) : r.push(n));
  }), l2 = r, Op = t, r;
};
function rr(e, t) {
  var r = [], n = [];
  return Array.isArray(t) ? n = t.map(function(a) {
    return Pn(a);
  }) : n = [Pn(t)], Qf(e).forEach(function(a) {
    var i = br(a, "type.displayName") || br(a, "type.name");
    n.indexOf(i) !== -1 && r.push(a);
  }), r;
}
function pr(e, t) {
  var r = rr(e, t);
  return r && r[0];
}
var Sp = function(t) {
  if (!t || !t.props)
    return !1;
  var r = t.props, n = r.width, a = r.height;
  return !(!oe(n) || n <= 0 || !oe(a) || a <= 0);
}, xV = ["a", "altGlyph", "altGlyphDef", "altGlyphItem", "animate", "animateColor", "animateMotion", "animateTransform", "circle", "clipPath", "color-profile", "cursor", "defs", "desc", "ellipse", "feBlend", "feColormatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "filter", "font", "font-face", "font-face-format", "font-face-name", "font-face-url", "foreignObject", "g", "glyph", "glyphRef", "hkern", "image", "line", "lineGradient", "marker", "mask", "metadata", "missing-glyph", "mpath", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "script", "set", "stop", "style", "svg", "switch", "symbol", "text", "textPath", "title", "tref", "tspan", "use", "view", "vkern"], wV = function(t) {
  return t && t.type && ol(t.type) && xV.indexOf(t.type) >= 0;
}, mm = function(t) {
  return t && d3(t) === "object" && "clipDot" in t;
}, OV = function(t, r, n, a) {
  var i, o = (i = s2 == null ? void 0 : s2[a]) !== null && i !== void 0 ? i : [];
  return !xe(t) && (a && o.includes(r) || mV.includes(r)) || n && Xf.includes(r);
}, pe = function(t, r, n) {
  if (!t || typeof t == "function" || typeof t == "boolean")
    return null;
  var a = t;
  if (/* @__PURE__ */ zr(t) && (a = t.props), !eo(a))
    return null;
  var i = {};
  return Object.keys(a).forEach(function(o) {
    var s;
    OV((s = a) === null || s === void 0 ? void 0 : s[o], o, r, n) && (i[o] = a[o]);
  }), i;
}, p3 = function e(t, r) {
  if (t === r)
    return !0;
  var n = Ma.count(t);
  if (n !== Ma.count(r))
    return !1;
  if (n === 0)
    return !0;
  if (n === 1)
    return Pp(Array.isArray(t) ? t[0] : t, Array.isArray(r) ? r[0] : r);
  for (var a = 0; a < n; a++) {
    var i = t[a], o = r[a];
    if (Array.isArray(i) || Array.isArray(o)) {
      if (!e(i, o))
        return !1;
    } else if (!Pp(i, o))
      return !1;
  }
  return !0;
}, Pp = function(t, r) {
  if (Ce(t) && Ce(r))
    return !0;
  if (!Ce(t) && !Ce(r)) {
    var n = t.props || {}, a = n.children, i = xp(n, yV), o = r.props || {}, s = o.children, l = xp(o, bV);
    return a && s ? pi(i, l) && p3(a, s) : !a && !s ? pi(i, l) : !1;
  }
  return !1;
}, Ep = function(t, r) {
  var n = [], a = {};
  return Qf(t).forEach(function(i, o) {
    if (wV(i))
      n.push(i);
    else if (i) {
      var s = Pn(i.type), l = r[s] || {}, c = l.handler, u = l.once;
      if (c && (!u || !a[s])) {
        var f = c(i, s, o);
        n.push(f), a[s] = !0;
      }
    }
  }), n;
}, SV = function(t) {
  var r = t && t.type;
  return r && wp[r] ? wp[r] : null;
}, PV = function(t, r) {
  return Qf(r).indexOf(t);
}, EV = ["children", "width", "height", "viewBox", "className", "style", "title", "desc"];
function h3() {
  return h3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, h3.apply(this, arguments);
}
function jV(e, t) {
  if (e == null)
    return {};
  var r = _V(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function _V(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function v3(e) {
  var t = e.children, r = e.width, n = e.height, a = e.viewBox, i = e.className, o = e.style, s = e.title, l = e.desc, c = jV(e, EV), u = a || {
    width: r,
    height: n,
    x: 0,
    y: 0
  }, f = _e("recharts-surface", i);
  return /* @__PURE__ */ P.createElement("svg", h3({}, pe(c, !0, "svg"), {
    className: f,
    width: r,
    height: n,
    style: o,
    viewBox: "".concat(u.x, " ").concat(u.y, " ").concat(u.width, " ").concat(u.height)
  }), /* @__PURE__ */ P.createElement("title", null, s), /* @__PURE__ */ P.createElement("desc", null, l), t);
}
var DV = ["children", "className"];
function m3() {
  return m3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, m3.apply(this, arguments);
}
function AV(e, t) {
  if (e == null)
    return {};
  var r = MV(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function MV(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
var De = /* @__PURE__ */ P.forwardRef(function(e, t) {
  var r = e.children, n = e.className, a = AV(e, DV), i = _e("recharts-layer", n);
  return /* @__PURE__ */ P.createElement("g", m3({
    className: i
  }, pe(a, !0), {
    ref: t
  }), r);
}), TV = process.env.NODE_ENV !== "production", Ur = function(t, r) {
  for (var n = arguments.length, a = new Array(n > 2 ? n - 2 : 0), i = 2; i < n; i++)
    a[i - 2] = arguments[i];
  if (TV && typeof console < "u" && console.warn && (r === void 0 && console.warn("LogUtils requires an error message argument"), !t))
    if (r === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var o = 0;
      console.warn(r.replace(/%s/g, function() {
        return a[o++];
      }));
    }
};
function $V(e, t, r) {
  var n = -1, a = e.length;
  t < 0 && (t = -t > a ? 0 : a + t), r = r > a ? a : r, r < 0 && (r += a), a = t > r ? 0 : r - t >>> 0, t >>>= 0;
  for (var i = Array(a); ++n < a; )
    i[n] = e[n + t];
  return i;
}
var NV = $V, IV = NV;
function LV(e, t, r) {
  var n = e.length;
  return r = r === void 0 ? n : r, !t && r >= n ? e : IV(e, t, r);
}
var RV = LV, kV = "\\ud800-\\udfff", BV = "\\u0300-\\u036f", VV = "\\ufe20-\\ufe2f", HV = "\\u20d0-\\u20ff", FV = BV + VV + HV, WV = "\\ufe0e\\ufe0f", zV = "\\u200d", UV = RegExp("[" + zV + kV + FV + WV + "]");
function ZV(e) {
  return UV.test(e);
}
var gm = ZV;
function qV(e) {
  return e.split("");
}
var GV = qV, ym = "\\ud800-\\udfff", YV = "\\u0300-\\u036f", KV = "\\ufe20-\\ufe2f", XV = "\\u20d0-\\u20ff", QV = YV + KV + XV, JV = "\\ufe0e\\ufe0f", eH = "[" + ym + "]", g3 = "[" + QV + "]", y3 = "\\ud83c[\\udffb-\\udfff]", tH = "(?:" + g3 + "|" + y3 + ")", bm = "[^" + ym + "]", Cm = "(?:\\ud83c[\\udde6-\\uddff]){2}", xm = "[\\ud800-\\udbff][\\udc00-\\udfff]", rH = "\\u200d", wm = tH + "?", Om = "[" + JV + "]?", nH = "(?:" + rH + "(?:" + [bm, Cm, xm].join("|") + ")" + Om + wm + ")*", aH = Om + wm + nH, iH = "(?:" + [bm + g3 + "?", g3, Cm, xm, eH].join("|") + ")", oH = RegExp(y3 + "(?=" + y3 + ")|" + iH + aH, "g");
function sH(e) {
  return e.match(oH) || [];
}
var lH = sH, cH = GV, uH = gm, fH = lH;
function dH(e) {
  return uH(e) ? fH(e) : cH(e);
}
var pH = dH, hH = RV, vH = gm, mH = pH, gH = fm;
function yH(e) {
  return function(t) {
    t = gH(t);
    var r = vH(t) ? mH(t) : void 0, n = r ? r[0] : t.charAt(0), a = r ? hH(r, 1).join("") : t.slice(1);
    return n[e]() + a;
  };
}
var bH = yH, CH = bH, xH = CH("toUpperCase"), wH = xH;
const Fc = /* @__PURE__ */ Je(wH);
function ut(e) {
  return function() {
    return e;
  };
}
const Sm = Math.cos, v1 = Math.sin, Kr = Math.sqrt, m1 = Math.PI, Wc = 2 * m1, b3 = Math.PI, C3 = 2 * b3, xa = 1e-6, OH = C3 - xa;
function Pm(e) {
  this._ += e[0];
  for (let t = 1, r = e.length; t < r; ++t)
    this._ += arguments[t] + e[t];
}
function SH(e) {
  let t = Math.floor(e);
  if (!(t >= 0))
    throw new Error(`invalid digits: ${e}`);
  if (t > 15)
    return Pm;
  const r = 10 ** t;
  return function(n) {
    this._ += n[0];
    for (let a = 1, i = n.length; a < i; ++a)
      this._ += Math.round(arguments[a] * r) / r + n[a];
  };
}
class PH {
  constructor(t) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "", this._append = t == null ? Pm : SH(t);
  }
  moveTo(t, r) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +r}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
  }
  lineTo(t, r) {
    this._append`L${this._x1 = +t},${this._y1 = +r}`;
  }
  quadraticCurveTo(t, r, n, a) {
    this._append`Q${+t},${+r},${this._x1 = +n},${this._y1 = +a}`;
  }
  bezierCurveTo(t, r, n, a, i, o) {
    this._append`C${+t},${+r},${+n},${+a},${this._x1 = +i},${this._y1 = +o}`;
  }
  arcTo(t, r, n, a, i) {
    if (t = +t, r = +r, n = +n, a = +a, i = +i, i < 0)
      throw new Error(`negative radius: ${i}`);
    let o = this._x1, s = this._y1, l = n - t, c = a - r, u = o - t, f = s - r, p = u * u + f * f;
    if (this._x1 === null)
      this._append`M${this._x1 = t},${this._y1 = r}`;
    else if (p > xa)
      if (!(Math.abs(f * l - c * u) > xa) || !i)
        this._append`L${this._x1 = t},${this._y1 = r}`;
      else {
        let h = n - o, m = a - s, v = l * l + c * c, g = h * h + m * m, y = Math.sqrt(v), b = Math.sqrt(p), w = i * Math.tan((b3 - Math.acos((v + p - g) / (2 * y * b))) / 2), x = w / b, C = w / y;
        Math.abs(x - 1) > xa && this._append`L${t + x * u},${r + x * f}`, this._append`A${i},${i},0,0,${+(f * h > u * m)},${this._x1 = t + C * l},${this._y1 = r + C * c}`;
      }
  }
  arc(t, r, n, a, i, o) {
    if (t = +t, r = +r, n = +n, o = !!o, n < 0)
      throw new Error(`negative radius: ${n}`);
    let s = n * Math.cos(a), l = n * Math.sin(a), c = t + s, u = r + l, f = 1 ^ o, p = o ? a - i : i - a;
    this._x1 === null ? this._append`M${c},${u}` : (Math.abs(this._x1 - c) > xa || Math.abs(this._y1 - u) > xa) && this._append`L${c},${u}`, n && (p < 0 && (p = p % C3 + C3), p > OH ? this._append`A${n},${n},0,1,${f},${t - s},${r - l}A${n},${n},0,1,${f},${this._x1 = c},${this._y1 = u}` : p > xa && this._append`A${n},${n},0,${+(p >= b3)},${f},${this._x1 = t + n * Math.cos(i)},${this._y1 = r + n * Math.sin(i)}`);
  }
  rect(t, r, n, a) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +r}h${n = +n}v${+a}h${-n}Z`;
  }
  toString() {
    return this._;
  }
}
function Jf(e) {
  let t = 3;
  return e.digits = function(r) {
    if (!arguments.length)
      return t;
    if (r == null)
      t = null;
    else {
      const n = Math.floor(r);
      if (!(n >= 0))
        throw new RangeError(`invalid digits: ${r}`);
      t = n;
    }
    return e;
  }, () => new PH(t);
}
function ed(e) {
  return typeof e == "object" && "length" in e ? e : Array.from(e);
}
function Em(e) {
  this._context = e;
}
Em.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      default:
        this._context.lineTo(e, t);
        break;
    }
  }
};
function zc(e) {
  return new Em(e);
}
function jm(e) {
  return e[0];
}
function _m(e) {
  return e[1];
}
function Dm(e, t) {
  var r = ut(!0), n = null, a = zc, i = null, o = Jf(s);
  e = typeof e == "function" ? e : e === void 0 ? jm : ut(e), t = typeof t == "function" ? t : t === void 0 ? _m : ut(t);
  function s(l) {
    var c, u = (l = ed(l)).length, f, p = !1, h;
    for (n == null && (i = a(h = o())), c = 0; c <= u; ++c)
      !(c < u && r(f = l[c], c, l)) === p && ((p = !p) ? i.lineStart() : i.lineEnd()), p && i.point(+e(f, c, l), +t(f, c, l));
    if (h)
      return i = null, h + "" || null;
  }
  return s.x = function(l) {
    return arguments.length ? (e = typeof l == "function" ? l : ut(+l), s) : e;
  }, s.y = function(l) {
    return arguments.length ? (t = typeof l == "function" ? l : ut(+l), s) : t;
  }, s.defined = function(l) {
    return arguments.length ? (r = typeof l == "function" ? l : ut(!!l), s) : r;
  }, s.curve = function(l) {
    return arguments.length ? (a = l, n != null && (i = a(n)), s) : a;
  }, s.context = function(l) {
    return arguments.length ? (l == null ? n = i = null : i = a(n = l), s) : n;
  }, s;
}
function Pl(e, t, r) {
  var n = null, a = ut(!0), i = null, o = zc, s = null, l = Jf(c);
  e = typeof e == "function" ? e : e === void 0 ? jm : ut(+e), t = typeof t == "function" ? t : ut(t === void 0 ? 0 : +t), r = typeof r == "function" ? r : r === void 0 ? _m : ut(+r);
  function c(f) {
    var p, h, m, v = (f = ed(f)).length, g, y = !1, b, w = new Array(v), x = new Array(v);
    for (i == null && (s = o(b = l())), p = 0; p <= v; ++p) {
      if (!(p < v && a(g = f[p], p, f)) === y)
        if (y = !y)
          h = p, s.areaStart(), s.lineStart();
        else {
          for (s.lineEnd(), s.lineStart(), m = p - 1; m >= h; --m)
            s.point(w[m], x[m]);
          s.lineEnd(), s.areaEnd();
        }
      y && (w[p] = +e(g, p, f), x[p] = +t(g, p, f), s.point(n ? +n(g, p, f) : w[p], r ? +r(g, p, f) : x[p]));
    }
    if (b)
      return s = null, b + "" || null;
  }
  function u() {
    return Dm().defined(a).curve(o).context(i);
  }
  return c.x = function(f) {
    return arguments.length ? (e = typeof f == "function" ? f : ut(+f), n = null, c) : e;
  }, c.x0 = function(f) {
    return arguments.length ? (e = typeof f == "function" ? f : ut(+f), c) : e;
  }, c.x1 = function(f) {
    return arguments.length ? (n = f == null ? null : typeof f == "function" ? f : ut(+f), c) : n;
  }, c.y = function(f) {
    return arguments.length ? (t = typeof f == "function" ? f : ut(+f), r = null, c) : t;
  }, c.y0 = function(f) {
    return arguments.length ? (t = typeof f == "function" ? f : ut(+f), c) : t;
  }, c.y1 = function(f) {
    return arguments.length ? (r = f == null ? null : typeof f == "function" ? f : ut(+f), c) : r;
  }, c.lineX0 = c.lineY0 = function() {
    return u().x(e).y(t);
  }, c.lineY1 = function() {
    return u().x(e).y(r);
  }, c.lineX1 = function() {
    return u().x(n).y(t);
  }, c.defined = function(f) {
    return arguments.length ? (a = typeof f == "function" ? f : ut(!!f), c) : a;
  }, c.curve = function(f) {
    return arguments.length ? (o = f, i != null && (s = o(i)), c) : o;
  }, c.context = function(f) {
    return arguments.length ? (f == null ? i = s = null : s = o(i = f), c) : i;
  }, c;
}
class Am {
  constructor(t, r) {
    this._context = t, this._x = r;
  }
  areaStart() {
    this._line = 0;
  }
  areaEnd() {
    this._line = NaN;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  }
  point(t, r) {
    switch (t = +t, r = +r, this._point) {
      case 0: {
        this._point = 1, this._line ? this._context.lineTo(t, r) : this._context.moveTo(t, r);
        break;
      }
      case 1:
        this._point = 2;
      default: {
        this._x ? this._context.bezierCurveTo(this._x0 = (this._x0 + t) / 2, this._y0, this._x0, r, t, r) : this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + r) / 2, t, this._y0, t, r);
        break;
      }
    }
    this._x0 = t, this._y0 = r;
  }
}
function EH(e) {
  return new Am(e, !0);
}
function jH(e) {
  return new Am(e, !1);
}
const td = {
  draw(e, t) {
    const r = Kr(t / m1);
    e.moveTo(r, 0), e.arc(0, 0, r, 0, Wc);
  }
}, _H = {
  draw(e, t) {
    const r = Kr(t / 5) / 2;
    e.moveTo(-3 * r, -r), e.lineTo(-r, -r), e.lineTo(-r, -3 * r), e.lineTo(r, -3 * r), e.lineTo(r, -r), e.lineTo(3 * r, -r), e.lineTo(3 * r, r), e.lineTo(r, r), e.lineTo(r, 3 * r), e.lineTo(-r, 3 * r), e.lineTo(-r, r), e.lineTo(-3 * r, r), e.closePath();
  }
}, Mm = Kr(1 / 3), DH = Mm * 2, AH = {
  draw(e, t) {
    const r = Kr(t / DH), n = r * Mm;
    e.moveTo(0, -r), e.lineTo(n, 0), e.lineTo(0, r), e.lineTo(-n, 0), e.closePath();
  }
}, MH = {
  draw(e, t) {
    const r = Kr(t), n = -r / 2;
    e.rect(n, n, r, r);
  }
}, TH = 0.8908130915292852, Tm = v1(m1 / 10) / v1(7 * m1 / 10), $H = v1(Wc / 10) * Tm, NH = -Sm(Wc / 10) * Tm, IH = {
  draw(e, t) {
    const r = Kr(t * TH), n = $H * r, a = NH * r;
    e.moveTo(0, -r), e.lineTo(n, a);
    for (let i = 1; i < 5; ++i) {
      const o = Wc * i / 5, s = Sm(o), l = v1(o);
      e.lineTo(l * r, -s * r), e.lineTo(s * n - l * a, l * n + s * a);
    }
    e.closePath();
  }
}, c2 = Kr(3), LH = {
  draw(e, t) {
    const r = -Kr(t / (c2 * 3));
    e.moveTo(0, r * 2), e.lineTo(-c2 * r, -r), e.lineTo(c2 * r, -r), e.closePath();
  }
}, Or = -0.5, Sr = Kr(3) / 2, x3 = 1 / Kr(12), RH = (x3 / 2 + 1) * 3, kH = {
  draw(e, t) {
    const r = Kr(t / RH), n = r / 2, a = r * x3, i = n, o = r * x3 + r, s = -i, l = o;
    e.moveTo(n, a), e.lineTo(i, o), e.lineTo(s, l), e.lineTo(Or * n - Sr * a, Sr * n + Or * a), e.lineTo(Or * i - Sr * o, Sr * i + Or * o), e.lineTo(Or * s - Sr * l, Sr * s + Or * l), e.lineTo(Or * n + Sr * a, Or * a - Sr * n), e.lineTo(Or * i + Sr * o, Or * o - Sr * i), e.lineTo(Or * s + Sr * l, Or * l - Sr * s), e.closePath();
  }
};
function BH(e, t) {
  let r = null, n = Jf(a);
  e = typeof e == "function" ? e : ut(e || td), t = typeof t == "function" ? t : ut(t === void 0 ? 64 : +t);
  function a() {
    let i;
    if (r || (r = i = n()), e.apply(this, arguments).draw(r, +t.apply(this, arguments)), i)
      return r = null, i + "" || null;
  }
  return a.type = function(i) {
    return arguments.length ? (e = typeof i == "function" ? i : ut(i), a) : e;
  }, a.size = function(i) {
    return arguments.length ? (t = typeof i == "function" ? i : ut(+i), a) : t;
  }, a.context = function(i) {
    return arguments.length ? (r = i ?? null, a) : r;
  }, a;
}
function g1() {
}
function y1(e, t, r) {
  e._context.bezierCurveTo(
    (2 * e._x0 + e._x1) / 3,
    (2 * e._y0 + e._y1) / 3,
    (e._x0 + 2 * e._x1) / 3,
    (e._y0 + 2 * e._y1) / 3,
    (e._x0 + 4 * e._x1 + t) / 6,
    (e._y0 + 4 * e._y1 + r) / 6
  );
}
function $m(e) {
  this._context = e;
}
$m.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        y1(this, this._x1, this._y1);
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      default:
        y1(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function VH(e) {
  return new $m(e);
}
function Nm(e) {
  this._context = e;
}
Nm.prototype = {
  areaStart: g1,
  areaEnd: g1,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2), this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._x2 = e, this._y2 = t;
        break;
      case 1:
        this._point = 2, this._x3 = e, this._y3 = t;
        break;
      case 2:
        this._point = 3, this._x4 = e, this._y4 = t, this._context.moveTo((this._x0 + 4 * this._x1 + e) / 6, (this._y0 + 4 * this._y1 + t) / 6);
        break;
      default:
        y1(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function HH(e) {
  return new Nm(e);
}
function Im(e) {
  this._context = e;
}
Im.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var r = (this._x0 + 4 * this._x1 + e) / 6, n = (this._y0 + 4 * this._y1 + t) / 6;
        this._line ? this._context.lineTo(r, n) : this._context.moveTo(r, n);
        break;
      case 3:
        this._point = 4;
      default:
        y1(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function FH(e) {
  return new Im(e);
}
function Lm(e) {
  this._context = e;
}
Lm.prototype = {
  areaStart: g1,
  areaEnd: g1,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._point && this._context.closePath();
  },
  point: function(e, t) {
    e = +e, t = +t, this._point ? this._context.lineTo(e, t) : (this._point = 1, this._context.moveTo(e, t));
  }
};
function WH(e) {
  return new Lm(e);
}
function jp(e) {
  return e < 0 ? -1 : 1;
}
function _p(e, t, r) {
  var n = e._x1 - e._x0, a = t - e._x1, i = (e._y1 - e._y0) / (n || a < 0 && -0), o = (r - e._y1) / (a || n < 0 && -0), s = (i * a + o * n) / (n + a);
  return (jp(i) + jp(o)) * Math.min(Math.abs(i), Math.abs(o), 0.5 * Math.abs(s)) || 0;
}
function Dp(e, t) {
  var r = e._x1 - e._x0;
  return r ? (3 * (e._y1 - e._y0) / r - t) / 2 : t;
}
function u2(e, t, r) {
  var n = e._x0, a = e._y0, i = e._x1, o = e._y1, s = (i - n) / 3;
  e._context.bezierCurveTo(n + s, a + s * t, i - s, o - s * r, i, o);
}
function b1(e) {
  this._context = e;
}
b1.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        u2(this, this._t0, Dp(this, this._t0));
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    var r = NaN;
    if (e = +e, t = +t, !(e === this._x1 && t === this._y1)) {
      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3, u2(this, Dp(this, r = _p(this, e, t)), r);
          break;
        default:
          u2(this, this._t0, r = _p(this, e, t));
          break;
      }
      this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t, this._t0 = r;
    }
  }
};
function Rm(e) {
  this._context = new km(e);
}
(Rm.prototype = Object.create(b1.prototype)).point = function(e, t) {
  b1.prototype.point.call(this, t, e);
};
function km(e) {
  this._context = e;
}
km.prototype = {
  moveTo: function(e, t) {
    this._context.moveTo(t, e);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(e, t) {
    this._context.lineTo(t, e);
  },
  bezierCurveTo: function(e, t, r, n, a, i) {
    this._context.bezierCurveTo(t, e, n, r, i, a);
  }
};
function zH(e) {
  return new b1(e);
}
function UH(e) {
  return new Rm(e);
}
function Bm(e) {
  this._context = e;
}
Bm.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [], this._y = [];
  },
  lineEnd: function() {
    var e = this._x, t = this._y, r = e.length;
    if (r)
      if (this._line ? this._context.lineTo(e[0], t[0]) : this._context.moveTo(e[0], t[0]), r === 2)
        this._context.lineTo(e[1], t[1]);
      else
        for (var n = Ap(e), a = Ap(t), i = 0, o = 1; o < r; ++i, ++o)
          this._context.bezierCurveTo(n[0][i], a[0][i], n[1][i], a[1][i], e[o], t[o]);
    (this._line || this._line !== 0 && r === 1) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
  },
  point: function(e, t) {
    this._x.push(+e), this._y.push(+t);
  }
};
function Ap(e) {
  var t, r = e.length - 1, n, a = new Array(r), i = new Array(r), o = new Array(r);
  for (a[0] = 0, i[0] = 2, o[0] = e[0] + 2 * e[1], t = 1; t < r - 1; ++t)
    a[t] = 1, i[t] = 4, o[t] = 4 * e[t] + 2 * e[t + 1];
  for (a[r - 1] = 2, i[r - 1] = 7, o[r - 1] = 8 * e[r - 1] + e[r], t = 1; t < r; ++t)
    n = a[t] / i[t - 1], i[t] -= n, o[t] -= n * o[t - 1];
  for (a[r - 1] = o[r - 1] / i[r - 1], t = r - 2; t >= 0; --t)
    a[t] = (o[t] - a[t + 1]) / i[t];
  for (i[r - 1] = (e[r] + a[r - 1]) / 2, t = 0; t < r - 1; ++t)
    i[t] = 2 * e[t + 1] - a[t + 1];
  return [a, i];
}
function ZH(e) {
  return new Bm(e);
}
function Uc(e, t) {
  this._context = e, this._t = t;
}
Uc.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN, this._point = 0;
  },
  lineEnd: function() {
    0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      default: {
        if (this._t <= 0)
          this._context.lineTo(this._x, t), this._context.lineTo(e, t);
        else {
          var r = this._x * (1 - this._t) + e * this._t;
          this._context.lineTo(r, this._y), this._context.lineTo(r, t);
        }
        break;
      }
    }
    this._x = e, this._y = t;
  }
};
function qH(e) {
  return new Uc(e, 0.5);
}
function GH(e) {
  return new Uc(e, 0);
}
function YH(e) {
  return new Uc(e, 1);
}
function Ci(e, t) {
  if ((o = e.length) > 1)
    for (var r = 1, n, a, i = e[t[0]], o, s = i.length; r < o; ++r)
      for (a = i, i = e[t[r]], n = 0; n < s; ++n)
        i[n][1] += i[n][0] = isNaN(a[n][1]) ? a[n][0] : a[n][1];
}
function w3(e) {
  for (var t = e.length, r = new Array(t); --t >= 0; )
    r[t] = t;
  return r;
}
function KH(e, t) {
  return e[t];
}
function XH(e) {
  const t = [];
  return t.key = e, t;
}
function QH() {
  var e = ut([]), t = w3, r = Ci, n = KH;
  function a(i) {
    var o = Array.from(e.apply(this, arguments), XH), s, l = o.length, c = -1, u;
    for (const f of i)
      for (s = 0, ++c; s < l; ++s)
        (o[s][c] = [0, +n(f, o[s].key, c, i)]).data = f;
    for (s = 0, u = ed(t(o)); s < l; ++s)
      o[u[s]].index = s;
    return r(o, u), o;
  }
  return a.keys = function(i) {
    return arguments.length ? (e = typeof i == "function" ? i : ut(Array.from(i)), a) : e;
  }, a.value = function(i) {
    return arguments.length ? (n = typeof i == "function" ? i : ut(+i), a) : n;
  }, a.order = function(i) {
    return arguments.length ? (t = i == null ? w3 : typeof i == "function" ? i : ut(Array.from(i)), a) : t;
  }, a.offset = function(i) {
    return arguments.length ? (r = i ?? Ci, a) : r;
  }, a;
}
function JH(e, t) {
  if ((n = e.length) > 0) {
    for (var r, n, a = 0, i = e[0].length, o; a < i; ++a) {
      for (o = r = 0; r < n; ++r)
        o += e[r][a][1] || 0;
      if (o)
        for (r = 0; r < n; ++r)
          e[r][a][1] /= o;
    }
    Ci(e, t);
  }
}
function eF(e, t) {
  if ((a = e.length) > 0) {
    for (var r = 0, n = e[t[0]], a, i = n.length; r < i; ++r) {
      for (var o = 0, s = 0; o < a; ++o)
        s += e[o][r][1] || 0;
      n[r][1] += n[r][0] = -s / 2;
    }
    Ci(e, t);
  }
}
function tF(e, t) {
  if (!(!((o = e.length) > 0) || !((i = (a = e[t[0]]).length) > 0))) {
    for (var r = 0, n = 1, a, i, o; n < i; ++n) {
      for (var s = 0, l = 0, c = 0; s < o; ++s) {
        for (var u = e[t[s]], f = u[n][1] || 0, p = u[n - 1][1] || 0, h = (f - p) / 2, m = 0; m < s; ++m) {
          var v = e[t[m]], g = v[n][1] || 0, y = v[n - 1][1] || 0;
          h += g - y;
        }
        l += f, c += h * f;
      }
      a[n - 1][1] += a[n - 1][0] = r, l && (r -= c / l);
    }
    a[n - 1][1] += a[n - 1][0] = r, Ci(e, t);
  }
}
function ps(e) {
  "@babel/helpers - typeof";
  return ps = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ps(e);
}
var rF = ["type", "size", "sizeType"];
function O3() {
  return O3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, O3.apply(this, arguments);
}
function Mp(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Tp(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Mp(Object(r), !0).forEach(function(n) {
      nF(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Mp(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function nF(e, t, r) {
  return t = aF(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function aF(e) {
  var t = iF(e, "string");
  return ps(t) == "symbol" ? t : t + "";
}
function iF(e, t) {
  if (ps(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (ps(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function oF(e, t) {
  if (e == null)
    return {};
  var r = sF(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function sF(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
var Vm = {
  symbolCircle: td,
  symbolCross: _H,
  symbolDiamond: AH,
  symbolSquare: MH,
  symbolStar: IH,
  symbolTriangle: LH,
  symbolWye: kH
}, lF = Math.PI / 180, cF = function(t) {
  var r = "symbol".concat(Fc(t));
  return Vm[r] || td;
}, uF = function(t, r, n) {
  if (r === "area")
    return t;
  switch (n) {
    case "cross":
      return 5 * t * t / 9;
    case "diamond":
      return 0.5 * t * t / Math.sqrt(3);
    case "square":
      return t * t;
    case "star": {
      var a = 18 * lF;
      return 1.25 * t * t * (Math.tan(a) - Math.tan(a * 2) * Math.pow(Math.tan(a), 2));
    }
    case "triangle":
      return Math.sqrt(3) * t * t / 4;
    case "wye":
      return (21 - 10 * Math.sqrt(3)) * t * t / 8;
    default:
      return Math.PI * t * t / 4;
  }
}, fF = function(t, r) {
  Vm["symbol".concat(Fc(t))] = r;
}, Zc = function(t) {
  var r = t.type, n = r === void 0 ? "circle" : r, a = t.size, i = a === void 0 ? 64 : a, o = t.sizeType, s = o === void 0 ? "area" : o, l = oF(t, rF), c = Tp(Tp({}, l), {}, {
    type: n,
    size: i,
    sizeType: s
  }), u = function() {
    var g = cF(n), y = BH().type(g).size(uF(i, s, n));
    return y();
  }, f = c.className, p = c.cx, h = c.cy, m = pe(c, !0);
  return p === +p && h === +h && i === +i ? /* @__PURE__ */ P.createElement("path", O3({}, m, {
    className: _e("recharts-symbols", f),
    transform: "translate(".concat(p, ", ").concat(h, ")"),
    d: u()
  })) : null;
};
Zc.registerSymbol = fF;
function xi(e) {
  "@babel/helpers - typeof";
  return xi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, xi(e);
}
function S3() {
  return S3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, S3.apply(this, arguments);
}
function $p(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function dF(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? $p(Object(r), !0).forEach(function(n) {
      hs(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : $p(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function pF(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Np(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Fm(n.key), n);
  }
}
function hF(e, t, r) {
  return t && Np(e.prototype, t), r && Np(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function vF(e, t, r) {
  return t = C1(t), mF(e, Hm() ? Reflect.construct(t, r || [], C1(e).constructor) : t.apply(e, r));
}
function mF(e, t) {
  if (t && (xi(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return gF(e);
}
function gF(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Hm() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Hm = function() {
    return !!e;
  })();
}
function C1(e) {
  return C1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, C1(e);
}
function yF(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && P3(e, t);
}
function P3(e, t) {
  return P3 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, P3(e, t);
}
function hs(e, t, r) {
  return t = Fm(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Fm(e) {
  var t = bF(e, "string");
  return xi(t) == "symbol" ? t : t + "";
}
function bF(e, t) {
  if (xi(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (xi(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Pr = 32, rd = /* @__PURE__ */ function(e) {
  function t() {
    return pF(this, t), vF(this, t, arguments);
  }
  return yF(t, e), hF(t, [{
    key: "renderIcon",
    value: (
      /**
       * Render the path of icon
       * @param {Object} data Data of each legend item
       * @return {String} Path element
       */
      function(n) {
        var a = this.props.inactiveColor, i = Pr / 2, o = Pr / 6, s = Pr / 3, l = n.inactive ? a : n.color;
        if (n.type === "plainline")
          return /* @__PURE__ */ P.createElement("line", {
            strokeWidth: 4,
            fill: "none",
            stroke: l,
            strokeDasharray: n.payload.strokeDasharray,
            x1: 0,
            y1: i,
            x2: Pr,
            y2: i,
            className: "recharts-legend-icon"
          });
        if (n.type === "line")
          return /* @__PURE__ */ P.createElement("path", {
            strokeWidth: 4,
            fill: "none",
            stroke: l,
            d: "M0,".concat(i, "h").concat(s, `
            A`).concat(o, ",").concat(o, ",0,1,1,").concat(2 * s, ",").concat(i, `
            H`).concat(Pr, "M").concat(2 * s, ",").concat(i, `
            A`).concat(o, ",").concat(o, ",0,1,1,").concat(s, ",").concat(i),
            className: "recharts-legend-icon"
          });
        if (n.type === "rect")
          return /* @__PURE__ */ P.createElement("path", {
            stroke: "none",
            fill: l,
            d: "M0,".concat(Pr / 8, "h").concat(Pr, "v").concat(Pr * 3 / 4, "h").concat(-Pr, "z"),
            className: "recharts-legend-icon"
          });
        if (/* @__PURE__ */ P.isValidElement(n.legendIcon)) {
          var c = dF({}, n);
          return delete c.legendIcon, /* @__PURE__ */ P.cloneElement(n.legendIcon, c);
        }
        return /* @__PURE__ */ P.createElement(Zc, {
          fill: l,
          cx: i,
          cy: i,
          size: Pr,
          sizeType: "diameter",
          type: n.type
        });
      }
    )
    /**
     * Draw items of legend
     * @return {ReactElement} Items
     */
  }, {
    key: "renderItems",
    value: function() {
      var n = this, a = this.props, i = a.payload, o = a.iconSize, s = a.layout, l = a.formatter, c = a.inactiveColor, u = {
        x: 0,
        y: 0,
        width: Pr,
        height: Pr
      }, f = {
        display: s === "horizontal" ? "inline-block" : "block",
        marginRight: 10
      }, p = {
        display: "inline-block",
        verticalAlign: "middle",
        marginRight: 4
      };
      return i.map(function(h, m) {
        var v = h.formatter || l, g = _e(hs(hs({
          "recharts-legend-item": !0
        }, "legend-item-".concat(m), !0), "inactive", h.inactive));
        if (h.type === "none")
          return null;
        var y = xe(h.value) ? null : h.value;
        Ur(
          !xe(h.value),
          `The name property is also required when using a function for the dataKey of a chart's cartesian components. Ex: <Bar name="Name of my Data"/>`
          // eslint-disable-line max-len
        );
        var b = h.inactive ? c : h.color;
        return /* @__PURE__ */ P.createElement("li", S3({
          className: g,
          style: f,
          key: "legend-item-".concat(m)
        }, Kn(n.props, h, m)), /* @__PURE__ */ P.createElement(v3, {
          width: o,
          height: o,
          viewBox: u,
          style: p
        }, n.renderIcon(h)), /* @__PURE__ */ P.createElement("span", {
          className: "recharts-legend-item-text",
          style: {
            color: b
          }
        }, v ? v(y, h, m) : y));
      });
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, a = n.payload, i = n.layout, o = n.align;
      if (!a || !a.length)
        return null;
      var s = {
        padding: 0,
        margin: 0,
        textAlign: i === "horizontal" ? o : "left"
      };
      return /* @__PURE__ */ P.createElement("ul", {
        className: "recharts-default-legend",
        style: s
      }, this.renderItems());
    }
  }]);
}(Cr);
hs(rd, "displayName", "Legend");
hs(rd, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "middle",
  inactiveColor: "#ccc"
});
var CF = Bc;
function xF() {
  this.__data__ = new CF(), this.size = 0;
}
var wF = xF;
function OF(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
var SF = OF;
function PF(e) {
  return this.__data__.get(e);
}
var EF = PF;
function jF(e) {
  return this.__data__.has(e);
}
var _F = jF, DF = Bc, AF = Zf, MF = qf, TF = 200;
function $F(e, t) {
  var r = this.__data__;
  if (r instanceof DF) {
    var n = r.__data__;
    if (!AF || n.length < TF - 1)
      return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new MF(n);
  }
  return r.set(e, t), this.size = r.size, this;
}
var NF = $F, IF = Bc, LF = wF, RF = SF, kF = EF, BF = _F, VF = NF;
function io(e) {
  var t = this.__data__ = new IF(e);
  this.size = t.size;
}
io.prototype.clear = LF;
io.prototype.delete = RF;
io.prototype.get = kF;
io.prototype.has = BF;
io.prototype.set = VF;
var Wm = io, HF = "__lodash_hash_undefined__";
function FF(e) {
  return this.__data__.set(e, HF), this;
}
var WF = FF;
function zF(e) {
  return this.__data__.has(e);
}
var UF = zF, ZF = qf, qF = WF, GF = UF;
function x1(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new ZF(); ++t < r; )
    this.add(e[t]);
}
x1.prototype.add = x1.prototype.push = qF;
x1.prototype.has = GF;
var zm = x1;
function YF(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
var Um = YF;
function KF(e, t) {
  return e.has(t);
}
var Zm = KF, XF = zm, QF = Um, JF = Zm, eW = 1, tW = 2;
function rW(e, t, r, n, a, i) {
  var o = r & eW, s = e.length, l = t.length;
  if (s != l && !(o && l > s))
    return !1;
  var c = i.get(e), u = i.get(t);
  if (c && u)
    return c == t && u == e;
  var f = -1, p = !0, h = r & tW ? new XF() : void 0;
  for (i.set(e, t), i.set(t, e); ++f < s; ) {
    var m = e[f], v = t[f];
    if (n)
      var g = o ? n(v, m, f, t, e, i) : n(m, v, f, e, t, i);
    if (g !== void 0) {
      if (g)
        continue;
      p = !1;
      break;
    }
    if (h) {
      if (!QF(t, function(y, b) {
        if (!JF(h, b) && (m === y || a(m, y, r, n, i)))
          return h.push(b);
      })) {
        p = !1;
        break;
      }
    } else if (!(m === v || a(m, v, r, n, i))) {
      p = !1;
      break;
    }
  }
  return i.delete(e), i.delete(t), p;
}
var qm = rW, nW = dn, aW = nW.Uint8Array, iW = aW;
function oW(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n, a) {
    r[++t] = [a, n];
  }), r;
}
var sW = oW;
function lW(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n) {
    r[++t] = n;
  }), r;
}
var nd = lW, Ip = il, Lp = iW, cW = Uf, uW = qm, fW = sW, dW = nd, pW = 1, hW = 2, vW = "[object Boolean]", mW = "[object Date]", gW = "[object Error]", yW = "[object Map]", bW = "[object Number]", CW = "[object RegExp]", xW = "[object Set]", wW = "[object String]", OW = "[object Symbol]", SW = "[object ArrayBuffer]", PW = "[object DataView]", Rp = Ip ? Ip.prototype : void 0, f2 = Rp ? Rp.valueOf : void 0;
function EW(e, t, r, n, a, i, o) {
  switch (r) {
    case PW:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case SW:
      return !(e.byteLength != t.byteLength || !i(new Lp(e), new Lp(t)));
    case vW:
    case mW:
    case bW:
      return cW(+e, +t);
    case gW:
      return e.name == t.name && e.message == t.message;
    case CW:
    case wW:
      return e == t + "";
    case yW:
      var s = fW;
    case xW:
      var l = n & pW;
      if (s || (s = dW), e.size != t.size && !l)
        return !1;
      var c = o.get(e);
      if (c)
        return c == t;
      n |= hW, o.set(e, t);
      var u = uW(s(e), s(t), n, a, i, o);
      return o.delete(e), u;
    case OW:
      if (f2)
        return f2.call(e) == f2.call(t);
  }
  return !1;
}
var jW = EW;
function _W(e, t) {
  for (var r = -1, n = t.length, a = e.length; ++r < n; )
    e[a + r] = t[r];
  return e;
}
var Gm = _W, DW = Gm, AW = cr;
function MW(e, t, r) {
  var n = t(e);
  return AW(e) ? n : DW(n, r(e));
}
var TW = MW;
function $W(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = 0, i = []; ++r < n; ) {
    var o = e[r];
    t(o, r, e) && (i[a++] = o);
  }
  return i;
}
var NW = $W;
function IW() {
  return [];
}
var LW = IW, RW = NW, kW = LW, BW = Object.prototype, VW = BW.propertyIsEnumerable, kp = Object.getOwnPropertySymbols, HW = kp ? function(e) {
  return e == null ? [] : (e = Object(e), RW(kp(e), function(t) {
    return VW.call(e, t);
  }));
} : kW, FW = HW;
function WW(e, t) {
  for (var r = -1, n = Array(e); ++r < e; )
    n[r] = t(r);
  return n;
}
var zW = WW, UW = $n, ZW = Nn, qW = "[object Arguments]";
function GW(e) {
  return ZW(e) && UW(e) == qW;
}
var YW = GW, Bp = YW, KW = Nn, Ym = Object.prototype, XW = Ym.hasOwnProperty, QW = Ym.propertyIsEnumerable, JW = Bp(function() {
  return arguments;
}()) ? Bp : function(e) {
  return KW(e) && XW.call(e, "callee") && !QW.call(e, "callee");
}, ad = JW, w1 = { exports: {} };
function ez() {
  return !1;
}
var tz = ez;
w1.exports;
(function(e, t) {
  var r = dn, n = tz, a = t && !t.nodeType && t, i = a && !0 && e && !e.nodeType && e, o = i && i.exports === a, s = o ? r.Buffer : void 0, l = s ? s.isBuffer : void 0, c = l || n;
  e.exports = c;
})(w1, w1.exports);
var Km = w1.exports, rz = 9007199254740991, nz = /^(?:0|[1-9]\d*)$/;
function az(e, t) {
  var r = typeof e;
  return t = t ?? rz, !!t && (r == "number" || r != "symbol" && nz.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var id = az, iz = 9007199254740991;
function oz(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= iz;
}
var od = oz, sz = $n, lz = od, cz = Nn, uz = "[object Arguments]", fz = "[object Array]", dz = "[object Boolean]", pz = "[object Date]", hz = "[object Error]", vz = "[object Function]", mz = "[object Map]", gz = "[object Number]", yz = "[object Object]", bz = "[object RegExp]", Cz = "[object Set]", xz = "[object String]", wz = "[object WeakMap]", Oz = "[object ArrayBuffer]", Sz = "[object DataView]", Pz = "[object Float32Array]", Ez = "[object Float64Array]", jz = "[object Int8Array]", _z = "[object Int16Array]", Dz = "[object Int32Array]", Az = "[object Uint8Array]", Mz = "[object Uint8ClampedArray]", Tz = "[object Uint16Array]", $z = "[object Uint32Array]", pt = {};
pt[Pz] = pt[Ez] = pt[jz] = pt[_z] = pt[Dz] = pt[Az] = pt[Mz] = pt[Tz] = pt[$z] = !0;
pt[uz] = pt[fz] = pt[Oz] = pt[dz] = pt[Sz] = pt[pz] = pt[hz] = pt[vz] = pt[mz] = pt[gz] = pt[yz] = pt[bz] = pt[Cz] = pt[xz] = pt[wz] = !1;
function Nz(e) {
  return cz(e) && lz(e.length) && !!pt[sz(e)];
}
var Iz = Nz;
function Lz(e) {
  return function(t) {
    return e(t);
  };
}
var Xm = Lz, O1 = { exports: {} };
O1.exports;
(function(e, t) {
  var r = im, n = t && !t.nodeType && t, a = n && !0 && e && !e.nodeType && e, i = a && a.exports === n, o = i && r.process, s = function() {
    try {
      var l = a && a.require && a.require("util").types;
      return l || o && o.binding && o.binding("util");
    } catch {
    }
  }();
  e.exports = s;
})(O1, O1.exports);
var Rz = O1.exports, kz = Iz, Bz = Xm, Vp = Rz, Hp = Vp && Vp.isTypedArray, Vz = Hp ? Bz(Hp) : kz, Qm = Vz, Hz = zW, Fz = ad, Wz = cr, zz = Km, Uz = id, Zz = Qm, qz = Object.prototype, Gz = qz.hasOwnProperty;
function Yz(e, t) {
  var r = Wz(e), n = !r && Fz(e), a = !r && !n && zz(e), i = !r && !n && !a && Zz(e), o = r || n || a || i, s = o ? Hz(e.length, String) : [], l = s.length;
  for (var c in e)
    (t || Gz.call(e, c)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    Uz(c, l))) && s.push(c);
  return s;
}
var Kz = Yz, Xz = Object.prototype;
function Qz(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || Xz;
  return e === r;
}
var Jz = Qz;
function eU(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var Jm = eU, tU = Jm, rU = tU(Object.keys, Object), nU = rU, aU = Jz, iU = nU, oU = Object.prototype, sU = oU.hasOwnProperty;
function lU(e) {
  if (!aU(e))
    return iU(e);
  var t = [];
  for (var r in Object(e))
    sU.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
var cU = lU, uU = zf, fU = od;
function dU(e) {
  return e != null && fU(e.length) && !uU(e);
}
var sl = dU, pU = Kz, hU = cU, vU = sl;
function mU(e) {
  return vU(e) ? pU(e) : hU(e);
}
var qc = mU, gU = TW, yU = FW, bU = qc;
function CU(e) {
  return gU(e, bU, yU);
}
var xU = CU, Fp = xU, wU = 1, OU = Object.prototype, SU = OU.hasOwnProperty;
function PU(e, t, r, n, a, i) {
  var o = r & wU, s = Fp(e), l = s.length, c = Fp(t), u = c.length;
  if (l != u && !o)
    return !1;
  for (var f = l; f--; ) {
    var p = s[f];
    if (!(o ? p in t : SU.call(t, p)))
      return !1;
  }
  var h = i.get(e), m = i.get(t);
  if (h && m)
    return h == t && m == e;
  var v = !0;
  i.set(e, t), i.set(t, e);
  for (var g = o; ++f < l; ) {
    p = s[f];
    var y = e[p], b = t[p];
    if (n)
      var w = o ? n(b, y, p, t, e, i) : n(y, b, p, e, t, i);
    if (!(w === void 0 ? y === b || a(y, b, r, n, i) : w)) {
      v = !1;
      break;
    }
    g || (g = p == "constructor");
  }
  if (v && !g) {
    var x = e.constructor, C = t.constructor;
    x != C && "constructor" in e && "constructor" in t && !(typeof x == "function" && x instanceof x && typeof C == "function" && C instanceof C) && (v = !1);
  }
  return i.delete(e), i.delete(t), v;
}
var EU = PU, jU = Fa, _U = dn, DU = jU(_U, "DataView"), AU = DU, MU = Fa, TU = dn, $U = MU(TU, "Promise"), NU = $U, IU = Fa, LU = dn, RU = IU(LU, "Set"), eg = RU, kU = Fa, BU = dn, VU = kU(BU, "WeakMap"), HU = VU, E3 = AU, j3 = Zf, _3 = NU, D3 = eg, A3 = HU, tg = $n, oo = sm, Wp = "[object Map]", FU = "[object Object]", zp = "[object Promise]", Up = "[object Set]", Zp = "[object WeakMap]", qp = "[object DataView]", WU = oo(E3), zU = oo(j3), UU = oo(_3), ZU = oo(D3), qU = oo(A3), wa = tg;
(E3 && wa(new E3(new ArrayBuffer(1))) != qp || j3 && wa(new j3()) != Wp || _3 && wa(_3.resolve()) != zp || D3 && wa(new D3()) != Up || A3 && wa(new A3()) != Zp) && (wa = function(e) {
  var t = tg(e), r = t == FU ? e.constructor : void 0, n = r ? oo(r) : "";
  if (n)
    switch (n) {
      case WU:
        return qp;
      case zU:
        return Wp;
      case UU:
        return zp;
      case ZU:
        return Up;
      case qU:
        return Zp;
    }
  return t;
});
var GU = wa, d2 = Wm, YU = qm, KU = jW, XU = EU, Gp = GU, Yp = cr, Kp = Km, QU = Qm, JU = 1, Xp = "[object Arguments]", Qp = "[object Array]", El = "[object Object]", eZ = Object.prototype, Jp = eZ.hasOwnProperty;
function tZ(e, t, r, n, a, i) {
  var o = Yp(e), s = Yp(t), l = o ? Qp : Gp(e), c = s ? Qp : Gp(t);
  l = l == Xp ? El : l, c = c == Xp ? El : c;
  var u = l == El, f = c == El, p = l == c;
  if (p && Kp(e)) {
    if (!Kp(t))
      return !1;
    o = !0, u = !1;
  }
  if (p && !u)
    return i || (i = new d2()), o || QU(e) ? YU(e, t, r, n, a, i) : KU(e, t, l, r, n, a, i);
  if (!(r & JU)) {
    var h = u && Jp.call(e, "__wrapped__"), m = f && Jp.call(t, "__wrapped__");
    if (h || m) {
      var v = h ? e.value() : e, g = m ? t.value() : t;
      return i || (i = new d2()), a(v, g, r, n, i);
    }
  }
  return p ? (i || (i = new d2()), XU(e, t, r, n, a, i)) : !1;
}
var rZ = tZ, nZ = rZ, e7 = Nn;
function rg(e, t, r, n, a) {
  return e === t ? !0 : e == null || t == null || !e7(e) && !e7(t) ? e !== e && t !== t : nZ(e, t, r, n, rg, a);
}
var sd = rg, aZ = Wm, iZ = sd, oZ = 1, sZ = 2;
function lZ(e, t, r, n) {
  var a = r.length, i = a, o = !n;
  if (e == null)
    return !i;
  for (e = Object(e); a--; ) {
    var s = r[a];
    if (o && s[2] ? s[1] !== e[s[0]] : !(s[0] in e))
      return !1;
  }
  for (; ++a < i; ) {
    s = r[a];
    var l = s[0], c = e[l], u = s[1];
    if (o && s[2]) {
      if (c === void 0 && !(l in e))
        return !1;
    } else {
      var f = new aZ();
      if (n)
        var p = n(c, u, l, e, t, f);
      if (!(p === void 0 ? iZ(u, c, oZ | sZ, n, f) : p))
        return !1;
    }
  }
  return !0;
}
var cZ = lZ, uZ = ia;
function fZ(e) {
  return e === e && !uZ(e);
}
var ng = fZ, dZ = ng, pZ = qc;
function hZ(e) {
  for (var t = pZ(e), r = t.length; r--; ) {
    var n = t[r], a = e[n];
    t[r] = [n, a, dZ(a)];
  }
  return t;
}
var vZ = hZ;
function mZ(e, t) {
  return function(r) {
    return r == null ? !1 : r[e] === t && (t !== void 0 || e in Object(r));
  };
}
var ag = mZ, gZ = cZ, yZ = vZ, bZ = ag;
function CZ(e) {
  var t = yZ(e);
  return t.length == 1 && t[0][2] ? bZ(t[0][0], t[0][1]) : function(r) {
    return r === e || gZ(r, e, t);
  };
}
var xZ = CZ;
function wZ(e, t) {
  return e != null && t in Object(e);
}
var OZ = wZ, SZ = dm, PZ = ad, EZ = cr, jZ = id, _Z = od, DZ = Hc;
function AZ(e, t, r) {
  t = SZ(t, e);
  for (var n = -1, a = t.length, i = !1; ++n < a; ) {
    var o = DZ(t[n]);
    if (!(i = e != null && r(e, o)))
      break;
    e = e[o];
  }
  return i || ++n != a ? i : (a = e == null ? 0 : e.length, !!a && _Z(a) && jZ(o, a) && (EZ(e) || PZ(e)));
}
var MZ = AZ, TZ = OZ, $Z = MZ;
function NZ(e, t) {
  return e != null && $Z(e, t, TZ);
}
var IZ = NZ, LZ = sd, RZ = pm, kZ = IZ, BZ = Wf, VZ = ng, HZ = ag, FZ = Hc, WZ = 1, zZ = 2;
function UZ(e, t) {
  return BZ(e) && VZ(t) ? HZ(FZ(e), t) : function(r) {
    var n = RZ(r, e);
    return n === void 0 && n === t ? kZ(r, e) : LZ(t, n, WZ | zZ);
  };
}
var ZZ = UZ;
function qZ(e) {
  return e;
}
var so = qZ;
function GZ(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var YZ = GZ, KZ = Kf;
function XZ(e) {
  return function(t) {
    return KZ(t, e);
  };
}
var QZ = XZ, JZ = YZ, eq = QZ, tq = Wf, rq = Hc;
function nq(e) {
  return tq(e) ? JZ(rq(e)) : eq(e);
}
var aq = nq, iq = xZ, oq = ZZ, sq = so, lq = cr, cq = aq;
function uq(e) {
  return typeof e == "function" ? e : e == null ? sq : typeof e == "object" ? lq(e) ? oq(e[0], e[1]) : iq(e) : cq(e);
}
var pn = uq;
function fq(e, t, r, n) {
  for (var a = e.length, i = r + (n ? 1 : -1); n ? i-- : ++i < a; )
    if (t(e[i], i, e))
      return i;
  return -1;
}
var ig = fq;
function dq(e) {
  return e !== e;
}
var pq = dq;
function hq(e, t, r) {
  for (var n = r - 1, a = e.length; ++n < a; )
    if (e[n] === t)
      return n;
  return -1;
}
var vq = hq, mq = ig, gq = pq, yq = vq;
function bq(e, t, r) {
  return t === t ? yq(e, t, r) : mq(e, gq, r);
}
var Cq = bq, xq = Cq;
function wq(e, t) {
  var r = e == null ? 0 : e.length;
  return !!r && xq(e, t, 0) > -1;
}
var Oq = wq;
function Sq(e, t, r) {
  for (var n = -1, a = e == null ? 0 : e.length; ++n < a; )
    if (r(t, e[n]))
      return !0;
  return !1;
}
var Pq = Sq;
function Eq() {
}
var jq = Eq, p2 = eg, _q = jq, Dq = nd, Aq = 1 / 0, Mq = p2 && 1 / Dq(new p2([, -0]))[1] == Aq ? function(e) {
  return new p2(e);
} : _q, Tq = Mq, $q = zm, Nq = Oq, Iq = Pq, Lq = Zm, Rq = Tq, kq = nd, Bq = 200;
function Vq(e, t, r) {
  var n = -1, a = Nq, i = e.length, o = !0, s = [], l = s;
  if (r)
    o = !1, a = Iq;
  else if (i >= Bq) {
    var c = t ? null : Rq(e);
    if (c)
      return kq(c);
    o = !1, a = Lq, l = new $q();
  } else
    l = t ? [] : s;
  e:
    for (; ++n < i; ) {
      var u = e[n], f = t ? t(u) : u;
      if (u = r || u !== 0 ? u : 0, o && f === f) {
        for (var p = l.length; p--; )
          if (l[p] === f)
            continue e;
        t && l.push(f), s.push(u);
      } else
        a(l, f, r) || (l !== s && l.push(f), s.push(u));
    }
  return s;
}
var Hq = Vq, Fq = pn, Wq = Hq;
function zq(e, t) {
  return e && e.length ? Wq(e, Fq(t)) : [];
}
var Uq = zq;
const t7 = /* @__PURE__ */ Je(Uq);
function og(e, t, r) {
  return t === !0 ? t7(e, r) : xe(t) ? t7(e, t) : e;
}
function wi(e) {
  "@babel/helpers - typeof";
  return wi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, wi(e);
}
var Zq = ["ref"];
function r7(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function yn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? r7(Object(r), !0).forEach(function(n) {
      Gc(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : r7(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function qq(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function n7(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, lg(n.key), n);
  }
}
function Gq(e, t, r) {
  return t && n7(e.prototype, t), r && n7(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Yq(e, t, r) {
  return t = S1(t), Kq(e, sg() ? Reflect.construct(t, r || [], S1(e).constructor) : t.apply(e, r));
}
function Kq(e, t) {
  if (t && (wi(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Xq(e);
}
function Xq(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function sg() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (sg = function() {
    return !!e;
  })();
}
function S1(e) {
  return S1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, S1(e);
}
function Qq(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && M3(e, t);
}
function M3(e, t) {
  return M3 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, M3(e, t);
}
function Gc(e, t, r) {
  return t = lg(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function lg(e) {
  var t = Jq(e, "string");
  return wi(t) == "symbol" ? t : t + "";
}
function Jq(e, t) {
  if (wi(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (wi(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function eG(e, t) {
  if (e == null)
    return {};
  var r = tG(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function tG(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function rG(e) {
  return e.value;
}
function nG(e, t) {
  if (/* @__PURE__ */ P.isValidElement(e))
    return /* @__PURE__ */ P.cloneElement(e, t);
  if (typeof e == "function")
    return /* @__PURE__ */ P.createElement(e, t);
  t.ref;
  var r = eG(t, Zq);
  return /* @__PURE__ */ P.createElement(rd, r);
}
var a7 = 1, En = /* @__PURE__ */ function(e) {
  function t() {
    var r;
    qq(this, t);
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    return r = Yq(this, t, [].concat(a)), Gc(r, "lastBoundingBox", {
      width: -1,
      height: -1
    }), r;
  }
  return Qq(t, e), Gq(t, [{
    key: "componentDidMount",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "getBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var n = this.wrapperNode.getBoundingClientRect();
        return n.height = this.wrapperNode.offsetHeight, n.width = this.wrapperNode.offsetWidth, n;
      }
      return null;
    }
  }, {
    key: "updateBBox",
    value: function() {
      var n = this.props.onBBoxUpdate, a = this.getBBox();
      a ? (Math.abs(a.width - this.lastBoundingBox.width) > a7 || Math.abs(a.height - this.lastBoundingBox.height) > a7) && (this.lastBoundingBox.width = a.width, this.lastBoundingBox.height = a.height, n && n(a)) : (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) && (this.lastBoundingBox.width = -1, this.lastBoundingBox.height = -1, n && n(null));
    }
  }, {
    key: "getBBoxSnapshot",
    value: function() {
      return this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0 ? yn({}, this.lastBoundingBox) : {
        width: 0,
        height: 0
      };
    }
  }, {
    key: "getDefaultPosition",
    value: function(n) {
      var a = this.props, i = a.layout, o = a.align, s = a.verticalAlign, l = a.margin, c = a.chartWidth, u = a.chartHeight, f, p;
      if (!n || (n.left === void 0 || n.left === null) && (n.right === void 0 || n.right === null))
        if (o === "center" && i === "vertical") {
          var h = this.getBBoxSnapshot();
          f = {
            left: ((c || 0) - h.width) / 2
          };
        } else
          f = o === "right" ? {
            right: l && l.right || 0
          } : {
            left: l && l.left || 0
          };
      if (!n || (n.top === void 0 || n.top === null) && (n.bottom === void 0 || n.bottom === null))
        if (s === "middle") {
          var m = this.getBBoxSnapshot();
          p = {
            top: ((u || 0) - m.height) / 2
          };
        } else
          p = s === "bottom" ? {
            bottom: l && l.bottom || 0
          } : {
            top: l && l.top || 0
          };
      return yn(yn({}, f), p);
    }
  }, {
    key: "render",
    value: function() {
      var n = this, a = this.props, i = a.content, o = a.width, s = a.height, l = a.wrapperStyle, c = a.payloadUniqBy, u = a.payload, f = yn(yn({
        position: "absolute",
        width: o || "auto",
        height: s || "auto"
      }, this.getDefaultPosition(l)), l);
      return /* @__PURE__ */ P.createElement("div", {
        className: "recharts-legend-wrapper",
        style: f,
        ref: function(h) {
          n.wrapperNode = h;
        }
      }, nG(i, yn(yn({}, this.props), {}, {
        payload: og(u, c, rG)
      })));
    }
  }], [{
    key: "getWithHeight",
    value: function(n, a) {
      var i = yn(yn({}, this.defaultProps), n.props), o = i.layout;
      return o === "vertical" && oe(n.props.height) ? {
        height: n.props.height
      } : o === "horizontal" ? {
        width: n.props.width || a
      } : null;
    }
  }]);
}(Cr);
Gc(En, "displayName", "Legend");
Gc(En, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "bottom"
});
var i7 = il, aG = ad, iG = cr, o7 = i7 ? i7.isConcatSpreadable : void 0;
function oG(e) {
  return iG(e) || aG(e) || !!(o7 && e && e[o7]);
}
var sG = oG, lG = Gm, cG = sG;
function cg(e, t, r, n, a) {
  var i = -1, o = e.length;
  for (r || (r = cG), a || (a = []); ++i < o; ) {
    var s = e[i];
    t > 0 && r(s) ? t > 1 ? cg(s, t - 1, r, n, a) : lG(a, s) : n || (a[a.length] = s);
  }
  return a;
}
var ug = cg;
function uG(e) {
  return function(t, r, n) {
    for (var a = -1, i = Object(t), o = n(t), s = o.length; s--; ) {
      var l = o[e ? s : ++a];
      if (r(i[l], l, i) === !1)
        break;
    }
    return t;
  };
}
var fG = uG, dG = fG, pG = dG(), hG = pG, vG = hG, mG = qc;
function gG(e, t) {
  return e && vG(e, t, mG);
}
var fg = gG, yG = sl;
function bG(e, t) {
  return function(r, n) {
    if (r == null)
      return r;
    if (!yG(r))
      return e(r, n);
    for (var a = r.length, i = t ? a : -1, o = Object(r); (t ? i-- : ++i < a) && n(o[i], i, o) !== !1; )
      ;
    return r;
  };
}
var CG = bG, xG = fg, wG = CG, OG = wG(xG), ld = OG, SG = ld, PG = sl;
function EG(e, t) {
  var r = -1, n = PG(e) ? Array(e.length) : [];
  return SG(e, function(a, i, o) {
    n[++r] = t(a, i, o);
  }), n;
}
var dg = EG;
function jG(e, t) {
  var r = e.length;
  for (e.sort(t); r--; )
    e[r] = e[r].value;
  return e;
}
var _G = jG, s7 = Ji;
function DG(e, t) {
  if (e !== t) {
    var r = e !== void 0, n = e === null, a = e === e, i = s7(e), o = t !== void 0, s = t === null, l = t === t, c = s7(t);
    if (!s && !c && !i && e > t || i && o && l && !s && !c || n && o && l || !r && l || !a)
      return 1;
    if (!n && !i && !c && e < t || c && r && a && !n && !i || s && r && a || !o && a || !l)
      return -1;
  }
  return 0;
}
var AG = DG, MG = AG;
function TG(e, t, r) {
  for (var n = -1, a = e.criteria, i = t.criteria, o = a.length, s = r.length; ++n < o; ) {
    var l = MG(a[n], i[n]);
    if (l) {
      if (n >= s)
        return l;
      var c = r[n];
      return l * (c == "desc" ? -1 : 1);
    }
  }
  return e.index - t.index;
}
var $G = TG, h2 = Yf, NG = Kf, IG = pn, LG = dg, RG = _G, kG = Xm, BG = $G, VG = so, HG = cr;
function FG(e, t, r) {
  t.length ? t = h2(t, function(i) {
    return HG(i) ? function(o) {
      return NG(o, i.length === 1 ? i[0] : i);
    } : i;
  }) : t = [VG];
  var n = -1;
  t = h2(t, kG(IG));
  var a = LG(e, function(i, o, s) {
    var l = h2(t, function(c) {
      return c(i);
    });
    return { criteria: l, index: ++n, value: i };
  });
  return RG(a, function(i, o) {
    return BG(i, o, r);
  });
}
var WG = FG;
function zG(e, t, r) {
  switch (r.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, r[0]);
    case 2:
      return e.call(t, r[0], r[1]);
    case 3:
      return e.call(t, r[0], r[1], r[2]);
  }
  return e.apply(t, r);
}
var UG = zG, ZG = UG, l7 = Math.max;
function qG(e, t, r) {
  return t = l7(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var n = arguments, a = -1, i = l7(n.length - t, 0), o = Array(i); ++a < i; )
      o[a] = n[t + a];
    a = -1;
    for (var s = Array(t + 1); ++a < t; )
      s[a] = n[a];
    return s[t] = r(o), ZG(e, this, s);
  };
}
var GG = qG;
function YG(e) {
  return function() {
    return e;
  };
}
var KG = YG, XG = Fa, QG = function() {
  try {
    var e = XG(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), pg = QG, JG = KG, c7 = pg, eY = so, tY = c7 ? function(e, t) {
  return c7(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: JG(t),
    writable: !0
  });
} : eY, rY = tY, nY = 800, aY = 16, iY = Date.now;
function oY(e) {
  var t = 0, r = 0;
  return function() {
    var n = iY(), a = aY - (n - r);
    if (r = n, a > 0) {
      if (++t >= nY)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var sY = oY, lY = rY, cY = sY, uY = cY(lY), fY = uY, dY = so, pY = GG, hY = fY;
function vY(e, t) {
  return hY(pY(e, t, dY), e + "");
}
var mY = vY, gY = Uf, yY = sl, bY = id, CY = ia;
function xY(e, t, r) {
  if (!CY(r))
    return !1;
  var n = typeof t;
  return (n == "number" ? yY(r) && bY(t, r.length) : n == "string" && t in r) ? gY(r[t], e) : !1;
}
var Yc = xY, wY = ug, OY = WG, SY = mY, u7 = Yc, PY = SY(function(e, t) {
  if (e == null)
    return [];
  var r = t.length;
  return r > 1 && u7(e, t[0], t[1]) ? t = [] : r > 2 && u7(t[0], t[1], t[2]) && (t = [t[0]]), OY(e, wY(t, 1), []);
}), EY = PY;
const cd = /* @__PURE__ */ Je(EY);
function vs(e) {
  "@babel/helpers - typeof";
  return vs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, vs(e);
}
function T3() {
  return T3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, T3.apply(this, arguments);
}
function jY(e, t) {
  return MY(e) || AY(e, t) || DY(e, t) || _Y();
}
function _Y() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function DY(e, t) {
  if (e) {
    if (typeof e == "string")
      return f7(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return f7(e, t);
  }
}
function f7(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function AY(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], l = !0, c = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        l = !1;
      } else
        for (; !(l = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); l = !0)
          ;
    } catch (u) {
      c = !0, a = u;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (c)
          throw a;
      }
    }
    return s;
  }
}
function MY(e) {
  if (Array.isArray(e))
    return e;
}
function d7(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function v2(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? d7(Object(r), !0).forEach(function(n) {
      TY(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : d7(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function TY(e, t, r) {
  return t = $Y(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function $Y(e) {
  var t = NY(e, "string");
  return vs(t) == "symbol" ? t : t + "";
}
function NY(e, t) {
  if (vs(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (vs(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function IY(e) {
  return Array.isArray(e) && Lt(e[0]) && Lt(e[1]) ? e.join(" ~ ") : e;
}
var LY = function(t) {
  var r = t.separator, n = r === void 0 ? " : " : r, a = t.contentStyle, i = a === void 0 ? {} : a, o = t.itemStyle, s = o === void 0 ? {} : o, l = t.labelStyle, c = l === void 0 ? {} : l, u = t.payload, f = t.formatter, p = t.itemSorter, h = t.wrapperClassName, m = t.labelClassName, v = t.label, g = t.labelFormatter, y = t.accessibilityLayer, b = y === void 0 ? !1 : y, w = function() {
    if (u && u.length) {
      var W = {
        padding: 0,
        margin: 0
      }, L = (p ? cd(u, p) : u).map(function(G, Q) {
        if (G.type === "none")
          return null;
        var X = v2({
          display: "block",
          paddingTop: 4,
          paddingBottom: 4,
          color: G.color || "#000"
        }, s), K = G.formatter || f || IY, te = G.value, _ = G.name, j = te, T = _;
        if (K && j != null && T != null) {
          var A = K(te, _, G, Q, u);
          if (Array.isArray(A)) {
            var O = jY(A, 2);
            j = O[0], T = O[1];
          } else
            j = A;
        }
        return (
          // eslint-disable-next-line react/no-array-index-key
          /* @__PURE__ */ P.createElement("li", {
            className: "recharts-tooltip-item",
            key: "tooltip-item-".concat(Q),
            style: X
          }, Lt(T) ? /* @__PURE__ */ P.createElement("span", {
            className: "recharts-tooltip-item-name"
          }, T) : null, Lt(T) ? /* @__PURE__ */ P.createElement("span", {
            className: "recharts-tooltip-item-separator"
          }, n) : null, /* @__PURE__ */ P.createElement("span", {
            className: "recharts-tooltip-item-value"
          }, j), /* @__PURE__ */ P.createElement("span", {
            className: "recharts-tooltip-item-unit"
          }, G.unit || ""))
        );
      });
      return /* @__PURE__ */ P.createElement("ul", {
        className: "recharts-tooltip-item-list",
        style: W
      }, L);
    }
    return null;
  }, x = v2({
    margin: 0,
    padding: 10,
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    whiteSpace: "nowrap"
  }, i), C = v2({
    margin: 0
  }, c), S = !Ce(v), E = S ? v : "", D = _e("recharts-default-tooltip", h), I = _e("recharts-tooltip-label", m);
  S && g && u !== void 0 && u !== null && (E = g(v, u));
  var k = b ? {
    role: "status",
    "aria-live": "assertive"
  } : {};
  return /* @__PURE__ */ P.createElement("div", T3({
    className: D,
    style: x
  }, k), /* @__PURE__ */ P.createElement("p", {
    className: I,
    style: C
  }, /* @__PURE__ */ P.isValidElement(E) ? E : "".concat(E)), w());
};
function ms(e) {
  "@babel/helpers - typeof";
  return ms = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ms(e);
}
function jl(e, t, r) {
  return t = RY(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function RY(e) {
  var t = kY(e, "string");
  return ms(t) == "symbol" ? t : t + "";
}
function kY(e, t) {
  if (ms(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (ms(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Oo = "recharts-tooltip-wrapper", BY = {
  visibility: "hidden"
};
function VY(e) {
  var t = e.coordinate, r = e.translateX, n = e.translateY;
  return _e(Oo, jl(jl(jl(jl({}, "".concat(Oo, "-right"), oe(r) && t && oe(t.x) && r >= t.x), "".concat(Oo, "-left"), oe(r) && t && oe(t.x) && r < t.x), "".concat(Oo, "-bottom"), oe(n) && t && oe(t.y) && n >= t.y), "".concat(Oo, "-top"), oe(n) && t && oe(t.y) && n < t.y));
}
function p7(e) {
  var t = e.allowEscapeViewBox, r = e.coordinate, n = e.key, a = e.offsetTopLeft, i = e.position, o = e.reverseDirection, s = e.tooltipDimension, l = e.viewBox, c = e.viewBoxDimension;
  if (i && oe(i[n]))
    return i[n];
  var u = r[n] - s - a, f = r[n] + a;
  if (t[n])
    return o[n] ? u : f;
  if (o[n]) {
    var p = u, h = l[n];
    return p < h ? Math.max(f, l[n]) : Math.max(u, l[n]);
  }
  var m = f + s, v = l[n] + c;
  return m > v ? Math.max(u, l[n]) : Math.max(f, l[n]);
}
function HY(e) {
  var t = e.translateX, r = e.translateY, n = e.useTranslate3d;
  return {
    transform: n ? "translate3d(".concat(t, "px, ").concat(r, "px, 0)") : "translate(".concat(t, "px, ").concat(r, "px)")
  };
}
function FY(e) {
  var t = e.allowEscapeViewBox, r = e.coordinate, n = e.offsetTopLeft, a = e.position, i = e.reverseDirection, o = e.tooltipBox, s = e.useTranslate3d, l = e.viewBox, c, u, f;
  return o.height > 0 && o.width > 0 && r ? (u = p7({
    allowEscapeViewBox: t,
    coordinate: r,
    key: "x",
    offsetTopLeft: n,
    position: a,
    reverseDirection: i,
    tooltipDimension: o.width,
    viewBox: l,
    viewBoxDimension: l.width
  }), f = p7({
    allowEscapeViewBox: t,
    coordinate: r,
    key: "y",
    offsetTopLeft: n,
    position: a,
    reverseDirection: i,
    tooltipDimension: o.height,
    viewBox: l,
    viewBoxDimension: l.height
  }), c = HY({
    translateX: u,
    translateY: f,
    useTranslate3d: s
  })) : c = BY, {
    cssProperties: c,
    cssClasses: VY({
      translateX: u,
      translateY: f,
      coordinate: r
    })
  };
}
function Oi(e) {
  "@babel/helpers - typeof";
  return Oi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Oi(e);
}
function h7(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function v7(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? h7(Object(r), !0).forEach(function(n) {
      N3(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : h7(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function WY(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function m7(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, vg(n.key), n);
  }
}
function zY(e, t, r) {
  return t && m7(e.prototype, t), r && m7(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function UY(e, t, r) {
  return t = P1(t), ZY(e, hg() ? Reflect.construct(t, r || [], P1(e).constructor) : t.apply(e, r));
}
function ZY(e, t) {
  if (t && (Oi(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return qY(e);
}
function qY(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function hg() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (hg = function() {
    return !!e;
  })();
}
function P1(e) {
  return P1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, P1(e);
}
function GY(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && $3(e, t);
}
function $3(e, t) {
  return $3 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, $3(e, t);
}
function N3(e, t, r) {
  return t = vg(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function vg(e) {
  var t = YY(e, "string");
  return Oi(t) == "symbol" ? t : t + "";
}
function YY(e, t) {
  if (Oi(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Oi(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var g7 = 1, KY = /* @__PURE__ */ function(e) {
  function t() {
    var r;
    WY(this, t);
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    return r = UY(this, t, [].concat(a)), N3(r, "state", {
      dismissed: !1,
      dismissedAtCoordinate: {
        x: 0,
        y: 0
      },
      lastBoundingBox: {
        width: -1,
        height: -1
      }
    }), N3(r, "handleKeyDown", function(o) {
      if (o.key === "Escape") {
        var s, l, c, u;
        r.setState({
          dismissed: !0,
          dismissedAtCoordinate: {
            x: (s = (l = r.props.coordinate) === null || l === void 0 ? void 0 : l.x) !== null && s !== void 0 ? s : 0,
            y: (c = (u = r.props.coordinate) === null || u === void 0 ? void 0 : u.y) !== null && c !== void 0 ? c : 0
          }
        });
      }
    }), r;
  }
  return GY(t, e), zY(t, [{
    key: "updateBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var n = this.wrapperNode.getBoundingClientRect();
        (Math.abs(n.width - this.state.lastBoundingBox.width) > g7 || Math.abs(n.height - this.state.lastBoundingBox.height) > g7) && this.setState({
          lastBoundingBox: {
            width: n.width,
            height: n.height
          }
        });
      } else
        (this.state.lastBoundingBox.width !== -1 || this.state.lastBoundingBox.height !== -1) && this.setState({
          lastBoundingBox: {
            width: -1,
            height: -1
          }
        });
    }
  }, {
    key: "componentDidMount",
    value: function() {
      document.addEventListener("keydown", this.handleKeyDown), this.updateBBox();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      document.removeEventListener("keydown", this.handleKeyDown);
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      var n, a;
      this.props.active && this.updateBBox(), this.state.dismissed && (((n = this.props.coordinate) === null || n === void 0 ? void 0 : n.x) !== this.state.dismissedAtCoordinate.x || ((a = this.props.coordinate) === null || a === void 0 ? void 0 : a.y) !== this.state.dismissedAtCoordinate.y) && (this.state.dismissed = !1);
    }
  }, {
    key: "render",
    value: function() {
      var n = this, a = this.props, i = a.active, o = a.allowEscapeViewBox, s = a.animationDuration, l = a.animationEasing, c = a.children, u = a.coordinate, f = a.hasPayload, p = a.isAnimationActive, h = a.offset, m = a.position, v = a.reverseDirection, g = a.useTranslate3d, y = a.viewBox, b = a.wrapperStyle, w = FY({
        allowEscapeViewBox: o,
        coordinate: u,
        offsetTopLeft: h,
        position: m,
        reverseDirection: v,
        tooltipBox: this.state.lastBoundingBox,
        useTranslate3d: g,
        viewBox: y
      }), x = w.cssClasses, C = w.cssProperties, S = v7(v7({
        transition: p && i ? "transform ".concat(s, "ms ").concat(l) : void 0
      }, C), {}, {
        pointerEvents: "none",
        visibility: !this.state.dismissed && i && f ? "visible" : "hidden",
        position: "absolute",
        top: 0,
        left: 0
      }, b);
      return (
        // This element allow listening to the `Escape` key.
        // See https://github.com/recharts/recharts/pull/2925
        /* @__PURE__ */ P.createElement("div", {
          tabIndex: -1,
          className: x,
          style: S,
          ref: function(D) {
            n.wrapperNode = D;
          }
        }, c)
      );
    }
  }]);
}(Cr), XY = function() {
  return !(typeof window < "u" && window.document && window.document.createElement && window.setTimeout);
}, Tr = {
  isSsr: XY(),
  get: function(t) {
    return Tr[t];
  },
  set: function(t, r) {
    if (typeof t == "string")
      Tr[t] = r;
    else {
      var n = Object.keys(t);
      n && n.length && n.forEach(function(a) {
        Tr[a] = t[a];
      });
    }
  }
};
function Si(e) {
  "@babel/helpers - typeof";
  return Si = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Si(e);
}
function y7(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function b7(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? y7(Object(r), !0).forEach(function(n) {
      ud(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : y7(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function QY(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function C7(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, gg(n.key), n);
  }
}
function JY(e, t, r) {
  return t && C7(e.prototype, t), r && C7(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function eK(e, t, r) {
  return t = E1(t), tK(e, mg() ? Reflect.construct(t, r || [], E1(e).constructor) : t.apply(e, r));
}
function tK(e, t) {
  if (t && (Si(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return rK(e);
}
function rK(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function mg() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (mg = function() {
    return !!e;
  })();
}
function E1(e) {
  return E1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, E1(e);
}
function nK(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && I3(e, t);
}
function I3(e, t) {
  return I3 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, I3(e, t);
}
function ud(e, t, r) {
  return t = gg(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function gg(e) {
  var t = aK(e, "string");
  return Si(t) == "symbol" ? t : t + "";
}
function aK(e, t) {
  if (Si(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Si(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function iK(e) {
  return e.dataKey;
}
function oK(e, t) {
  return /* @__PURE__ */ P.isValidElement(e) ? /* @__PURE__ */ P.cloneElement(e, t) : typeof e == "function" ? /* @__PURE__ */ P.createElement(e, t) : /* @__PURE__ */ P.createElement(LY, t);
}
var or = /* @__PURE__ */ function(e) {
  function t() {
    return QY(this, t), eK(this, t, arguments);
  }
  return nK(t, e), JY(t, [{
    key: "render",
    value: function() {
      var n = this, a = this.props, i = a.active, o = a.allowEscapeViewBox, s = a.animationDuration, l = a.animationEasing, c = a.content, u = a.coordinate, f = a.filterNull, p = a.isAnimationActive, h = a.offset, m = a.payload, v = a.payloadUniqBy, g = a.position, y = a.reverseDirection, b = a.useTranslate3d, w = a.viewBox, x = a.wrapperStyle, C = m ?? [];
      f && C.length && (C = og(m.filter(function(E) {
        return E.value != null && (E.hide !== !0 || n.props.includeHidden);
      }), v, iK));
      var S = C.length > 0;
      return /* @__PURE__ */ P.createElement(KY, {
        allowEscapeViewBox: o,
        animationDuration: s,
        animationEasing: l,
        isAnimationActive: p,
        active: i,
        coordinate: u,
        hasPayload: S,
        offset: h,
        position: g,
        reverseDirection: y,
        useTranslate3d: b,
        viewBox: w,
        wrapperStyle: x
      }, oK(c, b7(b7({}, this.props), {}, {
        payload: C
      })));
    }
  }]);
}(Cr);
ud(or, "displayName", "Tooltip");
ud(or, "defaultProps", {
  accessibilityLayer: !1,
  allowEscapeViewBox: {
    x: !1,
    y: !1
  },
  animationDuration: 400,
  animationEasing: "ease",
  contentStyle: {},
  coordinate: {
    x: 0,
    y: 0
  },
  cursor: !0,
  cursorStyle: {},
  filterNull: !0,
  isAnimationActive: !Tr.isSsr,
  itemStyle: {},
  labelStyle: {},
  offset: 10,
  reverseDirection: {
    x: !1,
    y: !1
  },
  separator: " : ",
  trigger: "hover",
  useTranslate3d: !1,
  viewBox: {
    x: 0,
    y: 0,
    height: 0,
    width: 0
  },
  wrapperStyle: {}
});
var sK = dn, lK = function() {
  return sK.Date.now();
}, cK = lK, uK = /\s/;
function fK(e) {
  for (var t = e.length; t-- && uK.test(e.charAt(t)); )
    ;
  return t;
}
var dK = fK, pK = dK, hK = /^\s+/;
function vK(e) {
  return e && e.slice(0, pK(e) + 1).replace(hK, "");
}
var mK = vK, gK = mK, x7 = ia, yK = Ji, w7 = 0 / 0, bK = /^[-+]0x[0-9a-f]+$/i, CK = /^0b[01]+$/i, xK = /^0o[0-7]+$/i, wK = parseInt;
function OK(e) {
  if (typeof e == "number")
    return e;
  if (yK(e))
    return w7;
  if (x7(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = x7(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = gK(e);
  var r = CK.test(e);
  return r || xK.test(e) ? wK(e.slice(2), r ? 2 : 8) : bK.test(e) ? w7 : +e;
}
var yg = OK, SK = ia, m2 = cK, O7 = yg, PK = "Expected a function", EK = Math.max, jK = Math.min;
function _K(e, t, r) {
  var n, a, i, o, s, l, c = 0, u = !1, f = !1, p = !0;
  if (typeof e != "function")
    throw new TypeError(PK);
  t = O7(t) || 0, SK(r) && (u = !!r.leading, f = "maxWait" in r, i = f ? EK(O7(r.maxWait) || 0, t) : i, p = "trailing" in r ? !!r.trailing : p);
  function h(S) {
    var E = n, D = a;
    return n = a = void 0, c = S, o = e.apply(D, E), o;
  }
  function m(S) {
    return c = S, s = setTimeout(y, t), u ? h(S) : o;
  }
  function v(S) {
    var E = S - l, D = S - c, I = t - E;
    return f ? jK(I, i - D) : I;
  }
  function g(S) {
    var E = S - l, D = S - c;
    return l === void 0 || E >= t || E < 0 || f && D >= i;
  }
  function y() {
    var S = m2();
    if (g(S))
      return b(S);
    s = setTimeout(y, v(S));
  }
  function b(S) {
    return s = void 0, p && n ? h(S) : (n = a = void 0, o);
  }
  function w() {
    s !== void 0 && clearTimeout(s), c = 0, n = l = a = s = void 0;
  }
  function x() {
    return s === void 0 ? o : b(m2());
  }
  function C() {
    var S = m2(), E = g(S);
    if (n = arguments, a = this, l = S, E) {
      if (s === void 0)
        return m(l);
      if (f)
        return clearTimeout(s), s = setTimeout(y, t), h(l);
    }
    return s === void 0 && (s = setTimeout(y, t)), o;
  }
  return C.cancel = w, C.flush = x, C;
}
var DK = _K, AK = DK, MK = ia, TK = "Expected a function";
function $K(e, t, r) {
  var n = !0, a = !0;
  if (typeof e != "function")
    throw new TypeError(TK);
  return MK(r) && (n = "leading" in r ? !!r.leading : n, a = "trailing" in r ? !!r.trailing : a), AK(e, t, {
    leading: n,
    maxWait: t,
    trailing: a
  });
}
var NK = $K;
const bg = /* @__PURE__ */ Je(NK);
function gs(e) {
  "@babel/helpers - typeof";
  return gs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, gs(e);
}
function S7(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function _l(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? S7(Object(r), !0).forEach(function(n) {
      IK(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : S7(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function IK(e, t, r) {
  return t = LK(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function LK(e) {
  var t = RK(e, "string");
  return gs(t) == "symbol" ? t : t + "";
}
function RK(e, t) {
  if (gs(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (gs(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function kK(e, t) {
  return FK(e) || HK(e, t) || VK(e, t) || BK();
}
function BK() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function VK(e, t) {
  if (e) {
    if (typeof e == "string")
      return P7(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return P7(e, t);
  }
}
function P7(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function HK(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], l = !0, c = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        l = !1;
      } else
        for (; !(l = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); l = !0)
          ;
    } catch (u) {
      c = !0, a = u;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (c)
          throw a;
      }
    }
    return s;
  }
}
function FK(e) {
  if (Array.isArray(e))
    return e;
}
var ll = /* @__PURE__ */ mC(function(e, t) {
  var r = e.aspect, n = e.initialDimension, a = n === void 0 ? {
    width: -1,
    height: -1
  } : n, i = e.width, o = i === void 0 ? "100%" : i, s = e.height, l = s === void 0 ? "100%" : s, c = e.minWidth, u = c === void 0 ? 0 : c, f = e.minHeight, p = e.maxHeight, h = e.children, m = e.debounce, v = m === void 0 ? 0 : m, g = e.id, y = e.className, b = e.onResize, w = e.style, x = w === void 0 ? {} : w, C = ye(null), S = ye();
  S.current = b, gC(t, function() {
    return Object.defineProperty(C.current, "current", {
      get: function() {
        return console.warn("The usage of ref.current.current is deprecated and will no longer be supported."), C.current;
      },
      configurable: !0
    });
  });
  var E = je({
    containerWidth: a.width,
    containerHeight: a.height
  }), D = kK(E, 2), I = D[0], k = D[1], V = yC(function(L, G) {
    k(function(Q) {
      var X = Math.round(L), K = Math.round(G);
      return Q.containerWidth === X && Q.containerHeight === K ? Q : {
        containerWidth: X,
        containerHeight: K
      };
    });
  }, []);
  Me(function() {
    var L = function(_) {
      var j, T = _[0].contentRect, A = T.width, O = T.height;
      V(A, O), (j = S.current) === null || j === void 0 || j.call(S, A, O);
    };
    v > 0 && (L = bg(L, v, {
      trailing: !0,
      leading: !1
    }));
    var G = new ResizeObserver(L), Q = C.current.getBoundingClientRect(), X = Q.width, K = Q.height;
    return V(X, K), G.observe(C.current), function() {
      G.disconnect();
    };
  }, [V, v]);
  var W = jr(function() {
    var L = I.containerWidth, G = I.containerHeight;
    if (L < 0 || G < 0)
      return null;
    Ur(Ea(o) || Ea(l), `The width(%s) and height(%s) are both fixed numbers,
       maybe you don't need to use a ResponsiveContainer.`, o, l), Ur(!r || r > 0, "The aspect(%s) must be greater than zero.", r);
    var Q = Ea(o) ? L : o, X = Ea(l) ? G : l;
    r && r > 0 && (Q ? X = Q / r : X && (Q = X * r), p && X > p && (X = p)), Ur(Q > 0 || X > 0, `The width(%s) and height(%s) of chart should be greater than 0,
       please check the style of container, or the props width(%s) and height(%s),
       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the
       height and width.`, Q, X, o, l, u, f, r);
    var K = !Array.isArray(h) && Pn(h.type).endsWith("Chart");
    return P.Children.map(h, function(te) {
      return hm.isElement(te) ? /* @__PURE__ */ Nt(te, _l({
        width: Q,
        height: X
      }, K ? {
        style: _l({
          height: "100%",
          width: "100%",
          maxHeight: X,
          maxWidth: Q
        }, te.props.style)
      } : {})) : te;
    });
  }, [r, h, l, p, f, u, I, o]);
  return /* @__PURE__ */ P.createElement("div", {
    id: g ? "".concat(g) : void 0,
    className: _e("recharts-responsive-container", y),
    style: _l(_l({}, x), {}, {
      width: o,
      height: l,
      minWidth: u,
      minHeight: f,
      maxHeight: p
    }),
    ref: C
  }, W);
}), Gr = function(t) {
  return null;
};
Gr.displayName = "Cell";
function ys(e) {
  "@babel/helpers - typeof";
  return ys = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ys(e);
}
function E7(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function L3(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? E7(Object(r), !0).forEach(function(n) {
      WK(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : E7(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function WK(e, t, r) {
  return t = zK(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function zK(e) {
  var t = UK(e, "string");
  return ys(t) == "symbol" ? t : t + "";
}
function UK(e, t) {
  if (ys(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (ys(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Ja = {
  widthCache: {},
  cacheCount: 0
}, ZK = 2e3, qK = {
  position: "absolute",
  top: "-20000px",
  left: 0,
  padding: 0,
  margin: 0,
  border: "none",
  whiteSpace: "pre"
}, j7 = "recharts_measurement_span";
function GK(e) {
  var t = L3({}, e);
  return Object.keys(t).forEach(function(r) {
    t[r] || delete t[r];
  }), t;
}
var Go = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (t == null || Tr.isSsr)
    return {
      width: 0,
      height: 0
    };
  var n = GK(r), a = JSON.stringify({
    text: t,
    copyStyle: n
  });
  if (Ja.widthCache[a])
    return Ja.widthCache[a];
  try {
    var i = document.getElementById(j7);
    i || (i = document.createElement("span"), i.setAttribute("id", j7), i.setAttribute("aria-hidden", "true"), document.body.appendChild(i));
    var o = L3(L3({}, qK), n);
    Object.assign(i.style, o), i.textContent = "".concat(t);
    var s = i.getBoundingClientRect(), l = {
      width: s.width,
      height: s.height
    };
    return Ja.widthCache[a] = l, ++Ja.cacheCount > ZK && (Ja.cacheCount = 0, Ja.widthCache = {}), l;
  } catch {
    return {
      width: 0,
      height: 0
    };
  }
}, YK = function(t) {
  return {
    top: t.top + window.scrollY - document.documentElement.clientTop,
    left: t.left + window.scrollX - document.documentElement.clientLeft
  };
};
function bs(e) {
  "@babel/helpers - typeof";
  return bs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, bs(e);
}
function j1(e, t) {
  return JK(e) || QK(e, t) || XK(e, t) || KK();
}
function KK() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function XK(e, t) {
  if (e) {
    if (typeof e == "string")
      return _7(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return _7(e, t);
  }
}
function _7(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function QK(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], l = !0, c = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        l = !1;
      } else
        for (; !(l = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); l = !0)
          ;
    } catch (u) {
      c = !0, a = u;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (c)
          throw a;
      }
    }
    return s;
  }
}
function JK(e) {
  if (Array.isArray(e))
    return e;
}
function eX(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function D7(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, rX(n.key), n);
  }
}
function tX(e, t, r) {
  return t && D7(e.prototype, t), r && D7(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function rX(e) {
  var t = nX(e, "string");
  return bs(t) == "symbol" ? t : t + "";
}
function nX(e, t) {
  if (bs(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (bs(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var A7 = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, M7 = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, aX = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/, iX = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/, Cg = {
  cm: 96 / 2.54,
  mm: 96 / 25.4,
  pt: 96 / 72,
  pc: 96 / 6,
  in: 96,
  Q: 96 / (2.54 * 40),
  px: 1
}, oX = Object.keys(Cg), si = "NaN";
function sX(e, t) {
  return e * Cg[t];
}
var Dl = /* @__PURE__ */ function() {
  function e(t, r) {
    eX(this, e), this.num = t, this.unit = r, this.num = t, this.unit = r, Number.isNaN(t) && (this.unit = ""), r !== "" && !aX.test(r) && (this.num = NaN, this.unit = ""), oX.includes(r) && (this.num = sX(t, r), this.unit = "px");
  }
  return tX(e, [{
    key: "add",
    value: function(r) {
      return this.unit !== r.unit ? new e(NaN, "") : new e(this.num + r.num, this.unit);
    }
  }, {
    key: "subtract",
    value: function(r) {
      return this.unit !== r.unit ? new e(NaN, "") : new e(this.num - r.num, this.unit);
    }
  }, {
    key: "multiply",
    value: function(r) {
      return this.unit !== "" && r.unit !== "" && this.unit !== r.unit ? new e(NaN, "") : new e(this.num * r.num, this.unit || r.unit);
    }
  }, {
    key: "divide",
    value: function(r) {
      return this.unit !== "" && r.unit !== "" && this.unit !== r.unit ? new e(NaN, "") : new e(this.num / r.num, this.unit || r.unit);
    }
  }, {
    key: "toString",
    value: function() {
      return "".concat(this.num).concat(this.unit);
    }
  }, {
    key: "isNaN",
    value: function() {
      return Number.isNaN(this.num);
    }
  }], [{
    key: "parse",
    value: function(r) {
      var n, a = (n = iX.exec(r)) !== null && n !== void 0 ? n : [], i = j1(a, 3), o = i[1], s = i[2];
      return new e(parseFloat(o), s ?? "");
    }
  }]);
}();
function xg(e) {
  if (e.includes(si))
    return si;
  for (var t = e; t.includes("*") || t.includes("/"); ) {
    var r, n = (r = A7.exec(t)) !== null && r !== void 0 ? r : [], a = j1(n, 4), i = a[1], o = a[2], s = a[3], l = Dl.parse(i ?? ""), c = Dl.parse(s ?? ""), u = o === "*" ? l.multiply(c) : l.divide(c);
    if (u.isNaN())
      return si;
    t = t.replace(A7, u.toString());
  }
  for (; t.includes("+") || /.-\d+(?:\.\d+)?/.test(t); ) {
    var f, p = (f = M7.exec(t)) !== null && f !== void 0 ? f : [], h = j1(p, 4), m = h[1], v = h[2], g = h[3], y = Dl.parse(m ?? ""), b = Dl.parse(g ?? ""), w = v === "+" ? y.add(b) : y.subtract(b);
    if (w.isNaN())
      return si;
    t = t.replace(M7, w.toString());
  }
  return t;
}
var T7 = /\(([^()]*)\)/;
function lX(e) {
  for (var t = e; t.includes("("); ) {
    var r = T7.exec(t), n = j1(r, 2), a = n[1];
    t = t.replace(T7, xg(a));
  }
  return t;
}
function cX(e) {
  var t = e.replace(/\s+/g, "");
  return t = lX(t), t = xg(t), t;
}
function uX(e) {
  try {
    return cX(e);
  } catch {
    return si;
  }
}
function g2(e) {
  var t = uX(e.slice(5, -1));
  return t === si ? "" : t;
}
var fX = ["x", "y", "lineHeight", "capHeight", "scaleToFit", "textAnchor", "verticalAnchor", "fill"], dX = ["dx", "dy", "angle", "className", "breakAll"];
function R3() {
  return R3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, R3.apply(this, arguments);
}
function $7(e, t) {
  if (e == null)
    return {};
  var r = pX(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function pX(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function N7(e, t) {
  return gX(e) || mX(e, t) || vX(e, t) || hX();
}
function hX() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function vX(e, t) {
  if (e) {
    if (typeof e == "string")
      return I7(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return I7(e, t);
  }
}
function I7(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function mX(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], l = !0, c = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        l = !1;
      } else
        for (; !(l = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); l = !0)
          ;
    } catch (u) {
      c = !0, a = u;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (c)
          throw a;
      }
    }
    return s;
  }
}
function gX(e) {
  if (Array.isArray(e))
    return e;
}
var wg = /[ \f\n\r\t\v\u2028\u2029]+/, Og = function(t) {
  var r = t.children, n = t.breakAll, a = t.style;
  try {
    var i = [];
    Ce(r) || (n ? i = r.toString().split("") : i = r.toString().split(wg));
    var o = i.map(function(l) {
      return {
        word: l,
        width: Go(l, a).width
      };
    }), s = n ? 0 : Go(" ", a).width;
    return {
      wordsWithComputedWidth: o,
      spaceWidth: s
    };
  } catch {
    return null;
  }
}, yX = function(t, r, n, a, i) {
  var o = t.maxLines, s = t.children, l = t.style, c = t.breakAll, u = oe(o), f = s, p = function() {
    var Q = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return Q.reduce(function(X, K) {
      var te = K.word, _ = K.width, j = X[X.length - 1];
      if (j && (a == null || i || j.width + _ + n < Number(a)))
        j.words.push(te), j.width += _ + n;
      else {
        var T = {
          words: [te],
          width: _
        };
        X.push(T);
      }
      return X;
    }, []);
  }, h = p(r), m = function(Q) {
    return Q.reduce(function(X, K) {
      return X.width > K.width ? X : K;
    });
  };
  if (!u)
    return h;
  for (var v = "…", g = function(Q) {
    var X = f.slice(0, Q), K = Og({
      breakAll: c,
      style: l,
      children: X + v
    }).wordsWithComputedWidth, te = p(K), _ = te.length > o || m(te).width > Number(a);
    return [_, te];
  }, y = 0, b = f.length - 1, w = 0, x; y <= b && w <= f.length - 1; ) {
    var C = Math.floor((y + b) / 2), S = C - 1, E = g(S), D = N7(E, 2), I = D[0], k = D[1], V = g(C), W = N7(V, 1), L = W[0];
    if (!I && !L && (y = C + 1), I && L && (b = C - 1), !I && L) {
      x = k;
      break;
    }
    w++;
  }
  return x || h;
}, L7 = function(t) {
  var r = Ce(t) ? [] : t.toString().split(wg);
  return [{
    words: r
  }];
}, bX = function(t) {
  var r = t.width, n = t.scaleToFit, a = t.children, i = t.style, o = t.breakAll, s = t.maxLines;
  if ((r || n) && !Tr.isSsr) {
    var l, c, u = Og({
      breakAll: o,
      children: a,
      style: i
    });
    if (u) {
      var f = u.wordsWithComputedWidth, p = u.spaceWidth;
      l = f, c = p;
    } else
      return L7(a);
    return yX({
      breakAll: o,
      children: a,
      maxLines: s,
      style: i
    }, l, c, r, n);
  }
  return L7(a);
}, R7 = "#808080", La = function(t) {
  var r = t.x, n = r === void 0 ? 0 : r, a = t.y, i = a === void 0 ? 0 : a, o = t.lineHeight, s = o === void 0 ? "1em" : o, l = t.capHeight, c = l === void 0 ? "0.71em" : l, u = t.scaleToFit, f = u === void 0 ? !1 : u, p = t.textAnchor, h = p === void 0 ? "start" : p, m = t.verticalAnchor, v = m === void 0 ? "end" : m, g = t.fill, y = g === void 0 ? R7 : g, b = $7(t, fX), w = jr(function() {
    return bX({
      breakAll: b.breakAll,
      children: b.children,
      maxLines: b.maxLines,
      scaleToFit: f,
      style: b.style,
      width: b.width
    });
  }, [b.breakAll, b.children, b.maxLines, f, b.style, b.width]), x = b.dx, C = b.dy, S = b.angle, E = b.className, D = b.breakAll, I = $7(b, dX);
  if (!Lt(n) || !Lt(i))
    return null;
  var k = n + (oe(x) ? x : 0), V = i + (oe(C) ? C : 0), W;
  switch (v) {
    case "start":
      W = g2("calc(".concat(c, ")"));
      break;
    case "middle":
      W = g2("calc(".concat((w.length - 1) / 2, " * -").concat(s, " + (").concat(c, " / 2))"));
      break;
    default:
      W = g2("calc(".concat(w.length - 1, " * -").concat(s, ")"));
      break;
  }
  var L = [];
  if (f) {
    var G = w[0].width, Q = b.width;
    L.push("scale(".concat((oe(Q) ? Q / G : 1) / G, ")"));
  }
  return S && L.push("rotate(".concat(S, ", ").concat(k, ", ").concat(V, ")")), L.length && (I.transform = L.join(" ")), /* @__PURE__ */ P.createElement("text", R3({}, pe(I, !0), {
    x: k,
    y: V,
    className: _e("recharts-text", E),
    textAnchor: h,
    fill: y.includes("url") ? R7 : y
  }), w.map(function(X, K) {
    var te = X.words.join(D ? "" : " ");
    return (
      // duplicate words will cause duplicate keys
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ P.createElement("tspan", {
        x: k,
        dy: K === 0 ? W : s,
        key: "".concat(te, "-").concat(K)
      }, te)
    );
  }));
};
function Zn(e, t) {
  return e == null || t == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function CX(e, t) {
  return e == null || t == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function fd(e) {
  let t, r, n;
  e.length !== 2 ? (t = Zn, r = (s, l) => Zn(e(s), l), n = (s, l) => e(s) - l) : (t = e === Zn || e === CX ? e : xX, r = e, n = e);
  function a(s, l, c = 0, u = s.length) {
    if (c < u) {
      if (t(l, l) !== 0)
        return u;
      do {
        const f = c + u >>> 1;
        r(s[f], l) < 0 ? c = f + 1 : u = f;
      } while (c < u);
    }
    return c;
  }
  function i(s, l, c = 0, u = s.length) {
    if (c < u) {
      if (t(l, l) !== 0)
        return u;
      do {
        const f = c + u >>> 1;
        r(s[f], l) <= 0 ? c = f + 1 : u = f;
      } while (c < u);
    }
    return c;
  }
  function o(s, l, c = 0, u = s.length) {
    const f = a(s, l, c, u - 1);
    return f > c && n(s[f - 1], l) > -n(s[f], l) ? f - 1 : f;
  }
  return { left: a, center: o, right: i };
}
function xX() {
  return 0;
}
function Sg(e) {
  return e === null ? NaN : +e;
}
function* wX(e, t) {
  if (t === void 0)
    for (let r of e)
      r != null && (r = +r) >= r && (yield r);
  else {
    let r = -1;
    for (let n of e)
      (n = t(n, ++r, e)) != null && (n = +n) >= n && (yield n);
  }
}
const OX = fd(Zn), SX = OX.right;
fd(Sg).center;
const cl = SX;
class k7 extends Map {
  constructor(t, r = jX) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: r } }), t != null)
      for (const [n, a] of t)
        this.set(n, a);
  }
  get(t) {
    return super.get(B7(this, t));
  }
  has(t) {
    return super.has(B7(this, t));
  }
  set(t, r) {
    return super.set(PX(this, t), r);
  }
  delete(t) {
    return super.delete(EX(this, t));
  }
}
function B7({ _intern: e, _key: t }, r) {
  const n = t(r);
  return e.has(n) ? e.get(n) : r;
}
function PX({ _intern: e, _key: t }, r) {
  const n = t(r);
  return e.has(n) ? e.get(n) : (e.set(n, r), r);
}
function EX({ _intern: e, _key: t }, r) {
  const n = t(r);
  return e.has(n) && (r = e.get(n), e.delete(n)), r;
}
function jX(e) {
  return e !== null && typeof e == "object" ? e.valueOf() : e;
}
function _X(e = Zn) {
  if (e === Zn)
    return Pg;
  if (typeof e != "function")
    throw new TypeError("compare is not a function");
  return (t, r) => {
    const n = e(t, r);
    return n || n === 0 ? n : (e(r, r) === 0) - (e(t, t) === 0);
  };
}
function Pg(e, t) {
  return (e == null || !(e >= e)) - (t == null || !(t >= t)) || (e < t ? -1 : e > t ? 1 : 0);
}
const DX = Math.sqrt(50), AX = Math.sqrt(10), MX = Math.sqrt(2);
function _1(e, t, r) {
  const n = (t - e) / Math.max(0, r), a = Math.floor(Math.log10(n)), i = n / Math.pow(10, a), o = i >= DX ? 10 : i >= AX ? 5 : i >= MX ? 2 : 1;
  let s, l, c;
  return a < 0 ? (c = Math.pow(10, -a) / o, s = Math.round(e * c), l = Math.round(t * c), s / c < e && ++s, l / c > t && --l, c = -c) : (c = Math.pow(10, a) * o, s = Math.round(e / c), l = Math.round(t / c), s * c < e && ++s, l * c > t && --l), l < s && 0.5 <= r && r < 2 ? _1(e, t, r * 2) : [s, l, c];
}
function k3(e, t, r) {
  if (t = +t, e = +e, r = +r, !(r > 0))
    return [];
  if (e === t)
    return [e];
  const n = t < e, [a, i, o] = n ? _1(t, e, r) : _1(e, t, r);
  if (!(i >= a))
    return [];
  const s = i - a + 1, l = new Array(s);
  if (n)
    if (o < 0)
      for (let c = 0; c < s; ++c)
        l[c] = (i - c) / -o;
    else
      for (let c = 0; c < s; ++c)
        l[c] = (i - c) * o;
  else if (o < 0)
    for (let c = 0; c < s; ++c)
      l[c] = (a + c) / -o;
  else
    for (let c = 0; c < s; ++c)
      l[c] = (a + c) * o;
  return l;
}
function B3(e, t, r) {
  return t = +t, e = +e, r = +r, _1(e, t, r)[2];
}
function V3(e, t, r) {
  t = +t, e = +e, r = +r;
  const n = t < e, a = n ? B3(t, e, r) : B3(e, t, r);
  return (n ? -1 : 1) * (a < 0 ? 1 / -a : a);
}
function V7(e, t) {
  let r;
  if (t === void 0)
    for (const n of e)
      n != null && (r < n || r === void 0 && n >= n) && (r = n);
  else {
    let n = -1;
    for (let a of e)
      (a = t(a, ++n, e)) != null && (r < a || r === void 0 && a >= a) && (r = a);
  }
  return r;
}
function H7(e, t) {
  let r;
  if (t === void 0)
    for (const n of e)
      n != null && (r > n || r === void 0 && n >= n) && (r = n);
  else {
    let n = -1;
    for (let a of e)
      (a = t(a, ++n, e)) != null && (r > a || r === void 0 && a >= a) && (r = a);
  }
  return r;
}
function Eg(e, t, r = 0, n = 1 / 0, a) {
  if (t = Math.floor(t), r = Math.floor(Math.max(0, r)), n = Math.floor(Math.min(e.length - 1, n)), !(r <= t && t <= n))
    return e;
  for (a = a === void 0 ? Pg : _X(a); n > r; ) {
    if (n - r > 600) {
      const l = n - r + 1, c = t - r + 1, u = Math.log(l), f = 0.5 * Math.exp(2 * u / 3), p = 0.5 * Math.sqrt(u * f * (l - f) / l) * (c - l / 2 < 0 ? -1 : 1), h = Math.max(r, Math.floor(t - c * f / l + p)), m = Math.min(n, Math.floor(t + (l - c) * f / l + p));
      Eg(e, t, h, m, a);
    }
    const i = e[t];
    let o = r, s = n;
    for (So(e, r, t), a(e[n], i) > 0 && So(e, r, n); o < s; ) {
      for (So(e, o, s), ++o, --s; a(e[o], i) < 0; )
        ++o;
      for (; a(e[s], i) > 0; )
        --s;
    }
    a(e[r], i) === 0 ? So(e, r, s) : (++s, So(e, s, n)), s <= t && (r = s + 1), t <= s && (n = s - 1);
  }
  return e;
}
function So(e, t, r) {
  const n = e[t];
  e[t] = e[r], e[r] = n;
}
function TX(e, t, r) {
  if (e = Float64Array.from(wX(e, r)), !(!(n = e.length) || isNaN(t = +t))) {
    if (t <= 0 || n < 2)
      return H7(e);
    if (t >= 1)
      return V7(e);
    var n, a = (n - 1) * t, i = Math.floor(a), o = V7(Eg(e, i).subarray(0, i + 1)), s = H7(e.subarray(i + 1));
    return o + (s - o) * (a - i);
  }
}
function $X(e, t, r = Sg) {
  if (!(!(n = e.length) || isNaN(t = +t))) {
    if (t <= 0 || n < 2)
      return +r(e[0], 0, e);
    if (t >= 1)
      return +r(e[n - 1], n - 1, e);
    var n, a = (n - 1) * t, i = Math.floor(a), o = +r(e[i], i, e), s = +r(e[i + 1], i + 1, e);
    return o + (s - o) * (a - i);
  }
}
function NX(e, t, r) {
  e = +e, t = +t, r = (a = arguments.length) < 2 ? (t = e, e = 0, 1) : a < 3 ? 1 : +r;
  for (var n = -1, a = Math.max(0, Math.ceil((t - e) / r)) | 0, i = new Array(a); ++n < a; )
    i[n] = e + n * r;
  return i;
}
function Rr(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(e);
      break;
    default:
      this.range(t).domain(e);
      break;
  }
  return this;
}
function In(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      typeof e == "function" ? this.interpolator(e) : this.range(e);
      break;
    }
    default: {
      this.domain(e), typeof t == "function" ? this.interpolator(t) : this.range(t);
      break;
    }
  }
  return this;
}
const H3 = Symbol("implicit");
function dd() {
  var e = new k7(), t = [], r = [], n = H3;
  function a(i) {
    let o = e.get(i);
    if (o === void 0) {
      if (n !== H3)
        return n;
      e.set(i, o = t.push(i) - 1);
    }
    return r[o % r.length];
  }
  return a.domain = function(i) {
    if (!arguments.length)
      return t.slice();
    t = [], e = new k7();
    for (const o of i)
      e.has(o) || e.set(o, t.push(o) - 1);
    return a;
  }, a.range = function(i) {
    return arguments.length ? (r = Array.from(i), a) : r.slice();
  }, a.unknown = function(i) {
    return arguments.length ? (n = i, a) : n;
  }, a.copy = function() {
    return dd(t, r).unknown(n);
  }, Rr.apply(a, arguments), a;
}
function Cs() {
  var e = dd().unknown(void 0), t = e.domain, r = e.range, n = 0, a = 1, i, o, s = !1, l = 0, c = 0, u = 0.5;
  delete e.unknown;
  function f() {
    var p = t().length, h = a < n, m = h ? a : n, v = h ? n : a;
    i = (v - m) / Math.max(1, p - l + c * 2), s && (i = Math.floor(i)), m += (v - m - i * (p - l)) * u, o = i * (1 - l), s && (m = Math.round(m), o = Math.round(o));
    var g = NX(p).map(function(y) {
      return m + i * y;
    });
    return r(h ? g.reverse() : g);
  }
  return e.domain = function(p) {
    return arguments.length ? (t(p), f()) : t();
  }, e.range = function(p) {
    return arguments.length ? ([n, a] = p, n = +n, a = +a, f()) : [n, a];
  }, e.rangeRound = function(p) {
    return [n, a] = p, n = +n, a = +a, s = !0, f();
  }, e.bandwidth = function() {
    return o;
  }, e.step = function() {
    return i;
  }, e.round = function(p) {
    return arguments.length ? (s = !!p, f()) : s;
  }, e.padding = function(p) {
    return arguments.length ? (l = Math.min(1, c = +p), f()) : l;
  }, e.paddingInner = function(p) {
    return arguments.length ? (l = Math.min(1, p), f()) : l;
  }, e.paddingOuter = function(p) {
    return arguments.length ? (c = +p, f()) : c;
  }, e.align = function(p) {
    return arguments.length ? (u = Math.max(0, Math.min(1, p)), f()) : u;
  }, e.copy = function() {
    return Cs(t(), [n, a]).round(s).paddingInner(l).paddingOuter(c).align(u);
  }, Rr.apply(f(), arguments);
}
function jg(e) {
  var t = e.copy;
  return e.padding = e.paddingOuter, delete e.paddingInner, delete e.paddingOuter, e.copy = function() {
    return jg(t());
  }, e;
}
function Yo() {
  return jg(Cs.apply(null, arguments).paddingInner(1));
}
function pd(e, t, r) {
  e.prototype = t.prototype = r, r.constructor = e;
}
function _g(e, t) {
  var r = Object.create(e.prototype);
  for (var n in t)
    r[n] = t[n];
  return r;
}
function ul() {
}
var xs = 0.7, D1 = 1 / xs, hi = "\\s*([+-]?\\d+)\\s*", ws = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", an = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", IX = /^#([0-9a-f]{3,8})$/, LX = new RegExp(`^rgb\\(${hi},${hi},${hi}\\)$`), RX = new RegExp(`^rgb\\(${an},${an},${an}\\)$`), kX = new RegExp(`^rgba\\(${hi},${hi},${hi},${ws}\\)$`), BX = new RegExp(`^rgba\\(${an},${an},${an},${ws}\\)$`), VX = new RegExp(`^hsl\\(${ws},${an},${an}\\)$`), HX = new RegExp(`^hsla\\(${ws},${an},${an},${ws}\\)$`), F7 = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
pd(ul, Os, {
  copy(e) {
    return Object.assign(new this.constructor(), this, e);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: W7,
  // Deprecated! Use color.formatHex.
  formatHex: W7,
  formatHex8: FX,
  formatHsl: WX,
  formatRgb: z7,
  toString: z7
});
function W7() {
  return this.rgb().formatHex();
}
function FX() {
  return this.rgb().formatHex8();
}
function WX() {
  return Dg(this).formatHsl();
}
function z7() {
  return this.rgb().formatRgb();
}
function Os(e) {
  var t, r;
  return e = (e + "").trim().toLowerCase(), (t = IX.exec(e)) ? (r = t[1].length, t = parseInt(t[1], 16), r === 6 ? U7(t) : r === 3 ? new sr(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : r === 8 ? Al(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : r === 4 ? Al(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = LX.exec(e)) ? new sr(t[1], t[2], t[3], 1) : (t = RX.exec(e)) ? new sr(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = kX.exec(e)) ? Al(t[1], t[2], t[3], t[4]) : (t = BX.exec(e)) ? Al(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = VX.exec(e)) ? G7(t[1], t[2] / 100, t[3] / 100, 1) : (t = HX.exec(e)) ? G7(t[1], t[2] / 100, t[3] / 100, t[4]) : F7.hasOwnProperty(e) ? U7(F7[e]) : e === "transparent" ? new sr(NaN, NaN, NaN, 0) : null;
}
function U7(e) {
  return new sr(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
}
function Al(e, t, r, n) {
  return n <= 0 && (e = t = r = NaN), new sr(e, t, r, n);
}
function zX(e) {
  return e instanceof ul || (e = Os(e)), e ? (e = e.rgb(), new sr(e.r, e.g, e.b, e.opacity)) : new sr();
}
function F3(e, t, r, n) {
  return arguments.length === 1 ? zX(e) : new sr(e, t, r, n ?? 1);
}
function sr(e, t, r, n) {
  this.r = +e, this.g = +t, this.b = +r, this.opacity = +n;
}
pd(sr, F3, _g(ul, {
  brighter(e) {
    return e = e == null ? D1 : Math.pow(D1, e), new sr(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? xs : Math.pow(xs, e), new sr(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new sr(Ta(this.r), Ta(this.g), Ta(this.b), A1(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: Z7,
  // Deprecated! Use color.formatHex.
  formatHex: Z7,
  formatHex8: UX,
  formatRgb: q7,
  toString: q7
}));
function Z7() {
  return `#${ja(this.r)}${ja(this.g)}${ja(this.b)}`;
}
function UX() {
  return `#${ja(this.r)}${ja(this.g)}${ja(this.b)}${ja((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function q7() {
  const e = A1(this.opacity);
  return `${e === 1 ? "rgb(" : "rgba("}${Ta(this.r)}, ${Ta(this.g)}, ${Ta(this.b)}${e === 1 ? ")" : `, ${e})`}`;
}
function A1(e) {
  return isNaN(e) ? 1 : Math.max(0, Math.min(1, e));
}
function Ta(e) {
  return Math.max(0, Math.min(255, Math.round(e) || 0));
}
function ja(e) {
  return e = Ta(e), (e < 16 ? "0" : "") + e.toString(16);
}
function G7(e, t, r, n) {
  return n <= 0 ? e = t = r = NaN : r <= 0 || r >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new Fr(e, t, r, n);
}
function Dg(e) {
  if (e instanceof Fr)
    return new Fr(e.h, e.s, e.l, e.opacity);
  if (e instanceof ul || (e = Os(e)), !e)
    return new Fr();
  if (e instanceof Fr)
    return e;
  e = e.rgb();
  var t = e.r / 255, r = e.g / 255, n = e.b / 255, a = Math.min(t, r, n), i = Math.max(t, r, n), o = NaN, s = i - a, l = (i + a) / 2;
  return s ? (t === i ? o = (r - n) / s + (r < n) * 6 : r === i ? o = (n - t) / s + 2 : o = (t - r) / s + 4, s /= l < 0.5 ? i + a : 2 - i - a, o *= 60) : s = l > 0 && l < 1 ? 0 : o, new Fr(o, s, l, e.opacity);
}
function ZX(e, t, r, n) {
  return arguments.length === 1 ? Dg(e) : new Fr(e, t, r, n ?? 1);
}
function Fr(e, t, r, n) {
  this.h = +e, this.s = +t, this.l = +r, this.opacity = +n;
}
pd(Fr, ZX, _g(ul, {
  brighter(e) {
    return e = e == null ? D1 : Math.pow(D1, e), new Fr(this.h, this.s, this.l * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? xs : Math.pow(xs, e), new Fr(this.h, this.s, this.l * e, this.opacity);
  },
  rgb() {
    var e = this.h % 360 + (this.h < 0) * 360, t = isNaN(e) || isNaN(this.s) ? 0 : this.s, r = this.l, n = r + (r < 0.5 ? r : 1 - r) * t, a = 2 * r - n;
    return new sr(
      y2(e >= 240 ? e - 240 : e + 120, a, n),
      y2(e, a, n),
      y2(e < 120 ? e + 240 : e - 120, a, n),
      this.opacity
    );
  },
  clamp() {
    return new Fr(Y7(this.h), Ml(this.s), Ml(this.l), A1(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const e = A1(this.opacity);
    return `${e === 1 ? "hsl(" : "hsla("}${Y7(this.h)}, ${Ml(this.s) * 100}%, ${Ml(this.l) * 100}%${e === 1 ? ")" : `, ${e})`}`;
  }
}));
function Y7(e) {
  return e = (e || 0) % 360, e < 0 ? e + 360 : e;
}
function Ml(e) {
  return Math.max(0, Math.min(1, e || 0));
}
function y2(e, t, r) {
  return (e < 60 ? t + (r - t) * e / 60 : e < 180 ? r : e < 240 ? t + (r - t) * (240 - e) / 60 : t) * 255;
}
const hd = (e) => () => e;
function qX(e, t) {
  return function(r) {
    return e + r * t;
  };
}
function GX(e, t, r) {
  return e = Math.pow(e, r), t = Math.pow(t, r) - e, r = 1 / r, function(n) {
    return Math.pow(e + n * t, r);
  };
}
function YX(e) {
  return (e = +e) == 1 ? Ag : function(t, r) {
    return r - t ? GX(t, r, e) : hd(isNaN(t) ? r : t);
  };
}
function Ag(e, t) {
  var r = t - e;
  return r ? qX(e, r) : hd(isNaN(e) ? t : e);
}
const K7 = function e(t) {
  var r = YX(t);
  function n(a, i) {
    var o = r((a = F3(a)).r, (i = F3(i)).r), s = r(a.g, i.g), l = r(a.b, i.b), c = Ag(a.opacity, i.opacity);
    return function(u) {
      return a.r = o(u), a.g = s(u), a.b = l(u), a.opacity = c(u), a + "";
    };
  }
  return n.gamma = e, n;
}(1);
function KX(e, t) {
  t || (t = []);
  var r = e ? Math.min(t.length, e.length) : 0, n = t.slice(), a;
  return function(i) {
    for (a = 0; a < r; ++a)
      n[a] = e[a] * (1 - i) + t[a] * i;
    return n;
  };
}
function XX(e) {
  return ArrayBuffer.isView(e) && !(e instanceof DataView);
}
function QX(e, t) {
  var r = t ? t.length : 0, n = e ? Math.min(r, e.length) : 0, a = new Array(n), i = new Array(r), o;
  for (o = 0; o < n; ++o)
    a[o] = lo(e[o], t[o]);
  for (; o < r; ++o)
    i[o] = t[o];
  return function(s) {
    for (o = 0; o < n; ++o)
      i[o] = a[o](s);
    return i;
  };
}
function JX(e, t) {
  var r = /* @__PURE__ */ new Date();
  return e = +e, t = +t, function(n) {
    return r.setTime(e * (1 - n) + t * n), r;
  };
}
function M1(e, t) {
  return e = +e, t = +t, function(r) {
    return e * (1 - r) + t * r;
  };
}
function eQ(e, t) {
  var r = {}, n = {}, a;
  (e === null || typeof e != "object") && (e = {}), (t === null || typeof t != "object") && (t = {});
  for (a in t)
    a in e ? r[a] = lo(e[a], t[a]) : n[a] = t[a];
  return function(i) {
    for (a in r)
      n[a] = r[a](i);
    return n;
  };
}
var W3 = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, b2 = new RegExp(W3.source, "g");
function tQ(e) {
  return function() {
    return e;
  };
}
function rQ(e) {
  return function(t) {
    return e(t) + "";
  };
}
function nQ(e, t) {
  var r = W3.lastIndex = b2.lastIndex = 0, n, a, i, o = -1, s = [], l = [];
  for (e = e + "", t = t + ""; (n = W3.exec(e)) && (a = b2.exec(t)); )
    (i = a.index) > r && (i = t.slice(r, i), s[o] ? s[o] += i : s[++o] = i), (n = n[0]) === (a = a[0]) ? s[o] ? s[o] += a : s[++o] = a : (s[++o] = null, l.push({ i: o, x: M1(n, a) })), r = b2.lastIndex;
  return r < t.length && (i = t.slice(r), s[o] ? s[o] += i : s[++o] = i), s.length < 2 ? l[0] ? rQ(l[0].x) : tQ(t) : (t = l.length, function(c) {
    for (var u = 0, f; u < t; ++u)
      s[(f = l[u]).i] = f.x(c);
    return s.join("");
  });
}
function lo(e, t) {
  var r = typeof t, n;
  return t == null || r === "boolean" ? hd(t) : (r === "number" ? M1 : r === "string" ? (n = Os(t)) ? (t = n, K7) : nQ : t instanceof Os ? K7 : t instanceof Date ? JX : XX(t) ? KX : Array.isArray(t) ? QX : typeof t.valueOf != "function" && typeof t.toString != "function" || isNaN(t) ? eQ : M1)(e, t);
}
function vd(e, t) {
  return e = +e, t = +t, function(r) {
    return Math.round(e * (1 - r) + t * r);
  };
}
function aQ(e, t) {
  t === void 0 && (t = e, e = lo);
  for (var r = 0, n = t.length - 1, a = t[0], i = new Array(n < 0 ? 0 : n); r < n; )
    i[r] = e(a, a = t[++r]);
  return function(o) {
    var s = Math.max(0, Math.min(n - 1, Math.floor(o *= n)));
    return i[s](o - s);
  };
}
function iQ(e) {
  return function() {
    return e;
  };
}
function T1(e) {
  return +e;
}
var X7 = [0, 1];
function tr(e) {
  return e;
}
function z3(e, t) {
  return (t -= e = +e) ? function(r) {
    return (r - e) / t;
  } : iQ(isNaN(t) ? NaN : 0.5);
}
function oQ(e, t) {
  var r;
  return e > t && (r = e, e = t, t = r), function(n) {
    return Math.max(e, Math.min(t, n));
  };
}
function sQ(e, t, r) {
  var n = e[0], a = e[1], i = t[0], o = t[1];
  return a < n ? (n = z3(a, n), i = r(o, i)) : (n = z3(n, a), i = r(i, o)), function(s) {
    return i(n(s));
  };
}
function lQ(e, t, r) {
  var n = Math.min(e.length, t.length) - 1, a = new Array(n), i = new Array(n), o = -1;
  for (e[n] < e[0] && (e = e.slice().reverse(), t = t.slice().reverse()); ++o < n; )
    a[o] = z3(e[o], e[o + 1]), i[o] = r(t[o], t[o + 1]);
  return function(s) {
    var l = cl(e, s, 1, n) - 1;
    return i[l](a[l](s));
  };
}
function fl(e, t) {
  return t.domain(e.domain()).range(e.range()).interpolate(e.interpolate()).clamp(e.clamp()).unknown(e.unknown());
}
function Kc() {
  var e = X7, t = X7, r = lo, n, a, i, o = tr, s, l, c;
  function u() {
    var p = Math.min(e.length, t.length);
    return o !== tr && (o = oQ(e[0], e[p - 1])), s = p > 2 ? lQ : sQ, l = c = null, f;
  }
  function f(p) {
    return p == null || isNaN(p = +p) ? i : (l || (l = s(e.map(n), t, r)))(n(o(p)));
  }
  return f.invert = function(p) {
    return o(a((c || (c = s(t, e.map(n), M1)))(p)));
  }, f.domain = function(p) {
    return arguments.length ? (e = Array.from(p, T1), u()) : e.slice();
  }, f.range = function(p) {
    return arguments.length ? (t = Array.from(p), u()) : t.slice();
  }, f.rangeRound = function(p) {
    return t = Array.from(p), r = vd, u();
  }, f.clamp = function(p) {
    return arguments.length ? (o = p ? !0 : tr, u()) : o !== tr;
  }, f.interpolate = function(p) {
    return arguments.length ? (r = p, u()) : r;
  }, f.unknown = function(p) {
    return arguments.length ? (i = p, f) : i;
  }, function(p, h) {
    return n = p, a = h, u();
  };
}
function md() {
  return Kc()(tr, tr);
}
function cQ(e) {
  return Math.abs(e = Math.round(e)) >= 1e21 ? e.toLocaleString("en").replace(/,/g, "") : e.toString(10);
}
function $1(e, t) {
  if ((r = (e = t ? e.toExponential(t - 1) : e.toExponential()).indexOf("e")) < 0)
    return null;
  var r, n = e.slice(0, r);
  return [
    n.length > 1 ? n[0] + n.slice(2) : n,
    +e.slice(r + 1)
  ];
}
function Pi(e) {
  return e = $1(Math.abs(e)), e ? e[1] : NaN;
}
function uQ(e, t) {
  return function(r, n) {
    for (var a = r.length, i = [], o = 0, s = e[0], l = 0; a > 0 && s > 0 && (l + s + 1 > n && (s = Math.max(1, n - l)), i.push(r.substring(a -= s, a + s)), !((l += s + 1) > n)); )
      s = e[o = (o + 1) % e.length];
    return i.reverse().join(t);
  };
}
function fQ(e) {
  return function(t) {
    return t.replace(/[0-9]/g, function(r) {
      return e[+r];
    });
  };
}
var dQ = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function Ss(e) {
  if (!(t = dQ.exec(e)))
    throw new Error("invalid format: " + e);
  var t;
  return new gd({
    fill: t[1],
    align: t[2],
    sign: t[3],
    symbol: t[4],
    zero: t[5],
    width: t[6],
    comma: t[7],
    precision: t[8] && t[8].slice(1),
    trim: t[9],
    type: t[10]
  });
}
Ss.prototype = gd.prototype;
function gd(e) {
  this.fill = e.fill === void 0 ? " " : e.fill + "", this.align = e.align === void 0 ? ">" : e.align + "", this.sign = e.sign === void 0 ? "-" : e.sign + "", this.symbol = e.symbol === void 0 ? "" : e.symbol + "", this.zero = !!e.zero, this.width = e.width === void 0 ? void 0 : +e.width, this.comma = !!e.comma, this.precision = e.precision === void 0 ? void 0 : +e.precision, this.trim = !!e.trim, this.type = e.type === void 0 ? "" : e.type + "";
}
gd.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function pQ(e) {
  e:
    for (var t = e.length, r = 1, n = -1, a; r < t; ++r)
      switch (e[r]) {
        case ".":
          n = a = r;
          break;
        case "0":
          n === 0 && (n = r), a = r;
          break;
        default:
          if (!+e[r])
            break e;
          n > 0 && (n = 0);
          break;
      }
  return n > 0 ? e.slice(0, n) + e.slice(a + 1) : e;
}
var Mg;
function hQ(e, t) {
  var r = $1(e, t);
  if (!r)
    return e + "";
  var n = r[0], a = r[1], i = a - (Mg = Math.max(-8, Math.min(8, Math.floor(a / 3))) * 3) + 1, o = n.length;
  return i === o ? n : i > o ? n + new Array(i - o + 1).join("0") : i > 0 ? n.slice(0, i) + "." + n.slice(i) : "0." + new Array(1 - i).join("0") + $1(e, Math.max(0, t + i - 1))[0];
}
function Q7(e, t) {
  var r = $1(e, t);
  if (!r)
    return e + "";
  var n = r[0], a = r[1];
  return a < 0 ? "0." + new Array(-a).join("0") + n : n.length > a + 1 ? n.slice(0, a + 1) + "." + n.slice(a + 1) : n + new Array(a - n.length + 2).join("0");
}
const J7 = {
  "%": (e, t) => (e * 100).toFixed(t),
  b: (e) => Math.round(e).toString(2),
  c: (e) => e + "",
  d: cQ,
  e: (e, t) => e.toExponential(t),
  f: (e, t) => e.toFixed(t),
  g: (e, t) => e.toPrecision(t),
  o: (e) => Math.round(e).toString(8),
  p: (e, t) => Q7(e * 100, t),
  r: Q7,
  s: hQ,
  X: (e) => Math.round(e).toString(16).toUpperCase(),
  x: (e) => Math.round(e).toString(16)
};
function e4(e) {
  return e;
}
var t4 = Array.prototype.map, r4 = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function vQ(e) {
  var t = e.grouping === void 0 || e.thousands === void 0 ? e4 : uQ(t4.call(e.grouping, Number), e.thousands + ""), r = e.currency === void 0 ? "" : e.currency[0] + "", n = e.currency === void 0 ? "" : e.currency[1] + "", a = e.decimal === void 0 ? "." : e.decimal + "", i = e.numerals === void 0 ? e4 : fQ(t4.call(e.numerals, String)), o = e.percent === void 0 ? "%" : e.percent + "", s = e.minus === void 0 ? "−" : e.minus + "", l = e.nan === void 0 ? "NaN" : e.nan + "";
  function c(f) {
    f = Ss(f);
    var p = f.fill, h = f.align, m = f.sign, v = f.symbol, g = f.zero, y = f.width, b = f.comma, w = f.precision, x = f.trim, C = f.type;
    C === "n" ? (b = !0, C = "g") : J7[C] || (w === void 0 && (w = 12), x = !0, C = "g"), (g || p === "0" && h === "=") && (g = !0, p = "0", h = "=");
    var S = v === "$" ? r : v === "#" && /[boxX]/.test(C) ? "0" + C.toLowerCase() : "", E = v === "$" ? n : /[%p]/.test(C) ? o : "", D = J7[C], I = /[defgprs%]/.test(C);
    w = w === void 0 ? 6 : /[gprs]/.test(C) ? Math.max(1, Math.min(21, w)) : Math.max(0, Math.min(20, w));
    function k(V) {
      var W = S, L = E, G, Q, X;
      if (C === "c")
        L = D(V) + L, V = "";
      else {
        V = +V;
        var K = V < 0 || 1 / V < 0;
        if (V = isNaN(V) ? l : D(Math.abs(V), w), x && (V = pQ(V)), K && +V == 0 && m !== "+" && (K = !1), W = (K ? m === "(" ? m : s : m === "-" || m === "(" ? "" : m) + W, L = (C === "s" ? r4[8 + Mg / 3] : "") + L + (K && m === "(" ? ")" : ""), I) {
          for (G = -1, Q = V.length; ++G < Q; )
            if (X = V.charCodeAt(G), 48 > X || X > 57) {
              L = (X === 46 ? a + V.slice(G + 1) : V.slice(G)) + L, V = V.slice(0, G);
              break;
            }
        }
      }
      b && !g && (V = t(V, 1 / 0));
      var te = W.length + V.length + L.length, _ = te < y ? new Array(y - te + 1).join(p) : "";
      switch (b && g && (V = t(_ + V, _.length ? y - L.length : 1 / 0), _ = ""), h) {
        case "<":
          V = W + V + L + _;
          break;
        case "=":
          V = W + _ + V + L;
          break;
        case "^":
          V = _.slice(0, te = _.length >> 1) + W + V + L + _.slice(te);
          break;
        default:
          V = _ + W + V + L;
          break;
      }
      return i(V);
    }
    return k.toString = function() {
      return f + "";
    }, k;
  }
  function u(f, p) {
    var h = c((f = Ss(f), f.type = "f", f)), m = Math.max(-8, Math.min(8, Math.floor(Pi(p) / 3))) * 3, v = Math.pow(10, -m), g = r4[8 + m / 3];
    return function(y) {
      return h(v * y) + g;
    };
  }
  return {
    format: c,
    formatPrefix: u
  };
}
var Tl, yd, Tg;
mQ({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function mQ(e) {
  return Tl = vQ(e), yd = Tl.format, Tg = Tl.formatPrefix, Tl;
}
function gQ(e) {
  return Math.max(0, -Pi(Math.abs(e)));
}
function yQ(e, t) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(Pi(t) / 3))) * 3 - Pi(Math.abs(e)));
}
function bQ(e, t) {
  return e = Math.abs(e), t = Math.abs(t) - e, Math.max(0, Pi(t) - Pi(e)) + 1;
}
function $g(e, t, r, n) {
  var a = V3(e, t, r), i;
  switch (n = Ss(n ?? ",f"), n.type) {
    case "s": {
      var o = Math.max(Math.abs(e), Math.abs(t));
      return n.precision == null && !isNaN(i = yQ(a, o)) && (n.precision = i), Tg(n, o);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      n.precision == null && !isNaN(i = bQ(a, Math.max(Math.abs(e), Math.abs(t)))) && (n.precision = i - (n.type === "e"));
      break;
    }
    case "f":
    case "%": {
      n.precision == null && !isNaN(i = gQ(a)) && (n.precision = i - (n.type === "%") * 2);
      break;
    }
  }
  return yd(n);
}
function sa(e) {
  var t = e.domain;
  return e.ticks = function(r) {
    var n = t();
    return k3(n[0], n[n.length - 1], r ?? 10);
  }, e.tickFormat = function(r, n) {
    var a = t();
    return $g(a[0], a[a.length - 1], r ?? 10, n);
  }, e.nice = function(r) {
    r == null && (r = 10);
    var n = t(), a = 0, i = n.length - 1, o = n[a], s = n[i], l, c, u = 10;
    for (s < o && (c = o, o = s, s = c, c = a, a = i, i = c); u-- > 0; ) {
      if (c = B3(o, s, r), c === l)
        return n[a] = o, n[i] = s, t(n);
      if (c > 0)
        o = Math.floor(o / c) * c, s = Math.ceil(s / c) * c;
      else if (c < 0)
        o = Math.ceil(o * c) / c, s = Math.floor(s * c) / c;
      else
        break;
      l = c;
    }
    return e;
  }, e;
}
function N1() {
  var e = md();
  return e.copy = function() {
    return fl(e, N1());
  }, Rr.apply(e, arguments), sa(e);
}
function Ng(e) {
  var t;
  function r(n) {
    return n == null || isNaN(n = +n) ? t : n;
  }
  return r.invert = r, r.domain = r.range = function(n) {
    return arguments.length ? (e = Array.from(n, T1), r) : e.slice();
  }, r.unknown = function(n) {
    return arguments.length ? (t = n, r) : t;
  }, r.copy = function() {
    return Ng(e).unknown(t);
  }, e = arguments.length ? Array.from(e, T1) : [0, 1], sa(r);
}
function Ig(e, t) {
  e = e.slice();
  var r = 0, n = e.length - 1, a = e[r], i = e[n], o;
  return i < a && (o = r, r = n, n = o, o = a, a = i, i = o), e[r] = t.floor(a), e[n] = t.ceil(i), e;
}
function n4(e) {
  return Math.log(e);
}
function a4(e) {
  return Math.exp(e);
}
function CQ(e) {
  return -Math.log(-e);
}
function xQ(e) {
  return -Math.exp(-e);
}
function wQ(e) {
  return isFinite(e) ? +("1e" + e) : e < 0 ? 0 : e;
}
function OQ(e) {
  return e === 10 ? wQ : e === Math.E ? Math.exp : (t) => Math.pow(e, t);
}
function SQ(e) {
  return e === Math.E ? Math.log : e === 10 && Math.log10 || e === 2 && Math.log2 || (e = Math.log(e), (t) => Math.log(t) / e);
}
function i4(e) {
  return (t, r) => -e(-t, r);
}
function bd(e) {
  const t = e(n4, a4), r = t.domain;
  let n = 10, a, i;
  function o() {
    return a = SQ(n), i = OQ(n), r()[0] < 0 ? (a = i4(a), i = i4(i), e(CQ, xQ)) : e(n4, a4), t;
  }
  return t.base = function(s) {
    return arguments.length ? (n = +s, o()) : n;
  }, t.domain = function(s) {
    return arguments.length ? (r(s), o()) : r();
  }, t.ticks = (s) => {
    const l = r();
    let c = l[0], u = l[l.length - 1];
    const f = u < c;
    f && ([c, u] = [u, c]);
    let p = a(c), h = a(u), m, v;
    const g = s == null ? 10 : +s;
    let y = [];
    if (!(n % 1) && h - p < g) {
      if (p = Math.floor(p), h = Math.ceil(h), c > 0) {
        for (; p <= h; ++p)
          for (m = 1; m < n; ++m)
            if (v = p < 0 ? m / i(-p) : m * i(p), !(v < c)) {
              if (v > u)
                break;
              y.push(v);
            }
      } else
        for (; p <= h; ++p)
          for (m = n - 1; m >= 1; --m)
            if (v = p > 0 ? m / i(-p) : m * i(p), !(v < c)) {
              if (v > u)
                break;
              y.push(v);
            }
      y.length * 2 < g && (y = k3(c, u, g));
    } else
      y = k3(p, h, Math.min(h - p, g)).map(i);
    return f ? y.reverse() : y;
  }, t.tickFormat = (s, l) => {
    if (s == null && (s = 10), l == null && (l = n === 10 ? "s" : ","), typeof l != "function" && (!(n % 1) && (l = Ss(l)).precision == null && (l.trim = !0), l = yd(l)), s === 1 / 0)
      return l;
    const c = Math.max(1, n * s / t.ticks().length);
    return (u) => {
      let f = u / i(Math.round(a(u)));
      return f * n < n - 0.5 && (f *= n), f <= c ? l(u) : "";
    };
  }, t.nice = () => r(Ig(r(), {
    floor: (s) => i(Math.floor(a(s))),
    ceil: (s) => i(Math.ceil(a(s)))
  })), t;
}
function Lg() {
  const e = bd(Kc()).domain([1, 10]);
  return e.copy = () => fl(e, Lg()).base(e.base()), Rr.apply(e, arguments), e;
}
function o4(e) {
  return function(t) {
    return Math.sign(t) * Math.log1p(Math.abs(t / e));
  };
}
function s4(e) {
  return function(t) {
    return Math.sign(t) * Math.expm1(Math.abs(t)) * e;
  };
}
function Cd(e) {
  var t = 1, r = e(o4(t), s4(t));
  return r.constant = function(n) {
    return arguments.length ? e(o4(t = +n), s4(t)) : t;
  }, sa(r);
}
function Rg() {
  var e = Cd(Kc());
  return e.copy = function() {
    return fl(e, Rg()).constant(e.constant());
  }, Rr.apply(e, arguments);
}
function l4(e) {
  return function(t) {
    return t < 0 ? -Math.pow(-t, e) : Math.pow(t, e);
  };
}
function PQ(e) {
  return e < 0 ? -Math.sqrt(-e) : Math.sqrt(e);
}
function EQ(e) {
  return e < 0 ? -e * e : e * e;
}
function xd(e) {
  var t = e(tr, tr), r = 1;
  function n() {
    return r === 1 ? e(tr, tr) : r === 0.5 ? e(PQ, EQ) : e(l4(r), l4(1 / r));
  }
  return t.exponent = function(a) {
    return arguments.length ? (r = +a, n()) : r;
  }, sa(t);
}
function wd() {
  var e = xd(Kc());
  return e.copy = function() {
    return fl(e, wd()).exponent(e.exponent());
  }, Rr.apply(e, arguments), e;
}
function jQ() {
  return wd.apply(null, arguments).exponent(0.5);
}
function c4(e) {
  return Math.sign(e) * e * e;
}
function _Q(e) {
  return Math.sign(e) * Math.sqrt(Math.abs(e));
}
function kg() {
  var e = md(), t = [0, 1], r = !1, n;
  function a(i) {
    var o = _Q(e(i));
    return isNaN(o) ? n : r ? Math.round(o) : o;
  }
  return a.invert = function(i) {
    return e.invert(c4(i));
  }, a.domain = function(i) {
    return arguments.length ? (e.domain(i), a) : e.domain();
  }, a.range = function(i) {
    return arguments.length ? (e.range((t = Array.from(i, T1)).map(c4)), a) : t.slice();
  }, a.rangeRound = function(i) {
    return a.range(i).round(!0);
  }, a.round = function(i) {
    return arguments.length ? (r = !!i, a) : r;
  }, a.clamp = function(i) {
    return arguments.length ? (e.clamp(i), a) : e.clamp();
  }, a.unknown = function(i) {
    return arguments.length ? (n = i, a) : n;
  }, a.copy = function() {
    return kg(e.domain(), t).round(r).clamp(e.clamp()).unknown(n);
  }, Rr.apply(a, arguments), sa(a);
}
function Bg() {
  var e = [], t = [], r = [], n;
  function a() {
    var o = 0, s = Math.max(1, t.length);
    for (r = new Array(s - 1); ++o < s; )
      r[o - 1] = $X(e, o / s);
    return i;
  }
  function i(o) {
    return o == null || isNaN(o = +o) ? n : t[cl(r, o)];
  }
  return i.invertExtent = function(o) {
    var s = t.indexOf(o);
    return s < 0 ? [NaN, NaN] : [
      s > 0 ? r[s - 1] : e[0],
      s < r.length ? r[s] : e[e.length - 1]
    ];
  }, i.domain = function(o) {
    if (!arguments.length)
      return e.slice();
    e = [];
    for (let s of o)
      s != null && !isNaN(s = +s) && e.push(s);
    return e.sort(Zn), a();
  }, i.range = function(o) {
    return arguments.length ? (t = Array.from(o), a()) : t.slice();
  }, i.unknown = function(o) {
    return arguments.length ? (n = o, i) : n;
  }, i.quantiles = function() {
    return r.slice();
  }, i.copy = function() {
    return Bg().domain(e).range(t).unknown(n);
  }, Rr.apply(i, arguments);
}
function Vg() {
  var e = 0, t = 1, r = 1, n = [0.5], a = [0, 1], i;
  function o(l) {
    return l != null && l <= l ? a[cl(n, l, 0, r)] : i;
  }
  function s() {
    var l = -1;
    for (n = new Array(r); ++l < r; )
      n[l] = ((l + 1) * t - (l - r) * e) / (r + 1);
    return o;
  }
  return o.domain = function(l) {
    return arguments.length ? ([e, t] = l, e = +e, t = +t, s()) : [e, t];
  }, o.range = function(l) {
    return arguments.length ? (r = (a = Array.from(l)).length - 1, s()) : a.slice();
  }, o.invertExtent = function(l) {
    var c = a.indexOf(l);
    return c < 0 ? [NaN, NaN] : c < 1 ? [e, n[0]] : c >= r ? [n[r - 1], t] : [n[c - 1], n[c]];
  }, o.unknown = function(l) {
    return arguments.length && (i = l), o;
  }, o.thresholds = function() {
    return n.slice();
  }, o.copy = function() {
    return Vg().domain([e, t]).range(a).unknown(i);
  }, Rr.apply(sa(o), arguments);
}
function Hg() {
  var e = [0.5], t = [0, 1], r, n = 1;
  function a(i) {
    return i != null && i <= i ? t[cl(e, i, 0, n)] : r;
  }
  return a.domain = function(i) {
    return arguments.length ? (e = Array.from(i), n = Math.min(e.length, t.length - 1), a) : e.slice();
  }, a.range = function(i) {
    return arguments.length ? (t = Array.from(i), n = Math.min(e.length, t.length - 1), a) : t.slice();
  }, a.invertExtent = function(i) {
    var o = t.indexOf(i);
    return [e[o - 1], e[o]];
  }, a.unknown = function(i) {
    return arguments.length ? (r = i, a) : r;
  }, a.copy = function() {
    return Hg().domain(e).range(t).unknown(r);
  }, Rr.apply(a, arguments);
}
const C2 = /* @__PURE__ */ new Date(), x2 = /* @__PURE__ */ new Date();
function Rt(e, t, r, n) {
  function a(i) {
    return e(i = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+i)), i;
  }
  return a.floor = (i) => (e(i = /* @__PURE__ */ new Date(+i)), i), a.ceil = (i) => (e(i = new Date(i - 1)), t(i, 1), e(i), i), a.round = (i) => {
    const o = a(i), s = a.ceil(i);
    return i - o < s - i ? o : s;
  }, a.offset = (i, o) => (t(i = /* @__PURE__ */ new Date(+i), o == null ? 1 : Math.floor(o)), i), a.range = (i, o, s) => {
    const l = [];
    if (i = a.ceil(i), s = s == null ? 1 : Math.floor(s), !(i < o) || !(s > 0))
      return l;
    let c;
    do
      l.push(c = /* @__PURE__ */ new Date(+i)), t(i, s), e(i);
    while (c < i && i < o);
    return l;
  }, a.filter = (i) => Rt((o) => {
    if (o >= o)
      for (; e(o), !i(o); )
        o.setTime(o - 1);
  }, (o, s) => {
    if (o >= o)
      if (s < 0)
        for (; ++s <= 0; )
          for (; t(o, -1), !i(o); )
            ;
      else
        for (; --s >= 0; )
          for (; t(o, 1), !i(o); )
            ;
  }), r && (a.count = (i, o) => (C2.setTime(+i), x2.setTime(+o), e(C2), e(x2), Math.floor(r(C2, x2))), a.every = (i) => (i = Math.floor(i), !isFinite(i) || !(i > 0) ? null : i > 1 ? a.filter(n ? (o) => n(o) % i === 0 : (o) => a.count(0, o) % i === 0) : a)), a;
}
const I1 = Rt(() => {
}, (e, t) => {
  e.setTime(+e + t);
}, (e, t) => t - e);
I1.every = (e) => (e = Math.floor(e), !isFinite(e) || !(e > 0) ? null : e > 1 ? Rt((t) => {
  t.setTime(Math.floor(t / e) * e);
}, (t, r) => {
  t.setTime(+t + r * e);
}, (t, r) => (r - t) / e) : I1);
I1.range;
const Cn = 1e3, Ar = Cn * 60, xn = Ar * 60, Dn = xn * 24, Od = Dn * 7, u4 = Dn * 30, w2 = Dn * 365, _a = Rt((e) => {
  e.setTime(e - e.getMilliseconds());
}, (e, t) => {
  e.setTime(+e + t * Cn);
}, (e, t) => (t - e) / Cn, (e) => e.getUTCSeconds());
_a.range;
const Sd = Rt((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * Cn);
}, (e, t) => {
  e.setTime(+e + t * Ar);
}, (e, t) => (t - e) / Ar, (e) => e.getMinutes());
Sd.range;
const Pd = Rt((e) => {
  e.setUTCSeconds(0, 0);
}, (e, t) => {
  e.setTime(+e + t * Ar);
}, (e, t) => (t - e) / Ar, (e) => e.getUTCMinutes());
Pd.range;
const Ed = Rt((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * Cn - e.getMinutes() * Ar);
}, (e, t) => {
  e.setTime(+e + t * xn);
}, (e, t) => (t - e) / xn, (e) => e.getHours());
Ed.range;
const jd = Rt((e) => {
  e.setUTCMinutes(0, 0, 0);
}, (e, t) => {
  e.setTime(+e + t * xn);
}, (e, t) => (t - e) / xn, (e) => e.getUTCHours());
jd.range;
const dl = Rt(
  (e) => e.setHours(0, 0, 0, 0),
  (e, t) => e.setDate(e.getDate() + t),
  (e, t) => (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * Ar) / Dn,
  (e) => e.getDate() - 1
);
dl.range;
const Xc = Rt((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / Dn, (e) => e.getUTCDate() - 1);
Xc.range;
const Fg = Rt((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / Dn, (e) => Math.floor(e / Dn));
Fg.range;
function Wa(e) {
  return Rt((t) => {
    t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
  }, (t, r) => {
    t.setDate(t.getDate() + r * 7);
  }, (t, r) => (r - t - (r.getTimezoneOffset() - t.getTimezoneOffset()) * Ar) / Od);
}
const Qc = Wa(0), L1 = Wa(1), DQ = Wa(2), AQ = Wa(3), Ei = Wa(4), MQ = Wa(5), TQ = Wa(6);
Qc.range;
L1.range;
DQ.range;
AQ.range;
Ei.range;
MQ.range;
TQ.range;
function za(e) {
  return Rt((t) => {
    t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
  }, (t, r) => {
    t.setUTCDate(t.getUTCDate() + r * 7);
  }, (t, r) => (r - t) / Od);
}
const Jc = za(0), R1 = za(1), $Q = za(2), NQ = za(3), ji = za(4), IQ = za(5), LQ = za(6);
Jc.range;
R1.range;
$Q.range;
NQ.range;
ji.range;
IQ.range;
LQ.range;
const _d = Rt((e) => {
  e.setDate(1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setMonth(e.getMonth() + t);
}, (e, t) => t.getMonth() - e.getMonth() + (t.getFullYear() - e.getFullYear()) * 12, (e) => e.getMonth());
_d.range;
const Dd = Rt((e) => {
  e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCMonth(e.getUTCMonth() + t);
}, (e, t) => t.getUTCMonth() - e.getUTCMonth() + (t.getUTCFullYear() - e.getUTCFullYear()) * 12, (e) => e.getUTCMonth());
Dd.range;
const An = Rt((e) => {
  e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setFullYear(e.getFullYear() + t);
}, (e, t) => t.getFullYear() - e.getFullYear(), (e) => e.getFullYear());
An.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : Rt((t) => {
  t.setFullYear(Math.floor(t.getFullYear() / e) * e), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
}, (t, r) => {
  t.setFullYear(t.getFullYear() + r * e);
});
An.range;
const Mn = Rt((e) => {
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCFullYear(e.getUTCFullYear() + t);
}, (e, t) => t.getUTCFullYear() - e.getUTCFullYear(), (e) => e.getUTCFullYear());
Mn.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : Rt((t) => {
  t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
}, (t, r) => {
  t.setUTCFullYear(t.getUTCFullYear() + r * e);
});
Mn.range;
function Wg(e, t, r, n, a, i) {
  const o = [
    [_a, 1, Cn],
    [_a, 5, 5 * Cn],
    [_a, 15, 15 * Cn],
    [_a, 30, 30 * Cn],
    [i, 1, Ar],
    [i, 5, 5 * Ar],
    [i, 15, 15 * Ar],
    [i, 30, 30 * Ar],
    [a, 1, xn],
    [a, 3, 3 * xn],
    [a, 6, 6 * xn],
    [a, 12, 12 * xn],
    [n, 1, Dn],
    [n, 2, 2 * Dn],
    [r, 1, Od],
    [t, 1, u4],
    [t, 3, 3 * u4],
    [e, 1, w2]
  ];
  function s(c, u, f) {
    const p = u < c;
    p && ([c, u] = [u, c]);
    const h = f && typeof f.range == "function" ? f : l(c, u, f), m = h ? h.range(c, +u + 1) : [];
    return p ? m.reverse() : m;
  }
  function l(c, u, f) {
    const p = Math.abs(u - c) / f, h = fd(([, , g]) => g).right(o, p);
    if (h === o.length)
      return e.every(V3(c / w2, u / w2, f));
    if (h === 0)
      return I1.every(Math.max(V3(c, u, f), 1));
    const [m, v] = o[p / o[h - 1][2] < o[h][2] / p ? h - 1 : h];
    return m.every(v);
  }
  return [s, l];
}
const [RQ, kQ] = Wg(Mn, Dd, Jc, Fg, jd, Pd), [BQ, VQ] = Wg(An, _d, Qc, dl, Ed, Sd);
function O2(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(-1, e.m, e.d, e.H, e.M, e.S, e.L);
    return t.setFullYear(e.y), t;
  }
  return new Date(e.y, e.m, e.d, e.H, e.M, e.S, e.L);
}
function S2(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(Date.UTC(-1, e.m, e.d, e.H, e.M, e.S, e.L));
    return t.setUTCFullYear(e.y), t;
  }
  return new Date(Date.UTC(e.y, e.m, e.d, e.H, e.M, e.S, e.L));
}
function Po(e, t, r) {
  return { y: e, m: t, d: r, H: 0, M: 0, S: 0, L: 0 };
}
function HQ(e) {
  var t = e.dateTime, r = e.date, n = e.time, a = e.periods, i = e.days, o = e.shortDays, s = e.months, l = e.shortMonths, c = Eo(a), u = jo(a), f = Eo(i), p = jo(i), h = Eo(o), m = jo(o), v = Eo(s), g = jo(s), y = Eo(l), b = jo(l), w = {
    a: K,
    A: te,
    b: _,
    B: j,
    c: null,
    d: m4,
    e: m4,
    f: uJ,
    g: CJ,
    G: wJ,
    H: sJ,
    I: lJ,
    j: cJ,
    L: zg,
    m: fJ,
    M: dJ,
    p: T,
    q: A,
    Q: b4,
    s: C4,
    S: pJ,
    u: hJ,
    U: vJ,
    V: mJ,
    w: gJ,
    W: yJ,
    x: null,
    X: null,
    y: bJ,
    Y: xJ,
    Z: OJ,
    "%": y4
  }, x = {
    a: O,
    A: N,
    b: q,
    B: Y,
    c: null,
    d: g4,
    e: g4,
    f: jJ,
    g: RJ,
    G: BJ,
    H: SJ,
    I: PJ,
    j: EJ,
    L: Zg,
    m: _J,
    M: DJ,
    p: z,
    q: R,
    Q: b4,
    s: C4,
    S: AJ,
    u: MJ,
    U: TJ,
    V: $J,
    w: NJ,
    W: IJ,
    x: null,
    X: null,
    y: LJ,
    Y: kJ,
    Z: VJ,
    "%": y4
  }, C = {
    a: k,
    A: V,
    b: W,
    B: L,
    c: G,
    d: h4,
    e: h4,
    f: nJ,
    g: p4,
    G: d4,
    H: v4,
    I: v4,
    j: JQ,
    L: rJ,
    m: QQ,
    M: eJ,
    p: I,
    q: XQ,
    Q: iJ,
    s: oJ,
    S: tJ,
    u: ZQ,
    U: qQ,
    V: GQ,
    w: UQ,
    W: YQ,
    x: Q,
    X,
    y: p4,
    Y: d4,
    Z: KQ,
    "%": aJ
  };
  w.x = S(r, w), w.X = S(n, w), w.c = S(t, w), x.x = S(r, x), x.X = S(n, x), x.c = S(t, x);
  function S($, F) {
    return function(B) {
      var M = [], J = -1, H = 0, ee = $.length, ne, ae, se;
      for (B instanceof Date || (B = /* @__PURE__ */ new Date(+B)); ++J < ee; )
        $.charCodeAt(J) === 37 && (M.push($.slice(H, J)), (ae = f4[ne = $.charAt(++J)]) != null ? ne = $.charAt(++J) : ae = ne === "e" ? " " : "0", (se = F[ne]) && (ne = se(B, ae)), M.push(ne), H = J + 1);
      return M.push($.slice(H, J)), M.join("");
    };
  }
  function E($, F) {
    return function(B) {
      var M = Po(1900, void 0, 1), J = D(M, $, B += "", 0), H, ee;
      if (J != B.length)
        return null;
      if ("Q" in M)
        return new Date(M.Q);
      if ("s" in M)
        return new Date(M.s * 1e3 + ("L" in M ? M.L : 0));
      if (F && !("Z" in M) && (M.Z = 0), "p" in M && (M.H = M.H % 12 + M.p * 12), M.m === void 0 && (M.m = "q" in M ? M.q : 0), "V" in M) {
        if (M.V < 1 || M.V > 53)
          return null;
        "w" in M || (M.w = 1), "Z" in M ? (H = S2(Po(M.y, 0, 1)), ee = H.getUTCDay(), H = ee > 4 || ee === 0 ? R1.ceil(H) : R1(H), H = Xc.offset(H, (M.V - 1) * 7), M.y = H.getUTCFullYear(), M.m = H.getUTCMonth(), M.d = H.getUTCDate() + (M.w + 6) % 7) : (H = O2(Po(M.y, 0, 1)), ee = H.getDay(), H = ee > 4 || ee === 0 ? L1.ceil(H) : L1(H), H = dl.offset(H, (M.V - 1) * 7), M.y = H.getFullYear(), M.m = H.getMonth(), M.d = H.getDate() + (M.w + 6) % 7);
      } else
        ("W" in M || "U" in M) && ("w" in M || (M.w = "u" in M ? M.u % 7 : "W" in M ? 1 : 0), ee = "Z" in M ? S2(Po(M.y, 0, 1)).getUTCDay() : O2(Po(M.y, 0, 1)).getDay(), M.m = 0, M.d = "W" in M ? (M.w + 6) % 7 + M.W * 7 - (ee + 5) % 7 : M.w + M.U * 7 - (ee + 6) % 7);
      return "Z" in M ? (M.H += M.Z / 100 | 0, M.M += M.Z % 100, S2(M)) : O2(M);
    };
  }
  function D($, F, B, M) {
    for (var J = 0, H = F.length, ee = B.length, ne, ae; J < H; ) {
      if (M >= ee)
        return -1;
      if (ne = F.charCodeAt(J++), ne === 37) {
        if (ne = F.charAt(J++), ae = C[ne in f4 ? F.charAt(J++) : ne], !ae || (M = ae($, B, M)) < 0)
          return -1;
      } else if (ne != B.charCodeAt(M++))
        return -1;
    }
    return M;
  }
  function I($, F, B) {
    var M = c.exec(F.slice(B));
    return M ? ($.p = u.get(M[0].toLowerCase()), B + M[0].length) : -1;
  }
  function k($, F, B) {
    var M = h.exec(F.slice(B));
    return M ? ($.w = m.get(M[0].toLowerCase()), B + M[0].length) : -1;
  }
  function V($, F, B) {
    var M = f.exec(F.slice(B));
    return M ? ($.w = p.get(M[0].toLowerCase()), B + M[0].length) : -1;
  }
  function W($, F, B) {
    var M = y.exec(F.slice(B));
    return M ? ($.m = b.get(M[0].toLowerCase()), B + M[0].length) : -1;
  }
  function L($, F, B) {
    var M = v.exec(F.slice(B));
    return M ? ($.m = g.get(M[0].toLowerCase()), B + M[0].length) : -1;
  }
  function G($, F, B) {
    return D($, t, F, B);
  }
  function Q($, F, B) {
    return D($, r, F, B);
  }
  function X($, F, B) {
    return D($, n, F, B);
  }
  function K($) {
    return o[$.getDay()];
  }
  function te($) {
    return i[$.getDay()];
  }
  function _($) {
    return l[$.getMonth()];
  }
  function j($) {
    return s[$.getMonth()];
  }
  function T($) {
    return a[+($.getHours() >= 12)];
  }
  function A($) {
    return 1 + ~~($.getMonth() / 3);
  }
  function O($) {
    return o[$.getUTCDay()];
  }
  function N($) {
    return i[$.getUTCDay()];
  }
  function q($) {
    return l[$.getUTCMonth()];
  }
  function Y($) {
    return s[$.getUTCMonth()];
  }
  function z($) {
    return a[+($.getUTCHours() >= 12)];
  }
  function R($) {
    return 1 + ~~($.getUTCMonth() / 3);
  }
  return {
    format: function($) {
      var F = S($ += "", w);
      return F.toString = function() {
        return $;
      }, F;
    },
    parse: function($) {
      var F = E($ += "", !1);
      return F.toString = function() {
        return $;
      }, F;
    },
    utcFormat: function($) {
      var F = S($ += "", x);
      return F.toString = function() {
        return $;
      }, F;
    },
    utcParse: function($) {
      var F = E($ += "", !0);
      return F.toString = function() {
        return $;
      }, F;
    }
  };
}
var f4 = { "-": "", _: " ", 0: "0" }, Ft = /^\s*\d+/, FQ = /^%/, WQ = /[\\^$*+?|[\]().{}]/g;
function Fe(e, t, r) {
  var n = e < 0 ? "-" : "", a = (n ? -e : e) + "", i = a.length;
  return n + (i < r ? new Array(r - i + 1).join(t) + a : a);
}
function zQ(e) {
  return e.replace(WQ, "\\$&");
}
function Eo(e) {
  return new RegExp("^(?:" + e.map(zQ).join("|") + ")", "i");
}
function jo(e) {
  return new Map(e.map((t, r) => [t.toLowerCase(), r]));
}
function UQ(e, t, r) {
  var n = Ft.exec(t.slice(r, r + 1));
  return n ? (e.w = +n[0], r + n[0].length) : -1;
}
function ZQ(e, t, r) {
  var n = Ft.exec(t.slice(r, r + 1));
  return n ? (e.u = +n[0], r + n[0].length) : -1;
}
function qQ(e, t, r) {
  var n = Ft.exec(t.slice(r, r + 2));
  return n ? (e.U = +n[0], r + n[0].length) : -1;
}
function GQ(e, t, r) {
  var n = Ft.exec(t.slice(r, r + 2));
  return n ? (e.V = +n[0], r + n[0].length) : -1;
}
function YQ(e, t, r) {
  var n = Ft.exec(t.slice(r, r + 2));
  return n ? (e.W = +n[0], r + n[0].length) : -1;
}
function d4(e, t, r) {
  var n = Ft.exec(t.slice(r, r + 4));
  return n ? (e.y = +n[0], r + n[0].length) : -1;
}
function p4(e, t, r) {
  var n = Ft.exec(t.slice(r, r + 2));
  return n ? (e.y = +n[0] + (+n[0] > 68 ? 1900 : 2e3), r + n[0].length) : -1;
}
function KQ(e, t, r) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(r, r + 6));
  return n ? (e.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), r + n[0].length) : -1;
}
function XQ(e, t, r) {
  var n = Ft.exec(t.slice(r, r + 1));
  return n ? (e.q = n[0] * 3 - 3, r + n[0].length) : -1;
}
function QQ(e, t, r) {
  var n = Ft.exec(t.slice(r, r + 2));
  return n ? (e.m = n[0] - 1, r + n[0].length) : -1;
}
function h4(e, t, r) {
  var n = Ft.exec(t.slice(r, r + 2));
  return n ? (e.d = +n[0], r + n[0].length) : -1;
}
function JQ(e, t, r) {
  var n = Ft.exec(t.slice(r, r + 3));
  return n ? (e.m = 0, e.d = +n[0], r + n[0].length) : -1;
}
function v4(e, t, r) {
  var n = Ft.exec(t.slice(r, r + 2));
  return n ? (e.H = +n[0], r + n[0].length) : -1;
}
function eJ(e, t, r) {
  var n = Ft.exec(t.slice(r, r + 2));
  return n ? (e.M = +n[0], r + n[0].length) : -1;
}
function tJ(e, t, r) {
  var n = Ft.exec(t.slice(r, r + 2));
  return n ? (e.S = +n[0], r + n[0].length) : -1;
}
function rJ(e, t, r) {
  var n = Ft.exec(t.slice(r, r + 3));
  return n ? (e.L = +n[0], r + n[0].length) : -1;
}
function nJ(e, t, r) {
  var n = Ft.exec(t.slice(r, r + 6));
  return n ? (e.L = Math.floor(n[0] / 1e3), r + n[0].length) : -1;
}
function aJ(e, t, r) {
  var n = FQ.exec(t.slice(r, r + 1));
  return n ? r + n[0].length : -1;
}
function iJ(e, t, r) {
  var n = Ft.exec(t.slice(r));
  return n ? (e.Q = +n[0], r + n[0].length) : -1;
}
function oJ(e, t, r) {
  var n = Ft.exec(t.slice(r));
  return n ? (e.s = +n[0], r + n[0].length) : -1;
}
function m4(e, t) {
  return Fe(e.getDate(), t, 2);
}
function sJ(e, t) {
  return Fe(e.getHours(), t, 2);
}
function lJ(e, t) {
  return Fe(e.getHours() % 12 || 12, t, 2);
}
function cJ(e, t) {
  return Fe(1 + dl.count(An(e), e), t, 3);
}
function zg(e, t) {
  return Fe(e.getMilliseconds(), t, 3);
}
function uJ(e, t) {
  return zg(e, t) + "000";
}
function fJ(e, t) {
  return Fe(e.getMonth() + 1, t, 2);
}
function dJ(e, t) {
  return Fe(e.getMinutes(), t, 2);
}
function pJ(e, t) {
  return Fe(e.getSeconds(), t, 2);
}
function hJ(e) {
  var t = e.getDay();
  return t === 0 ? 7 : t;
}
function vJ(e, t) {
  return Fe(Qc.count(An(e) - 1, e), t, 2);
}
function Ug(e) {
  var t = e.getDay();
  return t >= 4 || t === 0 ? Ei(e) : Ei.ceil(e);
}
function mJ(e, t) {
  return e = Ug(e), Fe(Ei.count(An(e), e) + (An(e).getDay() === 4), t, 2);
}
function gJ(e) {
  return e.getDay();
}
function yJ(e, t) {
  return Fe(L1.count(An(e) - 1, e), t, 2);
}
function bJ(e, t) {
  return Fe(e.getFullYear() % 100, t, 2);
}
function CJ(e, t) {
  return e = Ug(e), Fe(e.getFullYear() % 100, t, 2);
}
function xJ(e, t) {
  return Fe(e.getFullYear() % 1e4, t, 4);
}
function wJ(e, t) {
  var r = e.getDay();
  return e = r >= 4 || r === 0 ? Ei(e) : Ei.ceil(e), Fe(e.getFullYear() % 1e4, t, 4);
}
function OJ(e) {
  var t = e.getTimezoneOffset();
  return (t > 0 ? "-" : (t *= -1, "+")) + Fe(t / 60 | 0, "0", 2) + Fe(t % 60, "0", 2);
}
function g4(e, t) {
  return Fe(e.getUTCDate(), t, 2);
}
function SJ(e, t) {
  return Fe(e.getUTCHours(), t, 2);
}
function PJ(e, t) {
  return Fe(e.getUTCHours() % 12 || 12, t, 2);
}
function EJ(e, t) {
  return Fe(1 + Xc.count(Mn(e), e), t, 3);
}
function Zg(e, t) {
  return Fe(e.getUTCMilliseconds(), t, 3);
}
function jJ(e, t) {
  return Zg(e, t) + "000";
}
function _J(e, t) {
  return Fe(e.getUTCMonth() + 1, t, 2);
}
function DJ(e, t) {
  return Fe(e.getUTCMinutes(), t, 2);
}
function AJ(e, t) {
  return Fe(e.getUTCSeconds(), t, 2);
}
function MJ(e) {
  var t = e.getUTCDay();
  return t === 0 ? 7 : t;
}
function TJ(e, t) {
  return Fe(Jc.count(Mn(e) - 1, e), t, 2);
}
function qg(e) {
  var t = e.getUTCDay();
  return t >= 4 || t === 0 ? ji(e) : ji.ceil(e);
}
function $J(e, t) {
  return e = qg(e), Fe(ji.count(Mn(e), e) + (Mn(e).getUTCDay() === 4), t, 2);
}
function NJ(e) {
  return e.getUTCDay();
}
function IJ(e, t) {
  return Fe(R1.count(Mn(e) - 1, e), t, 2);
}
function LJ(e, t) {
  return Fe(e.getUTCFullYear() % 100, t, 2);
}
function RJ(e, t) {
  return e = qg(e), Fe(e.getUTCFullYear() % 100, t, 2);
}
function kJ(e, t) {
  return Fe(e.getUTCFullYear() % 1e4, t, 4);
}
function BJ(e, t) {
  var r = e.getUTCDay();
  return e = r >= 4 || r === 0 ? ji(e) : ji.ceil(e), Fe(e.getUTCFullYear() % 1e4, t, 4);
}
function VJ() {
  return "+0000";
}
function y4() {
  return "%";
}
function b4(e) {
  return +e;
}
function C4(e) {
  return Math.floor(+e / 1e3);
}
var ei, Gg, Yg;
HJ({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function HJ(e) {
  return ei = HQ(e), Gg = ei.format, ei.parse, Yg = ei.utcFormat, ei.utcParse, ei;
}
function FJ(e) {
  return new Date(e);
}
function WJ(e) {
  return e instanceof Date ? +e : +/* @__PURE__ */ new Date(+e);
}
function Ad(e, t, r, n, a, i, o, s, l, c) {
  var u = md(), f = u.invert, p = u.domain, h = c(".%L"), m = c(":%S"), v = c("%I:%M"), g = c("%I %p"), y = c("%a %d"), b = c("%b %d"), w = c("%B"), x = c("%Y");
  function C(S) {
    return (l(S) < S ? h : s(S) < S ? m : o(S) < S ? v : i(S) < S ? g : n(S) < S ? a(S) < S ? y : b : r(S) < S ? w : x)(S);
  }
  return u.invert = function(S) {
    return new Date(f(S));
  }, u.domain = function(S) {
    return arguments.length ? p(Array.from(S, WJ)) : p().map(FJ);
  }, u.ticks = function(S) {
    var E = p();
    return e(E[0], E[E.length - 1], S ?? 10);
  }, u.tickFormat = function(S, E) {
    return E == null ? C : c(E);
  }, u.nice = function(S) {
    var E = p();
    return (!S || typeof S.range != "function") && (S = t(E[0], E[E.length - 1], S ?? 10)), S ? p(Ig(E, S)) : u;
  }, u.copy = function() {
    return fl(u, Ad(e, t, r, n, a, i, o, s, l, c));
  }, u;
}
function zJ() {
  return Rr.apply(Ad(BQ, VQ, An, _d, Qc, dl, Ed, Sd, _a, Gg).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function UJ() {
  return Rr.apply(Ad(RQ, kQ, Mn, Dd, Jc, Xc, jd, Pd, _a, Yg).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
function eu() {
  var e = 0, t = 1, r, n, a, i, o = tr, s = !1, l;
  function c(f) {
    return f == null || isNaN(f = +f) ? l : o(a === 0 ? 0.5 : (f = (i(f) - r) * a, s ? Math.max(0, Math.min(1, f)) : f));
  }
  c.domain = function(f) {
    return arguments.length ? ([e, t] = f, r = i(e = +e), n = i(t = +t), a = r === n ? 0 : 1 / (n - r), c) : [e, t];
  }, c.clamp = function(f) {
    return arguments.length ? (s = !!f, c) : s;
  }, c.interpolator = function(f) {
    return arguments.length ? (o = f, c) : o;
  };
  function u(f) {
    return function(p) {
      var h, m;
      return arguments.length ? ([h, m] = p, o = f(h, m), c) : [o(0), o(1)];
    };
  }
  return c.range = u(lo), c.rangeRound = u(vd), c.unknown = function(f) {
    return arguments.length ? (l = f, c) : l;
  }, function(f) {
    return i = f, r = f(e), n = f(t), a = r === n ? 0 : 1 / (n - r), c;
  };
}
function la(e, t) {
  return t.domain(e.domain()).interpolator(e.interpolator()).clamp(e.clamp()).unknown(e.unknown());
}
function Kg() {
  var e = sa(eu()(tr));
  return e.copy = function() {
    return la(e, Kg());
  }, In.apply(e, arguments);
}
function Xg() {
  var e = bd(eu()).domain([1, 10]);
  return e.copy = function() {
    return la(e, Xg()).base(e.base());
  }, In.apply(e, arguments);
}
function Qg() {
  var e = Cd(eu());
  return e.copy = function() {
    return la(e, Qg()).constant(e.constant());
  }, In.apply(e, arguments);
}
function Md() {
  var e = xd(eu());
  return e.copy = function() {
    return la(e, Md()).exponent(e.exponent());
  }, In.apply(e, arguments);
}
function ZJ() {
  return Md.apply(null, arguments).exponent(0.5);
}
function Jg() {
  var e = [], t = tr;
  function r(n) {
    if (n != null && !isNaN(n = +n))
      return t((cl(e, n, 1) - 1) / (e.length - 1));
  }
  return r.domain = function(n) {
    if (!arguments.length)
      return e.slice();
    e = [];
    for (let a of n)
      a != null && !isNaN(a = +a) && e.push(a);
    return e.sort(Zn), r;
  }, r.interpolator = function(n) {
    return arguments.length ? (t = n, r) : t;
  }, r.range = function() {
    return e.map((n, a) => t(a / (e.length - 1)));
  }, r.quantiles = function(n) {
    return Array.from({ length: n + 1 }, (a, i) => TX(e, i / n));
  }, r.copy = function() {
    return Jg(t).domain(e);
  }, In.apply(r, arguments);
}
function tu() {
  var e = 0, t = 0.5, r = 1, n = 1, a, i, o, s, l, c = tr, u, f = !1, p;
  function h(v) {
    return isNaN(v = +v) ? p : (v = 0.5 + ((v = +u(v)) - i) * (n * v < n * i ? s : l), c(f ? Math.max(0, Math.min(1, v)) : v));
  }
  h.domain = function(v) {
    return arguments.length ? ([e, t, r] = v, a = u(e = +e), i = u(t = +t), o = u(r = +r), s = a === i ? 0 : 0.5 / (i - a), l = i === o ? 0 : 0.5 / (o - i), n = i < a ? -1 : 1, h) : [e, t, r];
  }, h.clamp = function(v) {
    return arguments.length ? (f = !!v, h) : f;
  }, h.interpolator = function(v) {
    return arguments.length ? (c = v, h) : c;
  };
  function m(v) {
    return function(g) {
      var y, b, w;
      return arguments.length ? ([y, b, w] = g, c = aQ(v, [y, b, w]), h) : [c(0), c(0.5), c(1)];
    };
  }
  return h.range = m(lo), h.rangeRound = m(vd), h.unknown = function(v) {
    return arguments.length ? (p = v, h) : p;
  }, function(v) {
    return u = v, a = v(e), i = v(t), o = v(r), s = a === i ? 0 : 0.5 / (i - a), l = i === o ? 0 : 0.5 / (o - i), n = i < a ? -1 : 1, h;
  };
}
function ey() {
  var e = sa(tu()(tr));
  return e.copy = function() {
    return la(e, ey());
  }, In.apply(e, arguments);
}
function ty() {
  var e = bd(tu()).domain([0.1, 1, 10]);
  return e.copy = function() {
    return la(e, ty()).base(e.base());
  }, In.apply(e, arguments);
}
function ry() {
  var e = Cd(tu());
  return e.copy = function() {
    return la(e, ry()).constant(e.constant());
  }, In.apply(e, arguments);
}
function Td() {
  var e = xd(tu());
  return e.copy = function() {
    return la(e, Td()).exponent(e.exponent());
  }, In.apply(e, arguments);
}
function qJ() {
  return Td.apply(null, arguments).exponent(0.5);
}
const x4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  scaleBand: Cs,
  scaleDiverging: ey,
  scaleDivergingLog: ty,
  scaleDivergingPow: Td,
  scaleDivergingSqrt: qJ,
  scaleDivergingSymlog: ry,
  scaleIdentity: Ng,
  scaleImplicit: H3,
  scaleLinear: N1,
  scaleLog: Lg,
  scaleOrdinal: dd,
  scalePoint: Yo,
  scalePow: wd,
  scaleQuantile: Bg,
  scaleQuantize: Vg,
  scaleRadial: kg,
  scaleSequential: Kg,
  scaleSequentialLog: Xg,
  scaleSequentialPow: Md,
  scaleSequentialQuantile: Jg,
  scaleSequentialSqrt: ZJ,
  scaleSequentialSymlog: Qg,
  scaleSqrt: jQ,
  scaleSymlog: Rg,
  scaleThreshold: Hg,
  scaleTime: zJ,
  scaleUtc: UJ,
  tickFormat: $g
}, Symbol.toStringTag, { value: "Module" }));
var GJ = Ji;
function YJ(e, t, r) {
  for (var n = -1, a = e.length; ++n < a; ) {
    var i = e[n], o = t(i);
    if (o != null && (s === void 0 ? o === o && !GJ(o) : r(o, s)))
      var s = o, l = i;
  }
  return l;
}
var ru = YJ;
function KJ(e, t) {
  return e > t;
}
var ny = KJ, XJ = ru, QJ = ny, JJ = so;
function eee(e) {
  return e && e.length ? XJ(e, JJ, QJ) : void 0;
}
var tee = eee;
const Vn = /* @__PURE__ */ Je(tee);
function ree(e, t) {
  return e < t;
}
var ay = ree, nee = ru, aee = ay, iee = so;
function oee(e) {
  return e && e.length ? nee(e, iee, aee) : void 0;
}
var see = oee;
const nu = /* @__PURE__ */ Je(see);
var lee = Yf, cee = pn, uee = dg, fee = cr;
function dee(e, t) {
  var r = fee(e) ? lee : uee;
  return r(e, cee(t));
}
var pee = dee, hee = ug, vee = pee;
function mee(e, t) {
  return hee(vee(e, t), 1);
}
var gee = mee;
const yee = /* @__PURE__ */ Je(gee);
var bee = sd;
function Cee(e, t) {
  return bee(e, t);
}
var xee = Cee;
const Xn = /* @__PURE__ */ Je(xee);
var co = 1e9, wee = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed during run-time using `Decimal.config`.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
  // `toFixed`, `toPrecision` and `toSignificantDigits`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -MAX_E
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to MAX_E
  // The natural logarithm of 10.
  // 115 digits
  LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
}, Nd, gt = !0, $r = "[DecimalError] ", $a = $r + "Invalid argument: ", $d = $r + "Exponent out of range: ", uo = Math.floor, Oa = Math.pow, Oee = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, hr, Bt = 1e7, ht = 7, iy = 9007199254740991, k1 = uo(iy / ht), fe = {};
fe.absoluteValue = fe.abs = function() {
  var e = new this.constructor(this);
  return e.s && (e.s = 1), e;
};
fe.comparedTo = fe.cmp = function(e) {
  var t, r, n, a, i = this;
  if (e = new i.constructor(e), i.s !== e.s)
    return i.s || -e.s;
  if (i.e !== e.e)
    return i.e > e.e ^ i.s < 0 ? 1 : -1;
  for (n = i.d.length, a = e.d.length, t = 0, r = n < a ? n : a; t < r; ++t)
    if (i.d[t] !== e.d[t])
      return i.d[t] > e.d[t] ^ i.s < 0 ? 1 : -1;
  return n === a ? 0 : n > a ^ i.s < 0 ? 1 : -1;
};
fe.decimalPlaces = fe.dp = function() {
  var e = this, t = e.d.length - 1, r = (t - e.e) * ht;
  if (t = e.d[t], t)
    for (; t % 10 == 0; t /= 10)
      r--;
  return r < 0 ? 0 : r;
};
fe.dividedBy = fe.div = function(e) {
  return jn(this, new this.constructor(e));
};
fe.dividedToIntegerBy = fe.idiv = function(e) {
  var t = this, r = t.constructor;
  return lt(jn(t, new r(e), 0, 1), r.precision);
};
fe.equals = fe.eq = function(e) {
  return !this.cmp(e);
};
fe.exponent = function() {
  return Mt(this);
};
fe.greaterThan = fe.gt = function(e) {
  return this.cmp(e) > 0;
};
fe.greaterThanOrEqualTo = fe.gte = function(e) {
  return this.cmp(e) >= 0;
};
fe.isInteger = fe.isint = function() {
  return this.e > this.d.length - 2;
};
fe.isNegative = fe.isneg = function() {
  return this.s < 0;
};
fe.isPositive = fe.ispos = function() {
  return this.s > 0;
};
fe.isZero = function() {
  return this.s === 0;
};
fe.lessThan = fe.lt = function(e) {
  return this.cmp(e) < 0;
};
fe.lessThanOrEqualTo = fe.lte = function(e) {
  return this.cmp(e) < 1;
};
fe.logarithm = fe.log = function(e) {
  var t, r = this, n = r.constructor, a = n.precision, i = a + 5;
  if (e === void 0)
    e = new n(10);
  else if (e = new n(e), e.s < 1 || e.eq(hr))
    throw Error($r + "NaN");
  if (r.s < 1)
    throw Error($r + (r.s ? "NaN" : "-Infinity"));
  return r.eq(hr) ? new n(0) : (gt = !1, t = jn(Ps(r, i), Ps(e, i), i), gt = !0, lt(t, a));
};
fe.minus = fe.sub = function(e) {
  var t = this;
  return e = new t.constructor(e), t.s == e.s ? ly(t, e) : oy(t, (e.s = -e.s, e));
};
fe.modulo = fe.mod = function(e) {
  var t, r = this, n = r.constructor, a = n.precision;
  if (e = new n(e), !e.s)
    throw Error($r + "NaN");
  return r.s ? (gt = !1, t = jn(r, e, 0, 1).times(e), gt = !0, r.minus(t)) : lt(new n(r), a);
};
fe.naturalExponential = fe.exp = function() {
  return sy(this);
};
fe.naturalLogarithm = fe.ln = function() {
  return Ps(this);
};
fe.negated = fe.neg = function() {
  var e = new this.constructor(this);
  return e.s = -e.s || 0, e;
};
fe.plus = fe.add = function(e) {
  var t = this;
  return e = new t.constructor(e), t.s == e.s ? oy(t, e) : ly(t, (e.s = -e.s, e));
};
fe.precision = fe.sd = function(e) {
  var t, r, n, a = this;
  if (e !== void 0 && e !== !!e && e !== 1 && e !== 0)
    throw Error($a + e);
  if (t = Mt(a) + 1, n = a.d.length - 1, r = n * ht + 1, n = a.d[n], n) {
    for (; n % 10 == 0; n /= 10)
      r--;
    for (n = a.d[0]; n >= 10; n /= 10)
      r++;
  }
  return e && t > r ? t : r;
};
fe.squareRoot = fe.sqrt = function() {
  var e, t, r, n, a, i, o, s = this, l = s.constructor;
  if (s.s < 1) {
    if (!s.s)
      return new l(0);
    throw Error($r + "NaN");
  }
  for (e = Mt(s), gt = !1, a = Math.sqrt(+s), a == 0 || a == 1 / 0 ? (t = rn(s.d), (t.length + e) % 2 == 0 && (t += "0"), a = Math.sqrt(t), e = uo((e + 1) / 2) - (e < 0 || e % 2), a == 1 / 0 ? t = "5e" + e : (t = a.toExponential(), t = t.slice(0, t.indexOf("e") + 1) + e), n = new l(t)) : n = new l(a.toString()), r = l.precision, a = o = r + 3; ; )
    if (i = n, n = i.plus(jn(s, i, o + 2)).times(0.5), rn(i.d).slice(0, o) === (t = rn(n.d)).slice(0, o)) {
      if (t = t.slice(o - 3, o + 1), a == o && t == "4999") {
        if (lt(i, r + 1, 0), i.times(i).eq(s)) {
          n = i;
          break;
        }
      } else if (t != "9999")
        break;
      o += 4;
    }
  return gt = !0, lt(n, r);
};
fe.times = fe.mul = function(e) {
  var t, r, n, a, i, o, s, l, c, u = this, f = u.constructor, p = u.d, h = (e = new f(e)).d;
  if (!u.s || !e.s)
    return new f(0);
  for (e.s *= u.s, r = u.e + e.e, l = p.length, c = h.length, l < c && (i = p, p = h, h = i, o = l, l = c, c = o), i = [], o = l + c, n = o; n--; )
    i.push(0);
  for (n = c; --n >= 0; ) {
    for (t = 0, a = l + n; a > n; )
      s = i[a] + h[n] * p[a - n - 1] + t, i[a--] = s % Bt | 0, t = s / Bt | 0;
    i[a] = (i[a] + t) % Bt | 0;
  }
  for (; !i[--o]; )
    i.pop();
  return t ? ++r : i.shift(), e.d = i, e.e = r, gt ? lt(e, f.precision) : e;
};
fe.toDecimalPlaces = fe.todp = function(e, t) {
  var r = this, n = r.constructor;
  return r = new n(r), e === void 0 ? r : (ln(e, 0, co), t === void 0 ? t = n.rounding : ln(t, 0, 8), lt(r, e + Mt(r) + 1, t));
};
fe.toExponential = function(e, t) {
  var r, n = this, a = n.constructor;
  return e === void 0 ? r = Ra(n, !0) : (ln(e, 0, co), t === void 0 ? t = a.rounding : ln(t, 0, 8), n = lt(new a(n), e + 1, t), r = Ra(n, !0, e + 1)), r;
};
fe.toFixed = function(e, t) {
  var r, n, a = this, i = a.constructor;
  return e === void 0 ? Ra(a) : (ln(e, 0, co), t === void 0 ? t = i.rounding : ln(t, 0, 8), n = lt(new i(a), e + Mt(a) + 1, t), r = Ra(n.abs(), !1, e + Mt(n) + 1), a.isneg() && !a.isZero() ? "-" + r : r);
};
fe.toInteger = fe.toint = function() {
  var e = this, t = e.constructor;
  return lt(new t(e), Mt(e) + 1, t.rounding);
};
fe.toNumber = function() {
  return +this;
};
fe.toPower = fe.pow = function(e) {
  var t, r, n, a, i, o, s = this, l = s.constructor, c = 12, u = +(e = new l(e));
  if (!e.s)
    return new l(hr);
  if (s = new l(s), !s.s) {
    if (e.s < 1)
      throw Error($r + "Infinity");
    return s;
  }
  if (s.eq(hr))
    return s;
  if (n = l.precision, e.eq(hr))
    return lt(s, n);
  if (t = e.e, r = e.d.length - 1, o = t >= r, i = s.s, o) {
    if ((r = u < 0 ? -u : u) <= iy) {
      for (a = new l(hr), t = Math.ceil(n / ht + 4), gt = !1; r % 2 && (a = a.times(s), O4(a.d, t)), r = uo(r / 2), r !== 0; )
        s = s.times(s), O4(s.d, t);
      return gt = !0, e.s < 0 ? new l(hr).div(a) : lt(a, n);
    }
  } else if (i < 0)
    throw Error($r + "NaN");
  return i = i < 0 && e.d[Math.max(t, r)] & 1 ? -1 : 1, s.s = 1, gt = !1, a = e.times(Ps(s, n + c)), gt = !0, a = sy(a), a.s = i, a;
};
fe.toPrecision = function(e, t) {
  var r, n, a = this, i = a.constructor;
  return e === void 0 ? (r = Mt(a), n = Ra(a, r <= i.toExpNeg || r >= i.toExpPos)) : (ln(e, 1, co), t === void 0 ? t = i.rounding : ln(t, 0, 8), a = lt(new i(a), e, t), r = Mt(a), n = Ra(a, e <= r || r <= i.toExpNeg, e)), n;
};
fe.toSignificantDigits = fe.tosd = function(e, t) {
  var r = this, n = r.constructor;
  return e === void 0 ? (e = n.precision, t = n.rounding) : (ln(e, 1, co), t === void 0 ? t = n.rounding : ln(t, 0, 8)), lt(new n(r), e, t);
};
fe.toString = fe.valueOf = fe.val = fe.toJSON = fe[Symbol.for("nodejs.util.inspect.custom")] = function() {
  var e = this, t = Mt(e), r = e.constructor;
  return Ra(e, t <= r.toExpNeg || t >= r.toExpPos);
};
function oy(e, t) {
  var r, n, a, i, o, s, l, c, u = e.constructor, f = u.precision;
  if (!e.s || !t.s)
    return t.s || (t = new u(e)), gt ? lt(t, f) : t;
  if (l = e.d, c = t.d, o = e.e, a = t.e, l = l.slice(), i = o - a, i) {
    for (i < 0 ? (n = l, i = -i, s = c.length) : (n = c, a = o, s = l.length), o = Math.ceil(f / ht), s = o > s ? o + 1 : s + 1, i > s && (i = s, n.length = 1), n.reverse(); i--; )
      n.push(0);
    n.reverse();
  }
  for (s = l.length, i = c.length, s - i < 0 && (i = s, n = c, c = l, l = n), r = 0; i; )
    r = (l[--i] = l[i] + c[i] + r) / Bt | 0, l[i] %= Bt;
  for (r && (l.unshift(r), ++a), s = l.length; l[--s] == 0; )
    l.pop();
  return t.d = l, t.e = a, gt ? lt(t, f) : t;
}
function ln(e, t, r) {
  if (e !== ~~e || e < t || e > r)
    throw Error($a + e);
}
function rn(e) {
  var t, r, n, a = e.length - 1, i = "", o = e[0];
  if (a > 0) {
    for (i += o, t = 1; t < a; t++)
      n = e[t] + "", r = ht - n.length, r && (i += kn(r)), i += n;
    o = e[t], n = o + "", r = ht - n.length, r && (i += kn(r));
  } else if (o === 0)
    return "0";
  for (; o % 10 === 0; )
    o /= 10;
  return i + o;
}
var jn = function() {
  function e(n, a) {
    var i, o = 0, s = n.length;
    for (n = n.slice(); s--; )
      i = n[s] * a + o, n[s] = i % Bt | 0, o = i / Bt | 0;
    return o && n.unshift(o), n;
  }
  function t(n, a, i, o) {
    var s, l;
    if (i != o)
      l = i > o ? 1 : -1;
    else
      for (s = l = 0; s < i; s++)
        if (n[s] != a[s]) {
          l = n[s] > a[s] ? 1 : -1;
          break;
        }
    return l;
  }
  function r(n, a, i) {
    for (var o = 0; i--; )
      n[i] -= o, o = n[i] < a[i] ? 1 : 0, n[i] = o * Bt + n[i] - a[i];
    for (; !n[0] && n.length > 1; )
      n.shift();
  }
  return function(n, a, i, o) {
    var s, l, c, u, f, p, h, m, v, g, y, b, w, x, C, S, E, D, I = n.constructor, k = n.s == a.s ? 1 : -1, V = n.d, W = a.d;
    if (!n.s)
      return new I(n);
    if (!a.s)
      throw Error($r + "Division by zero");
    for (l = n.e - a.e, E = W.length, C = V.length, h = new I(k), m = h.d = [], c = 0; W[c] == (V[c] || 0); )
      ++c;
    if (W[c] > (V[c] || 0) && --l, i == null ? b = i = I.precision : o ? b = i + (Mt(n) - Mt(a)) + 1 : b = i, b < 0)
      return new I(0);
    if (b = b / ht + 2 | 0, c = 0, E == 1)
      for (u = 0, W = W[0], b++; (c < C || u) && b--; c++)
        w = u * Bt + (V[c] || 0), m[c] = w / W | 0, u = w % W | 0;
    else {
      for (u = Bt / (W[0] + 1) | 0, u > 1 && (W = e(W, u), V = e(V, u), E = W.length, C = V.length), x = E, v = V.slice(0, E), g = v.length; g < E; )
        v[g++] = 0;
      D = W.slice(), D.unshift(0), S = W[0], W[1] >= Bt / 2 && ++S;
      do
        u = 0, s = t(W, v, E, g), s < 0 ? (y = v[0], E != g && (y = y * Bt + (v[1] || 0)), u = y / S | 0, u > 1 ? (u >= Bt && (u = Bt - 1), f = e(W, u), p = f.length, g = v.length, s = t(f, v, p, g), s == 1 && (u--, r(f, E < p ? D : W, p))) : (u == 0 && (s = u = 1), f = W.slice()), p = f.length, p < g && f.unshift(0), r(v, f, g), s == -1 && (g = v.length, s = t(W, v, E, g), s < 1 && (u++, r(v, E < g ? D : W, g))), g = v.length) : s === 0 && (u++, v = [0]), m[c++] = u, s && v[0] ? v[g++] = V[x] || 0 : (v = [V[x]], g = 1);
      while ((x++ < C || v[0] !== void 0) && b--);
    }
    return m[0] || m.shift(), h.e = l, lt(h, o ? i + Mt(h) + 1 : i);
  };
}();
function sy(e, t) {
  var r, n, a, i, o, s, l = 0, c = 0, u = e.constructor, f = u.precision;
  if (Mt(e) > 16)
    throw Error($d + Mt(e));
  if (!e.s)
    return new u(hr);
  for (t == null ? (gt = !1, s = f) : s = t, o = new u(0.03125); e.abs().gte(0.1); )
    e = e.times(o), c += 5;
  for (n = Math.log(Oa(2, c)) / Math.LN10 * 2 + 5 | 0, s += n, r = a = i = new u(hr), u.precision = s; ; ) {
    if (a = lt(a.times(e), s), r = r.times(++l), o = i.plus(jn(a, r, s)), rn(o.d).slice(0, s) === rn(i.d).slice(0, s)) {
      for (; c--; )
        i = lt(i.times(i), s);
      return u.precision = f, t == null ? (gt = !0, lt(i, f)) : i;
    }
    i = o;
  }
}
function Mt(e) {
  for (var t = e.e * ht, r = e.d[0]; r >= 10; r /= 10)
    t++;
  return t;
}
function P2(e, t, r) {
  if (t > e.LN10.sd())
    throw gt = !0, r && (e.precision = r), Error($r + "LN10 precision limit exceeded");
  return lt(new e(e.LN10), t);
}
function kn(e) {
  for (var t = ""; e--; )
    t += "0";
  return t;
}
function Ps(e, t) {
  var r, n, a, i, o, s, l, c, u, f = 1, p = 10, h = e, m = h.d, v = h.constructor, g = v.precision;
  if (h.s < 1)
    throw Error($r + (h.s ? "NaN" : "-Infinity"));
  if (h.eq(hr))
    return new v(0);
  if (t == null ? (gt = !1, c = g) : c = t, h.eq(10))
    return t == null && (gt = !0), P2(v, c);
  if (c += p, v.precision = c, r = rn(m), n = r.charAt(0), i = Mt(h), Math.abs(i) < 15e14) {
    for (; n < 7 && n != 1 || n == 1 && r.charAt(1) > 3; )
      h = h.times(e), r = rn(h.d), n = r.charAt(0), f++;
    i = Mt(h), n > 1 ? (h = new v("0." + r), i++) : h = new v(n + "." + r.slice(1));
  } else
    return l = P2(v, c + 2, g).times(i + ""), h = Ps(new v(n + "." + r.slice(1)), c - p).plus(l), v.precision = g, t == null ? (gt = !0, lt(h, g)) : h;
  for (s = o = h = jn(h.minus(hr), h.plus(hr), c), u = lt(h.times(h), c), a = 3; ; ) {
    if (o = lt(o.times(u), c), l = s.plus(jn(o, new v(a), c)), rn(l.d).slice(0, c) === rn(s.d).slice(0, c))
      return s = s.times(2), i !== 0 && (s = s.plus(P2(v, c + 2, g).times(i + ""))), s = jn(s, new v(f), c), v.precision = g, t == null ? (gt = !0, lt(s, g)) : s;
    s = l, a += 2;
  }
}
function w4(e, t) {
  var r, n, a;
  for ((r = t.indexOf(".")) > -1 && (t = t.replace(".", "")), (n = t.search(/e/i)) > 0 ? (r < 0 && (r = n), r += +t.slice(n + 1), t = t.substring(0, n)) : r < 0 && (r = t.length), n = 0; t.charCodeAt(n) === 48; )
    ++n;
  for (a = t.length; t.charCodeAt(a - 1) === 48; )
    --a;
  if (t = t.slice(n, a), t) {
    if (a -= n, r = r - n - 1, e.e = uo(r / ht), e.d = [], n = (r + 1) % ht, r < 0 && (n += ht), n < a) {
      for (n && e.d.push(+t.slice(0, n)), a -= ht; n < a; )
        e.d.push(+t.slice(n, n += ht));
      t = t.slice(n), n = ht - t.length;
    } else
      n -= a;
    for (; n--; )
      t += "0";
    if (e.d.push(+t), gt && (e.e > k1 || e.e < -k1))
      throw Error($d + r);
  } else
    e.s = 0, e.e = 0, e.d = [0];
  return e;
}
function lt(e, t, r) {
  var n, a, i, o, s, l, c, u, f = e.d;
  for (o = 1, i = f[0]; i >= 10; i /= 10)
    o++;
  if (n = t - o, n < 0)
    n += ht, a = t, c = f[u = 0];
  else {
    if (u = Math.ceil((n + 1) / ht), i = f.length, u >= i)
      return e;
    for (c = i = f[u], o = 1; i >= 10; i /= 10)
      o++;
    n %= ht, a = n - ht + o;
  }
  if (r !== void 0 && (i = Oa(10, o - a - 1), s = c / i % 10 | 0, l = t < 0 || f[u + 1] !== void 0 || c % i, l = r < 4 ? (s || l) && (r == 0 || r == (e.s < 0 ? 3 : 2)) : s > 5 || s == 5 && (r == 4 || l || r == 6 && // Check whether the digit to the left of the rounding digit is odd.
  (n > 0 ? a > 0 ? c / Oa(10, o - a) : 0 : f[u - 1]) % 10 & 1 || r == (e.s < 0 ? 8 : 7))), t < 1 || !f[0])
    return l ? (i = Mt(e), f.length = 1, t = t - i - 1, f[0] = Oa(10, (ht - t % ht) % ht), e.e = uo(-t / ht) || 0) : (f.length = 1, f[0] = e.e = e.s = 0), e;
  if (n == 0 ? (f.length = u, i = 1, u--) : (f.length = u + 1, i = Oa(10, ht - n), f[u] = a > 0 ? (c / Oa(10, o - a) % Oa(10, a) | 0) * i : 0), l)
    for (; ; )
      if (u == 0) {
        (f[0] += i) == Bt && (f[0] = 1, ++e.e);
        break;
      } else {
        if (f[u] += i, f[u] != Bt)
          break;
        f[u--] = 0, i = 1;
      }
  for (n = f.length; f[--n] === 0; )
    f.pop();
  if (gt && (e.e > k1 || e.e < -k1))
    throw Error($d + Mt(e));
  return e;
}
function ly(e, t) {
  var r, n, a, i, o, s, l, c, u, f, p = e.constructor, h = p.precision;
  if (!e.s || !t.s)
    return t.s ? t.s = -t.s : t = new p(e), gt ? lt(t, h) : t;
  if (l = e.d, f = t.d, n = t.e, c = e.e, l = l.slice(), o = c - n, o) {
    for (u = o < 0, u ? (r = l, o = -o, s = f.length) : (r = f, n = c, s = l.length), a = Math.max(Math.ceil(h / ht), s) + 2, o > a && (o = a, r.length = 1), r.reverse(), a = o; a--; )
      r.push(0);
    r.reverse();
  } else {
    for (a = l.length, s = f.length, u = a < s, u && (s = a), a = 0; a < s; a++)
      if (l[a] != f[a]) {
        u = l[a] < f[a];
        break;
      }
    o = 0;
  }
  for (u && (r = l, l = f, f = r, t.s = -t.s), s = l.length, a = f.length - s; a > 0; --a)
    l[s++] = 0;
  for (a = f.length; a > o; ) {
    if (l[--a] < f[a]) {
      for (i = a; i && l[--i] === 0; )
        l[i] = Bt - 1;
      --l[i], l[a] += Bt;
    }
    l[a] -= f[a];
  }
  for (; l[--s] === 0; )
    l.pop();
  for (; l[0] === 0; l.shift())
    --n;
  return l[0] ? (t.d = l, t.e = n, gt ? lt(t, h) : t) : new p(0);
}
function Ra(e, t, r) {
  var n, a = Mt(e), i = rn(e.d), o = i.length;
  return t ? (r && (n = r - o) > 0 ? i = i.charAt(0) + "." + i.slice(1) + kn(n) : o > 1 && (i = i.charAt(0) + "." + i.slice(1)), i = i + (a < 0 ? "e" : "e+") + a) : a < 0 ? (i = "0." + kn(-a - 1) + i, r && (n = r - o) > 0 && (i += kn(n))) : a >= o ? (i += kn(a + 1 - o), r && (n = r - a - 1) > 0 && (i = i + "." + kn(n))) : ((n = a + 1) < o && (i = i.slice(0, n) + "." + i.slice(n)), r && (n = r - o) > 0 && (a + 1 === o && (i += "."), i += kn(n))), e.s < 0 ? "-" + i : i;
}
function O4(e, t) {
  if (e.length > t)
    return e.length = t, !0;
}
function cy(e) {
  var t, r, n;
  function a(i) {
    var o = this;
    if (!(o instanceof a))
      return new a(i);
    if (o.constructor = a, i instanceof a) {
      o.s = i.s, o.e = i.e, o.d = (i = i.d) ? i.slice() : i;
      return;
    }
    if (typeof i == "number") {
      if (i * 0 !== 0)
        throw Error($a + i);
      if (i > 0)
        o.s = 1;
      else if (i < 0)
        i = -i, o.s = -1;
      else {
        o.s = 0, o.e = 0, o.d = [0];
        return;
      }
      if (i === ~~i && i < 1e7) {
        o.e = 0, o.d = [i];
        return;
      }
      return w4(o, i.toString());
    } else if (typeof i != "string")
      throw Error($a + i);
    if (i.charCodeAt(0) === 45 ? (i = i.slice(1), o.s = -1) : o.s = 1, Oee.test(i))
      w4(o, i);
    else
      throw Error($a + i);
  }
  if (a.prototype = fe, a.ROUND_UP = 0, a.ROUND_DOWN = 1, a.ROUND_CEIL = 2, a.ROUND_FLOOR = 3, a.ROUND_HALF_UP = 4, a.ROUND_HALF_DOWN = 5, a.ROUND_HALF_EVEN = 6, a.ROUND_HALF_CEIL = 7, a.ROUND_HALF_FLOOR = 8, a.clone = cy, a.config = a.set = See, e === void 0 && (e = {}), e)
    for (n = ["precision", "rounding", "toExpNeg", "toExpPos", "LN10"], t = 0; t < n.length; )
      e.hasOwnProperty(r = n[t++]) || (e[r] = this[r]);
  return a.config(e), a;
}
function See(e) {
  if (!e || typeof e != "object")
    throw Error($r + "Object expected");
  var t, r, n, a = [
    "precision",
    1,
    co,
    "rounding",
    0,
    8,
    "toExpNeg",
    -1 / 0,
    0,
    "toExpPos",
    0,
    1 / 0
  ];
  for (t = 0; t < a.length; t += 3)
    if ((n = e[r = a[t]]) !== void 0)
      if (uo(n) === n && n >= a[t + 1] && n <= a[t + 2])
        this[r] = n;
      else
        throw Error($a + r + ": " + n);
  if ((n = e[r = "LN10"]) !== void 0)
    if (n == Math.LN10)
      this[r] = new this(n);
    else
      throw Error($a + r + ": " + n);
  return this;
}
var Nd = cy(wee);
hr = new Nd(1);
const it = Nd;
function Pee(e) {
  return Dee(e) || _ee(e) || jee(e) || Eee();
}
function Eee() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function jee(e, t) {
  if (e) {
    if (typeof e == "string")
      return U3(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return U3(e, t);
  }
}
function _ee(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e))
    return Array.from(e);
}
function Dee(e) {
  if (Array.isArray(e))
    return U3(e);
}
function U3(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var Aee = function(t) {
  return t;
}, uy = {
  "@@functional/placeholder": !0
}, fy = function(t) {
  return t === uy;
}, S4 = function(t) {
  return function r() {
    return arguments.length === 0 || arguments.length === 1 && fy(arguments.length <= 0 ? void 0 : arguments[0]) ? r : t.apply(void 0, arguments);
  };
}, Mee = function e(t, r) {
  return t === 1 ? r : S4(function() {
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    var o = a.filter(function(s) {
      return s !== uy;
    }).length;
    return o >= t ? r.apply(void 0, a) : e(t - o, S4(function() {
      for (var s = arguments.length, l = new Array(s), c = 0; c < s; c++)
        l[c] = arguments[c];
      var u = a.map(function(f) {
        return fy(f) ? l.shift() : f;
      });
      return r.apply(void 0, Pee(u).concat(l));
    }));
  });
}, au = function(t) {
  return Mee(t.length, t);
}, Z3 = function(t, r) {
  for (var n = [], a = t; a < r; ++a)
    n[a - t] = a;
  return n;
}, Tee = au(function(e, t) {
  return Array.isArray(t) ? t.map(e) : Object.keys(t).map(function(r) {
    return t[r];
  }).map(e);
}), $ee = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  if (!r.length)
    return Aee;
  var a = r.reverse(), i = a[0], o = a.slice(1);
  return function() {
    return o.reduce(function(s, l) {
      return l(s);
    }, i.apply(void 0, arguments));
  };
}, q3 = function(t) {
  return Array.isArray(t) ? t.reverse() : t.split("").reverse.join("");
}, dy = function(t) {
  var r = null, n = null;
  return function() {
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r && i.every(function(s, l) {
      return s === r[l];
    }) || (r = i, n = t.apply(void 0, i)), n;
  };
};
function Nee(e) {
  var t;
  return e === 0 ? t = 1 : t = Math.floor(new it(e).abs().log(10).toNumber()) + 1, t;
}
function Iee(e, t, r) {
  for (var n = new it(e), a = 0, i = []; n.lt(t) && a < 1e5; )
    i.push(n.toNumber()), n = n.add(r), a++;
  return i;
}
var Lee = au(function(e, t, r) {
  var n = +e, a = +t;
  return n + r * (a - n);
}), Ree = au(function(e, t, r) {
  var n = t - +e;
  return n = n || 1 / 0, (r - e) / n;
}), kee = au(function(e, t, r) {
  var n = t - +e;
  return n = n || 1 / 0, Math.max(0, Math.min(1, (r - e) / n));
});
const iu = {
  rangeStep: Iee,
  getDigitCount: Nee,
  interpolateNumber: Lee,
  uninterpolateNumber: Ree,
  uninterpolateTruncation: kee
};
function G3(e) {
  return Hee(e) || Vee(e) || py(e) || Bee();
}
function Bee() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Vee(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e))
    return Array.from(e);
}
function Hee(e) {
  if (Array.isArray(e))
    return Y3(e);
}
function Es(e, t) {
  return zee(e) || Wee(e, t) || py(e, t) || Fee();
}
function Fee() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function py(e, t) {
  if (e) {
    if (typeof e == "string")
      return Y3(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Y3(e, t);
  }
}
function Y3(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function Wee(e, t) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(e)))) {
    var r = [], n = !0, a = !1, i = void 0;
    try {
      for (var o = e[Symbol.iterator](), s; !(n = (s = o.next()).done) && (r.push(s.value), !(t && r.length === t)); n = !0)
        ;
    } catch (l) {
      a = !0, i = l;
    } finally {
      try {
        !n && o.return != null && o.return();
      } finally {
        if (a)
          throw i;
      }
    }
    return r;
  }
}
function zee(e) {
  if (Array.isArray(e))
    return e;
}
function hy(e) {
  var t = Es(e, 2), r = t[0], n = t[1], a = r, i = n;
  return r > n && (a = n, i = r), [a, i];
}
function vy(e, t, r) {
  if (e.lte(0))
    return new it(0);
  var n = iu.getDigitCount(e.toNumber()), a = new it(10).pow(n), i = e.div(a), o = n !== 1 ? 0.05 : 0.1, s = new it(Math.ceil(i.div(o).toNumber())).add(r).mul(o), l = s.mul(a);
  return t ? l : new it(Math.ceil(l));
}
function Uee(e, t, r) {
  var n = 1, a = new it(e);
  if (!a.isint() && r) {
    var i = Math.abs(e);
    i < 1 ? (n = new it(10).pow(iu.getDigitCount(e) - 1), a = new it(Math.floor(a.div(n).toNumber())).mul(n)) : i > 1 && (a = new it(Math.floor(e)));
  } else
    e === 0 ? a = new it(Math.floor((t - 1) / 2)) : r || (a = new it(Math.floor(e)));
  var o = Math.floor((t - 1) / 2), s = $ee(Tee(function(l) {
    return a.add(new it(l - o).mul(n)).toNumber();
  }), Z3);
  return s(0, t);
}
function my(e, t, r, n) {
  var a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
  if (!Number.isFinite((t - e) / (r - 1)))
    return {
      step: new it(0),
      tickMin: new it(0),
      tickMax: new it(0)
    };
  var i = vy(new it(t).sub(e).div(r - 1), n, a), o;
  e <= 0 && t >= 0 ? o = new it(0) : (o = new it(e).add(t).div(2), o = o.sub(new it(o).mod(i)));
  var s = Math.ceil(o.sub(e).div(i).toNumber()), l = Math.ceil(new it(t).sub(o).div(i).toNumber()), c = s + l + 1;
  return c > r ? my(e, t, r, n, a + 1) : (c < r && (l = t > 0 ? l + (r - c) : l, s = t > 0 ? s : s + (r - c)), {
    step: i,
    tickMin: o.sub(new it(s).mul(i)),
    tickMax: o.add(new it(l).mul(i))
  });
}
function Zee(e) {
  var t = Es(e, 2), r = t[0], n = t[1], a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 6, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, o = Math.max(a, 2), s = hy([r, n]), l = Es(s, 2), c = l[0], u = l[1];
  if (c === -1 / 0 || u === 1 / 0) {
    var f = u === 1 / 0 ? [c].concat(G3(Z3(0, a - 1).map(function() {
      return 1 / 0;
    }))) : [].concat(G3(Z3(0, a - 1).map(function() {
      return -1 / 0;
    })), [u]);
    return r > n ? q3(f) : f;
  }
  if (c === u)
    return Uee(c, a, i);
  var p = my(c, u, o, i), h = p.step, m = p.tickMin, v = p.tickMax, g = iu.rangeStep(m, v.add(new it(0.1).mul(h)), h);
  return r > n ? q3(g) : g;
}
function qee(e, t) {
  var r = Es(e, 2), n = r[0], a = r[1], i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, o = hy([n, a]), s = Es(o, 2), l = s[0], c = s[1];
  if (l === -1 / 0 || c === 1 / 0)
    return [n, a];
  if (l === c)
    return [l];
  var u = Math.max(t, 2), f = vy(new it(c).sub(l).div(u - 1), i, 0), p = [].concat(G3(iu.rangeStep(new it(l), new it(c).sub(new it(0.99).mul(f)), f)), [c]);
  return n > a ? q3(p) : p;
}
var Gee = dy(Zee), Yee = dy(qee), Kee = ["offset", "layout", "width", "dataKey", "data", "dataPointFormatter", "xAxis", "yAxis"];
function _i(e) {
  "@babel/helpers - typeof";
  return _i = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _i(e);
}
function B1() {
  return B1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, B1.apply(this, arguments);
}
function Xee(e, t) {
  return tte(e) || ete(e, t) || Jee(e, t) || Qee();
}
function Qee() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Jee(e, t) {
  if (e) {
    if (typeof e == "string")
      return P4(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return P4(e, t);
  }
}
function P4(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function ete(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], l = !0, c = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        l = !1;
      } else
        for (; !(l = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); l = !0)
          ;
    } catch (u) {
      c = !0, a = u;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (c)
          throw a;
      }
    }
    return s;
  }
}
function tte(e) {
  if (Array.isArray(e))
    return e;
}
function rte(e, t) {
  if (e == null)
    return {};
  var r = nte(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function nte(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function ate(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function E4(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, by(n.key), n);
  }
}
function ite(e, t, r) {
  return t && E4(e.prototype, t), r && E4(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function ote(e, t, r) {
  return t = V1(t), ste(e, gy() ? Reflect.construct(t, r || [], V1(e).constructor) : t.apply(e, r));
}
function ste(e, t) {
  if (t && (_i(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return lte(e);
}
function lte(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function gy() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (gy = function() {
    return !!e;
  })();
}
function V1(e) {
  return V1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, V1(e);
}
function cte(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && K3(e, t);
}
function K3(e, t) {
  return K3 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, K3(e, t);
}
function yy(e, t, r) {
  return t = by(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function by(e) {
  var t = ute(e, "string");
  return _i(t) == "symbol" ? t : t + "";
}
function ute(e, t) {
  if (_i(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (_i(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var fo = /* @__PURE__ */ function(e) {
  function t() {
    return ate(this, t), ote(this, t, arguments);
  }
  return cte(t, e), ite(t, [{
    key: "render",
    value: function() {
      var n = this.props, a = n.offset, i = n.layout, o = n.width, s = n.dataKey, l = n.data, c = n.dataPointFormatter, u = n.xAxis, f = n.yAxis, p = rte(n, Kee), h = pe(p, !1);
      this.props.direction === "x" && u.type !== "number" && (process.env.NODE_ENV !== "production" ? Gt(!1, 'ErrorBar requires Axis type property to be "number".') : Gt(!1));
      var m = l.map(function(v) {
        var g = c(v, s), y = g.x, b = g.y, w = g.value, x = g.errorVal;
        if (!x)
          return null;
        var C = [], S, E;
        if (Array.isArray(x)) {
          var D = Xee(x, 2);
          S = D[0], E = D[1];
        } else
          S = E = x;
        if (i === "vertical") {
          var I = u.scale, k = b + a, V = k + o, W = k - o, L = I(w - S), G = I(w + E);
          C.push({
            x1: G,
            y1: V,
            x2: G,
            y2: W
          }), C.push({
            x1: L,
            y1: k,
            x2: G,
            y2: k
          }), C.push({
            x1: L,
            y1: V,
            x2: L,
            y2: W
          });
        } else if (i === "horizontal") {
          var Q = f.scale, X = y + a, K = X - o, te = X + o, _ = Q(w - S), j = Q(w + E);
          C.push({
            x1: K,
            y1: j,
            x2: te,
            y2: j
          }), C.push({
            x1: X,
            y1: _,
            x2: X,
            y2: j
          }), C.push({
            x1: K,
            y1: _,
            x2: te,
            y2: _
          });
        }
        return /* @__PURE__ */ P.createElement(De, B1({
          className: "recharts-errorBar",
          key: "bar-".concat(C.map(function(T) {
            return "".concat(T.x1, "-").concat(T.x2, "-").concat(T.y1, "-").concat(T.y2);
          }))
        }, h), C.map(function(T) {
          return /* @__PURE__ */ P.createElement("line", B1({}, T, {
            key: "line-".concat(T.x1, "-").concat(T.x2, "-").concat(T.y1, "-").concat(T.y2)
          }));
        }));
      });
      return /* @__PURE__ */ P.createElement(De, {
        className: "recharts-errorBars"
      }, m);
    }
  }]);
}(P.Component);
yy(fo, "defaultProps", {
  stroke: "black",
  strokeWidth: 1.5,
  width: 5,
  offset: 0,
  layout: "horizontal"
});
yy(fo, "displayName", "ErrorBar");
function js(e) {
  "@babel/helpers - typeof";
  return js = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, js(e);
}
function j4(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function va(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? j4(Object(r), !0).forEach(function(n) {
      fte(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : j4(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function fte(e, t, r) {
  return t = dte(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function dte(e) {
  var t = pte(e, "string");
  return js(t) == "symbol" ? t : t + "";
}
function pte(e, t) {
  if (js(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (js(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Cy = function(t) {
  var r = t.children, n = t.formattedGraphicalItems, a = t.legendWidth, i = t.legendContent, o = pr(r, En);
  if (!o)
    return null;
  var s = En.defaultProps, l = s !== void 0 ? va(va({}, s), o.props) : {}, c;
  return o.props && o.props.payload ? c = o.props && o.props.payload : i === "children" ? c = (n || []).reduce(function(u, f) {
    var p = f.item, h = f.props, m = h.sectors || h.data || [];
    return u.concat(m.map(function(v) {
      return {
        type: o.props.iconType || p.props.legendType,
        value: v.name,
        color: v.fill,
        payload: v
      };
    }));
  }, []) : c = (n || []).map(function(u) {
    var f = u.item, p = f.type.defaultProps, h = p !== void 0 ? va(va({}, p), f.props) : {}, m = h.dataKey, v = h.name, g = h.legendType, y = h.hide;
    return {
      inactive: y,
      dataKey: m,
      type: l.iconType || g || "square",
      color: Id(f),
      value: v || m,
      // @ts-expect-error property strokeDasharray is required in Payload but optional in props
      payload: h
    };
  }), va(va(va({}, l), En.getWithHeight(o, a)), {}, {
    payload: c,
    item: o
  });
};
function _s(e) {
  "@babel/helpers - typeof";
  return _s = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _s(e);
}
function _4(e) {
  return gte(e) || mte(e) || vte(e) || hte();
}
function hte() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function vte(e, t) {
  if (e) {
    if (typeof e == "string")
      return X3(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return X3(e, t);
  }
}
function mte(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function gte(e) {
  if (Array.isArray(e))
    return X3(e);
}
function X3(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function D4(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function wt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? D4(Object(r), !0).forEach(function(n) {
      vi(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : D4(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function vi(e, t, r) {
  return t = yte(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function yte(e) {
  var t = bte(e, "string");
  return _s(t) == "symbol" ? t : t + "";
}
function bte(e, t) {
  if (_s(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (_s(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function vt(e, t, r) {
  return Ce(e) || Ce(t) ? r : Lt(t) ? br(e, t, r) : xe(t) ? t(e) : r;
}
function Ko(e, t, r, n) {
  var a = yee(e, function(s) {
    return vt(s, t);
  });
  if (r === "number") {
    var i = a.filter(function(s) {
      return oe(s) || parseFloat(s);
    });
    return i.length ? [nu(i), Vn(i)] : [1 / 0, -1 / 0];
  }
  var o = n ? a.filter(function(s) {
    return !Ce(s);
  }) : a;
  return o.map(function(s) {
    return Lt(s) || s instanceof Date ? s : "";
  });
}
var Cte = function(t) {
  var r, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], a = arguments.length > 2 ? arguments[2] : void 0, i = arguments.length > 3 ? arguments[3] : void 0, o = -1, s = (r = n == null ? void 0 : n.length) !== null && r !== void 0 ? r : 0;
  if (s <= 1)
    return 0;
  if (i && i.axisType === "angleAxis" && Math.abs(Math.abs(i.range[1] - i.range[0]) - 360) <= 1e-6)
    for (var l = i.range, c = 0; c < s; c++) {
      var u = c > 0 ? a[c - 1].coordinate : a[s - 1].coordinate, f = a[c].coordinate, p = c >= s - 1 ? a[0].coordinate : a[c + 1].coordinate, h = void 0;
      if (Jt(f - u) !== Jt(p - f)) {
        var m = [];
        if (Jt(p - f) === Jt(l[1] - l[0])) {
          h = p;
          var v = f + l[1] - l[0];
          m[0] = Math.min(v, (v + u) / 2), m[1] = Math.max(v, (v + u) / 2);
        } else {
          h = u;
          var g = p + l[1] - l[0];
          m[0] = Math.min(f, (g + f) / 2), m[1] = Math.max(f, (g + f) / 2);
        }
        var y = [Math.min(f, (h + f) / 2), Math.max(f, (h + f) / 2)];
        if (t > y[0] && t <= y[1] || t >= m[0] && t <= m[1]) {
          o = a[c].index;
          break;
        }
      } else {
        var b = Math.min(u, p), w = Math.max(u, p);
        if (t > (b + f) / 2 && t <= (w + f) / 2) {
          o = a[c].index;
          break;
        }
      }
    }
  else
    for (var x = 0; x < s; x++)
      if (x === 0 && t <= (n[x].coordinate + n[x + 1].coordinate) / 2 || x > 0 && x < s - 1 && t > (n[x].coordinate + n[x - 1].coordinate) / 2 && t <= (n[x].coordinate + n[x + 1].coordinate) / 2 || x === s - 1 && t > (n[x].coordinate + n[x - 1].coordinate) / 2) {
        o = n[x].index;
        break;
      }
  return o;
}, Id = function(t) {
  var r, n = t, a = n.type.displayName, i = (r = t.type) !== null && r !== void 0 && r.defaultProps ? wt(wt({}, t.type.defaultProps), t.props) : t.props, o = i.stroke, s = i.fill, l;
  switch (a) {
    case "Line":
      l = o;
      break;
    case "Area":
    case "Radar":
      l = o && o !== "none" ? o : s;
      break;
    default:
      l = s;
      break;
  }
  return l;
}, xte = function(t) {
  var r = t.barSize, n = t.totalSize, a = t.stackGroups, i = a === void 0 ? {} : a;
  if (!i)
    return {};
  for (var o = {}, s = Object.keys(i), l = 0, c = s.length; l < c; l++)
    for (var u = i[s[l]].stackGroups, f = Object.keys(u), p = 0, h = f.length; p < h; p++) {
      var m = u[f[p]], v = m.items, g = m.cateAxisId, y = v.filter(function(E) {
        return Pn(E.type).indexOf("Bar") >= 0;
      });
      if (y && y.length) {
        var b = y[0].type.defaultProps, w = b !== void 0 ? wt(wt({}, b), y[0].props) : y[0].props, x = w.barSize, C = w[g];
        o[C] || (o[C] = []);
        var S = Ce(x) ? r : x;
        o[C].push({
          item: y[0],
          stackList: y.slice(1),
          barSize: Ce(S) ? void 0 : er(S, n, 0)
        });
      }
    }
  return o;
}, wte = function(t) {
  var r = t.barGap, n = t.barCategoryGap, a = t.bandSize, i = t.sizeList, o = i === void 0 ? [] : i, s = t.maxBarSize, l = o.length;
  if (l < 1)
    return null;
  var c = er(r, a, 0, !0), u, f = [];
  if (o[0].barSize === +o[0].barSize) {
    var p = !1, h = a / l, m = o.reduce(function(x, C) {
      return x + C.barSize || 0;
    }, 0);
    m += (l - 1) * c, m >= a && (m -= (l - 1) * c, c = 0), m >= a && h > 0 && (p = !0, h *= 0.9, m = l * h);
    var v = (a - m) / 2 >> 0, g = {
      offset: v - c,
      size: 0
    };
    u = o.reduce(function(x, C) {
      var S = {
        item: C.item,
        position: {
          offset: g.offset + g.size + c,
          // @ts-expect-error the type check above does not check for type number explicitly
          size: p ? h : C.barSize
        }
      }, E = [].concat(_4(x), [S]);
      return g = E[E.length - 1].position, C.stackList && C.stackList.length && C.stackList.forEach(function(D) {
        E.push({
          item: D,
          position: g
        });
      }), E;
    }, f);
  } else {
    var y = er(n, a, 0, !0);
    a - 2 * y - (l - 1) * c <= 0 && (c = 0);
    var b = (a - 2 * y - (l - 1) * c) / l;
    b > 1 && (b >>= 0);
    var w = s === +s ? Math.min(b, s) : b;
    u = o.reduce(function(x, C, S) {
      var E = [].concat(_4(x), [{
        item: C.item,
        position: {
          offset: y + (b + c) * S + (b - w) / 2,
          size: w
        }
      }]);
      return C.stackList && C.stackList.length && C.stackList.forEach(function(D) {
        E.push({
          item: D,
          position: E[E.length - 1].position
        });
      }), E;
    }, f);
  }
  return u;
}, Ote = function(t, r, n, a) {
  var i = n.children, o = n.width, s = n.margin, l = o - (s.left || 0) - (s.right || 0), c = Cy({
    children: i,
    legendWidth: l
  });
  if (c) {
    var u = a || {}, f = u.width, p = u.height, h = c.align, m = c.verticalAlign, v = c.layout;
    if ((v === "vertical" || v === "horizontal" && m === "middle") && h !== "center" && oe(t[h]))
      return wt(wt({}, t), {}, vi({}, h, t[h] + (f || 0)));
    if ((v === "horizontal" || v === "vertical" && h === "center") && m !== "middle" && oe(t[m]))
      return wt(wt({}, t), {}, vi({}, m, t[m] + (p || 0)));
  }
  return t;
}, Ste = function(t, r, n) {
  return Ce(r) ? !0 : t === "horizontal" ? r === "yAxis" : t === "vertical" || n === "x" ? r === "xAxis" : n === "y" ? r === "yAxis" : !0;
}, xy = function(t, r, n, a, i) {
  var o = r.props.children, s = rr(o, fo).filter(function(c) {
    return Ste(a, i, c.props.direction);
  });
  if (s && s.length) {
    var l = s.map(function(c) {
      return c.props.dataKey;
    });
    return t.reduce(function(c, u) {
      var f = vt(u, n);
      if (Ce(f))
        return c;
      var p = Array.isArray(f) ? [nu(f), Vn(f)] : [f, f], h = l.reduce(function(m, v) {
        var g = vt(u, v, 0), y = p[0] - Math.abs(Array.isArray(g) ? g[0] : g), b = p[1] + Math.abs(Array.isArray(g) ? g[1] : g);
        return [Math.min(y, m[0]), Math.max(b, m[1])];
      }, [1 / 0, -1 / 0]);
      return [Math.min(h[0], c[0]), Math.max(h[1], c[1])];
    }, [1 / 0, -1 / 0]);
  }
  return null;
}, Pte = function(t, r, n, a, i) {
  var o = r.map(function(s) {
    return xy(t, s, n, i, a);
  }).filter(function(s) {
    return !Ce(s);
  });
  return o && o.length ? o.reduce(function(s, l) {
    return [Math.min(s[0], l[0]), Math.max(s[1], l[1])];
  }, [1 / 0, -1 / 0]) : null;
}, wy = function(t, r, n, a, i) {
  var o = r.map(function(l) {
    var c = l.props.dataKey;
    return n === "number" && c && xy(t, l, c, a) || Ko(t, c, n, i);
  });
  if (n === "number")
    return o.reduce(
      // @ts-expect-error if (type === number) means that the domain is numerical type
      // - but this link is missing in the type definition
      function(l, c) {
        return [Math.min(l[0], c[0]), Math.max(l[1], c[1])];
      },
      [1 / 0, -1 / 0]
    );
  var s = {};
  return o.reduce(function(l, c) {
    for (var u = 0, f = c.length; u < f; u++)
      s[c[u]] || (s[c[u]] = !0, l.push(c[u]));
    return l;
  }, []);
}, Oy = function(t, r) {
  return t === "horizontal" && r === "xAxis" || t === "vertical" && r === "yAxis" || t === "centric" && r === "angleAxis" || t === "radial" && r === "radiusAxis";
}, Sy = function(t, r, n, a) {
  if (a)
    return t.map(function(l) {
      return l.coordinate;
    });
  var i, o, s = t.map(function(l) {
    return l.coordinate === r && (i = !0), l.coordinate === n && (o = !0), l.coordinate;
  });
  return i || s.push(r), o || s.push(n), s;
}, wn = function(t, r, n) {
  if (!t)
    return null;
  var a = t.scale, i = t.duplicateDomain, o = t.type, s = t.range, l = t.realScaleType === "scaleBand" ? a.bandwidth() / 2 : 2, c = (r || n) && o === "category" && a.bandwidth ? a.bandwidth() / l : 0;
  if (c = t.axisType === "angleAxis" && (s == null ? void 0 : s.length) >= 2 ? Jt(s[0] - s[1]) * 2 * c : c, r && (t.ticks || t.niceTicks)) {
    var u = (t.ticks || t.niceTicks).map(function(f) {
      var p = i ? i.indexOf(f) : f;
      return {
        // If the scaleContent is not a number, the coordinate will be NaN.
        // That could be the case for example with a PointScale and a string as domain.
        coordinate: a(p) + c,
        value: f,
        offset: c
      };
    });
    return u.filter(function(f) {
      return !ao(f.coordinate);
    });
  }
  return t.isCategorical && t.categoricalDomain ? t.categoricalDomain.map(function(f, p) {
    return {
      coordinate: a(f) + c,
      value: f,
      index: p,
      offset: c
    };
  }) : a.ticks && !n ? a.ticks(t.tickCount).map(function(f) {
    return {
      coordinate: a(f) + c,
      value: f,
      offset: c
    };
  }) : a.domain().map(function(f, p) {
    return {
      coordinate: a(f) + c,
      value: i ? i[f] : f,
      index: p,
      offset: c
    };
  });
}, E2 = /* @__PURE__ */ new WeakMap(), $l = function(t, r) {
  if (typeof r != "function")
    return t;
  E2.has(t) || E2.set(t, /* @__PURE__ */ new WeakMap());
  var n = E2.get(t);
  if (n.has(r))
    return n.get(r);
  var a = function() {
    t.apply(void 0, arguments), r.apply(void 0, arguments);
  };
  return n.set(r, a), a;
}, Py = function(t, r, n) {
  var a = t.scale, i = t.type, o = t.layout, s = t.axisType;
  if (a === "auto")
    return o === "radial" && s === "radiusAxis" ? {
      scale: Cs(),
      realScaleType: "band"
    } : o === "radial" && s === "angleAxis" ? {
      scale: N1(),
      realScaleType: "linear"
    } : i === "category" && r && (r.indexOf("LineChart") >= 0 || r.indexOf("AreaChart") >= 0 || r.indexOf("ComposedChart") >= 0 && !n) ? {
      scale: Yo(),
      realScaleType: "point"
    } : i === "category" ? {
      scale: Cs(),
      realScaleType: "band"
    } : {
      scale: N1(),
      realScaleType: "linear"
    };
  if (ol(a)) {
    var l = "scale".concat(Fc(a));
    return {
      scale: (x4[l] || Yo)(),
      realScaleType: x4[l] ? l : "point"
    };
  }
  return xe(a) ? {
    scale: a
  } : {
    scale: Yo(),
    realScaleType: "point"
  };
}, A4 = 1e-4, Ey = function(t) {
  var r = t.domain();
  if (!(!r || r.length <= 2)) {
    var n = r.length, a = t.range(), i = Math.min(a[0], a[1]) - A4, o = Math.max(a[0], a[1]) + A4, s = t(r[0]), l = t(r[n - 1]);
    (s < i || s > o || l < i || l > o) && t.domain([r[0], r[n - 1]]);
  }
}, Ete = function(t, r) {
  if (!t)
    return null;
  for (var n = 0, a = t.length; n < a; n++)
    if (t[n].item === r)
      return t[n].position;
  return null;
}, jte = function(t, r) {
  if (!r || r.length !== 2 || !oe(r[0]) || !oe(r[1]))
    return t;
  var n = Math.min(r[0], r[1]), a = Math.max(r[0], r[1]), i = [t[0], t[1]];
  return (!oe(t[0]) || t[0] < n) && (i[0] = n), (!oe(t[1]) || t[1] > a) && (i[1] = a), i[0] > a && (i[0] = a), i[1] < n && (i[1] = n), i;
}, _te = function(t) {
  var r = t.length;
  if (!(r <= 0))
    for (var n = 0, a = t[0].length; n < a; ++n)
      for (var i = 0, o = 0, s = 0; s < r; ++s) {
        var l = ao(t[s][n][1]) ? t[s][n][0] : t[s][n][1];
        l >= 0 ? (t[s][n][0] = i, t[s][n][1] = i + l, i = t[s][n][1]) : (t[s][n][0] = o, t[s][n][1] = o + l, o = t[s][n][1]);
      }
}, Dte = function(t) {
  var r = t.length;
  if (!(r <= 0))
    for (var n = 0, a = t[0].length; n < a; ++n)
      for (var i = 0, o = 0; o < r; ++o) {
        var s = ao(t[o][n][1]) ? t[o][n][0] : t[o][n][1];
        s >= 0 ? (t[o][n][0] = i, t[o][n][1] = i + s, i = t[o][n][1]) : (t[o][n][0] = 0, t[o][n][1] = 0);
      }
}, Ate = {
  sign: _te,
  // @ts-expect-error definitelytyped types are incorrect
  expand: JH,
  // @ts-expect-error definitelytyped types are incorrect
  none: Ci,
  // @ts-expect-error definitelytyped types are incorrect
  silhouette: eF,
  // @ts-expect-error definitelytyped types are incorrect
  wiggle: tF,
  positive: Dte
}, Mte = function(t, r, n) {
  var a = r.map(function(s) {
    return s.props.dataKey;
  }), i = Ate[n], o = QH().keys(a).value(function(s, l) {
    return +vt(s, l, 0);
  }).order(w3).offset(i);
  return o(t);
}, Tte = function(t, r, n, a, i, o) {
  if (!t)
    return null;
  var s = o ? r.reverse() : r, l = {}, c = s.reduce(function(f, p) {
    var h, m = (h = p.type) !== null && h !== void 0 && h.defaultProps ? wt(wt({}, p.type.defaultProps), p.props) : p.props, v = m.stackId, g = m.hide;
    if (g)
      return f;
    var y = m[n], b = f[y] || {
      hasStack: !1,
      stackGroups: {}
    };
    if (Lt(v)) {
      var w = b.stackGroups[v] || {
        numericAxisId: n,
        cateAxisId: a,
        items: []
      };
      w.items.push(p), b.hasStack = !0, b.stackGroups[v] = w;
    } else
      b.stackGroups[oa("_stackId_")] = {
        numericAxisId: n,
        cateAxisId: a,
        items: [p]
      };
    return wt(wt({}, f), {}, vi({}, y, b));
  }, l), u = {};
  return Object.keys(c).reduce(function(f, p) {
    var h = c[p];
    if (h.hasStack) {
      var m = {};
      h.stackGroups = Object.keys(h.stackGroups).reduce(function(v, g) {
        var y = h.stackGroups[g];
        return wt(wt({}, v), {}, vi({}, g, {
          numericAxisId: n,
          cateAxisId: a,
          items: y.items,
          stackedData: Mte(t, y.items, i)
        }));
      }, m);
    }
    return wt(wt({}, f), {}, vi({}, p, h));
  }, u);
}, jy = function(t, r) {
  var n = r.realScaleType, a = r.type, i = r.tickCount, o = r.originalDomain, s = r.allowDecimals, l = n || r.scale;
  if (l !== "auto" && l !== "linear")
    return null;
  if (i && a === "number" && o && (o[0] === "auto" || o[1] === "auto")) {
    var c = t.domain();
    if (!c.length)
      return null;
    var u = Gee(c, i, s);
    return t.domain([nu(u), Vn(u)]), {
      niceTicks: u
    };
  }
  if (i && a === "number") {
    var f = t.domain(), p = Yee(f, i, s);
    return {
      niceTicks: p
    };
  }
  return null;
};
function Di(e) {
  var t = e.axis, r = e.ticks, n = e.bandSize, a = e.entry, i = e.index, o = e.dataKey;
  if (t.type === "category") {
    if (!t.allowDuplicatedCategory && t.dataKey && !Ce(a[t.dataKey])) {
      var s = p1(r, "value", a[t.dataKey]);
      if (s)
        return s.coordinate + n / 2;
    }
    return r[i] ? r[i].coordinate + n / 2 : null;
  }
  var l = vt(a, Ce(o) ? t.dataKey : o);
  return Ce(l) ? null : t.scale(l);
}
var M4 = function(t) {
  var r = t.axis, n = t.ticks, a = t.offset, i = t.bandSize, o = t.entry, s = t.index;
  if (r.type === "category")
    return n[s] ? n[s].coordinate + a : null;
  var l = vt(o, r.dataKey, r.domain[s]);
  return Ce(l) ? null : r.scale(l) - i / 2 + a;
}, $te = function(t) {
  var r = t.numericAxis, n = r.scale.domain();
  if (r.type === "number") {
    var a = Math.min(n[0], n[1]), i = Math.max(n[0], n[1]);
    return a <= 0 && i >= 0 ? 0 : i < 0 ? i : a;
  }
  return n[0];
}, Nte = function(t, r) {
  var n, a = (n = t.type) !== null && n !== void 0 && n.defaultProps ? wt(wt({}, t.type.defaultProps), t.props) : t.props, i = a.stackId;
  if (Lt(i)) {
    var o = r[i];
    if (o) {
      var s = o.items.indexOf(t);
      return s >= 0 ? o.stackedData[s] : null;
    }
  }
  return null;
}, Ite = function(t) {
  return t.reduce(function(r, n) {
    return [nu(n.concat([r[0]]).filter(oe)), Vn(n.concat([r[1]]).filter(oe))];
  }, [1 / 0, -1 / 0]);
}, _y = function(t, r, n) {
  return Object.keys(t).reduce(function(a, i) {
    var o = t[i], s = o.stackedData, l = s.reduce(function(c, u) {
      var f = Ite(u.slice(r, n + 1));
      return [Math.min(c[0], f[0]), Math.max(c[1], f[1])];
    }, [1 / 0, -1 / 0]);
    return [Math.min(l[0], a[0]), Math.max(l[1], a[1])];
  }, [1 / 0, -1 / 0]).map(function(a) {
    return a === 1 / 0 || a === -1 / 0 ? 0 : a;
  });
}, T4 = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, $4 = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, Q3 = function(t, r, n) {
  if (xe(t))
    return t(r, n);
  if (!Array.isArray(t))
    return r;
  var a = [];
  if (oe(t[0]))
    a[0] = n ? t[0] : Math.min(t[0], r[0]);
  else if (T4.test(t[0])) {
    var i = +T4.exec(t[0])[1];
    a[0] = r[0] - i;
  } else
    xe(t[0]) ? a[0] = t[0](r[0]) : a[0] = r[0];
  if (oe(t[1]))
    a[1] = n ? t[1] : Math.max(t[1], r[1]);
  else if ($4.test(t[1])) {
    var o = +$4.exec(t[1])[1];
    a[1] = r[1] + o;
  } else
    xe(t[1]) ? a[1] = t[1](r[1]) : a[1] = r[1];
  return a;
}, H1 = function(t, r, n) {
  if (t && t.scale && t.scale.bandwidth) {
    var a = t.scale.bandwidth();
    if (!n || a > 0)
      return a;
  }
  if (t && r && r.length >= 2) {
    for (var i = cd(r, function(f) {
      return f.coordinate;
    }), o = 1 / 0, s = 1, l = i.length; s < l; s++) {
      var c = i[s], u = i[s - 1];
      o = Math.min((c.coordinate || 0) - (u.coordinate || 0), o);
    }
    return o === 1 / 0 ? 0 : o;
  }
  return n ? void 0 : 0;
}, N4 = function(t, r, n) {
  return !t || !t.length || Xn(t, br(n, "type.defaultProps.domain")) ? r : t;
}, Dy = function(t, r) {
  var n = t.type.defaultProps ? wt(wt({}, t.type.defaultProps), t.props) : t.props, a = n.dataKey, i = n.name, o = n.unit, s = n.formatter, l = n.tooltipType, c = n.chartType, u = n.hide;
  return wt(wt({}, pe(t, !1)), {}, {
    dataKey: a,
    unit: o,
    formatter: s,
    name: i || a,
    color: Id(t),
    value: vt(r, a),
    type: l,
    payload: r,
    chartType: c,
    hide: u
  });
};
function Ds(e) {
  "@babel/helpers - typeof";
  return Ds = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ds(e);
}
function I4(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function bn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? I4(Object(r), !0).forEach(function(n) {
      Ay(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : I4(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Ay(e, t, r) {
  return t = Lte(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Lte(e) {
  var t = Rte(e, "string");
  return Ds(t) == "symbol" ? t : t + "";
}
function Rte(e, t) {
  if (Ds(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Ds(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function kte(e, t) {
  return Fte(e) || Hte(e, t) || Vte(e, t) || Bte();
}
function Bte() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Vte(e, t) {
  if (e) {
    if (typeof e == "string")
      return L4(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return L4(e, t);
  }
}
function L4(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function Hte(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], l = !0, c = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        l = !1;
      } else
        for (; !(l = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); l = !0)
          ;
    } catch (u) {
      c = !0, a = u;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (c)
          throw a;
      }
    }
    return s;
  }
}
function Fte(e) {
  if (Array.isArray(e))
    return e;
}
var F1 = Math.PI / 180, Wte = function(t) {
  return t * 180 / Math.PI;
}, ft = function(t, r, n, a) {
  return {
    x: t + Math.cos(-F1 * a) * n,
    y: r + Math.sin(-F1 * a) * n
  };
}, My = function(t, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
  return Math.min(Math.abs(t - (n.left || 0) - (n.right || 0)), Math.abs(r - (n.top || 0) - (n.bottom || 0))) / 2;
}, zte = function(t, r, n, a, i) {
  var o = t.width, s = t.height, l = t.startAngle, c = t.endAngle, u = er(t.cx, o, o / 2), f = er(t.cy, s, s / 2), p = My(o, s, n), h = er(t.innerRadius, p, 0), m = er(t.outerRadius, p, p * 0.8), v = Object.keys(r);
  return v.reduce(function(g, y) {
    var b = r[y], w = b.domain, x = b.reversed, C;
    if (Ce(b.range))
      a === "angleAxis" ? C = [l, c] : a === "radiusAxis" && (C = [h, m]), x && (C = [C[1], C[0]]);
    else {
      C = b.range;
      var S = C, E = kte(S, 2);
      l = E[0], c = E[1];
    }
    var D = Py(b, i), I = D.realScaleType, k = D.scale;
    k.domain(w).range(C), Ey(k);
    var V = jy(k, bn(bn({}, b), {}, {
      realScaleType: I
    })), W = bn(bn(bn({}, b), V), {}, {
      range: C,
      radius: m,
      realScaleType: I,
      scale: k,
      cx: u,
      cy: f,
      innerRadius: h,
      outerRadius: m,
      startAngle: l,
      endAngle: c
    });
    return bn(bn({}, g), {}, Ay({}, y, W));
  }, {});
}, Ute = function(t, r) {
  var n = t.x, a = t.y, i = r.x, o = r.y;
  return Math.sqrt(Math.pow(n - i, 2) + Math.pow(a - o, 2));
}, Zte = function(t, r) {
  var n = t.x, a = t.y, i = r.cx, o = r.cy, s = Ute({
    x: n,
    y: a
  }, {
    x: i,
    y: o
  });
  if (s <= 0)
    return {
      radius: s
    };
  var l = (n - i) / s, c = Math.acos(l);
  return a > o && (c = 2 * Math.PI - c), {
    radius: s,
    angle: Wte(c),
    angleInRadian: c
  };
}, qte = function(t) {
  var r = t.startAngle, n = t.endAngle, a = Math.floor(r / 360), i = Math.floor(n / 360), o = Math.min(a, i);
  return {
    startAngle: r - o * 360,
    endAngle: n - o * 360
  };
}, Gte = function(t, r) {
  var n = r.startAngle, a = r.endAngle, i = Math.floor(n / 360), o = Math.floor(a / 360), s = Math.min(i, o);
  return t + s * 360;
}, R4 = function(t, r) {
  var n = t.x, a = t.y, i = Zte({
    x: n,
    y: a
  }, r), o = i.radius, s = i.angle, l = r.innerRadius, c = r.outerRadius;
  if (o < l || o > c)
    return !1;
  if (o === 0)
    return !0;
  var u = qte(r), f = u.startAngle, p = u.endAngle, h = s, m;
  if (f <= p) {
    for (; h > p; )
      h -= 360;
    for (; h < f; )
      h += 360;
    m = h >= f && h <= p;
  } else {
    for (; h > f; )
      h -= 360;
    for (; h < p; )
      h += 360;
    m = h >= p && h <= f;
  }
  return m ? bn(bn({}, r), {}, {
    radius: o,
    angle: Gte(h, r)
  }) : null;
}, Ty = function(t) {
  return !/* @__PURE__ */ zr(t) && !xe(t) && typeof t != "boolean" ? t.className : "";
};
function As(e) {
  "@babel/helpers - typeof";
  return As = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, As(e);
}
var Yte = ["offset"];
function Kte(e) {
  return ere(e) || Jte(e) || Qte(e) || Xte();
}
function Xte() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Qte(e, t) {
  if (e) {
    if (typeof e == "string")
      return J3(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return J3(e, t);
  }
}
function Jte(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function ere(e) {
  if (Array.isArray(e))
    return J3(e);
}
function J3(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function tre(e, t) {
  if (e == null)
    return {};
  var r = rre(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function rre(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function k4(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function $t(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? k4(Object(r), !0).forEach(function(n) {
      nre(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : k4(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function nre(e, t, r) {
  return t = are(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function are(e) {
  var t = ire(e, "string");
  return As(t) == "symbol" ? t : t + "";
}
function ire(e, t) {
  if (As(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (As(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Ms() {
  return Ms = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ms.apply(this, arguments);
}
var ore = function(t) {
  var r = t.value, n = t.formatter, a = Ce(t.children) ? r : t.children;
  return xe(n) ? n(a) : a;
}, sre = function(t, r) {
  var n = Jt(r - t), a = Math.min(Math.abs(r - t), 360);
  return n * a;
}, lre = function(t, r, n) {
  var a = t.position, i = t.viewBox, o = t.offset, s = t.className, l = i, c = l.cx, u = l.cy, f = l.innerRadius, p = l.outerRadius, h = l.startAngle, m = l.endAngle, v = l.clockWise, g = (f + p) / 2, y = sre(h, m), b = y >= 0 ? 1 : -1, w, x;
  a === "insideStart" ? (w = h + b * o, x = v) : a === "insideEnd" ? (w = m - b * o, x = !v) : a === "end" && (w = m + b * o, x = v), x = y <= 0 ? x : !x;
  var C = ft(c, u, g, w), S = ft(c, u, g, w + (x ? 1 : -1) * 359), E = "M".concat(C.x, ",").concat(C.y, `
    A`).concat(g, ",").concat(g, ",0,1,").concat(x ? 0 : 1, `,
    `).concat(S.x, ",").concat(S.y), D = Ce(t.id) ? oa("recharts-radial-line-") : t.id;
  return /* @__PURE__ */ P.createElement("text", Ms({}, n, {
    dominantBaseline: "central",
    className: _e("recharts-radial-bar-label", s)
  }), /* @__PURE__ */ P.createElement("defs", null, /* @__PURE__ */ P.createElement("path", {
    id: D,
    d: E
  })), /* @__PURE__ */ P.createElement("textPath", {
    xlinkHref: "#".concat(D)
  }, r));
}, cre = function(t) {
  var r = t.viewBox, n = t.offset, a = t.position, i = r, o = i.cx, s = i.cy, l = i.innerRadius, c = i.outerRadius, u = i.startAngle, f = i.endAngle, p = (u + f) / 2;
  if (a === "outside") {
    var h = ft(o, s, c + n, p), m = h.x, v = h.y;
    return {
      x: m,
      y: v,
      textAnchor: m >= o ? "start" : "end",
      verticalAnchor: "middle"
    };
  }
  if (a === "center")
    return {
      x: o,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "middle"
    };
  if (a === "centerTop")
    return {
      x: o,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "start"
    };
  if (a === "centerBottom")
    return {
      x: o,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "end"
    };
  var g = (l + c) / 2, y = ft(o, s, g, p), b = y.x, w = y.y;
  return {
    x: b,
    y: w,
    textAnchor: "middle",
    verticalAnchor: "middle"
  };
}, ure = function(t) {
  var r = t.viewBox, n = t.parentViewBox, a = t.offset, i = t.position, o = r, s = o.x, l = o.y, c = o.width, u = o.height, f = u >= 0 ? 1 : -1, p = f * a, h = f > 0 ? "end" : "start", m = f > 0 ? "start" : "end", v = c >= 0 ? 1 : -1, g = v * a, y = v > 0 ? "end" : "start", b = v > 0 ? "start" : "end";
  if (i === "top") {
    var w = {
      x: s + c / 2,
      y: l - f * a,
      textAnchor: "middle",
      verticalAnchor: h
    };
    return $t($t({}, w), n ? {
      height: Math.max(l - n.y, 0),
      width: c
    } : {});
  }
  if (i === "bottom") {
    var x = {
      x: s + c / 2,
      y: l + u + p,
      textAnchor: "middle",
      verticalAnchor: m
    };
    return $t($t({}, x), n ? {
      height: Math.max(n.y + n.height - (l + u), 0),
      width: c
    } : {});
  }
  if (i === "left") {
    var C = {
      x: s - g,
      y: l + u / 2,
      textAnchor: y,
      verticalAnchor: "middle"
    };
    return $t($t({}, C), n ? {
      width: Math.max(C.x - n.x, 0),
      height: u
    } : {});
  }
  if (i === "right") {
    var S = {
      x: s + c + g,
      y: l + u / 2,
      textAnchor: b,
      verticalAnchor: "middle"
    };
    return $t($t({}, S), n ? {
      width: Math.max(n.x + n.width - S.x, 0),
      height: u
    } : {});
  }
  var E = n ? {
    width: c,
    height: u
  } : {};
  return i === "insideLeft" ? $t({
    x: s + g,
    y: l + u / 2,
    textAnchor: b,
    verticalAnchor: "middle"
  }, E) : i === "insideRight" ? $t({
    x: s + c - g,
    y: l + u / 2,
    textAnchor: y,
    verticalAnchor: "middle"
  }, E) : i === "insideTop" ? $t({
    x: s + c / 2,
    y: l + p,
    textAnchor: "middle",
    verticalAnchor: m
  }, E) : i === "insideBottom" ? $t({
    x: s + c / 2,
    y: l + u - p,
    textAnchor: "middle",
    verticalAnchor: h
  }, E) : i === "insideTopLeft" ? $t({
    x: s + g,
    y: l + p,
    textAnchor: b,
    verticalAnchor: m
  }, E) : i === "insideTopRight" ? $t({
    x: s + c - g,
    y: l + p,
    textAnchor: y,
    verticalAnchor: m
  }, E) : i === "insideBottomLeft" ? $t({
    x: s + g,
    y: l + u - p,
    textAnchor: b,
    verticalAnchor: h
  }, E) : i === "insideBottomRight" ? $t({
    x: s + c - g,
    y: l + u - p,
    textAnchor: y,
    verticalAnchor: h
  }, E) : eo(i) && (oe(i.x) || Ea(i.x)) && (oe(i.y) || Ea(i.y)) ? $t({
    x: s + er(i.x, c),
    y: l + er(i.y, u),
    textAnchor: "end",
    verticalAnchor: "end"
  }, E) : $t({
    x: s + c / 2,
    y: l + u / 2,
    textAnchor: "middle",
    verticalAnchor: "middle"
  }, E);
}, fre = function(t) {
  return "cx" in t && oe(t.cx);
};
function It(e) {
  var t = e.offset, r = t === void 0 ? 5 : t, n = tre(e, Yte), a = $t({
    offset: r
  }, n), i = a.viewBox, o = a.position, s = a.value, l = a.children, c = a.content, u = a.className, f = u === void 0 ? "" : u, p = a.textBreakAll;
  if (!i || Ce(s) && Ce(l) && !/* @__PURE__ */ zr(c) && !xe(c))
    return null;
  if (/* @__PURE__ */ zr(c))
    return /* @__PURE__ */ Nt(c, a);
  var h;
  if (xe(c)) {
    if (h = /* @__PURE__ */ D9(c, a), /* @__PURE__ */ zr(h))
      return h;
  } else
    h = ore(a);
  var m = fre(i), v = pe(a, !0);
  if (m && (o === "insideStart" || o === "insideEnd" || o === "end"))
    return lre(a, h, v);
  var g = m ? cre(a) : ure(a);
  return /* @__PURE__ */ P.createElement(La, Ms({
    className: _e("recharts-label", f)
  }, v, g, {
    breakAll: p
  }), h);
}
It.displayName = "Label";
var $y = function(t) {
  var r = t.cx, n = t.cy, a = t.angle, i = t.startAngle, o = t.endAngle, s = t.r, l = t.radius, c = t.innerRadius, u = t.outerRadius, f = t.x, p = t.y, h = t.top, m = t.left, v = t.width, g = t.height, y = t.clockWise, b = t.labelViewBox;
  if (b)
    return b;
  if (oe(v) && oe(g)) {
    if (oe(f) && oe(p))
      return {
        x: f,
        y: p,
        width: v,
        height: g
      };
    if (oe(h) && oe(m))
      return {
        x: h,
        y: m,
        width: v,
        height: g
      };
  }
  return oe(f) && oe(p) ? {
    x: f,
    y: p,
    width: 0,
    height: 0
  } : oe(r) && oe(n) ? {
    cx: r,
    cy: n,
    startAngle: i || a || 0,
    endAngle: o || a || 0,
    innerRadius: c || 0,
    outerRadius: u || l || s || 0,
    clockWise: y
  } : t.viewBox ? t.viewBox : {};
}, dre = function(t, r) {
  return t ? t === !0 ? /* @__PURE__ */ P.createElement(It, {
    key: "label-implicit",
    viewBox: r
  }) : Lt(t) ? /* @__PURE__ */ P.createElement(It, {
    key: "label-implicit",
    viewBox: r,
    value: t
  }) : /* @__PURE__ */ zr(t) ? t.type === It ? /* @__PURE__ */ Nt(t, {
    key: "label-implicit",
    viewBox: r
  }) : /* @__PURE__ */ P.createElement(It, {
    key: "label-implicit",
    content: t,
    viewBox: r
  }) : xe(t) ? /* @__PURE__ */ P.createElement(It, {
    key: "label-implicit",
    content: t,
    viewBox: r
  }) : eo(t) ? /* @__PURE__ */ P.createElement(It, Ms({
    viewBox: r
  }, t, {
    key: "label-implicit"
  })) : null : null;
}, pre = function(t, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!t || !t.children && n && !t.label)
    return null;
  var a = t.children, i = $y(t), o = rr(a, It).map(function(l, c) {
    return /* @__PURE__ */ Nt(l, {
      viewBox: r || i,
      // eslint-disable-next-line react/no-array-index-key
      key: "label-".concat(c)
    });
  });
  if (!n)
    return o;
  var s = dre(t.label, r || i);
  return [s].concat(Kte(o));
};
It.parseViewBox = $y;
It.renderCallByParent = pre;
function hre(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
var vre = hre;
const mre = /* @__PURE__ */ Je(vre);
function Ts(e) {
  "@babel/helpers - typeof";
  return Ts = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ts(e);
}
var gre = ["valueAccessor"], yre = ["data", "dataKey", "clockWise", "id", "textBreakAll"];
function bre(e) {
  return Ore(e) || wre(e) || xre(e) || Cre();
}
function Cre() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function xre(e, t) {
  if (e) {
    if (typeof e == "string")
      return e0(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return e0(e, t);
  }
}
function wre(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function Ore(e) {
  if (Array.isArray(e))
    return e0(e);
}
function e0(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function W1() {
  return W1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, W1.apply(this, arguments);
}
function B4(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function V4(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? B4(Object(r), !0).forEach(function(n) {
      Sre(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : B4(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Sre(e, t, r) {
  return t = Pre(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Pre(e) {
  var t = Ere(e, "string");
  return Ts(t) == "symbol" ? t : t + "";
}
function Ere(e, t) {
  if (Ts(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Ts(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function H4(e, t) {
  if (e == null)
    return {};
  var r = jre(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function jre(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
var _re = function(t) {
  return Array.isArray(t.value) ? mre(t.value) : t.value;
};
function Zr(e) {
  var t = e.valueAccessor, r = t === void 0 ? _re : t, n = H4(e, gre), a = n.data, i = n.dataKey, o = n.clockWise, s = n.id, l = n.textBreakAll, c = H4(n, yre);
  return !a || !a.length ? null : /* @__PURE__ */ P.createElement(De, {
    className: "recharts-label-list"
  }, a.map(function(u, f) {
    var p = Ce(i) ? r(u, f) : vt(u && u.payload, i), h = Ce(s) ? {} : {
      id: "".concat(s, "-").concat(f)
    };
    return /* @__PURE__ */ P.createElement(It, W1({}, pe(u, !0), c, h, {
      parentViewBox: u.parentViewBox,
      value: p,
      textBreakAll: l,
      viewBox: It.parseViewBox(Ce(o) ? u : V4(V4({}, u), {}, {
        clockWise: o
      })),
      key: "label-".concat(f),
      index: f
    }));
  }));
}
Zr.displayName = "LabelList";
function Dre(e, t) {
  return e ? e === !0 ? /* @__PURE__ */ P.createElement(Zr, {
    key: "labelList-implicit",
    data: t
  }) : /* @__PURE__ */ P.isValidElement(e) || xe(e) ? /* @__PURE__ */ P.createElement(Zr, {
    key: "labelList-implicit",
    data: t,
    content: e
  }) : eo(e) ? /* @__PURE__ */ P.createElement(Zr, W1({
    data: t
  }, e, {
    key: "labelList-implicit"
  })) : null : null;
}
function Are(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!e || !e.children && r && !e.label)
    return null;
  var n = e.children, a = rr(n, Zr).map(function(o, s) {
    return /* @__PURE__ */ Nt(o, {
      data: t,
      // eslint-disable-next-line react/no-array-index-key
      key: "labelList-".concat(s)
    });
  });
  if (!r)
    return a;
  var i = Dre(e.label, t);
  return [i].concat(bre(a));
}
Zr.renderCallByParent = Are;
function $s(e) {
  "@babel/helpers - typeof";
  return $s = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, $s(e);
}
function t0() {
  return t0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, t0.apply(this, arguments);
}
function F4(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function W4(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? F4(Object(r), !0).forEach(function(n) {
      Mre(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : F4(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Mre(e, t, r) {
  return t = Tre(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Tre(e) {
  var t = $re(e, "string");
  return $s(t) == "symbol" ? t : t + "";
}
function $re(e, t) {
  if ($s(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if ($s(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Nre = function(t, r) {
  var n = Jt(r - t), a = Math.min(Math.abs(r - t), 359.999);
  return n * a;
}, Nl = function(t) {
  var r = t.cx, n = t.cy, a = t.radius, i = t.angle, o = t.sign, s = t.isExternal, l = t.cornerRadius, c = t.cornerIsExternal, u = l * (s ? 1 : -1) + a, f = Math.asin(l / u) / F1, p = c ? i : i + o * f, h = ft(r, n, u, p), m = ft(r, n, a, p), v = c ? i - o * f : i, g = ft(r, n, u * Math.cos(f * F1), v);
  return {
    center: h,
    circleTangency: m,
    lineTangency: g,
    theta: f
  };
}, Ny = function(t) {
  var r = t.cx, n = t.cy, a = t.innerRadius, i = t.outerRadius, o = t.startAngle, s = t.endAngle, l = Nre(o, s), c = o + l, u = ft(r, n, i, o), f = ft(r, n, i, c), p = "M ".concat(u.x, ",").concat(u.y, `
    A `).concat(i, ",").concat(i, `,0,
    `).concat(+(Math.abs(l) > 180), ",").concat(+(o > c), `,
    `).concat(f.x, ",").concat(f.y, `
  `);
  if (a > 0) {
    var h = ft(r, n, a, o), m = ft(r, n, a, c);
    p += "L ".concat(m.x, ",").concat(m.y, `
            A `).concat(a, ",").concat(a, `,0,
            `).concat(+(Math.abs(l) > 180), ",").concat(+(o <= c), `,
            `).concat(h.x, ",").concat(h.y, " Z");
  } else
    p += "L ".concat(r, ",").concat(n, " Z");
  return p;
}, Ire = function(t) {
  var r = t.cx, n = t.cy, a = t.innerRadius, i = t.outerRadius, o = t.cornerRadius, s = t.forceCornerRadius, l = t.cornerIsExternal, c = t.startAngle, u = t.endAngle, f = Jt(u - c), p = Nl({
    cx: r,
    cy: n,
    radius: i,
    angle: c,
    sign: f,
    cornerRadius: o,
    cornerIsExternal: l
  }), h = p.circleTangency, m = p.lineTangency, v = p.theta, g = Nl({
    cx: r,
    cy: n,
    radius: i,
    angle: u,
    sign: -f,
    cornerRadius: o,
    cornerIsExternal: l
  }), y = g.circleTangency, b = g.lineTangency, w = g.theta, x = l ? Math.abs(c - u) : Math.abs(c - u) - v - w;
  if (x < 0)
    return s ? "M ".concat(m.x, ",").concat(m.y, `
        a`).concat(o, ",").concat(o, ",0,0,1,").concat(o * 2, `,0
        a`).concat(o, ",").concat(o, ",0,0,1,").concat(-o * 2, `,0
      `) : Ny({
      cx: r,
      cy: n,
      innerRadius: a,
      outerRadius: i,
      startAngle: c,
      endAngle: u
    });
  var C = "M ".concat(m.x, ",").concat(m.y, `
    A`).concat(o, ",").concat(o, ",0,0,").concat(+(f < 0), ",").concat(h.x, ",").concat(h.y, `
    A`).concat(i, ",").concat(i, ",0,").concat(+(x > 180), ",").concat(+(f < 0), ",").concat(y.x, ",").concat(y.y, `
    A`).concat(o, ",").concat(o, ",0,0,").concat(+(f < 0), ",").concat(b.x, ",").concat(b.y, `
  `);
  if (a > 0) {
    var S = Nl({
      cx: r,
      cy: n,
      radius: a,
      angle: c,
      sign: f,
      isExternal: !0,
      cornerRadius: o,
      cornerIsExternal: l
    }), E = S.circleTangency, D = S.lineTangency, I = S.theta, k = Nl({
      cx: r,
      cy: n,
      radius: a,
      angle: u,
      sign: -f,
      isExternal: !0,
      cornerRadius: o,
      cornerIsExternal: l
    }), V = k.circleTangency, W = k.lineTangency, L = k.theta, G = l ? Math.abs(c - u) : Math.abs(c - u) - I - L;
    if (G < 0 && o === 0)
      return "".concat(C, "L").concat(r, ",").concat(n, "Z");
    C += "L".concat(W.x, ",").concat(W.y, `
      A`).concat(o, ",").concat(o, ",0,0,").concat(+(f < 0), ",").concat(V.x, ",").concat(V.y, `
      A`).concat(a, ",").concat(a, ",0,").concat(+(G > 180), ",").concat(+(f > 0), ",").concat(E.x, ",").concat(E.y, `
      A`).concat(o, ",").concat(o, ",0,0,").concat(+(f < 0), ",").concat(D.x, ",").concat(D.y, "Z");
  } else
    C += "L".concat(r, ",").concat(n, "Z");
  return C;
}, Lre = {
  cx: 0,
  cy: 0,
  innerRadius: 0,
  outerRadius: 0,
  startAngle: 0,
  endAngle: 0,
  cornerRadius: 0,
  forceCornerRadius: !1,
  cornerIsExternal: !1
}, Iy = function(t) {
  var r = W4(W4({}, Lre), t), n = r.cx, a = r.cy, i = r.innerRadius, o = r.outerRadius, s = r.cornerRadius, l = r.forceCornerRadius, c = r.cornerIsExternal, u = r.startAngle, f = r.endAngle, p = r.className;
  if (o < i || u === f)
    return null;
  var h = _e("recharts-sector", p), m = o - i, v = er(s, m, 0, !0), g;
  return v > 0 && Math.abs(u - f) < 360 ? g = Ire({
    cx: n,
    cy: a,
    innerRadius: i,
    outerRadius: o,
    cornerRadius: Math.min(v, m / 2),
    forceCornerRadius: l,
    cornerIsExternal: c,
    startAngle: u,
    endAngle: f
  }) : g = Ny({
    cx: n,
    cy: a,
    innerRadius: i,
    outerRadius: o,
    startAngle: u,
    endAngle: f
  }), /* @__PURE__ */ P.createElement("path", t0({}, pe(r, !0), {
    className: h,
    d: g,
    role: "img"
  }));
};
function Ns(e) {
  "@babel/helpers - typeof";
  return Ns = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ns(e);
}
function r0() {
  return r0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, r0.apply(this, arguments);
}
function z4(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function U4(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? z4(Object(r), !0).forEach(function(n) {
      Rre(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : z4(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Rre(e, t, r) {
  return t = kre(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function kre(e) {
  var t = Bre(e, "string");
  return Ns(t) == "symbol" ? t : t + "";
}
function Bre(e, t) {
  if (Ns(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Ns(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Z4 = {
  curveBasisClosed: HH,
  curveBasisOpen: FH,
  curveBasis: VH,
  curveBumpX: EH,
  curveBumpY: jH,
  curveLinearClosed: WH,
  curveLinear: zc,
  curveMonotoneX: zH,
  curveMonotoneY: UH,
  curveNatural: ZH,
  curveStep: qH,
  curveStepAfter: YH,
  curveStepBefore: GH
}, Il = function(t) {
  return t.x === +t.x && t.y === +t.y;
}, _o = function(t) {
  return t.x;
}, Do = function(t) {
  return t.y;
}, Vre = function(t, r) {
  if (xe(t))
    return t;
  var n = "curve".concat(Fc(t));
  return (n === "curveMonotone" || n === "curveBump") && r ? Z4["".concat(n).concat(r === "vertical" ? "Y" : "X")] : Z4[n] || zc;
}, Hre = function(t) {
  var r = t.type, n = r === void 0 ? "linear" : r, a = t.points, i = a === void 0 ? [] : a, o = t.baseLine, s = t.layout, l = t.connectNulls, c = l === void 0 ? !1 : l, u = Vre(n, s), f = c ? i.filter(function(v) {
    return Il(v);
  }) : i, p;
  if (Array.isArray(o)) {
    var h = c ? o.filter(function(v) {
      return Il(v);
    }) : o, m = f.map(function(v, g) {
      return U4(U4({}, v), {}, {
        base: h[g]
      });
    });
    return s === "vertical" ? p = Pl().y(Do).x1(_o).x0(function(v) {
      return v.base.x;
    }) : p = Pl().x(_o).y1(Do).y0(function(v) {
      return v.base.y;
    }), p.defined(Il).curve(u), p(m);
  }
  return s === "vertical" && oe(o) ? p = Pl().y(Do).x1(_o).x0(o) : oe(o) ? p = Pl().x(_o).y1(Do).y0(o) : p = Dm().x(_o).y(Do), p.defined(Il).curve(u), p(f);
}, qn = function(t) {
  var r = t.className, n = t.points, a = t.path, i = t.pathRef;
  if ((!n || !n.length) && !a)
    return null;
  var o = n && n.length ? Hre(t) : a;
  return /* @__PURE__ */ P.createElement("path", r0({}, pe(t, !1), h1(t), {
    className: _e("recharts-curve", r),
    d: o,
    ref: i
  }));
}, Fre = Object.getOwnPropertyNames, Wre = Object.getOwnPropertySymbols, zre = Object.prototype.hasOwnProperty;
function q4(e, t) {
  return function(n, a, i) {
    return e(n, a, i) && t(n, a, i);
  };
}
function Ll(e) {
  return function(r, n, a) {
    if (!r || !n || typeof r != "object" || typeof n != "object")
      return e(r, n, a);
    var i = a.cache, o = i.get(r), s = i.get(n);
    if (o && s)
      return o === n && s === r;
    i.set(r, n), i.set(n, r);
    var l = e(r, n, a);
    return i.delete(r), i.delete(n), l;
  };
}
function G4(e) {
  return Fre(e).concat(Wre(e));
}
var Ly = Object.hasOwn || function(e, t) {
  return zre.call(e, t);
};
function po(e, t) {
  return e || t ? e === t : e === t || e !== e && t !== t;
}
var Ry = "_owner", Y4 = Object.getOwnPropertyDescriptor, K4 = Object.keys;
function Ure(e, t, r) {
  var n = e.length;
  if (t.length !== n)
    return !1;
  for (; n-- > 0; )
    if (!r.equals(e[n], t[n], n, n, e, t, r))
      return !1;
  return !0;
}
function Zre(e, t) {
  return po(e.getTime(), t.getTime());
}
function X4(e, t, r) {
  if (e.size !== t.size)
    return !1;
  for (var n = {}, a = e.entries(), i = 0, o, s; (o = a.next()) && !o.done; ) {
    for (var l = t.entries(), c = !1, u = 0; (s = l.next()) && !s.done; ) {
      var f = o.value, p = f[0], h = f[1], m = s.value, v = m[0], g = m[1];
      !c && !n[u] && (c = r.equals(p, v, i, u, e, t, r) && r.equals(h, g, p, v, e, t, r)) && (n[u] = !0), u++;
    }
    if (!c)
      return !1;
    i++;
  }
  return !0;
}
function qre(e, t, r) {
  var n = K4(e), a = n.length;
  if (K4(t).length !== a)
    return !1;
  for (var i; a-- > 0; )
    if (i = n[a], i === Ry && (e.$$typeof || t.$$typeof) && e.$$typeof !== t.$$typeof || !Ly(t, i) || !r.equals(e[i], t[i], i, i, e, t, r))
      return !1;
  return !0;
}
function Ao(e, t, r) {
  var n = G4(e), a = n.length;
  if (G4(t).length !== a)
    return !1;
  for (var i, o, s; a-- > 0; )
    if (i = n[a], i === Ry && (e.$$typeof || t.$$typeof) && e.$$typeof !== t.$$typeof || !Ly(t, i) || !r.equals(e[i], t[i], i, i, e, t, r) || (o = Y4(e, i), s = Y4(t, i), (o || s) && (!o || !s || o.configurable !== s.configurable || o.enumerable !== s.enumerable || o.writable !== s.writable)))
      return !1;
  return !0;
}
function Gre(e, t) {
  return po(e.valueOf(), t.valueOf());
}
function Yre(e, t) {
  return e.source === t.source && e.flags === t.flags;
}
function Q4(e, t, r) {
  if (e.size !== t.size)
    return !1;
  for (var n = {}, a = e.values(), i, o; (i = a.next()) && !i.done; ) {
    for (var s = t.values(), l = !1, c = 0; (o = s.next()) && !o.done; )
      !l && !n[c] && (l = r.equals(i.value, o.value, i.value, o.value, e, t, r)) && (n[c] = !0), c++;
    if (!l)
      return !1;
  }
  return !0;
}
function Kre(e, t) {
  var r = e.length;
  if (t.length !== r)
    return !1;
  for (; r-- > 0; )
    if (e[r] !== t[r])
      return !1;
  return !0;
}
var Xre = "[object Arguments]", Qre = "[object Boolean]", Jre = "[object Date]", ene = "[object Map]", tne = "[object Number]", rne = "[object Object]", nne = "[object RegExp]", ane = "[object Set]", ine = "[object String]", one = Array.isArray, J4 = typeof ArrayBuffer == "function" && ArrayBuffer.isView ? ArrayBuffer.isView : null, e8 = Object.assign, sne = Object.prototype.toString.call.bind(Object.prototype.toString);
function lne(e) {
  var t = e.areArraysEqual, r = e.areDatesEqual, n = e.areMapsEqual, a = e.areObjectsEqual, i = e.arePrimitiveWrappersEqual, o = e.areRegExpsEqual, s = e.areSetsEqual, l = e.areTypedArraysEqual;
  return function(u, f, p) {
    if (u === f)
      return !0;
    if (u == null || f == null || typeof u != "object" || typeof f != "object")
      return u !== u && f !== f;
    var h = u.constructor;
    if (h !== f.constructor)
      return !1;
    if (h === Object)
      return a(u, f, p);
    if (one(u))
      return t(u, f, p);
    if (J4 != null && J4(u))
      return l(u, f, p);
    if (h === Date)
      return r(u, f, p);
    if (h === RegExp)
      return o(u, f, p);
    if (h === Map)
      return n(u, f, p);
    if (h === Set)
      return s(u, f, p);
    var m = sne(u);
    return m === Jre ? r(u, f, p) : m === nne ? o(u, f, p) : m === ene ? n(u, f, p) : m === ane ? s(u, f, p) : m === rne ? typeof u.then != "function" && typeof f.then != "function" && a(u, f, p) : m === Xre ? a(u, f, p) : m === Qre || m === tne || m === ine ? i(u, f, p) : !1;
  };
}
function cne(e) {
  var t = e.circular, r = e.createCustomConfig, n = e.strict, a = {
    areArraysEqual: n ? Ao : Ure,
    areDatesEqual: Zre,
    areMapsEqual: n ? q4(X4, Ao) : X4,
    areObjectsEqual: n ? Ao : qre,
    arePrimitiveWrappersEqual: Gre,
    areRegExpsEqual: Yre,
    areSetsEqual: n ? q4(Q4, Ao) : Q4,
    areTypedArraysEqual: n ? Ao : Kre
  };
  if (r && (a = e8({}, a, r(a))), t) {
    var i = Ll(a.areArraysEqual), o = Ll(a.areMapsEqual), s = Ll(a.areObjectsEqual), l = Ll(a.areSetsEqual);
    a = e8({}, a, {
      areArraysEqual: i,
      areMapsEqual: o,
      areObjectsEqual: s,
      areSetsEqual: l
    });
  }
  return a;
}
function une(e) {
  return function(t, r, n, a, i, o, s) {
    return e(t, r, s);
  };
}
function fne(e) {
  var t = e.circular, r = e.comparator, n = e.createState, a = e.equals, i = e.strict;
  if (n)
    return function(l, c) {
      var u = n(), f = u.cache, p = f === void 0 ? t ? /* @__PURE__ */ new WeakMap() : void 0 : f, h = u.meta;
      return r(l, c, {
        cache: p,
        equals: a,
        meta: h,
        strict: i
      });
    };
  if (t)
    return function(l, c) {
      return r(l, c, {
        cache: /* @__PURE__ */ new WeakMap(),
        equals: a,
        meta: void 0,
        strict: i
      });
    };
  var o = {
    cache: void 0,
    equals: a,
    meta: void 0,
    strict: i
  };
  return function(l, c) {
    return r(l, c, o);
  };
}
var dne = ca();
ca({ strict: !0 });
ca({ circular: !0 });
ca({
  circular: !0,
  strict: !0
});
ca({
  createInternalComparator: function() {
    return po;
  }
});
ca({
  strict: !0,
  createInternalComparator: function() {
    return po;
  }
});
ca({
  circular: !0,
  createInternalComparator: function() {
    return po;
  }
});
ca({
  circular: !0,
  createInternalComparator: function() {
    return po;
  },
  strict: !0
});
function ca(e) {
  e === void 0 && (e = {});
  var t = e.circular, r = t === void 0 ? !1 : t, n = e.createInternalComparator, a = e.createState, i = e.strict, o = i === void 0 ? !1 : i, s = cne(e), l = lne(s), c = n ? n(l) : une(l);
  return fne({ circular: r, comparator: l, createState: a, equals: c, strict: o });
}
function pne(e) {
  typeof requestAnimationFrame < "u" && requestAnimationFrame(e);
}
function t8(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = -1, n = function a(i) {
    r < 0 && (r = i), i - r > t ? (e(i), r = -1) : pne(a);
  };
  requestAnimationFrame(n);
}
function n0(e) {
  "@babel/helpers - typeof";
  return n0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, n0(e);
}
function hne(e) {
  return yne(e) || gne(e) || mne(e) || vne();
}
function vne() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function mne(e, t) {
  if (e) {
    if (typeof e == "string")
      return r8(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return r8(e, t);
  }
}
function r8(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function gne(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function yne(e) {
  if (Array.isArray(e))
    return e;
}
function bne() {
  var e = {}, t = function() {
    return null;
  }, r = !1, n = function a(i) {
    if (!r) {
      if (Array.isArray(i)) {
        if (!i.length)
          return;
        var o = i, s = hne(o), l = s[0], c = s.slice(1);
        if (typeof l == "number") {
          t8(a.bind(null, c), l);
          return;
        }
        a(l), t8(a.bind(null, c));
        return;
      }
      n0(i) === "object" && (e = i, t(e)), typeof i == "function" && i();
    }
  };
  return {
    stop: function() {
      r = !0;
    },
    start: function(i) {
      r = !1, n(i);
    },
    subscribe: function(i) {
      return t = i, function() {
        t = function() {
          return null;
        };
      };
    }
  };
}
function Is(e) {
  "@babel/helpers - typeof";
  return Is = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Is(e);
}
function n8(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function a8(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? n8(Object(r), !0).forEach(function(n) {
      ky(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : n8(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function ky(e, t, r) {
  return t = Cne(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Cne(e) {
  var t = xne(e, "string");
  return Is(t) === "symbol" ? t : String(t);
}
function xne(e, t) {
  if (Is(e) !== "object" || e === null)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Is(n) !== "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var wne = function(t, r) {
  return [Object.keys(t), Object.keys(r)].reduce(function(n, a) {
    return n.filter(function(i) {
      return a.includes(i);
    });
  });
}, One = function(t) {
  return t;
}, Sne = function(t) {
  return t.replace(/([A-Z])/g, function(r) {
    return "-".concat(r.toLowerCase());
  });
}, Xo = function(t, r) {
  return Object.keys(r).reduce(function(n, a) {
    return a8(a8({}, n), {}, ky({}, a, t(a, r[a])));
  }, {});
}, i8 = function(t, r, n) {
  return t.map(function(a) {
    return "".concat(Sne(a), " ").concat(r, "ms ").concat(n);
  }).join(",");
}, Pne = process.env.NODE_ENV !== "production", z1 = function(t, r, n, a, i, o, s, l) {
  if (Pne && typeof console < "u" && console.warn && (r === void 0 && console.warn("LogUtils requires an error message argument"), !t))
    if (r === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var c = [n, a, i, o, s, l], u = 0;
      console.warn(r.replace(/%s/g, function() {
        return c[u++];
      }));
    }
};
function Ene(e, t) {
  return Dne(e) || _ne(e, t) || By(e, t) || jne();
}
function jne() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _ne(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], l = !0, c = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        l = !1;
      } else
        for (; !(l = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); l = !0)
          ;
    } catch (u) {
      c = !0, a = u;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (c)
          throw a;
      }
    }
    return s;
  }
}
function Dne(e) {
  if (Array.isArray(e))
    return e;
}
function Ane(e) {
  return $ne(e) || Tne(e) || By(e) || Mne();
}
function Mne() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function By(e, t) {
  if (e) {
    if (typeof e == "string")
      return a0(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return a0(e, t);
  }
}
function Tne(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function $ne(e) {
  if (Array.isArray(e))
    return a0(e);
}
function a0(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var U1 = 1e-4, Vy = function(t, r) {
  return [0, 3 * t, 3 * r - 6 * t, 3 * t - 3 * r + 1];
}, Hy = function(t, r) {
  return t.map(function(n, a) {
    return n * Math.pow(r, a);
  }).reduce(function(n, a) {
    return n + a;
  });
}, o8 = function(t, r) {
  return function(n) {
    var a = Vy(t, r);
    return Hy(a, n);
  };
}, Nne = function(t, r) {
  return function(n) {
    var a = Vy(t, r), i = [].concat(Ane(a.map(function(o, s) {
      return o * s;
    }).slice(1)), [0]);
    return Hy(i, n);
  };
}, s8 = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  var a = r[0], i = r[1], o = r[2], s = r[3];
  if (r.length === 1)
    switch (r[0]) {
      case "linear":
        a = 0, i = 0, o = 1, s = 1;
        break;
      case "ease":
        a = 0.25, i = 0.1, o = 0.25, s = 1;
        break;
      case "ease-in":
        a = 0.42, i = 0, o = 1, s = 1;
        break;
      case "ease-out":
        a = 0.42, i = 0, o = 0.58, s = 1;
        break;
      case "ease-in-out":
        a = 0, i = 0, o = 0.58, s = 1;
        break;
      default: {
        var l = r[0].split("(");
        if (l[0] === "cubic-bezier" && l[1].split(")")[0].split(",").length === 4) {
          var c = l[1].split(")")[0].split(",").map(function(g) {
            return parseFloat(g);
          }), u = Ene(c, 4);
          a = u[0], i = u[1], o = u[2], s = u[3];
        } else
          z1(!1, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", r);
      }
    }
  z1([a, o, i, s].every(function(g) {
    return typeof g == "number" && g >= 0 && g <= 1;
  }), "[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s", r);
  var f = o8(a, o), p = o8(i, s), h = Nne(a, o), m = function(y) {
    return y > 1 ? 1 : y < 0 ? 0 : y;
  }, v = function(y) {
    for (var b = y > 1 ? 1 : y, w = b, x = 0; x < 8; ++x) {
      var C = f(w) - b, S = h(w);
      if (Math.abs(C - b) < U1 || S < U1)
        return p(w);
      w = m(w - C / S);
    }
    return p(w);
  };
  return v.isStepper = !1, v;
}, Ine = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = t.stiff, n = r === void 0 ? 100 : r, a = t.damping, i = a === void 0 ? 8 : a, o = t.dt, s = o === void 0 ? 17 : o, l = function(u, f, p) {
    var h = -(u - f) * n, m = p * i, v = p + (h - m) * s / 1e3, g = p * s / 1e3 + u;
    return Math.abs(g - f) < U1 && Math.abs(v) < U1 ? [f, 0] : [g, v];
  };
  return l.isStepper = !0, l.dt = s, l;
}, Lne = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  var a = r[0];
  if (typeof a == "string")
    switch (a) {
      case "ease":
      case "ease-in-out":
      case "ease-out":
      case "ease-in":
      case "linear":
        return s8(a);
      case "spring":
        return Ine();
      default:
        if (a.split("(")[0] === "cubic-bezier")
          return s8(a);
        z1(!1, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", r);
    }
  return typeof a == "function" ? a : (z1(!1, "[configEasing]: first argument type should be function or string, instead received %s", r), null);
};
function Ls(e) {
  "@babel/helpers - typeof";
  return Ls = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ls(e);
}
function l8(e) {
  return Bne(e) || kne(e) || Fy(e) || Rne();
}
function Rne() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function kne(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function Bne(e) {
  if (Array.isArray(e))
    return o0(e);
}
function c8(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Wt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? c8(Object(r), !0).forEach(function(n) {
      i0(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : c8(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function i0(e, t, r) {
  return t = Vne(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Vne(e) {
  var t = Hne(e, "string");
  return Ls(t) === "symbol" ? t : String(t);
}
function Hne(e, t) {
  if (Ls(e) !== "object" || e === null)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Ls(n) !== "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Fne(e, t) {
  return Une(e) || zne(e, t) || Fy(e, t) || Wne();
}
function Wne() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Fy(e, t) {
  if (e) {
    if (typeof e == "string")
      return o0(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return o0(e, t);
  }
}
function o0(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function zne(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], l = !0, c = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        l = !1;
      } else
        for (; !(l = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); l = !0)
          ;
    } catch (u) {
      c = !0, a = u;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (c)
          throw a;
      }
    }
    return s;
  }
}
function Une(e) {
  if (Array.isArray(e))
    return e;
}
var Z1 = function(t, r, n) {
  return t + (r - t) * n;
}, s0 = function(t) {
  var r = t.from, n = t.to;
  return r !== n;
}, Zne = function e(t, r, n) {
  var a = Xo(function(i, o) {
    if (s0(o)) {
      var s = t(o.from, o.to, o.velocity), l = Fne(s, 2), c = l[0], u = l[1];
      return Wt(Wt({}, o), {}, {
        from: c,
        velocity: u
      });
    }
    return o;
  }, r);
  return n < 1 ? Xo(function(i, o) {
    return s0(o) ? Wt(Wt({}, o), {}, {
      velocity: Z1(o.velocity, a[i].velocity, n),
      from: Z1(o.from, a[i].from, n)
    }) : o;
  }, r) : e(t, a, n - 1);
};
const qne = function(e, t, r, n, a) {
  var i = wne(e, t), o = i.reduce(function(g, y) {
    return Wt(Wt({}, g), {}, i0({}, y, [e[y], t[y]]));
  }, {}), s = i.reduce(function(g, y) {
    return Wt(Wt({}, g), {}, i0({}, y, {
      from: e[y],
      velocity: 0,
      to: t[y]
    }));
  }, {}), l = -1, c, u, f = function() {
    return null;
  }, p = function() {
    return Xo(function(y, b) {
      return b.from;
    }, s);
  }, h = function() {
    return !Object.values(s).filter(s0).length;
  }, m = function(y) {
    c || (c = y);
    var b = y - c, w = b / r.dt;
    s = Zne(r, s, w), a(Wt(Wt(Wt({}, e), t), p())), c = y, h() || (l = requestAnimationFrame(f));
  }, v = function(y) {
    u || (u = y);
    var b = (y - u) / n, w = Xo(function(C, S) {
      return Z1.apply(void 0, l8(S).concat([r(b)]));
    }, o);
    if (a(Wt(Wt(Wt({}, e), t), w)), b < 1)
      l = requestAnimationFrame(f);
    else {
      var x = Xo(function(C, S) {
        return Z1.apply(void 0, l8(S).concat([r(1)]));
      }, o);
      a(Wt(Wt(Wt({}, e), t), x));
    }
  };
  return f = r.isStepper ? m : v, function() {
    return requestAnimationFrame(f), function() {
      cancelAnimationFrame(l);
    };
  };
};
function Ai(e) {
  "@babel/helpers - typeof";
  return Ai = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ai(e);
}
var Gne = ["children", "begin", "duration", "attributeName", "easing", "isActive", "steps", "from", "to", "canBegin", "onAnimationEnd", "shouldReAnimate", "onAnimationReStart"];
function Yne(e, t) {
  if (e == null)
    return {};
  var r = Kne(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Kne(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function j2(e) {
  return eae(e) || Jne(e) || Qne(e) || Xne();
}
function Xne() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Qne(e, t) {
  if (e) {
    if (typeof e == "string")
      return l0(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return l0(e, t);
  }
}
function Jne(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function eae(e) {
  if (Array.isArray(e))
    return l0(e);
}
function l0(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function u8(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Br(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? u8(Object(r), !0).forEach(function(n) {
      Lo(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : u8(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Lo(e, t, r) {
  return t = Wy(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function tae(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function f8(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Wy(n.key), n);
  }
}
function rae(e, t, r) {
  return t && f8(e.prototype, t), r && f8(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Wy(e) {
  var t = nae(e, "string");
  return Ai(t) === "symbol" ? t : String(t);
}
function nae(e, t) {
  if (Ai(e) !== "object" || e === null)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Ai(n) !== "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function aae(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && c0(e, t);
}
function c0(e, t) {
  return c0 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, c0(e, t);
}
function iae(e) {
  var t = oae();
  return function() {
    var n = q1(e), a;
    if (t) {
      var i = q1(this).constructor;
      a = Reflect.construct(n, arguments, i);
    } else
      a = n.apply(this, arguments);
    return u0(this, a);
  };
}
function u0(e, t) {
  if (t && (Ai(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return f0(e);
}
function f0(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function oae() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function q1(e) {
  return q1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, q1(e);
}
var Nr = /* @__PURE__ */ function(e) {
  aae(r, e);
  var t = iae(r);
  function r(n, a) {
    var i;
    tae(this, r), i = t.call(this, n, a);
    var o = i.props, s = o.isActive, l = o.attributeName, c = o.from, u = o.to, f = o.steps, p = o.children, h = o.duration;
    if (i.handleStyleChange = i.handleStyleChange.bind(f0(i)), i.changeStyle = i.changeStyle.bind(f0(i)), !s || h <= 0)
      return i.state = {
        style: {}
      }, typeof p == "function" && (i.state = {
        style: u
      }), u0(i);
    if (f && f.length)
      i.state = {
        style: f[0].style
      };
    else if (c) {
      if (typeof p == "function")
        return i.state = {
          style: c
        }, u0(i);
      i.state = {
        style: l ? Lo({}, l, c) : c
      };
    } else
      i.state = {
        style: {}
      };
    return i;
  }
  return rae(r, [{
    key: "componentDidMount",
    value: function() {
      var a = this.props, i = a.isActive, o = a.canBegin;
      this.mounted = !0, !(!i || !o) && this.runAnimation(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function(a) {
      var i = this.props, o = i.isActive, s = i.canBegin, l = i.attributeName, c = i.shouldReAnimate, u = i.to, f = i.from, p = this.state.style;
      if (s) {
        if (!o) {
          var h = {
            style: l ? Lo({}, l, u) : u
          };
          this.state && p && (l && p[l] !== u || !l && p !== u) && this.setState(h);
          return;
        }
        if (!(dne(a.to, u) && a.canBegin && a.isActive)) {
          var m = !a.canBegin || !a.isActive;
          this.manager && this.manager.stop(), this.stopJSAnimation && this.stopJSAnimation();
          var v = m || c ? f : a.to;
          if (this.state && p) {
            var g = {
              style: l ? Lo({}, l, v) : v
            };
            (l && p[l] !== v || !l && p !== v) && this.setState(g);
          }
          this.runAnimation(Br(Br({}, this.props), {}, {
            from: v,
            begin: 0
          }));
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.mounted = !1;
      var a = this.props.onAnimationEnd;
      this.unSubscribe && this.unSubscribe(), this.manager && (this.manager.stop(), this.manager = null), this.stopJSAnimation && this.stopJSAnimation(), a && a();
    }
  }, {
    key: "handleStyleChange",
    value: function(a) {
      this.changeStyle(a);
    }
  }, {
    key: "changeStyle",
    value: function(a) {
      this.mounted && this.setState({
        style: a
      });
    }
  }, {
    key: "runJSAnimation",
    value: function(a) {
      var i = this, o = a.from, s = a.to, l = a.duration, c = a.easing, u = a.begin, f = a.onAnimationEnd, p = a.onAnimationStart, h = qne(o, s, Lne(c), l, this.changeStyle), m = function() {
        i.stopJSAnimation = h();
      };
      this.manager.start([p, u, m, l, f]);
    }
  }, {
    key: "runStepAnimation",
    value: function(a) {
      var i = this, o = a.steps, s = a.begin, l = a.onAnimationStart, c = o[0], u = c.style, f = c.duration, p = f === void 0 ? 0 : f, h = function(v, g, y) {
        if (y === 0)
          return v;
        var b = g.duration, w = g.easing, x = w === void 0 ? "ease" : w, C = g.style, S = g.properties, E = g.onAnimationEnd, D = y > 0 ? o[y - 1] : g, I = S || Object.keys(C);
        if (typeof x == "function" || x === "spring")
          return [].concat(j2(v), [i.runJSAnimation.bind(i, {
            from: D.style,
            to: C,
            duration: b,
            easing: x
          }), b]);
        var k = i8(I, b, x), V = Br(Br(Br({}, D.style), C), {}, {
          transition: k
        });
        return [].concat(j2(v), [V, b, E]).filter(One);
      };
      return this.manager.start([l].concat(j2(o.reduce(h, [u, Math.max(p, s)])), [a.onAnimationEnd]));
    }
  }, {
    key: "runAnimation",
    value: function(a) {
      this.manager || (this.manager = bne());
      var i = a.begin, o = a.duration, s = a.attributeName, l = a.to, c = a.easing, u = a.onAnimationStart, f = a.onAnimationEnd, p = a.steps, h = a.children, m = this.manager;
      if (this.unSubscribe = m.subscribe(this.handleStyleChange), typeof c == "function" || typeof h == "function" || c === "spring") {
        this.runJSAnimation(a);
        return;
      }
      if (p.length > 1) {
        this.runStepAnimation(a);
        return;
      }
      var v = s ? Lo({}, s, l) : l, g = i8(Object.keys(v), o, c);
      m.start([u, i, Br(Br({}, v), {}, {
        transition: g
      }), o, f]);
    }
  }, {
    key: "render",
    value: function() {
      var a = this.props, i = a.children;
      a.begin;
      var o = a.duration;
      a.attributeName, a.easing;
      var s = a.isActive;
      a.steps, a.from, a.to, a.canBegin, a.onAnimationEnd, a.shouldReAnimate, a.onAnimationReStart;
      var l = Yne(a, Gne), c = Ma.count(i), u = this.state.style;
      if (typeof i == "function")
        return i(u);
      if (!s || c === 0 || o <= 0)
        return i;
      var f = function(h) {
        var m = h.props, v = m.style, g = v === void 0 ? {} : v, y = m.className, b = /* @__PURE__ */ Nt(h, Br(Br({}, l), {}, {
          style: Br(Br({}, g), u),
          className: y
        }));
        return b;
      };
      return c === 1 ? f(Ma.only(i)) : /* @__PURE__ */ P.createElement("div", null, Ma.map(i, function(p) {
        return f(p);
      }));
    }
  }]), r;
}(Cr);
Nr.displayName = "Animate";
Nr.defaultProps = {
  begin: 0,
  duration: 1e3,
  from: "",
  to: "",
  attributeName: "",
  easing: "ease",
  isActive: !0,
  canBegin: !0,
  steps: [],
  onAnimationEnd: function() {
  },
  onAnimationStart: function() {
  }
};
Nr.propTypes = {
  from: Se.oneOfType([Se.object, Se.string]),
  to: Se.oneOfType([Se.object, Se.string]),
  attributeName: Se.string,
  // animation duration
  duration: Se.number,
  begin: Se.number,
  easing: Se.oneOfType([Se.string, Se.func]),
  steps: Se.arrayOf(Se.shape({
    duration: Se.number.isRequired,
    style: Se.object.isRequired,
    easing: Se.oneOfType([Se.oneOf(["ease", "ease-in", "ease-out", "ease-in-out", "linear"]), Se.func]),
    // transition css properties(dash case), optional
    properties: Se.arrayOf("string"),
    onAnimationEnd: Se.func
  })),
  children: Se.oneOfType([Se.node, Se.func]),
  isActive: Se.bool,
  canBegin: Se.bool,
  onAnimationEnd: Se.func,
  // decide if it should reanimate with initial from style when props change
  shouldReAnimate: Se.bool,
  onAnimationStart: Se.func,
  onAnimationReStart: Se.func
};
Se.object, Se.object, Se.object, Se.element;
Se.object, Se.object, Se.object, Se.oneOfType([Se.array, Se.element]), Se.any;
function Rs(e) {
  "@babel/helpers - typeof";
  return Rs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Rs(e);
}
function G1() {
  return G1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, G1.apply(this, arguments);
}
function sae(e, t) {
  return fae(e) || uae(e, t) || cae(e, t) || lae();
}
function lae() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function cae(e, t) {
  if (e) {
    if (typeof e == "string")
      return d8(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return d8(e, t);
  }
}
function d8(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function uae(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], l = !0, c = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        l = !1;
      } else
        for (; !(l = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); l = !0)
          ;
    } catch (u) {
      c = !0, a = u;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (c)
          throw a;
      }
    }
    return s;
  }
}
function fae(e) {
  if (Array.isArray(e))
    return e;
}
function p8(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function h8(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? p8(Object(r), !0).forEach(function(n) {
      dae(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : p8(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function dae(e, t, r) {
  return t = pae(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function pae(e) {
  var t = hae(e, "string");
  return Rs(t) == "symbol" ? t : t + "";
}
function hae(e, t) {
  if (Rs(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Rs(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var v8 = function(t, r, n, a, i) {
  var o = Math.min(Math.abs(n) / 2, Math.abs(a) / 2), s = a >= 0 ? 1 : -1, l = n >= 0 ? 1 : -1, c = a >= 0 && n >= 0 || a < 0 && n < 0 ? 1 : 0, u;
  if (o > 0 && i instanceof Array) {
    for (var f = [0, 0, 0, 0], p = 0, h = 4; p < h; p++)
      f[p] = i[p] > o ? o : i[p];
    u = "M".concat(t, ",").concat(r + s * f[0]), f[0] > 0 && (u += "A ".concat(f[0], ",").concat(f[0], ",0,0,").concat(c, ",").concat(t + l * f[0], ",").concat(r)), u += "L ".concat(t + n - l * f[1], ",").concat(r), f[1] > 0 && (u += "A ".concat(f[1], ",").concat(f[1], ",0,0,").concat(c, `,
        `).concat(t + n, ",").concat(r + s * f[1])), u += "L ".concat(t + n, ",").concat(r + a - s * f[2]), f[2] > 0 && (u += "A ".concat(f[2], ",").concat(f[2], ",0,0,").concat(c, `,
        `).concat(t + n - l * f[2], ",").concat(r + a)), u += "L ".concat(t + l * f[3], ",").concat(r + a), f[3] > 0 && (u += "A ".concat(f[3], ",").concat(f[3], ",0,0,").concat(c, `,
        `).concat(t, ",").concat(r + a - s * f[3])), u += "Z";
  } else if (o > 0 && i === +i && i > 0) {
    var m = Math.min(o, i);
    u = "M ".concat(t, ",").concat(r + s * m, `
            A `).concat(m, ",").concat(m, ",0,0,").concat(c, ",").concat(t + l * m, ",").concat(r, `
            L `).concat(t + n - l * m, ",").concat(r, `
            A `).concat(m, ",").concat(m, ",0,0,").concat(c, ",").concat(t + n, ",").concat(r + s * m, `
            L `).concat(t + n, ",").concat(r + a - s * m, `
            A `).concat(m, ",").concat(m, ",0,0,").concat(c, ",").concat(t + n - l * m, ",").concat(r + a, `
            L `).concat(t + l * m, ",").concat(r + a, `
            A `).concat(m, ",").concat(m, ",0,0,").concat(c, ",").concat(t, ",").concat(r + a - s * m, " Z");
  } else
    u = "M ".concat(t, ",").concat(r, " h ").concat(n, " v ").concat(a, " h ").concat(-n, " Z");
  return u;
}, vae = function(t, r) {
  if (!t || !r)
    return !1;
  var n = t.x, a = t.y, i = r.x, o = r.y, s = r.width, l = r.height;
  if (Math.abs(s) > 0 && Math.abs(l) > 0) {
    var c = Math.min(i, i + s), u = Math.max(i, i + s), f = Math.min(o, o + l), p = Math.max(o, o + l);
    return n >= c && n <= u && a >= f && a <= p;
  }
  return !1;
}, mae = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  // The radius of border
  // The radius of four corners when radius is a number
  // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
  radius: 0,
  isAnimationActive: !1,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, Ld = function(t) {
  var r = h8(h8({}, mae), t), n = ye(), a = je(-1), i = sae(a, 2), o = i[0], s = i[1];
  Me(function() {
    if (n.current && n.current.getTotalLength)
      try {
        var x = n.current.getTotalLength();
        x && s(x);
      } catch {
      }
  }, []);
  var l = r.x, c = r.y, u = r.width, f = r.height, p = r.radius, h = r.className, m = r.animationEasing, v = r.animationDuration, g = r.animationBegin, y = r.isAnimationActive, b = r.isUpdateAnimationActive;
  if (l !== +l || c !== +c || u !== +u || f !== +f || u === 0 || f === 0)
    return null;
  var w = _e("recharts-rectangle", h);
  return b ? /* @__PURE__ */ P.createElement(Nr, {
    canBegin: o > 0,
    from: {
      width: u,
      height: f,
      x: l,
      y: c
    },
    to: {
      width: u,
      height: f,
      x: l,
      y: c
    },
    duration: v,
    animationEasing: m,
    isActive: b
  }, function(x) {
    var C = x.width, S = x.height, E = x.x, D = x.y;
    return /* @__PURE__ */ P.createElement(Nr, {
      canBegin: o > 0,
      from: "0px ".concat(o === -1 ? 1 : o, "px"),
      to: "".concat(o, "px 0px"),
      attributeName: "strokeDasharray",
      begin: g,
      duration: v,
      isActive: y,
      easing: m
    }, /* @__PURE__ */ P.createElement("path", G1({}, pe(r, !0), {
      className: w,
      d: v8(E, D, C, S, p),
      ref: n
    })));
  }) : /* @__PURE__ */ P.createElement("path", G1({}, pe(r, !0), {
    className: w,
    d: v8(l, c, u, f, p)
  }));
}, gae = ["points", "className", "baseLinePoints", "connectNulls"];
function li() {
  return li = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, li.apply(this, arguments);
}
function yae(e, t) {
  if (e == null)
    return {};
  var r = bae(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function bae(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function m8(e) {
  return Oae(e) || wae(e) || xae(e) || Cae();
}
function Cae() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function xae(e, t) {
  if (e) {
    if (typeof e == "string")
      return d0(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return d0(e, t);
  }
}
function wae(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function Oae(e) {
  if (Array.isArray(e))
    return d0(e);
}
function d0(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var g8 = function(t) {
  return t && t.x === +t.x && t.y === +t.y;
}, Sae = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], r = [[]];
  return t.forEach(function(n) {
    g8(n) ? r[r.length - 1].push(n) : r[r.length - 1].length > 0 && r.push([]);
  }), g8(t[0]) && r[r.length - 1].push(t[0]), r[r.length - 1].length <= 0 && (r = r.slice(0, -1)), r;
}, Qo = function(t, r) {
  var n = Sae(t);
  r && (n = [n.reduce(function(i, o) {
    return [].concat(m8(i), m8(o));
  }, [])]);
  var a = n.map(function(i) {
    return i.reduce(function(o, s, l) {
      return "".concat(o).concat(l === 0 ? "M" : "L").concat(s.x, ",").concat(s.y);
    }, "");
  }).join("");
  return n.length === 1 ? "".concat(a, "Z") : a;
}, Pae = function(t, r, n) {
  var a = Qo(t, n);
  return "".concat(a.slice(-1) === "Z" ? a.slice(0, -1) : a, "L").concat(Qo(r.reverse(), n).slice(1));
}, Eae = function(t) {
  var r = t.points, n = t.className, a = t.baseLinePoints, i = t.connectNulls, o = yae(t, gae);
  if (!r || !r.length)
    return null;
  var s = _e("recharts-polygon", n);
  if (a && a.length) {
    var l = o.stroke && o.stroke !== "none", c = Pae(r, a, i);
    return /* @__PURE__ */ P.createElement("g", {
      className: s
    }, /* @__PURE__ */ P.createElement("path", li({}, pe(o, !0), {
      fill: c.slice(-1) === "Z" ? o.fill : "none",
      stroke: "none",
      d: c
    })), l ? /* @__PURE__ */ P.createElement("path", li({}, pe(o, !0), {
      fill: "none",
      d: Qo(r, i)
    })) : null, l ? /* @__PURE__ */ P.createElement("path", li({}, pe(o, !0), {
      fill: "none",
      d: Qo(a, i)
    })) : null);
  }
  var u = Qo(r, i);
  return /* @__PURE__ */ P.createElement("path", li({}, pe(o, !0), {
    fill: u.slice(-1) === "Z" ? o.fill : "none",
    className: s,
    d: u
  }));
};
function p0() {
  return p0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, p0.apply(this, arguments);
}
var pl = function(t) {
  var r = t.cx, n = t.cy, a = t.r, i = t.className, o = _e("recharts-dot", i);
  return r === +r && n === +n && a === +a ? /* @__PURE__ */ P.createElement("circle", p0({}, pe(t, !1), h1(t), {
    className: o,
    cx: r,
    cy: n,
    r: a
  })) : null;
};
function ks(e) {
  "@babel/helpers - typeof";
  return ks = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ks(e);
}
var jae = ["x", "y", "top", "left", "width", "height", "className"];
function h0() {
  return h0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, h0.apply(this, arguments);
}
function y8(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function _ae(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? y8(Object(r), !0).forEach(function(n) {
      Dae(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : y8(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Dae(e, t, r) {
  return t = Aae(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Aae(e) {
  var t = Mae(e, "string");
  return ks(t) == "symbol" ? t : t + "";
}
function Mae(e, t) {
  if (ks(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (ks(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Tae(e, t) {
  if (e == null)
    return {};
  var r = $ae(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function $ae(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
var Nae = function(t, r, n, a, i, o) {
  return "M".concat(t, ",").concat(i, "v").concat(a, "M").concat(o, ",").concat(r, "h").concat(n);
}, Iae = function(t) {
  var r = t.x, n = r === void 0 ? 0 : r, a = t.y, i = a === void 0 ? 0 : a, o = t.top, s = o === void 0 ? 0 : o, l = t.left, c = l === void 0 ? 0 : l, u = t.width, f = u === void 0 ? 0 : u, p = t.height, h = p === void 0 ? 0 : p, m = t.className, v = Tae(t, jae), g = _ae({
    x: n,
    y: i,
    top: s,
    left: c,
    width: f,
    height: h
  }, v);
  return !oe(n) || !oe(i) || !oe(f) || !oe(h) || !oe(s) || !oe(c) ? null : /* @__PURE__ */ P.createElement("path", h0({}, pe(g, !0), {
    className: _e("recharts-cross", m),
    d: Nae(n, i, f, h, s, c)
  }));
}, Lae = ru, Rae = ny, kae = pn;
function Bae(e, t) {
  return e && e.length ? Lae(e, kae(t), Rae) : void 0;
}
var Vae = Bae;
const Hae = /* @__PURE__ */ Je(Vae);
var Fae = ru, Wae = pn, zae = ay;
function Uae(e, t) {
  return e && e.length ? Fae(e, Wae(t), zae) : void 0;
}
var Zae = Uae;
const qae = /* @__PURE__ */ Je(Zae);
var Gae = ["cx", "cy", "angle", "ticks", "axisLine"], Yae = ["ticks", "tick", "angle", "tickFormatter", "stroke"];
function Mi(e) {
  "@babel/helpers - typeof";
  return Mi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Mi(e);
}
function Jo() {
  return Jo = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Jo.apply(this, arguments);
}
function b8(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ma(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? b8(Object(r), !0).forEach(function(n) {
      ou(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : b8(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function C8(e, t) {
  if (e == null)
    return {};
  var r = Kae(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Kae(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function Xae(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function x8(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Uy(n.key), n);
  }
}
function Qae(e, t, r) {
  return t && x8(e.prototype, t), r && x8(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Jae(e, t, r) {
  return t = Y1(t), eie(e, zy() ? Reflect.construct(t, r || [], Y1(e).constructor) : t.apply(e, r));
}
function eie(e, t) {
  if (t && (Mi(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return tie(e);
}
function tie(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function zy() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (zy = function() {
    return !!e;
  })();
}
function Y1(e) {
  return Y1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Y1(e);
}
function rie(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && v0(e, t);
}
function v0(e, t) {
  return v0 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, v0(e, t);
}
function ou(e, t, r) {
  return t = Uy(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Uy(e) {
  var t = nie(e, "string");
  return Mi(t) == "symbol" ? t : t + "";
}
function nie(e, t) {
  if (Mi(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Mi(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var su = /* @__PURE__ */ function(e) {
  function t() {
    return Xae(this, t), Jae(this, t, arguments);
  }
  return rie(t, e), Qae(t, [{
    key: "getTickValueCoord",
    value: (
      /**
       * Calculate the coordinate of tick
       * @param  {Number} coordinate The radius of tick
       * @return {Object} (x, y)
       */
      function(n) {
        var a = n.coordinate, i = this.props, o = i.angle, s = i.cx, l = i.cy;
        return ft(s, l, a, o);
      }
    )
  }, {
    key: "getTickTextAnchor",
    value: function() {
      var n = this.props.orientation, a;
      switch (n) {
        case "left":
          a = "end";
          break;
        case "right":
          a = "start";
          break;
        default:
          a = "middle";
          break;
      }
      return a;
    }
  }, {
    key: "getViewBox",
    value: function() {
      var n = this.props, a = n.cx, i = n.cy, o = n.angle, s = n.ticks, l = Hae(s, function(u) {
        return u.coordinate || 0;
      }), c = qae(s, function(u) {
        return u.coordinate || 0;
      });
      return {
        cx: a,
        cy: i,
        startAngle: o,
        endAngle: o,
        innerRadius: c.coordinate || 0,
        outerRadius: l.coordinate || 0
      };
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var n = this.props, a = n.cx, i = n.cy, o = n.angle, s = n.ticks, l = n.axisLine, c = C8(n, Gae), u = s.reduce(function(m, v) {
        return [Math.min(m[0], v.coordinate), Math.max(m[1], v.coordinate)];
      }, [1 / 0, -1 / 0]), f = ft(a, i, u[0], o), p = ft(a, i, u[1], o), h = ma(ma(ma({}, pe(c, !1)), {}, {
        fill: "none"
      }, pe(l, !1)), {}, {
        x1: f.x,
        y1: f.y,
        x2: p.x,
        y2: p.y
      });
      return /* @__PURE__ */ P.createElement("line", Jo({
        className: "recharts-polar-radius-axis-line"
      }, h));
    }
  }, {
    key: "renderTicks",
    value: function() {
      var n = this, a = this.props, i = a.ticks, o = a.tick, s = a.angle, l = a.tickFormatter, c = a.stroke, u = C8(a, Yae), f = this.getTickTextAnchor(), p = pe(u, !1), h = pe(o, !1), m = i.map(function(v, g) {
        var y = n.getTickValueCoord(v), b = ma(ma(ma(ma({
          textAnchor: f,
          transform: "rotate(".concat(90 - s, ", ").concat(y.x, ", ").concat(y.y, ")")
        }, p), {}, {
          stroke: "none",
          fill: c
        }, h), {}, {
          index: g
        }, y), {}, {
          payload: v
        });
        return /* @__PURE__ */ P.createElement(De, Jo({
          className: _e("recharts-polar-radius-axis-tick", Ty(o)),
          key: "tick-".concat(v.coordinate)
        }, Kn(n.props, v, g)), t.renderTickItem(o, b, l ? l(v.value, g) : v.value));
      });
      return /* @__PURE__ */ P.createElement(De, {
        className: "recharts-polar-radius-axis-ticks"
      }, m);
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, a = n.ticks, i = n.axisLine, o = n.tick;
      return !a || !a.length ? null : /* @__PURE__ */ P.createElement(De, {
        className: _e("recharts-polar-radius-axis", this.props.className)
      }, i && this.renderAxisLine(), o && this.renderTicks(), It.renderCallByParent(this.props, this.getViewBox()));
    }
  }], [{
    key: "renderTickItem",
    value: function(n, a, i) {
      var o;
      return /* @__PURE__ */ P.isValidElement(n) ? o = /* @__PURE__ */ P.cloneElement(n, a) : xe(n) ? o = n(a) : o = /* @__PURE__ */ P.createElement(La, Jo({}, a, {
        className: "recharts-polar-radius-axis-tick-value"
      }), i), o;
    }
  }]);
}(Cr);
ou(su, "displayName", "PolarRadiusAxis");
ou(su, "axisType", "radiusAxis");
ou(su, "defaultProps", {
  type: "number",
  radiusAxisId: 0,
  cx: 0,
  cy: 0,
  angle: 0,
  orientation: "right",
  stroke: "#ccc",
  axisLine: !0,
  tick: !0,
  tickCount: 5,
  allowDataOverflow: !1,
  scale: "auto",
  allowDuplicatedCategory: !0
});
function Ti(e) {
  "@babel/helpers - typeof";
  return Ti = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ti(e);
}
function Pa() {
  return Pa = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Pa.apply(this, arguments);
}
function w8(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ga(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? w8(Object(r), !0).forEach(function(n) {
      lu(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : w8(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function aie(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function O8(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, qy(n.key), n);
  }
}
function iie(e, t, r) {
  return t && O8(e.prototype, t), r && O8(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function oie(e, t, r) {
  return t = K1(t), sie(e, Zy() ? Reflect.construct(t, r || [], K1(e).constructor) : t.apply(e, r));
}
function sie(e, t) {
  if (t && (Ti(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return lie(e);
}
function lie(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Zy() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Zy = function() {
    return !!e;
  })();
}
function K1(e) {
  return K1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, K1(e);
}
function cie(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && m0(e, t);
}
function m0(e, t) {
  return m0 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, m0(e, t);
}
function lu(e, t, r) {
  return t = qy(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function qy(e) {
  var t = uie(e, "string");
  return Ti(t) == "symbol" ? t : t + "";
}
function uie(e, t) {
  if (Ti(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Ti(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var fie = Math.PI / 180, S8 = 1e-5, cu = /* @__PURE__ */ function(e) {
  function t() {
    return aie(this, t), oie(this, t, arguments);
  }
  return cie(t, e), iie(t, [{
    key: "getTickLineCoord",
    value: (
      /**
       * Calculate the coordinate of line endpoint
       * @param  {Object} data The Data if ticks
       * @return {Object} (x0, y0): The start point of text,
       *                  (x1, y1): The end point close to text,
       *                  (x2, y2): The end point close to axis
       */
      function(n) {
        var a = this.props, i = a.cx, o = a.cy, s = a.radius, l = a.orientation, c = a.tickSize, u = c || 8, f = ft(i, o, s, n.coordinate), p = ft(i, o, s + (l === "inner" ? -1 : 1) * u, n.coordinate);
        return {
          x1: f.x,
          y1: f.y,
          x2: p.x,
          y2: p.y
        };
      }
    )
    /**
     * Get the text-anchor of each tick
     * @param  {Object} data Data of ticks
     * @return {String} text-anchor
     */
  }, {
    key: "getTickTextAnchor",
    value: function(n) {
      var a = this.props.orientation, i = Math.cos(-n.coordinate * fie), o;
      return i > S8 ? o = a === "outer" ? "start" : "end" : i < -S8 ? o = a === "outer" ? "end" : "start" : o = "middle", o;
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var n = this.props, a = n.cx, i = n.cy, o = n.radius, s = n.axisLine, l = n.axisLineType, c = ga(ga({}, pe(this.props, !1)), {}, {
        fill: "none"
      }, pe(s, !1));
      if (l === "circle")
        return /* @__PURE__ */ P.createElement(pl, Pa({
          className: "recharts-polar-angle-axis-line"
        }, c, {
          cx: a,
          cy: i,
          r: o
        }));
      var u = this.props.ticks, f = u.map(function(p) {
        return ft(a, i, o, p.coordinate);
      });
      return /* @__PURE__ */ P.createElement(Eae, Pa({
        className: "recharts-polar-angle-axis-line"
      }, c, {
        points: f
      }));
    }
  }, {
    key: "renderTicks",
    value: function() {
      var n = this, a = this.props, i = a.ticks, o = a.tick, s = a.tickLine, l = a.tickFormatter, c = a.stroke, u = pe(this.props, !1), f = pe(o, !1), p = ga(ga({}, u), {}, {
        fill: "none"
      }, pe(s, !1)), h = i.map(function(m, v) {
        var g = n.getTickLineCoord(m), y = n.getTickTextAnchor(m), b = ga(ga(ga({
          textAnchor: y
        }, u), {}, {
          stroke: "none",
          fill: c
        }, f), {}, {
          index: v,
          payload: m,
          x: g.x2,
          y: g.y2
        });
        return /* @__PURE__ */ P.createElement(De, Pa({
          className: _e("recharts-polar-angle-axis-tick", Ty(o)),
          key: "tick-".concat(m.coordinate)
        }, Kn(n.props, m, v)), s && /* @__PURE__ */ P.createElement("line", Pa({
          className: "recharts-polar-angle-axis-tick-line"
        }, p, g)), o && t.renderTickItem(o, b, l ? l(m.value, v) : m.value));
      });
      return /* @__PURE__ */ P.createElement(De, {
        className: "recharts-polar-angle-axis-ticks"
      }, h);
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, a = n.ticks, i = n.radius, o = n.axisLine;
      return i <= 0 || !a || !a.length ? null : /* @__PURE__ */ P.createElement(De, {
        className: _e("recharts-polar-angle-axis", this.props.className)
      }, o && this.renderAxisLine(), this.renderTicks());
    }
  }], [{
    key: "renderTickItem",
    value: function(n, a, i) {
      var o;
      return /* @__PURE__ */ P.isValidElement(n) ? o = /* @__PURE__ */ P.cloneElement(n, a) : xe(n) ? o = n(a) : o = /* @__PURE__ */ P.createElement(La, Pa({}, a, {
        className: "recharts-polar-angle-axis-tick-value"
      }), i), o;
    }
  }]);
}(Cr);
lu(cu, "displayName", "PolarAngleAxis");
lu(cu, "axisType", "angleAxis");
lu(cu, "defaultProps", {
  type: "category",
  angleAxisId: 0,
  scale: "auto",
  cx: 0,
  cy: 0,
  orientation: "outer",
  axisLine: !0,
  tickLine: !0,
  tickSize: 8,
  tick: !0,
  hide: !1,
  allowDuplicatedCategory: !0
});
var die = Jm, pie = die(Object.getPrototypeOf, Object), hie = pie, vie = $n, mie = hie, gie = Nn, yie = "[object Object]", bie = Function.prototype, Cie = Object.prototype, Gy = bie.toString, xie = Cie.hasOwnProperty, wie = Gy.call(Object);
function Oie(e) {
  if (!gie(e) || vie(e) != yie)
    return !1;
  var t = mie(e);
  if (t === null)
    return !0;
  var r = xie.call(t, "constructor") && t.constructor;
  return typeof r == "function" && r instanceof r && Gy.call(r) == wie;
}
var Sie = Oie;
const Pie = /* @__PURE__ */ Je(Sie);
var Eie = $n, jie = Nn, _ie = "[object Boolean]";
function Die(e) {
  return e === !0 || e === !1 || jie(e) && Eie(e) == _ie;
}
var Aie = Die;
const Mie = /* @__PURE__ */ Je(Aie);
function Bs(e) {
  "@babel/helpers - typeof";
  return Bs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Bs(e);
}
function X1() {
  return X1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, X1.apply(this, arguments);
}
function Tie(e, t) {
  return Lie(e) || Iie(e, t) || Nie(e, t) || $ie();
}
function $ie() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Nie(e, t) {
  if (e) {
    if (typeof e == "string")
      return P8(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return P8(e, t);
  }
}
function P8(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function Iie(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], l = !0, c = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        l = !1;
      } else
        for (; !(l = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); l = !0)
          ;
    } catch (u) {
      c = !0, a = u;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (c)
          throw a;
      }
    }
    return s;
  }
}
function Lie(e) {
  if (Array.isArray(e))
    return e;
}
function E8(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function j8(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? E8(Object(r), !0).forEach(function(n) {
      Rie(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : E8(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Rie(e, t, r) {
  return t = kie(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function kie(e) {
  var t = Bie(e, "string");
  return Bs(t) == "symbol" ? t : t + "";
}
function Bie(e, t) {
  if (Bs(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Bs(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var _8 = function(t, r, n, a, i) {
  var o = n - a, s;
  return s = "M ".concat(t, ",").concat(r), s += "L ".concat(t + n, ",").concat(r), s += "L ".concat(t + n - o / 2, ",").concat(r + i), s += "L ".concat(t + n - o / 2 - a, ",").concat(r + i), s += "L ".concat(t, ",").concat(r, " Z"), s;
}, Vie = {
  x: 0,
  y: 0,
  upperWidth: 0,
  lowerWidth: 0,
  height: 0,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, Hie = function(t) {
  var r = j8(j8({}, Vie), t), n = ye(), a = je(-1), i = Tie(a, 2), o = i[0], s = i[1];
  Me(function() {
    if (n.current && n.current.getTotalLength)
      try {
        var w = n.current.getTotalLength();
        w && s(w);
      } catch {
      }
  }, []);
  var l = r.x, c = r.y, u = r.upperWidth, f = r.lowerWidth, p = r.height, h = r.className, m = r.animationEasing, v = r.animationDuration, g = r.animationBegin, y = r.isUpdateAnimationActive;
  if (l !== +l || c !== +c || u !== +u || f !== +f || p !== +p || u === 0 && f === 0 || p === 0)
    return null;
  var b = _e("recharts-trapezoid", h);
  return y ? /* @__PURE__ */ P.createElement(Nr, {
    canBegin: o > 0,
    from: {
      upperWidth: 0,
      lowerWidth: 0,
      height: p,
      x: l,
      y: c
    },
    to: {
      upperWidth: u,
      lowerWidth: f,
      height: p,
      x: l,
      y: c
    },
    duration: v,
    animationEasing: m,
    isActive: y
  }, function(w) {
    var x = w.upperWidth, C = w.lowerWidth, S = w.height, E = w.x, D = w.y;
    return /* @__PURE__ */ P.createElement(Nr, {
      canBegin: o > 0,
      from: "0px ".concat(o === -1 ? 1 : o, "px"),
      to: "".concat(o, "px 0px"),
      attributeName: "strokeDasharray",
      begin: g,
      duration: v,
      easing: m
    }, /* @__PURE__ */ P.createElement("path", X1({}, pe(r, !0), {
      className: b,
      d: _8(E, D, x, C, S),
      ref: n
    })));
  }) : /* @__PURE__ */ P.createElement("g", null, /* @__PURE__ */ P.createElement("path", X1({}, pe(r, !0), {
    className: b,
    d: _8(l, c, u, f, p)
  })));
}, Fie = ["option", "shapeType", "propTransformer", "activeClassName", "isActive"];
function Vs(e) {
  "@babel/helpers - typeof";
  return Vs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Vs(e);
}
function Wie(e, t) {
  if (e == null)
    return {};
  var r = zie(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function zie(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function D8(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Q1(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? D8(Object(r), !0).forEach(function(n) {
      Uie(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : D8(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Uie(e, t, r) {
  return t = Zie(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Zie(e) {
  var t = qie(e, "string");
  return Vs(t) == "symbol" ? t : t + "";
}
function qie(e, t) {
  if (Vs(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Vs(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Gie(e, t) {
  return Q1(Q1({}, t), e);
}
function Yie(e, t) {
  return e === "symbols";
}
function A8(e) {
  var t = e.shapeType, r = e.elementProps;
  switch (t) {
    case "rectangle":
      return /* @__PURE__ */ P.createElement(Ld, r);
    case "trapezoid":
      return /* @__PURE__ */ P.createElement(Hie, r);
    case "sector":
      return /* @__PURE__ */ P.createElement(Iy, r);
    case "symbols":
      if (Yie(t))
        return /* @__PURE__ */ P.createElement(Zc, r);
      break;
    default:
      return null;
  }
}
function Kie(e) {
  return /* @__PURE__ */ zr(e) ? e.props : e;
}
function J1(e) {
  var t = e.option, r = e.shapeType, n = e.propTransformer, a = n === void 0 ? Gie : n, i = e.activeClassName, o = i === void 0 ? "recharts-active-shape" : i, s = e.isActive, l = Wie(e, Fie), c;
  if (/* @__PURE__ */ zr(t))
    c = /* @__PURE__ */ Nt(t, Q1(Q1({}, l), Kie(t)));
  else if (xe(t))
    c = t(l);
  else if (Pie(t) && !Mie(t)) {
    var u = a(t, l);
    c = /* @__PURE__ */ P.createElement(A8, {
      shapeType: r,
      elementProps: u
    });
  } else {
    var f = l;
    c = /* @__PURE__ */ P.createElement(A8, {
      shapeType: r,
      elementProps: f
    });
  }
  return s ? /* @__PURE__ */ P.createElement(De, {
    className: o
  }, c) : c;
}
function uu(e, t) {
  return t != null && "trapezoids" in e.props;
}
function fu(e, t) {
  return t != null && "sectors" in e.props;
}
function Hs(e, t) {
  return t != null && "points" in e.props;
}
function Xie(e, t) {
  var r, n, a = e.x === (t == null || (r = t.labelViewBox) === null || r === void 0 ? void 0 : r.x) || e.x === t.x, i = e.y === (t == null || (n = t.labelViewBox) === null || n === void 0 ? void 0 : n.y) || e.y === t.y;
  return a && i;
}
function Qie(e, t) {
  var r = e.endAngle === t.endAngle, n = e.startAngle === t.startAngle;
  return r && n;
}
function Jie(e, t) {
  var r = e.x === t.x, n = e.y === t.y, a = e.z === t.z;
  return r && n && a;
}
function eoe(e, t) {
  var r;
  return uu(e, t) ? r = Xie : fu(e, t) ? r = Qie : Hs(e, t) && (r = Jie), r;
}
function toe(e, t) {
  var r;
  return uu(e, t) ? r = "trapezoids" : fu(e, t) ? r = "sectors" : Hs(e, t) && (r = "points"), r;
}
function roe(e, t) {
  if (uu(e, t)) {
    var r;
    return (r = t.tooltipPayload) === null || r === void 0 || (r = r[0]) === null || r === void 0 || (r = r.payload) === null || r === void 0 ? void 0 : r.payload;
  }
  if (fu(e, t)) {
    var n;
    return (n = t.tooltipPayload) === null || n === void 0 || (n = n[0]) === null || n === void 0 || (n = n.payload) === null || n === void 0 ? void 0 : n.payload;
  }
  return Hs(e, t) ? t.payload : {};
}
function noe(e) {
  var t = e.activeTooltipItem, r = e.graphicalItem, n = e.itemData, a = toe(r, t), i = roe(r, t), o = n.filter(function(l, c) {
    var u = Xn(i, l), f = r.props[a].filter(function(m) {
      var v = eoe(r, t);
      return v(m, t);
    }), p = r.props[a].indexOf(f[f.length - 1]), h = c === p;
    return u && h;
  }), s = n.indexOf(o[o.length - 1]);
  return s;
}
var Wl;
function $i(e) {
  "@babel/helpers - typeof";
  return $i = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, $i(e);
}
function ci() {
  return ci = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ci.apply(this, arguments);
}
function M8(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ct(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? M8(Object(r), !0).forEach(function(n) {
      _r(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : M8(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function aoe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function T8(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Ky(n.key), n);
  }
}
function ioe(e, t, r) {
  return t && T8(e.prototype, t), r && T8(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function ooe(e, t, r) {
  return t = ec(t), soe(e, Yy() ? Reflect.construct(t, r || [], ec(e).constructor) : t.apply(e, r));
}
function soe(e, t) {
  if (t && ($i(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return loe(e);
}
function loe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Yy() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Yy = function() {
    return !!e;
  })();
}
function ec(e) {
  return ec = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, ec(e);
}
function coe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && g0(e, t);
}
function g0(e, t) {
  return g0 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, g0(e, t);
}
function _r(e, t, r) {
  return t = Ky(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Ky(e) {
  var t = uoe(e, "string");
  return $i(t) == "symbol" ? t : t + "";
}
function uoe(e, t) {
  if ($i(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if ($i(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var hn = /* @__PURE__ */ function(e) {
  function t(r) {
    var n;
    return aoe(this, t), n = ooe(this, t, [r]), _r(n, "pieRef", null), _r(n, "sectorRefs", []), _r(n, "id", oa("recharts-pie-")), _r(n, "handleAnimationEnd", function() {
      var a = n.props.onAnimationEnd;
      n.setState({
        isAnimationFinished: !0
      }), xe(a) && a();
    }), _r(n, "handleAnimationStart", function() {
      var a = n.props.onAnimationStart;
      n.setState({
        isAnimationFinished: !1
      }), xe(a) && a();
    }), n.state = {
      isAnimationFinished: !r.isAnimationActive,
      prevIsAnimationActive: r.isAnimationActive,
      prevAnimationId: r.animationId,
      sectorToFocus: 0
    }, n;
  }
  return coe(t, e), ioe(t, [{
    key: "isActiveIndex",
    value: function(n) {
      var a = this.props.activeIndex;
      return Array.isArray(a) ? a.indexOf(n) !== -1 : n === a;
    }
  }, {
    key: "hasActiveIndex",
    value: function() {
      var n = this.props.activeIndex;
      return Array.isArray(n) ? n.length !== 0 : n || n === 0;
    }
  }, {
    key: "renderLabels",
    value: function(n) {
      var a = this.props.isAnimationActive;
      if (a && !this.state.isAnimationFinished)
        return null;
      var i = this.props, o = i.label, s = i.labelLine, l = i.dataKey, c = i.valueKey, u = pe(this.props, !1), f = pe(o, !1), p = pe(s, !1), h = o && o.offsetRadius || 20, m = n.map(function(v, g) {
        var y = (v.startAngle + v.endAngle) / 2, b = ft(v.cx, v.cy, v.outerRadius + h, y), w = ct(ct(ct(ct({}, u), v), {}, {
          stroke: "none"
        }, f), {}, {
          index: g,
          textAnchor: t.getTextAnchor(b.x, v.cx)
        }, b), x = ct(ct(ct(ct({}, u), v), {}, {
          fill: "none",
          stroke: v.fill
        }, p), {}, {
          index: g,
          points: [ft(v.cx, v.cy, v.outerRadius, y), b]
        }), C = l;
        return Ce(l) && Ce(c) ? C = "value" : Ce(l) && (C = c), // eslint-disable-next-line react/no-array-index-key
        /* @__PURE__ */ P.createElement(De, {
          key: "label-".concat(v.startAngle, "-").concat(v.endAngle, "-").concat(v.midAngle, "-").concat(g)
        }, s && t.renderLabelLineItem(s, x, "line"), t.renderLabelItem(o, w, vt(v, C)));
      });
      return /* @__PURE__ */ P.createElement(De, {
        className: "recharts-pie-labels"
      }, m);
    }
  }, {
    key: "renderSectorsStatically",
    value: function(n) {
      var a = this, i = this.props, o = i.activeShape, s = i.blendStroke, l = i.inactiveShape;
      return n.map(function(c, u) {
        if ((c == null ? void 0 : c.startAngle) === 0 && (c == null ? void 0 : c.endAngle) === 0 && n.length !== 1)
          return null;
        var f = a.isActiveIndex(u), p = l && a.hasActiveIndex() ? l : null, h = f ? o : p, m = ct(ct({}, c), {}, {
          stroke: s ? c.fill : c.stroke,
          tabIndex: -1
        });
        return /* @__PURE__ */ P.createElement(De, ci({
          ref: function(g) {
            g && !a.sectorRefs.includes(g) && a.sectorRefs.push(g);
          },
          tabIndex: -1,
          className: "recharts-pie-sector"
        }, Kn(a.props, c, u), {
          // eslint-disable-next-line react/no-array-index-key
          key: "sector-".concat(c == null ? void 0 : c.startAngle, "-").concat(c == null ? void 0 : c.endAngle, "-").concat(c.midAngle, "-").concat(u)
        }), /* @__PURE__ */ P.createElement(J1, ci({
          option: h,
          isActive: f,
          shapeType: "sector"
        }, m)));
      });
    }
  }, {
    key: "renderSectorsWithAnimation",
    value: function() {
      var n = this, a = this.props, i = a.sectors, o = a.isAnimationActive, s = a.animationBegin, l = a.animationDuration, c = a.animationEasing, u = a.animationId, f = this.state, p = f.prevSectors, h = f.prevIsAnimationActive;
      return /* @__PURE__ */ P.createElement(Nr, {
        begin: s,
        duration: l,
        isActive: o,
        easing: c,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "pie-".concat(u, "-").concat(h),
        onAnimationStart: this.handleAnimationStart,
        onAnimationEnd: this.handleAnimationEnd
      }, function(m) {
        var v = m.t, g = [], y = i && i[0], b = y.startAngle;
        return i.forEach(function(w, x) {
          var C = p && p[x], S = x > 0 ? br(w, "paddingAngle", 0) : 0;
          if (C) {
            var E = bt(C.endAngle - C.startAngle, w.endAngle - w.startAngle), D = ct(ct({}, w), {}, {
              startAngle: b + S,
              endAngle: b + E(v) + S
            });
            g.push(D), b = D.endAngle;
          } else {
            var I = w.endAngle, k = w.startAngle, V = bt(0, I - k), W = V(v), L = ct(ct({}, w), {}, {
              startAngle: b + S,
              endAngle: b + W + S
            });
            g.push(L), b = L.endAngle;
          }
        }), /* @__PURE__ */ P.createElement(De, null, n.renderSectorsStatically(g));
      });
    }
  }, {
    key: "attachKeyboardHandlers",
    value: function(n) {
      var a = this;
      n.onkeydown = function(i) {
        if (!i.altKey)
          switch (i.key) {
            case "ArrowLeft": {
              var o = ++a.state.sectorToFocus % a.sectorRefs.length;
              a.sectorRefs[o].focus(), a.setState({
                sectorToFocus: o
              });
              break;
            }
            case "ArrowRight": {
              var s = --a.state.sectorToFocus < 0 ? a.sectorRefs.length - 1 : a.state.sectorToFocus % a.sectorRefs.length;
              a.sectorRefs[s].focus(), a.setState({
                sectorToFocus: s
              });
              break;
            }
            case "Escape": {
              a.sectorRefs[a.state.sectorToFocus].blur(), a.setState({
                sectorToFocus: 0
              });
              break;
            }
          }
      };
    }
  }, {
    key: "renderSectors",
    value: function() {
      var n = this.props, a = n.sectors, i = n.isAnimationActive, o = this.state.prevSectors;
      return i && a && a.length && (!o || !Xn(o, a)) ? this.renderSectorsWithAnimation() : this.renderSectorsStatically(a);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      this.pieRef && this.attachKeyboardHandlers(this.pieRef);
    }
  }, {
    key: "render",
    value: function() {
      var n = this, a = this.props, i = a.hide, o = a.sectors, s = a.className, l = a.label, c = a.cx, u = a.cy, f = a.innerRadius, p = a.outerRadius, h = a.isAnimationActive, m = this.state.isAnimationFinished;
      if (i || !o || !o.length || !oe(c) || !oe(u) || !oe(f) || !oe(p))
        return null;
      var v = _e("recharts-pie", s);
      return /* @__PURE__ */ P.createElement(De, {
        tabIndex: this.props.rootTabIndex,
        className: v,
        ref: function(y) {
          n.pieRef = y;
        }
      }, this.renderSectors(), l && this.renderLabels(o), It.renderCallByParent(this.props, null, !1), (!h || m) && Zr.renderCallByParent(this.props, o, !1));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, a) {
      return a.prevIsAnimationActive !== n.isAnimationActive ? {
        prevIsAnimationActive: n.isAnimationActive,
        prevAnimationId: n.animationId,
        curSectors: n.sectors,
        prevSectors: [],
        isAnimationFinished: !0
      } : n.isAnimationActive && n.animationId !== a.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curSectors: n.sectors,
        prevSectors: a.curSectors,
        isAnimationFinished: !0
      } : n.sectors !== a.curSectors ? {
        curSectors: n.sectors,
        isAnimationFinished: !0
      } : null;
    }
  }, {
    key: "getTextAnchor",
    value: function(n, a) {
      return n > a ? "start" : n < a ? "end" : "middle";
    }
  }, {
    key: "renderLabelLineItem",
    value: function(n, a, i) {
      if (/* @__PURE__ */ P.isValidElement(n))
        return /* @__PURE__ */ P.cloneElement(n, a);
      if (xe(n))
        return n(a);
      var o = _e("recharts-pie-label-line", typeof n != "boolean" ? n.className : "");
      return /* @__PURE__ */ P.createElement(qn, ci({}, a, {
        key: i,
        type: "linear",
        className: o
      }));
    }
  }, {
    key: "renderLabelItem",
    value: function(n, a, i) {
      if (/* @__PURE__ */ P.isValidElement(n))
        return /* @__PURE__ */ P.cloneElement(n, a);
      var o = i;
      if (xe(n) && (o = n(a), /* @__PURE__ */ P.isValidElement(o)))
        return o;
      var s = _e("recharts-pie-label-text", typeof n != "boolean" && !xe(n) ? n.className : "");
      return /* @__PURE__ */ P.createElement(La, ci({}, a, {
        alignmentBaseline: "middle",
        className: s
      }), o);
    }
  }]);
}(Cr);
Wl = hn;
_r(hn, "displayName", "Pie");
_r(hn, "defaultProps", {
  stroke: "#fff",
  fill: "#808080",
  legendType: "rect",
  cx: "50%",
  cy: "50%",
  startAngle: 0,
  endAngle: 360,
  innerRadius: 0,
  outerRadius: "80%",
  paddingAngle: 0,
  labelLine: !0,
  hide: !1,
  minAngle: 0,
  isAnimationActive: !Tr.isSsr,
  animationBegin: 400,
  animationDuration: 1500,
  animationEasing: "ease",
  nameKey: "name",
  blendStroke: !1,
  rootTabIndex: 0
});
_r(hn, "parseDeltaAngle", function(e, t) {
  var r = Jt(t - e), n = Math.min(Math.abs(t - e), 360);
  return r * n;
});
_r(hn, "getRealPieData", function(e) {
  var t = e.data, r = e.children, n = pe(e, !1), a = rr(r, Gr);
  return t && t.length ? t.map(function(i, o) {
    return ct(ct(ct({
      payload: i
    }, n), i), a && a[o] && a[o].props);
  }) : a && a.length ? a.map(function(i) {
    return ct(ct({}, n), i.props);
  }) : [];
});
_r(hn, "parseCoordinateOfPie", function(e, t) {
  var r = t.top, n = t.left, a = t.width, i = t.height, o = My(a, i), s = n + er(e.cx, a, a / 2), l = r + er(e.cy, i, i / 2), c = er(e.innerRadius, o, 0), u = er(e.outerRadius, o, o * 0.8), f = e.maxRadius || Math.sqrt(a * a + i * i) / 2;
  return {
    cx: s,
    cy: l,
    innerRadius: c,
    outerRadius: u,
    maxRadius: f
  };
});
_r(hn, "getComposedData", function(e) {
  var t = e.item, r = e.offset, n = t.type.defaultProps !== void 0 ? ct(ct({}, t.type.defaultProps), t.props) : t.props, a = Wl.getRealPieData(n);
  if (!a || !a.length)
    return null;
  var i = n.cornerRadius, o = n.startAngle, s = n.endAngle, l = n.paddingAngle, c = n.dataKey, u = n.nameKey, f = n.valueKey, p = n.tooltipType, h = Math.abs(n.minAngle), m = Wl.parseCoordinateOfPie(n, r), v = Wl.parseDeltaAngle(o, s), g = Math.abs(v), y = c;
  Ce(c) && Ce(f) ? (Ur(!1, `Use "dataKey" to specify the value of pie,
      the props "valueKey" will be deprecated in 1.1.0`), y = "value") : Ce(c) && (Ur(!1, `Use "dataKey" to specify the value of pie,
      the props "valueKey" will be deprecated in 1.1.0`), y = f);
  var b = a.filter(function(D) {
    return vt(D, y, 0) !== 0;
  }).length, w = (g >= 360 ? b : b - 1) * l, x = g - b * h - w, C = a.reduce(function(D, I) {
    var k = vt(I, y, 0);
    return D + (oe(k) ? k : 0);
  }, 0), S;
  if (C > 0) {
    var E;
    S = a.map(function(D, I) {
      var k = vt(D, y, 0), V = vt(D, u, I), W = (oe(k) ? k : 0) / C, L;
      I ? L = E.endAngle + Jt(v) * l * (k !== 0 ? 1 : 0) : L = o;
      var G = L + Jt(v) * ((k !== 0 ? h : 0) + W * x), Q = (L + G) / 2, X = (m.innerRadius + m.outerRadius) / 2, K = [{
        name: V,
        value: k,
        payload: D,
        dataKey: y,
        type: p
      }], te = ft(m.cx, m.cy, X, Q);
      return E = ct(ct(ct({
        percent: W,
        cornerRadius: i,
        name: V,
        tooltipPayload: K,
        midAngle: Q,
        middleRadius: X,
        tooltipPosition: te
      }, D), m), {}, {
        value: vt(D, y),
        startAngle: L,
        endAngle: G,
        payload: D,
        paddingAngle: Jt(v) * l
      }), E;
    });
  }
  return ct(ct({}, m), {}, {
    sectors: S,
    data: a
  });
});
var foe = Math.ceil, doe = Math.max;
function poe(e, t, r, n) {
  for (var a = -1, i = doe(foe((t - e) / (r || 1)), 0), o = Array(i); i--; )
    o[n ? i : ++a] = e, e += r;
  return o;
}
var hoe = poe, voe = yg, $8 = 1 / 0, moe = 17976931348623157e292;
function goe(e) {
  if (!e)
    return e === 0 ? e : 0;
  if (e = voe(e), e === $8 || e === -$8) {
    var t = e < 0 ? -1 : 1;
    return t * moe;
  }
  return e === e ? e : 0;
}
var Xy = goe, yoe = hoe, boe = Yc, _2 = Xy;
function Coe(e) {
  return function(t, r, n) {
    return n && typeof n != "number" && boe(t, r, n) && (r = n = void 0), t = _2(t), r === void 0 ? (r = t, t = 0) : r = _2(r), n = n === void 0 ? t < r ? 1 : -1 : _2(n), yoe(t, r, n, e);
  };
}
var xoe = Coe, woe = xoe, Ooe = woe(), Soe = Ooe;
const tc = /* @__PURE__ */ Je(Soe);
function Fs(e) {
  "@babel/helpers - typeof";
  return Fs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Fs(e);
}
function N8(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function I8(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? N8(Object(r), !0).forEach(function(n) {
      Qy(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : N8(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Qy(e, t, r) {
  return t = Poe(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Poe(e) {
  var t = Eoe(e, "string");
  return Fs(t) == "symbol" ? t : t + "";
}
function Eoe(e, t) {
  if (Fs(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Fs(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var joe = ["Webkit", "Moz", "O", "ms"], _oe = function(t, r) {
  if (!t)
    return null;
  var n = t.replace(/(\w)/, function(i) {
    return i.toUpperCase();
  }), a = joe.reduce(function(i, o) {
    return I8(I8({}, i), {}, Qy({}, o + n, r));
  }, {});
  return a[t] = r, a;
};
function Ni(e) {
  "@babel/helpers - typeof";
  return Ni = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ni(e);
}
function rc() {
  return rc = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, rc.apply(this, arguments);
}
function L8(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function D2(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? L8(Object(r), !0).forEach(function(n) {
      dr(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : L8(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Doe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function R8(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, eb(n.key), n);
  }
}
function Aoe(e, t, r) {
  return t && R8(e.prototype, t), r && R8(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Moe(e, t, r) {
  return t = nc(t), Toe(e, Jy() ? Reflect.construct(t, r || [], nc(e).constructor) : t.apply(e, r));
}
function Toe(e, t) {
  if (t && (Ni(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return $oe(e);
}
function $oe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Jy() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Jy = function() {
    return !!e;
  })();
}
function nc(e) {
  return nc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, nc(e);
}
function Noe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && y0(e, t);
}
function y0(e, t) {
  return y0 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, y0(e, t);
}
function dr(e, t, r) {
  return t = eb(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function eb(e) {
  var t = Ioe(e, "string");
  return Ni(t) == "symbol" ? t : t + "";
}
function Ioe(e, t) {
  if (Ni(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Ni(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Loe = function(t) {
  var r = t.data, n = t.startIndex, a = t.endIndex, i = t.x, o = t.width, s = t.travellerWidth;
  if (!r || !r.length)
    return {};
  var l = r.length, c = Yo().domain(tc(0, l)).range([i, i + o - s]), u = c.domain().map(function(f) {
    return c(f);
  });
  return {
    isTextActive: !1,
    isSlideMoving: !1,
    isTravellerMoving: !1,
    isTravellerFocused: !1,
    startX: c(n),
    endX: c(a),
    scale: c,
    scaleValues: u
  };
}, k8 = function(t) {
  return t.changedTouches && !!t.changedTouches.length;
}, Ii = /* @__PURE__ */ function(e) {
  function t(r) {
    var n;
    return Doe(this, t), n = Moe(this, t, [r]), dr(n, "handleDrag", function(a) {
      n.leaveTimer && (clearTimeout(n.leaveTimer), n.leaveTimer = null), n.state.isTravellerMoving ? n.handleTravellerMove(a) : n.state.isSlideMoving && n.handleSlideDrag(a);
    }), dr(n, "handleTouchMove", function(a) {
      a.changedTouches != null && a.changedTouches.length > 0 && n.handleDrag(a.changedTouches[0]);
    }), dr(n, "handleDragEnd", function() {
      n.setState({
        isTravellerMoving: !1,
        isSlideMoving: !1
      }, function() {
        var a = n.props, i = a.endIndex, o = a.onDragEnd, s = a.startIndex;
        o == null || o({
          endIndex: i,
          startIndex: s
        });
      }), n.detachDragEndListener();
    }), dr(n, "handleLeaveWrapper", function() {
      (n.state.isTravellerMoving || n.state.isSlideMoving) && (n.leaveTimer = window.setTimeout(n.handleDragEnd, n.props.leaveTimeOut));
    }), dr(n, "handleEnterSlideOrTraveller", function() {
      n.setState({
        isTextActive: !0
      });
    }), dr(n, "handleLeaveSlideOrTraveller", function() {
      n.setState({
        isTextActive: !1
      });
    }), dr(n, "handleSlideDragStart", function(a) {
      var i = k8(a) ? a.changedTouches[0] : a;
      n.setState({
        isTravellerMoving: !1,
        isSlideMoving: !0,
        slideMoveStartX: i.pageX
      }), n.attachDragEndListener();
    }), n.travellerDragStartHandlers = {
      startX: n.handleTravellerDragStart.bind(n, "startX"),
      endX: n.handleTravellerDragStart.bind(n, "endX")
    }, n.state = {}, n;
  }
  return Noe(t, e), Aoe(t, [{
    key: "componentWillUnmount",
    value: function() {
      this.leaveTimer && (clearTimeout(this.leaveTimer), this.leaveTimer = null), this.detachDragEndListener();
    }
  }, {
    key: "getIndex",
    value: function(n) {
      var a = n.startX, i = n.endX, o = this.state.scaleValues, s = this.props, l = s.gap, c = s.data, u = c.length - 1, f = Math.min(a, i), p = Math.max(a, i), h = t.getIndexInRange(o, f), m = t.getIndexInRange(o, p);
      return {
        startIndex: h - h % l,
        endIndex: m === u ? u : m - m % l
      };
    }
  }, {
    key: "getTextOfTick",
    value: function(n) {
      var a = this.props, i = a.data, o = a.tickFormatter, s = a.dataKey, l = vt(i[n], s, n);
      return xe(o) ? o(l, n) : l;
    }
  }, {
    key: "attachDragEndListener",
    value: function() {
      window.addEventListener("mouseup", this.handleDragEnd, !0), window.addEventListener("touchend", this.handleDragEnd, !0), window.addEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "detachDragEndListener",
    value: function() {
      window.removeEventListener("mouseup", this.handleDragEnd, !0), window.removeEventListener("touchend", this.handleDragEnd, !0), window.removeEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "handleSlideDrag",
    value: function(n) {
      var a = this.state, i = a.slideMoveStartX, o = a.startX, s = a.endX, l = this.props, c = l.x, u = l.width, f = l.travellerWidth, p = l.startIndex, h = l.endIndex, m = l.onChange, v = n.pageX - i;
      v > 0 ? v = Math.min(v, c + u - f - s, c + u - f - o) : v < 0 && (v = Math.max(v, c - o, c - s));
      var g = this.getIndex({
        startX: o + v,
        endX: s + v
      });
      (g.startIndex !== p || g.endIndex !== h) && m && m(g), this.setState({
        startX: o + v,
        endX: s + v,
        slideMoveStartX: n.pageX
      });
    }
  }, {
    key: "handleTravellerDragStart",
    value: function(n, a) {
      var i = k8(a) ? a.changedTouches[0] : a;
      this.setState({
        isSlideMoving: !1,
        isTravellerMoving: !0,
        movingTravellerId: n,
        brushMoveStartX: i.pageX
      }), this.attachDragEndListener();
    }
  }, {
    key: "handleTravellerMove",
    value: function(n) {
      var a = this.state, i = a.brushMoveStartX, o = a.movingTravellerId, s = a.endX, l = a.startX, c = this.state[o], u = this.props, f = u.x, p = u.width, h = u.travellerWidth, m = u.onChange, v = u.gap, g = u.data, y = {
        startX: this.state.startX,
        endX: this.state.endX
      }, b = n.pageX - i;
      b > 0 ? b = Math.min(b, f + p - h - c) : b < 0 && (b = Math.max(b, f - c)), y[o] = c + b;
      var w = this.getIndex(y), x = w.startIndex, C = w.endIndex, S = function() {
        var D = g.length - 1;
        return o === "startX" && (s > l ? x % v === 0 : C % v === 0) || s < l && C === D || o === "endX" && (s > l ? C % v === 0 : x % v === 0) || s > l && C === D;
      };
      this.setState(dr(dr({}, o, c + b), "brushMoveStartX", n.pageX), function() {
        m && S() && m(w);
      });
    }
  }, {
    key: "handleTravellerMoveKeyboard",
    value: function(n, a) {
      var i = this, o = this.state, s = o.scaleValues, l = o.startX, c = o.endX, u = this.state[a], f = s.indexOf(u);
      if (f !== -1) {
        var p = f + n;
        if (!(p === -1 || p >= s.length)) {
          var h = s[p];
          a === "startX" && h >= c || a === "endX" && h <= l || this.setState(dr({}, a, h), function() {
            i.props.onChange(i.getIndex({
              startX: i.state.startX,
              endX: i.state.endX
            }));
          });
        }
      }
    }
  }, {
    key: "renderBackground",
    value: function() {
      var n = this.props, a = n.x, i = n.y, o = n.width, s = n.height, l = n.fill, c = n.stroke;
      return /* @__PURE__ */ P.createElement("rect", {
        stroke: c,
        fill: l,
        x: a,
        y: i,
        width: o,
        height: s
      });
    }
  }, {
    key: "renderPanorama",
    value: function() {
      var n = this.props, a = n.x, i = n.y, o = n.width, s = n.height, l = n.data, c = n.children, u = n.padding, f = Ma.only(c);
      return f ? /* @__PURE__ */ P.cloneElement(f, {
        x: a,
        y: i,
        width: o,
        height: s,
        margin: u,
        compact: !0,
        data: l
      }) : null;
    }
  }, {
    key: "renderTravellerLayer",
    value: function(n, a) {
      var i, o, s = this, l = this.props, c = l.y, u = l.travellerWidth, f = l.height, p = l.traveller, h = l.ariaLabel, m = l.data, v = l.startIndex, g = l.endIndex, y = Math.max(n, this.props.x), b = D2(D2({}, pe(this.props, !1)), {}, {
        x: y,
        y: c,
        width: u,
        height: f
      }), w = h || "Min value: ".concat((i = m[v]) === null || i === void 0 ? void 0 : i.name, ", Max value: ").concat((o = m[g]) === null || o === void 0 ? void 0 : o.name);
      return /* @__PURE__ */ P.createElement(De, {
        tabIndex: 0,
        role: "slider",
        "aria-label": w,
        "aria-valuenow": n,
        className: "recharts-brush-traveller",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.travellerDragStartHandlers[a],
        onTouchStart: this.travellerDragStartHandlers[a],
        onKeyDown: function(C) {
          ["ArrowLeft", "ArrowRight"].includes(C.key) && (C.preventDefault(), C.stopPropagation(), s.handleTravellerMoveKeyboard(C.key === "ArrowRight" ? 1 : -1, a));
        },
        onFocus: function() {
          s.setState({
            isTravellerFocused: !0
          });
        },
        onBlur: function() {
          s.setState({
            isTravellerFocused: !1
          });
        },
        style: {
          cursor: "col-resize"
        }
      }, t.renderTraveller(p, b));
    }
  }, {
    key: "renderSlide",
    value: function(n, a) {
      var i = this.props, o = i.y, s = i.height, l = i.stroke, c = i.travellerWidth, u = Math.min(n, a) + c, f = Math.max(Math.abs(a - n) - c, 0);
      return /* @__PURE__ */ P.createElement("rect", {
        className: "recharts-brush-slide",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.handleSlideDragStart,
        onTouchStart: this.handleSlideDragStart,
        style: {
          cursor: "move"
        },
        stroke: "none",
        fill: l,
        fillOpacity: 0.2,
        x: u,
        y: o,
        width: f,
        height: s
      });
    }
  }, {
    key: "renderText",
    value: function() {
      var n = this.props, a = n.startIndex, i = n.endIndex, o = n.y, s = n.height, l = n.travellerWidth, c = n.stroke, u = this.state, f = u.startX, p = u.endX, h = 5, m = {
        pointerEvents: "none",
        fill: c
      };
      return /* @__PURE__ */ P.createElement(De, {
        className: "recharts-brush-texts"
      }, /* @__PURE__ */ P.createElement(La, rc({
        textAnchor: "end",
        verticalAnchor: "middle",
        x: Math.min(f, p) - h,
        y: o + s / 2
      }, m), this.getTextOfTick(a)), /* @__PURE__ */ P.createElement(La, rc({
        textAnchor: "start",
        verticalAnchor: "middle",
        x: Math.max(f, p) + l + h,
        y: o + s / 2
      }, m), this.getTextOfTick(i)));
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, a = n.data, i = n.className, o = n.children, s = n.x, l = n.y, c = n.width, u = n.height, f = n.alwaysShowText, p = this.state, h = p.startX, m = p.endX, v = p.isTextActive, g = p.isSlideMoving, y = p.isTravellerMoving, b = p.isTravellerFocused;
      if (!a || !a.length || !oe(s) || !oe(l) || !oe(c) || !oe(u) || c <= 0 || u <= 0)
        return null;
      var w = _e("recharts-brush", i), x = P.Children.count(o) === 1, C = _oe("userSelect", "none");
      return /* @__PURE__ */ P.createElement(De, {
        className: w,
        onMouseLeave: this.handleLeaveWrapper,
        onTouchMove: this.handleTouchMove,
        style: C
      }, this.renderBackground(), x && this.renderPanorama(), this.renderSlide(h, m), this.renderTravellerLayer(h, "startX"), this.renderTravellerLayer(m, "endX"), (v || g || y || b || f) && this.renderText());
    }
  }], [{
    key: "renderDefaultTraveller",
    value: function(n) {
      var a = n.x, i = n.y, o = n.width, s = n.height, l = n.stroke, c = Math.floor(i + s / 2) - 1;
      return /* @__PURE__ */ P.createElement(P.Fragment, null, /* @__PURE__ */ P.createElement("rect", {
        x: a,
        y: i,
        width: o,
        height: s,
        fill: l,
        stroke: "none"
      }), /* @__PURE__ */ P.createElement("line", {
        x1: a + 1,
        y1: c,
        x2: a + o - 1,
        y2: c,
        fill: "none",
        stroke: "#fff"
      }), /* @__PURE__ */ P.createElement("line", {
        x1: a + 1,
        y1: c + 2,
        x2: a + o - 1,
        y2: c + 2,
        fill: "none",
        stroke: "#fff"
      }));
    }
  }, {
    key: "renderTraveller",
    value: function(n, a) {
      var i;
      return /* @__PURE__ */ P.isValidElement(n) ? i = /* @__PURE__ */ P.cloneElement(n, a) : xe(n) ? i = n(a) : i = t.renderDefaultTraveller(a), i;
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function(n, a) {
      var i = n.data, o = n.width, s = n.x, l = n.travellerWidth, c = n.updateId, u = n.startIndex, f = n.endIndex;
      if (i !== a.prevData || c !== a.prevUpdateId)
        return D2({
          prevData: i,
          prevTravellerWidth: l,
          prevUpdateId: c,
          prevX: s,
          prevWidth: o
        }, i && i.length ? Loe({
          data: i,
          width: o,
          x: s,
          travellerWidth: l,
          startIndex: u,
          endIndex: f
        }) : {
          scale: null,
          scaleValues: null
        });
      if (a.scale && (o !== a.prevWidth || s !== a.prevX || l !== a.prevTravellerWidth)) {
        a.scale.range([s, s + o - l]);
        var p = a.scale.domain().map(function(h) {
          return a.scale(h);
        });
        return {
          prevData: i,
          prevTravellerWidth: l,
          prevUpdateId: c,
          prevX: s,
          prevWidth: o,
          startX: a.scale(n.startIndex),
          endX: a.scale(n.endIndex),
          scaleValues: p
        };
      }
      return null;
    }
  }, {
    key: "getIndexInRange",
    value: function(n, a) {
      for (var i = n.length, o = 0, s = i - 1; s - o > 1; ) {
        var l = Math.floor((o + s) / 2);
        n[l] > a ? s = l : o = l;
      }
      return a >= n[s] ? s : o;
    }
  }]);
}(Cr);
dr(Ii, "displayName", "Brush");
dr(Ii, "defaultProps", {
  height: 40,
  travellerWidth: 5,
  gap: 1,
  fill: "#fff",
  stroke: "#666",
  padding: {
    top: 1,
    right: 1,
    bottom: 1,
    left: 1
  },
  leaveTimeOut: 1e3,
  alwaysShowText: !1
});
var Roe = ld;
function koe(e, t) {
  var r;
  return Roe(e, function(n, a, i) {
    return r = t(n, a, i), !r;
  }), !!r;
}
var Boe = koe, Voe = Um, Hoe = pn, Foe = Boe, Woe = cr, zoe = Yc;
function Uoe(e, t, r) {
  var n = Woe(e) ? Voe : Foe;
  return r && zoe(e, t, r) && (t = void 0), n(e, Hoe(t));
}
var Zoe = Uoe;
const qoe = /* @__PURE__ */ Je(Zoe);
var on = function(t, r) {
  var n = t.alwaysShow, a = t.ifOverflow;
  return n && (a = "extendDomain"), a === r;
}, B8 = pg;
function Goe(e, t, r) {
  t == "__proto__" && B8 ? B8(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
var Yoe = Goe, Koe = Yoe, Xoe = fg, Qoe = pn;
function Joe(e, t) {
  var r = {};
  return t = Qoe(t), Xoe(e, function(n, a, i) {
    Koe(r, a, t(n, a, i));
  }), r;
}
var ese = Joe;
const tse = /* @__PURE__ */ Je(ese);
function rse(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (!t(e[r], r, e))
      return !1;
  return !0;
}
var nse = rse, ase = ld;
function ise(e, t) {
  var r = !0;
  return ase(e, function(n, a, i) {
    return r = !!t(n, a, i), r;
  }), r;
}
var ose = ise, sse = nse, lse = ose, cse = pn, use = cr, fse = Yc;
function dse(e, t, r) {
  var n = use(e) ? sse : lse;
  return r && fse(e, t, r) && (t = void 0), n(e, cse(t));
}
var pse = dse;
const tb = /* @__PURE__ */ Je(pse);
var hse = ["x", "y"];
function Li(e) {
  "@babel/helpers - typeof";
  return Li = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Li(e);
}
function b0() {
  return b0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, b0.apply(this, arguments);
}
function V8(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Mo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? V8(Object(r), !0).forEach(function(n) {
      vse(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : V8(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function vse(e, t, r) {
  return t = mse(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function mse(e) {
  var t = gse(e, "string");
  return Li(t) == "symbol" ? t : t + "";
}
function gse(e, t) {
  if (Li(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Li(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function yse(e, t) {
  if (e == null)
    return {};
  var r = bse(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function bse(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function Cse(e, t) {
  var r = e.x, n = e.y, a = yse(e, hse), i = "".concat(r), o = parseInt(i, 10), s = "".concat(n), l = parseInt(s, 10), c = "".concat(t.height || a.height), u = parseInt(c, 10), f = "".concat(t.width || a.width), p = parseInt(f, 10);
  return Mo(Mo(Mo(Mo(Mo({}, t), a), o ? {
    x: o
  } : {}), l ? {
    y: l
  } : {}), {}, {
    height: u,
    width: p,
    name: t.name,
    radius: t.radius
  });
}
function H8(e) {
  return /* @__PURE__ */ P.createElement(J1, b0({
    shapeType: "rectangle",
    propTransformer: Cse,
    activeClassName: "recharts-active-bar"
  }, e));
}
var xse = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  return function(n, a) {
    if (typeof t == "number")
      return t;
    var i = typeof n == "number";
    return i ? t(n, a) : (i || (process.env.NODE_ENV !== "production" ? Gt(!1, "minPointSize callback function received a value with type of ".concat(Li(n), ". Currently only numbers are supported.")) : Gt(!1)), r);
  };
}, wse = ["value", "background"], rb;
function Ri(e) {
  "@babel/helpers - typeof";
  return Ri = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ri(e);
}
function Ose(e, t) {
  if (e == null)
    return {};
  var r = Sse(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Sse(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function ac() {
  return ac = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ac.apply(this, arguments);
}
function F8(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function At(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? F8(Object(r), !0).forEach(function(n) {
      Hn(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : F8(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Pse(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function W8(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ab(n.key), n);
  }
}
function Ese(e, t, r) {
  return t && W8(e.prototype, t), r && W8(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function jse(e, t, r) {
  return t = ic(t), _se(e, nb() ? Reflect.construct(t, r || [], ic(e).constructor) : t.apply(e, r));
}
function _se(e, t) {
  if (t && (Ri(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Dse(e);
}
function Dse(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function nb() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (nb = function() {
    return !!e;
  })();
}
function ic(e) {
  return ic = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, ic(e);
}
function Ase(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && C0(e, t);
}
function C0(e, t) {
  return C0 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, C0(e, t);
}
function Hn(e, t, r) {
  return t = ab(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function ab(e) {
  var t = Mse(e, "string");
  return Ri(t) == "symbol" ? t : t + "";
}
function Mse(e, t) {
  if (Ri(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Ri(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Ir = /* @__PURE__ */ function(e) {
  function t() {
    var r;
    Pse(this, t);
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    return r = jse(this, t, [].concat(a)), Hn(r, "state", {
      isAnimationFinished: !1
    }), Hn(r, "id", oa("recharts-bar-")), Hn(r, "handleAnimationEnd", function() {
      var o = r.props.onAnimationEnd;
      r.setState({
        isAnimationFinished: !0
      }), o && o();
    }), Hn(r, "handleAnimationStart", function() {
      var o = r.props.onAnimationStart;
      r.setState({
        isAnimationFinished: !1
      }), o && o();
    }), r;
  }
  return Ase(t, e), Ese(t, [{
    key: "renderRectanglesStatically",
    value: function(n) {
      var a = this, i = this.props, o = i.shape, s = i.dataKey, l = i.activeIndex, c = i.activeBar, u = pe(this.props, !1);
      return n && n.map(function(f, p) {
        var h = p === l, m = h ? c : o, v = At(At(At({}, u), f), {}, {
          isActive: h,
          option: m,
          index: p,
          dataKey: s,
          onAnimationStart: a.handleAnimationStart,
          onAnimationEnd: a.handleAnimationEnd
        });
        return /* @__PURE__ */ P.createElement(De, ac({
          className: "recharts-bar-rectangle"
        }, Kn(a.props, f, p), {
          key: "rectangle-".concat(f == null ? void 0 : f.x, "-").concat(f == null ? void 0 : f.y, "-").concat(f == null ? void 0 : f.value)
        }), /* @__PURE__ */ P.createElement(H8, v));
      });
    }
  }, {
    key: "renderRectanglesWithAnimation",
    value: function() {
      var n = this, a = this.props, i = a.data, o = a.layout, s = a.isAnimationActive, l = a.animationBegin, c = a.animationDuration, u = a.animationEasing, f = a.animationId, p = this.state.prevData;
      return /* @__PURE__ */ P.createElement(Nr, {
        begin: l,
        duration: c,
        isActive: s,
        easing: u,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "bar-".concat(f),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(h) {
        var m = h.t, v = i.map(function(g, y) {
          var b = p && p[y];
          if (b) {
            var w = bt(b.x, g.x), x = bt(b.y, g.y), C = bt(b.width, g.width), S = bt(b.height, g.height);
            return At(At({}, g), {}, {
              x: w(m),
              y: x(m),
              width: C(m),
              height: S(m)
            });
          }
          if (o === "horizontal") {
            var E = bt(0, g.height), D = E(m);
            return At(At({}, g), {}, {
              y: g.y + g.height - D,
              height: D
            });
          }
          var I = bt(0, g.width), k = I(m);
          return At(At({}, g), {}, {
            width: k
          });
        });
        return /* @__PURE__ */ P.createElement(De, null, n.renderRectanglesStatically(v));
      });
    }
  }, {
    key: "renderRectangles",
    value: function() {
      var n = this.props, a = n.data, i = n.isAnimationActive, o = this.state.prevData;
      return i && a && a.length && (!o || !Xn(o, a)) ? this.renderRectanglesWithAnimation() : this.renderRectanglesStatically(a);
    }
  }, {
    key: "renderBackground",
    value: function() {
      var n = this, a = this.props, i = a.data, o = a.dataKey, s = a.activeIndex, l = pe(this.props.background, !1);
      return i.map(function(c, u) {
        c.value;
        var f = c.background, p = Ose(c, wse);
        if (!f)
          return null;
        var h = At(At(At(At(At({}, p), {}, {
          fill: "#eee"
        }, f), l), Kn(n.props, c, u)), {}, {
          onAnimationStart: n.handleAnimationStart,
          onAnimationEnd: n.handleAnimationEnd,
          dataKey: o,
          index: u,
          className: "recharts-bar-background-rectangle"
        });
        return /* @__PURE__ */ P.createElement(H8, ac({
          key: "background-bar-".concat(u),
          option: n.props.background,
          isActive: u === s
        }, h));
      });
    }
  }, {
    key: "renderErrorBar",
    value: function(n, a) {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished)
        return null;
      var i = this.props, o = i.data, s = i.xAxis, l = i.yAxis, c = i.layout, u = i.children, f = rr(u, fo);
      if (!f)
        return null;
      var p = c === "vertical" ? o[0].height / 2 : o[0].width / 2, h = function(g, y) {
        var b = Array.isArray(g.value) ? g.value[1] : g.value;
        return {
          x: g.x,
          y: g.y,
          value: b,
          errorVal: vt(g, y)
        };
      }, m = {
        clipPath: n ? "url(#clipPath-".concat(a, ")") : null
      };
      return /* @__PURE__ */ P.createElement(De, m, f.map(function(v) {
        return /* @__PURE__ */ P.cloneElement(v, {
          key: "error-bar-".concat(a, "-").concat(v.props.dataKey),
          data: o,
          xAxis: s,
          yAxis: l,
          layout: c,
          offset: p,
          dataPointFormatter: h
        });
      }));
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, a = n.hide, i = n.data, o = n.className, s = n.xAxis, l = n.yAxis, c = n.left, u = n.top, f = n.width, p = n.height, h = n.isAnimationActive, m = n.background, v = n.id;
      if (a || !i || !i.length)
        return null;
      var g = this.state.isAnimationFinished, y = _e("recharts-bar", o), b = s && s.allowDataOverflow, w = l && l.allowDataOverflow, x = b || w, C = Ce(v) ? this.id : v;
      return /* @__PURE__ */ P.createElement(De, {
        className: y
      }, b || w ? /* @__PURE__ */ P.createElement("defs", null, /* @__PURE__ */ P.createElement("clipPath", {
        id: "clipPath-".concat(C)
      }, /* @__PURE__ */ P.createElement("rect", {
        x: b ? c : c - f / 2,
        y: w ? u : u - p / 2,
        width: b ? f : f * 2,
        height: w ? p : p * 2
      }))) : null, /* @__PURE__ */ P.createElement(De, {
        className: "recharts-bar-rectangles",
        clipPath: x ? "url(#clipPath-".concat(C, ")") : null
      }, m ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(x, C), (!h || g) && Zr.renderCallByParent(this.props, i));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, a) {
      return n.animationId !== a.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curData: n.data,
        prevData: a.curData
      } : n.data !== a.curData ? {
        curData: n.data
      } : null;
    }
  }]);
}(Cr);
rb = Ir;
Hn(Ir, "displayName", "Bar");
Hn(Ir, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  legendType: "rect",
  minPointSize: 0,
  hide: !1,
  data: [],
  layout: "vertical",
  activeBar: !1,
  isAnimationActive: !Tr.isSsr,
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: "ease"
});
Hn(Ir, "getComposedData", function(e) {
  var t = e.props, r = e.item, n = e.barPosition, a = e.bandSize, i = e.xAxis, o = e.yAxis, s = e.xAxisTicks, l = e.yAxisTicks, c = e.stackedData, u = e.dataStartIndex, f = e.displayedData, p = e.offset, h = Ete(n, r);
  if (!h)
    return null;
  var m = t.layout, v = r.type.defaultProps, g = v !== void 0 ? At(At({}, v), r.props) : r.props, y = g.dataKey, b = g.children, w = g.minPointSize, x = m === "horizontal" ? o : i, C = c ? x.scale.domain() : null, S = $te({
    numericAxis: x
  }), E = rr(b, Gr), D = f.map(function(I, k) {
    var V, W, L, G, Q, X;
    c ? V = jte(c[u + k], C) : (V = vt(I, y), Array.isArray(V) || (V = [S, V]));
    var K = xse(w, rb.defaultProps.minPointSize)(V[1], k);
    if (m === "horizontal") {
      var te, _ = [o.scale(V[0]), o.scale(V[1])], j = _[0], T = _[1];
      W = M4({
        axis: i,
        ticks: s,
        bandSize: a,
        offset: h.offset,
        entry: I,
        index: k
      }), L = (te = T ?? j) !== null && te !== void 0 ? te : void 0, G = h.size;
      var A = j - T;
      if (Q = Number.isNaN(A) ? 0 : A, X = {
        x: W,
        y: o.y,
        width: G,
        height: o.height
      }, Math.abs(K) > 0 && Math.abs(Q) < Math.abs(K)) {
        var O = Jt(Q || K) * (Math.abs(K) - Math.abs(Q));
        L -= O, Q += O;
      }
    } else {
      var N = [i.scale(V[0]), i.scale(V[1])], q = N[0], Y = N[1];
      if (W = q, L = M4({
        axis: o,
        ticks: l,
        bandSize: a,
        offset: h.offset,
        entry: I,
        index: k
      }), G = Y - q, Q = h.size, X = {
        x: i.x,
        y: L,
        width: i.width,
        height: Q
      }, Math.abs(K) > 0 && Math.abs(G) < Math.abs(K)) {
        var z = Jt(G || K) * (Math.abs(K) - Math.abs(G));
        G += z;
      }
    }
    return At(At(At({}, I), {}, {
      x: W,
      y: L,
      width: G,
      height: Q,
      value: c ? V : V[1],
      payload: I,
      background: X
    }, E && E[k] && E[k].props), {}, {
      tooltipPayload: [Dy(r, I)],
      tooltipPosition: {
        x: W + G / 2,
        y: L + Q / 2
      }
    });
  });
  return At({
    data: D,
    layout: m
  }, p);
});
function Ws(e) {
  "@babel/helpers - typeof";
  return Ws = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ws(e);
}
function Tse(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function z8(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ib(n.key), n);
  }
}
function $se(e, t, r) {
  return t && z8(e.prototype, t), r && z8(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function U8(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Vr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? U8(Object(r), !0).forEach(function(n) {
      du(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : U8(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function du(e, t, r) {
  return t = ib(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function ib(e) {
  var t = Nse(e, "string");
  return Ws(t) == "symbol" ? t : t + "";
}
function Nse(e, t) {
  if (Ws(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Ws(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var ob = function(t, r, n, a, i) {
  var o = t.width, s = t.height, l = t.layout, c = t.children, u = Object.keys(r), f = {
    left: n.left,
    leftMirror: n.left,
    right: o - n.right,
    rightMirror: o - n.right,
    top: n.top,
    topMirror: n.top,
    bottom: s - n.bottom,
    bottomMirror: s - n.bottom
  }, p = !!pr(c, Ir);
  return u.reduce(function(h, m) {
    var v = r[m], g = v.orientation, y = v.domain, b = v.padding, w = b === void 0 ? {} : b, x = v.mirror, C = v.reversed, S = "".concat(g).concat(x ? "Mirror" : ""), E, D, I, k, V;
    if (v.type === "number" && (v.padding === "gap" || v.padding === "no-gap")) {
      var W = y[1] - y[0], L = 1 / 0, G = v.categoricalDomain.sort();
      if (G.forEach(function(N, q) {
        q > 0 && (L = Math.min((N || 0) - (G[q - 1] || 0), L));
      }), Number.isFinite(L)) {
        var Q = L / W, X = v.layout === "vertical" ? n.height : n.width;
        if (v.padding === "gap" && (E = Q * X / 2), v.padding === "no-gap") {
          var K = er(t.barCategoryGap, Q * X), te = Q * X / 2;
          E = te - K - (te - K) / X * K;
        }
      }
    }
    a === "xAxis" ? D = [n.left + (w.left || 0) + (E || 0), n.left + n.width - (w.right || 0) - (E || 0)] : a === "yAxis" ? D = l === "horizontal" ? [n.top + n.height - (w.bottom || 0), n.top + (w.top || 0)] : [n.top + (w.top || 0) + (E || 0), n.top + n.height - (w.bottom || 0) - (E || 0)] : D = v.range, C && (D = [D[1], D[0]]);
    var _ = Py(v, i, p), j = _.scale, T = _.realScaleType;
    j.domain(y).range(D), Ey(j);
    var A = jy(j, Vr(Vr({}, v), {}, {
      realScaleType: T
    }));
    a === "xAxis" ? (V = g === "top" && !x || g === "bottom" && x, I = n.left, k = f[S] - V * v.height) : a === "yAxis" && (V = g === "left" && !x || g === "right" && x, I = f[S] - V * v.width, k = n.top);
    var O = Vr(Vr(Vr({}, v), A), {}, {
      realScaleType: T,
      x: I,
      y: k,
      scale: j,
      width: a === "xAxis" ? n.width : v.width,
      height: a === "yAxis" ? n.height : v.height
    });
    return O.bandSize = H1(O, A), !v.hide && a === "xAxis" ? f[S] += (V ? -1 : 1) * O.height : v.hide || (f[S] += (V ? -1 : 1) * O.width), Vr(Vr({}, h), {}, du({}, m, O));
  }, {});
}, sb = function(t, r) {
  var n = t.x, a = t.y, i = r.x, o = r.y;
  return {
    x: Math.min(n, i),
    y: Math.min(a, o),
    width: Math.abs(i - n),
    height: Math.abs(o - a)
  };
}, Ise = function(t) {
  var r = t.x1, n = t.y1, a = t.x2, i = t.y2;
  return sb({
    x: r,
    y: n
  }, {
    x: a,
    y: i
  });
}, lb = /* @__PURE__ */ function() {
  function e(t) {
    Tse(this, e), this.scale = t;
  }
  return $se(e, [{
    key: "domain",
    get: function() {
      return this.scale.domain;
    }
  }, {
    key: "range",
    get: function() {
      return this.scale.range;
    }
  }, {
    key: "rangeMin",
    get: function() {
      return this.range()[0];
    }
  }, {
    key: "rangeMax",
    get: function() {
      return this.range()[1];
    }
  }, {
    key: "bandwidth",
    get: function() {
      return this.scale.bandwidth;
    }
  }, {
    key: "apply",
    value: function(r) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = n.bandAware, i = n.position;
      if (r !== void 0) {
        if (i)
          switch (i) {
            case "start":
              return this.scale(r);
            case "middle": {
              var o = this.bandwidth ? this.bandwidth() / 2 : 0;
              return this.scale(r) + o;
            }
            case "end": {
              var s = this.bandwidth ? this.bandwidth() : 0;
              return this.scale(r) + s;
            }
            default:
              return this.scale(r);
          }
        if (a) {
          var l = this.bandwidth ? this.bandwidth() / 2 : 0;
          return this.scale(r) + l;
        }
        return this.scale(r);
      }
    }
  }, {
    key: "isInRange",
    value: function(r) {
      var n = this.range(), a = n[0], i = n[n.length - 1];
      return a <= i ? r >= a && r <= i : r >= i && r <= a;
    }
  }], [{
    key: "create",
    value: function(r) {
      return new e(r);
    }
  }]);
}();
du(lb, "EPS", 1e-4);
var Rd = function(t) {
  var r = Object.keys(t).reduce(function(n, a) {
    return Vr(Vr({}, n), {}, du({}, a, lb.create(t[a])));
  }, {});
  return Vr(Vr({}, r), {}, {
    apply: function(a) {
      var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = i.bandAware, s = i.position;
      return tse(a, function(l, c) {
        return r[c].apply(l, {
          bandAware: o,
          position: s
        });
      });
    },
    isInRange: function(a) {
      return tb(a, function(i, o) {
        return r[o].isInRange(i);
      });
    }
  });
};
function Lse(e) {
  return (e % 180 + 180) % 180;
}
var Rse = function(t) {
  var r = t.width, n = t.height, a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, i = Lse(a), o = i * Math.PI / 180, s = Math.atan(n / r), l = o > s && o < Math.PI - s ? n / Math.sin(o) : r / Math.cos(o);
  return Math.abs(l);
}, kse = pn, Bse = sl, Vse = qc;
function Hse(e) {
  return function(t, r, n) {
    var a = Object(t);
    if (!Bse(t)) {
      var i = kse(r);
      t = Vse(t), r = function(s) {
        return i(a[s], s, a);
      };
    }
    var o = e(t, r, n);
    return o > -1 ? a[i ? t[o] : o] : void 0;
  };
}
var Fse = Hse, Wse = Xy;
function zse(e) {
  var t = Wse(e), r = t % 1;
  return t === t ? r ? t - r : t : 0;
}
var Use = zse, Zse = ig, qse = pn, Gse = Use, Yse = Math.max;
function Kse(e, t, r) {
  var n = e == null ? 0 : e.length;
  if (!n)
    return -1;
  var a = r == null ? 0 : Gse(r);
  return a < 0 && (a = Yse(n + a, 0)), Zse(e, qse(t), a);
}
var Xse = Kse, Qse = Fse, Jse = Xse, ele = Qse(Jse), tle = ele;
const rle = /* @__PURE__ */ Je(tle);
var nle = gB(function(e) {
  return {
    x: e.left,
    y: e.top,
    width: e.width,
    height: e.height
  };
}, function(e) {
  return ["l", e.left, "t", e.top, "w", e.width, "h", e.height].join("");
});
function oc(e) {
  "@babel/helpers - typeof";
  return oc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, oc(e);
}
var kd = /* @__PURE__ */ Jn(void 0), Bd = /* @__PURE__ */ Jn(void 0), cb = /* @__PURE__ */ Jn(void 0), ub = /* @__PURE__ */ Jn({}), fb = /* @__PURE__ */ Jn(void 0), db = /* @__PURE__ */ Jn(0), pb = /* @__PURE__ */ Jn(0), Z8 = function(t) {
  var r = t.state, n = r.xAxisMap, a = r.yAxisMap, i = r.offset, o = t.clipPathId, s = t.children, l = t.width, c = t.height, u = nle(i);
  return /* @__PURE__ */ P.createElement(kd.Provider, {
    value: n
  }, /* @__PURE__ */ P.createElement(Bd.Provider, {
    value: a
  }, /* @__PURE__ */ P.createElement(ub.Provider, {
    value: i
  }, /* @__PURE__ */ P.createElement(cb.Provider, {
    value: u
  }, /* @__PURE__ */ P.createElement(fb.Provider, {
    value: o
  }, /* @__PURE__ */ P.createElement(db.Provider, {
    value: c
  }, /* @__PURE__ */ P.createElement(pb.Provider, {
    value: l
  }, s)))))));
}, ale = function() {
  return _t(fb);
};
function hb(e) {
  var t = Object.keys(e);
  return t.length === 0 ? "There are no available ids." : "Available ids are: ".concat(t, ".");
}
var vb = function(t) {
  var r = _t(kd);
  r == null && (process.env.NODE_ENV !== "production" ? Gt(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : Gt(!1));
  var n = r[t];
  return n == null && (process.env.NODE_ENV !== "production" ? Gt(!1, 'Could not find xAxis by id "'.concat(t, '" [').concat(oc(t), "]. ").concat(hb(r))) : Gt(!1)), n;
}, ile = function() {
  var t = _t(kd);
  return Bn(t);
}, ole = function() {
  var t = _t(Bd), r = rle(t, function(n) {
    return tb(n.domain, Number.isFinite);
  });
  return r || Bn(t);
}, mb = function(t) {
  var r = _t(Bd);
  r == null && (process.env.NODE_ENV !== "production" ? Gt(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : Gt(!1));
  var n = r[t];
  return n == null && (process.env.NODE_ENV !== "production" ? Gt(!1, 'Could not find yAxis by id "'.concat(t, '" [').concat(oc(t), "]. ").concat(hb(r))) : Gt(!1)), n;
}, sle = function() {
  var t = _t(cb);
  return t;
}, lle = function() {
  return _t(ub);
}, Vd = function() {
  return _t(pb);
}, Hd = function() {
  return _t(db);
};
function ki(e) {
  "@babel/helpers - typeof";
  return ki = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ki(e);
}
function cle(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function q8(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, yb(n.key), n);
  }
}
function ule(e, t, r) {
  return t && q8(e.prototype, t), r && q8(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function fle(e, t, r) {
  return t = sc(t), dle(e, gb() ? Reflect.construct(t, r || [], sc(e).constructor) : t.apply(e, r));
}
function dle(e, t) {
  if (t && (ki(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return ple(e);
}
function ple(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function gb() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (gb = function() {
    return !!e;
  })();
}
function sc(e) {
  return sc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, sc(e);
}
function hle(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && x0(e, t);
}
function x0(e, t) {
  return x0 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, x0(e, t);
}
function G8(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Y8(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? G8(Object(r), !0).forEach(function(n) {
      Fd(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : G8(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Fd(e, t, r) {
  return t = yb(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function yb(e) {
  var t = vle(e, "string");
  return ki(t) == "symbol" ? t : t + "";
}
function vle(e, t) {
  if (ki(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (ki(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function mle(e, t) {
  return Cle(e) || ble(e, t) || yle(e, t) || gle();
}
function gle() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function yle(e, t) {
  if (e) {
    if (typeof e == "string")
      return K8(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return K8(e, t);
  }
}
function K8(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function ble(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], l = !0, c = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        l = !1;
      } else
        for (; !(l = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); l = !0)
          ;
    } catch (u) {
      c = !0, a = u;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (c)
          throw a;
      }
    }
    return s;
  }
}
function Cle(e) {
  if (Array.isArray(e))
    return e;
}
function w0() {
  return w0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, w0.apply(this, arguments);
}
var xle = function(t, r) {
  var n;
  return /* @__PURE__ */ P.isValidElement(t) ? n = /* @__PURE__ */ P.cloneElement(t, r) : xe(t) ? n = t(r) : n = /* @__PURE__ */ P.createElement("line", w0({}, r, {
    className: "recharts-reference-line-line"
  })), n;
}, wle = function(t, r, n, a, i, o, s, l, c) {
  var u = i.x, f = i.y, p = i.width, h = i.height;
  if (n) {
    var m = c.y, v = t.y.apply(m, {
      position: o
    });
    if (on(c, "discard") && !t.y.isInRange(v))
      return null;
    var g = [{
      x: u + p,
      y: v
    }, {
      x: u,
      y: v
    }];
    return l === "left" ? g.reverse() : g;
  }
  if (r) {
    var y = c.x, b = t.x.apply(y, {
      position: o
    });
    if (on(c, "discard") && !t.x.isInRange(b))
      return null;
    var w = [{
      x: b,
      y: f + h
    }, {
      x: b,
      y: f
    }];
    return s === "top" ? w.reverse() : w;
  }
  if (a) {
    var x = c.segment, C = x.map(function(S) {
      return t.apply(S, {
        position: o
      });
    });
    return on(c, "discard") && qoe(C, function(S) {
      return !t.isInRange(S);
    }) ? null : C;
  }
  return null;
};
function Ole(e) {
  var t = e.x, r = e.y, n = e.segment, a = e.xAxisId, i = e.yAxisId, o = e.shape, s = e.className, l = e.alwaysShow, c = ale(), u = vb(a), f = mb(i), p = sle();
  if (!c || !p)
    return null;
  Ur(l === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
  var h = Rd({
    x: u.scale,
    y: f.scale
  }), m = Lt(t), v = Lt(r), g = n && n.length === 2, y = wle(h, m, v, g, p, e.position, u.orientation, f.orientation, e);
  if (!y)
    return null;
  var b = mle(y, 2), w = b[0], x = w.x, C = w.y, S = b[1], E = S.x, D = S.y, I = on(e, "hidden") ? "url(#".concat(c, ")") : void 0, k = Y8(Y8({
    clipPath: I
  }, pe(e, !0)), {}, {
    x1: x,
    y1: C,
    x2: E,
    y2: D
  });
  return /* @__PURE__ */ P.createElement(De, {
    className: _e("recharts-reference-line", s)
  }, xle(o, k), It.renderCallByParent(e, Ise({
    x1: x,
    y1: C,
    x2: E,
    y2: D
  })));
}
var Wd = /* @__PURE__ */ function(e) {
  function t() {
    return cle(this, t), fle(this, t, arguments);
  }
  return hle(t, e), ule(t, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ P.createElement(Ole, this.props);
    }
  }]);
}(P.Component);
Fd(Wd, "displayName", "ReferenceLine");
Fd(Wd, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  fill: "none",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1,
  position: "middle"
});
function O0() {
  return O0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, O0.apply(this, arguments);
}
function Bi(e) {
  "@babel/helpers - typeof";
  return Bi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Bi(e);
}
function X8(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Q8(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? X8(Object(r), !0).forEach(function(n) {
      pu(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : X8(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Sle(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function J8(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Cb(n.key), n);
  }
}
function Ple(e, t, r) {
  return t && J8(e.prototype, t), r && J8(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Ele(e, t, r) {
  return t = lc(t), jle(e, bb() ? Reflect.construct(t, r || [], lc(e).constructor) : t.apply(e, r));
}
function jle(e, t) {
  if (t && (Bi(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _le(e);
}
function _le(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function bb() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (bb = function() {
    return !!e;
  })();
}
function lc(e) {
  return lc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, lc(e);
}
function Dle(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && S0(e, t);
}
function S0(e, t) {
  return S0 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, S0(e, t);
}
function pu(e, t, r) {
  return t = Cb(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Cb(e) {
  var t = Ale(e, "string");
  return Bi(t) == "symbol" ? t : t + "";
}
function Ale(e, t) {
  if (Bi(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Bi(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Mle = function(t) {
  var r = t.x, n = t.y, a = t.xAxis, i = t.yAxis, o = Rd({
    x: a.scale,
    y: i.scale
  }), s = o.apply({
    x: r,
    y: n
  }, {
    bandAware: !0
  });
  return on(t, "discard") && !o.isInRange(s) ? null : s;
}, hu = /* @__PURE__ */ function(e) {
  function t() {
    return Sle(this, t), Ele(this, t, arguments);
  }
  return Dle(t, e), Ple(t, [{
    key: "render",
    value: function() {
      var n = this.props, a = n.x, i = n.y, o = n.r, s = n.alwaysShow, l = n.clipPathId, c = Lt(a), u = Lt(i);
      if (Ur(s === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.'), !c || !u)
        return null;
      var f = Mle(this.props);
      if (!f)
        return null;
      var p = f.x, h = f.y, m = this.props, v = m.shape, g = m.className, y = on(this.props, "hidden") ? "url(#".concat(l, ")") : void 0, b = Q8(Q8({
        clipPath: y
      }, pe(this.props, !0)), {}, {
        cx: p,
        cy: h
      });
      return /* @__PURE__ */ P.createElement(De, {
        className: _e("recharts-reference-dot", g)
      }, t.renderDot(v, b), It.renderCallByParent(this.props, {
        x: p - o,
        y: h - o,
        width: 2 * o,
        height: 2 * o
      }));
    }
  }]);
}(P.Component);
pu(hu, "displayName", "ReferenceDot");
pu(hu, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#fff",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1
});
pu(hu, "renderDot", function(e, t) {
  var r;
  return /* @__PURE__ */ P.isValidElement(e) ? r = /* @__PURE__ */ P.cloneElement(e, t) : xe(e) ? r = e(t) : r = /* @__PURE__ */ P.createElement(pl, O0({}, t, {
    cx: t.cx,
    cy: t.cy,
    className: "recharts-reference-dot-dot"
  })), r;
});
function P0() {
  return P0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, P0.apply(this, arguments);
}
function Vi(e) {
  "@babel/helpers - typeof";
  return Vi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Vi(e);
}
function e9(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function t9(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? e9(Object(r), !0).forEach(function(n) {
      vu(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : e9(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Tle(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function r9(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, wb(n.key), n);
  }
}
function $le(e, t, r) {
  return t && r9(e.prototype, t), r && r9(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Nle(e, t, r) {
  return t = cc(t), Ile(e, xb() ? Reflect.construct(t, r || [], cc(e).constructor) : t.apply(e, r));
}
function Ile(e, t) {
  if (t && (Vi(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Lle(e);
}
function Lle(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function xb() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (xb = function() {
    return !!e;
  })();
}
function cc(e) {
  return cc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, cc(e);
}
function Rle(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && E0(e, t);
}
function E0(e, t) {
  return E0 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, E0(e, t);
}
function vu(e, t, r) {
  return t = wb(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function wb(e) {
  var t = kle(e, "string");
  return Vi(t) == "symbol" ? t : t + "";
}
function kle(e, t) {
  if (Vi(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Vi(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Ble = function(t, r, n, a, i) {
  var o = i.x1, s = i.x2, l = i.y1, c = i.y2, u = i.xAxis, f = i.yAxis;
  if (!u || !f)
    return null;
  var p = Rd({
    x: u.scale,
    y: f.scale
  }), h = {
    x: t ? p.x.apply(o, {
      position: "start"
    }) : p.x.rangeMin,
    y: n ? p.y.apply(l, {
      position: "start"
    }) : p.y.rangeMin
  }, m = {
    x: r ? p.x.apply(s, {
      position: "end"
    }) : p.x.rangeMax,
    y: a ? p.y.apply(c, {
      position: "end"
    }) : p.y.rangeMax
  };
  return on(i, "discard") && (!p.isInRange(h) || !p.isInRange(m)) ? null : sb(h, m);
}, mu = /* @__PURE__ */ function(e) {
  function t() {
    return Tle(this, t), Nle(this, t, arguments);
  }
  return Rle(t, e), $le(t, [{
    key: "render",
    value: function() {
      var n = this.props, a = n.x1, i = n.x2, o = n.y1, s = n.y2, l = n.className, c = n.alwaysShow, u = n.clipPathId;
      Ur(c === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
      var f = Lt(a), p = Lt(i), h = Lt(o), m = Lt(s), v = this.props.shape;
      if (!f && !p && !h && !m && !v)
        return null;
      var g = Ble(f, p, h, m, this.props);
      if (!g && !v)
        return null;
      var y = on(this.props, "hidden") ? "url(#".concat(u, ")") : void 0;
      return /* @__PURE__ */ P.createElement(De, {
        className: _e("recharts-reference-area", l)
      }, t.renderRect(v, t9(t9({
        clipPath: y
      }, pe(this.props, !0)), g)), It.renderCallByParent(this.props, g));
    }
  }]);
}(P.Component);
vu(mu, "displayName", "ReferenceArea");
vu(mu, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#ccc",
  fillOpacity: 0.5,
  stroke: "none",
  strokeWidth: 1
});
vu(mu, "renderRect", function(e, t) {
  var r;
  return /* @__PURE__ */ P.isValidElement(e) ? r = /* @__PURE__ */ P.cloneElement(e, t) : xe(e) ? r = e(t) : r = /* @__PURE__ */ P.createElement(Ld, P0({}, t, {
    className: "recharts-reference-area-rect"
  })), r;
});
function Ob(e, t, r) {
  if (t < 1)
    return [];
  if (t === 1 && r === void 0)
    return e;
  for (var n = [], a = 0; a < e.length; a += t)
    if (r === void 0 || r(e[a]) === !0)
      n.push(e[a]);
    else
      return;
  return n;
}
function Vle(e, t, r) {
  var n = {
    width: e.width + t.width,
    height: e.height + t.height
  };
  return Rse(n, r);
}
function Hle(e, t, r) {
  var n = r === "width", a = e.x, i = e.y, o = e.width, s = e.height;
  return t === 1 ? {
    start: n ? a : i,
    end: n ? a + o : i + s
  } : {
    start: n ? a + o : i + s,
    end: n ? a : i
  };
}
function uc(e, t, r, n, a) {
  if (e * t < e * n || e * t > e * a)
    return !1;
  var i = r();
  return e * (t - e * i / 2 - n) >= 0 && e * (t + e * i / 2 - a) <= 0;
}
function Fle(e, t) {
  return Ob(e, t + 1);
}
function Wle(e, t, r, n, a) {
  for (var i = (n || []).slice(), o = t.start, s = t.end, l = 0, c = 1, u = o, f = function() {
    var m = n == null ? void 0 : n[l];
    if (m === void 0)
      return {
        v: Ob(n, c)
      };
    var v = l, g, y = function() {
      return g === void 0 && (g = r(m, v)), g;
    }, b = m.coordinate, w = l === 0 || uc(e, b, y, u, s);
    w || (l = 0, u = o, c += 1), w && (u = b + e * (y() / 2 + a), l += c);
  }, p; c <= i.length; )
    if (p = f(), p)
      return p.v;
  return [];
}
function zs(e) {
  "@babel/helpers - typeof";
  return zs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, zs(e);
}
function n9(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Zt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? n9(Object(r), !0).forEach(function(n) {
      zle(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : n9(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function zle(e, t, r) {
  return t = Ule(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Ule(e) {
  var t = Zle(e, "string");
  return zs(t) == "symbol" ? t : t + "";
}
function Zle(e, t) {
  if (zs(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (zs(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function qle(e, t, r, n, a) {
  for (var i = (n || []).slice(), o = i.length, s = t.start, l = t.end, c = function(p) {
    var h = i[p], m, v = function() {
      return m === void 0 && (m = r(h, p)), m;
    };
    if (p === o - 1) {
      var g = e * (h.coordinate + e * v() / 2 - l);
      i[p] = h = Zt(Zt({}, h), {}, {
        tickCoord: g > 0 ? h.coordinate - g * e : h.coordinate
      });
    } else
      i[p] = h = Zt(Zt({}, h), {}, {
        tickCoord: h.coordinate
      });
    var y = uc(e, h.tickCoord, v, s, l);
    y && (l = h.tickCoord - e * (v() / 2 + a), i[p] = Zt(Zt({}, h), {}, {
      isShow: !0
    }));
  }, u = o - 1; u >= 0; u--)
    c(u);
  return i;
}
function Gle(e, t, r, n, a, i) {
  var o = (n || []).slice(), s = o.length, l = t.start, c = t.end;
  if (i) {
    var u = n[s - 1], f = r(u, s - 1), p = e * (u.coordinate + e * f / 2 - c);
    o[s - 1] = u = Zt(Zt({}, u), {}, {
      tickCoord: p > 0 ? u.coordinate - p * e : u.coordinate
    });
    var h = uc(e, u.tickCoord, function() {
      return f;
    }, l, c);
    h && (c = u.tickCoord - e * (f / 2 + a), o[s - 1] = Zt(Zt({}, u), {}, {
      isShow: !0
    }));
  }
  for (var m = i ? s - 1 : s, v = function(b) {
    var w = o[b], x, C = function() {
      return x === void 0 && (x = r(w, b)), x;
    };
    if (b === 0) {
      var S = e * (w.coordinate - e * C() / 2 - l);
      o[b] = w = Zt(Zt({}, w), {}, {
        tickCoord: S < 0 ? w.coordinate - S * e : w.coordinate
      });
    } else
      o[b] = w = Zt(Zt({}, w), {}, {
        tickCoord: w.coordinate
      });
    var E = uc(e, w.tickCoord, C, l, c);
    E && (l = w.tickCoord + e * (C() / 2 + a), o[b] = Zt(Zt({}, w), {}, {
      isShow: !0
    }));
  }, g = 0; g < m; g++)
    v(g);
  return o;
}
function zd(e, t, r) {
  var n = e.tick, a = e.ticks, i = e.viewBox, o = e.minTickGap, s = e.orientation, l = e.interval, c = e.tickFormatter, u = e.unit, f = e.angle;
  if (!a || !a.length || !n)
    return [];
  if (oe(l) || Tr.isSsr)
    return Fle(a, typeof l == "number" && oe(l) ? l : 0);
  var p = [], h = s === "top" || s === "bottom" ? "width" : "height", m = u && h === "width" ? Go(u, {
    fontSize: t,
    letterSpacing: r
  }) : {
    width: 0,
    height: 0
  }, v = function(w, x) {
    var C = xe(c) ? c(w.value, x) : w.value;
    return h === "width" ? Vle(Go(C, {
      fontSize: t,
      letterSpacing: r
    }), m, f) : Go(C, {
      fontSize: t,
      letterSpacing: r
    })[h];
  }, g = a.length >= 2 ? Jt(a[1].coordinate - a[0].coordinate) : 1, y = Hle(i, g, h);
  return l === "equidistantPreserveStart" ? Wle(g, y, v, a, o) : (l === "preserveStart" || l === "preserveStartEnd" ? p = Gle(g, y, v, a, o, l === "preserveStartEnd") : p = qle(g, y, v, a, o), p.filter(function(b) {
    return b.isShow;
  }));
}
var Yle = ["viewBox"], Kle = ["viewBox"], Xle = ["ticks"];
function Hi(e) {
  "@babel/helpers - typeof";
  return Hi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Hi(e);
}
function ui() {
  return ui = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ui.apply(this, arguments);
}
function a9(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Xt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? a9(Object(r), !0).forEach(function(n) {
      Ud(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : a9(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function A2(e, t) {
  if (e == null)
    return {};
  var r = Qle(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Qle(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function Jle(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function i9(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Pb(n.key), n);
  }
}
function e1e(e, t, r) {
  return t && i9(e.prototype, t), r && i9(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function t1e(e, t, r) {
  return t = fc(t), r1e(e, Sb() ? Reflect.construct(t, r || [], fc(e).constructor) : t.apply(e, r));
}
function r1e(e, t) {
  if (t && (Hi(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return n1e(e);
}
function n1e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Sb() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Sb = function() {
    return !!e;
  })();
}
function fc(e) {
  return fc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, fc(e);
}
function a1e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && j0(e, t);
}
function j0(e, t) {
  return j0 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, j0(e, t);
}
function Ud(e, t, r) {
  return t = Pb(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Pb(e) {
  var t = i1e(e, "string");
  return Hi(t) == "symbol" ? t : t + "";
}
function i1e(e, t) {
  if (Hi(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Hi(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var ho = /* @__PURE__ */ function(e) {
  function t(r) {
    var n;
    return Jle(this, t), n = t1e(this, t, [r]), n.state = {
      fontSize: "",
      letterSpacing: ""
    }, n;
  }
  return a1e(t, e), e1e(t, [{
    key: "shouldComponentUpdate",
    value: function(n, a) {
      var i = n.viewBox, o = A2(n, Yle), s = this.props, l = s.viewBox, c = A2(s, Kle);
      return !pi(i, l) || !pi(o, c) || !pi(a, this.state);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      var n = this.layerReference;
      if (n) {
        var a = n.getElementsByClassName("recharts-cartesian-axis-tick-value")[0];
        a && this.setState({
          fontSize: window.getComputedStyle(a).fontSize,
          letterSpacing: window.getComputedStyle(a).letterSpacing
        });
      }
    }
    /**
     * Calculate the coordinates of endpoints in ticks
     * @param  {Object} data The data of a simple tick
     * @return {Object} (x1, y1): The coordinate of endpoint close to tick text
     *  (x2, y2): The coordinate of endpoint close to axis
     */
  }, {
    key: "getTickLineCoord",
    value: function(n) {
      var a = this.props, i = a.x, o = a.y, s = a.width, l = a.height, c = a.orientation, u = a.tickSize, f = a.mirror, p = a.tickMargin, h, m, v, g, y, b, w = f ? -1 : 1, x = n.tickSize || u, C = oe(n.tickCoord) ? n.tickCoord : n.coordinate;
      switch (c) {
        case "top":
          h = m = n.coordinate, g = o + +!f * l, v = g - w * x, b = v - w * p, y = C;
          break;
        case "left":
          v = g = n.coordinate, m = i + +!f * s, h = m - w * x, y = h - w * p, b = C;
          break;
        case "right":
          v = g = n.coordinate, m = i + +f * s, h = m + w * x, y = h + w * p, b = C;
          break;
        default:
          h = m = n.coordinate, g = o + +f * l, v = g + w * x, b = v + w * p, y = C;
          break;
      }
      return {
        line: {
          x1: h,
          y1: v,
          x2: m,
          y2: g
        },
        tick: {
          x: y,
          y: b
        }
      };
    }
  }, {
    key: "getTickTextAnchor",
    value: function() {
      var n = this.props, a = n.orientation, i = n.mirror, o;
      switch (a) {
        case "left":
          o = i ? "start" : "end";
          break;
        case "right":
          o = i ? "end" : "start";
          break;
        default:
          o = "middle";
          break;
      }
      return o;
    }
  }, {
    key: "getTickVerticalAnchor",
    value: function() {
      var n = this.props, a = n.orientation, i = n.mirror, o = "end";
      switch (a) {
        case "left":
        case "right":
          o = "middle";
          break;
        case "top":
          o = i ? "start" : "end";
          break;
        default:
          o = i ? "end" : "start";
          break;
      }
      return o;
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var n = this.props, a = n.x, i = n.y, o = n.width, s = n.height, l = n.orientation, c = n.mirror, u = n.axisLine, f = Xt(Xt(Xt({}, pe(this.props, !1)), pe(u, !1)), {}, {
        fill: "none"
      });
      if (l === "top" || l === "bottom") {
        var p = +(l === "top" && !c || l === "bottom" && c);
        f = Xt(Xt({}, f), {}, {
          x1: a,
          y1: i + p * s,
          x2: a + o,
          y2: i + p * s
        });
      } else {
        var h = +(l === "left" && !c || l === "right" && c);
        f = Xt(Xt({}, f), {}, {
          x1: a + h * o,
          y1: i,
          x2: a + h * o,
          y2: i + s
        });
      }
      return /* @__PURE__ */ P.createElement("line", ui({}, f, {
        className: _e("recharts-cartesian-axis-line", br(u, "className"))
      }));
    }
  }, {
    key: "renderTicks",
    value: (
      /**
       * render the ticks
       * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
       * @param {string} fontSize Fontsize to consider for tick spacing
       * @param {string} letterSpacing Letterspacing to consider for tick spacing
       * @return {ReactComponent} renderedTicks
       */
      function(n, a, i) {
        var o = this, s = this.props, l = s.tickLine, c = s.stroke, u = s.tick, f = s.tickFormatter, p = s.unit, h = zd(Xt(Xt({}, this.props), {}, {
          ticks: n
        }), a, i), m = this.getTickTextAnchor(), v = this.getTickVerticalAnchor(), g = pe(this.props, !1), y = pe(u, !1), b = Xt(Xt({}, g), {}, {
          fill: "none"
        }, pe(l, !1)), w = h.map(function(x, C) {
          var S = o.getTickLineCoord(x), E = S.line, D = S.tick, I = Xt(Xt(Xt(Xt({
            textAnchor: m,
            verticalAnchor: v
          }, g), {}, {
            stroke: "none",
            fill: c
          }, y), D), {}, {
            index: C,
            payload: x,
            visibleTicksCount: h.length,
            tickFormatter: f
          });
          return /* @__PURE__ */ P.createElement(De, ui({
            className: "recharts-cartesian-axis-tick",
            key: "tick-".concat(x.value, "-").concat(x.coordinate, "-").concat(x.tickCoord)
          }, Kn(o.props, x, C)), l && /* @__PURE__ */ P.createElement("line", ui({}, b, E, {
            className: _e("recharts-cartesian-axis-tick-line", br(l, "className"))
          })), u && t.renderTickItem(u, I, "".concat(xe(f) ? f(x.value, C) : x.value).concat(p || "")));
        });
        return /* @__PURE__ */ P.createElement("g", {
          className: "recharts-cartesian-axis-ticks"
        }, w);
      }
    )
  }, {
    key: "render",
    value: function() {
      var n = this, a = this.props, i = a.axisLine, o = a.width, s = a.height, l = a.ticksGenerator, c = a.className, u = a.hide;
      if (u)
        return null;
      var f = this.props, p = f.ticks, h = A2(f, Xle), m = p;
      return xe(l) && (m = p && p.length > 0 ? l(this.props) : l(h)), o <= 0 || s <= 0 || !m || !m.length ? null : /* @__PURE__ */ P.createElement(De, {
        className: _e("recharts-cartesian-axis", c),
        ref: function(g) {
          n.layerReference = g;
        }
      }, i && this.renderAxisLine(), this.renderTicks(m, this.state.fontSize, this.state.letterSpacing), It.renderCallByParent(this.props));
    }
  }], [{
    key: "renderTickItem",
    value: function(n, a, i) {
      var o;
      return /* @__PURE__ */ P.isValidElement(n) ? o = /* @__PURE__ */ P.cloneElement(n, a) : xe(n) ? o = n(a) : o = /* @__PURE__ */ P.createElement(La, ui({}, a, {
        className: "recharts-cartesian-axis-tick-value"
      }), i), o;
    }
  }]);
}(W0);
Ud(ho, "displayName", "CartesianAxis");
Ud(ho, "defaultProps", {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  viewBox: {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  // The orientation of axis
  orientation: "bottom",
  // The ticks
  ticks: [],
  stroke: "#666",
  tickLine: !0,
  axisLine: !0,
  tick: !0,
  mirror: !1,
  minTickGap: 5,
  // The width or height of tick
  tickSize: 6,
  tickMargin: 2,
  interval: "preserveEnd"
});
var o1e = ["x1", "y1", "x2", "y2", "key"], s1e = ["offset"];
function ka(e) {
  "@babel/helpers - typeof";
  return ka = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ka(e);
}
function o9(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function qt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? o9(Object(r), !0).forEach(function(n) {
      l1e(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : o9(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function l1e(e, t, r) {
  return t = c1e(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function c1e(e) {
  var t = u1e(e, "string");
  return ka(t) == "symbol" ? t : t + "";
}
function u1e(e, t) {
  if (ka(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (ka(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Da() {
  return Da = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Da.apply(this, arguments);
}
function s9(e, t) {
  if (e == null)
    return {};
  var r = f1e(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function f1e(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
var d1e = function(t) {
  var r = t.fill;
  if (!r || r === "none")
    return null;
  var n = t.fillOpacity, a = t.x, i = t.y, o = t.width, s = t.height, l = t.ry;
  return /* @__PURE__ */ P.createElement("rect", {
    x: a,
    y: i,
    ry: l,
    width: o,
    height: s,
    stroke: "none",
    fill: r,
    fillOpacity: n,
    className: "recharts-cartesian-grid-bg"
  });
};
function Eb(e, t) {
  var r;
  if (/* @__PURE__ */ P.isValidElement(e))
    r = /* @__PURE__ */ P.cloneElement(e, t);
  else if (xe(e))
    r = e(t);
  else {
    var n = t.x1, a = t.y1, i = t.x2, o = t.y2, s = t.key, l = s9(t, o1e), c = pe(l, !1);
    c.offset;
    var u = s9(c, s1e);
    r = /* @__PURE__ */ P.createElement("line", Da({}, u, {
      x1: n,
      y1: a,
      x2: i,
      y2: o,
      fill: "none",
      key: s
    }));
  }
  return r;
}
function p1e(e) {
  var t = e.x, r = e.width, n = e.horizontal, a = n === void 0 ? !0 : n, i = e.horizontalPoints;
  if (!a || !i || !i.length)
    return null;
  var o = i.map(function(s, l) {
    var c = qt(qt({}, e), {}, {
      x1: t,
      y1: s,
      x2: t + r,
      y2: s,
      key: "line-".concat(l),
      index: l
    });
    return Eb(a, c);
  });
  return /* @__PURE__ */ P.createElement("g", {
    className: "recharts-cartesian-grid-horizontal"
  }, o);
}
function h1e(e) {
  var t = e.y, r = e.height, n = e.vertical, a = n === void 0 ? !0 : n, i = e.verticalPoints;
  if (!a || !i || !i.length)
    return null;
  var o = i.map(function(s, l) {
    var c = qt(qt({}, e), {}, {
      x1: s,
      y1: t,
      x2: s,
      y2: t + r,
      key: "line-".concat(l),
      index: l
    });
    return Eb(a, c);
  });
  return /* @__PURE__ */ P.createElement("g", {
    className: "recharts-cartesian-grid-vertical"
  }, o);
}
function v1e(e) {
  var t = e.horizontalFill, r = e.fillOpacity, n = e.x, a = e.y, i = e.width, o = e.height, s = e.horizontalPoints, l = e.horizontal, c = l === void 0 ? !0 : l;
  if (!c || !t || !t.length)
    return null;
  var u = s.map(function(p) {
    return Math.round(p + a - a);
  }).sort(function(p, h) {
    return p - h;
  });
  a !== u[0] && u.unshift(0);
  var f = u.map(function(p, h) {
    var m = !u[h + 1], v = m ? a + o - p : u[h + 1] - p;
    if (v <= 0)
      return null;
    var g = h % t.length;
    return /* @__PURE__ */ P.createElement("rect", {
      key: "react-".concat(h),
      y: p,
      x: n,
      height: v,
      width: i,
      stroke: "none",
      fill: t[g],
      fillOpacity: r,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ P.createElement("g", {
    className: "recharts-cartesian-gridstripes-horizontal"
  }, f);
}
function m1e(e) {
  var t = e.vertical, r = t === void 0 ? !0 : t, n = e.verticalFill, a = e.fillOpacity, i = e.x, o = e.y, s = e.width, l = e.height, c = e.verticalPoints;
  if (!r || !n || !n.length)
    return null;
  var u = c.map(function(p) {
    return Math.round(p + i - i);
  }).sort(function(p, h) {
    return p - h;
  });
  i !== u[0] && u.unshift(0);
  var f = u.map(function(p, h) {
    var m = !u[h + 1], v = m ? i + s - p : u[h + 1] - p;
    if (v <= 0)
      return null;
    var g = h % n.length;
    return /* @__PURE__ */ P.createElement("rect", {
      key: "react-".concat(h),
      x: p,
      y: o,
      width: v,
      height: l,
      stroke: "none",
      fill: n[g],
      fillOpacity: a,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ P.createElement("g", {
    className: "recharts-cartesian-gridstripes-vertical"
  }, f);
}
var g1e = function(t, r) {
  var n = t.xAxis, a = t.width, i = t.height, o = t.offset;
  return Sy(zd(qt(qt(qt({}, ho.defaultProps), n), {}, {
    ticks: wn(n, !0),
    viewBox: {
      x: 0,
      y: 0,
      width: a,
      height: i
    }
  })), o.left, o.left + o.width, r);
}, y1e = function(t, r) {
  var n = t.yAxis, a = t.width, i = t.height, o = t.offset;
  return Sy(zd(qt(qt(qt({}, ho.defaultProps), n), {}, {
    ticks: wn(n, !0),
    viewBox: {
      x: 0,
      y: 0,
      width: a,
      height: i
    }
  })), o.top, o.top + o.height, r);
}, ti = {
  horizontal: !0,
  vertical: !0,
  // The ordinates of horizontal grid lines
  horizontalPoints: [],
  // The abscissas of vertical grid lines
  verticalPoints: [],
  stroke: "#ccc",
  fill: "none",
  // The fill of colors of grid lines
  verticalFill: [],
  horizontalFill: []
};
function gu(e) {
  var t, r, n, a, i, o, s = Vd(), l = Hd(), c = lle(), u = qt(qt({}, e), {}, {
    stroke: (t = e.stroke) !== null && t !== void 0 ? t : ti.stroke,
    fill: (r = e.fill) !== null && r !== void 0 ? r : ti.fill,
    horizontal: (n = e.horizontal) !== null && n !== void 0 ? n : ti.horizontal,
    horizontalFill: (a = e.horizontalFill) !== null && a !== void 0 ? a : ti.horizontalFill,
    vertical: (i = e.vertical) !== null && i !== void 0 ? i : ti.vertical,
    verticalFill: (o = e.verticalFill) !== null && o !== void 0 ? o : ti.verticalFill,
    x: oe(e.x) ? e.x : c.left,
    y: oe(e.y) ? e.y : c.top,
    width: oe(e.width) ? e.width : c.width,
    height: oe(e.height) ? e.height : c.height
  }), f = u.x, p = u.y, h = u.width, m = u.height, v = u.syncWithTicks, g = u.horizontalValues, y = u.verticalValues, b = ile(), w = ole();
  if (!oe(h) || h <= 0 || !oe(m) || m <= 0 || !oe(f) || f !== +f || !oe(p) || p !== +p)
    return null;
  var x = u.verticalCoordinatesGenerator || g1e, C = u.horizontalCoordinatesGenerator || y1e, S = u.horizontalPoints, E = u.verticalPoints;
  if ((!S || !S.length) && xe(C)) {
    var D = g && g.length, I = C({
      yAxis: w ? qt(qt({}, w), {}, {
        ticks: D ? g : w.ticks
      }) : void 0,
      width: s,
      height: l,
      offset: c
    }, D ? !0 : v);
    Ur(Array.isArray(I), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat(ka(I), "]")), Array.isArray(I) && (S = I);
  }
  if ((!E || !E.length) && xe(x)) {
    var k = y && y.length, V = x({
      xAxis: b ? qt(qt({}, b), {}, {
        ticks: k ? y : b.ticks
      }) : void 0,
      width: s,
      height: l,
      offset: c
    }, k ? !0 : v);
    Ur(Array.isArray(V), "verticalCoordinatesGenerator should return Array but instead it returned [".concat(ka(V), "]")), Array.isArray(V) && (E = V);
  }
  return /* @__PURE__ */ P.createElement("g", {
    className: "recharts-cartesian-grid"
  }, /* @__PURE__ */ P.createElement(d1e, {
    fill: u.fill,
    fillOpacity: u.fillOpacity,
    x: u.x,
    y: u.y,
    width: u.width,
    height: u.height,
    ry: u.ry
  }), /* @__PURE__ */ P.createElement(p1e, Da({}, u, {
    offset: c,
    horizontalPoints: S,
    xAxis: b,
    yAxis: w
  })), /* @__PURE__ */ P.createElement(h1e, Da({}, u, {
    offset: c,
    verticalPoints: E,
    xAxis: b,
    yAxis: w
  })), /* @__PURE__ */ P.createElement(v1e, Da({}, u, {
    horizontalPoints: S
  })), /* @__PURE__ */ P.createElement(m1e, Da({}, u, {
    verticalPoints: E
  })));
}
gu.displayName = "CartesianGrid";
var b1e = ["type", "layout", "connectNulls", "ref"], C1e = ["key"];
function Fi(e) {
  "@babel/helpers - typeof";
  return Fi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Fi(e);
}
function l9(e, t) {
  if (e == null)
    return {};
  var r = x1e(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function x1e(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function es() {
  return es = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, es.apply(this, arguments);
}
function c9(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function fr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? c9(Object(r), !0).forEach(function(n) {
      Hr(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : c9(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function ri(e) {
  return P1e(e) || S1e(e) || O1e(e) || w1e();
}
function w1e() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function O1e(e, t) {
  if (e) {
    if (typeof e == "string")
      return _0(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return _0(e, t);
  }
}
function S1e(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function P1e(e) {
  if (Array.isArray(e))
    return _0(e);
}
function _0(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function E1e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function u9(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, _b(n.key), n);
  }
}
function j1e(e, t, r) {
  return t && u9(e.prototype, t), r && u9(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function _1e(e, t, r) {
  return t = dc(t), D1e(e, jb() ? Reflect.construct(t, r || [], dc(e).constructor) : t.apply(e, r));
}
function D1e(e, t) {
  if (t && (Fi(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return A1e(e);
}
function A1e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function jb() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (jb = function() {
    return !!e;
  })();
}
function dc(e) {
  return dc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, dc(e);
}
function M1e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && D0(e, t);
}
function D0(e, t) {
  return D0 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, D0(e, t);
}
function Hr(e, t, r) {
  return t = _b(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function _b(e) {
  var t = T1e(e, "string");
  return Fi(t) == "symbol" ? t : t + "";
}
function T1e(e, t) {
  if (Fi(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Fi(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var hl = /* @__PURE__ */ function(e) {
  function t() {
    var r;
    E1e(this, t);
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    return r = _1e(this, t, [].concat(a)), Hr(r, "state", {
      isAnimationFinished: !0,
      totalLength: 0
    }), Hr(r, "generateSimpleStrokeDasharray", function(o, s) {
      return "".concat(s, "px ").concat(o - s, "px");
    }), Hr(r, "getStrokeDasharray", function(o, s, l) {
      var c = l.reduce(function(y, b) {
        return y + b;
      });
      if (!c)
        return r.generateSimpleStrokeDasharray(s, o);
      for (var u = Math.floor(o / c), f = o % c, p = s - o, h = [], m = 0, v = 0; m < l.length; v += l[m], ++m)
        if (v + l[m] > f) {
          h = [].concat(ri(l.slice(0, m)), [f - v]);
          break;
        }
      var g = h.length % 2 === 0 ? [0, p] : [p];
      return [].concat(ri(t.repeat(l, u)), ri(h), g).map(function(y) {
        return "".concat(y, "px");
      }).join(", ");
    }), Hr(r, "id", oa("recharts-line-")), Hr(r, "pathRef", function(o) {
      r.mainCurve = o;
    }), Hr(r, "handleAnimationEnd", function() {
      r.setState({
        isAnimationFinished: !0
      }), r.props.onAnimationEnd && r.props.onAnimationEnd();
    }), Hr(r, "handleAnimationStart", function() {
      r.setState({
        isAnimationFinished: !1
      }), r.props.onAnimationStart && r.props.onAnimationStart();
    }), r;
  }
  return M1e(t, e), j1e(t, [{
    key: "componentDidMount",
    value: function() {
      if (this.props.isAnimationActive) {
        var n = this.getTotalLength();
        this.setState({
          totalLength: n
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      if (this.props.isAnimationActive) {
        var n = this.getTotalLength();
        n !== this.state.totalLength && this.setState({
          totalLength: n
        });
      }
    }
  }, {
    key: "getTotalLength",
    value: function() {
      var n = this.mainCurve;
      try {
        return n && n.getTotalLength && n.getTotalLength() || 0;
      } catch {
        return 0;
      }
    }
  }, {
    key: "renderErrorBar",
    value: function(n, a) {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished)
        return null;
      var i = this.props, o = i.points, s = i.xAxis, l = i.yAxis, c = i.layout, u = i.children, f = rr(u, fo);
      if (!f)
        return null;
      var p = function(v, g) {
        return {
          x: v.x,
          y: v.y,
          value: v.value,
          errorVal: vt(v.payload, g)
        };
      }, h = {
        clipPath: n ? "url(#clipPath-".concat(a, ")") : null
      };
      return /* @__PURE__ */ P.createElement(De, h, f.map(function(m) {
        return /* @__PURE__ */ P.cloneElement(m, {
          key: "bar-".concat(m.props.dataKey),
          data: o,
          xAxis: s,
          yAxis: l,
          layout: c,
          dataPointFormatter: p
        });
      }));
    }
  }, {
    key: "renderDots",
    value: function(n, a, i) {
      var o = this.props.isAnimationActive;
      if (o && !this.state.isAnimationFinished)
        return null;
      var s = this.props, l = s.dot, c = s.points, u = s.dataKey, f = pe(this.props, !1), p = pe(l, !0), h = c.map(function(v, g) {
        var y = fr(fr(fr({
          key: "dot-".concat(g),
          r: 3
        }, f), p), {}, {
          value: v.value,
          dataKey: u,
          cx: v.x,
          cy: v.y,
          index: g,
          payload: v.payload
        });
        return t.renderDotItem(l, y);
      }), m = {
        clipPath: n ? "url(#clipPath-".concat(a ? "" : "dots-").concat(i, ")") : null
      };
      return /* @__PURE__ */ P.createElement(De, es({
        className: "recharts-line-dots",
        key: "dots"
      }, m), h);
    }
  }, {
    key: "renderCurveStatically",
    value: function(n, a, i, o) {
      var s = this.props, l = s.type, c = s.layout, u = s.connectNulls;
      s.ref;
      var f = l9(s, b1e), p = fr(fr(fr({}, pe(f, !0)), {}, {
        fill: "none",
        className: "recharts-line-curve",
        clipPath: a ? "url(#clipPath-".concat(i, ")") : null,
        points: n
      }, o), {}, {
        type: l,
        layout: c,
        connectNulls: u
      });
      return /* @__PURE__ */ P.createElement(qn, es({}, p, {
        pathRef: this.pathRef
      }));
    }
  }, {
    key: "renderCurveWithAnimation",
    value: function(n, a) {
      var i = this, o = this.props, s = o.points, l = o.strokeDasharray, c = o.isAnimationActive, u = o.animationBegin, f = o.animationDuration, p = o.animationEasing, h = o.animationId, m = o.animateNewValues, v = o.width, g = o.height, y = this.state, b = y.prevPoints, w = y.totalLength;
      return /* @__PURE__ */ P.createElement(Nr, {
        begin: u,
        duration: f,
        isActive: c,
        easing: p,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "line-".concat(h),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(x) {
        var C = x.t;
        if (b) {
          var S = b.length / s.length, E = s.map(function(W, L) {
            var G = Math.floor(L * S);
            if (b[G]) {
              var Q = b[G], X = bt(Q.x, W.x), K = bt(Q.y, W.y);
              return fr(fr({}, W), {}, {
                x: X(C),
                y: K(C)
              });
            }
            if (m) {
              var te = bt(v * 2, W.x), _ = bt(g / 2, W.y);
              return fr(fr({}, W), {}, {
                x: te(C),
                y: _(C)
              });
            }
            return fr(fr({}, W), {}, {
              x: W.x,
              y: W.y
            });
          });
          return i.renderCurveStatically(E, n, a);
        }
        var D = bt(0, w), I = D(C), k;
        if (l) {
          var V = "".concat(l).split(/[,\s]+/gim).map(function(W) {
            return parseFloat(W);
          });
          k = i.getStrokeDasharray(I, w, V);
        } else
          k = i.generateSimpleStrokeDasharray(w, I);
        return i.renderCurveStatically(s, n, a, {
          strokeDasharray: k
        });
      });
    }
  }, {
    key: "renderCurve",
    value: function(n, a) {
      var i = this.props, o = i.points, s = i.isAnimationActive, l = this.state, c = l.prevPoints, u = l.totalLength;
      return s && o && o.length && (!c && u > 0 || !Xn(c, o)) ? this.renderCurveWithAnimation(n, a) : this.renderCurveStatically(o, n, a);
    }
  }, {
    key: "render",
    value: function() {
      var n, a = this.props, i = a.hide, o = a.dot, s = a.points, l = a.className, c = a.xAxis, u = a.yAxis, f = a.top, p = a.left, h = a.width, m = a.height, v = a.isAnimationActive, g = a.id;
      if (i || !s || !s.length)
        return null;
      var y = this.state.isAnimationFinished, b = s.length === 1, w = _e("recharts-line", l), x = c && c.allowDataOverflow, C = u && u.allowDataOverflow, S = x || C, E = Ce(g) ? this.id : g, D = (n = pe(o, !1)) !== null && n !== void 0 ? n : {
        r: 3,
        strokeWidth: 2
      }, I = D.r, k = I === void 0 ? 3 : I, V = D.strokeWidth, W = V === void 0 ? 2 : V, L = mm(o) ? o : {}, G = L.clipDot, Q = G === void 0 ? !0 : G, X = k * 2 + W;
      return /* @__PURE__ */ P.createElement(De, {
        className: w
      }, x || C ? /* @__PURE__ */ P.createElement("defs", null, /* @__PURE__ */ P.createElement("clipPath", {
        id: "clipPath-".concat(E)
      }, /* @__PURE__ */ P.createElement("rect", {
        x: x ? p : p - h / 2,
        y: C ? f : f - m / 2,
        width: x ? h : h * 2,
        height: C ? m : m * 2
      })), !Q && /* @__PURE__ */ P.createElement("clipPath", {
        id: "clipPath-dots-".concat(E)
      }, /* @__PURE__ */ P.createElement("rect", {
        x: p - X / 2,
        y: f - X / 2,
        width: h + X,
        height: m + X
      }))) : null, !b && this.renderCurve(S, E), this.renderErrorBar(S, E), (b || o) && this.renderDots(S, Q, E), (!v || y) && Zr.renderCallByParent(this.props, s));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, a) {
      return n.animationId !== a.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curPoints: n.points,
        prevPoints: a.curPoints
      } : n.points !== a.curPoints ? {
        curPoints: n.points
      } : null;
    }
  }, {
    key: "repeat",
    value: function(n, a) {
      for (var i = n.length % 2 !== 0 ? [].concat(ri(n), [0]) : n, o = [], s = 0; s < a; ++s)
        o = [].concat(ri(o), ri(i));
      return o;
    }
  }, {
    key: "renderDotItem",
    value: function(n, a) {
      var i;
      if (/* @__PURE__ */ P.isValidElement(n))
        i = /* @__PURE__ */ P.cloneElement(n, a);
      else if (xe(n))
        i = n(a);
      else {
        var o = a.key, s = l9(a, C1e), l = _e("recharts-line-dot", typeof n != "boolean" ? n.className : "");
        i = /* @__PURE__ */ P.createElement(pl, es({
          key: o
        }, s, {
          className: l
        }));
      }
      return i;
    }
  }]);
}(Cr);
Hr(hl, "displayName", "Line");
Hr(hl, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  connectNulls: !1,
  activeDot: !0,
  dot: !0,
  legendType: "line",
  stroke: "#3182bd",
  strokeWidth: 1,
  fill: "#fff",
  points: [],
  isAnimationActive: !Tr.isSsr,
  animateNewValues: !0,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease",
  hide: !1,
  label: !1
});
Hr(hl, "getComposedData", function(e) {
  var t = e.props, r = e.xAxis, n = e.yAxis, a = e.xAxisTicks, i = e.yAxisTicks, o = e.dataKey, s = e.bandSize, l = e.displayedData, c = e.offset, u = t.layout, f = l.map(function(p, h) {
    var m = vt(p, o);
    return u === "horizontal" ? {
      x: Di({
        axis: r,
        ticks: a,
        bandSize: s,
        entry: p,
        index: h
      }),
      y: Ce(m) ? null : n.scale(m),
      value: m,
      payload: p
    } : {
      x: Ce(m) ? null : r.scale(m),
      y: Di({
        axis: n,
        ticks: i,
        bandSize: s,
        entry: p,
        index: h
      }),
      value: m,
      payload: p
    };
  });
  return fr({
    points: f,
    layout: u
  }, c);
});
var $1e = ["layout", "type", "stroke", "connectNulls", "isRange", "ref"], N1e = ["key"], Db;
function Wi(e) {
  "@babel/helpers - typeof";
  return Wi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Wi(e);
}
function Ab(e, t) {
  if (e == null)
    return {};
  var r = I1e(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function I1e(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function Aa() {
  return Aa = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Aa.apply(this, arguments);
}
function f9(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Rn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? f9(Object(r), !0).forEach(function(n) {
      nn(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : f9(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function L1e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function d9(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Tb(n.key), n);
  }
}
function R1e(e, t, r) {
  return t && d9(e.prototype, t), r && d9(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function k1e(e, t, r) {
  return t = pc(t), B1e(e, Mb() ? Reflect.construct(t, r || [], pc(e).constructor) : t.apply(e, r));
}
function B1e(e, t) {
  if (t && (Wi(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return V1e(e);
}
function V1e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Mb() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Mb = function() {
    return !!e;
  })();
}
function pc(e) {
  return pc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, pc(e);
}
function H1e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && A0(e, t);
}
function A0(e, t) {
  return A0 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, A0(e, t);
}
function nn(e, t, r) {
  return t = Tb(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Tb(e) {
  var t = F1e(e, "string");
  return Wi(t) == "symbol" ? t : t + "";
}
function F1e(e, t) {
  if (Wi(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Wi(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Ua = /* @__PURE__ */ function(e) {
  function t() {
    var r;
    L1e(this, t);
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    return r = k1e(this, t, [].concat(a)), nn(r, "state", {
      isAnimationFinished: !0
    }), nn(r, "id", oa("recharts-area-")), nn(r, "handleAnimationEnd", function() {
      var o = r.props.onAnimationEnd;
      r.setState({
        isAnimationFinished: !0
      }), xe(o) && o();
    }), nn(r, "handleAnimationStart", function() {
      var o = r.props.onAnimationStart;
      r.setState({
        isAnimationFinished: !1
      }), xe(o) && o();
    }), r;
  }
  return H1e(t, e), R1e(t, [{
    key: "renderDots",
    value: function(n, a, i) {
      var o = this.props.isAnimationActive, s = this.state.isAnimationFinished;
      if (o && !s)
        return null;
      var l = this.props, c = l.dot, u = l.points, f = l.dataKey, p = pe(this.props, !1), h = pe(c, !0), m = u.map(function(g, y) {
        var b = Rn(Rn(Rn({
          key: "dot-".concat(y),
          r: 3
        }, p), h), {}, {
          index: y,
          cx: g.x,
          cy: g.y,
          dataKey: f,
          value: g.value,
          payload: g.payload,
          points: u
        });
        return t.renderDotItem(c, b);
      }), v = {
        clipPath: n ? "url(#clipPath-".concat(a ? "" : "dots-").concat(i, ")") : null
      };
      return /* @__PURE__ */ P.createElement(De, Aa({
        className: "recharts-area-dots"
      }, v), m);
    }
  }, {
    key: "renderHorizontalRect",
    value: function(n) {
      var a = this.props, i = a.baseLine, o = a.points, s = a.strokeWidth, l = o[0].x, c = o[o.length - 1].x, u = n * Math.abs(l - c), f = Vn(o.map(function(p) {
        return p.y || 0;
      }));
      return oe(i) && typeof i == "number" ? f = Math.max(i, f) : i && Array.isArray(i) && i.length && (f = Math.max(Vn(i.map(function(p) {
        return p.y || 0;
      })), f)), oe(f) ? /* @__PURE__ */ P.createElement("rect", {
        x: l < c ? l : l - u,
        y: 0,
        width: u,
        height: Math.floor(f + (s ? parseInt("".concat(s), 10) : 1))
      }) : null;
    }
  }, {
    key: "renderVerticalRect",
    value: function(n) {
      var a = this.props, i = a.baseLine, o = a.points, s = a.strokeWidth, l = o[0].y, c = o[o.length - 1].y, u = n * Math.abs(l - c), f = Vn(o.map(function(p) {
        return p.x || 0;
      }));
      return oe(i) && typeof i == "number" ? f = Math.max(i, f) : i && Array.isArray(i) && i.length && (f = Math.max(Vn(i.map(function(p) {
        return p.x || 0;
      })), f)), oe(f) ? /* @__PURE__ */ P.createElement("rect", {
        x: 0,
        y: l < c ? l : l - u,
        width: f + (s ? parseInt("".concat(s), 10) : 1),
        height: Math.floor(u)
      }) : null;
    }
  }, {
    key: "renderClipRect",
    value: function(n) {
      var a = this.props.layout;
      return a === "vertical" ? this.renderVerticalRect(n) : this.renderHorizontalRect(n);
    }
  }, {
    key: "renderAreaStatically",
    value: function(n, a, i, o) {
      var s = this.props, l = s.layout, c = s.type, u = s.stroke, f = s.connectNulls, p = s.isRange;
      s.ref;
      var h = Ab(s, $1e);
      return /* @__PURE__ */ P.createElement(De, {
        clipPath: i ? "url(#clipPath-".concat(o, ")") : null
      }, /* @__PURE__ */ P.createElement(qn, Aa({}, pe(h, !0), {
        points: n,
        connectNulls: f,
        type: c,
        baseLine: a,
        layout: l,
        stroke: "none",
        className: "recharts-area-area"
      })), u !== "none" && /* @__PURE__ */ P.createElement(qn, Aa({}, pe(this.props, !1), {
        className: "recharts-area-curve",
        layout: l,
        type: c,
        connectNulls: f,
        fill: "none",
        points: n
      })), u !== "none" && p && /* @__PURE__ */ P.createElement(qn, Aa({}, pe(this.props, !1), {
        className: "recharts-area-curve",
        layout: l,
        type: c,
        connectNulls: f,
        fill: "none",
        points: a
      })));
    }
  }, {
    key: "renderAreaWithAnimation",
    value: function(n, a) {
      var i = this, o = this.props, s = o.points, l = o.baseLine, c = o.isAnimationActive, u = o.animationBegin, f = o.animationDuration, p = o.animationEasing, h = o.animationId, m = this.state, v = m.prevPoints, g = m.prevBaseLine;
      return /* @__PURE__ */ P.createElement(Nr, {
        begin: u,
        duration: f,
        isActive: c,
        easing: p,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "area-".concat(h),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(y) {
        var b = y.t;
        if (v) {
          var w = v.length / s.length, x = s.map(function(D, I) {
            var k = Math.floor(I * w);
            if (v[k]) {
              var V = v[k], W = bt(V.x, D.x), L = bt(V.y, D.y);
              return Rn(Rn({}, D), {}, {
                x: W(b),
                y: L(b)
              });
            }
            return D;
          }), C;
          if (oe(l) && typeof l == "number") {
            var S = bt(g, l);
            C = S(b);
          } else if (Ce(l) || ao(l)) {
            var E = bt(g, 0);
            C = E(b);
          } else
            C = l.map(function(D, I) {
              var k = Math.floor(I * w);
              if (g[k]) {
                var V = g[k], W = bt(V.x, D.x), L = bt(V.y, D.y);
                return Rn(Rn({}, D), {}, {
                  x: W(b),
                  y: L(b)
                });
              }
              return D;
            });
          return i.renderAreaStatically(x, C, n, a);
        }
        return /* @__PURE__ */ P.createElement(De, null, /* @__PURE__ */ P.createElement("defs", null, /* @__PURE__ */ P.createElement("clipPath", {
          id: "animationClipPath-".concat(a)
        }, i.renderClipRect(b))), /* @__PURE__ */ P.createElement(De, {
          clipPath: "url(#animationClipPath-".concat(a, ")")
        }, i.renderAreaStatically(s, l, n, a)));
      });
    }
  }, {
    key: "renderArea",
    value: function(n, a) {
      var i = this.props, o = i.points, s = i.baseLine, l = i.isAnimationActive, c = this.state, u = c.prevPoints, f = c.prevBaseLine, p = c.totalLength;
      return l && o && o.length && (!u && p > 0 || !Xn(u, o) || !Xn(f, s)) ? this.renderAreaWithAnimation(n, a) : this.renderAreaStatically(o, s, n, a);
    }
  }, {
    key: "render",
    value: function() {
      var n, a = this.props, i = a.hide, o = a.dot, s = a.points, l = a.className, c = a.top, u = a.left, f = a.xAxis, p = a.yAxis, h = a.width, m = a.height, v = a.isAnimationActive, g = a.id;
      if (i || !s || !s.length)
        return null;
      var y = this.state.isAnimationFinished, b = s.length === 1, w = _e("recharts-area", l), x = f && f.allowDataOverflow, C = p && p.allowDataOverflow, S = x || C, E = Ce(g) ? this.id : g, D = (n = pe(o, !1)) !== null && n !== void 0 ? n : {
        r: 3,
        strokeWidth: 2
      }, I = D.r, k = I === void 0 ? 3 : I, V = D.strokeWidth, W = V === void 0 ? 2 : V, L = mm(o) ? o : {}, G = L.clipDot, Q = G === void 0 ? !0 : G, X = k * 2 + W;
      return /* @__PURE__ */ P.createElement(De, {
        className: w
      }, x || C ? /* @__PURE__ */ P.createElement("defs", null, /* @__PURE__ */ P.createElement("clipPath", {
        id: "clipPath-".concat(E)
      }, /* @__PURE__ */ P.createElement("rect", {
        x: x ? u : u - h / 2,
        y: C ? c : c - m / 2,
        width: x ? h : h * 2,
        height: C ? m : m * 2
      })), !Q && /* @__PURE__ */ P.createElement("clipPath", {
        id: "clipPath-dots-".concat(E)
      }, /* @__PURE__ */ P.createElement("rect", {
        x: u - X / 2,
        y: c - X / 2,
        width: h + X,
        height: m + X
      }))) : null, b ? null : this.renderArea(S, E), (o || b) && this.renderDots(S, Q, E), (!v || y) && Zr.renderCallByParent(this.props, s));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, a) {
      return n.animationId !== a.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curPoints: n.points,
        curBaseLine: n.baseLine,
        prevPoints: a.curPoints,
        prevBaseLine: a.curBaseLine
      } : n.points !== a.curPoints || n.baseLine !== a.curBaseLine ? {
        curPoints: n.points,
        curBaseLine: n.baseLine
      } : null;
    }
  }]);
}(Cr);
Db = Ua;
nn(Ua, "displayName", "Area");
nn(Ua, "defaultProps", {
  stroke: "#3182bd",
  fill: "#3182bd",
  fillOpacity: 0.6,
  xAxisId: 0,
  yAxisId: 0,
  legendType: "line",
  connectNulls: !1,
  // points of area
  points: [],
  dot: !1,
  activeDot: !0,
  hide: !1,
  isAnimationActive: !Tr.isSsr,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
});
nn(Ua, "getBaseValue", function(e, t, r, n) {
  var a = e.layout, i = e.baseValue, o = t.props.baseValue, s = o ?? i;
  if (oe(s) && typeof s == "number")
    return s;
  var l = a === "horizontal" ? n : r, c = l.scale.domain();
  if (l.type === "number") {
    var u = Math.max(c[0], c[1]), f = Math.min(c[0], c[1]);
    return s === "dataMin" ? f : s === "dataMax" || u < 0 ? u : Math.max(Math.min(c[0], c[1]), 0);
  }
  return s === "dataMin" ? c[0] : s === "dataMax" ? c[1] : c[0];
});
nn(Ua, "getComposedData", function(e) {
  var t = e.props, r = e.item, n = e.xAxis, a = e.yAxis, i = e.xAxisTicks, o = e.yAxisTicks, s = e.bandSize, l = e.dataKey, c = e.stackedData, u = e.dataStartIndex, f = e.displayedData, p = e.offset, h = t.layout, m = c && c.length, v = Db.getBaseValue(t, r, n, a), g = h === "horizontal", y = !1, b = f.map(function(x, C) {
    var S;
    m ? S = c[u + C] : (S = vt(x, l), Array.isArray(S) ? y = !0 : S = [v, S]);
    var E = S[1] == null || m && vt(x, l) == null;
    return g ? {
      x: Di({
        axis: n,
        ticks: i,
        bandSize: s,
        entry: x,
        index: C
      }),
      y: E ? null : a.scale(S[1]),
      value: S,
      payload: x
    } : {
      x: E ? null : n.scale(S[1]),
      y: Di({
        axis: a,
        ticks: o,
        bandSize: s,
        entry: x,
        index: C
      }),
      value: S,
      payload: x
    };
  }), w;
  return m || y ? w = b.map(function(x) {
    var C = Array.isArray(x.value) ? x.value[0] : null;
    return g ? {
      x: x.x,
      y: C != null && x.y != null ? a.scale(C) : null
    } : {
      x: C != null ? n.scale(C) : null,
      y: x.y
    };
  }) : w = g ? a.scale(v) : n.scale(v), Rn({
    points: b,
    baseLine: w,
    layout: h,
    isRange: y
  }, p);
});
nn(Ua, "renderDotItem", function(e, t) {
  var r;
  if (/* @__PURE__ */ P.isValidElement(e))
    r = /* @__PURE__ */ P.cloneElement(e, t);
  else if (xe(e))
    r = e(t);
  else {
    var n = _e("recharts-area-dot", typeof e != "boolean" ? e.className : ""), a = t.key, i = Ab(t, N1e);
    r = /* @__PURE__ */ P.createElement(pl, Aa({}, i, {
      key: a,
      className: n
    }));
  }
  return r;
});
function zi(e) {
  "@babel/helpers - typeof";
  return zi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, zi(e);
}
function W1e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function p9(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Ib(n.key), n);
  }
}
function z1e(e, t, r) {
  return t && p9(e.prototype, t), r && p9(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function U1e(e, t, r) {
  return t = hc(t), Z1e(e, $b() ? Reflect.construct(t, r || [], hc(e).constructor) : t.apply(e, r));
}
function Z1e(e, t) {
  if (t && (zi(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return q1e(e);
}
function q1e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function $b() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return ($b = function() {
    return !!e;
  })();
}
function hc(e) {
  return hc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, hc(e);
}
function G1e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && M0(e, t);
}
function M0(e, t) {
  return M0 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, M0(e, t);
}
function Nb(e, t, r) {
  return t = Ib(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Ib(e) {
  var t = Y1e(e, "string");
  return zi(t) == "symbol" ? t : t + "";
}
function Y1e(e, t) {
  if (zi(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (zi(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var yu = /* @__PURE__ */ function(e) {
  function t() {
    return W1e(this, t), U1e(this, t, arguments);
  }
  return G1e(t, e), z1e(t, [{
    key: "render",
    value: function() {
      return null;
    }
  }]);
}(P.Component);
Nb(yu, "displayName", "ZAxis");
Nb(yu, "defaultProps", {
  zAxisId: 0,
  range: [64, 64],
  scale: "auto",
  type: "number"
});
var K1e = ["option", "isActive"];
function ts() {
  return ts = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ts.apply(this, arguments);
}
function X1e(e, t) {
  if (e == null)
    return {};
  var r = Q1e(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Q1e(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function J1e(e) {
  var t = e.option, r = e.isActive, n = X1e(e, K1e);
  return typeof t == "string" ? /* @__PURE__ */ P.createElement(J1, ts({
    option: /* @__PURE__ */ P.createElement(Zc, ts({
      type: t
    }, n)),
    isActive: r,
    shapeType: "symbols"
  }, n)) : /* @__PURE__ */ P.createElement(J1, ts({
    option: t,
    isActive: r,
    shapeType: "symbols"
  }, n));
}
function Ui(e) {
  "@babel/helpers - typeof";
  return Ui = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ui(e);
}
function rs() {
  return rs = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, rs.apply(this, arguments);
}
function h9(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Er(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? h9(Object(r), !0).forEach(function(n) {
      Fn(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : h9(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function ece(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function v9(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Rb(n.key), n);
  }
}
function tce(e, t, r) {
  return t && v9(e.prototype, t), r && v9(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function rce(e, t, r) {
  return t = vc(t), nce(e, Lb() ? Reflect.construct(t, r || [], vc(e).constructor) : t.apply(e, r));
}
function nce(e, t) {
  if (t && (Ui(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return ace(e);
}
function ace(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Lb() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Lb = function() {
    return !!e;
  })();
}
function vc(e) {
  return vc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, vc(e);
}
function ice(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && T0(e, t);
}
function T0(e, t) {
  return T0 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, T0(e, t);
}
function Fn(e, t, r) {
  return t = Rb(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Rb(e) {
  var t = oce(e, "string");
  return Ui(t) == "symbol" ? t : t + "";
}
function oce(e, t) {
  if (Ui(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Ui(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var bu = /* @__PURE__ */ function(e) {
  function t() {
    var r;
    ece(this, t);
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    return r = rce(this, t, [].concat(a)), Fn(r, "state", {
      isAnimationFinished: !1
    }), Fn(r, "handleAnimationEnd", function() {
      r.setState({
        isAnimationFinished: !0
      });
    }), Fn(r, "handleAnimationStart", function() {
      r.setState({
        isAnimationFinished: !1
      });
    }), Fn(r, "id", oa("recharts-scatter-")), r;
  }
  return ice(t, e), tce(t, [{
    key: "renderSymbolsStatically",
    value: function(n) {
      var a = this, i = this.props, o = i.shape, s = i.activeShape, l = i.activeIndex, c = pe(this.props, !1);
      return n.map(function(u, f) {
        var p = l === f, h = p ? s : o, m = Er(Er({}, c), u);
        return /* @__PURE__ */ P.createElement(De, rs({
          className: "recharts-scatter-symbol",
          key: "symbol-".concat(u == null ? void 0 : u.cx, "-").concat(u == null ? void 0 : u.cy, "-").concat(u == null ? void 0 : u.size, "-").concat(f)
        }, Kn(a.props, u, f), {
          role: "img"
        }), /* @__PURE__ */ P.createElement(J1e, rs({
          option: h,
          isActive: p,
          key: "symbol-".concat(f)
        }, m)));
      });
    }
  }, {
    key: "renderSymbolsWithAnimation",
    value: function() {
      var n = this, a = this.props, i = a.points, o = a.isAnimationActive, s = a.animationBegin, l = a.animationDuration, c = a.animationEasing, u = a.animationId, f = this.state.prevPoints;
      return /* @__PURE__ */ P.createElement(Nr, {
        begin: s,
        duration: l,
        isActive: o,
        easing: c,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "pie-".concat(u),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(p) {
        var h = p.t, m = i.map(function(v, g) {
          var y = f && f[g];
          if (y) {
            var b = bt(y.cx, v.cx), w = bt(y.cy, v.cy), x = bt(y.size, v.size);
            return Er(Er({}, v), {}, {
              cx: b(h),
              cy: w(h),
              size: x(h)
            });
          }
          var C = bt(0, v.size);
          return Er(Er({}, v), {}, {
            size: C(h)
          });
        });
        return /* @__PURE__ */ P.createElement(De, null, n.renderSymbolsStatically(m));
      });
    }
  }, {
    key: "renderSymbols",
    value: function() {
      var n = this.props, a = n.points, i = n.isAnimationActive, o = this.state.prevPoints;
      return i && a && a.length && (!o || !Xn(o, a)) ? this.renderSymbolsWithAnimation() : this.renderSymbolsStatically(a);
    }
  }, {
    key: "renderErrorBar",
    value: function() {
      var n = this.props.isAnimationActive;
      if (n && !this.state.isAnimationFinished)
        return null;
      var a = this.props, i = a.points, o = a.xAxis, s = a.yAxis, l = a.children, c = rr(l, fo);
      return c ? c.map(function(u, f) {
        var p = u.props, h = p.direction, m = p.dataKey;
        return /* @__PURE__ */ P.cloneElement(u, {
          key: "".concat(h, "-").concat(m, "-").concat(i[f]),
          data: i,
          xAxis: o,
          yAxis: s,
          layout: h === "x" ? "vertical" : "horizontal",
          dataPointFormatter: function(g, y) {
            return {
              x: g.cx,
              y: g.cy,
              value: h === "x" ? +g.node.x : +g.node.y,
              errorVal: vt(g, y)
            };
          }
        });
      }) : null;
    }
  }, {
    key: "renderLine",
    value: function() {
      var n = this.props, a = n.points, i = n.line, o = n.lineType, s = n.lineJointType, l = pe(this.props, !1), c = pe(i, !1), u, f;
      if (o === "joint")
        u = a.map(function(w) {
          return {
            x: w.cx,
            y: w.cy
          };
        });
      else if (o === "fitting") {
        var p = hV(a), h = p.xmin, m = p.xmax, v = p.a, g = p.b, y = function(x) {
          return v * x + g;
        };
        u = [{
          x: h,
          y: y(h)
        }, {
          x: m,
          y: y(m)
        }];
      }
      var b = Er(Er(Er({}, l), {}, {
        fill: "none",
        stroke: l && l.fill
      }, c), {}, {
        points: u
      });
      return /* @__PURE__ */ P.isValidElement(i) ? f = /* @__PURE__ */ P.cloneElement(i, b) : xe(i) ? f = i(b) : f = /* @__PURE__ */ P.createElement(qn, rs({}, b, {
        type: s
      })), /* @__PURE__ */ P.createElement(De, {
        className: "recharts-scatter-line",
        key: "recharts-scatter-line"
      }, f);
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, a = n.hide, i = n.points, o = n.line, s = n.className, l = n.xAxis, c = n.yAxis, u = n.left, f = n.top, p = n.width, h = n.height, m = n.id, v = n.isAnimationActive;
      if (a || !i || !i.length)
        return null;
      var g = this.state.isAnimationFinished, y = _e("recharts-scatter", s), b = l && l.allowDataOverflow, w = c && c.allowDataOverflow, x = b || w, C = Ce(m) ? this.id : m;
      return /* @__PURE__ */ P.createElement(De, {
        className: y,
        clipPath: x ? "url(#clipPath-".concat(C, ")") : null
      }, b || w ? /* @__PURE__ */ P.createElement("defs", null, /* @__PURE__ */ P.createElement("clipPath", {
        id: "clipPath-".concat(C)
      }, /* @__PURE__ */ P.createElement("rect", {
        x: b ? u : u - p / 2,
        y: w ? f : f - h / 2,
        width: b ? p : p * 2,
        height: w ? h : h * 2
      }))) : null, o && this.renderLine(), this.renderErrorBar(), /* @__PURE__ */ P.createElement(De, {
        key: "recharts-scatter-symbols"
      }, this.renderSymbols()), (!v || g) && Zr.renderCallByParent(this.props, i));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, a) {
      return n.animationId !== a.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curPoints: n.points,
        prevPoints: a.curPoints
      } : n.points !== a.curPoints ? {
        curPoints: n.points
      } : null;
    }
  }]);
}(Cr);
Fn(bu, "displayName", "Scatter");
Fn(bu, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  zAxisId: 0,
  legendType: "circle",
  lineType: "joint",
  lineJointType: "linear",
  data: [],
  shape: "circle",
  hide: !1,
  isAnimationActive: !Tr.isSsr,
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: "linear"
});
Fn(bu, "getComposedData", function(e) {
  var t = e.xAxis, r = e.yAxis, n = e.zAxis, a = e.item, i = e.displayedData, o = e.xAxisTicks, s = e.yAxisTicks, l = e.offset, c = a.props.tooltipType, u = rr(a.props.children, Gr), f = Ce(t.dataKey) ? a.props.dataKey : t.dataKey, p = Ce(r.dataKey) ? a.props.dataKey : r.dataKey, h = n && n.dataKey, m = n ? n.range : yu.defaultProps.range, v = m && m[0], g = t.scale.bandwidth ? t.scale.bandwidth() : 0, y = r.scale.bandwidth ? r.scale.bandwidth() : 0, b = i.map(function(w, x) {
    var C = vt(w, f), S = vt(w, p), E = !Ce(h) && vt(w, h) || "-", D = [{
      name: Ce(t.dataKey) ? a.props.name : t.name || t.dataKey,
      unit: t.unit || "",
      value: C,
      payload: w,
      dataKey: f,
      type: c
    }, {
      name: Ce(r.dataKey) ? a.props.name : r.name || r.dataKey,
      unit: r.unit || "",
      value: S,
      payload: w,
      dataKey: p,
      type: c
    }];
    E !== "-" && D.push({
      name: n.name || n.dataKey,
      unit: n.unit || "",
      value: E,
      payload: w,
      dataKey: h,
      type: c
    });
    var I = Di({
      axis: t,
      ticks: o,
      bandSize: g,
      entry: w,
      index: x,
      dataKey: f
    }), k = Di({
      axis: r,
      ticks: s,
      bandSize: y,
      entry: w,
      index: x,
      dataKey: p
    }), V = E !== "-" ? n.scale(E) : v, W = Math.sqrt(Math.max(V, 0) / Math.PI);
    return Er(Er({}, w), {}, {
      cx: I,
      cy: k,
      x: I - W,
      y: k - W,
      xAxis: t,
      yAxis: r,
      zAxis: n,
      width: 2 * W,
      height: 2 * W,
      size: V,
      node: {
        x: C,
        y: S,
        z: E
      },
      tooltipPayload: D,
      tooltipPosition: {
        x: I,
        y: k
      },
      payload: w
    }, u && u[x] && u[x].props);
  });
  return Er({
    points: b
  }, l);
});
function Zi(e) {
  "@babel/helpers - typeof";
  return Zi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Zi(e);
}
function sce(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function m9(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Vb(n.key), n);
  }
}
function lce(e, t, r) {
  return t && m9(e.prototype, t), r && m9(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function cce(e, t, r) {
  return t = mc(t), uce(e, kb() ? Reflect.construct(t, r || [], mc(e).constructor) : t.apply(e, r));
}
function uce(e, t) {
  if (t && (Zi(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return fce(e);
}
function fce(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function kb() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (kb = function() {
    return !!e;
  })();
}
function mc(e) {
  return mc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, mc(e);
}
function dce(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && $0(e, t);
}
function $0(e, t) {
  return $0 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, $0(e, t);
}
function Bb(e, t, r) {
  return t = Vb(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Vb(e) {
  var t = pce(e, "string");
  return Zi(t) == "symbol" ? t : t + "";
}
function pce(e, t) {
  if (Zi(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Zi(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function N0() {
  return N0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, N0.apply(this, arguments);
}
function hce(e) {
  var t = e.xAxisId, r = Vd(), n = Hd(), a = vb(t);
  return a == null ? null : (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ P.createElement(ho, N0({}, a, {
      className: _e("recharts-".concat(a.axisType, " ").concat(a.axisType), a.className),
      viewBox: {
        x: 0,
        y: 0,
        width: r,
        height: n
      },
      ticksGenerator: function(o) {
        return wn(o, !0);
      }
    }))
  );
}
var Qn = /* @__PURE__ */ function(e) {
  function t() {
    return sce(this, t), cce(this, t, arguments);
  }
  return dce(t, e), lce(t, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ P.createElement(hce, this.props);
    }
  }]);
}(P.Component);
Bb(Qn, "displayName", "XAxis");
Bb(Qn, "defaultProps", {
  allowDecimals: !0,
  hide: !1,
  orientation: "bottom",
  width: 0,
  height: 30,
  mirror: !1,
  xAxisId: 0,
  tickCount: 5,
  type: "category",
  padding: {
    left: 0,
    right: 0
  },
  allowDataOverflow: !1,
  scale: "auto",
  reversed: !1,
  allowDuplicatedCategory: !0
});
function qi(e) {
  "@babel/helpers - typeof";
  return qi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, qi(e);
}
function vce(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function g9(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Wb(n.key), n);
  }
}
function mce(e, t, r) {
  return t && g9(e.prototype, t), r && g9(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function gce(e, t, r) {
  return t = gc(t), yce(e, Hb() ? Reflect.construct(t, r || [], gc(e).constructor) : t.apply(e, r));
}
function yce(e, t) {
  if (t && (qi(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return bce(e);
}
function bce(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Hb() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Hb = function() {
    return !!e;
  })();
}
function gc(e) {
  return gc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, gc(e);
}
function Cce(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && I0(e, t);
}
function I0(e, t) {
  return I0 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, I0(e, t);
}
function Fb(e, t, r) {
  return t = Wb(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Wb(e) {
  var t = xce(e, "string");
  return qi(t) == "symbol" ? t : t + "";
}
function xce(e, t) {
  if (qi(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (qi(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function L0() {
  return L0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, L0.apply(this, arguments);
}
var wce = function(t) {
  var r = t.yAxisId, n = Vd(), a = Hd(), i = mb(r);
  return i == null ? null : (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ P.createElement(ho, L0({}, i, {
      className: _e("recharts-".concat(i.axisType, " ").concat(i.axisType), i.className),
      viewBox: {
        x: 0,
        y: 0,
        width: n,
        height: a
      },
      ticksGenerator: function(s) {
        return wn(s, !0);
      }
    }))
  );
}, Za = /* @__PURE__ */ function(e) {
  function t() {
    return vce(this, t), gce(this, t, arguments);
  }
  return Cce(t, e), mce(t, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ P.createElement(wce, this.props);
    }
  }]);
}(P.Component);
Fb(Za, "displayName", "YAxis");
Fb(Za, "defaultProps", {
  allowDuplicatedCategory: !0,
  allowDecimals: !0,
  hide: !1,
  orientation: "left",
  width: 60,
  height: 0,
  mirror: !1,
  yAxisId: 0,
  tickCount: 5,
  type: "number",
  padding: {
    top: 0,
    bottom: 0
  },
  allowDataOverflow: !1,
  scale: "auto",
  reversed: !1
});
function y9(e) {
  return Ece(e) || Pce(e) || Sce(e) || Oce();
}
function Oce() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Sce(e, t) {
  if (e) {
    if (typeof e == "string")
      return R0(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return R0(e, t);
  }
}
function Pce(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function Ece(e) {
  if (Array.isArray(e))
    return R0(e);
}
function R0(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var k0 = function(t, r, n, a, i) {
  var o = rr(t, Wd), s = rr(t, hu), l = [].concat(y9(o), y9(s)), c = rr(t, mu), u = "".concat(a, "Id"), f = a[0], p = r;
  if (l.length && (p = l.reduce(function(v, g) {
    if (g.props[u] === n && on(g.props, "extendDomain") && oe(g.props[f])) {
      var y = g.props[f];
      return [Math.min(v[0], y), Math.max(v[1], y)];
    }
    return v;
  }, p)), c.length) {
    var h = "".concat(f, "1"), m = "".concat(f, "2");
    p = c.reduce(function(v, g) {
      if (g.props[u] === n && on(g.props, "extendDomain") && oe(g.props[h]) && oe(g.props[m])) {
        var y = g.props[h], b = g.props[m];
        return [Math.min(v[0], y, b), Math.max(v[1], y, b)];
      }
      return v;
    }, p);
  }
  return i && i.length && (p = i.reduce(function(v, g) {
    return oe(g) ? [Math.min(v[0], g), Math.max(v[1], g)] : v;
  }, p)), p;
}, zb = { exports: {} };
(function(e) {
  var t = Object.prototype.hasOwnProperty, r = "~";
  function n() {
  }
  Object.create && (n.prototype = /* @__PURE__ */ Object.create(null), new n().__proto__ || (r = !1));
  function a(l, c, u) {
    this.fn = l, this.context = c, this.once = u || !1;
  }
  function i(l, c, u, f, p) {
    if (typeof u != "function")
      throw new TypeError("The listener must be a function");
    var h = new a(u, f || l, p), m = r ? r + c : c;
    return l._events[m] ? l._events[m].fn ? l._events[m] = [l._events[m], h] : l._events[m].push(h) : (l._events[m] = h, l._eventsCount++), l;
  }
  function o(l, c) {
    --l._eventsCount === 0 ? l._events = new n() : delete l._events[c];
  }
  function s() {
    this._events = new n(), this._eventsCount = 0;
  }
  s.prototype.eventNames = function() {
    var c = [], u, f;
    if (this._eventsCount === 0)
      return c;
    for (f in u = this._events)
      t.call(u, f) && c.push(r ? f.slice(1) : f);
    return Object.getOwnPropertySymbols ? c.concat(Object.getOwnPropertySymbols(u)) : c;
  }, s.prototype.listeners = function(c) {
    var u = r ? r + c : c, f = this._events[u];
    if (!f)
      return [];
    if (f.fn)
      return [f.fn];
    for (var p = 0, h = f.length, m = new Array(h); p < h; p++)
      m[p] = f[p].fn;
    return m;
  }, s.prototype.listenerCount = function(c) {
    var u = r ? r + c : c, f = this._events[u];
    return f ? f.fn ? 1 : f.length : 0;
  }, s.prototype.emit = function(c, u, f, p, h, m) {
    var v = r ? r + c : c;
    if (!this._events[v])
      return !1;
    var g = this._events[v], y = arguments.length, b, w;
    if (g.fn) {
      switch (g.once && this.removeListener(c, g.fn, void 0, !0), y) {
        case 1:
          return g.fn.call(g.context), !0;
        case 2:
          return g.fn.call(g.context, u), !0;
        case 3:
          return g.fn.call(g.context, u, f), !0;
        case 4:
          return g.fn.call(g.context, u, f, p), !0;
        case 5:
          return g.fn.call(g.context, u, f, p, h), !0;
        case 6:
          return g.fn.call(g.context, u, f, p, h, m), !0;
      }
      for (w = 1, b = new Array(y - 1); w < y; w++)
        b[w - 1] = arguments[w];
      g.fn.apply(g.context, b);
    } else {
      var x = g.length, C;
      for (w = 0; w < x; w++)
        switch (g[w].once && this.removeListener(c, g[w].fn, void 0, !0), y) {
          case 1:
            g[w].fn.call(g[w].context);
            break;
          case 2:
            g[w].fn.call(g[w].context, u);
            break;
          case 3:
            g[w].fn.call(g[w].context, u, f);
            break;
          case 4:
            g[w].fn.call(g[w].context, u, f, p);
            break;
          default:
            if (!b)
              for (C = 1, b = new Array(y - 1); C < y; C++)
                b[C - 1] = arguments[C];
            g[w].fn.apply(g[w].context, b);
        }
    }
    return !0;
  }, s.prototype.on = function(c, u, f) {
    return i(this, c, u, f, !1);
  }, s.prototype.once = function(c, u, f) {
    return i(this, c, u, f, !0);
  }, s.prototype.removeListener = function(c, u, f, p) {
    var h = r ? r + c : c;
    if (!this._events[h])
      return this;
    if (!u)
      return o(this, h), this;
    var m = this._events[h];
    if (m.fn)
      m.fn === u && (!p || m.once) && (!f || m.context === f) && o(this, h);
    else {
      for (var v = 0, g = [], y = m.length; v < y; v++)
        (m[v].fn !== u || p && !m[v].once || f && m[v].context !== f) && g.push(m[v]);
      g.length ? this._events[h] = g.length === 1 ? g[0] : g : o(this, h);
    }
    return this;
  }, s.prototype.removeAllListeners = function(c) {
    var u;
    return c ? (u = r ? r + c : c, this._events[u] && o(this, u)) : (this._events = new n(), this._eventsCount = 0), this;
  }, s.prototype.off = s.prototype.removeListener, s.prototype.addListener = s.prototype.on, s.prefixed = r, s.EventEmitter = s, e.exports = s;
})(zb);
var jce = zb.exports;
const _ce = /* @__PURE__ */ Je(jce);
var M2 = new _ce(), T2 = "recharts.syncMouseEvents";
function Us(e) {
  "@babel/helpers - typeof";
  return Us = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Us(e);
}
function Dce(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function b9(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Ub(n.key), n);
  }
}
function Ace(e, t, r) {
  return t && b9(e.prototype, t), r && b9(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function $2(e, t, r) {
  return t = Ub(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Ub(e) {
  var t = Mce(e, "string");
  return Us(t) == "symbol" ? t : t + "";
}
function Mce(e, t) {
  if (Us(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Us(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Tce = /* @__PURE__ */ function() {
  function e() {
    Dce(this, e), $2(this, "activeIndex", 0), $2(this, "coordinateList", []), $2(this, "layout", "horizontal");
  }
  return Ace(e, [{
    key: "setDetails",
    value: function(r) {
      var n, a = r.coordinateList, i = a === void 0 ? null : a, o = r.container, s = o === void 0 ? null : o, l = r.layout, c = l === void 0 ? null : l, u = r.offset, f = u === void 0 ? null : u, p = r.mouseHandlerCallback, h = p === void 0 ? null : p;
      this.coordinateList = (n = i ?? this.coordinateList) !== null && n !== void 0 ? n : [], this.container = s ?? this.container, this.layout = c ?? this.layout, this.offset = f ?? this.offset, this.mouseHandlerCallback = h ?? this.mouseHandlerCallback, this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
    }
  }, {
    key: "focus",
    value: function() {
      this.spoofMouse();
    }
  }, {
    key: "keyboardEvent",
    value: function(r) {
      if (this.coordinateList.length !== 0)
        switch (r.key) {
          case "ArrowRight": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1), this.spoofMouse();
            break;
          }
          case "ArrowLeft": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.max(this.activeIndex - 1, 0), this.spoofMouse();
            break;
          }
        }
    }
  }, {
    key: "setIndex",
    value: function(r) {
      this.activeIndex = r;
    }
  }, {
    key: "spoofMouse",
    value: function() {
      var r, n;
      if (this.layout === "horizontal" && this.coordinateList.length !== 0) {
        var a = this.container.getBoundingClientRect(), i = a.x, o = a.y, s = a.height, l = this.coordinateList[this.activeIndex].coordinate, c = ((r = window) === null || r === void 0 ? void 0 : r.scrollX) || 0, u = ((n = window) === null || n === void 0 ? void 0 : n.scrollY) || 0, f = i + l + c, p = o + this.offset.top + s / 2 + u;
        this.mouseHandlerCallback({
          pageX: f,
          pageY: p
        });
      }
    }
  }]);
}();
function $ce(e, t, r) {
  if (r === "number" && t === !0 && Array.isArray(e)) {
    var n = e == null ? void 0 : e[0], a = e == null ? void 0 : e[1];
    if (n && a && oe(n) && oe(a))
      return !0;
  }
  return !1;
}
function Nce(e, t, r, n) {
  var a = n / 2;
  return {
    stroke: "none",
    fill: "#ccc",
    x: e === "horizontal" ? t.x - a : r.left + 0.5,
    y: e === "horizontal" ? r.top + 0.5 : t.y - a,
    width: e === "horizontal" ? n : r.width - 1,
    height: e === "horizontal" ? r.height - 1 : n
  };
}
function Zb(e) {
  var t = e.cx, r = e.cy, n = e.radius, a = e.startAngle, i = e.endAngle, o = ft(t, r, n, a), s = ft(t, r, n, i);
  return {
    points: [o, s],
    cx: t,
    cy: r,
    radius: n,
    startAngle: a,
    endAngle: i
  };
}
function Ice(e, t, r) {
  var n, a, i, o;
  if (e === "horizontal")
    n = t.x, i = n, a = r.top, o = r.top + r.height;
  else if (e === "vertical")
    a = t.y, o = a, n = r.left, i = r.left + r.width;
  else if (t.cx != null && t.cy != null)
    if (e === "centric") {
      var s = t.cx, l = t.cy, c = t.innerRadius, u = t.outerRadius, f = t.angle, p = ft(s, l, c, f), h = ft(s, l, u, f);
      n = p.x, a = p.y, i = h.x, o = h.y;
    } else
      return Zb(t);
  return [{
    x: n,
    y: a
  }, {
    x: i,
    y: o
  }];
}
function Zs(e) {
  "@babel/helpers - typeof";
  return Zs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Zs(e);
}
function C9(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Rl(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? C9(Object(r), !0).forEach(function(n) {
      Lce(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : C9(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Lce(e, t, r) {
  return t = Rce(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Rce(e) {
  var t = kce(e, "string");
  return Zs(t) == "symbol" ? t : t + "";
}
function kce(e, t) {
  if (Zs(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Zs(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Bce(e) {
  var t, r, n = e.element, a = e.tooltipEventType, i = e.isActive, o = e.activeCoordinate, s = e.activePayload, l = e.offset, c = e.activeTooltipIndex, u = e.tooltipAxisBandSize, f = e.layout, p = e.chartName, h = (t = n.props.cursor) !== null && t !== void 0 ? t : (r = n.type.defaultProps) === null || r === void 0 ? void 0 : r.cursor;
  if (!n || !h || !i || !o || p !== "ScatterChart" && a !== "axis")
    return null;
  var m, v = qn;
  if (p === "ScatterChart")
    m = o, v = Iae;
  else if (p === "BarChart")
    m = Nce(f, o, l, u), v = Ld;
  else if (f === "radial") {
    var g = Zb(o), y = g.cx, b = g.cy, w = g.radius, x = g.startAngle, C = g.endAngle;
    m = {
      cx: y,
      cy: b,
      startAngle: x,
      endAngle: C,
      innerRadius: w,
      outerRadius: w
    }, v = Iy;
  } else
    m = {
      points: Ice(f, o, l)
    }, v = qn;
  var S = Rl(Rl(Rl(Rl({
    stroke: "#ccc",
    pointerEvents: "none"
  }, l), m), pe(h, !1)), {}, {
    payload: s,
    payloadIndex: c,
    className: _e("recharts-tooltip-cursor", h.className)
  });
  return /* @__PURE__ */ zr(h) ? /* @__PURE__ */ Nt(h, S) : /* @__PURE__ */ D9(v, S);
}
var Vce = ["item"], Hce = ["children", "className", "width", "height", "style", "compact", "title", "desc"];
function Gi(e) {
  "@babel/helpers - typeof";
  return Gi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Gi(e);
}
function ns() {
  return ns = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ns.apply(this, arguments);
}
function x9(e, t) {
  return zce(e) || Wce(e, t) || Gb(e, t) || Fce();
}
function Fce() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Wce(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], l = !0, c = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        l = !1;
      } else
        for (; !(l = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); l = !0)
          ;
    } catch (u) {
      c = !0, a = u;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (c)
          throw a;
      }
    }
    return s;
  }
}
function zce(e) {
  if (Array.isArray(e))
    return e;
}
function w9(e, t) {
  if (e == null)
    return {};
  var r = Uce(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Uce(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function Zce(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function O9(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Yb(n.key), n);
  }
}
function qce(e, t, r) {
  return t && O9(e.prototype, t), r && O9(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Gce(e, t, r) {
  return t = yc(t), Yce(e, qb() ? Reflect.construct(t, r || [], yc(e).constructor) : t.apply(e, r));
}
function Yce(e, t) {
  if (t && (Gi(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Kce(e);
}
function Kce(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function qb() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (qb = function() {
    return !!e;
  })();
}
function yc(e) {
  return yc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, yc(e);
}
function Xce(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && B0(e, t);
}
function B0(e, t) {
  return B0 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, B0(e, t);
}
function Yi(e) {
  return eue(e) || Jce(e) || Gb(e) || Qce();
}
function Qce() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Gb(e, t) {
  if (e) {
    if (typeof e == "string")
      return V0(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return V0(e, t);
  }
}
function Jce(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function eue(e) {
  if (Array.isArray(e))
    return V0(e);
}
function V0(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function S9(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function re(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? S9(Object(r), !0).forEach(function(n) {
      we(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : S9(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function we(e, t, r) {
  return t = Yb(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Yb(e) {
  var t = tue(e, "string");
  return Gi(t) == "symbol" ? t : t + "";
}
function tue(e, t) {
  if (Gi(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Gi(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var rue = {
  xAxis: ["bottom", "top"],
  yAxis: ["left", "right"]
}, nue = {
  width: "100%",
  height: "100%"
}, Kb = {
  x: 0,
  y: 0
};
function kl(e) {
  return e;
}
var aue = function(t, r) {
  return r === "horizontal" ? t.x : r === "vertical" ? t.y : r === "centric" ? t.angle : t.radius;
}, iue = function(t, r, n, a) {
  var i = r.find(function(u) {
    return u && u.index === n;
  });
  if (i) {
    if (t === "horizontal")
      return {
        x: i.coordinate,
        y: a.y
      };
    if (t === "vertical")
      return {
        x: a.x,
        y: i.coordinate
      };
    if (t === "centric") {
      var o = i.coordinate, s = a.radius;
      return re(re(re({}, a), ft(a.cx, a.cy, s, o)), {}, {
        angle: o,
        radius: s
      });
    }
    var l = i.coordinate, c = a.angle;
    return re(re(re({}, a), ft(a.cx, a.cy, l, c)), {}, {
      angle: c,
      radius: l
    });
  }
  return Kb;
}, Cu = function(t, r) {
  var n = r.graphicalItems, a = r.dataStartIndex, i = r.dataEndIndex, o = (n ?? []).reduce(function(s, l) {
    var c = l.props.data;
    return c && c.length ? [].concat(Yi(s), Yi(c)) : s;
  }, []);
  return o.length > 0 ? o : t && t.length && oe(a) && oe(i) ? t.slice(a, i + 1) : [];
};
function Xb(e) {
  return e === "number" ? [0, "auto"] : void 0;
}
var H0 = function(t, r, n, a) {
  var i = t.graphicalItems, o = t.tooltipAxis, s = Cu(r, t);
  return n < 0 || !i || !i.length || n >= s.length ? null : i.reduce(function(l, c) {
    var u, f = (u = c.props.data) !== null && u !== void 0 ? u : r;
    f && t.dataStartIndex + t.dataEndIndex !== 0 && // https://github.com/recharts/recharts/issues/4717
    // The data is sliced only when the active index is within the start/end index range.
    t.dataEndIndex - t.dataStartIndex >= n && (f = f.slice(t.dataStartIndex, t.dataEndIndex + 1));
    var p;
    if (o.dataKey && !o.allowDuplicatedCategory) {
      var h = f === void 0 ? s : f;
      p = p1(h, o.dataKey, a);
    } else
      p = f && f[n] || s[n];
    return p ? [].concat(Yi(l), [Dy(c, p)]) : l;
  }, []);
}, P9 = function(t, r, n, a) {
  var i = a || {
    x: t.chartX,
    y: t.chartY
  }, o = aue(i, n), s = t.orderedTooltipTicks, l = t.tooltipAxis, c = t.tooltipTicks, u = Cte(o, s, c, l);
  if (u >= 0 && c) {
    var f = c[u] && c[u].value, p = H0(t, r, u, f), h = iue(n, s, u, i);
    return {
      activeTooltipIndex: u,
      activeLabel: f,
      activePayload: p,
      activeCoordinate: h
    };
  }
  return null;
}, oue = function(t, r) {
  var n = r.axes, a = r.graphicalItems, i = r.axisType, o = r.axisIdKey, s = r.stackGroups, l = r.dataStartIndex, c = r.dataEndIndex, u = t.layout, f = t.children, p = t.stackOffset, h = Oy(u, i);
  return n.reduce(function(m, v) {
    var g, y = v.type.defaultProps !== void 0 ? re(re({}, v.type.defaultProps), v.props) : v.props, b = y.type, w = y.dataKey, x = y.allowDataOverflow, C = y.allowDuplicatedCategory, S = y.scale, E = y.ticks, D = y.includeHidden, I = y[o];
    if (m[I])
      return m;
    var k = Cu(t.data, {
      graphicalItems: a.filter(function(A) {
        var O, N = o in A.props ? A.props[o] : (O = A.type.defaultProps) === null || O === void 0 ? void 0 : O[o];
        return N === I;
      }),
      dataStartIndex: l,
      dataEndIndex: c
    }), V = k.length, W, L, G;
    $ce(y.domain, x, b) && (W = Q3(y.domain, null, x), h && (b === "number" || S !== "auto") && (G = Ko(k, w, "category")));
    var Q = Xb(b);
    if (!W || W.length === 0) {
      var X, K = (X = y.domain) !== null && X !== void 0 ? X : Q;
      if (w) {
        if (W = Ko(k, w, b), b === "category" && h) {
          var te = pV(W);
          C && te ? (L = W, W = tc(0, V)) : C || (W = N4(K, W, v).reduce(function(A, O) {
            return A.indexOf(O) >= 0 ? A : [].concat(Yi(A), [O]);
          }, []));
        } else if (b === "category")
          C ? W = W.filter(function(A) {
            return A !== "" && !Ce(A);
          }) : W = N4(K, W, v).reduce(function(A, O) {
            return A.indexOf(O) >= 0 || O === "" || Ce(O) ? A : [].concat(Yi(A), [O]);
          }, []);
        else if (b === "number") {
          var _ = Pte(k, a.filter(function(A) {
            var O, N, q = o in A.props ? A.props[o] : (O = A.type.defaultProps) === null || O === void 0 ? void 0 : O[o], Y = "hide" in A.props ? A.props.hide : (N = A.type.defaultProps) === null || N === void 0 ? void 0 : N.hide;
            return q === I && (D || !Y);
          }), w, i, u);
          _ && (W = _);
        }
        h && (b === "number" || S !== "auto") && (G = Ko(k, w, "category"));
      } else
        h ? W = tc(0, V) : s && s[I] && s[I].hasStack && b === "number" ? W = p === "expand" ? [0, 1] : _y(s[I].stackGroups, l, c) : W = wy(k, a.filter(function(A) {
          var O = o in A.props ? A.props[o] : A.type.defaultProps[o], N = "hide" in A.props ? A.props.hide : A.type.defaultProps.hide;
          return O === I && (D || !N);
        }), b, u, !0);
      if (b === "number")
        W = k0(f, W, I, i, E), K && (W = Q3(K, W, x));
      else if (b === "category" && K) {
        var j = K, T = W.every(function(A) {
          return j.indexOf(A) >= 0;
        });
        T && (W = j);
      }
    }
    return re(re({}, m), {}, we({}, I, re(re({}, y), {}, {
      axisType: i,
      domain: W,
      categoricalDomain: G,
      duplicateDomain: L,
      originalDomain: (g = y.domain) !== null && g !== void 0 ? g : Q,
      isCategorical: h,
      layout: u
    })));
  }, {});
}, sue = function(t, r) {
  var n = r.graphicalItems, a = r.Axis, i = r.axisType, o = r.axisIdKey, s = r.stackGroups, l = r.dataStartIndex, c = r.dataEndIndex, u = t.layout, f = t.children, p = Cu(t.data, {
    graphicalItems: n,
    dataStartIndex: l,
    dataEndIndex: c
  }), h = p.length, m = Oy(u, i), v = -1;
  return n.reduce(function(g, y) {
    var b = y.type.defaultProps !== void 0 ? re(re({}, y.type.defaultProps), y.props) : y.props, w = b[o], x = Xb("number");
    if (!g[w]) {
      v++;
      var C;
      return m ? C = tc(0, h) : s && s[w] && s[w].hasStack ? (C = _y(s[w].stackGroups, l, c), C = k0(f, C, w, i)) : (C = Q3(x, wy(p, n.filter(function(S) {
        var E, D, I = o in S.props ? S.props[o] : (E = S.type.defaultProps) === null || E === void 0 ? void 0 : E[o], k = "hide" in S.props ? S.props.hide : (D = S.type.defaultProps) === null || D === void 0 ? void 0 : D.hide;
        return I === w && !k;
      }), "number", u), a.defaultProps.allowDataOverflow), C = k0(f, C, w, i)), re(re({}, g), {}, we({}, w, re(re({
        axisType: i
      }, a.defaultProps), {}, {
        hide: !0,
        orientation: br(rue, "".concat(i, ".").concat(v % 2), null),
        domain: C,
        originalDomain: x,
        isCategorical: m,
        layout: u
        // specify scale when no Axis
        // scale: isCategorical ? 'band' : 'linear',
      })));
    }
    return g;
  }, {});
}, lue = function(t, r) {
  var n = r.axisType, a = n === void 0 ? "xAxis" : n, i = r.AxisComp, o = r.graphicalItems, s = r.stackGroups, l = r.dataStartIndex, c = r.dataEndIndex, u = t.children, f = "".concat(a, "Id"), p = rr(u, i), h = {};
  return p && p.length ? h = oue(t, {
    axes: p,
    graphicalItems: o,
    axisType: a,
    axisIdKey: f,
    stackGroups: s,
    dataStartIndex: l,
    dataEndIndex: c
  }) : o && o.length && (h = sue(t, {
    Axis: i,
    graphicalItems: o,
    axisType: a,
    axisIdKey: f,
    stackGroups: s,
    dataStartIndex: l,
    dataEndIndex: c
  })), h;
}, cue = function(t) {
  var r = Bn(t), n = wn(r, !1, !0);
  return {
    tooltipTicks: n,
    orderedTooltipTicks: cd(n, function(a) {
      return a.coordinate;
    }),
    tooltipAxis: r,
    tooltipAxisBandSize: H1(r, n)
  };
}, E9 = function(t) {
  var r = t.children, n = t.defaultShowTooltip, a = pr(r, Ii), i = 0, o = 0;
  return t.data && t.data.length !== 0 && (o = t.data.length - 1), a && a.props && (a.props.startIndex >= 0 && (i = a.props.startIndex), a.props.endIndex >= 0 && (o = a.props.endIndex)), {
    chartX: 0,
    chartY: 0,
    dataStartIndex: i,
    dataEndIndex: o,
    activeTooltipIndex: -1,
    isTooltipActive: !!n
  };
}, uue = function(t) {
  return !t || !t.length ? !1 : t.some(function(r) {
    var n = Pn(r && r.type);
    return n && n.indexOf("Bar") >= 0;
  });
}, j9 = function(t) {
  return t === "horizontal" ? {
    numericAxisName: "yAxis",
    cateAxisName: "xAxis"
  } : t === "vertical" ? {
    numericAxisName: "xAxis",
    cateAxisName: "yAxis"
  } : t === "centric" ? {
    numericAxisName: "radiusAxis",
    cateAxisName: "angleAxis"
  } : {
    numericAxisName: "angleAxis",
    cateAxisName: "radiusAxis"
  };
}, fue = function(t, r) {
  var n = t.props, a = t.graphicalItems, i = t.xAxisMap, o = i === void 0 ? {} : i, s = t.yAxisMap, l = s === void 0 ? {} : s, c = n.width, u = n.height, f = n.children, p = n.margin || {}, h = pr(f, Ii), m = pr(f, En), v = Object.keys(l).reduce(function(C, S) {
    var E = l[S], D = E.orientation;
    return !E.mirror && !E.hide ? re(re({}, C), {}, we({}, D, C[D] + E.width)) : C;
  }, {
    left: p.left || 0,
    right: p.right || 0
  }), g = Object.keys(o).reduce(function(C, S) {
    var E = o[S], D = E.orientation;
    return !E.mirror && !E.hide ? re(re({}, C), {}, we({}, D, br(C, "".concat(D)) + E.height)) : C;
  }, {
    top: p.top || 0,
    bottom: p.bottom || 0
  }), y = re(re({}, g), v), b = y.bottom;
  h && (y.bottom += h.props.height || Ii.defaultProps.height), m && r && (y = Ote(y, a, n, r));
  var w = c - y.left - y.right, x = u - y.top - y.bottom;
  return re(re({
    brushBottom: b
  }, y), {}, {
    // never return negative values for height and width
    width: Math.max(w, 0),
    height: Math.max(x, 0)
  });
}, due = function(t, r) {
  if (r === "xAxis")
    return t[r].width;
  if (r === "yAxis")
    return t[r].height;
}, Zd = function(t) {
  var r = t.chartName, n = t.GraphicalChild, a = t.defaultTooltipEventType, i = a === void 0 ? "axis" : a, o = t.validateTooltipEventTypes, s = o === void 0 ? ["axis"] : o, l = t.axisComponents, c = t.legendContent, u = t.formatAxisMap, f = t.defaultProps, p = function(g, y) {
    var b = y.graphicalItems, w = y.stackGroups, x = y.offset, C = y.updateId, S = y.dataStartIndex, E = y.dataEndIndex, D = g.barSize, I = g.layout, k = g.barGap, V = g.barCategoryGap, W = g.maxBarSize, L = j9(I), G = L.numericAxisName, Q = L.cateAxisName, X = uue(b), K = [];
    return b.forEach(function(te, _) {
      var j = Cu(g.data, {
        graphicalItems: [te],
        dataStartIndex: S,
        dataEndIndex: E
      }), T = te.type.defaultProps !== void 0 ? re(re({}, te.type.defaultProps), te.props) : te.props, A = T.dataKey, O = T.maxBarSize, N = T["".concat(G, "Id")], q = T["".concat(Q, "Id")], Y = {}, z = l.reduce(function(ve, Te) {
        var We, Ze, yt = y["".concat(Te.axisType, "Map")], Tt = T["".concat(Te.axisType, "Id")];
        yt && yt[Tt] || Te.axisType === "zAxis" || (process.env.NODE_ENV !== "production" ? Gt(!1, "Specifying a(n) ".concat(Te.axisType, "Id requires a corresponding ").concat(
          Te.axisType,
          "Id on the targeted graphical component "
        ).concat((We = te == null || (Ze = te.type) === null || Ze === void 0 ? void 0 : Ze.displayName) !== null && We !== void 0 ? We : "")) : Gt(!1));
        var kr = yt[Tt];
        return re(re({}, ve), {}, we(we({}, Te.axisType, kr), "".concat(Te.axisType, "Ticks"), wn(kr)));
      }, Y), R = z[Q], $ = z["".concat(Q, "Ticks")], F = w && w[N] && w[N].hasStack && Nte(te, w[N].stackGroups), B = Pn(te.type).indexOf("Bar") >= 0, M = H1(R, $), J = [], H = X && xte({
        barSize: D,
        stackGroups: w,
        totalSize: due(z, Q)
      });
      if (B) {
        var ee, ne, ae = Ce(O) ? W : O, se = (ee = (ne = H1(R, $, !0)) !== null && ne !== void 0 ? ne : ae) !== null && ee !== void 0 ? ee : 0;
        J = wte({
          barGap: k,
          barCategoryGap: V,
          bandSize: se !== M ? se : M,
          sizeList: H[q],
          maxBarSize: ae
        }), se !== M && (J = J.map(function(ve) {
          return re(re({}, ve), {}, {
            position: re(re({}, ve.position), {}, {
              offset: ve.position.offset - se / 2
            })
          });
        }));
      }
      var de = te && te.type && te.type.getComposedData;
      de && K.push({
        props: re(re({}, de(re(re({}, z), {}, {
          displayedData: j,
          props: g,
          dataKey: A,
          item: te,
          bandSize: M,
          barPosition: J,
          offset: x,
          stackedData: F,
          layout: I,
          dataStartIndex: S,
          dataEndIndex: E
        }))), {}, we(we(we({
          key: te.key || "item-".concat(_)
        }, G, z[G]), Q, z[Q]), "animationId", C)),
        childIndex: PV(te, g.children),
        item: te
      });
    }), K;
  }, h = function(g, y) {
    var b = g.props, w = g.dataStartIndex, x = g.dataEndIndex, C = g.updateId;
    if (!Sp({
      props: b
    }))
      return null;
    var S = b.children, E = b.layout, D = b.stackOffset, I = b.data, k = b.reverseStackOrder, V = j9(E), W = V.numericAxisName, L = V.cateAxisName, G = rr(S, n), Q = Tte(I, G, "".concat(W, "Id"), "".concat(L, "Id"), D, k), X = l.reduce(function(T, A) {
      var O = "".concat(A.axisType, "Map");
      return re(re({}, T), {}, we({}, O, lue(b, re(re({}, A), {}, {
        graphicalItems: G,
        stackGroups: A.axisType === W && Q,
        dataStartIndex: w,
        dataEndIndex: x
      }))));
    }, {}), K = fue(re(re({}, X), {}, {
      props: b,
      graphicalItems: G
    }), y == null ? void 0 : y.legendBBox);
    Object.keys(X).forEach(function(T) {
      X[T] = u(b, X[T], K, T.replace("Map", ""), r);
    });
    var te = X["".concat(L, "Map")], _ = cue(te), j = p(b, re(re({}, X), {}, {
      dataStartIndex: w,
      dataEndIndex: x,
      updateId: C,
      graphicalItems: G,
      stackGroups: Q,
      offset: K
    }));
    return re(re({
      formattedGraphicalItems: j,
      graphicalItems: G,
      offset: K,
      stackGroups: Q
    }, _), X);
  }, m = /* @__PURE__ */ function(v) {
    function g(y) {
      var b, w, x;
      return Zce(this, g), x = Gce(this, g, [y]), we(x, "eventEmitterSymbol", Symbol("rechartsEventEmitter")), we(x, "accessibilityManager", new Tce()), we(x, "handleLegendBBoxUpdate", function(C) {
        if (C) {
          var S = x.state, E = S.dataStartIndex, D = S.dataEndIndex, I = S.updateId;
          x.setState(re({
            legendBBox: C
          }, h({
            props: x.props,
            dataStartIndex: E,
            dataEndIndex: D,
            updateId: I
          }, re(re({}, x.state), {}, {
            legendBBox: C
          }))));
        }
      }), we(x, "handleReceiveSyncEvent", function(C, S, E) {
        if (x.props.syncId === C) {
          if (E === x.eventEmitterSymbol && typeof x.props.syncMethod != "function")
            return;
          x.applySyncEvent(S);
        }
      }), we(x, "handleBrushChange", function(C) {
        var S = C.startIndex, E = C.endIndex;
        if (S !== x.state.dataStartIndex || E !== x.state.dataEndIndex) {
          var D = x.state.updateId;
          x.setState(function() {
            return re({
              dataStartIndex: S,
              dataEndIndex: E
            }, h({
              props: x.props,
              dataStartIndex: S,
              dataEndIndex: E,
              updateId: D
            }, x.state));
          }), x.triggerSyncEvent({
            dataStartIndex: S,
            dataEndIndex: E
          });
        }
      }), we(x, "handleMouseEnter", function(C) {
        var S = x.getMouseInfo(C);
        if (S) {
          var E = re(re({}, S), {}, {
            isTooltipActive: !0
          });
          x.setState(E), x.triggerSyncEvent(E);
          var D = x.props.onMouseEnter;
          xe(D) && D(E, C);
        }
      }), we(x, "triggeredAfterMouseMove", function(C) {
        var S = x.getMouseInfo(C), E = S ? re(re({}, S), {}, {
          isTooltipActive: !0
        }) : {
          isTooltipActive: !1
        };
        x.setState(E), x.triggerSyncEvent(E);
        var D = x.props.onMouseMove;
        xe(D) && D(E, C);
      }), we(x, "handleItemMouseEnter", function(C) {
        x.setState(function() {
          return {
            isTooltipActive: !0,
            activeItem: C,
            activePayload: C.tooltipPayload,
            activeCoordinate: C.tooltipPosition || {
              x: C.cx,
              y: C.cy
            }
          };
        });
      }), we(x, "handleItemMouseLeave", function() {
        x.setState(function() {
          return {
            isTooltipActive: !1
          };
        });
      }), we(x, "handleMouseMove", function(C) {
        C.persist(), x.throttleTriggeredAfterMouseMove(C);
      }), we(x, "handleMouseLeave", function(C) {
        x.throttleTriggeredAfterMouseMove.cancel();
        var S = {
          isTooltipActive: !1
        };
        x.setState(S), x.triggerSyncEvent(S);
        var E = x.props.onMouseLeave;
        xe(E) && E(S, C);
      }), we(x, "handleOuterEvent", function(C) {
        var S = SV(C), E = br(x.props, "".concat(S));
        if (S && xe(E)) {
          var D, I;
          /.*touch.*/i.test(S) ? I = x.getMouseInfo(C.changedTouches[0]) : I = x.getMouseInfo(C), E((D = I) !== null && D !== void 0 ? D : {}, C);
        }
      }), we(x, "handleClick", function(C) {
        var S = x.getMouseInfo(C);
        if (S) {
          var E = re(re({}, S), {}, {
            isTooltipActive: !0
          });
          x.setState(E), x.triggerSyncEvent(E);
          var D = x.props.onClick;
          xe(D) && D(E, C);
        }
      }), we(x, "handleMouseDown", function(C) {
        var S = x.props.onMouseDown;
        if (xe(S)) {
          var E = x.getMouseInfo(C);
          S(E, C);
        }
      }), we(x, "handleMouseUp", function(C) {
        var S = x.props.onMouseUp;
        if (xe(S)) {
          var E = x.getMouseInfo(C);
          S(E, C);
        }
      }), we(x, "handleTouchMove", function(C) {
        C.changedTouches != null && C.changedTouches.length > 0 && x.throttleTriggeredAfterMouseMove(C.changedTouches[0]);
      }), we(x, "handleTouchStart", function(C) {
        C.changedTouches != null && C.changedTouches.length > 0 && x.handleMouseDown(C.changedTouches[0]);
      }), we(x, "handleTouchEnd", function(C) {
        C.changedTouches != null && C.changedTouches.length > 0 && x.handleMouseUp(C.changedTouches[0]);
      }), we(x, "triggerSyncEvent", function(C) {
        x.props.syncId !== void 0 && M2.emit(T2, x.props.syncId, C, x.eventEmitterSymbol);
      }), we(x, "applySyncEvent", function(C) {
        var S = x.props, E = S.layout, D = S.syncMethod, I = x.state.updateId, k = C.dataStartIndex, V = C.dataEndIndex;
        if (C.dataStartIndex !== void 0 || C.dataEndIndex !== void 0)
          x.setState(re({
            dataStartIndex: k,
            dataEndIndex: V
          }, h({
            props: x.props,
            dataStartIndex: k,
            dataEndIndex: V,
            updateId: I
          }, x.state)));
        else if (C.activeTooltipIndex !== void 0) {
          var W = C.chartX, L = C.chartY, G = C.activeTooltipIndex, Q = x.state, X = Q.offset, K = Q.tooltipTicks;
          if (!X)
            return;
          if (typeof D == "function")
            G = D(K, C);
          else if (D === "value") {
            G = -1;
            for (var te = 0; te < K.length; te++)
              if (K[te].value === C.activeLabel) {
                G = te;
                break;
              }
          }
          var _ = re(re({}, X), {}, {
            x: X.left,
            y: X.top
          }), j = Math.min(W, _.x + _.width), T = Math.min(L, _.y + _.height), A = K[G] && K[G].value, O = H0(x.state, x.props.data, G), N = K[G] ? {
            x: E === "horizontal" ? K[G].coordinate : j,
            y: E === "horizontal" ? T : K[G].coordinate
          } : Kb;
          x.setState(re(re({}, C), {}, {
            activeLabel: A,
            activeCoordinate: N,
            activePayload: O,
            activeTooltipIndex: G
          }));
        } else
          x.setState(C);
      }), we(x, "renderCursor", function(C) {
        var S, E = x.state, D = E.isTooltipActive, I = E.activeCoordinate, k = E.activePayload, V = E.offset, W = E.activeTooltipIndex, L = E.tooltipAxisBandSize, G = x.getTooltipEventType(), Q = (S = C.props.active) !== null && S !== void 0 ? S : D, X = x.props.layout, K = C.key || "_recharts-cursor";
        return /* @__PURE__ */ P.createElement(Bce, {
          key: K,
          activeCoordinate: I,
          activePayload: k,
          activeTooltipIndex: W,
          chartName: r,
          element: C,
          isActive: Q,
          layout: X,
          offset: V,
          tooltipAxisBandSize: L,
          tooltipEventType: G
        });
      }), we(x, "renderPolarAxis", function(C, S, E) {
        var D = br(C, "type.axisType"), I = br(x.state, "".concat(D, "Map")), k = C.type.defaultProps, V = k !== void 0 ? re(re({}, k), C.props) : C.props, W = I && I[V["".concat(D, "Id")]];
        return /* @__PURE__ */ Nt(C, re(re({}, W), {}, {
          className: _e(D, W.className),
          key: C.key || "".concat(S, "-").concat(E),
          ticks: wn(W, !0)
        }));
      }), we(x, "renderPolarGrid", function(C) {
        var S = C.props, E = S.radialLines, D = S.polarAngles, I = S.polarRadius, k = x.state, V = k.radiusAxisMap, W = k.angleAxisMap, L = Bn(V), G = Bn(W), Q = G.cx, X = G.cy, K = G.innerRadius, te = G.outerRadius;
        return /* @__PURE__ */ Nt(C, {
          polarAngles: Array.isArray(D) ? D : wn(G, !0).map(function(_) {
            return _.coordinate;
          }),
          polarRadius: Array.isArray(I) ? I : wn(L, !0).map(function(_) {
            return _.coordinate;
          }),
          cx: Q,
          cy: X,
          innerRadius: K,
          outerRadius: te,
          key: C.key || "polar-grid",
          radialLines: E
        });
      }), we(x, "renderLegend", function() {
        var C = x.state.formattedGraphicalItems, S = x.props, E = S.children, D = S.width, I = S.height, k = x.props.margin || {}, V = D - (k.left || 0) - (k.right || 0), W = Cy({
          children: E,
          formattedGraphicalItems: C,
          legendWidth: V,
          legendContent: c
        });
        if (!W)
          return null;
        var L = W.item, G = w9(W, Vce);
        return /* @__PURE__ */ Nt(L, re(re({}, G), {}, {
          chartWidth: D,
          chartHeight: I,
          margin: k,
          onBBoxUpdate: x.handleLegendBBoxUpdate
        }));
      }), we(x, "renderTooltip", function() {
        var C, S = x.props, E = S.children, D = S.accessibilityLayer, I = pr(E, or);
        if (!I)
          return null;
        var k = x.state, V = k.isTooltipActive, W = k.activeCoordinate, L = k.activePayload, G = k.activeLabel, Q = k.offset, X = (C = I.props.active) !== null && C !== void 0 ? C : V;
        return /* @__PURE__ */ Nt(I, {
          viewBox: re(re({}, Q), {}, {
            x: Q.left,
            y: Q.top
          }),
          active: X,
          label: G,
          payload: X ? L : [],
          coordinate: W,
          accessibilityLayer: D
        });
      }), we(x, "renderBrush", function(C) {
        var S = x.props, E = S.margin, D = S.data, I = x.state, k = I.offset, V = I.dataStartIndex, W = I.dataEndIndex, L = I.updateId;
        return /* @__PURE__ */ Nt(C, {
          key: C.key || "_recharts-brush",
          onChange: $l(x.handleBrushChange, C.props.onChange),
          data: D,
          x: oe(C.props.x) ? C.props.x : k.left,
          y: oe(C.props.y) ? C.props.y : k.top + k.height + k.brushBottom - (E.bottom || 0),
          width: oe(C.props.width) ? C.props.width : k.width,
          startIndex: V,
          endIndex: W,
          updateId: "brush-".concat(L)
        });
      }), we(x, "renderReferenceElement", function(C, S, E) {
        if (!C)
          return null;
        var D = x, I = D.clipPathId, k = x.state, V = k.xAxisMap, W = k.yAxisMap, L = k.offset, G = C.type.defaultProps || {}, Q = C.props, X = Q.xAxisId, K = X === void 0 ? G.xAxisId : X, te = Q.yAxisId, _ = te === void 0 ? G.yAxisId : te;
        return /* @__PURE__ */ Nt(C, {
          key: C.key || "".concat(S, "-").concat(E),
          xAxis: V[K],
          yAxis: W[_],
          viewBox: {
            x: L.left,
            y: L.top,
            width: L.width,
            height: L.height
          },
          clipPathId: I
        });
      }), we(x, "renderActivePoints", function(C) {
        var S = C.item, E = C.activePoint, D = C.basePoint, I = C.childIndex, k = C.isRange, V = [], W = S.props.key, L = S.item.type.defaultProps !== void 0 ? re(re({}, S.item.type.defaultProps), S.item.props) : S.item.props, G = L.activeDot, Q = L.dataKey, X = re(re({
          index: I,
          dataKey: Q,
          cx: E.x,
          cy: E.y,
          r: 4,
          fill: Id(S.item),
          strokeWidth: 2,
          stroke: "#fff",
          payload: E.payload,
          value: E.value
        }, pe(G, !1)), h1(G));
        return V.push(g.renderActiveDot(G, X, "".concat(W, "-activePoint-").concat(I))), D ? V.push(g.renderActiveDot(G, re(re({}, X), {}, {
          cx: D.x,
          cy: D.y
        }), "".concat(W, "-basePoint-").concat(I))) : k && V.push(null), V;
      }), we(x, "renderGraphicChild", function(C, S, E) {
        var D = x.filterFormatItem(C, S, E);
        if (!D)
          return null;
        var I = x.getTooltipEventType(), k = x.state, V = k.isTooltipActive, W = k.tooltipAxis, L = k.activeTooltipIndex, G = k.activeLabel, Q = x.props.children, X = pr(Q, or), K = D.props, te = K.points, _ = K.isRange, j = K.baseLine, T = D.item.type.defaultProps !== void 0 ? re(re({}, D.item.type.defaultProps), D.item.props) : D.item.props, A = T.activeDot, O = T.hide, N = T.activeBar, q = T.activeShape, Y = !!(!O && V && X && (A || N || q)), z = {};
        I !== "axis" && X && X.props.trigger === "click" ? z = {
          onClick: $l(x.handleItemMouseEnter, C.props.onClick)
        } : I !== "axis" && (z = {
          onMouseLeave: $l(x.handleItemMouseLeave, C.props.onMouseLeave),
          onMouseEnter: $l(x.handleItemMouseEnter, C.props.onMouseEnter)
        });
        var R = /* @__PURE__ */ Nt(C, re(re({}, D.props), z));
        function $(Te) {
          return typeof W.dataKey == "function" ? W.dataKey(Te.payload) : null;
        }
        if (Y)
          if (L >= 0) {
            var F, B;
            if (W.dataKey && !W.allowDuplicatedCategory) {
              var M = typeof W.dataKey == "function" ? $ : "payload.".concat(W.dataKey.toString());
              F = p1(te, M, G), B = _ && j && p1(j, M, G);
            } else
              F = te == null ? void 0 : te[L], B = _ && j && j[L];
            if (q || N) {
              var J = C.props.activeIndex !== void 0 ? C.props.activeIndex : L;
              return [/* @__PURE__ */ Nt(C, re(re(re({}, D.props), z), {}, {
                activeIndex: J
              })), null, null];
            }
            if (!Ce(F))
              return [R].concat(Yi(x.renderActivePoints({
                item: D,
                activePoint: F,
                basePoint: B,
                childIndex: L,
                isRange: _
              })));
          } else {
            var H, ee = (H = x.getItemByXY(x.state.activeCoordinate)) !== null && H !== void 0 ? H : {
              graphicalItem: R
            }, ne = ee.graphicalItem, ae = ne.item, se = ae === void 0 ? C : ae, de = ne.childIndex, ve = re(re(re({}, D.props), z), {}, {
              activeIndex: de
            });
            return [/* @__PURE__ */ Nt(se, ve), null, null];
          }
        return _ ? [R, null, null] : [R, null];
      }), we(x, "renderCustomized", function(C, S, E) {
        return /* @__PURE__ */ Nt(C, re(re({
          key: "recharts-customized-".concat(E)
        }, x.props), x.state));
      }), we(x, "renderMap", {
        CartesianGrid: {
          handler: kl,
          once: !0
        },
        ReferenceArea: {
          handler: x.renderReferenceElement
        },
        ReferenceLine: {
          handler: kl
        },
        ReferenceDot: {
          handler: x.renderReferenceElement
        },
        XAxis: {
          handler: kl
        },
        YAxis: {
          handler: kl
        },
        Brush: {
          handler: x.renderBrush,
          once: !0
        },
        Bar: {
          handler: x.renderGraphicChild
        },
        Line: {
          handler: x.renderGraphicChild
        },
        Area: {
          handler: x.renderGraphicChild
        },
        Radar: {
          handler: x.renderGraphicChild
        },
        RadialBar: {
          handler: x.renderGraphicChild
        },
        Scatter: {
          handler: x.renderGraphicChild
        },
        Pie: {
          handler: x.renderGraphicChild
        },
        Funnel: {
          handler: x.renderGraphicChild
        },
        Tooltip: {
          handler: x.renderCursor,
          once: !0
        },
        PolarGrid: {
          handler: x.renderPolarGrid,
          once: !0
        },
        PolarAngleAxis: {
          handler: x.renderPolarAxis
        },
        PolarRadiusAxis: {
          handler: x.renderPolarAxis
        },
        Customized: {
          handler: x.renderCustomized
        }
      }), x.clipPathId = "".concat((b = y.id) !== null && b !== void 0 ? b : oa("recharts"), "-clip"), x.throttleTriggeredAfterMouseMove = bg(x.triggeredAfterMouseMove, (w = y.throttleDelay) !== null && w !== void 0 ? w : 1e3 / 60), x.state = {}, x;
    }
    return Xce(g, v), qce(g, [{
      key: "componentDidMount",
      value: function() {
        var b, w;
        this.addListener(), this.accessibilityManager.setDetails({
          container: this.container,
          offset: {
            left: (b = this.props.margin.left) !== null && b !== void 0 ? b : 0,
            top: (w = this.props.margin.top) !== null && w !== void 0 ? w : 0
          },
          coordinateList: this.state.tooltipTicks,
          mouseHandlerCallback: this.triggeredAfterMouseMove,
          layout: this.props.layout
        }), this.displayDefaultTooltip();
      }
    }, {
      key: "displayDefaultTooltip",
      value: function() {
        var b = this.props, w = b.children, x = b.data, C = b.height, S = b.layout, E = pr(w, or);
        if (E) {
          var D = E.props.defaultIndex;
          if (!(typeof D != "number" || D < 0 || D > this.state.tooltipTicks.length - 1)) {
            var I = this.state.tooltipTicks[D] && this.state.tooltipTicks[D].value, k = H0(this.state, x, D, I), V = this.state.tooltipTicks[D].coordinate, W = (this.state.offset.top + C) / 2, L = S === "horizontal", G = L ? {
              x: V,
              y: W
            } : {
              y: V,
              x: W
            }, Q = this.state.formattedGraphicalItems.find(function(K) {
              var te = K.item;
              return te.type.name === "Scatter";
            });
            Q && (G = re(re({}, G), Q.props.points[D].tooltipPosition), k = Q.props.points[D].tooltipPayload);
            var X = {
              activeTooltipIndex: D,
              isTooltipActive: !0,
              activeLabel: I,
              activePayload: k,
              activeCoordinate: G
            };
            this.setState(X), this.renderCursor(E), this.accessibilityManager.setIndex(D);
          }
        }
      }
    }, {
      key: "getSnapshotBeforeUpdate",
      value: function(b, w) {
        if (!this.props.accessibilityLayer)
          return null;
        if (this.state.tooltipTicks !== w.tooltipTicks && this.accessibilityManager.setDetails({
          coordinateList: this.state.tooltipTicks
        }), this.props.layout !== b.layout && this.accessibilityManager.setDetails({
          layout: this.props.layout
        }), this.props.margin !== b.margin) {
          var x, C;
          this.accessibilityManager.setDetails({
            offset: {
              left: (x = this.props.margin.left) !== null && x !== void 0 ? x : 0,
              top: (C = this.props.margin.top) !== null && C !== void 0 ? C : 0
            }
          });
        }
        return null;
      }
    }, {
      key: "componentDidUpdate",
      value: function(b) {
        p3([pr(b.children, or)], [pr(this.props.children, or)]) || this.displayDefaultTooltip();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.removeListener(), this.throttleTriggeredAfterMouseMove.cancel();
      }
    }, {
      key: "getTooltipEventType",
      value: function() {
        var b = pr(this.props.children, or);
        if (b && typeof b.props.shared == "boolean") {
          var w = b.props.shared ? "axis" : "item";
          return s.indexOf(w) >= 0 ? w : i;
        }
        return i;
      }
      /**
       * Get the information of mouse in chart, return null when the mouse is not in the chart
       * @param  {MousePointer} event    The event object
       * @return {Object}          Mouse data
       */
    }, {
      key: "getMouseInfo",
      value: function(b) {
        if (!this.container)
          return null;
        var w = this.container, x = w.getBoundingClientRect(), C = YK(x), S = {
          chartX: Math.round(b.pageX - C.left),
          chartY: Math.round(b.pageY - C.top)
        }, E = x.width / w.offsetWidth || 1, D = this.inRange(S.chartX, S.chartY, E);
        if (!D)
          return null;
        var I = this.state, k = I.xAxisMap, V = I.yAxisMap, W = this.getTooltipEventType();
        if (W !== "axis" && k && V) {
          var L = Bn(k).scale, G = Bn(V).scale, Q = L && L.invert ? L.invert(S.chartX) : null, X = G && G.invert ? G.invert(S.chartY) : null;
          return re(re({}, S), {}, {
            xValue: Q,
            yValue: X
          });
        }
        var K = P9(this.state, this.props.data, this.props.layout, D);
        return K ? re(re({}, S), K) : null;
      }
    }, {
      key: "inRange",
      value: function(b, w) {
        var x = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, C = this.props.layout, S = b / x, E = w / x;
        if (C === "horizontal" || C === "vertical") {
          var D = this.state.offset, I = S >= D.left && S <= D.left + D.width && E >= D.top && E <= D.top + D.height;
          return I ? {
            x: S,
            y: E
          } : null;
        }
        var k = this.state, V = k.angleAxisMap, W = k.radiusAxisMap;
        if (V && W) {
          var L = Bn(V);
          return R4({
            x: S,
            y: E
          }, L);
        }
        return null;
      }
    }, {
      key: "parseEventsOfWrapper",
      value: function() {
        var b = this.props.children, w = this.getTooltipEventType(), x = pr(b, or), C = {};
        x && w === "axis" && (x.props.trigger === "click" ? C = {
          onClick: this.handleClick
        } : C = {
          onMouseEnter: this.handleMouseEnter,
          onMouseMove: this.handleMouseMove,
          onMouseLeave: this.handleMouseLeave,
          onTouchMove: this.handleTouchMove,
          onTouchStart: this.handleTouchStart,
          onTouchEnd: this.handleTouchEnd
        });
        var S = h1(this.props, this.handleOuterEvent);
        return re(re({}, S), C);
      }
    }, {
      key: "addListener",
      value: function() {
        M2.on(T2, this.handleReceiveSyncEvent);
      }
    }, {
      key: "removeListener",
      value: function() {
        M2.removeListener(T2, this.handleReceiveSyncEvent);
      }
    }, {
      key: "filterFormatItem",
      value: function(b, w, x) {
        for (var C = this.state.formattedGraphicalItems, S = 0, E = C.length; S < E; S++) {
          var D = C[S];
          if (D.item === b || D.props.key === b.key || w === Pn(D.item.type) && x === D.childIndex)
            return D;
        }
        return null;
      }
    }, {
      key: "renderClipPath",
      value: function() {
        var b = this.clipPathId, w = this.state.offset, x = w.left, C = w.top, S = w.height, E = w.width;
        return /* @__PURE__ */ P.createElement("defs", null, /* @__PURE__ */ P.createElement("clipPath", {
          id: b
        }, /* @__PURE__ */ P.createElement("rect", {
          x,
          y: C,
          height: S,
          width: E
        })));
      }
    }, {
      key: "getXScales",
      value: function() {
        var b = this.state.xAxisMap;
        return b ? Object.entries(b).reduce(function(w, x) {
          var C = x9(x, 2), S = C[0], E = C[1];
          return re(re({}, w), {}, we({}, S, E.scale));
        }, {}) : null;
      }
    }, {
      key: "getYScales",
      value: function() {
        var b = this.state.yAxisMap;
        return b ? Object.entries(b).reduce(function(w, x) {
          var C = x9(x, 2), S = C[0], E = C[1];
          return re(re({}, w), {}, we({}, S, E.scale));
        }, {}) : null;
      }
    }, {
      key: "getXScaleByAxisId",
      value: function(b) {
        var w;
        return (w = this.state.xAxisMap) === null || w === void 0 || (w = w[b]) === null || w === void 0 ? void 0 : w.scale;
      }
    }, {
      key: "getYScaleByAxisId",
      value: function(b) {
        var w;
        return (w = this.state.yAxisMap) === null || w === void 0 || (w = w[b]) === null || w === void 0 ? void 0 : w.scale;
      }
    }, {
      key: "getItemByXY",
      value: function(b) {
        var w = this.state, x = w.formattedGraphicalItems, C = w.activeItem;
        if (x && x.length)
          for (var S = 0, E = x.length; S < E; S++) {
            var D = x[S], I = D.props, k = D.item, V = k.type.defaultProps !== void 0 ? re(re({}, k.type.defaultProps), k.props) : k.props, W = Pn(k.type);
            if (W === "Bar") {
              var L = (I.data || []).find(function(K) {
                return vae(b, K);
              });
              if (L)
                return {
                  graphicalItem: D,
                  payload: L
                };
            } else if (W === "RadialBar") {
              var G = (I.data || []).find(function(K) {
                return R4(b, K);
              });
              if (G)
                return {
                  graphicalItem: D,
                  payload: G
                };
            } else if (uu(D, C) || fu(D, C) || Hs(D, C)) {
              var Q = noe({
                graphicalItem: D,
                activeTooltipItem: C,
                itemData: V.data
              }), X = V.activeIndex === void 0 ? Q : V.activeIndex;
              return {
                graphicalItem: re(re({}, D), {}, {
                  childIndex: X
                }),
                payload: Hs(D, C) ? V.data[Q] : D.props.data[Q]
              };
            }
          }
        return null;
      }
    }, {
      key: "render",
      value: function() {
        var b = this;
        if (!Sp(this))
          return null;
        var w = this.props, x = w.children, C = w.className, S = w.width, E = w.height, D = w.style, I = w.compact, k = w.title, V = w.desc, W = w9(w, Hce), L = pe(W, !1);
        if (I)
          return /* @__PURE__ */ P.createElement(Z8, {
            state: this.state,
            width: this.props.width,
            height: this.props.height,
            clipPathId: this.clipPathId
          }, /* @__PURE__ */ P.createElement(v3, ns({}, L, {
            width: S,
            height: E,
            title: k,
            desc: V
          }), this.renderClipPath(), Ep(x, this.renderMap)));
        if (this.props.accessibilityLayer) {
          var G, Q;
          L.tabIndex = (G = this.props.tabIndex) !== null && G !== void 0 ? G : 0, L.role = (Q = this.props.role) !== null && Q !== void 0 ? Q : "application", L.onKeyDown = function(K) {
            b.accessibilityManager.keyboardEvent(K);
          }, L.onFocus = function() {
            b.accessibilityManager.focus();
          };
        }
        var X = this.parseEventsOfWrapper();
        return /* @__PURE__ */ P.createElement(Z8, {
          state: this.state,
          width: this.props.width,
          height: this.props.height,
          clipPathId: this.clipPathId
        }, /* @__PURE__ */ P.createElement("div", ns({
          className: _e("recharts-wrapper", C),
          style: re({
            position: "relative",
            cursor: "default",
            width: S,
            height: E
          }, D)
        }, X, {
          ref: function(te) {
            b.container = te;
          }
        }), /* @__PURE__ */ P.createElement(v3, ns({}, L, {
          width: S,
          height: E,
          title: k,
          desc: V,
          style: nue
        }), this.renderClipPath(), Ep(x, this.renderMap)), this.renderLegend(), this.renderTooltip()));
      }
    }]);
  }(W0);
  return we(m, "displayName", r), we(m, "defaultProps", re({
    layout: "horizontal",
    stackOffset: "none",
    barCategoryGap: "10%",
    barGap: 4,
    margin: {
      top: 5,
      right: 5,
      bottom: 5,
      left: 5
    },
    reverseStackOrder: !1,
    syncMethod: "index"
  }, f)), we(m, "getDerivedStateFromProps", function(v, g) {
    var y = v.dataKey, b = v.data, w = v.children, x = v.width, C = v.height, S = v.layout, E = v.stackOffset, D = v.margin, I = g.dataStartIndex, k = g.dataEndIndex;
    if (g.updateId === void 0) {
      var V = E9(v);
      return re(re(re({}, V), {}, {
        updateId: 0
      }, h(re(re({
        props: v
      }, V), {}, {
        updateId: 0
      }), g)), {}, {
        prevDataKey: y,
        prevData: b,
        prevWidth: x,
        prevHeight: C,
        prevLayout: S,
        prevStackOffset: E,
        prevMargin: D,
        prevChildren: w
      });
    }
    if (y !== g.prevDataKey || b !== g.prevData || x !== g.prevWidth || C !== g.prevHeight || S !== g.prevLayout || E !== g.prevStackOffset || !pi(D, g.prevMargin)) {
      var W = E9(v), L = {
        // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
        // any flickering
        chartX: g.chartX,
        chartY: g.chartY,
        // The tooltip should stay active when it was active in the previous render. If this is not
        // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
        isTooltipActive: g.isTooltipActive
      }, G = re(re({}, P9(g, b, S)), {}, {
        updateId: g.updateId + 1
      }), Q = re(re(re({}, W), L), G);
      return re(re(re({}, Q), h(re({
        props: v
      }, Q), g)), {}, {
        prevDataKey: y,
        prevData: b,
        prevWidth: x,
        prevHeight: C,
        prevLayout: S,
        prevStackOffset: E,
        prevMargin: D,
        prevChildren: w
      });
    }
    if (!p3(w, g.prevChildren)) {
      var X, K, te, _, j = pr(w, Ii), T = j && (X = (K = j.props) === null || K === void 0 ? void 0 : K.startIndex) !== null && X !== void 0 ? X : I, A = j && (te = (_ = j.props) === null || _ === void 0 ? void 0 : _.endIndex) !== null && te !== void 0 ? te : k, O = T !== I || A !== k, N = !Ce(b), q = N && !O ? g.updateId : g.updateId + 1;
      return re(re({
        updateId: q
      }, h(re(re({
        props: v
      }, g), {}, {
        updateId: q,
        dataStartIndex: T,
        dataEndIndex: A
      }), g)), {}, {
        prevChildren: w,
        dataStartIndex: T,
        dataEndIndex: A
      });
    }
    return null;
  }), we(m, "renderActiveDot", function(v, g, y) {
    var b;
    return /* @__PURE__ */ zr(v) ? b = /* @__PURE__ */ Nt(v, g) : xe(v) ? b = v(g) : b = /* @__PURE__ */ P.createElement(pl, g), /* @__PURE__ */ P.createElement(De, {
      className: "recharts-active-dot",
      key: y
    }, b);
  }), function(g) {
    return /* @__PURE__ */ P.createElement(m, g);
  };
}, Qb = Zd({
  chartName: "BarChart",
  GraphicalChild: Ir,
  defaultTooltipEventType: "axis",
  validateTooltipEventTypes: ["axis", "item"],
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: Qn
  }, {
    axisType: "yAxis",
    AxisComp: Za
  }],
  formatAxisMap: ob
}), Jb = Zd({
  chartName: "PieChart",
  GraphicalChild: hn,
  validateTooltipEventTypes: ["item"],
  defaultTooltipEventType: "item",
  legendContent: "children",
  axisComponents: [{
    axisType: "angleAxis",
    AxisComp: cu
  }, {
    axisType: "radiusAxis",
    AxisComp: su
  }],
  formatAxisMap: zte,
  defaultProps: {
    layout: "centric",
    startAngle: 0,
    endAngle: 360,
    cx: "50%",
    cy: "50%",
    innerRadius: 0,
    outerRadius: "80%"
  }
}), pue = Zd({
  chartName: "ComposedChart",
  GraphicalChild: [hl, Ua, Ir, bu],
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: Qn
  }, {
    axisType: "yAxis",
    AxisComp: Za
  }, {
    axisType: "zAxis",
    AxisComp: yu
  }],
  formatAxisMap: ob
});
const hue = P.forwardRef((e, t) => {
  const {
    data: r,
    onClickCellChart: n,
    onClickIconCard: a,
    chartColors: i,
    labelOne: o,
    labelTwo: s,
    ...l
  } = e;
  if (r == null || o == null)
    return null;
  const c = (y) => () => {
    n !== void 0 && n({ data: y });
  }, u = (y) => () => {
    a !== void 0 && a({ data: y });
  }, f = i.map((y) => Ae[y.colorCellChart]), p = i.map((y) => y.bgColorCards), h = i.map((y) => y.iconColor), m = i.map((y) => y.textColor), v = {
    gridTemplateColumns: "4fr 6fr"
  }, g = ({ labelTop: y, labelBottom: b }) => /* @__PURE__ */ d.jsxs("g", { children: [
    /* @__PURE__ */ d.jsx("text", { x: "50%", y: "50%", textAnchor: "middle", dominantBaseline: "middle", fontSize: 30, fontWeight: "700", fill: "#292929", children: y }),
    /* @__PURE__ */ d.jsx("text", { x: "50%", y: "60%", textAnchor: "middle", dominantBaseline: "middle", fontSize: 14, fontWeight: "400", fill: "#292929", children: b })
  ] });
  return /* @__PURE__ */ d.jsx("section", { ref: t, className: "flex justify-center items-center", ...l, children: /* @__PURE__ */ d.jsxs("div", { className: "w-full max-w-[1260px] flex flex-col gap-4 2s:grid 2s:gap-8 relative", style: v, children: [
    /* @__PURE__ */ d.jsx(ll, { width: "100%", height: 300, children: /* @__PURE__ */ d.jsxs(Jb, { children: [
      /* @__PURE__ */ d.jsxs(
        hn,
        {
          dataKey: "value",
          data: r,
          innerRadius: "55%",
          outerRadius: "100%",
          cursor: "pointer",
          children: [
            /* @__PURE__ */ d.jsx(
              It,
              {
                content: /* @__PURE__ */ d.jsx(g, { labelTop: o ?? "", labelBottom: s ?? "" }),
                position: "center"
              }
            ),
            r.map((y, b) => /* @__PURE__ */ d.jsx(
              Gr,
              {
                fill: f[b % f.length],
                onClick: c(y)
              },
              `cell-${b}`
            ))
          ]
        }
      ),
      /* @__PURE__ */ d.jsx(or, {})
    ] }) }),
    /* @__PURE__ */ d.jsx("div", { className: "w-full grid 2s:grid-cols-2 gap-4 mx-auto", children: r.map((y, b) => /* @__PURE__ */ d.jsxs(ds, { bg: p[b % p.length], gap: 4, spacing: 4, rounded: "md", children: [
      /* @__PURE__ */ d.jsxs(sn, { justifyContent: "between", children: [
        /* @__PURE__ */ d.jsxs(sn, { gap: 4, children: [
          /* @__PURE__ */ d.jsx("div", { className: `w-3 h-3 rounded-full bg-${h[b % h.length]}` }),
          /* @__PURE__ */ d.jsx(lr, { variant: "title-3", children: y.name })
        ] }),
        /* @__PURE__ */ d.jsx("div", { className: "cursor-pointer", onClick: u(y), children: /* @__PURE__ */ d.jsx(ge, { variant: "viewvalue", color: h[b % h.length] }) })
      ] }),
      /* @__PURE__ */ d.jsx(Sn, { variant: "heading-5", color: m[b % m.length], children: y.value }),
      /* @__PURE__ */ d.jsx(yr, { variant: "description-3", color: m[b % m.length], children: y.date })
    ] }, b)) })
  ] }) });
});
hue.displayName = "PieCharts";
const vue = P.forwardRef((e) => {
  const { containerName: t, numberOfAlerts: r, filterOneOptions: n = [], filterTwoOptions: a = [], onChangeValueFilteroOne: i, onChangeValueFilteroTwo: o, onChangeValueFilterDate: s, valueFilterOne: l, valueFilterTwo: c, valueFilterDate: u, onClickVerMas: f, clearFilters: p, graphicKeyName: h } = e, m = () => `component_${h ?? "defaultKeyName"}_hidden`, [v, g] = je(() => {
    const w = localStorage.getItem(m());
    return w !== null ? JSON.parse(w) : !1;
  }), y = () => {
    g((w) => {
      const x = !w;
      return localStorage.setItem(m(), JSON.stringify(x)), x;
    });
  }, b = (w) => {
    const x = w.option.startDate, C = w.option.endDate, S = C !== void 0 ? V2(C, "dd/MM/yyyy") : "Fecha de fin no disponible", D = [x !== void 0 ? V2(x, "dd/MM/yyyy") : "Fecha de inicio no disponible", S];
    s !== void 0 && s({ option: D });
  };
  return /* @__PURE__ */ d.jsx(d.Fragment, { children: /* @__PURE__ */ d.jsxs("div", { className: "border rounded-md shadow-s mb-8 max-w-[1260px] mx-auto", children: [
    /* @__PURE__ */ d.jsx("div", { className: "p-4", children: /* @__PURE__ */ d.jsxs("div", { className: "flex flex-col 2s:justify-between 2s:items-center gap-4 2s:flex-row", children: [
      /* @__PURE__ */ d.jsxs(sn, { gap: 4, alignItems: "center", children: [
        /* @__PURE__ */ d.jsx("button", { className: "cursor-pointer", onClick: y, children: /* @__PURE__ */ d.jsx(ge, { variant: v ? "eye-hide" : "eye", color: "neutral-300" }) }),
        /* @__PURE__ */ d.jsx(lr, { variant: "title-2", children: t }),
        r !== void 0 ? /* @__PURE__ */ d.jsx("div", { className: "bg-error-600 rounded-lg py-2 px-4", children: /* @__PURE__ */ d.jsxs(lr, { variant: "title-4", color: "white", children: [
          r,
          " nuevas"
        ] }) }) : void 0
      ] }),
      /* @__PURE__ */ d.jsxs(sn, { gap: 4, children: [
        /* @__PURE__ */ d.jsx("button", { onClick: f, className: "cursor-pointer text-white py-1 px-1 2s:px-6 2s:min-w-max font-bold bg-secondary-600 hover:bg-secondary-500 rounded-md flex-1 flex items-center justify-center text-sm", children: "Ver todas" }),
        /* @__PURE__ */ d.jsx("button", { onClick: p, className: "text-white py-1 px-1 2s:px-6 2s:min-w-max font-bold bg-error-500 hover:bg-error-400 rounded-md flex-1 flex items-center justify-center text-sm", children: "Limpiar filtros" })
      ] })
    ] }) }),
    /* @__PURE__ */ d.jsx("div", { className: `border-1 ${v ? "hidden" : "block"}` }),
    /* @__PURE__ */ d.jsx("div", { className: `p-4 ${v ? "hidden" : "block"}`, children: /* @__PURE__ */ d.jsxs("div", { className: "flex gap-4", children: [
      /* @__PURE__ */ d.jsxs("div", { className: "flex flex-col flex-1 gap-4 2s:flex-row", children: [
        /* @__PURE__ */ d.jsx(
          L2,
          {
            variant: "default",
            value: l,
            options: n,
            onChangeValue: i
          }
        ),
        /* @__PURE__ */ d.jsx(
          L2,
          {
            variant: "default",
            value: c,
            options: a,
            onChangeValue: o
          }
        ),
        /* @__PURE__ */ d.jsx(
          $h,
          {
            valueFilterDate: u,
            onChangeValueFilterDate: b
          }
        )
      ] }),
      /* @__PURE__ */ d.jsx("div", { className: "hidden", children: /* @__PURE__ */ d.jsxs(T9, { variant: "actions", button: /* @__PURE__ */ d.jsx(Ut, { variant: "secondary", size: "m", icon: "menu-context", onlyIcon: !0 }), children: [
        /* @__PURE__ */ d.jsx(I2, { icon: "trash", children: "Eliminar" }),
        /* @__PURE__ */ d.jsx(I2, { icon: "edit", children: "Editar" })
      ] }) })
    ] }) }),
    /* @__PURE__ */ d.jsx("div", { className: `border-1 ${v ? "hidden" : "block"}` }),
    /* @__PURE__ */ d.jsx("div", { className: `p-4 2s:p-8 mb-4 ${v ? "hidden" : "grid"}`, children: e.children })
  ] }) });
});
vue.displayName = "GraphicContainer";
const mue = P.forwardRef((e) => {
  const { handleLabelClick: t, data: r, chartColors: n } = e;
  if (r == null)
    return null;
  const a = r.filter((u) => u.value !== 0), i = (u) => () => {
    t !== void 0 && t({ data: u });
  }, o = n.map((u) => Ae[u.colorCellChart]), s = {
    gridTemplateColumns: "8fr 2fr"
  }, l = Math.PI / 180, c = ({
    cx: u,
    cy: f,
    midAngle: p,
    innerRadius: h,
    outerRadius: m,
    index: v
  }) => {
    const g = h + (m - h) * 0.5, y = u + g * Math.cos(-p * Number(l)), b = f + g * Math.sin(-p * Number(l));
    return /* @__PURE__ */ d.jsx(
      "text",
      {
        className: "text-md s:text-l font-bold",
        x: y,
        y: b,
        fill: "white",
        textAnchor: y > u ? "start" : "end",
        dominantBaseline: "central",
        children: `${a[v].value}`
      }
    );
  };
  return /* @__PURE__ */ d.jsx(d.Fragment, { children: /* @__PURE__ */ d.jsxs("div", { className: "flex flex-col 2s:grid 2s:gap-8", style: s, children: [
    /* @__PURE__ */ d.jsx(ll, { width: "100%", aspect: 2, children: /* @__PURE__ */ d.jsx(Jb, { children: /* @__PURE__ */ d.jsx(
      hn,
      {
        dataKey: "value",
        startAngle: 180,
        endAngle: 0,
        data: a,
        labelLine: !1,
        label: c,
        cx: "50%",
        cy: "90%",
        innerRadius: "70%",
        outerRadius: "180%",
        fill: "#8884d8",
        stroke: "none",
        cursor: "pointer",
        children: a.map((u, f) => /* @__PURE__ */ d.jsx(
          Gr,
          {
            fill: o[f % o.length],
            onClick: i(u)
          },
          `cell-${f}`
        ))
      }
    ) }) }),
    /* @__PURE__ */ d.jsxs("div", { className: "flex flex-col justify-center gap-4 rounded-md text-center", children: [
      /* @__PURE__ */ d.jsxs("div", { className: "rounded-md p-4 text-center bg-success-400", children: [
        /* @__PURE__ */ d.jsx(lr, { variant: "title-3", color: "white", children: "A tiempo" }),
        /* @__PURE__ */ d.jsx(Sn, { variant: "heading-4", color: "white", children: r[2].value !== null ? r[2].value : "0" }),
        /* @__PURE__ */ d.jsx(yr, { variant: "description-4", color: "white", children: "Operaciones" })
      ] }),
      /* @__PURE__ */ d.jsxs("div", { className: "rounded-md p-4 text-center bg-warning-400", children: [
        /* @__PURE__ */ d.jsx(lr, { variant: "title-3", color: "white", children: "Críticas" }),
        /* @__PURE__ */ d.jsx(Sn, { variant: "heading-4", color: "white", children: r[1].value !== null ? r[1].value : "0" }),
        /* @__PURE__ */ d.jsx(yr, { variant: "description-4", color: "white", children: "Operaciones" })
      ] }),
      /* @__PURE__ */ d.jsxs("div", { className: "rounded-md p-4 text-center bg-error-400", children: [
        /* @__PURE__ */ d.jsx(lr, { variant: "title-3", color: "white", children: "Muy críticas" }),
        /* @__PURE__ */ d.jsx(Sn, { variant: "heading-4", color: "white", children: r[0].value !== null ? r[0].value : "0" }),
        /* @__PURE__ */ d.jsx(yr, { variant: "description-4", color: "white", children: "Operaciones" })
      ] })
    ] })
  ] }) });
});
mue.displayName = "SemiPieChart";
const gue = P.forwardRef((e, t) => {
  const {
    data: r,
    chartColors: n,
    domainYAxis: a,
    ticksYAxis: i,
    onActivClick: o,
    ...s
  } = e;
  if (r == null)
    return null;
  const l = r.map((y) => ({
    name: y.name,
    [y.currentDate]: y.numCurrenDate,
    [y.previousDate]: y.numPreviousDate
  })), c = Object.keys(l[0]), u = n.map((y) => Ae[y.colorBar]), f = n.map((y) => Ae[y.colorLine]), p = (y) => () => {
    o !== void 0 && o({ data: y });
  }, [h, m] = je(1), [v, g] = je(0);
  return Me(() => {
    const y = () => {
      const b = document.getElementById("container-chart");
      b !== null && (b.getBoundingClientRect().width <= 650 ? (m(1), g(-45)) : (m(2), l.length >= 6 ? g(-45) : g(0)));
    };
    return y(), window.addEventListener("resize", y), () => {
      window.removeEventListener("resize", y);
    };
  }, [l]), /* @__PURE__ */ d.jsx(d.Fragment, { children: /* @__PURE__ */ d.jsx("section", { className: "w-full max-w-[1260px]", id: "container-chart", ref: t, ...s, children: /* @__PURE__ */ d.jsx(ll, { width: "100%", aspect: h, children: /* @__PURE__ */ d.jsxs(
    pue,
    {
      width: 500,
      height: 800,
      data: l,
      margin: {
        top: 20,
        right: 20,
        bottom: v === 0 ? 20 : 40,
        left: -20
      },
      children: [
        /* @__PURE__ */ d.jsx(gu, { stroke: "#f5f5f5" }),
        /* @__PURE__ */ d.jsx(Qn, { dataKey: "name", className: "text-xs 2s:text-s", interval: 0, angle: v, textAnchor: v === 0 ? "middle" : "end" }),
        /* @__PURE__ */ d.jsx(
          Za,
          {
            domain: a,
            ticks: i,
            className: "text-xs 2s:text-s"
          }
        ),
        /* @__PURE__ */ d.jsx(or, { contentStyle: { fontSize: h === 2 ? "14px" : "13px" } }),
        /* @__PURE__ */ d.jsx(
          En,
          {
            wrapperStyle: { bottom: 0, left: 10 },
            iconType: "circle",
            formatter: (y) => /* @__PURE__ */ d.jsx("span", { style: { fontWeight: "bold", color: "black", marginTop: "40px", fontSize: h === 2 ? "14px" : "13px" }, children: y })
          }
        ),
        /* @__PURE__ */ d.jsx(Ir, { width: 65, dataKey: c[1], barSize: 65, fill: u[0], children: r.map((y, b) => /* @__PURE__ */ d.jsx(Gr, { onClick: p(y) }, `cell-${b}`)) }),
        /* @__PURE__ */ d.jsx(hl, { type: "monotone", dataKey: c[2], stroke: f[0], strokeWidth: 2 })
      ]
    }
  ) }) }) });
});
gue.displayName = "ComposedCharts";
const yue = P.forwardRef((e, t) => {
  const {
    data: r,
    chartColors: n,
    domainXAxis: a,
    ticksXAxis: i,
    onClickNegativeBar: o,
    onClickPositiveBar: s,
    ...l
  } = e;
  if (r == null)
    return null;
  const c = r.map((y) => ({
    name: y.name,
    [y.positiveBarName]: y.positiveBarNumber,
    [y.negativeBarName]: y.negativeBarNumber
  })), u = Object.keys(c[0]), f = n.map((y) => Ae[y.colorBarNegative]), p = n.map((y) => Ae[y.colorBarPositive]), h = (y) => () => {
    o !== void 0 && o({ data: y });
  }, m = (y) => () => {
    s !== void 0 && s({ data: y });
  }, [v, g] = je(1);
  return Me(() => {
    const y = () => {
      const b = document.getElementById("container-chart-horizontal");
      b !== null && (b.getBoundingClientRect().width <= 550 ? g(1) : g(2));
    };
    return y(), window.addEventListener("resize", y), () => {
      window.removeEventListener("resize", y);
    };
  }, []), /* @__PURE__ */ d.jsx(d.Fragment, { children: /* @__PURE__ */ d.jsx("section", { id: "container-chart-horizontal", className: "w-full max-w-[1260px]", ref: t, ...l, children: /* @__PURE__ */ d.jsx(ll, { width: "100%", aspect: v, children: /* @__PURE__ */ d.jsxs(
    Qb,
    {
      width: 500,
      height: 400,
      data: c,
      layout: "vertical",
      margin: {
        top: 5,
        right: 10,
        left: 0,
        bottom: 5
      },
      children: [
        /* @__PURE__ */ d.jsx(gu, { strokeDasharray: "3 3" }),
        /* @__PURE__ */ d.jsx(
          Qn,
          {
            type: "number",
            domain: a,
            ticks: i,
            className: "text-xs 2s:text-s"
          }
        ),
        /* @__PURE__ */ d.jsx(Za, { dataKey: "name", type: "category", className: "text-xs 2s:text-s", width: v === 2 ? 122 : void 0 }),
        /* @__PURE__ */ d.jsx(or, { contentStyle: { fontSize: v === 2 ? "14px" : "13px" } }),
        /* @__PURE__ */ d.jsx(
          En,
          {
            iconType: "circle",
            formatter: (y) => /* @__PURE__ */ d.jsx("span", { style: { fontWeight: "bold", color: "black", marginTop: "40px", fontSize: v === 2 ? "14px" : "13px" }, children: y })
          }
        ),
        /* @__PURE__ */ d.jsx(Ir, { dataKey: u[2], barSize: 38, fill: f[0], children: r.map((y, b) => /* @__PURE__ */ d.jsx(Gr, { onClick: h(y) }, `cell-${b}`)) }),
        /* @__PURE__ */ d.jsx(Ir, { dataKey: u[1], barSize: 38, fill: p[0], children: r.map((y, b) => /* @__PURE__ */ d.jsx(Gr, { onClick: m(y) }, `cell-${b}`)) })
      ]
    }
  ) }) }) });
});
yue.displayName = "HorizontalChart";
const bue = P.forwardRef((e, t) => {
  const {
    data: r,
    chartColors: n,
    domainXAxis: a,
    ticksXAxis: i,
    onClickCurrentBar: o,
    onClickPreviousBar: s,
    image: l,
    ...c
  } = e;
  if (r == null || n == null || a == null || i == null || l == null)
    return null;
  const u = r.map((S) => ({
    name: S.name,
    [S.currentDate]: S.numCurrenDate,
    [S.previousDate]: S.numPreviousDate,
    url: S.url
  })), f = Object.keys(u[0]), p = n.map((S) => Ae[S.colorBarCurrent]), h = n.map((S) => Ae[S.colorBarPrevious]), m = (S) => () => {
    o !== void 0 && o({ data: S });
  }, v = (S) => () => {
    s !== void 0 && s({ data: S });
  }, g = ({ data: S, ...E }) => {
    const D = E.x, I = E.y, k = S == null ? void 0 : S.map((V) => V.name);
    return D == null || I == null ? null : /* @__PURE__ */ d.jsx(d.Fragment, { children: /* @__PURE__ */ d.jsxs("g", { transform: `translate(${D},${I})`, radius: "100%", children: [
      k == null ? void 0 : k.map((V, W) => /* @__PURE__ */ d.jsx("text", { x: 0, y: 10, transform: "rotate(-45)", textAnchor: "end", dominantBaseline: "middle", fontSize: 7, fontWeight: "400", fill: "#666666", children: V }, W)),
      /* @__PURE__ */ d.jsx("defs", { children: /* @__PURE__ */ d.jsx("clipPath", { id: "circleView", children: /* @__PURE__ */ d.jsx("circle", { cx: -5, cy: 65, r: 14 }) }) }),
      /* @__PURE__ */ d.jsx("image", { href: E.payload.value, clipPath: "url(#circleView)", x: -55, y: 50, height: "35px", width: "100px", radius: 100, textAnchor: "middle" })
    ] }) });
  }, [y, b] = je(1), [w, x] = je(0);
  Me(() => {
    const S = () => {
      const E = document.getElementById("container-chart-simple-bar");
      E !== null && (E.getBoundingClientRect().width <= 650 ? (b(1), x(-45)) : (b(2), u.length >= 6 ? x(-45) : x(0)));
    };
    return S(), window.addEventListener("resize", S), () => {
      window.removeEventListener("resize", S);
    };
  }, []);
  const C = ({ active: S, payload: E }) => S == null ? null : S && E != null && E.length > 0 ? /* @__PURE__ */ d.jsx("div", { className: "bg-neutral-100 p-3 border-white border-1", children: Object.keys(E[0].payload).map((D) => {
    if (D === "name") {
      const I = String(E[0].payload[D]);
      return /* @__PURE__ */ d.jsx("p", { children: `${I}` }, D);
    }
    if (D === "Mes actual") {
      const I = String(E[0].payload[D]);
      return /* @__PURE__ */ d.jsx("p", { style: { color: p[0] }, children: `${D}: ${I}` }, D);
    }
    if (D === "Mes anterior") {
      const I = String(E[0].payload[D]);
      return /* @__PURE__ */ d.jsx("p", { style: { color: h[0] }, children: `${D}: ${I}` }, D);
    }
    return null;
  }) }) : null;
  return /* @__PURE__ */ d.jsx(d.Fragment, { children: /* @__PURE__ */ d.jsx("section", { id: "container-chart-simple-bar", className: "w-full max-w-[1260px]", ref: t, ...c, children: /* @__PURE__ */ d.jsx(ll, { width: "100%", aspect: y, children: /* @__PURE__ */ d.jsxs(
    Qb,
    {
      width: 500,
      height: 300,
      data: u,
      margin: {
        top: 20,
        right: 20,
        bottom: w === 0 ? 20 : 50,
        left: -20
      },
      children: [
        /* @__PURE__ */ d.jsx(gu, { stroke: "#A3A3A3", strokeWidth: 0.5, horizontal: !0, vertical: !1 }),
        l ? /* @__PURE__ */ d.jsx(Qn, { dataKey: "url", interval: 0, tick: /* @__PURE__ */ d.jsx(g, { data: r }) }) : /* @__PURE__ */ d.jsx(Qn, { dataKey: "name", fontSize: 12, interval: 0, angle: -45, textAnchor: "end" }),
        /* @__PURE__ */ d.jsx(
          Za,
          {
            className: "text-xs 2s:text-s",
            radius: "100%",
            domain: a,
            ticks: i
          }
        ),
        l ? /* @__PURE__ */ d.jsx(
          or,
          {
            contentStyle: { fontSize: y === 2 ? "14px" : "13px" },
            content: /* @__PURE__ */ d.jsx(C, {})
          }
        ) : /* @__PURE__ */ d.jsx(
          or,
          {
            contentStyle: { fontSize: y === 2 ? "14px" : "13px" }
          }
        ),
        /* @__PURE__ */ d.jsx(
          En,
          {
            wrapperStyle: { bottom: l ? -15 : 0, left: 5 },
            iconType: "circle",
            formatter: (S) => /* @__PURE__ */ d.jsx("span", { style: { fontWeight: "bold", color: "black", marginTop: "40px", fontSize: y === 2 ? "14px" : "13px" }, children: S })
          }
        ),
        /* @__PURE__ */ d.jsx(Ir, { dataKey: f[1], fill: p[0], barSize: 37, children: r.map((S, E) => /* @__PURE__ */ d.jsx(Gr, { onClick: m(S) }, `cell-${E}`)) }),
        /* @__PURE__ */ d.jsx(Ir, { dataKey: f[2], fill: h[0], barSize: 37, children: r.map((S, E) => /* @__PURE__ */ d.jsx(Gr, { onClick: v(S) }, `cell-${E}`)) })
      ]
    }
  ) }) }) });
});
bue.displayName = "SimpleBarChart";
const Cue = P.forwardRef((e, t) => {
  const {
    selectFilter: r,
    search: n
  } = e, a = F0(), {
    placeholder: i = "Search...",
    minLengthToSearch: o = 5,
    onSearch: s
  } = n;
  return /* @__PURE__ */ d.jsxs("div", { ref: t, className: "flex m:flex-grow m:max-w-[800px] justify-between h-[40px] border border-neutral-300 rounded-md bg-neutral-200 w-[100%]", children: [
    /* @__PURE__ */ d.jsx("div", { className: "w-[110px] min-w-[110px] s:w-[140px] s:min-w-[140px] 2s:min-w-[30%] relative h-full border-r border-neutral-300", children: r }),
    /* @__PURE__ */ d.jsx(
      Jv,
      {
        idSearch: a,
        placeholder: i,
        minLengthToSearch: o,
        onSearch: s
      }
    )
  ] });
});
Cue.displayName = "TableScrollHeader";
const xue = (e) => {
  const {
    columns: t = [],
    isCheckedRow: r,
    setIndiceChecked: n,
    data: a
  } = e, i = (o) => {
    const s = [];
    if (o)
      for (const l of a.keys())
        s.push(l);
    n !== void 0 && n(s);
  };
  return /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
    (r ?? !1) && /* @__PURE__ */ d.jsx(
      "div",
      {
        style: { gridArea: "col-reserved-check" },
        className: "min-w-[50px] flex gap-2 justify-between items-center px-4",
        children: /* @__PURE__ */ d.jsx(
          "input",
          {
            type: "checkbox",
            id: "checkAll",
            title: "Seleccionar todos",
            className: "w-full overflow-hidden whitespace-nowrap",
            onClick: (o) => {
              i(o.target.checked);
            }
          }
        )
      }
    ),
    t.filter((o) => o.isShow).map((o) => /* @__PURE__ */ d.jsxs(
      "div",
      {
        style: { gridArea: `col-${o.id}` },
        title: o.title,
        className: `min-w-[205px] flex gap-2 justify-between items-center px-4 font-bold leading-[120%] select-none ${o.sorted && o.orderBy !== null ? "text-secondary-600" : "hover:text-secondary-500"}`,
        children: [
          /* @__PURE__ */ d.jsx("p", { className: "w-full text-ellipsis overflow-hidden whitespace-nowrap", children: o.title }),
          (o.sortable ?? !1) && /* @__PURE__ */ d.jsx(
            "button",
            {
              type: "button",
              className: "w-6 h-6 flex items-center justify-center",
              children: /* @__PURE__ */ d.jsxs(
                "svg",
                {
                  className: "w-5",
                  viewBox: "0 0 25 24",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                  children: [
                    /* @__PURE__ */ d.jsx(
                      "path",
                      {
                        d: "M16.743 10L8.25505 10C8.1049 9.9994 7.95831 9.95665 7.83381 9.87715C7.70931 9.79765 7.6125 9.68497 7.55561 9.55336C7.49873 9.42176 7.48433 9.27713 7.51423 9.13777C7.54413 8.99841 7.61699 8.87057 7.7236 8.77043L11.96 4.75815C12.0306 4.69075 12.1145 4.63726 12.207 4.60075C12.2996 4.56425 12.3988 4.54545 12.499 4.54545C12.5992 4.54545 12.6985 4.56425 12.791 4.60075C12.8835 4.63726 12.9675 4.69075 13.0381 4.75815L17.2744 8.77043C17.3811 8.87057 17.4539 8.99841 17.4838 9.13777C17.5137 9.27713 17.4993 9.42176 17.4424 9.55337C17.3855 9.68497 17.2887 9.79765 17.1642 9.87715C17.0397 9.95665 16.8931 9.9994 16.743 10Z",
                        fill: o.sorted && o.orderBy === "asc" ? "#2875B4" : "#E6E6E6"
                      }
                    ),
                    /* @__PURE__ */ d.jsx(
                      "path",
                      {
                        d: "M8.25505 14H16.743C16.8931 14.0006 17.0397 14.0433 17.1642 14.1228C17.2887 14.2023 17.3855 14.315 17.4424 14.4466C17.4993 14.5782 17.5137 14.7229 17.4838 14.8622C17.4539 15.0016 17.3811 15.1294 17.2744 15.2296L13.0381 19.2419C12.9675 19.3092 12.8835 19.3627 12.791 19.3992C12.6985 19.4358 12.5992 19.4545 12.499 19.4545C12.3988 19.4545 12.2996 19.4358 12.207 19.3992C12.1145 19.3627 12.0306 19.3092 11.96 19.2419L7.7236 15.2296C7.61699 15.1294 7.54413 15.0016 7.51423 14.8622C7.48433 14.7229 7.49873 14.5782 7.55561 14.4466C7.6125 14.315 7.70931 14.2023 7.83381 14.1228C7.95831 14.0433 8.1049 14.0006 8.25505 14Z",
                        fill: o.sorted && o.orderBy === "desc" ? "#2875B4" : "#E6E6E6"
                      }
                    )
                  ]
                }
              )
            }
          )
        ]
      },
      o.id
    ))
  ] });
}, wue = (e) => {
  const {
    columns: t = [],
    data: r = [],
    isCheckedRow: n,
    activeRowValidation: a,
    handleCheckedRow: i,
    nextPageScroll: o,
    dataLength: s = 0,
    hasMore: l,
    colorColumn: c
  } = e, u = () => o !== void 0 ? o() : null, f = (n ? "col-reserved-check " : "") + t.filter((b) => b.isShow).map((b) => `col-${b.id}`).concat("col-reserved-actions").join(" ").toString(), p = (n ? "50px " : "") + Array.from({ length: t.filter((b) => b.isShow).length }, () => "1fr").concat("150px").join(" ").toString(), h = { gridTemplateAreas: `'${f}'`, gridTemplateColumns: p }, m = [], [v, g] = je(m), y = (b, w) => {
    g(b ? (x) => [...x, w] : (x) => x.filter((C) => C !== w));
  };
  return Me(() => {
    const b = [];
    v.length > 0 && v.forEach((w) => {
      b.push(r[w]);
    }), i !== void 0 && i({ rows: b });
  }, [v]), /* @__PURE__ */ d.jsx("div", { className: "hidden 2s:block", children: /* @__PURE__ */ d.jsx("div", { className: "max-h-[calc(100vh-461px)] m:max-h-[calc(100vh-305px)] l:max-h-[calc(100vh-312px)] w-full overflow-x-auto overflow-y-auto table-main-scrollbar pb-1", children: /* @__PURE__ */ d.jsxs("div", { className: "min-w-[min-content]", children: [
    /* @__PURE__ */ d.jsx("div", { className: "bg-white grid w-full h-10 sticky top-0", style: { ...h, zIndex: r.length + 10 }, children: /* @__PURE__ */ d.jsx(
      xue,
      {
        columns: t,
        data: r,
        isCheckedRow: n,
        setIndiceChecked: g
      }
    ) }),
    /* @__PURE__ */ d.jsx("div", { className: "bg-secondary-100 w-full overflow-y-auto", children: /* @__PURE__ */ d.jsx(
      "div",
      {
        className: `max-h-[calc(100vh-461px)] min-h-[calc(100vh-461px)] m:max-h-[calc(100vh-305px)] m:min-h-[calc(100vh-305px)]
                  l:max-h-[calc(100vh-312px)] l:min-h-[calc(100vh-312px)] table-max-height w-full overflow-auto table-main-scrollbar pb-1`,
        id: "scrollableTable",
        children: /* @__PURE__ */ d.jsx(
          Lc,
          {
            dataLength: s,
            hasMore: l,
            next: u,
            scrollableTarget: "scrollableTable",
            style: { overflow: "hidden" },
            loader: /* @__PURE__ */ d.jsx(sn, { justifyContent: "center", children: /* @__PURE__ */ d.jsx(Ut, { isLoading: !0, variant: "secondary", children: "Cargando... " }) }),
            children: r.map((b, w) => {
              const x = w % 2 === 0, S = (a === void 0 || b[a.field] === void 0 ? !0 : b[a.field] === a.value) ? x ? "bg-secondary-200" : "bg-secondary-100" : "bg-neutral-200 text-neutral-400";
              return /* @__PURE__ */ d.jsx(ea, { children: /* @__PURE__ */ d.jsxs(
                "div",
                {
                  style: h,
                  className: `${S} hover:bg-secondary-300 hover:text-secondary-600 cursor-pointer border-b border-white last:border-none h-[48px] grid w-full`,
                  children: [
                    n && /* @__PURE__ */ d.jsx("div", { className: "min-w-[50px] flex justify-between items-center pr-1", children: /* @__PURE__ */ d.jsx(
                      "input",
                      {
                        type: "checkbox",
                        title: "Seleccionar",
                        checked: v.includes(w),
                        value: w,
                        className: "checkbox w-full overflow-hidden whitespace-nowrap",
                        onChange: (E) => {
                          y(E.target.checked, w);
                        }
                      }
                    ) }),
                    Object.entries(b).map(([E, D]) => {
                      const I = t.find((L) => L.id === E);
                      if (I === void 0 || !I.isShow)
                        return null;
                      let k = !1, V = "", W = c ? c.filter((L) => L.title === E) : [];
                      if (W.length > 0) {
                        k = !0;
                        const L = W[0].params.filter((Q) => Q.value === D), G = L.length > 0 ? L[0].color : "transparent";
                        V = Ae[G];
                      }
                      return /* @__PURE__ */ d.jsx(
                        "div",
                        {
                          style: { gridArea: `col-${I.id}` },
                          title: D,
                          className: "min-w-[205px] flex items-center px-4 border-l border-white first:border-none leading-[120%]",
                          children: k ? /* @__PURE__ */ d.jsx("div", { className: "w-full h-8 px-4 justify-center items-center gap-2 flex", style: { borderRadius: "8px", backgroundColor: V }, children: /* @__PURE__ */ d.jsx("div", { className: "grow text-center text-white text-xs font-bold leading-[14.40px]", children: D }) }) : /* @__PURE__ */ d.jsx("p", { className: "w-full text-ellipsis overflow-hidden whitespace-nowrap", children: D })
                        },
                        E
                      );
                    })
                  ]
                },
                b.id
              ) }, `fragment-${w}`);
            })
          }
        )
      }
    ) })
  ] }) }) });
}, Oue = (e) => {
  const {
    columns: t = [],
    data: r = [],
    handleCheckedRow: n,
    nextPageScroll: a,
    dataLength: i,
    hasMore: o,
    colorColumn: s
  } = e, l = [], [c, u] = je(l), f = (h, m) => {
    u(h ? (v) => [...v, m] : (v) => v.filter((g) => g !== m));
  };
  Me(() => {
    const h = [];
    c.length > 0 && c.forEach((m) => {
      h.push(r[m]);
    }), n !== void 0 && n({ rows: h });
  }, [c]);
  const p = () => a !== void 0 ? a() : null;
  return /* @__PURE__ */ d.jsx("div", { className: "grid gap-2 2s:hidden", children: /* @__PURE__ */ d.jsx(
    "div",
    {
      className: `max-h-[calc(100vh-461px)] min-h-[calc(100vh-461px)] m:max-h-[calc(100vh-305px)] m:min-h-[calc(100vh-305px)]
      l:max-h-[calc(100vh-312px)] l:min-h-[calc(100vh-312px)] table-max-height w-full overflow-auto table-main-scrollbar pb-1`,
      children: /* @__PURE__ */ d.jsx(
        Lc,
        {
          dataLength: i,
          hasMore: o,
          next: p,
          scrollableTarget: "scrollableTable",
          style: { overflow: "hidden" },
          loader: /* @__PURE__ */ d.jsx(sn, { justifyContent: "center", children: /* @__PURE__ */ d.jsx(Ut, { isLoading: !0, variant: "secondary", children: "Cargando... " }) }),
          children: r.map((h, m) => /* @__PURE__ */ d.jsx(ea, { children: /* @__PURE__ */ d.jsx(
            "div",
            {
              className: "relative p-4 rounded-md bg-secondary-100 hover:bg-secondary-200 hover:text-secondary-600 w-full cursor-pointer",
              children: /* @__PURE__ */ d.jsxs("div", { className: "flex flex-wrap gap-y-1.5 gap-x-6", children: [
                /* @__PURE__ */ d.jsx(
                  "div",
                  {
                    style: { gridArea: "col-reserved-check" },
                    children: /* @__PURE__ */ d.jsx(
                      "input",
                      {
                        type: "checkbox",
                        id: "checkAll",
                        title: "Seleccionar todos",
                        className: "w-full overflow-hidden whitespace-nowrap",
                        onChange: (v) => {
                          f(v.target.checked, m);
                        }
                      }
                    )
                  }
                ),
                Object.entries(h).filter(([v]) => t.some((g) => g.id === v && g.isMobileShow)).map(([v, g]) => {
                  const y = t.find((E) => E.id === v);
                  if (y === void 0)
                    return null;
                  const {
                    isMobileShow: b = !1,
                    isTextBold: w = !1
                  } = y;
                  if (!b)
                    return null;
                  let x = !1, C = "", S = s ? s.filter((E) => E.title === v) : [];
                  if (S.length > 0) {
                    x = !0;
                    const E = S[0].params.filter((I) => I.value === g), D = E.length > 0 ? E[0].color : "transparent";
                    C = Ae[D];
                  }
                  return x ? /* @__PURE__ */ d.jsx("div", { className: "w-full h-8 px-4 justify-center items-center gap-2 flex", style: { borderRadius: "8px", backgroundColor: C }, children: /* @__PURE__ */ d.jsx("div", { className: "grow text-center text-white text-xs font-bold leading-[14.40px]", children: g }) }) : /* @__PURE__ */ d.jsx(
                    "p",
                    {
                      className: `leading-[120%] ${w ? "font-bold" : ""} w-full pr-12`,
                      children: g
                    },
                    v
                  );
                })
              ] })
            },
            h.id
          ) }, `fragment-${m}`))
        }
      )
    }
  ) });
}, Sue = P.forwardRef((e, t) => {
  const {
    columns: r = [],
    data: n = [],
    isCheckedRow: a = !1,
    className: i,
    nextPageScroll: o,
    dataLength: s = 1,
    hasMore: l,
    handleCheckedRow: c,
    colorColumn: u
  } = e;
  return /* @__PURE__ */ d.jsxs("div", { ref: t, className: Ne(["block", i]), children: [
    /* @__PURE__ */ d.jsx(
      Oue,
      {
        hasMore: l,
        columns: r,
        data: n,
        isCheckedRow: a,
        nextPageScroll: o,
        dataLength: s,
        handleCheckedRow: c
      }
    ),
    /* @__PURE__ */ d.jsx(
      wue,
      {
        hasMore: l,
        columns: r,
        data: n,
        isCheckedRow: a,
        nextPageScroll: o,
        dataLength: s,
        handleCheckedRow: c,
        colorColumn: u
      }
    )
  ] });
});
Sue.displayName = "TableScrollMain";
export {
  jL as Acordeon,
  Nw as Autocomplete,
  qs as Avatar,
  wL as Body,
  On as Box,
  jue as BoxFile,
  wC as BoxStatus,
  OC as Breadcrumb,
  Ut as Button,
  N9 as Checkbox,
  Nh as CimaLogo,
  ge as CodeIcon,
  gue as ComposedChart,
  Ew as Dashboard,
  jw as DashboardMain,
  $h as DateRangeInput,
  yr as Description,
  _w as Divider,
  T9 as Dropdown,
  I2 as DropdownAction,
  Aw as ExportTable,
  Mw as ExportTableCol,
  Iw as FieldError,
  sn as Flexbox,
  $o as FlexboxRow,
  _L as Genlingx,
  vue as GraphicContainer,
  kD as HeaderBoxLeft,
  BD as HeaderBoxRight,
  VD as HeaderNotificationItem,
  HD as HeaderNotifications,
  FD as HeaderOldButton,
  WD as HeaderSearch,
  zD as HeaderUser,
  UD as HeaderUserItem,
  ZD as HeaderWrapper,
  Sn as Heading,
  yue as HorizontalChart,
  I9 as Input,
  Ww as InputMask,
  Z0 as Label,
  FI as MenuItems,
  WI as MenuWrapper,
  zI as Modal,
  UI as ModalBody,
  ZI as ModalFocus,
  YI as ModalFocusContainer,
  GI as ModalFooter,
  qI as ModalHeader,
  hue as PieCharts,
  Lw as Radio,
  qD as SaicoLogo,
  L2 as Select,
  Uw as SelectGroup,
  mue as SemiPieChart,
  bue as SimpleBarChart,
  KI as Spreen,
  XI as SpreenBody,
  QI as SpreenFooter,
  tL as SpreenHeader,
  JI as SpreenLeft,
  eL as SpreenRight,
  ds as Stack,
  Io as StackRow,
  nL as StepperIcon,
  rL as StepperSimple,
  NL as TableBasic,
  aL as TableEmpty,
  iL as TableFooter,
  oL as TableHeader,
  sL as TableLoader,
  hL as TableMain,
  vL as TablePagination,
  Cue as TableScrollHeader,
  Sue as TableScrollMain,
  mL as TableShowPages,
  SL as TarjetBody,
  EL as TarjetFooter,
  PL as TarjetTitle,
  OL as TextOther,
  zw as Textarea,
  lr as Title,
  xL as Toast,
  DL as Visrlink,
  _ue as closeDropdown,
  Due as shootToast
};
